'use strict';

angular.module('mtic.components.dashboards.student_general', ['mtic.components.modules']);

angular.module('mtic.components.dashboards.student_general').directive('dashboardStudent', function (EventManager, StudentDataService, $log, $timeout, language, TIMING_CONSTANTS, $q, $rootScope) {

  return {
    template:'<div class="student-page-container" resize><student-classes ng-if="!isClassSelected" on-select="selectClassroom"></student-classes><student-class ng-if="isClassSelected && !isLeaderboardActive"></student-class><student-leaderboard ng-if="isClassSelected && isLeaderboardActive"></student-leaderboard></div>',
    scope: {},
    link: function link(scope) {

      // event manager
      var eventManager = new EventManager("studentDashboard", scope);
      scope.isClassSelected = false;
      scope.isLeaderboardActive = false;

      eventManager.broadcast('language:init', language.getCurrentSelectedLanguage());

      scope.$watch('isClassSelected', function () {
        if (scope.isClassSelected) {
          $rootScope.pageView = 'student-class-view';
        } else {
          $rootScope.pageView = 'student-classes-view';
        }
        $rootScope.sidebarExpanded = false;
      });

      scope.selectClassroom = function (class_group_id) {
        if (!class_group_id) {
          return;
        }
        scope.isLeaderboardActive = false;
        scope.isClassSelected = true;
        StudentDataService.setActiveClassroom(class_group_id);
        eventManager.broadcast('student:cycle:open');
      };

      eventManager.listen('navbar:my-classes:click', function (e) {
        scope.isClassSelected = false;
        scope.moduleMapData = null;
        scope.isLeaderboardActive = false;
      });

      eventManager.listen('student:leaderboard:open', function (e, data) {
        // $log.log('leaderboard open', data)
        StudentDataService.leaderboardConfig = {
          classId: data.classId,
          classType: data.classType,
          classCountry: data.classCountry
        };
        scope.isLeaderboardActive = true;
        scope.isClassSelected = true;
        $rootScope.sidebarExpanded = false;
      });

      eventManager.listen('post-student-cycle-prompt-complete', function (e, args) {
        scope.selectClassroom(args);
      });
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.student_general').component('studentClassesContainer', {
  template:'<div class="classroom-card-container"><div ng-repeat="classroom in studentClassesContainer.classes" class="classroom-card is-student" ng-class="{\'is-student-teacherless\':studentClassesContainer.isTeacherless}"><div class="classroom-card-header" ng-class="{\'is-greyed\':studentClassesContainer.isTeacherless}">{{studentClassesContainer.getClassTypeCaption(classroom.resource_type)}}</div><div class="classroom-card-content" ng-hide="studentClassesContainer.isTeacherless"><div class="classroom-card-classname">{{classroom.name}}</div></div><div class="classroom-card-footer"><button class="button is-large is-success" ng-click="studentClassesContainer.selectClassroom(classroom.id)" ng-bind="studentClassesContainer.getClassTypeCaption(\'14585\')">View Modules</button></div></div></div>',
  bindings: {
    onSelect: '<',
    classes: '<',
    isTeacherless: '<'
  },
  controllerAs: 'studentClassesContainer',
  controller: function controller($scope, $q, $log, $timeout, StudentDataService, userAccount, api, EventManager, language, LocaleService) {
    var eventManager = new EventManager('studentClassesContainer', $scope);
    var studentClassesContainer = this;
    // var last_clicked_class_id;

    studentClassesContainer.selectClassroom = function (class_id) {
      studentClassesContainer.onSelect(class_id);
    };

    studentClassesContainer.getClassTypeCaption = function (moduleResourceType) {
      return language.get(moduleResourceType);
    };

    eventManager.listen('open-module-view', function (e, args) {
      if (!args) {
        //studentClassesContainer.onSelect(studentClassesContainer.last_clicked_class_id);
      } else {
        studentClassesContainer.selectClassroom(args);
      }
    });
  }
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general', ['mtic', 'angular.filter', 'mtic.components.modules', 'mtic.components.custom_calendar', 'mtic.components.user_box', 'ui.tree']);

angular.module('mtic.components.dashboards.teacher_general').directive('dashboardTeacher', function ($log, $http, EventManager, PanelFactory, TeacherDataService, language, $rootScope, PlatformService) {
  return {
    template:'<div class="teacher" resize><teacher-classes ng-if="showClasses"></teacher-classes><teacher-students ng-if="!showClasses"></teacher-students></div>',
    scope: {},
    link: function link(scope) {
      var eventManager = new EventManager('teacherDashboard', scope);
      eventManager.broadcast('app:secondary:opened', 'Teacher');

      scope.$watch('showClasses', function () {
        if (scope.$parent.$parent.pageShown === 'teacher') {
          if (scope.showClasses) {
            $rootScope.pageView = 'teacher-classes-view';
          } else {
            $rootScope.pageView = 'teacher-students-view';
          }
          $rootScope.sidebarExpanded = PlatformService.isPhonePortrait() && window.location.href.indexOf('open_item_link') === -1 ? false : true;
        }
      });

      scope.showClasses = true;

      eventManager.broadcast('language:init', language.getCurrentSelectedLanguage());

      eventManager.listen("navbar:my-classes:click", function () {
        scope.showClasses = true;
      });

      eventManager.listen('teacher:view:class', function () {
        scope.showClasses = false;
      });
    }

  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('classLessonSummary', function ($log, $q, EventManager, StudentDataService) {
      return {
            template:'<button type="button" ng-click="goToClassTable()">goToClassTable</button> <span ng-if="loading">Loading ...</span><div ng-if="!loading" style="max-height: 400px;overflow: scroll;"><table class="table"><thead><th>Resource</th><th>Complete</th><th>Locked</th><th>Work</th></thead><tbody><tr ng-repeat="work in studentWork.resources"><td ng-bind="work.name"></td><td ng-bind="work.complete"></td><td ng-bind="work.locked"></td><td ng-bind="work.resourceState"></td></tr></tbody></table></div>',
            scope: {
                  classId: '=',
                  userId: '='
            },
            link: function link(scope) {
                  var eventManager = new EventManager('teacherDashboard/classLessonSummary', scope);
                  scope.studentWork = null;
                  scope.loading = true;
                  StudentDataService.getStudentWorkAsTeacher(scope.userId, scope.classId).then(function (work) {
                        scope.studentWork = work;
                        scope.loading = false;
                  });

                  scope.goToClassTable = function () {
                        eventManager.broadcast('teacher:unselectStudent');
                  };
            }
      };
});
'use strict';

angular.module('mtic.components.modules.c3', []).constant('C3_ASSET_URL', 'assets/images/c3-module/').constant('C3_META_ASSET_URL', 'assets/images/c3-meta/');
'use strict';

angular.module('mtic.components.modules.c3').directive('c3RunLikeMathModuleOperation', function ($log, $timeout, TIMING_CONSTANTS, EventManager, C3_META_ASSET_URL, C3_ASSET_URL, PIXI, language, MODULE_AVAILABLE_LANGUAGE, MapStateService, userAccount, preliveCheck, DEV_VARIABLES, runLikeMathItemFactory, TeacherDataService, PlatformService) {

  return {
    template:'<div ng-hide="loading_done" style="position:absolute;top:0px;left:0px;width:100%;height:100%;background-color:#555;z-index:1000"><div class="loader"></div></div><canvas id="canvas" width="300" height="300"></canvas>',
    scope: {
      moduleMapData: "=moduleMapData",
      interceptClick: "=?",
      slugs: "=?"

    },
    link: function link(scope) {
      var thiz = this;
      var items = [];
      var eventManager = new EventManager('c3RunLikeMathModuleOperation', scope);
      //PIXI Rendering Settings
      var canvas_el = document.getElementById("canvas");
      var width = Math.max(1200, canvas_el.parentElement.parentElement.clientWidth);
      var height = Math.max(800, canvas_el.parentElement.parentElement.clientHeight);

      var renderer = PIXI.autoDetectRenderer(width, height, {
        autoResize: true,
        backgroundColor: 0x18052b,
        view: document.getElementById('canvas')
      });
      var stage = new PIXI.Container();
      // stage.alpha = 0.01;

      var canvasDimention = {
        width: canvas_el.parentElement.parentElement.parentElement.clientWidth,
        height: canvas_el.parentElement.parentElement.parentElement.clientHeight
      };

      stage.y += 100;
      stage.x -= 50;
      // if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1200){
      //   stage.x -= 50;
      //   stage.scale.set(0.6,0.6)
      // }else if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1400){
      //   //stage.scale.set(0.8,0.8)
      // }

      scope.$watch("moduleMapData", function (moduleMapData) {
        if (!moduleMapData) {
          return;
        }

        //this is what runs to initialize the map
        if (!PIXI_Load_Cache || !PIXI.loader.resources[C3_META_ASSET_URL + "bkg.png"]) {
          PIXI.loader.reset();
          PIXI.loader.add([C3_ASSET_URL + "lockedLevel.png", C3_ASSET_URL + "numpadBtn_orange.png", C3_ASSET_URL + "backBtn.png", C3_ASSET_URL + "star.png", C3_ASSET_URL + "stars.png", C3_META_ASSET_URL + "bkg.png"]).load(function () {
            PIXI_Load_Cache = true;
            $timeout(function () {
              init(moduleMapData.resources);
            });
          });
        } else {
          $timeout(function () {
            init(moduleMapData.resources);
          });
        }
      });

      var getPositioningParams = function getPositioningParams(background, totalResource) {
        var maxWidth = background.width;
        var paddingSpace = 600;
        var resourceSprite = new PIXI.Sprite(PIXI.loader.resources[C3_ASSET_URL + "numpadBtn_orange.png"].texture);
        resourceSprite.width = 90;
        resourceSprite.height = 80;

        var itemsPerRow = (maxWidth - paddingSpace) / (resourceSprite.width + 25);
        var maxItemsPerRow = Math.min(itemsPerRow, 5);
        var columns = Math.ceil(totalResource / maxItemsPerRow);

        return {
          maxPerRow: Math.floor(maxItemsPerRow),
          columns: columns,
          width: 90,
          height: 80,
          paddingBetweenItem: 50,
          paddingLeft: paddingSpace / 2,
          paddingTop: paddingSpace / 2
        };
      };

      var setupHeadingText = function setupHeadingText(positioningParams) {
        var headingSprite = new PIXI.Sprite();
        var graphics = new PIXI.Graphics();

        var setupText = function setupText() {
          var subModuleName = language.get(scope.moduleMapData.slug);
          headingSprite.removeChild(graphics);
          graphics.clear();
          graphics.removeChildren();
          graphics = new PIXI.Graphics();
          var textInfo = new PIXI.Text(subModuleName);
          textInfo.style.align = "center";
          textInfo.style.fill = "white";
          textInfo.style.fontFamily = "vanilla-extract-edit";
          textInfo.style.fontSize = 70;
          var totalLessonsWidth = 5 * positioningParams.width + positioningParams.paddingBetweenItem * 4;
          graphics.position.set(positioningParams.paddingLeft + (totalLessonsWidth - textInfo.width) / 2, 100);
          graphics.addChild(textInfo);
          headingSprite.addChild(graphics);
        };
        setupText();
        eventManager.listen('language:change', function () {
          setupText();
        });
        stage.addChild(headingSprite);
      };

      var init = function init(moduleMapData) {
        $log.debug('[[c3Module34]] INIT', moduleMapData);
        var combinedResourceMap = {};
        _.forEach(moduleMapData, function (someItem) {
          combinedResourceMap[someItem.slug] = someItem;
        });
        if (Object.keys(combinedResourceMap).length !== moduleMapData.length) {
          throw "some resourceMap slugs are not unique!";
        }

        var positioningParams = getPositioningParams(renderer, Object.keys(combinedResourceMap).length);
        setupHeadingText(positioningParams);
        var count = 0;
        _.each(scope.slugs, function (slug) {
          var resource = _.find(scope.moduleMapData.children, function (mapItem) {
            return mapItem.slug === slug;
          });
          var displayItem = new runLikeMathItemFactory.createMapItem(resource, scope.onItemClick, positioningParams, count, stage);
          items.push(displayItem);
          //add empty star
          var starTexture = getIconTexture(0, displayItem.sprite);
          displayItem.icon = starTexture;
          stage.addChild(displayItem.sprite);
          displayItem.setupText(count, displayItem.sprite);
          stage.addChild(displayItem.icon);
          count++;
        });

        //renderer.render(stage);
        eventManager.broadcast('teacherStudentWorkspace:studentFilter:request');
        window.addEventListener("resize", onResize);

        $timeout(function () {
          onResize();
          // stage.alpha = 1;
          scope.loading_done = true;
        }, 1000);
      };

      var updateItemInfoComplete = function updateItemInfoComplete(existsItem, item_info) {
        var exists_score_max = item_info.resourceState ? item_info.resourceState.score_max : null;
        item_info.complete = existsItem.completed;
        item_info.resourceState = { complete: existsItem.completed };
        item_info.resourceState.score_max = exists_score_max ? Math.max(exists_score_max, existsItem.score) : existsItem.score;
        item_info.score = item_info.resourceState.score_max;
      };

      var starsSprite = PIXI.BaseTexture.fromImage(C3_ASSET_URL + "stars.png");
      var getIconTexture = function getIconTexture(count, subModuleSprite) {
        var starIcon;
        var spriteTexture;
        if (count >= 0) {
          spriteTexture = new PIXI.Texture(starsSprite, new PIXI.Rectangle(count * 90, 0, 90, 49));
          starIcon = new PIXI.Sprite(spriteTexture);
          starIcon.width = starIcon.width * 1.16;
          starIcon.height = starIcon.height * 1.16;
          starIcon.position.x = subModuleSprite.position.x - 5;
          starIcon.position.y = subModuleSprite.position.y - starIcon.height / 2; //-(subModuleSprite.height/2);
        }

        return starIcon;
      };

      var getStars = function getStars(item_info) {
        var levelData = { starsAchieved: 0 };
        var score = item_info.resourceState.score_max;
        if (score >= 1) {
          levelData.starsAchieved = 3;
          levelData.badged = true;
        } else if (score >= 0.75) {
          levelData.starsAchieved = 3;
        } else if (score >= 0.5) {
          levelData.starsAchieved = 2;
        } else if (score >= 0.25) {
          levelData.starsAchieved = 1;
        }

        return levelData;
      };

      function updateMapItems(filteredList, selectedStudent) {
        var existsItem = {};
        var containsAtleastOneFilter = false;
        var count = 0;
        var completedItems = {};

        angular.forEach(items, function (each) {
          var doneItemsList = [];
          if (filteredList && filteredList.length > 0) {
            doneItemsList = _.filter(filteredList, function (item) {
              return item.resource_id === each.resource_info.id;
            });
          }

          each.clearText();
          if (each.icon) {
            each.icon.destroy();
          }

          each.icon = new PIXI.Sprite();

          if (doneItemsList.length > 0) {
            _.each(doneItemsList, function (existsItem) {
              if (existsItem && existsItem.completed) {
                completedItems[count] = true;
                updateItemInfoComplete(existsItem, each.resource_info);
                var stars = getStars(each.resource_info);
                if (stars && stars.starsAchieved > 0 || !selectedStudent) {
                  var starTexture = getIconTexture(stars.starsAchieved, each.sprite);
                  each.icon = starTexture;
                }
                if (!selectedStudent || stars && stars.starsAchieved > 0) {
                  var texture = PIXI.loader.resources[C3_ASSET_URL + "numpadBtn_orange.png"].texture;
                  each.sprite.texture = new PIXI.Texture(texture, new PIXI.Rectangle(0, 110, 135, 100)); //PIXI.loader.resources[C3_ASSET_URL + "lockedLevel.png"].texture;
                  each.updateText(count + 1);
                }
              }
            });
          } else {
            // var height
            if (selectedStudent && count !== 0) {
              each.sprite.texture = PIXI.loader.resources[C3_ASSET_URL + "lockedLevel.png"].texture;
              each.icon = null;
            } else {
              each.icon = getIconTexture(0, each.sprite);
              var buttonTexture = PIXI.loader.resources[C3_ASSET_URL + "numpadBtn_orange.png"].texture;
              each.sprite.texture = new PIXI.Texture(buttonTexture, new PIXI.Rectangle(0, 110, 135, 100)); //PIXI.loader.resources[C3_ASSET_URL + "lockedLevel.png"].texture;
              each.updateText(count + 1);
            }
            // stage.addChild(each.sprite);
          }

          if (each.icon) {
            stage.addChild(each.icon);
          }
          renderer.render(stage);
          count++;
        });

        // always fill the next one with empty stars
        if (selectedStudent) {
          for (var i = 0; i < items.length - 1; i++) {
            var index = i + 1;
            if (completedItems[i] && !completedItems[index]) {
              var starTexture = getIconTexture(0, items[index].sprite);
              items[index].icon = starTexture;
              var buttonTexture = PIXI.loader.resources[C3_ASSET_URL + "numpadBtn_orange.png"].texture;
              items[index].sprite.texture = new PIXI.Texture(buttonTexture, new PIXI.Rectangle(0, 110, 135, 100)); //PIXI.loader.resources[C3_ASSET_URL + "lockedLevel.png"].texture;
              items[index].updateText(index + 1);
              stage.addChild(items[index].icon);
            }
          }
          renderer.render(stage);
        }
      }

      eventManager.listen("teacherStudentWorkspace:studentFilter:change", function (e, eventData) {
        var filteredList = eventData.list || [];
        updateMapItems(filteredList, eventData.selectedStudent);
      });

      eventManager.listen('module:change:meta', function (e, slug) {
        eventManager.broadcast("close:current:module", slug);
      });

      eventManager.listen('destroy-c3-run-like-math-map', function () {
        PIXI_Load_Cache = false;
        window.removeEventListener("resize", onResize);
      });

      scope.$on('$destroy', function () {
        canvas_el.parentNode.removeChild(canvas_el);
        PIXI_Load_Cache = false;
        window.removeEventListener("resize", onResize);
      }.bind(this));

      function onResize(sidepanel_expanded) {
        //var canvas_el =  document.getElementById('canvas');
        if (!canvas_el || !canvas_el.parentElement || !canvas_el.parentElement.parentElement || !canvas_el.parentElement.parentElement.parentElement) {
          return;
        }

        var sidepanel_width = 0;
        if (sidepanel_expanded === true || sidepanel_expanded === false) {
          sidepanel_width = sidepanel_expanded ? 140 : -200;
        }

        canvasDimention = {
          width: canvas_el.parentElement.parentElement.parentElement.clientWidth - sidepanel_width,
          height: canvas_el.parentElement.parentElement.parentElement.clientHeight
        };

        canvas_el.width = canvasDimention.width;
        canvas_el.height = canvasDimention.height;

        renderer.resize(canvasDimention.width, canvasDimention.height);
        if (stage && renderer) {
          var scale = Math.min(0.8, renderer.width / 880);
          stage.scale.set(scale, scale);
          stage.x = renderer.width / 2 - stage.width / 2 - 80;
          if (canvasDimention.width > 500) {
            stage.x -= 40;
          }
          stage.y = renderer.height / 2 - stage.height / 2;
        }

        renderer.render(stage);
      }
      eventManager.listen('sidepanel:toggled', function (e, val) {
        if (!PlatformService.isPhonePortrait()) {
          onResize(val);
        }
      });
    }
  };
});

var PIXI_Load_Cache;
var EXISTS;
'use strict';

angular.module('mtic.components.login', ['mtic.components.alert_popup']);

angular.module('mtic.components.login').directive('login', function (EventManager, userAccount) {
      return {
            template:'<ng-switch on="type"><signin ng-switch-when="signin"></signin><signup ng-switch-when="signup"></signup></ng-switch>',
            scope: {},
            link: function link(scope) {
                  var eventManager = new EventManager('login', scope);
                  scope.type = 'signin';
                  scope.username = userAccount.getData().uuid;
                  scope.restoringSession = false;
                  eventManager.listen('login:open', function (e, type) {
                        scope.type = type;
                  });
            }
      };
});
'use strict';

angular.module('mtic.components.login').component('mticPostIamRegistrationSchoolOne', {
  template:'<div style="height:10px"></div><div ng-show="school.isSelected(school)" style="width:20px;height:20px;background-color: #3a99d8;border-radius: 20px;position: absolute;left:247px;margin-top:-5px;z-index: 1;color:#fff;padding-left:5px">&#10004;</div><div class="box" style="width:260px;box-shadow:none !important;padding:0px 10px 5px 0px !important;" ng-class="{\'school_selected_box\' : school.isSelected(school) }"><article class="media" style="margin-bottom:7px"><div ng-click="school.select(school)" class="media-content" style="cursor:pointer;"><div class="content columns"><p class="column is-12" style="padding: 12px 20px 0px 16px"><strong style="font-size:16px;font-weight:600" ng-bind="school.nameSlug" ng-class="{\'school_selected_text\' : school.isSelected(school) }"></strong><br></p></div></div></article></div>',
  bindings: {
    id: '<',
    nameSlug: '<',
    nameLong: '<',
    // infos: '<',
    select: '<',
    isSelected: '<'
  },
  controllerAs: 'school',
  controller: function controller($log) {
    var school = this;

    // $log.log('school info pass', school.nameSlug, school.nameLong)

    school.iconClass = function () {
      if (school.isSelected(school)) {
        return {
          'button': true,
          'is-info': true
        };
      } else {
        return {
          'button': true,
          'is-info': true,
          'is-outlined': true
        };
      }
    };
  }
});
'use strict';

angular.module('mtic.components.login').component('mticPostIamRegistrationModuleOption', {
  template:'<div class="box"><article class="media"><div class="media-content"><div class="content columns"><p class="column is-9"><strong ng-bind="moduleOption.name"></strong><br><small ng-bind="moduleOption.infos.full_address"></small></p><p class="column is-2"><a ng-class="moduleOption.iconClass()" ng-click="moduleOption.select(moduleOption)"><span class="icon"><i class="fa fa-check-circle-o"></i></span></a></p></div></div></article></div>',
  bindings: {
    id: '<',
    name: '<',
    infos: '<',
    select: '<',
    isSelected: '<'
  },
  controllerAs: 'moduleOption',
  controller: function controller() {
    var moduleOption = this;
    moduleOption.iconClass = function () {
      if (moduleOption.isSelected(moduleOption)) {
        return {
          'button': true,
          'is-info': true
        };
      } else {
        return {
          'button': true,
          'is-info': true,
          'is-outlined': true
        };
      }
    };
  }
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsDashboardCell', function ($log, EventManager, TeacherDataService) {
  return {
    template:'<img ng-if="stats.diagnostic" ng-hide="stats.diagnostic.locked || sp.m1_locked" class="sml-progress" ng-src="{{getProgressRing(\'small\', stats.diagnostic.score_max_mean, stats.diagnostic.locked)}}"> <img ng-if="stats.lessons" class="lrg-progress" ng-src="{{getProgressRing(\'large\', stats.lessons.score_max_mean, stats.diagnostic.locked)}}" ng-hide="sp.m1_locked" style="cursor: pointer;"> <img ng-if="stats.summative" ng-hide="stats.diagnostic.locked || sp.m1_locked" class="sml-progress" ng-src="{{getProgressRing(\'small\', stats.summative.score_max_mean, stats.summative.locked)}}">',
    scope: {
      stats: '=',
      module: '='
    },
    link: function link(scope) {
      var eventManager = new EventManager('teacherStudentsDashboardCell', scope);
      scope.getProgressRing = function (size, score, lock) {
        var url = 'https://s3.eu-central-1.amazonaws.com/mtic-items/interface/';
        if (lock) {
          url += 'teachview-ring-' + size + '-locked.png';
        } else {
          var num = score ? Math.min(21, Math.round(21 * score)) : 0;
          if (num === 0) {
            url += 'teachview-ring-' + size + '-blank.png';
          } else {
            if (String(num).length === 1) {
              num = '0' + num;
            }
            url += 'teachview-ring-' + size + '-fill00' + num + '.png';
          }
        }
        return url;
      };
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('sortIcon', function ($log, EventManager, TeacherDataService) {
  return {
    template:'<i style="position:relative; top:4px; margin-left:6px;" ng-attr-class="fa {{getIconClass()}}" aria-hidden="true"></i>',
    scope: {
      sortBy: '=',
      sortByTarget: '=',
      sortByOrder: '='
    },
    link: function link(scope) {
      // var eventManager = new EventManager('sortIcon', scope);
      scope.getIconClass = function () {
        if (scope.sortByTarget === scope.sortBy) {
          if (scope.sortByOrder === 'ASC') {
            return 'fa-sort-asc';
          } else if (scope.sortByOrder === 'DESC') {
            return 'fa-sort-desc';
          }
        }
        return 'fa-sort';
      };
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsClassLeaderboardConfetti', function ($log) {
    return {
        template:'<canvas id="confetti-canvas" style="overflow-y: hidden;overflow-x: hidden;width: 100%;margin: 0;"></canvas>',
        scope: {},
        link: function link(scope, element) {

            // var W = window.innerWidth;
            // var H = window.innerHeight;
            // const canvas = document.getElementById("confetti-canvas");
            // const context = canvas.getContext("2d");
            // const maxConfettis = 60;
            // const particles = [];

            // const possibleColors = [
            // "DodgerBlue",
            // "OliveDrab",
            // "Gold",
            // "Pink",
            // "SlateBlue",
            // "LightBlue",
            // "Gold",
            // "Violet",
            // "PaleGreen",
            // "SteelBlue",
            // "SandyBrown",
            // "Chocolate",
            // "Crimson"
            // ];

            // function randomFromTo(from, to) {
            //     return Math.floor(Math.random() * (to - from + 1) + from);
            // }

            // function confettiParticle() {
            //     this.x = Math.random() * W; // x
            //     this.y = Math.random() * H - H; // y
            //     this.r = randomFromTo(11, 33); // radius
            //     this.d = Math.random() * maxConfettis + 11;
            //     this.color = possibleColors[Math.floor(Math.random() * possibleColors.length)];
            //     this.tilt = Math.floor(Math.random() * 33) - 11;
            //     this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
            //     this.tiltAngle = 0;

            //     this.draw = function() {
            //         context.beginPath();
            //         context.lineWidth = this.r / 2;
            //         context.strokeStyle = this.color;
            //         context.moveTo(this.x + this.tilt + this.r / 3, this.y);
            //         context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5);
            //         return context.stroke();
            //     };
            // }

            // function Draw() {
            //     const results = [];

            //     // Magical recursive functional love
            //     requestAnimationFrame(Draw);

            //     context.clearRect(0, 0, W, window.innerHeight);

            //     for (var i = 0; i < maxConfettis; i++) {
            //         results.push(particles[i].draw());
            //     }

            //     let particle = {};
            //     let remainingFlakes = 0;
            //     for (var i = 0; i < maxConfettis; i++) {
            //         particle = particles[i];

            //         particle.tiltAngle += particle.tiltAngleIncremental;
            //         particle.y += (1/5)*(Math.cos(particle.d) + 3 + particle.r / 2) / 2;
            //         particle.tilt = Math.sin(particle.tiltAngle - i / 3) * 15;

            //         if (particle.y <= H) {
            //             remainingFlakes++;
            //         }

            //         // If a confetti has fluttered out of view,
            //         // bring it back to above the viewport and let if re-fall.
            //         if (particle.x > W + 30 || particle.x < -30 || particle.y > H) {
            //         particle.x = Math.random() * W;
            //         particle.y = -30;
            //         particle.tilt = Math.floor(Math.random() * 10) - 20;
            //         }
            //     }

            //  return results;
            // }

            // window.addEventListener(
            //     "resize",
            //     function() {
            //         W = window.innerWidth;
            //         H = window.innerHeight;
            //         canvas.width = window.innerWidth;
            //         canvas.height = window.innerHeight;
            //     },
            //     false
            // );

            // // Push new confetti objects to `particles[]`
            // for (var i = 0; i < maxConfettis; i++) {
            //     particles.push(new confettiParticle());
            // }

            // // Initialize
            // canvas.width = W;
            // canvas.height = H;
            // Draw();
        }
    };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').component('teacherClassesStudentsReturn', {
  template:'<div ng-if="table.students.searched" ng-show="table.students.selected" class="columns"><div class="colum is-6"><label>Selected:</label><br><user-box user="table.students.selected"></user-box></div><div class="colum is-6" ng-if="table.classes.list.length > 0"><div class="select"><select ng-options="class as class.name for class in table.classes.list track by class.id" ng-model="table.classes.selected"></select></div><label class="checkbox"><input type="checkbox" ng-model="table.options.transferProgress"> Transfer Work</label> <a class="button" type="submit" ng-click="table.students.addToClass()">Transfer</a></div><div class="colum is-6" ng-if="table.classes.list.length === 0">You have no classes in this school. <button class="button" ng-disabled="true">Transfer</button></div></div><div class="columns"><form ng-submit="table.students.search(table.students.searchText)" class="colum is-6"><label>Student Account</label><div class="field has-addons"><div class="control"><input class="input" type="text" ng-model="table.students.searchText"></div><div class="control"><a class="button is-info" ng-click="table.students.search(table.students.searchText)">Search</a></div></div></form></div><div class="columns"><table class="table colum is-6 is-offset-3" ng-if="table.students.searched"><thead><tr><th>First Name</th><th>Last Name</th><th>Username</th><th>Class Name</th><th>Module</th></tr></thead><tbody><tr ng-repeat="student in table.students.found" ng-click="table.students.select(student)"><td ng-bind="student.first_name"></td><td ng-bind="student.last_name"></td><td ng-bind="student.user_name"></td><td ng-bind="student.classroom.name"></td><td ng-bind="student.getModuleName()"></td></tr></tbody></table></div>',
  bindings: {
    school: '<'
  },
  controllerAs: 'table',
  controller: function controller($q, $log, TeacherDataService, MticAlertModalService) {

    var table = this;

    var validator = Validator.validator();

    var is = Validator.Assert;

    table.flags = {
      loading: true,
      error: null,
      reset: function reset() {
        this.loading = true;
        this.error = null;
      },
      done: function done(error) {
        this.loading = false;
        if (error) {
          this.error = error;
        }
      }
    };

    table.options = {
      transferProgress: true
    };

    table.classes = {
      list: [],
      selected: null
    };

    table.students = {
      searchText: '',
      searched: false,
      found: [],
      selected: null,
      search: function search(studentUserName) {
        return TeacherDataService.searchStudent({
          uuid: studentUserName,
          noschool: true,
          auth_type: 'microsoftStrategy'
        }).then(function (students) {
          table.students.found = students;
          table.students.searched = true;
        });
      },
      select: function select(student) {
        table.students.selected = student;
      },
      addToClass: function addToClass() {
        var student = table.students.selected;
        var classroom = table.classes.selected;
        if (student.moduleResource.id === classroom.module_resource_id) {
          return TeacherDataService.transferStudent({
            user_id: student.user_id,
            from_class_id: student.classroom.id,
            to_class_id: classroom.id,
            transferProgress: table.options.transferProgress
          }).then(function (response) {
            $log.debug({ response: response });
            MticAlertModalService.set('Succesfuly Transfered!', { isLang: false });
          }).catch(function (err) {
            $log.debug(err);
            MticAlertModalService.set('Something happend!', { isLang: false });
          });
        } else {
          var msg = 'Transfering this student to this class will mean that their work will not be moved (since the previous class had access to different resources)';
          MticAlertModalService.set(msg, {
            isLang: false,
            ask: true,
            callback: function callback(saidYes) {
              if (saidYes) {
                return TeacherDataService.transferStudent({
                  user_id: student.user_id,
                  class_id: classroom.id,
                  transferProgress: false
                });
              }
            }
          });
        }
      }
    };

    var getClasses = function getClasses(school_id, reset) {
      return TeacherDataService.getSchoolClasses(reset, school_id, false).then(function (classes) {
        table.classes.list = classes;
        table.classes.selected = classes[0];
        return;
      });
    };

    var updateSelections = function updateSelections(reset) {
      $log.debug('school', table.school);
      var selectedSchool = table.school;
      $log.debug({ selectedSchool: selectedSchool });
      table.flags.reset();

      return getClasses(selectedSchool.id, reset).then(function () {
        table.flags.done();
      });
    };

    table.$onInit = function () {
      updateSelections();
    };

    table.$onChanges = function () {
      updateSelections();
    };
  }
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').component('teacherClassesSchoolsClasses', {
  template:'<div class="mtic-resource-loader-container-wrap" style="left: 0;" ng-show="table.flags.loading"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div ng-if="table.flags.error">{{table.flags.error}}</div><div class="classroom-card-container"><div ng-show="table.archivedStatus && (!table.classes || table.classes.length==0)"><p class="font-size-20 margin-left-20 margin-top-10" ng-bind="getTranslation(\'27647\')">No classes have been archived.</p></div><div class="classroom-card" ng-repeat="classroom in table.classes" ng-hide="isBlacklistedCode(classroom.code)"><div class="classroom-card-header" ng-class="{\'background-color-abb6b9-force\':table.archivedStatus}">{{classroom.getType()}}</div><div class="classroom-card-content"><div class="classroom-card-classname"><span ng-hide="classroom.editable"><div style="position:absolute; left:6px; top:6px;"><a ng-click="classroom.editable = true"><i class="fa fa-pencil item-list-icon" aria-hidden="true"></i></a></div><div style="padding: 0px 30px; text-align: center;word-wrap:break-word" ng-bind="classroom.name"></div></span><form ng-if="classroom.editable" ng-submit="table.updateClass(classroom.id, classroom.name, classroom.description)"><a ng-click="table.updateClass(classroom.id, classroom.name, classroom.description)"><i class="fa fa-check item-list-icon" aria-hidden="true"></i></a> <input type="text" ng-model="classroom.name"></form></div><div class="classroom-card-studentcount" style="display:none;">0 students</div><div class="classroom-card-classcode text-selectable">Code: {{classroom.code}}</div><div ng-show="classroom.shared_users_list" style="margin:0px" class="classroom-card-classcode text-selectable" ng-mouseover="show_full_shared_list = true;" ng-mouseleave="show_full_shared_list = false;" ng-click="show_full_shared_list = !show_full_shared_list"><b>{{language.get(\'shared_with\')}}:</b> <span ng-hide="show_full_shared_list">{{classroom.shared_user_list_capped}}</span><span ng-show="show_full_shared_list">{{classroom.shared_users_list}}</span></div></div><div class="classroom-card-footer" ng-style="{\'padding-top\':classroom.shared_users_list?\'0px\':\'20px\'}"><button ng-if="!openedEditCLassStatusMode" class="button is-large is-success" ng-click="table.viewClassroom(classroom)" ng-bind="language.get(\'14565\')">View Class</button> <button ng-if="!table.archivedStatus && openedEditCLassStatusMode" ng-disabled="classroom.statusUpdating" class="button background-color-ff3860 color-white font-size-20" ng-click="table.archiveClass(classroom,true)"><i class="fa fa-minus color-white margin-top-5" aria-hidden="true"></i> <span class="margin-left-10 color-white" ng-bind="getTranslation(\'27646\')">Remove Class</span></button> <button ng-if="table.archivedStatus && openedEditCLassStatusMode" ng-disabled="classroom.statusUpdating" class="button background-color-00b1e5 color-white font-size-20" ng-click="table.archiveClass(classroom,false)"><i class="fa fa-arrow-up color-white" aria-hidden="true"></i> <span class="margin-left-10 color-white" ng-bind="getTranslation(\'27649\')">Un-archive Class</span></button></div></div><div ng-hide="table.archivedStatus" class="classroom-create-card" ng-click="table.addMode=true" style="position:relative;"><span class="classroom-create-card-icon">+</span><div class="classroom-create-card-text"><div ng-show="true" ng-bind="language.get(\'14560\')">Click here to create a class</div><div ng-show="false">Click here to create your first class</div></div></div></div><div ng-show="table.addMode" class="add-class-container"><div class="mticCard"><div class="mticCard__header"><span class="mticCard__headerText" ng-bind="language.get(\'14561\')">New Class</span> <span class="mticCard__close" ng-click="table.addMode=false;table.classMaker.reset()"><span class="char-icon">&#10006;</span> <i class="fa fa-times-circle" aria-hidden="true"></i></span></div><div class="mticCard__body"><form ng-submit="table.classMaker.create(); table.addMode=false;"><span class="mticCard__enterClassDetails" ng-bind="language.get(\'14536\')"></span><div class="mticCard__selectClassGrade" select-box options="table.modules" model="table.classMaker.selectedModule" filler-text="language.get(\'14562\')" display-function="displayFunc"></div><input class="input mticCard__classDetailsInput" type="text" ng-model="table.classMaker.name" placeholder="{{language.get(\'14578\')}}"> <a class="button mticCard__button" ng-disabled="!(table.classMaker.name && table.classMaker.selectedModule)" ng-click="table.classMaker.create(); table.addMode=false;" ng-bind="language.get(\'14564\')">Add Class</a></form></div></div></div>',
  bindings: {
    school: '<',
    addMode: '=?',
    archivedStatus: '='
  },
  controllerAs: 'table',
  controller: function controller($scope, $q, $log, TeacherDataService, EventManager, language, $timeout, api, LocaleService) {
    $scope.language = language;
    $scope.getTranslation = function (slug) {
      return language.get(slug);
    };
    var eventManager = new EventManager('teacherClassesSchoolsClasses', $scope);
    var table = this;
    var validator = Validator.validator();
    var is = Validator.Assert;
    table.flags = {
      loading: true,
      error: null,
      reset: function reset() {
        this.loading = true;
        this.error = null;
      },
      done: function done(error) {
        this.loading = false;
        if (error) {
          this.error = error;
        }
      }
    };
    table.modules = [];
    table.classes = [];
    // $log.log($scope.table.archivedStatus,"archived-status");

    table.classMaker = {
      selectedModule: null,
      name: '',
      description: '',
      reset: function reset() {
        this.selectedModule = null;
        this.name = '';
        this.description = '';
      },
      create: function create() {
        var selectedModule = this.selectedModule,
            name = this.name,
            description = this.description;

        var newClass = {
          module_id: selectedModule ? selectedModule.module_id : null,
          name: name,
          description: description,
          school_id: table.school.id
        };
        var validationResult = validator.validate(newClass, {
          module_id: [is.greaterThan(0)],
          school_id: [is.greaterThan(0)],
          name: [is.notBlank()]
          //description: [is.notBlank()]
        });
        $log.debug({ validationResult: validationResult });
        if (validationResult === true) {
          $log.debug(newClass);
          return TeacherDataService.createSchoolClass(newClass).then(function () {
            return updateSelections(true);
          });
        } else {
          window.alert('Please fill in all values!');
        }
      }
    };

    table.updateClass = function (class_id, class_name, class_description) {
      table.flags.reset();
      TeacherDataService.updateClassInfo(class_id, class_name, class_description).then(function () {
        updateSelections(true);
      });
    };

    table.viewClassroom = function (classroom) {
      // console.log('table.viewClassroom', classroom)
      TeacherDataService.activeClassroomId = classroom.id;
      eventManager.broadcast('teacher:view:class');
      eventManager.broadcast('teacher:change:tab', 'dashboard');
    };

    eventManager.listen('open-module-view', function (e, args) {
      if (!args) {
        return;
      }
      TeacherDataService.activeClassroomId = args;
      eventManager.broadcast('teacher:view:class');

      $timeout(function () {
        eventManager.broadcast('goto-module-tab', args);
      }, 500);
    });

    var getModules = function getModules(school_id, reset) {
      return TeacherDataService.getSchoolModules({ school_id: school_id, reset: reset }).then(function (modules) {
        table.modules = modules;
        return;
      });
    };

    var loadingClasses = false;
    var goToModTab = function goToModTab() {
      var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));
      var item_id = urlParams.get('item_id');
      if (item_id === 'LEADERBOARD') {
        eventManager.broadcast('set:nav:selection', 'class-leaderboard');
      } else {
        eventManager.broadcast('set:nav:selection', 'modules');
      }
    };
    var getClasses = function getClasses(school_id, reset) {
      if (loadingClasses) {
        return;
      }

      loadingClasses = true;
      TeacherDataService.activeSchoolId = school_id;
      var archiveStatus = table.archivedStatus || false;
      reset = reset || archiveStatus;
      if (archiveStatus) {
        return TeacherDataService.getSchoolArchivedClasses(reset, school_id, true).then(function (classes) {
          loadingClasses = false;
          table.classes = angular.copy(classes);
          return;
        });
      } else {
        return TeacherDataService.getSchoolClasses(reset, school_id, false).then(function (classes) {
          _.each(classes, function (cur_class) {
            if (cur_class.shared_users && cur_class.shared_users.length > 0) {
              var shared_user_list = [];
              cur_class.shared_users.forEach(function (user) {
                shared_user_list.push(user.User.UserInfo.info.first_name + ' ' + user.User.UserInfo.info.last_name);
              });
              cur_class.shared_users_list = _.toString(shared_user_list).split(',').join(', ');
              cur_class.shared_user_list_capped = cur_class.shared_users_list.substr(0, 50) + (cur_class.shared_users_list.length > 50 ? '...' : '');
            }
          });

          loadingClasses = false;
          table.classes = angular.copy(classes);
          if (window.location.href.indexOf('open_item_link') > -1 && !LocaleService.item_link_opened) {
            var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));
            var found_matching_class = false;
            for (var i = 0; i < table.classes.length; i++) {
              var user_class = table.classes[i];
              if (user_class.module_resource_id + '' === urlParams.get('module_id')) {
                found_matching_class = true;
                TeacherDataService.activeClassroomId = user_class.id;
                eventManager.broadcast('teacher:view:class');
                $timeout(goToModTab, 100);
                break;
              }
            }
            if (!found_matching_class) {
              var matching_module;
              $scope.table.modules.forEach(function (mod) {
                if (mod.module_resource_id === Number(urlParams.get('module_id'))) {
                  matching_module = mod;
                }
              });
              if (matching_module) {
                $timeout(function () {
                  if (window.confirm(language.get('item_links_create_class'))) {
                    table.addMode = true;
                    table.classMaker.selectedModule = matching_module;
                  }
                }, 100);
              } else {
                window.alert(language.get('item_links_invalid_mod'));
              }
            }
          }
          eventManager.broadcast('mathletic-comp-classes', table.classes);
          return;
        });
      }
    };

    var updateSelections = function updateSelections(reset) {
      $log.debug('school', table.school);
      var selectedSchool = table.school;
      $log.debug({ selectedSchool: selectedSchool });
      table.flags.reset();
      $q.all([getModules(selectedSchool.id, reset), getClasses(selectedSchool.id, reset)]).then(function () {
        table.flags.done();
      });
    };

    eventManager.listen('refresh-class-list', function () {
      updateSelections(true);
    });

    table.$onInit = function () {
      updateSelections();
    };

    table.archiveClass = function (classRoom, status) {
      if (classRoom.statusUpdating) {
        return;
      }
      classRoom.statusUpdating = true;

      api.updateClassArchiveStatus(classRoom.id, status).then(function (data) {
        // $log.log("return-data-",data);
        classRoom.statusUpdating = false;
        table.classes = _.filter(table.classes, function (each) {
          return each.id !== classRoom.id;
        });
        eventManager.broadcast("updated:class:archive:status", { archived: status, class: classRoom, classes: table.classes });
        if (status) {
          eventManager.broadcast('mathletic-comp-classes', table.classes);
        } else {
          eventManager.broadcast('mathletic-comp-classes-unarchived');
        }
      });
    };

    eventManager.listen('mathletic-comp-classes-unarchived', function () {
      if (!table.archivedStatus) {
        eventManager.broadcast('mathletic-comp-classes', table.classes);
      }
    });

    table.$onChanges = function () {
      $log.debug('school', table.school);
      $scope.table.archivedStatus = table.archivedStatus;
      updateSelections();
    };

    $scope.displayFunc = function (module) {
      return module.getName();
    };

    $scope.isBlacklistedCode = function (code) {
      var isBlacklisted = false;
      if (code) {
        _.each(['c2018', 'c2019', 'c1917'], function (id) {
          if (code.substr(code.length - id.length, id.length) === id) {
            isBlacklisted = true;
          }
        });
      }
      return isBlacklisted;
    };

    eventManager.listen("edit:class:status:mode:on", function (e) {
      $scope.openedEditCLassStatusMode = true;
    });

    eventManager.listen("edit:class:status:mode:off", function (e) {
      $scope.openedEditCLassStatusMode = false;
    });

    eventManager.listen("updated:class:archive:status", function (e, modifiedInfo) {
      if (modifiedInfo.archived && $scope.table.archivedStatus) {
        table.classes.push(modifiedInfo.class);
      } else if (!modifiedInfo.archived && !$scope.table.archivedStatus) {
        table.classes.push(modifiedInfo.class);
      }
    });
  }
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('classPerformanceTable', function ($log, $q, EventManager) {
      return {
            template:'<ul><li ng-repeat="student in students" style="margin:10px;"><b>{{student.user.info | json}}</b><div style="padding:10px;"><pre>{{student.moduleWork[currentModule] | json}}</pre></div><button type="button" ng-click="zoomIn(student)">Zoom In</button></li></ul>',
            scope: {
                  students: '=students',
                  currentModule: '='
            },
            link: function link(scope) {
                  var eventManager = new EventManager('teacherDashboard/classPerformanceTable', scope);
                  scope.zoomIn = function (student) {
                        eventManager.broadcast('teacher:selectStudent', student.user);
                  };
            }
      };
});
'use strict';

angular.module('mtic.components.navbar', []);

angular.module('mtic.components.navbar').directive('navBar', function (userAccount, preliveCheck, api, LocaleService, PlatformService, $rootScope, $log) {
  return {
    template:'<nav id="nav-display-for-certificate" class="nav nav-main"><div class="nav-left" ng-if="!isTeacher()"><nav-bar-back-to-module-arrow></nav-bar-back-to-module-arrow><nav-bar-back-arrow></nav-bar-back-arrow><nav-bar-route-view style="overflow: hidden;"></nav-bar-route-view></div><div class="nav-right"><nav-bar-admin-view ng-if="isAdmin()"></nav-bar-admin-view><nav-bar-teacher-test ng-if="isLoggedIn()"></nav-bar-teacher-test><nav-bar-help></nav-bar-help><nav-bar-volume></nav-bar-volume><nav-bar-language></nav-bar-language><nav-bar-my-classes ng-if="isLoggedIn()"></nav-bar-my-classes><div ng-class="[\'mobile-burger\', (($root.sidebarExpanded) ? \'expanded\' : \'collapsed\')]" ng-click="mobileBurgerClick()"></div><nav-bar-user ng-if="isLoggedIn()"></nav-bar-user></div></nav>',
    restrict: 'E',
    scope: {},
    link: function link(scope) {

      LocaleService.computeCurrentUrlVersion();

      scope.isLoggedIn = function () {
        return userAccount.isLoggedIn();
      };
      scope.isTeacher = function () {
        return userAccount.getData().role.isTeacher;
      };

      scope.isLuxUser = function () {
        return LocaleService.getCurrentLocale() === 'LUXEMBOURG';
      };

      scope.isAdmin = function () {
        return userAccount.getData().isAdmin;
      };

      scope.mobileBurgerClick = function () {
        $rootScope.sidebarExpanded = !$rootScope.sidebarExpanded;
      };
      scope.isPreLive = preliveCheck.isPreliveCheck();

      scope.isOcmt = function () {
        return $rootScope.isOCMT;
      };
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarVolume', function (volumeCaptionStatus, EventManager, language, PlatformService) {
  return {
    template:'<div class="nav-item nav-item__dropdown nav-item__sound"><a onclick="return false;" class="nav-item__titleLink"><div class="nav-item__titleWrap"><i class="fa fa-volume-up" aria-hidden="true"></i></div></a><ul class="nav-item__dropdownWrap"><li class="nav-item__dropdownItem"><a ng-click="status.changeStatus(\'captions\')"><p ng-bind="language.get(\'14527\')">Closed Captions</p><div ng-class="classes.captions()" class="nav-item__soundToggle"></div></a></li><li class="nav-item__dropdownItem" ng-if="!isMobile"><a ng-click="status.changeStatus(\'volume\')"><p ng-bind="language.get(\'14528\')">Sounds</p><div ng-class="classes.sounds()" class="nav-item__soundToggle"></div></a></li></ul></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('navBarVolume', scope);

      scope.isMobile = PlatformService.isMobile;

      scope.status = {
        volumeOn: true,
        captionsOn: false,
        changeStatus: function changeStatus(type) {
          this[type + 'On'] = !this[type + 'On'];
          volumeCaptionStatus.set(this.volumeOn, this.captionsOn);
          eventManager.broadcast('navigation:' + type + ':change', this[type + 'On']);
        }

      };
      scope.language = language;
      scope.classes = {
        main: function main() {
          return scope.status.volumeOn ? {} : { 'nav-item__sound--off': true };
        },
        sounds: function sounds() {
          return scope.status.volumeOn ? { 'nav-item__soundToggle--on': true } : {};
        },
        captions: function captions() {
          return scope.status.captionsOn ? { 'nav-item__soundToggle--on': true } : {};
        }
      };
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarUser', function (userAccount, EventManager, $q, language, $timeout, $rootScope, LocaleService, $log, GenericPopup, api) {
  return {
    template:'<div class="nav-item nav-item__dropdown nav-item__userSettings"><a onclick="return false;" class="nav-item__titleLink"><div class="nav-item__titleWrap"><div class="userDropdown__avatarWrap"><img src="assets/images/navbar/avatar.png" class="userDropdown__avatar"></div><span ng-hide="isTeacher()" ng-bind="fullName()"></span></div></a><ul class="nav-item__dropdownWrap"><li class="nav-item__dropdownItem" ng-show="isOcmtTeacher()"><a ng-click="showChangePasswordModal = true"><span>Change Password</span></a></li><li class="nav-item__dropdownItem"><a ng-click="logoutConfirmation = true"><span ng-bind="language.get(\'27643\')">Logout</span> <span class="icon"><i class="fa fa-sign-out"></i></span></a></li></ul></div><div ng-show="logoutConfirmation" style="position:fixed;top:0px;left:0px;width:100%;height:100%;background-color:rgba(0,0,0,0.4);display:flex;align-items:center;justify-content:center"><div class="box" style="width:260px;font-size:20px;color:#333"><span ng-bind="language.get(\'26211\')">Are you sure you want to logout ?</span><br><br><button ng-click="logoutConfirmation = false" class="button is-primary" ng-bind="language.get(\'26212\')">Cancel</button> <button ng-click="logout()" class="button is-primary" ng-bind="language.get(\'26213\')">Confirm</button></div></div><div ng-show="showChangePasswordModal" style="position:fixed;top:0px;left:0px;width:100%;height:100%;background-color:rgba(0,0,0,0.4);display:flex;align-items:center;justify-content:center"><div class="box" style="width:260px;font-size:20px;color:#333"><div class="mticCard__body" ng-class="{processing: processingPasswordChange}"><span class="mticCard__enterNewPassword">Enter new password:</span><div class="new-password-section" style="margin-bottom:10px"><input type="password" placeholder="Password:" ng-disabled="processingPasswordChange" class="input mticCard__newPasswordInput" ng-model="newPassword"></div><a ng-disabled="processingPasswordChange" class="button mticCard__button is-danger" ng-click="showChangePasswordModal = false">Cancel</a> <a ng-disabled="processingPasswordChange" class="button mticCard__button" ng-click="changePassowrd(newPassword)">Submit</a><div class="processing-text" ng-show="processingPasswordChange">Processing...</div></div></div></div><div ng-if="offline_post_submission" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: fixed;overflow:auto;top:0px;left:0px;z-index:100000000;display:flex;justify-content:center;align-items:center"><div style="background-color:#ffffff;width:400px;height:240px;border-radius: 10px;text-align: center;padding: 30px"><span style="font-size:18px;" ng-bind="language.get(\'15053\')">There appears to be a problem with your Internet connection.</span><br><br><span style="font-size:18px;" ng-bind="language.get(\'15055\')">Check your network connection and try again.</span><br><a class="button is-primary" ng-click="logout()" style="min-width:100px;margin-top:30px;margin-bottom:20px" ng-bind="language.get(\'15054\')">Try Again</a></div></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('navbar:user');
      var active_slug;
      var isUpdating = false;
      scope.language = language;
      scope.logout = function () {
        if (!navigator.onLine) {
          $timeout(function () {
            scope.offline_post_submission = true;
          }, 200);
          return;
        }
        if (isUpdating) {
          return;
        }

        isUpdating = true;
        eventManager.broadcast('logout:manual');
        if (active_slug && active_slug.indexOf('_m56_') > -1 && !userAccount.getData().role.isTeacher) {
          var defer = $q.defer();
          eventManager.broadcast("module:updateAndClose:resource", defer);
          defer.promise.then(function () {
            userAccount.logout();
            isUpdating = false;
          }, function () {
            isUpdating = false;
          });
        } else {
          $timeout(function () {
            userAccount.logout();
            isUpdating = false;
          }, 300);
        }
      };

      scope.fullName = function () {
        return userAccount.getData().fullName;
      };

      scope.isTeacher = function () {
        return userAccount.getData().role.isTeacher;
      };

      scope.numOfNotifications = function () {
        return 0;
      };

      scope.isOcmtTeacher = function () {
        return scope.isTeacher() && $rootScope.isOCMT && !LocaleService.getIfIamUser();
      };

      scope.changePassowrd = function (password) {
        scope.processingPasswordChange = true;
        api.postTeacherPasswordUpdate(password).then(function (response) {
          scope.processingPasswordChange = false;
          scope.showChangePasswordModal = false;
          GenericPopup.open('Reset Password', 'Password has been changed.');
        }).catch(function (err) {
          scope.processingPasswordChange = false;
          scope.showChangePasswordModal = false;
          GenericPopup.open('Reset Password', 'There was an error updating the password.');
        });
      };

      eventManager.listen('module:open:resource', function (e, data) {
        active_slug = data.slug;
      });

      eventManager.listen('module:close:resource', function (e, data) {
        active_slug = "";
      });
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarTeacherTest', function (EventManager, $timeout, $log, TeacherDataService, userAccount, api, $q, language, notificationService) {
  return {
    template:'<div class="navbar-teacher-test-wrapper"><div class="nav-item" style="font-size: 28px; cursor:pointer;" ng-click="showTest()"><a class="nav-item__titleLink"><div class="nav-item__titleWrap"><i class="fa fa-envelope-o"></i></div></a></div></div>',
    restrict: 'E',
    scope: {
      // cycleFourMember: "=",
      // showInNavbar: "="
    },
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('navBarTeacherTest', scope);
      scope.showTest = function () {
        notificationService.showNotifications();
      };
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarRouteView', function (EventManager, language, $log, MapStateService) {
  return {
    template:'<div class="route-path"><span class="route-brand">{{$root.isMTIC ? \'Mathematic\' : \'OCMT-HSE\'}}</span> <span class="route-screen" ng-bind="getModuleText()" ng-if="addText" ng-click="backToModules()" style="cursor: pointer; flex-shrink: 0;"></span> <span class="route-screen-slash" ng-if="getSubmodText() !== \'\'">/</span> <span class="route-screen" ng-bind="getSubmodText()" ng-if="addText" ng-click="closeResource()" style="cursor: pointer"></span> <span class="route-screen-slash" ng-if="addText && getRestText()">/</span> <span class="route-screen" ng-bind="getRestText()" ng-if="addText"></span> <span class="route-screen" ng-bind="getText()" ng-if="!addText"></span></div>',
    restrict: 'E',
    scope: {
      addText: '=?'
    },
    link: function link(scope, element, attrs) {

      var eventManager = new EventManager('navBarRouteView', scope);

      var mainApp;
      var secondaryScreen;
      var subModule;
      var resourceName;

      var main_slug;
      var secondary_slug;
      var subModule_slug;
      var resource_slug;

      eventManager.listen('module:open:resource', function (e, resourceData) {
        resource_slug = resourceData.slug;
        resourceName = language.get(resourceData.slug);
        if ((!resourceName || resourceName === resourceData.slug) && resourceData.name) {
          resourceName = resourceData.name;
        }
      });

      eventManager.listen('module:close:resource', function (e, args) {
        if (!(args && args.isPassive)) {
          resource_slug = '';
          resourceName = '';
        }
      });

      eventManager.listen('update:resource:slug:route:name', function (e, resourceData) {
        resource_slug = resourceData.slug;
        resourceName = language.get(resourceData.slug);
        if (!resourceName) {
          resourceName = resourceData.name;
        }
      });

      eventManager.listen('app:open', function (e, type) {
        main_slug = type;
        mainApp = language.get(type);
      });

      eventManager.listen('app:secondary:opened', function (e, type) {
        secondary_slug = type;
        secondaryScreen = language.get(type);
        if (!secondaryScreen) {
          secondaryScreen = type;
        }
      });

      eventManager.listen('submodule:opened', function (e, moduleData) {
        subModule_slug = moduleData.slug;
        subModule = language.get(moduleData.slug);
        if (!subModule) {
          subModule = moduleData.name;
        }
      });

      eventManager.listen('submodule:closed', function (e, moduleData) {
        subModule_slug = '';
        subModule = '';
      });

      eventManager.listen('update:submodule:slug:route:name', function (e, moduleData) {
        subModule_slug = moduleData.slug;
        subModule = language.get(moduleData.slug);
        if (!subModule) {
          subModule = moduleData.name;
        }
      });

      eventManager.listen('language:change', function (e, data) {
        if (resource_slug !== '') {
          resourceName = language.get(resource_slug);
        }
        mainApp = language.get(main_slug);
        secondaryScreen = language.get(secondary_slug);
        subModule = language.get(subModule_slug);
      });

      scope.getText = function () {
        var use = mainApp === 'student' ? language.get('14569') : mainApp;
        return [use, secondaryScreen, subModule, resourceName].filter(function (a) {
          return a;
        }).join(' / ');
      };

      scope.getModuleText = function () {
        var txt = scope.addText;
        txt = txt.replace('Modules', language.get('14569'));
        return txt;
      };
      scope.getSubmodText = function () {
        if (!subModule) {
          return '';
        }
        var txt = subModule;
        return txt;
      };
      scope.getRestText = function () {
        if (resource_slug && (resource_slug === 'run_like_math' || resource_slug.indexOf('run_like_math') === -1 || resource_slug.indexOf('lv_') === -1)) {
          return language.get(resource_slug);
        } else if (resource_slug) {
          var splt = resource_slug.split('_');
          var level = '';
          if (!isNaN(splt[splt.length - 1])) {
            level = splt[splt.length - 1];
          }
          var trans_slug = resource_slug.replace('_' + level, '');
          //run_like_math_obj[trans_slug][language.getCurrentSelectedLanguage()]
          resourceName = language.get(trans_slug) + ' ' + level;
          return resourceName;
        }
      };

      scope.backToModules = function () {
        eventManager.broadcast('module:change:meta', MapStateService.getMetaStateSlug());
        var focusedSlug = MapStateService.getFocusSlug();
        var activeModule = MapStateService.getActiveModule();
        if (focusedSlug && focusedSlug.indexOf(activeModule) > -1) {
          MapStateService.setFocusSlug("");
        }

        subModule_slug = '';
        subModule = '';
        scope.closeResource();
      };

      scope.closeResource = function () {
        if (resource_slug !== '') {
          eventManager.broadcast('module:close:resource');
        }
      };
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarOnlineStatus', function (EventManager, $interval) {
  return {
    template:'<div class="nav-item onlineStatus"><a onclick="return false;" class="nav-item__titleLink" ng-click="online = !online"><div class="nav-item__titleWrap"><p class="onlineStatus__statusText">Online</p><p class="onlineStatus__innerCircle" ng-class="{\'onlineStatus__innerCircle--online\': isOnline}"><span class="icon"><i ng-hide="!isOnline" class="fa fa-check"></i><i ng-hide="isOnline" class="fa fa-times"></i></span></p></div></a></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('navBarOnlineStatus', scope);

      scope.isOnline = navigator.onLine;
      eventManager.broadcast('online:status', scope.isOnline);
      $interval(function () {
        if (scope.isOnline !== navigator.onLine) {
          scope.isOnline = !scope.isOnline;
          eventManager.broadcast('online:status', scope.isOnline);
        }
      }, 500);
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarMyClasses', function (TeacherDataService, language, EventManager, userAccount, $q, notificationService, MapStateService) {
  return {
    template:'<div class="nav-item no-bg-trans nav-item__titleWrap nav-item__myClasses"><a class="nav-item__titleLink"><div class="nav-item__titleWrap"><button class="button is-small is-danger" ng-click="clickButton()" ng-bind="getTranslation(\'27642\')">My Classes</button></div></a></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('navbar:my-classes:click');
      var isUpdating = false;
      var active_slug = '';

      function onClick() {
        eventManager.broadcast("navbar:my-classes:click");
        if (active_slug) {
          eventManager.broadcast('module:close:resource');
        }
        isUpdating = false;
      }

      eventManager.listen('agenda_myclasses_change_request_granted', function (e, args) {
        scope.clickButton(true);
      });

      scope.getTranslation = function (slug) {
        return language.get(slug);
      };

      scope.clickButton = function (dont_stop) {
        if (notificationService.isNotificationActive()) {
          return;
        } else {
          notificationService.hideNotifications();
        }
        if (TeacherDataService.inTeacherAgendaView && !dont_stop) {
          eventManager.broadcast('request_agenda_change', { goto_myclass: true });
          return;
        }

        MapStateService.setFocusSlug("");

        if (isUpdating) {
          return;
        }

        isUpdating = true;
        if (active_slug && active_slug.indexOf('_m56_') > -1 && !userAccount.getData().role.isTeacher) {
          var defer = $q.defer();
          eventManager.broadcast("module:updateAndClose:resource", defer);
          defer.promise.then(onClick, function () {
            isUpdating = false;
          });
        } else {
          onClick();
        }
      };

      eventManager.listen('module:open:resource', function (e, data) {
        active_slug = data.slug;
      });

      eventManager.listen('module:close:resource', function (e, data) {
        active_slug = "";
      });
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarLanguage', function (language, EventManager, $cookies, $timeout, $log) {
  return {
    template:'<div class="nav-item nav-item__dropdown nav-item__language"><div class="nav-item__titleLink"><div class="nav-item__titleWrap"><span class="nav-item__title" ng-bind="language.getCurrentSelectedLanguage(true)">ENGLISH</span> <span class="icon"><i class="fa fa-angle-down"></i></span></div></div><ul class="nav-item__dropdownWrap"><li class="nav-item__dropdownItem" ng-repeat="lang in language.getActiveLanguageOptions()" ng-click="selectLanguage(lang.slug);" name="button"><div ng-bind="lang.text">English</div></li></ul></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('language');
      scope.ui = {
        isOpen: false
      };
      scope.isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);

      scope.language = language;
      scope.selectLanguage = function (slug) {
        scope.ui.isOpen = false;
        if (!scope.isMobile) {
          $timeout(function () {
            scope.ui.isOpen = true;
          }, 200);
        }
        // if (slug !== $cookies.get('bar_language')) {
        language.set(slug);
        // }
      };
      eventManager.listen("language:options:change", function (e) {
        scope.languageOptions = language.options;
      });
      scope.$watch('ui.isOpen', function (val) {});

      //console.log(language.getActiveLanguageOptions())
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarHelp', function (EventManager, language, $log, BRANDING, $rootScope) {
  return {
    template:'<div class="nav-item nav-item__about" style="font-size: 28px; cursor:pointer;" ng-click="openHelpChat()"><a class="nav-item__titleLink"><div class="nav-item__titleWrap"><i class="fa fa-question-circle-o" aria-hidden="true"></i></div></a></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('navBarHelp', scope);
      // eventManager.broadcast('navigation:' + type + ':change', this[type + 'On']);

      var isOlarkVisible = false;

      //use this if you need to set olark language dynamically
      // eventManager.listen('language:change', function(){     
      //   if(language.getCurrentSelectedLanguage() === 'en'){
      //     window.olark('api.box.setLocale', 'en-US')
      //   }else{
      //     window.olark('api.box.setLocale', 'fr-FR')
      //   }
      // })

      scope.openHelpChat = function (forced) {
        if (isOlarkVisible && !forced) {
          isOlarkVisible = false;
          window.olark('api.box.hide');
          eventManager.broadcast("user:chat", "close");
        } else {
          isOlarkVisible = true;
          window.olark('api.box.expand');

          eventManager.broadcast("user:chat", "open");
        }
      };

      eventManager.listen('help:open:forced', function () {
        scope.openHelpChat(true);
      });
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarBackToModuleArrow', function (EventManager, MapStateService, $log, TeacherDataService) {
  return {
    template:'<div class="nav-item back-button-clipper" ng-class="{\'clipHide\':!status.show}"><a class="nav-item__titleLink" ng-click="closeResource()"><div class="nav-item__titleWrap"><span class="icon"><i class="fa fa-angle-left"></i></span></div></a></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('navBarBackToModuleArrow', scope);
      var active = false;
      scope.status = {
        show: false

      };
      scope.closeResource = function () {
        scope.status.show = false;
        var focusedSlug = MapStateService.getFocusSlug();
        var activeModule = MapStateService.getActiveModule();
        eventManager.broadcast('module:change:meta', MapStateService.getMetaStateSlug());
        if (focusedSlug && focusedSlug.indexOf(activeModule) > -1) {
          MapStateService.setFocusSlug("");
        }

        if (!TeacherDataService.isTeacherWorkspaceView) {
          eventManager.broadcast("update:submodule:slug:route:name", { slug: "", name: "" });
        }
      };
      eventManager.listen('module:change:submodule', function (e, data) {
        scope.status.show = true;
        active = true;
        eventManager.broadcast('hide:back:arrow');
      });

      eventManager.listen('module:open:resource', function (e, data) {
        scope.status.show = false;
      });

      eventManager.listen('module:close:resource', function (e, args) {
        if (!(args && args.isPassive)) {
          if (active) {
            scope.status.show = true;
          }
        }
      });

      eventManager.listen('hide:back:module:arrow', function (e, data) {
        scope.status.show = false;
      });
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarBackArrow', function (EventManager, $q, userAccount, $log, $timeout) {
  return {
    template:'<div class="nav-item back-button-clipper" ng-class="{\'clipHide\':!status.show}"><a class="nav-item__titleLink" ng-click="closeResource()"><div class="nav-item__titleWrap"><span class="icon"><i class="fa fa-angle-left"></i></span></div></a> <input type="text" id="backInvisInput" style="display:none" class="position-absolute top-25 width-1"></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('navBarBackArrow', scope);
      var active_slug = '';
      var isClosing = false;
      scope.status = {
        show: false
      };

      var closeResource = function closeResource() {
        eventManager.broadcast('module:close:resource');
        // eventManager.clearResourceSession()
        isClosing = false;
      };

      scope.closeResource = function () {
        if (isClosing) {
          return;
        }
        var invisButton = document.getElementById("backInvisInput");
        try {
          invisButton.style.display = 'inline-block';
          invisButton.focus();
          $timeout(function () {
            invisButton.blur();
            invisButton.style.display = 'none';
          }, 50);
        } catch (e) {
          $log.log('hiding input field that is there');
        }

        isClosing = true;
        if (active_slug && active_slug.indexOf('_m56_') > -1 && !userAccount.getData().role.isTeacher) {
          var defer = $q.defer();
          eventManager.broadcast('module:updateAndClose:resource', defer);
          defer.promise.then(closeResource, function () {
            isClosing = false;
          });
        } else {
          closeResource();
        }
        scope.status.show = false;
      };

      eventManager.listen('module:open:resource', function (e, data) {
        active_slug = data.slug;
        if (data.is_forced) {
          return;
        }
        scope.status.show = true;
      });

      eventManager.listen('module:close:resource', function (e, args) {
        if (!(args && args.isPassive)) {
          scope.status.show = false;
        }
      });

      //hide:back:arrow
      eventManager.listen('hide:back:arrow', function (e, data) {
        scope.status.show = false;
      });
    }
  };
});
'use strict';

angular.module('mtic.components.navbar').directive('navBarAdminView', function (EventManager, $timeout, $log, userAccount, api) {
  return {
    template:'<div class="nav-item" ng-click="broadCastAdminShow()" style="font-size: 28px; cursor:pointer;"><a class="nav-item__titleLink"><div class="nav-item__titleWrap"><i class="fa fa-user-circle-o"></i></div></a></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element, attrs) {
      var eventManager = new EventManager('navBarAdminView', scope);

      scope.broadCastAdminShow = function () {
        eventManager.broadcast('show_admin_view');
      };
    }
  };
});
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('mtic.components.notifications', []);
angular.module('mtic.components.notifications').directive('notificationsList', function ($log, EventManager, $timeout, LocaleService, TeacherDataService, language, api, userAccount, notificationService, apiTranslationService, ModuleFilter, $q, StudentDataService) {
  return {
    template:'<style>\n    @keyframes shake {\n    10%, 90% {\n      transform: translate3d(-2px, 0, 0);\n    }\n  \n    20%, 80% {\n      transform: translate3d(4px, 0, 0);\n    }\n  \n    30%, 50%, 70% {\n      transform: translate3d(-8px, 0, 0);\n    }\n  \n    40%, 60% {\n      transform: translate3d(8px, 0, 0);\n    }\n  }\n  \n  .apply-shake {\n      animation: shake 0.8s cubic-bezier(.36,.07,.19,.97) both;\n  }\n  .fullsize-overlay {\n    position: fixed;z-index:100;width:100%;height:100%;left:0;top:0;background-color:rgba(0,0,0,0.4);display:flex;\n  }\n  .grey_box{\n    padding:20px;display:flex;flex-direction:column;align-items:center;background-color:#f1f1f1;border-radius:10px\n  }\n  .notification_info{\n    font-size:12px;\n    font-weight: bold;\n  }\n  </style><div ng-show="show_notifications" class="fullsize-overlay" style="align-items:center;justify-content:center"><div ng-hide="show_archive_confirmation" id="notifications_box" class="grey_box"><span style="color:#ccc;font-size:18px;width:100%;"><span ng-bind="getTranslation(\'NOTIFICATIONS\')">NOTIFICATIONS</span><button class="delete" aria-label="close" ng-click="attempt_to_hide()" style="float:right"></button></span><table ng-hide="showArchivedNotifications || showMessagePanel" class="table is-hoverable is-fullwidth"><tbody><tr ng-style="{\'background-color\':item.is_forced && !item.dismissed && highlight_forced?\'#ffcc\':\'#fff\'}" ng-repeat="item in notifications_list" ng-hide="item.hidden || item.archived" style="cursor:pointer"><td ng-bind="renderMomentDate(item.release_date)" style="color:rgb(0, 184, 184)" ng-click="open_notification(item)"></td><td ng-style="{\'color\': !item.dismissed || item.is_repeatable? \'#333\':\'#ccc\'}" ng-click="open_notification(item)">{{getApiTranslation(item.name)}}<div ng-show="item.ignore_count && item.ignore_count > 1 && !item.dismissed && !item.is_forced" class="notification_info">{{getTranslation(\'notification_mandatory_1\').replace(\'__\', item.ignore_count)}}</div><div ng-show="item.ignore_count !== null && item.ignore_count < 2 && !item.dismissed && !item.is_forced" ng-bind="getTranslation(\'notification_mandatory_2\')" class="notification_info">This notification will become mandatory on your next login</div></td><td style="color:rgb(255, 0, 0);">{{item.dismissed ? \'\': item.should_reset ? getTranslation(\'follow_up\'):getTranslation(\'NEW\')}} <i ng-show="item.is_forced && !item.dismissed" class="fa fa-exclamation-circle" aria-hidden="true" style="margin-top:4px"></i> <i ng-show="item.dismissed" class="fa fa-check" aria-hidden="true" style="color:#66CC66"></i></td></tr></tbody></table><table ng-show="showArchivedNotifications && !showMessagePanel" class="table is-hoverable is-fullwidth"><tbody><tr ng-style="{\'background-color\':item.is_forced && !item.dismissed && highlight_forced?\'#ffcc\':\'#fff\'}" ng-repeat="item in notifications_list" ng-hide="!item.archived" style="cursor:pointer"><td ng-bind="renderMomentDate(item.release_date)" style="color:rgb(0, 184, 184)"></td><td ng-bind="item.name" style="color:#ccc"></td><td style="color:rgb(255, 0, 0);"><i ng-show="item.dismissed" ng-click="archiveNotification(item)" class="fa fa-archive" aria-hidden="true" style="color:#555"></i></td></tr></tbody></table><div ng-show="showMessagePanel"><div ng-show="message.sending" class="loader"></div><div ng-show="message.success">Message Sent!</div><div ng-show="!message.sending && !message.success">Enter user id: <input type="text" ng-model="message.user_id"><br><textarea rows="6" ng-model="message.text">\n        </textarea></div></div><div><button class="button" ng-show="showArchivedNotifications && !showMessagePanel" ng-click="showArchivedNotifications = false">Hide Archived</button><button class="button is-success" ng-show="showMessagePanel" ng-click="message.sendMessage()">Send</button></div></div><div ng-show="show_archive_confirmation" style="width:400px;padding:20px;display:flex;flex-direction:column;align-items:center;background-color:#f1f1f1;border-radius:10px"><div ng-show="archiving" class="loader"></div><div ng-hide="archiving" style="text-align: center"><span ng-hide="showArchivedNotifications">Archive notification ?</span> <span ng-show="showArchivedNotifications">Unarchive notification ?</span><div style="display:flex;padding:10px"><button class="button is-danger" ng-click="show_archive_confirmation = false">Cancel</button> <button class="button is-success" ng-click="archive()" style="margin-left:10px">Confirm</button></div></div></div></div><ng-switch ng-if="notificationView" on="notificationView" class="fullsize-overlay" ng-style="{\'top\' : notificationView === \'resource_notification\' ? \'0px\' : \'35px\'}" style="justify-content:center;align-items:center;z-index:10000;overflow: auto"><cycle-prompt ng-switch-when="cycle_prompt"></cycle-prompt><student-questionnaire-prompt ng-switch-when="student_baseline_prompt" set-resource="setResource" is-baseline="true"></student-questionnaire-prompt><student-questionnaire-prompt ng-switch-when="student_questionnaire_prompt" set-resource="setResource" is-baseline="false"></student-questionnaire-prompt><student-questionnaire-prompt ng-switch-when="student_post_test" set-resource="setResource" is-baseline="false" is-post-test="true"></student-questionnaire-prompt><teacher-onboarding-prompt ng-switch-when="teacher_onboarding" set-resource="setResource"></teacher-onboarding-prompt><teacher-updates ng-switch-when="notification_teacher_view" dismissed="dismissed"></teacher-updates><mtic-resource style="width:100%;height:100%" ng-switch-when="resource_notification" window-id="loadedResource" resource="resource_data" scroll-frame="\'yes\'"></mtic-resource><user-message ng-switch-when="user_message" message="current_notification.log_state.message" from-user="current_notification.from_user"></user-message><system-message ng-style="{\'width\': iframe_style.width ? iframe_style.width : \'95%\', \'height\': iframe_style.height ? iframe_style.height : \'95%\'}" ng-switch-when="iframe_message" resource-data="current_notification.resource" iframe-style="iframe_style"></system-message></ng-switch>',
    scope: {},
    link: function link(scope) {
      var eventManager = new EventManager('notificationSystem');
      scope.notifications_list = [];
      var dismissed_list = [];
      var eligbleSeenNotifications = [];
      scope.getTranslation = function (slug) {
        return language.get(slug);
      };
      function init() {
        $q.all([api.getUserNotifications(userAccount.getData().user_id), apiTranslationService.getTranslationPack('mtic_notifications')]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              notifications = _ref2[0],
              translations = _ref2[1];

          // scope.show_notifications = true;
          // $log.log('raw notifications : ' , notifications);
          scope.notifications_list = process_notifications(notifications);
          $log.log('got user notifications : ', scope.notifications_list);
          // $log.log('got eligbleSeenNotifications : ' , eligbleSeenNotifications)
          updateHiddenStatus();
          //Added a slight timeout to avoid flashing notifications that are not hidden in time
          $timeout(function () {
            checkPending();
          }, 300);
        });
      }
      scope.getApiTranslation = function (id) {
        return apiTranslationService.getTranslation(id);
      };

      function process_notifications(list, mapping) {

        var modified = [];
        dismissed_list = [];
        var reset_mapping = mapping || {};
        var reprocess = false;

        list.forEach(function (entry) {

          var notificationId = entry.id;

          if (ModuleFilter.checkNotificationAvailable(entry.notification_data)) {
            if (entry.notification_type === 'p2p') {
              var p2p_list = _.map(entry.NotificationStateLogs, function (p2p_entry) {
                return {
                  id: notificationId,
                  instance_id: p2p_entry.id,
                  name: entry.notification_slug,
                  is_forced: entry.is_forced,
                  is_repeatable: entry.is_repeatable,
                  dismissed: p2p_entry.dismissed,
                  from_user: p2p_entry.from_user_id,
                  log_state: p2p_entry.log_state,
                  release_date: entry.notification_type === 'p2p' ? p2p_entry.created_at : entry.display_release_date,
                  type: entry.notification_type,
                  archived: p2p_entry.hidden
                };
              });
              modified = modified.concat(p2p_list);
            } else {

              var isDismissed = false;
              var isSeen = false;
              var notiStateLog = entry.NotificationStateLogs[0];
              var notiStateLogData;
              var isNotiHidden;
              var gracePeriodDays;
              var ignoreLimit;
              var new_ignore_count;
              if (notiStateLog) {
                notiStateLogData = notiStateLog.log_state;
                isNotiHidden = notiStateLog.hidden;
              }
              if (entry.notification_data) {
                gracePeriodDays = entry.notification_data.grace_period_days;
                ignoreLimit = entry.notification_data.ignore_limit;
              }

              var seen_date;
              var latest_entry;
              //filtering out old logs when a yearly reset is used
              if (entry.notification_data && entry.notification_data.yearly_reset) {
                entry.NotificationStateLogs = _.filter(entry.NotificationStateLogs, function (cur_log) {
                  return new Date(cur_log.updated_at) > new Date(entry.notification_data.yearly_reset);
                });
              }

              _.each(entry.NotificationStateLogs, function (log) {
                isDismissed = isDismissed || log.dismissed;

                if (!latest_entry || new Date(log.created_at) > new Date(latest_entry.created_at)) {
                  latest_entry = log;
                }
                if (log.log_state && log.log_state.isSeenDuringGrace) {
                  seen_date = new Date(log.updated_at);
                }
                isSeen = true;
              });

              //if the notification is dismissed and reset settings is not undefined, check if it should be reset
              if (latest_entry && latest_entry.dismissed && entry.notification_data && entry.notification_data.reset_settings && !latest_entry.log_state.is_reset) {
                //the notification_data's reset_settings has a reset_by slug which indicates the notification this one is reset by, find it
                var reset_entry = _.find(list, function (list_entry) {
                  return list_entry.notification_slug === entry.notification_data.reset_settings.reset_by;
                });

                if (reset_entry && reset_entry.NotificationStateLogs) {
                  var reset_dismiss_date;
                  _.each(reset_entry.NotificationStateLogs, function (log) {
                    //if the first_element_reset flag is present, then it doesn't require the dependant notification to have been reset itself, otherwise it does
                    if (log.dismissed && (log.log_state && log.log_state.is_reset && !entry.notification_data.reset_settings.first_element_reset || (!log.log_state || !log.log_state.is_reset) && entry.notification_data.reset_settings.first_element_reset)) {
                      reset_dismiss_date = new moment(log.dismissed_at);
                    }
                  });

                  if (reset_dismiss_date) {
                    reset_dismiss_date.add(entry.notification_data.reset_settings.reset_days, 'days');
                    //if today is after the calculated reset date, reset the notification
                    if (reset_dismiss_date < new moment()) {
                      isDismissed = false;
                      entry.should_reset = true;
                      if (reset_dismiss_date < new moment().add(-1, "day")) {
                        //if more than one day has passed since the reset date, notification is mandatory
                        entry.is_mandatory = true;
                      }
                      //$log.log('SHOULD RESET NOW : ', reset_dismiss_date, entry.is_mandatory)
                    }
                  }
                }
              }

              if (gracePeriodDays && !isSeen) {
                eligbleSeenNotifications.push(notificationId);
              }

              var gracePeriodOver = false;
              var force_optional = false;
              var cur_date = new Date();

              //checking if grace period is over
              if (!isDismissed && seen_date && gracePeriodDays && !entry.should_reset) {
                var unlockedByEntry = _.find(list, function (notif) {
                  return entry.unlocked_by_notifications.indexOf(notif.notification_slug) > -1;
                });

                seen_date.setDate(seen_date.getDate() + gracePeriodDays);
                if (seen_date < cur_date) {
                  gracePeriodOver = true;
                }

                // adding 1 day to force mandatory when show_after_grace_period flag is used
                var postGracePeriodDate = _.clone(seen_date);
                postGracePeriodDate.setDate(postGracePeriodDate.getDate() + 1);

                var mandatoryDatePassed = postGracePeriodDate > cur_date;

                if (unlockedByEntry && unlockedByEntry.NotificationStateLogs && unlockedByEntry.NotificationStateLogs.length > 0) {
                  seen_date = new Date(unlockedByEntry.NotificationStateLogs[0].dismissed_at);
                  seen_date.setDate(seen_date.getDate() + gracePeriodDays);
                  if (seen_date < cur_date) {
                    gracePeriodOver = true;
                  }

                  if (entry.NotificationStateLogs) {
                    var entryCreatedAt = new Date(entry.NotificationStateLogs[0].created_at);
                    entryCreatedAt.setDate(entryCreatedAt.getDate() + 1);
                    mandatoryDatePassed = entryCreatedAt > cur_date;
                  }
                }

                if (entry.notification_data && entry.notification_data.show_after_grace_period && mandatoryDatePassed) {
                  force_optional = true;
                }
              } else if (!isDismissed && ignoreLimit) {
                new_ignore_count = latest_entry && latest_entry.log_state.ignored_count ? latest_entry.log_state.ignored_count : 1;

                if (latest_entry && latest_entry.log_state.ignored_count && latest_entry.log_state.ignored_date) {
                  if (moment(latest_entry.log_state.ignored_date, 'MM-DD-YYYY').format('MM-DD-YYYY') !== moment().format('MM-DD-YYYY')) {
                    if (latest_entry.log_state.ignored_count >= ignoreLimit) {
                      //if ignore count is at the limit make it mandatory
                      entry.is_forced = true;
                      new_ignore_count = null;
                    } else {
                      //if ignore count is less than limit increase it
                      new_ignore_count++;
                      api.logNotificationState(userAccount.getData().user_id, entry.id, { ignored_count: new_ignore_count, ignored_date: moment().format('MM-DD-YYYY') }, true).then(function () {});
                    }
                  }
                } else {
                  api.logNotificationState(userAccount.getData().user_id, entry.id, { ignored_count: 1, ignored_date: moment().format('MM-DD-YYYY') }, true).then(function () {});
                }
              }

              modified.push({
                id: entry.id,
                name: entry.notification_slug,
                is_forced: entry.is_forced || gracePeriodOver && !force_optional || entry.is_mandatory,
                is_repeatable: entry.is_repeatable,
                unlocked_by: entry.unlocked_by_notifications,
                dismissed: isDismissed,
                release_date: entry.display_release_date,
                type: entry.notification_type,
                log_state: notiStateLogData,
                hidden: entry.unlocked_by_notifications && entry.unlocked_by_notifications.length > 0 && !isDismissed,
                show_when_available: entry.notification_data && entry.notification_data.show_when_available_only,
                hidden_by_flag: !gracePeriodOver && entry.notification_data && entry.notification_data.show_after_grace_period && !isDismissed && !entry.should_reset,
                archived: isDismissed && isNotiHidden,
                resource: entry.Resource,
                options: entry.notification_data,
                should_reset: entry.should_reset,
                ignore_count: ignoreLimit ? ignoreLimit - new_ignore_count : null
              });
              if (isDismissed) {
                dismissed_list.push(entry.notification_slug);
              }
              if (entry.notification_slug === "cycle_prompt" && entry.NotificationStateLogs && entry.NotificationStateLogs[0]) {
                checkC4Status(entry.NotificationStateLogs[0].log_state);
              }
            }
          }
        });

        if (reprocess) {
          return process_notifications(list, reset_mapping);
        } else {
          return modified;
        }
      }

      function updateHiddenStatus() {
        var reset = false;
        scope.notifications_list.forEach(function (notification) {
          if (notification.unlocked_by && notification.unlocked_by.length > 0) {
            var hidden = false;
            notification.unlocked_by.forEach(function (locker) {
              if (dismissed_list.indexOf(locker) === -1 || !scope.is_c4_member && notification.options.c4_users_only) {
                hidden = true;
              }
            });
            if (!notification.hidden && hidden) {
              dismissed_list.splice(dismissed_list.indexOf(notification.name), 1);
              reset = true;
            }
            notification.hidden = hidden && !notification.should_reset;
          }
          if (!notification.hidden && eligbleSeenNotifications.indexOf(notification.id) > -1) {
            api.logNotificationState(userAccount.getData().user_id, notification.id, { isSeenDuringGrace: true }).then(function () {
              eligbleSeenNotifications.splice(eligbleSeenNotifications.indexOf(notification.id), 1);
            });
          }

          notification.hidden = notification.hidden || notification.hidden_by_flag;
          // the show_when_available flag allows the notification to be displayed only when it's available
          if (notification.show_when_available) {
            notification.hidden = notification.hidden || notification.dismissed && !notification.is_repeatable;
          }
        });
        if (reset) {
          updateHiddenStatus();
        }
      }
      eventManager.listen('login:first', function () {
        init();
      });

      scope.attempt_to_hide = function () {
        if (checkPending(true)) {
          document.querySelector("#notifications_box").classList.add("apply-shake");
          scope.highlight_forced = true;
          $timeout(function () {
            scope.highlight_forced = false;
            document.querySelector("#notifications_box").classList.remove("apply-shake");
          }, 800);
        } else {
          scope.showMessagePanel = false;
        }
      };
      scope.renderMomentDate = function (date) {
        return moment(date).locale(language.getMomentLocale()).format('D MMM YYYY');
      };
      scope.open_notification = function (notification) {
        if (!notification.is_repeatable && notification.dismissed) {
          return;
        }
        // $log.log('opening notification : ' , notification)
        scope.current_notification = notification;

        if (notification.options && notification.options.language) {
          language.setAvailableOptions(notification.options.language);
        }
        if (notification.type === 'system' || notification.type === 'p2p') {
          scope.notificationView = notification.name;
          scope.dismissed = notification.dismissed;
        } else if (notification.type === 'iframe_message') {
          if (!eventManager.getResourceSession() || eventManager.getResourceSession() && window.confirm(scope.getTranslation("mtic_close_opened_lesson"))) {
            if (eventManager.getResourceSession()) {
              eventManager.broadcast('module:close:resource');
            }
            scope.current_notification.resource.notification_slug = scope.current_notification.name;
            scope.setResource(scope.current_notification.resource, scope.current_notification.should_reset);
            scope.notificationView = notification.type;
            scope.dismissed = notification.dismissed;

            scope.iframe_style = { "show_close_button": !notification.is_forced };
            if (notification.options.style) {
              scope.iframe_style.width = notification.options.style.width;
              scope.iframe_style.height = notification.options.style.height;
            }
          }
        } else if (notification.type === 'resource') {
          scope.notificationView = 'resource_notification';
          scope.resource_data = {
            hostUrl: notification.resource.content.hostUrl,
            module_id: 57,
            slug: notification.resource.slug,
            id: notification.resource.id,
            class_id: 99999,
            content: notification.resource.content
          };
        }
        eventManager.broadcast('user:view:notification', notification.name);
        scope.show_notifications = false;
      };

      function checkPending(attempt_dismiss) {
        var show = false;
        //the popup flag is used to hide a notification from the notificaion list but immediately open it instead
        var popup_available = false;
        scope.notifications_list.forEach(function (item) {
          if (!attempt_dismiss && !item.dismissed && !item.hidden && (!item.options || !item.options.popup)) {
            show = true;
          } else if (attempt_dismiss && !item.dismissed && !item.hidden && item.is_forced && (!item.options || !item.options.popup)) {
            show = true;
          } else if (!item.dismissed && !item.hidden && item.options && item.options.popup) {
            item.hidden = true;
            popup_available = item;
          }
        });
        scope.show_notifications = show && !popup_available;
        if (window.location.href.indexOf('open_item_link') > -1 && !LocaleService.item_link_opened) {
          scope.show_notifications = false;
          return false;
        }
        if (popup_available) {
          scope.open_notification(popup_available);
        }
        return show;
      }

      scope.archiveNotification = function (item) {
        scope.show_archive_confirmation = true;
        scope.archive = function () {
          scope.archiving = true;
          api.archiveNotification(userAccount.getData().user_id, item.id, item.instance_id).then(function () {
            scope.archiving = false;
            item.archived = !item.archived;
            scope.show_archive_confirmation = false;
            scope.showArchivedNotifications = false;
          }).catch(function () {
            scope.archiving = false;
          });
        };
      };

      eventManager.listen('resource:score:submitted', function (e, data) {
        if (scope.resource_data && data.slug === scope.resource_data.slug) {
          var dont_hide = true;
          if (scope.resource_data.resource_type === 'embedded_notification') {
            eventManager.broadcast('module:close:resource');
            dont_hide = false;
          }
          notificationService.dismissNotification(null, dont_hide);
        }
      });

      eventManager.listen('hide-notification-iframe', function () {
        scope.notificationView = null;
        scope.show_notifications = false;
      });

      function checkC4Status(state) {
        scope.is_c4_member = scope.is_c4_member || (userAccount.getData().role.isTeacher ? state.class_choice_c3_1 || state.class_choice_c3_2 || state.class_choice_c4_1 || state.class_choice_c4_2 : state.class_choice_c4_1 || state.class_choice_c4_2);
      }

      notificationService.showNotifications = function () {
        scope.show_notifications = true;
      };
      notificationService.dismissNotification = function (log_state, dont_hide, dont_log) {
        $log.log('dismiss: ', scope.current_notification);

        if (scope.current_notification.should_reset) {
          if (!log_state && scope.current_notification.log_state) {
            log_state = scope.current_notification.log_state;
          }
          log_state.is_reset = true;
        }
        if (scope.current_notification && (!scope.current_notification.dismissed || log_state) && !dont_log) {
          api.dismissNotification(userAccount.getData().user_id, scope.current_notification.id, log_state, scope.current_notification.instance_id).then(function (dismissed) {
            scope.current_notification.dismissed = true;
            scope.notificationView = dont_hide ? scope.notificationView : null;
            dismissed_list.push(scope.current_notification.name);
            eventManager.broadcast('user:dismiss:notification', scope.current_notification.name);
            if (scope.current_notification.name === "cycle_prompt" && log_state) {
              checkC4Status(log_state);
            }
            updateHiddenStatus();
            checkPending();
          });
        } else {
          scope.notificationView = dont_hide ? scope.notificationView : null;
          checkPending();
        }
      };
      notificationService.isNotificationActive = function () {
        return scope.notificationView && scope.current_notification && scope.current_notification.is_forced && !scope.current_notification.dismissed;
      };
      notificationService.hideNotifications = function () {
        scope.notificationView = null;
        checkPending();
      };

      scope.message = {
        sending: false,
        user_id: null,
        text: '',
        sendMessage: function sendMessage() {
          if (!scope.message.user_id || scope.message.text === '' || isNaN(scope.message.user_id)) {
            window.alert('Please enter a valid user and message!');
            return;
          }
          scope.message.sending = true;
          api.postUserNotification('user_message', scope.message.user_id, userAccount.getData().user_id, { message: scope.message.text }).then(function (msg) {
            scope.message.sending = false;
            scope.message.success = true;
            $timeout(function () {
              scope.message.success = false;
              scope.showMessagePanel = false;
            }, 1000);
          }).catch(function (err) {
            scope.message.sending = false;
          });
        }
      };

      scope.setResource = function (data, is_follow_up) {
        scope.resource_data = {
          hostUrl: data.hostUrl,
          module_id: 57,
          slug: data.slug,
          id: data.id,
          class_id: 99999,
          resource_type: data.resource_type ? data.resource_type : 'baseline',
          notification_slug: data.notification_slug,
          is_follow_up: is_follow_up,
          is_forced: scope.current_notification.is_forced
        };
        eventManager.broadcast('module:open:resource', scope.resource_data);
        scope.notificationView = 'resource_notification';
      };
      eventManager.listen('module:close:resource', function () {
        if (scope.resource_data && scope.notificationView === 'resource_notification') {
          scope.notificationView = null;
        }
      });
    }
  };
});
'use strict';

angular.module('mtic.components.notifications').directive('userMessage', function ($log, EventManager, $timeout, language, userAccount, api, notificationService) {
  return {
    template:'<div class="box"><button class="delete" aria-label="close" ng-click="dismiss()" style="float:right"></button><div style="padding:50px"><span>Message from : {{fromUser}}</span><br>Message: <span ng-bind="message" style="font-weight:bold"></span></div></div>',
    scope: {
      message: "=",
      fromUser: "="
    },
    link: function link(scope) {
      var eventManager = new EventManager('userMessage');
      scope.dismiss = function () {
        notificationService.dismissNotification();
      };
    }
  };
});
'use strict';

angular.module('mtic.components.notifications').directive('teacherUpdates', function ($log, EventManager, $timeout, language, userAccount, api, notificationService) {
  return {
    template:'<div ng-show="show_teacher_info_popup" ng-if="whatsNew.showAgendaModule" ng-class="{\'is-active\' : whatsNew.showAgendaModule }" class="modal mticBulmaModal mticBulmaModal--large whatsNewModal" style="background:none !important;"><div class="modal-card"><header class="modal-card-head mticBulmaModal__head"><img class="mticBulmaModal__headLogo" src="assets/images/logos/mathematic_favicon.png"><div class="modal-card-title mticBulmaModal__title" style="display: flex; justify-content: center;"><span class="agendaBox__headerText mticText__blue" ng-bind="getTranslation(whatsNew.agenda_current_page.header)"></span></div><button ng-show="dismissed" class="delete" aria-label="close" ng-click="whatsNew.close()"></button></header><section class="modal-card-body whatsNewModal__body"><ng-switch on="whatsNew.agenda_current_page.page"><div ng-switch-when="welcome" class="whatsNewModal__page"><div class="whatsNewModal__whiteBG"><p class="whatsNewModal__p whatsNewModal__p--larger" ng-bind="getTranslation(\'27708\')">There have been a few exciting changes to your Teacher View in order to better personalize your student’s learning experience.</p><p class="whatsNewModal__p" ng-bind="getTranslation(\'27709\')">The two main features that have been affected are the <b><i>Design</i></b> of the overall Teacher View and the updated version of the <b><i>Agenda</i></b>. Continue reading below to get caught up on all of the new changes and how they will help improve your experience with MathemaTIC.</p><div class="modalDivider"></div><img src="assets/images/logos/login_mathemaTIC_logo.png" class="whatsNewModal__logo"></div></div><div ng-switch-when="design" class="whatsNewModal__page"><p class="whatsNewModal__p whatsNewModal__p--bold whatsNewModal__p--larger" ng-bind="getTranslation(\'27710\')">The design for MathemaTIC’s teacher view has been updated to create a simpler, more streamlined experience as well as adding a few new features to help you get the most out of your resource.</p><div class="columns"><div class="column is-two-thirds"><div class="whatsNewModal__whiteBG"><img src="assets/images/agenda/whatsNewModal/1.gif" class="whatsNewModal__gif"></div></div><div class="column whatsNewModal__column whatsNewModal__column--right"><h2 class="whatsNewModal__h2" ng-bind="getTranslation(\'27711\')">Navigation Bar</h2><div class="modalDivider modalDivider--light"></div><p class="whatsNewModal__p" ng-bind="getTranslation(\'27712\')">Once you have entered your class view, you will notice that the Navigation Bar has relocated from the top of your screen to the left hand side. This new design gives you more space on screen and makes navigating through MathemaTIC more efficient.</p></div></div></div><div ng-switch-when="agenda1" class="whatsNewModal__page"><p class="whatsNewModal__p whatsNewModal__p--bold whatsNewModal__p--larger" ng-bind="getTranslation(\'27716\')">We are excited to present our new and improved Agenda! Along with an updated design, the Agenda now contains several additional features that allow you to organize your classes, schedule items and review your students performance all in one convenient view. This feature works well for assigning time sensitive material such as assessments, homework, or test-preparation.</p><div class="modalDivider modalDivider--light"></div><div class="columns"><div class="column"><div class="whatsNewModal__whiteBG"><img src="assets/images/agenda/whatsNewModal/teachers.png" width="550" class="whatsNewModal__gif"></div></div></div></div><div ng-switch-when="agenda2" class="whatsNewModal__page"><div class="columns"><div class="column whatsNewModal__column whatsNewModal__column--left" style="display: flex; flex-direction: column; align-items: flex-end;"><h2 class="whatsNewModal__h2" ng-bind="getTranslation(\'27717\')">Create Units</h2><div class="modalDivider modalDivider--light"></div><p class="whatsNewModal__p" ng-bind="getTranslation(\'27718\')">The updated design on the Agenda now allows you to start creating units directly from the calendar view.</p><p class="whatsNewModal__p" ng-bind="getTranslation(\'27719\')">You are be able to assign ether whole modules or specific items and topics.</p></div><div class="column is-two-thirds"><div class="whatsNewModal__whiteBG"><img src="assets/images/agenda/whatsNewModal/2.gif" class="whatsNewModal__gif"></div></div></div><p class="whatsNewModal__p" ng-bind="getTranslation(\'27720\')">Within the unit creation window, you can choose to make units accessible only during a certain time frame by selecting a start and end date from the calendar. Your units can be assigned to individual students or an entire class.</p></div><div ng-switch-when="agenda3" class="whatsNewModal__page"><div class="columns"><div class="column whatsNewModal__column whatsNewModal__column--left" style="display: flex; flex-direction: column; align-items: flex-end;"><h2 class="whatsNewModal__h2" ng-bind="getTranslation(\'27721\')">Edit Units</h2><div class="modalDivider modalDivider--light"></div><p class="whatsNewModal__p" ng-bind="getTranslation(\'27722\')">If you want to make any changes to your scheduled units, you can edit them directly from your calendar at any time.</p></div><div class="column is-two-thirds"><div class="whatsNewModal__whiteBG"><img src="assets/images/agenda/whatsNewModal/3.gif" class="whatsNewModal__gif"></div></div></div></div><div ng-switch-when="agenda4" class="whatsNewModal__page"><div class="columns"><div class="column whatsNewModal__column whatsNewModal__column--left" style="display: flex; flex-direction: column; align-items: flex-end;"><h2 class="whatsNewModal__h2" ng-bind="getTranslation(\'27723\')">Assign Summative Assessments</h2><div class="modalDivider modalDivider--light"></div><p class="whatsNewModal__p" ng-bind="getTranslation(\'27724\')">Whenever your students are ready to attempt a summative test, you can assign it directly from the Agenda.</p><p class="whatsNewModal__p" ng-bind="getTranslation(\'27725\')">To assign an item as a summative test simply select the ‘summative’ check box at the top of the page inside of the unit creation window.</p></div><div class="column is-two-thirds"><div class="whatsNewModal__whiteBG"><img src="assets/images/agenda/whatsNewModal/4.gif" class="whatsNewModal__gif"></div></div></div></div><div ng-switch-when="agenda5" class="whatsNewModal__page"><div class="columns"><div class="column whatsNewModal__column whatsNewModal__column--left" style="display: flex; flex-direction: column; align-items: flex-end;"><h2 class="whatsNewModal__h2" ng-bind="getTranslation(\'27726\')">Access Student Data</h2><div class="modalDivider modalDivider--light"></div><p class="whatsNewModal__p" ng-bind="getTranslation(\'27727\')">You can track how your student’s performed within an assigned unit directly from the Agenda or from your Dashboard.</p><p class="whatsNewModal__p" ng-bind="getTranslation(\'27728\')">You can see how far a single student, or an entire class, has progressed through an assigned unit as well as the time spent on each item.</p></div><div class="column is-two-thirds"><div class="whatsNewModal__whiteBG"><img src="assets/images/agenda/whatsNewModal/5.gif" class="whatsNewModal__gif"></div></div></div></div></ng-switch></section><footer class="modal-card-foot" style="justify-content: space-between;"><button class="button agendaBox__footerButton" ng-disabled="whatsNew.cur_index === 0" ng-click="whatsNew.move_page(-1)"><span class="icon"><i class="fa fa-angle-left"></i></span><span ng-bind="getTranslation(\'27499\')">Back</span></button><div class="centered-flex"><div ng-repeat="page in whatsNew.agenda_pages track by $index" ng-style="{\'background-color\' : $parent.whatsNew.cur_index === $index ? \'#ccc\':\'#fff\'}" style="width:14px;height:14px;border-radius:7px;border: 2px #ccc solid;margin-right:10px"></div></div><button class="button agendaBox__footerButton" ng-click="whatsNew.move_page(1)" style="background-color:#66CC66"><span ng-show="whatsNew.cur_index < 6" ng-bind="getTranslation(\'27498\')">Continue</span> <span ng-hide="whatsNew.cur_index < 6" ng-bind="getTranslation(\'27896\')">Got it!</span> <span class="icon"><i class="fa fa-angle-right"></i></span></button></footer></div></div>',
    scope: {
      dismissed: '='
    },
    link: function link(scope) {
      var eventManager = new EventManager('teacherUpdates');
      scope.getTranslation = function (slug) {
        return language.get(slug);
      };
      scope.isTeacher = userAccount.getData().role.isTeacher;
      scope.show_teacher_info_popup = true;
      scope.whatsNew = {
        showAgendaModule: true,
        agenda_pages: [{
          page: 'welcome',
          header: '27707' // welcome to Mathematic's newest update!
        }, {
          page: 'design',
          header: '27713' // 'Design'
        }, {
          page: 'agenda1',
          header: '27714' // 'Agenda'
        }, {
          page: 'agenda2',
          header: '27714' // 'Agenda'
        }, {
          page: 'agenda3',
          header: '27714' // 'Agenda'
        }, {
          page: 'agenda4',
          header: '27714' // 'Agenda'
        }, {
          page: 'agenda5',
          header: '27714' // 'Agenda'
        }],
        cur_index: 0,
        agenda_current_page: {
          page: 'welcome',
          header: '27707' // welcome to Mathematic's newest update!
        },
        move_page: function move_page(index) {
          var new_index = scope.whatsNew.cur_index + index;
          if (new_index > -1 && new_index < scope.whatsNew.agenda_pages.length) {
            scope.whatsNew.agenda_current_page = scope.whatsNew.agenda_pages[new_index];
            scope.whatsNew.cur_index = new_index;
          } else if (new_index >= scope.whatsNew.agenda_pages.length) {
            scope.whatsNew.close();
          }
        },
        get_button_state: function get_button_state(continue_btn) {
          if (continue_btn) {
            if (scope.whatsNew.cur_index < scope.whatsNew.agenda_pages.length && (scope.whatsNew.isCustomUnit || scope.whatsNew.agenda_selected_module !== '')) {
              return 'agenda_footer_buttons_enabled';
            } else {
              return 'agenda_footer_buttons_disabled';
            }
          } else {
            if (scope.whatsNew.cur_index > 0) {
              return 'agenda_footer_buttons_enabled';
            } else {
              return 'agenda_footer_buttons_disabled';
            }
          }
        },
        close: function close() {
          scope.show_teacher_info_popup = false;
          scope.whatsNew.reset();
          notificationService.dismissNotification();
        },
        reset: function reset() {
          scope.whatsNew = {};
          scope.whatsNew = angular.copy(whatsNewTemp);
        }
      };
      var whatsNewTemp = angular.copy(scope.whatsNew);
    }
  };
});
'use strict';

angular.module('mtic.components.notifications').directive('teacherOnboardingPrompt', function ($log, EventManager, $timeout, language, api, notificationService) {
  return {
    template:'<div class="mticModal" style="z-index:1"><div class="mticCard mticCard--modal" style="width:660px !important; margin-top: 10px; margin-bottom: 100px;"><div class="mticCard__header"><span class="mticCard__headerText"></span></div><div class="mticCard__body" style="padding : 20px; text-align: center;"><p class="mticCard__paragraph">Cher utilisateur de l’environnement MathemaTIC,</p><p class="mticCard__paragraph">Nous vous invitons par ce questionnaire, d’une durée de quinze minutes, à nous donner votre avis professionnel sur vos habitudes d’enseignement et d’utilisation des TIC (Technologies de l’Information et de la Communication) dans votre pratique scolaire. Pour votre information, vos élèves recevront également un questionnaire de six questions.</p><p class="mticCard__paragraph">Vos réponses seront utilisées de manière strictement anonyme à des fins de recherche et ne seront pas transmises à des tiers. Ces données nous permettront également d’adapter l’environnement MathemaTIC ainsi que les futures formations relatives à l’environnement.</p><div class="mticCard__paragraph">Pendant vos deux premières semaines d’utilisation de la plateforme, il est nécessaire de remplir ce questionnaire afin de pouvoir continuer à accéder à MathemaTIC pour le reste de l’années colaire.</div><p class="mticCard__paragraph">Vous trouverez ci-dessous une vidéo explicative concernant les buts et l’utilisation de vos réponses à ce questionnaire.</p><p class="mticCard__paragraph">Nous vous remercions d’avance pour votre participation..<br>L’équipe MathemaTIC</p><iframe width="560" height="315" src="https://www.youtube.com/embed/uvYUVv6F2Gs?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><div class="mticCard__outerLink" ng-click="setResource({ \'slug\':\'mtic_teacher_onboarding\', \'id\':1236, \'hostUrl\':\'https://d3kdl9636cazwt.cloudfront.net/containers/inbook/v2.5.78/index.html?host=cloudfront&repo=mtic_teacher_onboarding&cloudfrontVersion=v1.0.35\', \'notification_slug\':\'teacher_onboarding\' })" style="position: absolute; top: 100%; width: 100%; transform: translateY(20%); background-color: #3398db; color: #fff; padding: 12px 24px; font-size: 16px; font-weight: 600; cursor: pointer;"><span>Cliquez ici pour ouvrir le questionnaire.</span> <i class="fa fa-external-link" aria-hidden="true" style="float: right; font-size: 24px; font-weight: bold;"></i></div></div></div>',
    scope: {
      setResource: '=?'
    },
    link: function link(scope) {
      var eventManager = new EventManager('teacherOnboardingPrompt');
      scope.languageService = language;
    }
  };
});
'use strict';

angular.module('mtic.components.notifications').directive('systemMessage', function ($log, EventManager, $timeout, language, userAccount, api, notificationService, $sce) {
  return {
    template:'<div class="grey_box" style="height:100%;width:100%"><div style="width:100%" ng-if="iframeStyle.show_close_button"><button class="delete" aria-label="close" ng-click="dismiss()" style="float:right"></button></div><mtic-resource style="width:100%;height:100%;padding:10px 0px;" window-id="loadedResource" resource="resourceData" scroll-frame="\'yes\'"></mtic-resource></div>',
    scope: {
      resourceData: "=",
      iframeStyle: "="
    },
    link: function link(scope) {
      var eventManager = new EventManager('systemMessage');
      $log.log('RESOURCE DATA : ', scope.resourceData);
      scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
      };
      scope.dismiss = function () {
        eventManager.broadcast('module:close:resource');
        notificationService.dismissNotification(null, false, true);
      };
    }
  };
});
'use strict';

angular.module('mtic.components.notifications').directive('studentQuestionnairePrompt', function ($log, EventManager, $timeout, language, api, notificationService) {
  return {
    template:'<div ng-if="!isBaseline && !isPostTest" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);overflow:auto;z-index:1000"><div class="mticCard" style="width:800px"><div class="mticCard__header"><span class="mticCard__headerText"></span></div><div class="mticCard__body content" style="padding : 20px; text-align: left;display:flex;flex-direction:column;"><span style="font-size:20px" ng-show="isGerman()">Liebe Schülerin, lieber Schüler,<br><br>Bevor du wieder mit MathemaTIC arbeiten kannst, bitten wir dich, die folgenden Fragen zu beantworten.<br><br>Deine Antworten werden streng vertraulich (anonym) behandelt und nicht an Dritte weitergegeben.<br><br>Wir danken dirfür deine Teilnahme.<br><br></span> <span style="font-size:20px" ng-hide="isGerman()">Cher élève,<br><br>Pour continuer à travailler sur MathemaTIC, merci de répondre aux questions suivantes. Remplir ce questionnaire ne prendra que quelques minutes.<br><br>Les réponses seront traitées de manière strictement anonyme et ne seront pas transmises à des tiers.<br><br>Nous te remercions de ta participation.<br><br>L’équipe MathemaTIC<br><br></span><div class="button is-success is-medium" style="padding: 10px 60px; text-transform: uppercase" ng-click="setResource({ \'slug\':\'mtic_student_onboarding\', \'id\':1240, \'hostUrl\':\'https://d3kdl9636cazwt.cloudfront.net/containers/inbook/v2.5.78/index.html?host=cloudfront&repo=mtic_student_onboarding&cloudfrontVersion=v1.0.11\'})"><span ng-hide="isGerman()">Clique ici pour ouvrir le questionnaire</span> <span ng-show="isGerman()">Klicke hier um zu dem Fragebogen zu gelangen.</span></div></div></div></div><div ng-if="isBaseline && !isPostTest" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);;overflow:auto;z-index: 1000"><div class="mticCard" style="margin-bottom:100px"><div class="mticCard__header"></div><div class="mticCard__body" style="padding : 20px"><p class="mticCard__largeParagraph" style="margin-bottom: 24px;" ng-bind="languageService.get(\'14780\')">Nur für Schüler vom Zyklus 4</p><a class="button is-primary" style="margin-bottom: 12px;" ng-click="setResource({ \'slug\':\'mtic_baseline_assessment\', \'id\':1244, \'hostUrl\':\'https://d3kdl9636cazwt.cloudfront.net/containers/inbook/v2.5.78/index.html?host=cloudfront&repo=mtic_baseline_assessment&cloudfrontVersion=v1.0.22\' })" ng-bind="languageService.get(\'14782\')">Test beginnen</a></div></div></div><div ng-if="isPostTest" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);;overflow:auto;z-index: 1000"><div class="mticCard" style="margin-bottom:100px"><div class="mticCard__header"></div><div class="mticCard__body" style="padding : 20px"><p class="mticCard__largeParagraph" style="margin-bottom: 24px;" ng-bind="languageService.get(\'14780\')">Nur für Schüler vom Zyklus 4</p><a class="button is-primary" style="margin-bottom: 12px;" ng-click="setResource({ \'slug\':\'mtic_post_test\', \'id\':2890, \'hostUrl\':\'https://d3kdl9636cazwt.cloudfront.net/containers/inbook/v2.5.78/index.html?host=cloudfront&repo=mtic_post_test&cloudfrontVersion=v1.1.22\' })" ng-bind="languageService.get(\'14782\')">Test beginnen</a></div></div></div>',
    scope: {
      isBaseline: '=?',
      setResource: '=?',
      isPostTest: '=?'
    },
    link: function link(scope) {
      var eventManager = new EventManager('studentQuestionnairePrompt');
      scope.languageService = language;
      scope.isGerman = function () {
        return language.getCurrentSelectedLanguage() === 'de';
      };
    }
  };
});
'use strict';

angular.module('mtic.components.notifications').directive('cyclePrompt', function ($log, EventManager, $timeout, language, userAccount, api, notificationService) {
  return {
    template:'<div class="mticCard" style="margin-bottom:100px"><div class="mticCard__header"><span class="mticCard__headerText"></span></div><div class="mticCard__body" style="padding : 20px; text-align: center;"><p ng-bind="languageService.get(\'14784\')" ng-if="isTeacher">Select the level(s) that you teach:</p><p ng-bind="languageService.get(\'student_cycle_prompt\')" ng-if="!isTeacher">Select the level that you are enrolled in:</p><br><p ng-show="isTeacher"><span ng-bind="languageService.get(\'14785\')">Cycle</span> 2 <input type="checkbox" ng-model="c4_prompt.class_choice_c2">&nbsp;&nbsp; <span ng-bind="languageService.get(\'14785\')">Cycle</span> 3.1 <input type="checkbox" ng-model="c4_prompt.class_choice_c3_1">&nbsp;&nbsp; <span ng-bind="languageService.get(\'14785\')">Cycle</span> 3.2 <input type="checkbox" ng-model="c4_prompt.class_choice_c3_2"><br><span ng-bind="languageService.get(\'14785\')">Cycle</span> 4.1 <input type="checkbox" ng-model="c4_prompt.class_choice_c4_1">&nbsp;&nbsp; <span ng-bind="languageService.get(\'14785\')">Cycle</span> 4.2 <input type="checkbox" ng-model="c4_prompt.class_choice_c4_2">&nbsp;&nbsp; <span ng-bind="languageService.get(\'14786\')">Secondary School</span> <input type="checkbox" ng-model="c4_prompt.class_choice_g78"></p><p ng-hide="isTeacher"><span ng-bind="languageService.get(\'14785\')">Cycle</span> 2 <input type="radio" ng-model="c4_prompt_radio_selection.selection" value="class_choice_c2">&nbsp;&nbsp; <span ng-bind="languageService.get(\'14785\')">Cycle</span> 3.1 <input type="radio" ng-model="c4_prompt_radio_selection.selection" value="class_choice_c3_1">&nbsp;&nbsp; <span ng-bind="languageService.get(\'14785\')">Cycle</span> 3.2 <input type="radio" ng-model="c4_prompt_radio_selection.selection" value="class_choice_c3_2"><br><span ng-bind="languageService.get(\'14785\')">Cycle</span> 4.1 <input type="radio" ng-model="c4_prompt_radio_selection.selection" value="class_choice_c4_1">&nbsp;&nbsp; <span ng-bind="languageService.get(\'14785\')">Cycle</span> 4.2 <input type="radio" ng-model="c4_prompt_radio_selection.selection" value="class_choice_c4_2">&nbsp;&nbsp; <span ng-bind="languageService.get(\'14786\')">Secondary School</span> <input type="radio" ng-model="c4_prompt_radio_selection.selection" value="class_choice_g78"><br><span ng-bind="languageService.get(\'mtic_vp_meta\')"></span> <input type="radio" ng-model="c4_prompt_radio_selection.selection" value="class_choice_vp"></p><br><button ng-disabled="(isTeacher && no_c4_prompt_selection()) || (!isTeacher && !c4_prompt_radio_selection.selection)" class="button is-primary" ng-click="submit_teacher_cycle_prompt()" ng-bind="languageService.get(\'11289\')">Submit</button></div></div>',
    scope: {},
    link: function link(scope) {
      var eventManager = new EventManager('cyclePrompt');
      scope.languageService = language;
      scope.isTeacher = userAccount.getData().role.isTeacher;
      scope.c4_prompt = {
        class_choice_c2: false,
        class_choice_c3_1: false,
        class_choice_c3_2: false,
        class_choice_c4_1: false,
        class_choice_c4_2: false,
        class_choice_g78: false
      };
      scope.c4_prompt_radio_selection = { selection: null };
      scope.submit_teacher_cycle_prompt = function () {
        if (!scope.isTeacher) {
          scope.c4_prompt = {
            class_choice_c2: false,
            class_choice_c3_1: false,
            class_choice_c3_2: false,
            class_choice_c4_1: false,
            class_choice_c4_2: false,
            class_choice_g78: false
          };
          scope.c4_prompt[scope.c4_prompt_radio_selection.selection] = true;
        }

        notificationService.dismissNotification(scope.c4_prompt);
      };
      scope.no_c4_prompt_selection = function () {
        var one_selected = true;
        for (var key in scope.c4_prompt) {
          if (scope.c4_prompt[key]) {
            one_selected = false;
          }
        }
        return one_selected;
      };
    }
  };
});
'use strict';

angular.module('mtic.components.modules.qcModule', []).component('qcModule', {
  template:'<style type="text/css">\n  .qc-module {\n    border: 1px solid black; padding: 5px;\n    margin-top: 10px;\n  }\n  .qc-sub-module {\n    /*border: 1px solid black; padding: 5px;*/\n  }\n</style><qc-module-child resources="qcModule.moduleMapData.resources"></qc-module-child>',
  bindings: {
    moduleMapData: '<'
  },
  controllerAs: 'qcModule',
  controller: function controller(EventManager, $scope) {
    var eventManager = new EventManager('qcModule', $scope);
    var qcModule = this;
    qcModule.openResource = function (resource) {
      eventManager.broadcast('module:open:resource', resource);
    };
  }
});
'use strict';

angular.module('mtic.components.modules.qcModule').component('qcModuleChild', {
  template:'<div class="columns is-multiline qc-module"><div ng-repeat="resource in qcModule.resources" class="column is-third"><div ng-if="!qcModule.hasChildren(resource)"><b>Name: {{resource.name}}</b><br><b>Slug {{resource.slug}}</b><br><b>is complete {{resource.complete}}</b><br><b>is locked {{resource.locked}}</b><br><a ng-click="qcModule.openResource(resource)">Open Me</a></div><div ng-if="qcModule.hasChildren(resource)"><b>Name: {{resource.name}}</b><br><b>Slug {{resource.slug}}</b><br><qc-module-child class="qc-sub-module" resources="resource.children"></qc-module-child></div></div></div>',
  bindings: {
    resources: '<'
  },
  controllerAs: 'qcModule',
  controller: function controller(EventManager, $scope) {
    var eventManager = new EventManager('qcModule', $scope);
    var qcModule = this;
    qcModule.openResource = function (resource) {
      eventManager.broadcast('module:open:resource', resource);
    };
    qcModule.hasChildren = function (resource) {
      return resource.children ? resource.children.length > 0 : false;
    };
  }
});
'use strict';

angular.module('mtic.components.modules.generalModuleMap', []).constant('GR78_ASSET_URL', 'assets/images/gr78/').constant('AGENDA_ASSETS_URL', 'assets/images/agenda/');
'use strict';

angular.module('mtic.components.modules.generalModuleMap').directive('moduleMetaMap', function (GR78_ASSET_URL, C4_ASSET_URL, AGENDA_ASSETS_URL, DEV_VARIABLES, StudentDataService, PanelStateService, $timeout, TIMING_CONSTANTS, TeacherDataService, $q, $log, $http, $window, itemFactory, MapDataMassage, MapStateService, VerletSystemService, learningMapUtil, PIXI, EventManager, language, flashPermission, userAccount, preliveCheck, LocaleService, ModuleFilter, C3_ASSET_URL, PlatformService, PanelFactory, $rootScope) {

  return {

    template:'<style>\n  .rlm_option_button_unselected{\n    box-shadow: 0px -5px 0px 0px #32284D;\n    margin-top:5px;\n    color:rgba(255,255,255,0.5);cursor:pointer;background-color:#3E335C;border-radius:10px;font-size:26px; font-weight:700;padding:5px 50px 15px;\n  }\n  .rlm_option_button_selected{\n    box-shadow: 0px 5px 0px 0px #F07900;\n    color:rgba(255,255,255,1);cursor:pointer;background-color:#FFAF00;border-radius:10px;font-size:26px; font-weight:700;padding:5px 50px 15px;\n  }\n</style><div class="module-meta-map"><div ng-hide="loading_done" style="position:absolute;top:0px;left:0px;width:100%;height:100%;background-color:#555;z-index:1000"><div class="loader"></div></div><div ng-if="!loadedIframeModule.active && !badBrowser" class="inner-viewport" ng-class="{\'agendaSplitView\': !isTeacherWorkspaceView}" id="canvas_container" style="overflow:hidden;"><div ng-if="!isTeacherWorkspaceView && (!currentActiveSubModule || currentActiveSubModule.slug !== \'run_like_math\')" class="no-select agendaSplitViewSidebar"><nav class="nav is-small" style="margin-bottom: 24px;"><div class="nav-center"><a class="nav-item is-tab studentAgendaPanel__tab" ng-if="!isTeacher" ng-class="{\'is-active studentAgendaPanel__tab--active\':isShowingAgendaPanel()}" ng-click="selectAgendaPanel()"><span class="icon studentAgendaPanel__navTabIcon"><img src="assets/images/agenda/icon-blue-agenda.png"></span> <span class="studentAgendaPanel__navTabText">Agenda</span></a> <a class="nav-item is-tab studentAgendaPanel__tab" ng-class="{\'is-active studentAgendaPanel__tab--active\':isShowingModulePanel()}" ng-click="selectModulePanel()"><span class="icon studentAgendaPanel__navTabIcon"><img src="assets/images/agenda/icon-module-blue.png"></span> <span class="studentAgendaPanel__navTabText" ng-bind="getTranslation(\'14569\')">Module</span></a></div></nav><div style="padding:12px;"><lmap-sidepanel-agenda-general ng-if="isShowingAgendaPanel() && !isTeacher" module-map-data="moduleMapData"></lmap-sidepanel-agenda-general><div ng-if="isShowingModulePanel() || isTeacher"><form autocomplete="off"><input class="agendaSearchField" placeholder="{{getLang(\'22608\')}}" ng-model="itemSearchInput" ng-change="itemSearchChange(itemSearchInput)" autocomplete="custom_input"></form><teacher-students-agenda-perf-preview filtered-view="itemSearchInput" module-map="moduleMapData" view-controller="view_controller"></teacher-students-agenda-perf-preview></div></div><div class="no-select" ng-style="{ left: currentActiveSubModule.children || !isTeacherWorkspaceView ? \'350px\' : \'0px\' }" style="position:absolute; bottom:0px; right:0px;"></div></div><div ng-class="{\'agendaSplitView__main\': !isTeacherWorkspaceView}"><canvas ng-show="!isRlm(currentActiveSubModule)" id="module-item-map-canvas" width="300" height="300" style="float:right"></canvas><div class="inner-viewport" ng-if="isRlm(currentActiveSubModule)" style="overflow:hidden;"><module-iframe ng-if="!isTeacherWorkspaceView" module-id="moduleMapData.module_id" module-map-data="currentActiveSubModule"></module-iframe><ng-switch ng-if="isTeacherWorkspaceView" on="currentActiveSubModule.slug"><c3-run-like-math-module-operation slugs="slugs.addition" on-item-click="selectResource" ng-init="currentActiveSubModule.resources=currentActiveSubModule.children" ng-switch-when="run_like_math_addition" module-map-data="currentActiveSubModule"></c3-run-like-math-module-operation><c3-run-like-math-module-operation slugs="slugs.subtraction" on-item-click="selectResource" ng-init="currentActiveSubModule.resources=currentActiveSubModule.children" ng-switch-when="run_like_math_subtraction" module-map-data="currentActiveSubModule"></c3-run-like-math-module-operation><c3-run-like-math-module-operation slugs="slugs.multiplication" on-item-click="selectResource" ng-init="currentActiveSubModule.resources=currentActiveSubModule.children" ng-switch-when="run_like_math_multiplication" module-map-data="currentActiveSubModule"></c3-run-like-math-module-operation><c3-run-like-math-module-operation slugs="slugs.division" on-item-click="selectResource" ng-init="currentActiveSubModule.resources=currentActiveSubModule.children" ng-switch-when="run_like_math_division" module-map-data="currentActiveSubModule"></c3-run-like-math-module-operation><c3-run-like-math-module-select on-item-click="selectResource" ng-init="currentActiveSubModule.resources=currentActiveSubModule.children" ng-switch-when="run_like_math" module-map-data="currentActiveSubModule"></c3-run-like-math-module-select></ng-switch></div><lmap-bottom-panel-general highlighted-resource="selectedResource" module-map-data="currentActiveSubModule" ng-show="(isShowingAgendaPanel() || isShowingModulePanel()) && !hide_bottom_panel" ng-if="!isTeacherWorkspaceView && !isRlm(currentActiveSubModule)"></lmap-bottom-panel-general><span ng-click="returnToMetaModules()" ng-style="{ top: !isTeacherWorkspaceView ? \'10px\' : \'70px\' }" ng-show="currentActiveSubModule && currentActiveSubModule.slug" style="z-index:1;position:absolute;cursor: pointer; background-color:#FF6666; padding:12px; border-radius: 0px 10px 10px 0px; height:66px; width: 62px; color:#fff; font-size:42px"><i class="fa fa-arrow-left"></i></span><div ng-if="overlay_options"><ng-switch on="overlay_options.slug"><div ng-switch-when="run_like_math" ng-init="set_rlm_option(\'training\', true)" style="color:#fff;display:flex;flex-direction: column; align-items:center; position:absolute; left:0;" ng-style="{\'transform\':overlay_scale?\'scale(\'+overlay_scale+\')\':\'scale(1)\', \'top\':overlay_top, \'width\': canv_width}"><div ng-bind="getLang(overlay_options.bindings.slug)" style="font-size:72px; font-weight:800"></div><div ng-bind="getLang(\'run_like_math_select_mode\')" style="margin-top:-10px;font-size:32px; font-weight:800"></div><div style="margin-top:10px;display:flex;background-color:#3E335C;border-radius:10px;"><div ng-bind="getLang(\'run_like_math_training\')" ng-click="set_rlm_option(\'training\')" ng-class="rlm_option_selected === \'training\' ? \'rlm_option_button_selected\' : \'rlm_option_button_unselected\'"></div><div style="background-color:rgba(255,255,255,0.3);height:50px;margin-top:5px;width:2px"></div><div ng-bind="getLang(\'run_like_math_challenge\')" ng-click="set_rlm_option(\'challenge\')" ng-class="rlm_option_selected === \'challenge\' ? \'rlm_option_button_selected\' : \'rlm_option_button_unselected\'"></div></div></div><div ng-switch-when="ocmt_hse" class="ocmt-overlay"><img width="100" ng-src="{{overlay_options.bindings.img_url}}"><div ng-bind="overlay_options.bindings.title" style="font-size:32px; font-weight:800; color: #492740"></div></div></ng-switch></div></div></div><module-iframe ng-if="loadedIframeModule.active" module-map-data="loadedIframeModule.data"></module-iframe><div style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; display: flex; align-items: center; justify-content: center; padding-bottom:180px;background-color: #e9f0f3" ng-show="badBrowser"><div style="width:480px; max-width: 80%; font-size: 20px; text-align:center;"><div style="margin-bottom:18px;"><img src="assets/images/logos/login_mathemaTIC_logo.png"></div><div>This module is not yet available in the <b>MathemaTIC app</b> for Android and iOS.<div style="margin-top:18px; line-height:100%;"><small>Please revisit this module in a the browser or on a desktop.</small></div><button style="margin-top:30px" class="button is-small is-danger" ng-click="goBackToClasses()" ng-bind="getTranslation(\'27642\')">My Classes</button></div></div></div><div style="display:flex; position:fixed;right: 8px; top: 45px;" ng-hide="disable_zoom || isRlm(currentActiveSubModule)" ng-class="agendaView ? \'module-zoom-buttons agenda-module-zoom-buttons\' : \'module-zoom-buttons\'"><button ng-click="zoom_function(1)" class="button" style="margin-right:3px;font-size:24px"><i class="fa fa-search-minus" aria-hidden="true"></i></button> <button ng-click="zoom_function(-1)" class="button" style="font-size:24px"><i class="fa fa-search-plus" aria-hidden="true"></i></button></div></div>',
    scope: {
      moduleMapData: "=",
      interceptClick: "=?",
      onItemClick: "<",
      workspaceData: "=?",
      interactionDisabled: "=?"
    },
    link: function link(scope, element) {
      scope.getTranslation = function (id) {
        return language.get(id);
      };
      scope.badBrowser = false;
      var middle_view_visible = false;
      scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
      /*
      if(window.isWebEmbedConnect && !scope.interceptClick && !navigator.userAgent.match(/Android/i)){
        //kickout to browser
        var userData = userAccount.getData();
        var cur_class = userAccount.getData().role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom();
        window.location.href = 'https://mathematic.lu/app2/'+'?web-open-browser&firebase_token='+userData.firebase_token+'&uuid='+userData.uuid+'&session_key='+userData.sessionKey+'&user_id='+userData.user_id+'&class_id='+cur_class;//window.location.href.replace('/?debugBrowsers#/web-embed-connect', '').replace('web-embed-connect', '').replace('web-embed-response', '').replace('&iam-logout', '')
      }
      */
      // else if(window.isWebEmbedConnect && !scope.interceptClick){
      //   scope.badBrowser = true;
      // }

      scope.isTeacher = userAccount.getData().role.isTeacher;
      // event manager for coordination with rest of application
      var eventManager = new EventManager('gr78MetaMap', scope);
      var verlet_system = new VerletSystemService();

      scope.goBackToClasses = function () {
        eventManager.broadcast("navbar:my-classes:click");
        eventManager.broadcast('module:close:resource');
      };
      ///////////////////
      // PRIVATE VARS //
      /////////////////

      var state = 0,
          leftMostMapItemPosition = 0,
          rightMostMapItemPosition = 0,
          topMostMapItemPosition = 0,
          allSummativeItems = [],
          languageOptions = [];
      var canvas_el = null;
      var app = null;
      var renderer = null;
      var drag_info = null;
      var canvasDimention = null;
      var scale = null;
      var stage = null;
      var meta_background = null;
      var modules_container = null;
      var container = null;
      var lines_graphic = null;
      var selection_graphic = null;
      var cloud_man = null;
      var items = [];
      var modules = [];
      var moduleContainerManager;
      var isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);
      var bg_images;

      var agendas_list = [];

      var img_asset_paths = [];

      // [
      //   GR78_ASSET_URL + "symlink.png",
      //   GR78_ASSET_URL + "item_blue_0.png",
      //   GR78_ASSET_URL + "item_blue_1.png",
      //   GR78_ASSET_URL + "item_red_0.png",
      //   GR78_ASSET_URL + "item_red_1.png",
      //   GR78_ASSET_URL + "item_red_2.png",
      //   GR78_ASSET_URL + "item_red_3.png",
      //   GR78_ASSET_URL + "item_black_0.png",
      //   GR78_ASSET_URL + "item_black_1.png",
      //   GR78_ASSET_URL + "item_black_2.png",
      //   GR78_ASSET_URL + "item_black_3.png",
      //   GR78_ASSET_URL + "item_blue_locked.png",
      //   GR78_ASSET_URL + "item_red_locked.png",
      //   GR78_ASSET_URL + "item_black_locked.png",
      //   GR78_ASSET_URL + "assessment.png",
      //   GR78_ASSET_URL + "assessment_complete.png",
      //   GR78_ASSET_URL + "selection.png",
      //   GR78_ASSET_URL + "mtic_gr78_m0.png",
      //   GR78_ASSET_URL + "mtic_gr78_m1.png",
      //   GR78_ASSET_URL + "mtic_gr78_m2.png",
      //   GR78_ASSET_URL + "mtic_gr78_m3.png",
      //   GR78_ASSET_URL + "mtic_gr78_m4.png",
      //   GR78_ASSET_URL + "mtic_gr78_c4_m1.png",
      //   GR78_ASSET_URL + "mtic_gr78_c4_m6.png",
      //   GR78_ASSET_URL + "formative_gold.png",
      //   GR78_ASSET_URL + "formative_silver.png",
      //   GR78_ASSET_URL + "formative_locked.png",
      //   GR78_ASSET_URL + "formative_unlocked.png",

      //   C4_ASSET_URL + "run_like_math_item_0.png",
      //   C4_ASSET_URL + "run_like_math_item_1.png",
      //   C4_ASSET_URL + "run_like_math_item_2.png",
      //   C4_ASSET_URL + "run_like_math_item_3.png",
      //   C4_ASSET_URL + "run_like_math_item_4.png",
      //   C4_ASSET_URL + "run_like_math_item_locked.png",

      //   C3_ASSET_URL + "map.png",
      //   C3_ASSET_URL + "m34_map.png",
      //   C3_ASSET_URL + "m56_map.png",
      //   C3_ASSET_URL + "star.png",
      //   C3_ASSET_URL + "item_blue_0.png",
      //   C3_ASSET_URL + "item_blue_1.png",
      //   C3_ASSET_URL + "item_red_0.png",
      //   C3_ASSET_URL + "item_red_1.png",
      //   C3_ASSET_URL + "item_red_2.png",
      //   C3_ASSET_URL + "item_red_3.png",
      //   C3_ASSET_URL + "item_black_0.png",
      //   C3_ASSET_URL + "item_black_1.png",
      //   C3_ASSET_URL + "item_black_2.png",
      //   C3_ASSET_URL + "item_black_3.png",
      //   C3_ASSET_URL + "item_blue_locked.png",
      //   C3_ASSET_URL + "item_red_locked.png",
      //   C3_ASSET_URL + "item_black_locked.png",
      //   C3_ASSET_URL + "item_af_locked.png",
      //   C3_ASSET_URL + "item_af.png",
      //   C3_ASSET_URL + "item_test.png",
      //   C3_ASSET_URL + "assessment.png",
      //   C3_ASSET_URL + "assessment_complete.png",
      //   C3_ASSET_URL + "item_test_locked.png",

      //   "assets/images/ocmt/ocmt_item_0.png",
      //   "assets/images/ocmt/WholeNumbers_diagnostic_icon.png",
      //   "assets/images/ocmt/WholeNumbers_diagnostic_icon_unlocked.png",
      //   "assets/images/ocmt/WholeNumbers_summative_icon.png",
      //   "assets/images/ocmt/WholeNumbers_summative_icon_unlocked.png",
      //   "assets/images/ocmt/ocmt_item_locked.png",
      //   "assets/images/ocmt/selection_m1.png",
      //   "assets/images/ocmt/selection.png",
      // ]
      var focus_item = null;

      scope.hasAgendas = false;
      scope.loadedIframeModule = {
        active: false,
        data: []
      };
      scope.moduleProgress = 0.5;

      flashPermission.getPermission();

      var runDownModel = {};
      var highlightedItem = null;

      var zooming = false;

      var update_texts = [];var update_direction = 0.002;

      var resourceLockManager = function ResourceLockManager(self) {
        var originalLockState = {};
        self.setOriginal = function (resourceId, isLocked) {
          if (!originalLockState[resourceId]) {
            originalLockState[resourceId] = isLocked;
          }
        };
        self.unlock = function (resourceIds) {
          self.reset();
          resourceIds.forEach(function (resourceId) {
            var item = getItemById(resourceId);
            if (item) {
              item.unlock();
            }
          });
        };
        self.lock = function (resourceIds) {
          self.reset();
          resourceIds.forEach(function (resourceId) {
            var item = getItemById(resourceId);
            if (TeacherDataService.isTeacherModuleView) {
              item.unlock();
            } else {
              if (item) {
                item.lock();
              }
            }
          });
        };
        self.reset = function () {
          items.forEach(function (item) {
            if (TeacherDataService.isTeacherModuleView) {
              item.unlock();
            } else {
              if (originalLockState[item.id] === true) {
                item.lock();
              } else if (originalLockState[item.id] === false) {
                item.unlock();
              }
            }
          });
        };
        return self;
      }({});

      scope.showAgenda = true;
      scope.selectedResource = {};
      function unlockpath(item_id, use_slug) {
        // $log.log('UNLOCK PATH : ', item_id )
        items.forEach(function (resource) {
          if (resource.id === item_id || use_slug && item_id === resource.slug) {
            resource.unlock();
            resource.unlockedByAgenda = true;
            if (resource.unlocked_by.length > 0) {
              resource.unlocked_by.forEach(function (higher_resource) {
                unlockpath(higher_resource, true);
              });
            }
          }
        });
      }

      eventManager.listen('moduleview:agenda:loaded', function (e, data) {
        // $log.log('agenda data : ', data)
        if (data.length > 0) {
          agendas_list = data;
          scope.hasAgendas = true;
          scope.selectAgendaPanel();
          data.forEach(function (agenda) {
            if (agenda.force_unlock) {
              if (agenda.force_unlock) {
                agenda.resources.forEach(function (item) {
                  unlockpath(item);
                });
              }
            }
          });
        } else {
          scope.hasAgendas = false;
          scope.selectModulePanel();
        }
      });

      scope.hasAgendaOption = function () {
        return scope.hasAgendas;
      };
      scope.hasModuleOption = function () {
        return scope.currentActiveSubModule && scope.currentActiveSubModule.children;
      };

      scope.isShowingAgendaPanel = function () {
        return scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView;
      };
      scope.isShowingModulePanel = function () {
        //&& scope.hasModuleOption()
        return !scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView || scope.isTeacher;
      };

      scope.toggleAgenda = function () {
        if (scope.showAgenda) {
          scope.selectModulePanel();
        } else {
          scope.selectAgendaPanel();
        }
      };

      scope.selectAgendaPanel = function () {
        // $log.log('from select agenda panel')
        if (!scope.hasAgendas) {
          return;
        }
        scope.showAgenda = true;
        PanelStateService.setAgendaShowing(scope.showAgenda);
        if (!scope.showAgenda) {
          eventManager.broadcast('moduleview:agenda:request');
        }
      };

      scope.selectModulePanel = function () {
        // $log.log('from select module panel')
        if (scope.showAgenda) {
          scope.showAgenda = false;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          for (var i = 0; i < items.length; i++) {
            items[i].undoAgendaHighlight();
          }
        }
      };

      scope.panelDisplay = {};
      scope.getLang = language.get;

      scope.isStudent = function () {
        return !userAccount.getData().role.isTeacher;
      };

      /////////////
      // CONSTRUCTOR
      /////////////

      var _TOUCHED_POINTS = [];
      var map_config = {};
      var default_scale = 0.45;
      var default_map_configs = {
        background_color: 0xdee9fc,
        hide_bottom_panel: false,
        gradient_start: '#7DC5BA',
        gradient_stop: '#A0E0DA',
        meta_background_visible: true,
        disable_verlet: false,
        map_style: 'gr78',
        line_options: {
          disabled: false,
          color: 0xCCCCDD,
          offset_y: 0,
          line_size: 8
        },
        tooltip_options: {
          fontcolor: 0xFFFFFF,
          inverted: false,
          color: 0xdae2ea,
          locked_color: 0x63a19a,
          item_fillcolor: 0x3B5763,
          bar_color: 0x075a8f,
          bar_fill_color: 0x33ccff,
          always_visible: false,
          no_bar: false
        },
        selector_options: {
          disabled: false,
          offset_y: 0,
          disable_size_shifting: false,
          start_scale: 1,
          rotation_speed: 0.015
        },
        disable_zoom: false
      };
      function init() {
        scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
        // retrieve template element references
        canvas_el = document.getElementById('module-item-map-canvas');
        if (!canvas_el) {
          return;
        }

        MapStateService.setMetaStateSlug(scope.moduleMapData.resource_slug);
        map_config = scope.moduleMapData.meta_config && scope.moduleMapData.meta_config.map_config ? _.extend(_.clone(default_map_configs), scope.moduleMapData.meta_config.map_config) : default_map_configs;
        map_config.asset_url = map_config.asset_url || GR78_ASSET_URL;

        if (map_config.unlock_by_diagnostic) {
          unlock_lessons_by_diagnostic();
        }

        if (map_config.disable_verlet) {
          verlet_system.toggle(false);
        }

        scope.hide_bottom_panel = map_config.hide_bottom_panel;

        img_asset_paths = map_config.img_assets || [];
        for (var i = 0; i < img_asset_paths.length; i++) {
          if (img_asset_paths[i].indexOf(map_config.asset_url) === -1) {
            img_asset_paths[i] = map_config.asset_url + img_asset_paths[i];
          }
        }

        app = new PIXI.Application(300, 300, {
          autoResize: true,
          backgroundColor: map_config.background_color,
          antialias: true,
          view: canvas_el
        });

        renderer = app.renderer;
        scale = default_scale;
        items = [];

        drag_info = learningMapUtil.getDragInfoSettings();

        canvasDimention = {
          width: 0, //window.innerWidth - 180 - sidepanel_width,
          height: window.innerHeight - 50
        };
        stage = app.stage;
        stage.interactive = true;

        cloud_man = learningMapUtil.createCloudManager();
        stage.addChild(cloud_man.overlay_sprite);

        var meta_canvas = document.createElement("canvas");
        meta_canvas.width = 200;
        meta_canvas.height = 200;
        var ctx = meta_canvas.getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, 200);
        gradient.addColorStop(0, map_config.gradient_stop);
        gradient.addColorStop(1, map_config.gradient_start);
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 200, 200);

        var meta_tex = PIXI.Texture.fromCanvas(meta_canvas);

        meta_background = new PIXI.Sprite(meta_tex);

        stage.addChildAt(meta_background, 0);

        window.addEventListener("resize", onResize);

        // var isExpanded = TeacherDataService.inTeacherAgendaView || isMobile ? false : null
        // onResize(isExpanded);
        renderer.render(stage);

        container = new PIXI.Sprite();
        container.interactive = true;
        container.x = renderer.width / 2;
        container.y = renderer.height / 2;

        stage.addChildAt(container, 1);
        toggle_mapconfig();

        lines_graphic = new PIXI.Graphics();
        container.addChild(lines_graphic);

        container.scale.set(scale, scale);
        app.ticker.add(update);

        canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else

        // prevent browser from selecting other html text when double clicking the PIXI canvas
        canvas_el.addEventListener('pointerdown', handleDoubleClick, false);
        // scope.test_data = 'TESTING';
        stage.on('pointerdown', function (e) {
          if (map_config && map_config.disable_panning || scope.currentActiveSubModule && scope.currentActiveSubModule.config && scope.currentActiveSubModule.config.map_config && scope.currentActiveSubModule.config.map_config.disable_panning) {
            return;
          }
          var e_o = e.data.originalEvent;
          _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x: e_o.pageX, y: e_o.pageY });

          drag_info.dragging = true;
          focus_item = null;

          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: container.x,
            y: container.y
          };
          drag_info.start_drag_mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };
          // scope.agendaImgBox = document.getElementById('agendaImgBox')        
        });
        stage.on('pointermove', function (e) {
          if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
            var mouse_pos = {
              x: e.data.global.x,
              y: e.data.global.y
            };
            container.position.x = Math.min(1000, Math.max(drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x), 0));
            container.position.y = Math.min(1000, Math.max(drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y), 0));
            var delta_pos = {
              x: drag_info.last_mouse_pos.x - mouse_pos.x,
              y: drag_info.last_mouse_pos.y - mouse_pos.y
            };
            // if(scope.agendaImgBox){
            //   if(container.position.x > 0 && container.position.x < 1000){
            //     scope.agendaImgBox.style.left = scope.agendaImgBox.style.left.replace('px', '') - delta_pos.x + 'px'
            //   }              
            //   if(container.position.y > 0 && container.position.y < 1000){
            //     scope.agendaImgBox.style.top = scope.agendaImgBox.style.top.replace('px', '') - delta_pos.y + 'px'
            //   }
            // }
            drag_info.velocity = {
              x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
              y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
            };
            drag_info.last_mouse_pos = {
              x: mouse_pos.x,
              y: mouse_pos.y
            };
          }
        });
        stage.on('pointerup', function (e) {
          if (window.DEBUG_TOUCH) {
            $log.log('g78_metamap pointerup ; ', JSON.stringify(drag_info));
          }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
          prev_diff = null;
        });

        stage.on('pointerout', function (e) {
          if (window.DEBUG_TOUCH) {
            $log.log('g78_metamap pointerup ; ', JSON.stringify(drag_info));
          }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
          prev_diff = null;
        });

        if (PIXI.loader.resources) {
          for (var ast in PIXI.loader.resources) {
            PIXI.loader.reset();
            PIXI_gr78_Load_Cache = false;
            break;
          }
        }

        if (window.DEBUG_TOUCH) {
          $log.log('g78_metamap pointerdown ; ', JSON.stringify(drag_info));
        }
        return loadAssets().then(function () {
          $log.debug('[[gr78MetaMap]] loadAssets.then');
          scope.loading_done = true;
          var isExpanded = TeacherDataService.inTeacherAgendaView ? false : null;
          $timeout(function () {
            if (window.location.href.indexOf('open_item_link') > -1 && !LocaleService.item_link_opened) {
              var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));
              var item_id = urlParams.get('item_id');
              if (item_id === 'LEADERBOARD') {
                eventManager.broadcast('activate:leaderboard');
              } else {
                item_id = Number(item_id);
                var item_to_open = getItemById(item_id);
                if (item_to_open) {
                  var parent_resource = getResourceById(getResourceBySlug(item_to_open.slug).parent_resource_id);
                  eventManager.broadcast('submodule:opened', {
                    slug: parent_resource.slug,
                    name: parent_resource.name
                  });
                  eventManager.broadcast('module:open:resource', _.pick(item_to_open, 'slug', 'id', 'parent_resource_id', 'name', 'container', 'content', 'config', 'type'));
                } else {
                  //display error here                 
                  window.alert(language.get('item_links_missing_item').replace('__', urlParams.get('item_id')));
                }
              }
            }
            onResize(isExpanded);
          }, 300);
          return;
        }).catch(function (err) {
          $log.error('[[gr78MetaMap]] loadAssets.then', err.message);
          $log.debug(err.stack);
        });
      }

      scope.returnToMetaModules = function () {
        scope.loadedIframeModule.active = false;
        eventManager.broadcast('module:change:meta', scope.moduleMapData.resource_slug);
      };

      function unlock_lessons_by_diagnostic() {
        _.each(scope.moduleMapData.resources, function (submod) {
          if (submod.children) {
            var unlock_by_diag = false;
            var lock_summative = false;
            _.each(submod.children, function (lesson) {
              if (lesson.config.assessment_type && lesson.config.assessment_type === 'diagnostic' && lesson.resourceState && lesson.resourceState.score_max >= 0.8) {
                unlock_by_diag = true;
                lock_summative = lesson.resourceState.score_max === 1;
              }
            });
            if (unlock_by_diag) {
              _.each(submod.children, function (lesson) {
                if (lesson.config.assessment_type && lesson.config.assessment_type === 'summative' && (!lesson.resourceState || !lesson.resourceState.complete)) {
                  lesson.locked = lock_summative;
                  if (lock_summative) {
                    lesson.complete = true;
                    if (!lesson.resourceState) {
                      lesson.resourceState = {};
                    }
                    lesson.resourceState.complete = true;
                    lesson.resourceState.scoreMax = 1;
                  }
                } else if (!lesson.config.assessment_type) {
                  lesson.locked = false;
                  lesson.complete = true;
                  if (!lesson.resourceState) {
                    lesson.resourceState = {};
                  }
                  lesson.resourceState.complete = true;
                  lesson.resourceState.scoreMax = 1;
                }
              });
            }
          }
        });
      }

      function toggle_mapconfig() {
        // toggles map_config between cycle and submodules
        meta_background.visible = map_config.meta_background_visible;
        renderer.backgroundColor = Number(map_config.background_color);
        scope.disable_zoom = map_config.disable_zoom;
        scope.overlay_options = map_config.overlay_options;
        if (scope.disable_zoom) {
          scale = default_scale;
          container.scale.set(default_scale, default_scale);
        }
        //remove all images
        if (bg_images && bg_images.length > 0) {
          _.each(bg_images, function (img) {
            if (img.reference && img.reference.parent) {
              img.reference.parent.removeChild(img.reference);
            }
          });
        }
        bg_images = [];
        //add images
        if (map_config.background_images) {
          _.each(map_config.background_images, function (img) {
            //$log.log('adding image : ', img)
            var bg_img;
            if (img.type === 'regular') {
              bg_img = PIXI.Sprite.fromImage(map_config.asset_url + img.name);
            } else if (img.type === 'tiling') {
              bg_img = new PIXI.extras.TilingSprite(PIXI.Texture.fromImage(map_config.asset_url + img.name));
            }
            if (bg_img && (img.anchor_x || img.anchor_x === 0) && (img.anchor_y || img.anchor_y === 0)) {
              bg_img.anchor.set(img.anchor_x, img.anchor_y);
            }
            bg_images.push({ config: img, reference: bg_img });
            if (img.is_container_image && container) {
              container.addChildAt(bg_img, 0);
            } else {
              stage.addChildAt(bg_img, 1);
            }
          });
        }
        onResize();
        if (map_config.start_pan) {
          container.position.x += map_config.start_pan.x;
          container.position.y += map_config.start_pan.y;
        }
      }
      function reset_mapconfig() {
        map_config = scope.moduleMapData.meta_config && scope.moduleMapData.meta_config.map_config ? _.extend(_.clone(default_map_configs), scope.moduleMapData.meta_config.map_config) : default_map_configs;
        toggle_mapconfig();
      }

      eventManager.listen('module:change:meta', function (e, data) {
        $timeout(function () {
          //Remove the focus from the selected item
          eventManager.broadcast('module:dismiss:focus');
          language.setAvailableOptions(_.get(scope.moduleMapData, ['content', 'available_languages', LocaleService.getUrlVersion()]));
          if (scope.currentActiveSubModule && scope.currentActiveSubModule.config && scope.currentActiveSubModule.config.map_config) {
            reset_mapconfig();
          }
          scope.currentActiveSubModule = {};
          scope.panelDisplay = {
            slug: '',
            isExpanded: false,
            sub: {}
          };

          verlet_system.deactivateAllBodies(true);
          for (var i = 0; i < modules.length; i++) {
            verlet_system.activateBody(modules[i].slug, true);

            modules[i].graphics.interactive = true;
          }
          onResize();

          //no active module
          MapStateService.setActiveModule("");
          MapStateService.setCurrentItemLang("");
        }, TIMING_CONSTANTS.INSTANT);
      });

      eventManager.listen('unlock-item', function (e, slug) {
        items.forEach(function (resource) {
          if (slug === resource.slug) {
            resource.unlock(true);
            resource.unlockedByAgenda = true;
          }
        });
        // var scopeResource = getResourceBySlug(slug);
        // scopeResource.locked = false;
      });
      eventManager.listen('module:change:submodule', function (e, data) {
        $timeout(function () {
          verlet_system.deactivateAllBodies(true);

          MapStateService.setActiveModule(data);
          var resources = MapStateService.getSelectedResourcesForAgendaCreation();
          var use_resources = scope.moduleMapData.resources;
          if (data.indexOf('run_like_math_') > -1 && scope.moduleMapData.module_id === 11) {
            for (var j = 0; j < scope.moduleMapData.resources.length; j++) {
              if (scope.moduleMapData.resources[j].slug === 'run_like_math') {
                use_resources = scope.moduleMapData.resources[j].children;
              }
            }
          }
          for (var i = 0; i < use_resources.length; i++) {
            if (use_resources[i].slug === data) {
              if (scope.currentActiveSubModule && scope.currentActiveSubModule.config && scope.currentActiveSubModule.config.map_config && !use_resources[i].map_config) {
                //if going from module with map config to one without, reset to default parents config
                reset_mapconfig();
              }
              scope.currentActiveSubModule = use_resources[i];
              if (scope.currentActiveSubModule && scope.currentActiveSubModule.id === 192 && scope.currentActiveSubModule.children) {
                scope.currentActiveSubModule.resources = scope.currentActiveSubModule.children;
              }
              if (scope.currentActiveSubModule.config.map_config) {
                map_config = _.extend(map_config, scope.currentActiveSubModule.config.map_config);
                toggle_mapconfig();
              }
              var resource = use_resources[i];
              for (var n = 0; n < resource.children.length; n++) {
                //unselect any highlited item
                var item = getItemBySlug(resource.children[n].slug);
                if (item && TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView) {
                  item.hideAgendaHighlight();
                }
                // if((resources && resources.contains && resources.contains(item.id))){
                //   item.showAgendaHighlight();
                // }
                if (DEV_VARIABLES.RESOURCES.HIDE_THESE.indexOf(resource.children[n].slug) > -1 || resource.children[n].config && resource.children[n].config.hidden === true) {
                  continue;
                }

                verlet_system.activateBody(resource.children[n].slug, true);
              }
              break;
            }
          }
          eventManager.broadcast('log:language:options', {
            available_language: scope.currentActiveSubModule.content.available_languages || 'none',
            current_url_version: LocaleService.getUrlVersion(),
            cycle: 'gr78'
          });
          language.setAvailableOptions(_.get(scope.currentActiveSubModule, ['content', 'available_languages', LocaleService.getUrlVersion()]));
          if (MapStateService.getCurrentItemLang() && MapStateService.getCurrentItemLang() !== language.getCurrentSelectedLanguage()) {
            language.set(MapStateService.getCurrentItemLang());
          }
          if (!scope.hasAgendaOption()) {
            scope.selectModulePanel();
          }
          // $log.log('from current active sub : ', scope.currentActiveSubModule)

          var isVerletNeeded = !map_config.disable_verlet;
          if (map_config.disable_verlet || scope.currentActiveSubModule.display && scope.currentActiveSubModule.display.isVerletDisabled) {
            isVerletNeeded = false;
          }
          verlet_system.toggle(isVerletNeeded);
          // $log.log('verlate is active : ' , isVerletNeeded, verlet_system.getCurrentEnabledStatus())

          if (scope.currentActiveSubModule.display.panel && scope.currentActiveSubModule.display) {
            scope.panelDisplay = {
              slug: scope.currentActiveSubModule.slug,
              isExpanded: true,
              sub: scope.currentActiveSubModule.display.panel
            };
          }

          if (bg_images && bg_images.length > 0) {
            _.each(bg_images, function (img) {
              if (img.config.hide_in_submodule) {
                img.reference.visible = false;
              }
            });
          }
        }, TIMING_CONSTANTS.INSTANT);
      });

      eventManager.listen('module:open:resource', function (e, data) {
        MapStateService.setFocusSlug(data.slug);
        MapStateService.setCurrentItemLang(language.getCurrentSelectedLanguage());
      });

      var prehighlighted_list = [];
      eventManager.listen('highlight:map:items', function (e, list) {
        // $log.log('got prehighlighted list : ', list)
        prehighlighted_list = list;
        $timeout(function () {
          onResize();
        }, 500);
      });

      eventManager.listen('module:select:resource', function (e, data) {
        var scopeResource = getResourceBySlug(data.slug);
        if (scopeResource === null) {
          eventManager.broadcast('module:dismiss:focus');
          return;
        }

        if (scope.onItemClick && scope.interceptClick) {
          var item = getItemBySlug(data.slug);
          scope.onItemClick(scopeResource, item, data);
          // return;
        }
        $timeout(function () {
          scope.selectedResource = scopeResource;
        }, TIMING_CONSTANTS.INSTANT);

        var mapResource = getItemBySlug(data.slug);
        if (scope.itemResource && scope.itemResource !== mapResource && map_config.map_style === 'ocmt') {
          scope.itemResource.endRotation();
        }
        scope.itemResource = mapResource;

        //This isn't a map item??
        if (mapResource === null) {
          return;
        }

        focus_item = mapResource;

        scope.scale_factor = focus_item && focus_item.type === 'assessment' && focus_item.config.assessment_type !== 'formative' ? 9.6 : 10;

        if (map_config.map_style !== 'ocmt' && selection_graphic) {
          mapResource.sprite.addChildAt(selection_graphic, 0);
          selection_graphic.scale.set(0);
        }

        //Find the module that contains the selected item and open it
        var module_slug = '';
        for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
          if (scope.moduleMapData.resources[i].children.indexOf(scopeResource) > -1) {
            if (MapStateService.getActiveModule() !== scope.moduleMapData.resources[i].slug) {
              eventManager.broadcast('module:change:submodule', scope.moduleMapData.resources[i].slug);
              eventManager.broadcast('update:submodule:slug:route:name', { slug: scope.moduleMapData.resources[i].slug, name: scope.moduleMapData.resources[i].name });
              MapStateService.setActiveModule(scope.moduleMapData.resources[i].slug);
            }
          }
        }

        if (TeacherDataService.inTeacherAgendaView) {
          if (!middle_view_visible) {
            middle_view_visible = true;
          }
        }
      });

      eventManager.listen('module:center:resource', function (e, data) {
        if (data.map_config && (data.map_config.disable_panning || data.map_config.disable_auto_pan)) {
          return;
        }
        focus_item = getItemBySlug(data.slug);
      });

      eventManager.listen('module:stop:pan', function () {
        focus_item = null;
      });

      // eventManager.listen('agenda:show:image', function(e, img_url){        
      //   if(TeacherDataService.inTeacherAgendaView){
      //     $log.log('GOT IMAGE : ', img_url)
      //     scope.agenda_box_graphic.removeChildren();

      //     var texture = PIXI.Texture.from(img_url);
      //     var agenda_img = new PIXI.Sprite(texture);
      //     scope.agenda_box_graphic.addChild(agenda_img)
      //     agenda_img.width = 880
      //     agenda_img.x = 10;
      //     agenda_img.y = 60;
      //   }
      // })

      /////////////
      // METHODS
      /////////////

      //Mousewheel zoom/in out at cursor position (like google maps)
      var handleScroll = function handleScroll(evt) {
        if (!evt || map_config.disable_zoom) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = evt.detail < 0 || evt.wheelDelta > 0 ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = container.scale.x;
        scale = Math.max(Math.min(1.0, start_scale + direction / 15), 0.25);
        var diff = scale - start_scale;
        container.scale.set(scale, scale);
        //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
        // var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
        // container.position.x -= diff * pos.x;
        // container.position.y -= diff * pos.y;

        evt.preventDefault();
        return false;
      };

      var handleDoubleClick = function handleDoubleClick(e) {
        e.preventDefault();
        return false;
      };

      var initMapDraw = function initMapDraw(moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        var combinedResourceMap = {};
        // $log.log("modulemapdata : ", moduleMapData)

        _.forEach(moduleMapData.children, function (someItem) {
          combinedResourceMap[someItem.slug] = someItem;
          loadChildren(someItem);
        });

        var currentModuleChildrenDisplayItems = [];
        _.each(combinedResourceMap, function (resource) {
          var item = createItem(resource, moduleMapData.config);
          if (!item) {
            return;
          }
          currentModuleChildrenDisplayItems.push(item);
          if (item.sprite && item.sprite.position && item.sprite.position.x < leftMostMapItemPosition) {
            leftMostMapItemPosition = item.sprite.position.x;
          }
          if (item.sprite && item.sprite.position && item.sprite.position.x && item.sprite.position.x > rightMostMapItemPosition) {
            rightMostMapItemPosition = item.sprite.position.x;
          }
          if (item.sprite && item.sprite.position && item.sprite.position.y && item.sprite.position.y < topMostMapItemPosition) {
            topMostMapItemPosition = item.sprite.position.y;
          }
        });

        // $log.log('currentModuleChildrenDisplayItems : ', moduleMapData)

        var summativeItem = _.find(currentModuleChildrenDisplayItems, function (each) {
          return each.slug.indexOf('sum') > -1 && each.resource_type === 'assessment';
        });
        if (summativeItem) {
          //  $log.log('summative g78 : ', summativeItem)
          summativeItem.sprite.position.set(leftMostMapItemPosition + (rightMostMapItemPosition - leftMostMapItemPosition) / 2 - summativeItem.sprite.width / 2, topMostMapItemPosition - 150);
          summativeItem.initialX = summativeItem.sprite.position.x;
          allSummativeItems.push(summativeItem);
        }

        _.forEach(items, function (item) {
          if (!item.locked) {
            item.unlock();
          }
          if (MapDataMassage.getTempUnlocks()) {
            if (_.indexOf(MapDataMassage.getTempUnlocks(), item.slug) !== -1) {
              item.unlock();
            }
          }
        });

        if (agendas_list.length > 0) {
          agendas_list.forEach(function (agenda) {
            if (agenda.force_unlock) {
              agenda.resources.forEach(function (item) {
                unlockpath(item);
              });
            }
          });
        }
      };

      var updateItemsHighlighterAnimation = function updateItemsHighlighterAnimation() {
        angular.forEach(items, function (each) {
          if (each.selection_graphic) {
            //Rotate it a little bit
            each.selection_graphic.rotation = (each.selection_graphic.rotation - 0.015) % (Math.PI * 2);
            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            var scale_factor = each.type === 'assessment' && each.config.assessment_type !== 'formative' ? 9.6 : 10;
            each.selection_graphic.scale.set((each.selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / scale_factor);
          }
          if (each.highlight_graphic) {
            //Rotate it a little bit
            each.highlight_graphic.rotation = (each.highlight_graphic.rotation - 0.015) % (Math.PI * 2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.highlight_graphic.scale.set((each.highlight_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / 10);
          }
        });
      };

      var prev_diff;

      //This loops to control things that should update every frame
      var update = function update() {
        if (selection_graphic && map_config.selector_options && map_config.selector_options.disable_module_selection) {
          selection_graphic.visible = false;
        } else if (selection_graphic) {
          selection_graphic.visible = true;
        }

        if (selection_graphic !== null && !scope.interceptClick && map_config.map_style !== 'ocmt' && (!map_config.selector_options || !map_config.selector_options.disable_animations)) {
          //Rotate it a little bit
          selection_graphic.rotation = (selection_graphic.rotation - map_config.selector_options.rotation_speed) % (Math.PI * 2);

          //Use UNIX time to scale the graphic with a sin function
          //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
          var selection_scale = map_config.selector_options.disable_size_shifting ? map_config.selector_options.start_scale : (selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / scope.scale_factor;
          selection_graphic.scale.set(selection_scale);
          selection_graphic.y = map_config.selector_options.offset_y;
        } else if (map_config.map_style === 'ocmt' && scope.itemResource) {
          scope.itemResource.rotateRing();
        }

        if (TeacherDataService.isTeacherWorkspaceView && (!map_config.selector_options || !map_config.selector_options.disable_animations)) {
          updateItemsHighlighterAnimation();
        } else if (TeacherDataService.isTeacherWorkspaceView && map_config.selector_options && map_config.selector_options.disable_animations) {
          var itemScale = map_config && map_config.icon_options && map_config.icon_options.item_icon_scale ? map_config.icon_options.item_icon_scale : 1.0;

          angular.forEach(items, function (each) {
            if (each.selection_graphic) {
              // reset rotation and scale of item selection icon
              each.selection_graphic.rotation = 0;

              var scale_size = 0.75;
              var selector_scale = map_config.selector_options && map_config.selector_options.selector_scale ? map_config.selector_options.selector_scale : scale_size;
              each.selection_graphic.scale.set(selector_scale * itemScale, selector_scale * itemScale);
            }
          });
        }
        //update the fade in animation
        cloud_man.update();

        //update the verlet force directed graph that positions the map items in that big jiggly web
        verlet_system.update();

        if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
          drag_info.velocity = {
            x: drag_info.velocity.x * 0.954,
            y: drag_info.velocity.y * 0.954
          };
        } else {
          container.position.x = Math.min(1000, Math.max(container.position.x - drag_info.velocity.x, 0));
          container.position.y = Math.min(1000, Math.max(container.position.y - drag_info.velocity.y, 0));
          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;
        }

        focusItemTicker();

        lines_graphic.clear();
        if (!map_config.line_options.disabled) {
          var line_color = Number(map_config.line_options.color);
          lines_graphic.lineStyle(8, line_color, 1);
          var segments = verlet_system.getLineSegments();
          var i;
          for (i = 0; i < segments.solid.length; i++) {
            var cur_seg = segments.solid[i];
            var start_point = map_config.line_options.offset_y || cur_seg.start.y;
            var end_point = map_config.line_options.offset_y || cur_seg.end.y;
            lines_graphic.lineStyle(map_config.line_options.line_size, line_color, 1);
            if (scope.item_path_slug.indexOf(cur_seg.id) > -1) {
              lines_graphic.lineStyle(map_config.line_options.line_size, 0XFFCC00, 1);
            }
            lines_graphic.moveTo(cur_seg.start.x, start_point);
            lines_graphic.lineTo(cur_seg.end.x, end_point);
          }
          lines_graphic.beginFill(0xFF0000, 1);
          for (i = 0; i < segments.dash.length; i++) {
            lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
          }
          lines_graphic.endFill();
        }

        if (update_texts.length > 0) {
          update_direction = update_texts[0].scale.x >= 1.1 || update_texts[0].scale.x < 1 ? update_direction * -1 : update_direction;
          update_texts.forEach(function (update_text) {
            update_text.scale.x += update_direction;
            update_text.scale.y += update_direction;
            update_text.alpha = 1 - 2.5 * (1.1 - update_text.scale.x);
            update_text.x += update_direction * -1;
          });
        }

        if (window.DEBUG_TOUCH) {
          $log.log('g78_metamap update ; ', JSON.stringify(drag_info));
        }
      };

      scope.item_path_slug = [];
      function createHighlightedSegments(slug) {
        if (!slug) {
          scope.item_path_slug = [];
          return;
        }
        items.forEach(function (resource) {
          if (slug === resource.slug) {
            scope.item_path_slug.push(slug);
            if (resource.unlocked_by.length > 0) {
              resource.unlocked_by.forEach(function (higher_resource) {
                createHighlightedSegments(higher_resource);
              });
            }
          }
        });
        // $log.log('scope.item_path_slug , ', scope.item_path_slug)
      }

      eventManager.listen('highlight:path', function (e, data) {
        scope.item_path_slug = [];
        // $log.log('HIGHLIGHT THIS : ', data)
        // var use_slug = data.slug.split(':')[1].trim();
        var use = data.slug;
        if (data.clear) {
          use = false;
        }
        createHighlightedSegments(use);
      });

      /**
       *Expand a subgroup to reveal child items
       *slug is a unique String that identifies the group MapItem
       **/
      var expandGroup = function expandGroup(slug) {
        //Cancel this mouse event if they were dragging more than 10 pixels
        if (drag_info.dragging) {
          if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
            return;
          }
        }

        if (verlet_system.deactivateBody(slug, true)) {
          var group = getItemBySlug(slug);
          //position all of the sub items so that they appear from where the clicked group icon is
          for (var i = 0; i < items.length; i++) {
            if (items[i].parentItem === group) {
              items[i].sprite.position.x = group.sprite.position.x;
              items[i].sprite.position.y = group.sprite.position.y;
              verlet_system.activateBody(items[i].slug, true);
            }
          }
          // toggleGroupExpanded(group);
        }
      };

      /**
       *Collapse a subgroup to hide child items
       *slug is a unique String that identifies the group MapItem
       **/
      var collapseGroup = function collapseGroup(slug) {
        var group = getItemBySlug(slug);
        if (group.isExpanded === true) {
          toggleGroupExpanded(group);
        }
      };

      /**
       *Toggle the expand/collapse of a given item group
       *group is a MapItem
       **/
      var toggleGroupExpanded = function toggleGroupExpanded(group) {
        group.isExpanded = !group.isExpanded;
        //    baseVerletSystem.hookUpConstraints();
      };

      //If focus item is defined, pan towards it
      var focusItemTicker = function focusItemTicker() {
        if (focus_item === null || map_config.disable_panning || map_config.disable_auto_pan || !scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0) {
          return;
        }
        var abs_pos = container.toGlobal(focus_item.sprite.position);
        container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
        container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
      };

      /**
       *Return a MapItem whose slug matches the passed slug
       *Returns null if no MapItem can be found
       */
      var getItemBySlug = function getItemBySlug(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      };

      var getItemById = function getItemById(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      };

      var getResourceBySlug = function getResourceBySlug(slug) {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n++) {
          if (scope.moduleMapData.resources[n].slug === slug) {
            return scope.moduleMapData.resources[n];
          }
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === slug) {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      };

      var getResourceById = function getResourceById(id) {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n++) {
          if (scope.moduleMapData.resources[n].id === id) {
            return scope.moduleMapData.resources[n];
          }
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].id === id) {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      };

      ////////////////
      //
      ////////////////
      var onResize = function onResize(sidepanel_expanded) {
        var _canvasEl = document.getElementById('module-item-map-canvas');
        if (!_canvasEl) {
          return;
        }

        var sidepanel_width = TeacherDataService.sidepanelStatus ? 260 : 60;
        var canv_width;
        scope.agendaView = TeacherDataService.inTeacherAgendaView;

        if (!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView) {
          if (sidepanel_expanded === true || sidepanel_expanded === false) {
            sidepanel_width = sidepanel_expanded ? 140 : -200;
          } else {
            sidepanel_width = 0;
          }
          canv_width = (PlatformService.isPhonePortrait() ? window.innerWidth : _canvasEl.parentElement.offsetWidth) - sidepanel_width;
        } else {
          var middleview = document.getElementById('agenda_middleview');
          if (middleview) {
            sidepanel_width += 300;
          }
          if (!TeacherDataService.inTeacherAgendaView) {
            sidepanel_width += -30;
          }
          if (window.innerWidth < 1225) {
            sidepanel_width = TeacherDataService.sidepanelStatus ? 260 : 60;
          }

          var sidebarWidth = 370;
          var agendaSplitViewSidebar = document.getElementById('agendaSplitViewSidebar');
          if (agendaSplitViewSidebar) {
            sidebarWidth = agendaSplitViewSidebar.offsetWidth;
          }

          canv_width = window.innerWidth - sidebarWidth - sidepanel_width;
        }

        var canvasDimHeightSubtractor = 0;
        if (!TeacherDataService.inTeacherAgendaView && !TeacherDataService.isTeacherWorkspaceView) {
          if (PlatformService.isMobile && !PlatformService.isPhonePortrait() && $rootScope.isOCMT) {
            canvasDimHeightSubtractor = 95;
          } else {
            canvasDimHeightSubtractor = 135;
          }
        } else {
          canvasDimHeightSubtractor = 35;
        }

        if (map_config.hide_bottom_panel) {
          canvasDimHeightSubtractor = 35;
        }

        canvasDimention = {
          width: canv_width,
          height: window.innerHeight - canvasDimHeightSubtractor
        };

        _canvasEl.width = canvasDimention.width;
        _canvasEl.height = canvasDimention.height;

        meta_background.width = canvasDimention.width;
        meta_background.height = canvasDimention.height;

        renderer.resize(canvasDimention.width, canvasDimention.height);
        cloud_man.onResize(canvasDimention.width, canvasDimention.height);

        scope.overlay_top = '50px';

        if (bg_images && bg_images.length > 0) {
          _.each(bg_images, function (img) {
            if (img.config.type === 'regular') {
              if (img.config.dimensions) {
                var img_scale = canvasDimention.width / window.innerWidth * img.config.dimensions.width;

                if (img.config.is_container_image) {
                  img_scale = img.config.dimensions.width;
                }

                img.reference.scale.set(img_scale, img_scale);
              }

              img.reference.position.x = img.config.position.is_proportion ? canvasDimention.width * img.config.position.x : img.config.position.x;

              var heightDifferential = (TeacherDataService.isTeacherWorkspaceView || TeacherDataService.inTeacherAgendaView) && img.config.is_container_image ? 100 : 0;

              if (img.config.is_container_image) {
                img.reference.position.y = img.config.position.y;
              } else {
                img.reference.position.y = img.config.position.is_proportion ? canvasDimention.height * img.config.position.y - heightDifferential : img.config.position.y - heightDifferential;
              }
            } else if (img.config.type === 'tiling') {
              img.reference.position.x = img.config.position.is_proportion ? canvasDimention.width * img.config.position.x : img.config.position.x;
              img.reference.position.y = img.config.position.is_proportion ? canvasDimention.height * img.config.position.y : img.config.position.y;
              if (img.config.dimensions) {
                img.reference.width = img.config.dimensions.width <= 1 ? canvasDimention.width * img.config.dimensions.width : img.config.dimensions.width;
                img.reference.height = img.config.dimensions.height <= 1 ? canvasDimention.height * img.config.dimensions.height : img.config.dimensions.height;
              }
            }

            if (img.config.hide_in_submodule) {
              img.reference.visible = !scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0;
            }
          });
        }

        if (container && renderer) {
          if (PlatformService.isMobile && $rootScope.isOCMT) {
            var mScale = void 0;
            var mContainerX = void 0;
            var mContainerY = void 0;

            if (window.orientation === 0) {
              mScale = canvas_el.clientWidth * 0.00067633;
              mContainerX = canvas_el.clientWidth / 2;
              mContainerY = canvas_el.clientHeight * 0.52;
            } else {
              mScale = canvas_el.clientWidth * 0.0005;
              mContainerX = canvas_el.clientWidth / 2;
              mContainerY = canvas_el.clientHeight * 0.75;
            }
            container.scale.set(mScale, mScale);
            container.x = mContainerX;
            container.y = mContainerY;
          } else {
            scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width / 800) : scale;
            if (renderer.height < 800 && scope.currentActiveSubModule && scope.currentActiveSubModule.slug && scope.currentActiveSubModule.slug.indexOf('run_like_math') > -1) {
              scale = Math.max(0.2655, 0.45 * Math.min(renderer.height, renderer.width) / 800);
              scope.overlay_scale = Math.min(1, scale * 2);
              scope.overlay_top = 50 * scope.overlay_scale + 'px';
            } else {
              scope.overlay_scale = null;
            }
            container.scale.set(scale, scale);

            if (map_config.zoom_start_difference && renderer.width < 800) {
              scope.zoom_function(map_config.zoom_start_difference * -1);
            }
            if (focus_item && !map_config.disable_panning && !map_config.disable_auto_pan) {
              var abs_pos = container.toGlobal(focus_item.sprite.position);
              container.x += -(abs_pos.x - 125 - app.renderer.width / 2);
              container.y += -(abs_pos.y + 80 - app.renderer.height / 2);
            } else {
              container.x = renderer.width / 2;
              container.y = renderer.height / 2;
            }
          }

          if (window.innerWidth < 1225 && TeacherDataService.inTeacherAgendaView) {
            scope.overlay_top = '30%';
          }

          scope.canv_width = canvasDimention.width + 'px';
        }
      };

      //this is what runs to initialize the map
      var loadAssets = function loadAssets() {
        $log.debug('[[gr78MetaMap]] loadAssets');
        return $q(function (resolve, reject) {
          try {
            if (!PIXI_gr78_Load_Cache) {
              PIXI.loader.add(img_asset_paths).load(function () {
                PIXI_gr78_Load_Cache = true;
                initMap(resolve);
              });
            } else {
              initMap(resolve);
            }
          } catch (err) {
            $log.error('[[gr78MetaMap]]', err);
            reject(err);
          }
        });
      };

      //remove when rlm integration done
      scope.slugs = {
        addition: ["run_like_math_addition_lv_1", "run_like_math_addition_lv_2", "run_like_math_addition_lv_3", "run_like_math_addition_lv_4", "run_like_math_addition_lv_5", "run_like_math_addition_lv_6", "run_like_math_addition_lv_7", "run_like_math_addition_lv_8", "run_like_math_addition_lv_9", "run_like_math_addition_lv_10"],
        subtraction: ["run_like_math_subtraction_lv_1", "run_like_math_subtraction_lv_2", "run_like_math_subtraction_lv_3", "run_like_math_subtraction_lv_4", "run_like_math_subtraction_lv_5", "run_like_math_subtraction_lv_6", "run_like_math_subtraction_lv_7", "run_like_math_subtraction_lv_8", "run_like_math_subtraction_lv_9", "run_like_math_subtraction_lv_10"],
        division: ["run_like_math_division_lv_1", "run_like_math_division_lv_2", "run_like_math_division_lv_3", "run_like_math_division_lv_4", "run_like_math_division_lv_5", "run_like_math_division_lv_6", "run_like_math_division_lv_7", "run_like_math_division_lv_8", "run_like_math_division_lv_9", "run_like_math_division_lv_10"],
        multiplication: ["run_like_math_multiplication_lv_1", "run_like_math_multiplication_lv_2", "run_like_math_multiplication_lv_3", "run_like_math_multiplication_lv_4", "run_like_math_multiplication_lv_5", "run_like_math_multiplication_lv_6", "run_like_math_multiplication_lv_7", "run_like_math_multiplication_lv_8", "run_like_math_multiplication_lv_9", "run_like_math_multiplication_lv_10"]
      };
      scope.isRlm = function (mod) {
        return mod && (mod.id === 192 || mod.parent_resource_id === 192);
      };
      //done remove

      var initMap = function initMap(resolve) {
        $log.debug('[[gr78MetaMap]] initMap');
        modules = [];
        var i, n, p;

        for (i = 0; i < scope.moduleMapData.resources.length; i++) {
          if ((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) && (scope.moduleMapData.resources[i].id === 923 || scope.moduleMapData.resources[i].id === 955)) {
            //hide these
          } else {
            initMapDraw(scope.moduleMapData.resources[i]);
            if (!ModuleFilter.checkAvailable(scope.moduleMapData.resources[i]) && map_config.hide_on_lock || scope.moduleMapData.resources[i].parent_resource_id === 192) {
              continue;
            }
            var module_container = createModuleContainer(scope.moduleMapData.resources[i]);
            modules.push(module_container);
          }

          //Add all the bad boys to the verlet_system
        }
        //moduleContainerManager.translationChanged();
        $log.debug('[[gr78MetaMap]] initMap.initMapDraw done');

        verlet_system.deactivateAllBodies(true);

        for (i = 0; i < modules.length; i++) {
          verlet_system.activateBody(modules[i].slug, true);
        }
        $log.debug('[[gr78MetaMap]] initMap.verlet_system done');
        var active_module = MapStateService.getActiveModule();
        for (n = 0; n < modules.length; n++) {
          if (modules[n].slug === active_module) {
            moduleClicked(modules[n]);

            var active_items = MapStateService.getActiveItems();

            verlet_system.deactivateAllBodies(true);

            for (p = 0; p < active_items.length; p++) {
              var item = getItemBySlug(active_items[p]);
              var pos = MapStateService.getItemState(active_items[p]);
              if (!item) {
                continue;
              }
              item.sprite.position.x = pos.x;
              item.sprite.position.y = pos.y;
              verlet_system.activateBody(active_items[p], true);
            }
          }
        }

        if (!map_config.selection_disabled) {
          selection_graphic = new PIXI.Sprite(PIXI.loader.resources[map_config.asset_url + 'selection.png'].texture);
          selection_graphic.anchor.set(0.5, 0.5);
          selection_graphic.scale.set(0.75, 0.75);
          selection_graphic.interactive = false;
          selection_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
        }

        if (!PanelStateService.agendaShowing()) {
          scope.toggleAgenda();
        }

        //If an item was selected before we left the map, find it and highlight it as we return.
        var focus_slug = MapStateService.getFocusSlug();
        for (n = 0; n < scope.moduleMapData.resources.length; n++) {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === focus_slug) {
              var item_info = scope.moduleMapData.resources[n].children[i];
              // var item_evt_info = {
              //   slug : item_info.slug,
              //   id : item_info.id
              // };
              //brodcast the selection events
              eventManager.broadcast('module:center:resource', item_info);
              eventManager.broadcast('module:select:resource', item_info);
              if (focus_item === null || map_config.disable_panning || map_config.disable_auto_pan) {
                break;
              }
              //center on the resource immediately
              if (focus_item) {
                var abs_pos = container.toGlobal(focus_item.sprite.position);
                container.x += -(abs_pos.x - 125 - app.renderer.width / 2);
                container.y += -(abs_pos.y + 80 - app.renderer.height / 2);
              }

              break;
            }
          }
        }
        if (focus_item) {
          if (scope.moduleMapData.resources[n] !== undefined && scope.moduleMapData.resources[n].children[i] !== undefined) {
            $timeout(function () {
              scope.panelDisplay = scope.moduleMapData.resources[n].children[i];
            }, TIMING_CONSTANTS.INSTANT);
          }
        }

        if (PlatformService.isMobile && $rootScope.isOCMT) {
          $timeout(function () {
            var mScale = void 0;
            var mContainerX = void 0;
            var mContainerY = void 0;

            if (window.orientation === 0) {
              mScale = canvas_el.clientWidth * 0.00067633;
              mContainerX = canvas_el.clientWidth / 2;
              mContainerY = canvas_el.clientHeight * 0.52;
            } else {
              mScale = canvas_el.clientWidth * 0.0005;
              mContainerX = canvas_el.clientWidth / 2;
              mContainerY = canvas_el.clientHeight * 0.75;
            }
            container.scale.set(mScale, mScale);
            container.x = mContainerX;
            container.y = mContainerY;
          }, 100);
        } else {
          if (map_config.zoom_start_difference) {
            $timeout(function () {
              scope.zoom_function(map_config.zoom_start_difference * -1);
            }, 100);
          }
        }

        $log.debug('[[gr78MetaMap]] initMap.active_module done');
        resolve();

        eventManager.broadcast('creating-items-done');
        if (prehighlighted_list && prehighlighted_list.length > 0) {
          _.each(prehighlighted_list, function (el) {
            var item = getItemById(el);
            if (item) {
              item.showAgendaHighlight(true);
            }
          });
        }
      };

      var module_clicked = false;
      var moduleClicked = function moduleClicked(module_container) {
        if ((module_container.slug === 'mtic_c3_m1v2' || module_container.slug === 'mtic_c3_m1' || module_container.slug === 'mtic_c3_m3') && (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1)) {
          window.alert('Some of the video items are currently not supported on Internet Explorer. Please use a different browser for the best results.');
        }
        if ((module_container.slug === 'mtic_c3_m56' || module_container.slug === 'mtic_gr910_m1' || module_container.slug === 'mtic_gr910_m2') && PlatformService.isMobile && !window.confirm('This module is not optimized for mobile devices. Please use a different device for the best results.')) {
          return;
        }
        if (module_container.slug === 'mtic_c3_m56' && (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1)) {
          window.alert('This module is currently not supported on Internet Explorer. Please use a different browser to access this module.');
          return;
        }

        if (scope.interactionDisabled || scope.agendaView && module_container.id === 192) {
          return;
        }
        module_clicked = true;

        // $log.log('MODULE CONTAINER : ', module_container)
        if (ModuleFilter.checkAvailable(module_container)) {
          if (scope.interceptClick) {
            if (scope.interceptClick.slug !== module_container.slug) {
              scope.interceptClick.slug = module_container.slug;
            } else if (!TeacherDataService.inTeacherAgendaView) {
              // eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
            }

            scope.$apply();
          }
          var i;
          scope.moduleProgress = module_container.progress;
          $log.debug('[[gr78MetaMap]] clicked', module_container);

          if (module_container.content.container) {
            scope.loadedIframeModule.data = module_container;
            scope.loadedIframeModule.active = true;
          } else {
            for (i = 0; i < modules.length; i++) {
              modules[i].graphics.interactive = false;

              verlet_system.deactivateBody(modules[i].slug, true);
            }
            eventManager.broadcast('submodule:opened', {
              slug: module_container.slug,
              name: module_container.name
            });

            $timeout(function () {
              onResize();
            }, 10);
            $timeout(function () {
              eventManager.broadcast('module:change:submodule', module_container.slug);
            }, TIMING_CONSTANTS.INSTANT);
          }
        } else {
          window.alert(language.get('module_is_locked'));
        }
      };

      var createModuleContainer = function createModuleContainer(module, reset) {
        //Set up the container sprite that will be used
        var do_lock = module.locked;
        //$log.log("MODULE : " , module)//DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(module.slug) > -1
        // $log.log('ModuleFilter.checkAvailable(module)', ModuleFilter.checkAvailable(module))
        if (!ModuleFilter.checkAvailable(module)) {
          do_lock = true;
        }
        //For drawing progress ring
        var sum = 0;
        var prog = 0;
        var formative_count = 0;
        var lesson_count = 0;

        module.progress_rings = { diagnostic: 0, lessons: 0, summative: 0, summative_complete: false };

        for (var i = 0; i < module.children.length; i++) {
          var child = module.children[i];

          if (child.resource_type === 'lesson') {
            module.progress_rings.lessons += child.complete && child.resourceState.score_max ? child.resourceState.score_max : 0;
            lesson_count++;
          } else if (child.config.assessment_type && child.config.assessment_type === 'diagnostic') {
            module.progress_rings.diagnostic = child.complete && child.resourceState.score_max ? child.resourceState.score_max : 0;
          } else if (child.config.assessment_type && child.config.assessment_type === 'formative' && !module.progress_rings.summative_complete) {
            module.progress_rings.summative += child.complete && child.resourceState.score_max ? child.resourceState.score_max : 0;
            formative_count++;
          } else if (child.config.assessment_type && child.config.assessment_type === 'summative') {
            if (child.complete) {
              module.progress_rings.summative_complete = true;
            }
            module.progress_rings.summative = child.complete && child.resourceState.score_max ? child.resourceState.score_max : module.progress_rings.summative;
          }

          if (child.resource_type === 'symlink' || child.resource_type === 'assessment' && child.config.assessment_type && child.config.assessment_type === 'formative') {
            continue;
          }
          sum++;
          if (TeacherDataService.isTeacherWorkspaceView) {
            prog += workspace_list[child.id] ? 1 : 0;
          } else {
            prog += child.complete ? 1 : 0;
          }
        }

        if (!module.progress_rings.summative_complete && formative_count > 0) {
          module.progress_rings.summative = module.progress_rings.summative / formative_count;
        }
        module.progress_rings.lessons = module.progress_rings.lessons / lesson_count;

        var getProgressRingColor = function getProgressRingColor(val) {
          var color = '';
          if (val <= 0.5) {
            color = 'red';
          } else if (0.5 < val && val <= 0.8) {
            color = 'yellow';
          } else {
            color = 'green';
          }
          return color;
        };

        module.progress_rings = {
          diagnostic: {
            value: Math.round(module.progress_rings.diagnostic * 100),
            color: getProgressRingColor(module.progress_rings.diagnostic)
          },
          lessons: {
            value: Math.round(module.progress_rings.lessons * 100),
            color: getProgressRingColor(module.progress_rings.lessons)
          },
          summative: {
            value: Math.round(module.progress_rings.summative * 100),
            color: getProgressRingColor(module.progress_rings.summative),
            complete: module.progress_rings.summative_complete
          }
        };

        if (TeacherDataService.isTeacherModuleView) {
          prog = 0;
        }
        var mod_graphics;
        if (reset) {
          modules.forEach(function (mod) {
            if (mod.slug === module.slug) {
              mod_graphics = mod.graphics;
            }
          });
          //mod_graphics = container.getChildAt(0);
          if (!mod_graphics) {
            return;
          }
          mod_graphics.clear();
          mod_graphics.removeChildren();
        } else {
          mod_graphics = new PIXI.Graphics();
        }
        // mod_graphics.beginFill(do_lock ? 0xC5FBF5 : 0xFFFFFF).drawCircle(0, 0, 145).endFill() //white border
        // .moveTo(0, 0)
        // .beginFill(0x33ACE0).arc(0,0,146,-Math.PI/2, (prog/sum)*Math.PI*2-Math.PI/2); //progress ring
        var mod_graphic_url = map_config.use_panel_factory_icon_names ? PanelFactory.getModuleIconAssetUrl(module.slug) : map_config.asset_url + (do_lock ? "center_lock" : module.slug) + ".png";
        if (map_config.set_module_icon_names) {
          mod_graphic_url = map_config.set_module_icon_names[module.slug] || map_config.set_module_icon_names.default;
          mod_graphic_url = map_config.asset_url + mod_graphic_url + ".png";
        }
        var mod_image = PIXI.Sprite.fromImage(mod_graphic_url);
        mod_image.anchor.set(0.5);
        var img_size = module.slug.indexOf('ocmt') > -1 ? 325 : 250;
        mod_image.width = module.display.width || img_size;
        mod_image.height = module.display.height || img_size;
        mod_graphics.addChild(mod_image);

        container.addChild(mod_graphics);
        mod_graphics.buttonMode = true;
        mod_graphics.interactive = true;
        mod_graphics.x = module.display.position.x;
        mod_graphics.y = module.display.position.y + 300;
        // if(module.id === 69){
        //   mod_graphics.y -= 30;
        // }

        var tooltip = new PIXI.Graphics();
        mod_graphics.addChild(tooltip);
        var mod_graphics_height = mod_graphics.height;

        var drawTooltip = function drawTooltip() {
          tooltip.removeChildren();
          tooltip.clear();
          var height_diff = module.config.is_new ? 70 : 0;
          var padding = map_config.tooltip_options.padding || 0;
          var textInfo = new PIXI.Text(language.get(module.slug), {
            fontFamily: 'Arial',
            align: 'center',
            fontSize: isMobile ? 40 : 32,
            fill: Number(map_config.tooltip_options.fontcolor),
            dropShadow: false,
            wordWrap: true,
            wordWrapWidth: map_config.tooltip_options.wordwrap_width || 300
          });
          textInfo.y = textInfo.height / 2 + 5 + height_diff + padding / 2;
          textInfo.anchor.set(0.5);

          var title_width = textInfo.width;

          if (module.config.is_new) {
            title_width = Math.max(title_width, new PIXI.Text(language.get('updated_slug')).width * 1.1 + 40);
          }

          var text_width = title_width + padding;
          var rectHeight = do_lock ? textInfo.height + 15 + padding : textInfo.height + 35 + padding;

          var triangly_y_start = map_config.tooltip_options.inverted ? 0 : rectHeight;
          var triangly_y_end = map_config.tooltip_options.inverted ? -25 : rectHeight + 25;

          tooltip.beginFill(do_lock ? Number(map_config.tooltip_options.locked_color) : Number(map_config.tooltip_options.color)).drawRoundedRect(-(text_width + 40) / 2, 0, text_width + 40, rectHeight + height_diff, 10).endFill();

          if (module.config.is_new) {
            if (!map_config.tooltip_options.inverted) {
              triangly_y_start += height_diff;
              triangly_y_end += height_diff;
            }
            tooltip.lineStyle(0);
            tooltip.beginFill(map_config.tooltip_options.new_mod_color);
            tooltip.drawRoundedRect(-(text_width + 40) / 2, 0, text_width + 40, height_diff - 10, 10);
            tooltip.drawRect(-(text_width + 40) / 2, height_diff - 20, text_width + 40, 20);
            tooltip.endFill();

            var mod_update_text = new PIXI.Text(language.get('updated_slug'));
            mod_update_text.anchor.set(0.5);
            mod_update_text.style.align = "center";
            mod_update_text.style.fill = "white";
            mod_update_text.style.fontFamily = "Helvetica";
            mod_update_text.style.fontSize = 36;
            mod_update_text.x = 0;
            mod_update_text.y = 38;
            tooltip.addChild(mod_update_text);
            update_texts.push(mod_update_text);
          }

          tooltip.beginFill(do_lock ? Number(map_config.tooltip_options.locked_color) : module.config.is_new && map_config.tooltip_options.inverted ? map_config.tooltip_options.new_mod_color : Number(map_config.tooltip_options.color));
          tooltip.moveTo(-15, triangly_y_start);
          tooltip.lineTo(15, triangly_y_start);
          tooltip.lineTo(0, triangly_y_end);
          tooltip.lineTo(-15, triangly_y_start);
          tooltip.endFill();

          if (!do_lock && !map_config.tooltip_options.no_bar) {
            tooltip.beginFill(Number(map_config.tooltip_options.bar_color));
            tooltip.drawRect(-(text_width + 40) / 2 + 10, textInfo.height + 10 + height_diff + padding / 2, text_width + 20, 15);
            tooltip.endFill();

            tooltip.beginFill(Number(map_config.tooltip_options.bar_fill_color));
            tooltip.drawRect(-(text_width + 40) / 2 + 10, textInfo.height + 10 + height_diff + padding / 2, (text_width + 20) * (prog / sum), 15);
            tooltip.endFill();
          }

          tooltip.addChild(textInfo);

          tooltip.y = map_config.tooltip_options.inverted ? mod_graphics_height / 2 + 50 : -1 * mod_graphics_height / 2 - tooltip.height;
          textInfo.x = tooltip.width / 2 - title_width / 2 - 20;
        };

        eventManager.listen('language:change', drawTooltip);
        drawTooltip();

        var module_container = {
          graphics: mod_graphics,
          slug: module.slug,
          id: module.id,
          name: module.name,
          content: module.content,
          children: module.children,
          progress: prog / sum
        };
        if (reset) {
          mod_graphics.off('pointertap');
        }
        mod_graphics.on('pointertap', function (e) {
          //PIXI is receiving mouse events from other targets
          if (e.data.originalEvent.target && e.data.originalEvent.target.id !== 'module-item-map-canvas') {
            return;
          }
          $timeout(function () {
            if (!zooming) {
              moduleClicked(module_container);
            }
          }, 10);
        });

        // eventManager.listen('destroy-c3-map', function(){
        //   PIXI_gr78_Load_Cache = false;
        // })


        eventManager.listen('module:dismiss:focus', function (e, data) {
          scope.selectedResource = {};
          if (selection_graphic && selection_graphic.parent !== null) {
            selection_graphic.parent.removeChild(selection_graphic);
          }
        });

        eventManager.listen('triggerMapResize', function () {
          $timeout(function () {
            onResize();
          }, 100);
        });

        var connection = [];
        if (modules.length > 0) {
          //    connection.push(modules[modules.length - 1].slug);
        }

        verlet_system.createBody(module.slug, mod_graphics, connection);
        return module_container;
      };

      var loadChildren = function loadChildren(someItem) {
        someItem.childResourcemap = [];

        if (someItem.children === undefined) {
          return;
        }
        if (someItem.children.length > 0) {
          _.forEach(someItem.children, function (childItem) {
            someItem.childResourcemap[childItem.slug] = childItem;
            loadChildren(childItem);
          });
        }
      };
      var interpeteAgendaLockStatus = function interpeteAgendaLockStatus(agenda) {
        if (agenda.force_unlock === true) {
          return 'unlock';
        } else if (agenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      };

      var summative_list = [];

      eventManager.listen('got-c4-summative-data', function (e, args) {
        $timeout(function () {
          summative_list.forEach(function (summ) {
            if (args && args.unlocked.indexOf(summ.name) > -1) {
              // $log.log(MapStateService.getActiveModule());
              var name_check = summ.val.slug.replace('g78', 'gr78');
              args.force_unlock = args.force_unlock || [];
              var start_visible = MapStateService.getActiveModule() && summ.val.config.assessment_type === 'summative' && name_check.indexOf(MapStateService.getActiveModule()) > -1;
              createItem(summ.val, summ.parent, !start_visible, true, args.force_unlock.indexOf(summ.name) > -1);
            }
          });
        }, 500);
      });

      var createItem = function createItem(resource, parentItem, start_hidden, build, force_unlock) {
        var isSummative = false;
        if ((resource.slug.indexOf('summative') > -1 || resource.config.assessment_type === 'summative') && !resource.config.show_summative) {
          isSummative = true;
          if (!build && !TeacherDataService.isTeacherModuleView && !TeacherDataService.isTeacherWorkspaceView) {
            summative_list.push({ name: resource.slug, val: resource, parent: parentItem });
            return;
          }
        } else if (resource.children && resource.children.length > 0) {
          _.forEach(resource.children, function (childItem) {
            createItem(childItem, resource);
          });
          return;
        }

        if (verlet_system.getBody(resource.slug) !== undefined) {
          return;
        }
        var displayItem;

        if (TeacherDataService.isTeacherModuleView || TeacherDataService.isTeacherWorkspaceView) {
          resource.locked = false;
        }
        //Add this to the map logic array of items
        items.push(displayItem = new itemFactory.createMapItem(resource, eventManager, parentItem && parentItem.map_config ? parentItem.map_config : scope.moduleMapData.meta_config.map_config));
        resourceLockManager.setOriginal(displayItem.id, displayItem.locked);
        //create a VerletBody for the item
        displayItem.parentItem = parentItem;
        //     displayItem.sprite.position.x += Math.random() * 10;
        //    displayItem.sprite.position.y += Math.random() * 10;
        container.addChild(displayItem.sprite);

        var children = [];
        //Build the child items
        _.forEach(resource.children, function (childItem) {
          children.push(createItem(childItem, displayItem, true));
        });

        if (map_config.map_style === 'ocmt') {
          displayItem.addSemiRing();
          displayItem.addBottomLineGraphics();
        }

        //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
        //So we create its list of unlocked_by based on the items in the group
        //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
        //And add it to the unlocked_by of the group
        if (displayItem.unlocked_by.length === 0) {
          for (var i = 0; i < children.length; i++) {
            for (var n = 0; n < children[i].unlocked_by.length; n++) {
              var is_inner = true;
              for (var p = 0; p < children.length; p++) {
                //This is pointing from an item in the group to another item in the group
                if (children[i].unlocked_by[n] === children[p].slug) {
                  is_inner = false;
                }
              }
              //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
              if (is_inner) {
                displayItem.unlocked_by.push(children[i].unlocked_by[n]);
              }
            }
          }
        }

        // displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        if (!isSummative) {
          displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        } else {
          displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, false, !resource.complete);
        }
        if (start_hidden) {
          displayItem.sprite.visible = false;
          verlet_system.deactivateBody(resource.slug);
        }
        if (map_config.position_multiplier) {
          displayItem.sprite.position.x = displayItem.sprite.position.x * map_config.position_multiplier;
          displayItem.sprite.position.y = displayItem.sprite.position.y * map_config.position_multiplier;
        }
        if (PlatformService.isMobile && resource.slug.indexOf('run_like_math') > -1) {
          displayItem.sprite.position.y += 125;
        }

        //Add the expandGroup listener to the item
        if (resource.resource_type === "group") {
          displayItem.setDelegate(expandGroup.bind(this));
          displayItem.isExpanded = false;
        }
        if (isSummative) {
          // resource.locked = resource.unlocked_by && resource.unlocked_by.length > 0 ? resource.locked : false;
          if (force_unlock) {
            displayItem.unlock(true);
          }
          if (!map_config.summative_pos_from_db) {
            displayItem.sprite.position.x = -900;
            displayItem.sprite.position.y = -500;
          }
        }
        // if(prehighlighted_list.indexOf(resource.id) > -1){
        //   $log.log('PREHIGHLIGHTING : ', resource.slug)
        //   $timeout(function(){
        //     displayItem.showAgendaHighlight(true);
        //   }, 100);
        // }
        return displayItem;
      };

      scope.$on('$destroy', function () {
        // language.resetAvilableOptions();
        EXISTS = false;
        MapStateService.setActiveModule("");
        //first save the state
        var active_items = verlet_system.getActiveSlugs();

        for (var i = 0; i < active_items.length; i++) {
          var item = getItemBySlug(active_items[i]);
          if (item) {
            MapStateService.setItemState(active_items[i], {
              x: item.sprite.position.x,
              y: item.sprite.position.y
            });
          }
        }

        MapStateService.setActiveItems(active_items);

        PIXI.loader.reset();
        PIXI_gr78_Load_Cache = false;

        $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");
        if (canvas_el) {

          canvas_el.getContext('webgl').getExtension('WEBGL_lose_context').loseContext();
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll); // for Firefox
          canvas_el.removeEventListener('mousewheel', handleScroll); // for everyone else

          // prevent browser from selecting other html text when double clicking the PIXI canvas
          canvas_el.removeEventListener('pointerdown', handleDoubleClick);
        }
        verlet_system.clear();

        if (stage) {
          stage.destroy(true);
          stage = null;
        }
        if (app) {
          app.renderer.destroy(true);
          app.renderer = null;
        }
        modules = [];
        window.removeEventListener("resize", onResize);
      });

      scope.$watch("moduleMapData", function (moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        language.setAvailableOptions(_.get(moduleMapData, ['content', 'available_languages', LocaleService.getUrlVersion()]));
        for (var i = 0; i < moduleMapData.resources.length; i++) {
          switch (moduleMapData.resources[i].slug) {
            case 'mtic_gr78_m2':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapTwo(moduleMapData.resources[i].children);
              break;
            case 'mtic_gr78_m1':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapOne(moduleMapData.resources[i].children);
              break;
            case 'mtic_gr78_m6':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapOne(moduleMapData.resources[i].children);
              break;
          }
        }

        $timeout(function () {
          MapStateService.setCurrentItemLang("");
        }, 1000);

        if (!moduleMapData || EXISTS) {
          return;
        }

        var timer = window.isWebEmbedConnect ? 500 : 0;
        $timeout(function () {
          EXISTS = true;
          init();
        }, timer);
      });

      eventManager.listen('moduleview:agenda:selected', function (e, agenda) {
        for (var i = 0; i < items.length; i++) {
          //items[i].hideAgendaHighlight();
        }
        if (!agenda || !agenda.resources) {
          return;
        }
        switch (interpeteAgendaLockStatus(agenda)) {
          case 'unlock':
            return resourceLockManager.unlock(agenda.resources);
          // case 'lock':
          //   return resourceLockManager.lock(agenda.resources);
          // default:
          //   return resourceLockManager.reset();
        }
      });

      var workspace_list = {};
      var users_list = [];
      scope.$watch('[workspaceData.users, workspaceData.modules]', function (val) {
        var timer = window.isWebEmbedConnect && TeacherDataService.isTeacherWorkspaceView ? 500 : 50;
        //$log.log('workspace data : ' , scope.workspaceData)
        $timeout(function () {
          if (scope.workspaceData && scope.workspaceData.modules.length > 0 && (!scope.currentActiveSubModule || !scope.currentActiveSubModule.children)) {
            workspace_list = {};
            users_list = [];
            scope.workspaceData.users.forEach(function (user) {
              users_list.push(user.user_id);
            });

            scope.workspaceData.modules.forEach(function (work) {
              if (users_list.indexOf(work.user_id) > -1) {
                workspace_list[work.resource_id] = scope.workspaceData.users.length === 1 && (work.completed || workspace_list[work.resource_id]) ? true : false;
              }
            });

            //modules.forEach(function(built_mod){
            //container.removeChild(built_mod.graphics);
            //})

            // modules = [];
            for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
              if ((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) && (scope.moduleMapData.resources[i].id === 923 || scope.moduleMapData.resources[i].id === 955)) {
                //hide these
              } else {
                var module_container = createModuleContainer(scope.moduleMapData.resources[i], true);
                //modules.push(module_container);
              }
            }
          }
        }, timer);
      });

      scope.itemSearchChange = function (val) {
        scope.filteredNameList = [];
        if (!scope.itemsNameList) {
          return;
        }
        if (val.trim() !== '') {
          scope.filteredNameList = scope.itemsNameList.filter(function (name) {
            var nameMod = name.name.toLowerCase();
            var valMod = val.toLowerCase();
            var bool_val;
            try {
              bool_val = nameMod.match(valMod);
            } catch (e) {
              bool_val = false;
            }
            return bool_val;
          });
        }
        // $log.log('scope.filteredNameList', scope.filteredNameList);
      };

      scope.view_controller = {
        isStudentView: true,
        isModulePanelView: true,
        openSubMod: function openSubMod(slug) {
          // $log.log('opening sub mod:', slug)
          $timeout(function () {
            eventManager.broadcast('module:change:submodule', slug);
          }, 1000);
        },
        openMainMod: function openMainMod(slug) {
          eventManager.broadcast('module:change:meta', 'mtic_gr78_m_meta');
        }
      };

      eventManager.listen('sidepanel:toggled', function (e, val) {
        if (!PlatformService.isPhonePortrait()) {
          onResize(val);
        }
      });

      eventManager.listen('hide_item_selection_highlight', function (e, resource) {
        var item = getItemBySlug(resource.slug);
        item.hideAgendaHighlight(true);
      });

      eventManager.listen('toggle_item_selection_highlight', function (e, slug) {
        var item = getItemBySlug(slug);
        item.showAgendaHighlight();
      });

      scope.zoom_function = function (val) {
        handleScroll({ detail: val, preventDefault: function preventDefault() {} });
        zooming = true;
        $timeout(function () {
          zooming = false;
        }, 10);
      };

      eventManager.listen('offline-post-call-resolved', function () {
        if (!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0 || !module_clicked) {
          for (var texture in PIXI.TextureCache) {
            var tmp = PIXI.Texture.removeTextureFromCache(texture);
            tmp.destroy(true);
          }
          eventManager.broadcast('refresh:current:tab');
          eventManager.broadcast('student:cycle:open');
        }
      });

      MapStateService.setItemOptions({ training_mode: true });
      scope.set_rlm_option = function (option, init) {
        if (init) {
          var item_options = MapStateService.getItemOptions();
          if (item_options && item_options.training_mode === false) {
            option = 'challenge';
          }
        }
        scope.rlm_option_selected = option;
        MapStateService.setItemOptions({ training_mode: option === 'training' });
      };
    }
  };
});

var PIXI_gr78_Load_Cache;
var EXISTS;
'use strict';

angular.module('mtic.components.modules.generalModuleMap').directive('lmapSidepanelNodeGeneral', function ($log, language, EventManager, PanelStateService) {
  return {

    template:'<div ng-if="resource.slug !== \'mtic_g78_m1_beaker\' && resource.slug !== \'mtic_g78_m1_prop_table_b\'"><div ng-click="onNodeClick()" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:100%; cursor: pointer; padding: 2px 4px; border-bottom:1px solid #f1f1f1;" ng-style="getStyleModifiers()"><span style="display:inline-block; position:relative; top:3px; margin-right:6px;"><i ng-if="selected" ng-attr-class="fa fa-star" aria-hidden="true"></i> <i ng-attr-class="fa {{getIconCssClasses()}}" aria-hidden="true"></i></span> <span ng-bind="getName()"></span></div><div style="padding-left:20px;" ng-show="resource.isExpanded"><lmap-sidepanel-node ng-repeat="subresource in subresources" resource="subresource" module-map-data="moduleMapData"></lmap-sidepanel-node></div></div>',
    scope: {
      'resource': '=',
      'moduleMapData': '='
    },

    link: function link(scope, element) {
      var eventManager = new EventManager('lmapSidepanelNode', scope);

      scope.selected = false;
      scope.subresources = [];
      scope.databaseResource = {};
      var activeAgenda = null;
      var interpeteAgendaLockStatus = function interpeteAgendaLockStatus() {
        if (activeAgenda.force_unlock === true) {
          return 'unlock';
        } else if (activeAgenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      };
      scope.$watch('resource', function (resource) {
        if (resource) {
          //       $log.debug('[[lmapSidepanelNode]] rendering', scope.resource, resource)
          scope.subresources = resource.sub || [];
          scope.databaseResource = getDbResource(resource.slug);
        }
      });

      eventManager.listen('moduleview:agenda:selected', function (e, agenda) {
        activeAgenda = agenda;
      });
      eventManager.listen('module:select:resource', function (e, data) {
        if (data.slug === scope.resource.slug) {
          scope.selected = true;
        } else {
          scope.selected = false;
        }
      });
      eventManager.listen('module:dismiss:focus', function (e, data) {
        scope.selected = false;
      });

      scope.itemIsLocked = function () {
        var isLocked = scope.databaseResource ? scope.databaseResource.locked : true;
        if (activeAgenda && activeAgenda.resources && scope.databaseResource && activeAgenda.resources.indexOf(scope.databaseResource.id) > -1) {
          switch (interpeteAgendaLockStatus()) {
            case 'unlock':
              return false;
            case 'lock':
              return true;
          }
        }
        return isLocked;
      };
      scope.getName = function () {
        var name;
        // if(scope.resource.slug && scope.resource.slug.indexOf("_m0")>1){
        //   name = language.get(scope.resource.slug+'_short');
        // }else{
        //   name = language.get(scope.resource.slug);
        // }
        name = language.get(scope.resource.slug);

        if (!name) {
          if (scope.databaseResource.name) {
            name = scope.databaseResource.name;
          } else {
            name = scope.resource.slug;
          }
        }
        return name;
      };

      scope.getIconCssClasses = function () {
        var shape = '';
        var color = '';
        if (scope.resource.slug === 'mtic_g78_m1_diag') {
          color = 'color-bubble-icon-assessment';
          shape = 'fa-check-circle';
        } else {
          if (scope.subresources.length > 0) {
            color = 'color-bubble-icon-group';
            shape = 'fa-stop';
          } else {

            color = 'color-bubble-icon-' + (scope.databaseResource.display && scope.databaseResource.display.color ? scope.databaseResource.display.color : 'blue');
            shape = 'fa-circle';
            // var databaseResource = getDbResource(scope.resource.slug);
            if (scope.databaseResource.complete) {
              shape = 'fa-check-circle';
            }
          }
        }
        return shape + ' ' + color;
      };

      scope.onNodeClick = function () {
        if (scope.subresources.length > 0) {
          toggleExpansion();
        } else {
          if (!scope.itemIsLocked()) {
            // var item_evt_info = {
            //   slug : scope.databaseResource.slug,
            //   id : scope.databaseResource.id
            // }
            eventManager.broadcast('module:select:resource', scope.databaseResource);
            eventManager.broadcast('module:center:resource', scope.databaseResource);
          }
        }
      };

      scope.getStyleModifiers = function () {
        if (scope.subresources.length > 0) {
          return {};
        } else {
          return { 'font-weight': 'bold' };
        }
      };

      var toggleExpansion = function toggleExpansion() {
        scope.resource.isExpanded = !scope.resource.isExpanded;
        PanelStateService.setResourceExpanded(scope.resource.slug, scope.resource.isExpanded);
      };

      var getDbResource = function getDbResource(slug, resources) {
        var passedChildren = false;
        if (!resources) {
          if (scope.moduleMapData && scope.moduleMapData.children) {
            resources = scope.moduleMapData.children;
          } else if (scope.moduleMapData && scope.moduleMapData.resources && Array.isArray(scope.moduleMapData.resources)) {
            resources = scope.moduleMapData.resources;
          } else {
            $log.warn('[[lmapSidepanelNode]] MISSING CHILDREN FOR `moduleMapData`');
            resources = [];
          }
        } else {
          passedChildren = true;
        }

        for (var i = 0; i < resources.length; i++) {
          var resource = resources[i];
          if (resource.slug === slug) {
            return resource;
          }
          if (resource.children && resource.children.length > 0) {
            resource = getDbResource(slug, resource.children);
            if (resource) {
              return resource;
            }
          }
        }
        if (passedChildren) {
          return false;
        } else {
          $log.warn("[[lmapSidepanelNode]] Could not find databaseResource for ", slug, scope);
          return {};
        }
      };

      if (scope.resource && !language.get(scope.resource.slug)) {
        $log.warn('No text defined for ', scope.resource.slug);
      }

      if (scope.resource && PanelStateService.getResourceExpanded(scope.resource.slug)) {
        toggleExpansion();
      }
    }
  };
});
'use strict';

angular.module('mtic.components.modules.generalModuleMap').directive('lmapSidepanelAgendaGeneral', function ($log, $q, language, EventManager, StudentDataService, PanelStateService, $timeout) {
  return {

    template:'<div><div ng-hide="loadingStatus.done">Loading ...</div><div ng-show="loadingStatus.done" ng-if="loadingStatus.error">An Error has occured!</div><div ng-show="loadingStatus.done" ng-if="!loadingStatus.error"><button ng-hide="true" type="button" class="button" ng-click="refresh()"><i class="fa fa-refresh" aria-hidden="true"></i></button><div class="studentSidebarAgendaUnit" ng-repeat="agenda in agendas track by $index"><div class="studentSidebarAgendaUnit__monthAndYear" ng-show="isNewAgendaMonth($index)"><span class="studentSidebarAgendaUnit__monthAndYearText" ng-bind="moment(agenda.date_close).format(\'YYYY MMMM\')"></span></div><div class="studentSidebarAgendaUnit__overviewInfo"><div class="studentSidebarAgendaUnit__overviewDays"><div class="studentSidebarAgendaUnit__overviewCalendarDay" ng-bind="moment(agenda.date_close).format(\'DD\')"></div><div class="studentSidebarAgendaUnit__overviewWeekDay" ng-bind="moment(agenda.date_close).format(\'ddd\')"></div></div><div class="studentSidebarAgendaUnit__nameAndProgress"><div class="studentSidebarAgendaUnit__name" ng-bind="language.get(agenda.description)"></div><div class="studentSidebarAgendaUnit__progressBar"><div class="studentSidebarAgendaUnit__progressBarFill" ng-style="{\'width\':agenda.progress.prop*100+\'%\'}"></div></div></div></div><teacher-students-agenda-perf-preview module-map="moduleMapData" filtered-resources="agenda.resources" view-controller="view_controller" agenda-progress-map="agenda.resource_progress_map"></teacher-students-agenda-perf-preview></div></div></div>',
    scope: {
      'moduleMapData': '='
    },

    link: function link(scope, element) {
      var eventManager = new EventManager('lmapSidepanelAgendaNode', scope);
      moment.locale(language.getCurrentSelectedLanguage());
      scope.language = language;
      var selectedResourceId = -1;
      var studentAgendaItemHashMap = {};
      scope.loadingStatus = {
        done: false,
        error: false
      };
      scope.agendas = [];
      scope.active_agenda = {};
      scope.databaseResource = {};
      scope.resourceMapping = {};
      scope.agenda_progress = {
        total: 0,
        score: 0
      };

      scope.moment = moment;

      scope.getName = function (resourceId) {
        var name = '#(N/A)';
        if (scope.resourceMapping[resourceId]) {
          var resource = scope.resourceMapping[resourceId];
          // if(resource.slug && (resource.slug.indexOf("_m0")>1||resource.slug.indexOf("_m4")>1)){
          //   name = language.get(resource.slug+'_short');
          // }else{
          //   name = language.get(resource.slug);
          // }
          name = language.get(resource.slug);

          if (!name) {
            if (resource.name) {
              name = resource.name;
            } else {
              name = resource.slug;
            }
          }
        }
        return name;
      };
      scope.getIconCssClasses = function (resourceId) {
        var shape = '';
        var color = '';
        var resource = scope.resourceMapping[resourceId];
        if (resource) {
          color = 'color-bubble-icon-' + (resource.display.color ? resource.display.color : 'blue');
          if (resourceIsComplete(resourceId)) {
            shape = 'fa-check-circle';
          } else {
            shape = 'fa-circle-o';
          }
        }
        return shape + ' ' + color;
      };
      scope.selectAgenda = function (agenda) {
        // scope.active_agenda = agenda;
        if (agenda && agenda.id) {
          eventManager.broadcast('moduleview:agenda:selected', agenda);
          PanelStateService.setActiveAgenda(agenda.id);
        }
      };
      scope.onNodeClick = function (resourceId) {
        var resource = scope.resourceMapping[resourceId];
        var isLocked = isThisResourceLocked(resource);
        $log.debug('[[lmapSidepanelAgenda]] onNodeClick', resource, resourceId, isLocked);
        if (!isLocked && selectedResourceId === Number(resource.id)) {
          eventManager.broadcast('module:open:resource', resource);
        } else if (resource) {
          // var item_evt_info = {
          //   slug : resource.slug,
          //   id : resource.id
          // }
          eventManager.broadcast('module:select:resource', resource);
          eventManager.broadcast('module:center:resource', resource);
        }
      };
      scope.isSelected = function (resourceId) {
        return selectedResourceId === Number(resourceId);
      };
      scope.refresh = function () {
        eventManager.broadcast('agendapanel:refresh');
      };
      var isThisResourceLocked = function isThisResourceLocked(resource) {
        var isLocked = resource.locked;
        switch (interpeteAgendaLockStatus()) {
          case 'unlock':
            return false;
          case 'lock':
            return true;
          default:
            return isLocked;
        }
      };
      var interpeteAgendaLockStatus = function interpeteAgendaLockStatus() {
        if (scope.active_agenda.force_unlock === true) {
          return 'unlock';
        } else if (scope.active_agenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      };
      var resourceIsComplete = function resourceIsComplete(resourceId) {
        var mapResource = scope.resourceMapping[resourceId];
        var studentAgendaItemResource = studentAgendaItemHashMap[resourceId];
        return studentAgendaItemResource && studentAgendaItemResource.resource_completed || mapResource.resourceState && mapResource.resourceState.complete;
      };
      var placeCustomInMap = function placeCustomInMap(resource) {
        var parent_slug = resource.content.position_data.parent_slug;
        var index = Number(resource.content.position_data.index);
        // $log.log('scope.modulemapdata : ' , scope.moduleMapData)
        if (parent_slug === scope.moduleMapData.slug) {
          scope.moduleMapData.resources.splice(index, 0, resource);
          return;
        }

        scope.moduleMapData.resources.forEach(function (sub_mod) {

          if (sub_mod.display && sub_mod.display.panel) {
            if (sub_mod.slug === parent_slug) {
              sub_mod.display.panel.splice(index, 0, resource);
              return;
            }
            sub_mod.display.panel.forEach(function (sub) {
              checkResourceAndInsert(sub, resource);
            });
          }
        });
      };
      var checkResourceAndInsert = function checkResourceAndInsert(sub, resource) {
        if (sub.sub) {
          if (sub.slug === resource.content.position_data.parent_slug) {
            sub.sub.splice(Number(resource.content.position_data.index), 0, resource);
          } else {
            sub.sub.forEach(function (sub_sub) {
              checkResourceAndInsert(sub_sub, resource);
            });
          }
        }
      };
      var checkIfResourcesAreInMapElseAttemptToGrab = function checkIfResourcesAreInMapElseAttemptToGrab(agendaData) {
        return $q.all(agendaData.map(function (agenda) {
          return $q.all(agenda.resources.map(function (resourceId) {
            if (!scope.resourceMapping[resourceId]) {
              // $log.log('lmap get custom : ', resourceId)
              return StudentDataService.getCustomResource(resourceId).then(function (resource) {
                scope.resourceMapping[resourceId] = resource;
                if (resource.content && resource.content.position_data) {
                  placeCustomInMap(resource);
                }
                // $log.log('mapping custom : ', resource)
                return;
              });
            } else {
              return $q.resolve();
            }
          }));
        })).then(function () {
          return agendaData;
        });
      };
      var calcProgress = function calcProgress(agenda) {
        agenda.progress = {};
        agenda.progress.total = 0;
        agenda.progress.score = 0;
        agenda.resource_progress_map = {};
        studentAgendaItemHashMap = {};
        agenda.StudentAgendaItems.forEach(function (studentAgendaItem) {
          studentAgendaItemHashMap[studentAgendaItem.resource_id] = studentAgendaItem;
        });
        agenda.resources.forEach(function (resourceId) {
          var resource = scope.resourceMapping[resourceId];
          if (resource && resource.display) {
            if (resource.resource_type === "custom_resource") {
              agenda.progress.score = studentAgendaItemHashMap[resourceId] ? agenda.progress.score + 1 : agenda.progress.score;
              agenda.resource_progress_map[resource.slug] = studentAgendaItemHashMap[resourceId] ? true : false;
            } else if (!agenda.force_redo || agenda.force_redo && studentAgendaItemHashMap[resource.id]) {
              agenda.progress.score += resource.complete ? 1 : 0;
              agenda.resource_progress_map[resource.slug] = resource.complete;
              if (resource.config && resource.config.assessment_type && !resource.complete && agenda.force_unlock) {
                if (force_unlocked_list.indexOf(resource.slug) === -1) {
                  force_unlocked_list.push(resource.slug);
                }
                resource.locked = false;
                eventManager.broadcast('unlock-item', resource.slug);
              }
            } else {
              agenda.resource_progress_map[resource.slug] = false;
              if (resource.config && resource.config.assessment_type && (agenda.force_redo && resource.complete || agenda.force_unlock)) {
                if (force_unlocked_list.indexOf(resource.slug) === -1) {
                  force_unlocked_list.push(resource.slug);
                }
                resource.locked = false;
                eventManager.broadcast('unlock-item', resource.slug);
              }
            }

            agenda.progress.total++;
          }
        });
        agenda.progress.prop = agenda.progress.score / agenda.progress.total;
        // $log.log('agenda progress : ', agenda, studentAgendaItemHashMap)//, scope.resourceMapping)
      };

      scope.dotifyUnitName = function dotifyUnitName() {
        var overviewDays = document.querySelector(".studentSidebarAgendaUnit__overviewDays");
        var unitNames = document.querySelectorAll(".studentSidebarAgendaUnit__name");

        if (!overviewDays || !unitNames) {
          return;
        }

        var overviewDaysWidth = overviewDays.clientWidth;

        for (var i = 0; i < unitNames.length; i++) {
          if (unitNames[i].clientHeight >= unitNames[i].scrollHeight) {
            unitNames[i].style.overflow = 'hidden';
            unitNames[i].style.textOverflow = 'ellipsis';
            unitNames[i].style.width = unitNames[i].clientWidth - overviewDaysWidth + "px";

            continue;
          }
          var limit = unitNames[i].offsetTop + unitNames[i].offsetHeight;
          var dots = document.createElement('span');
          if (unitNames[i]['data-inner']) {
            unitNames[i].innerHTML = unitNames[i]['data-inner'];
          } else {
            unitNames[i]['data-inner'] = unitNames[i].innerHTML;
          }
          dots.appendChild(document.createTextNode('...'));
          unitNames[i].style.overflow = 'hidden';
          unitNames[i].appendChild(dots);
          while (dots.offsetTop + dots.offsetHeight > limit) {
            dots.previousSibling.data = dots.previousSibling.data.replace(/\W*\w+\W*$/, '');
          }
        }
      };

      var init = function init() {
        scope.resourceMapping = {};
        scope.loadingStatus.done = false;
        scope.loadingStatus.error = false;
        return $q.all([$q(function (resolve) {
          scope.moduleMapData.resources.forEach(function (moduleMap) {
            moduleMap.children.forEach(function (resource) {
              scope.resourceMapping[resource.id] = angular.copy(resource);
              if (resource.children) {
                resource.children.forEach(function (sub) {
                  scope.resourceMapping[sub.id] = angular.copy(sub);
                });
              }
            });
          });
          resolve();
        }), StudentDataService.getAgendas()]).then(function (datas) {
          return checkIfResourcesAreInMapElseAttemptToGrab(datas[1]);
        }).then(function (agendaData) {
          eventManager.broadcast('moduleview:agenda:loaded', agendaData);
          scope.agendas = agendaData;
          scope.agendas.sort(dateSort);
          // $log.log('got agendas : ', agendaData)
          scope.agendas.forEach(function (agenda) {
            calcProgress(agenda);
          });
          var active_agenda_index = 0;
          if (PanelStateService.getActiveAgenda() !== undefined) {
            var target_id = PanelStateService.getActiveAgenda();
            for (var i = 0; i < agendaData.length; i++) {
              if (agendaData[i].id === target_id) {
                active_agenda_index = i;
                break;
              }
            }
          }

          scope.active_agenda = agendaData[active_agenda_index];
          sendSummInfo();

          eventManager.broadcast('moduleview:agenda:selected', agendaData[active_agenda_index]);
        }).then(function () {
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = false;

          angular.element(document).ready(function () {
            $timeout(function () {
              scope.dotifyUnitName();
            }, 100);
          });
        }).catch(function (err) {
          $log.error(err);
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = true;
        });
      };

      function dateSort(a, b) {
        if (Date.parse(a.date_close) < Date.parse(b.date_close)) {
          return -1;
        }
        if (Date.parse(a.date_close) > Date.parse(b.date_close)) {
          return 1;
        }
        return 0;
      }

      eventManager.listen('agendapanel:refresh', function () {
        init();
      });

      eventManager.listen('module:select:resource', function (e, resource) {
        selectedResourceId = Number(resource.id);
      });

      eventManager.listen('module:dismiss:focus', function (e, data) {
        selectedResourceId = -1;
      });
      //There must be a better way :thinking:
      eventManager.listen('moduleview:agenda:request', function (e) {
        eventManager.broadcast('moduleview:agenda:selected', scope.active_agenda);
      });

      eventManager.listen('moduleview:agenda:selected', function (e, agenda) {
        if (agenda && agenda !== null && 'StudentAgendaItems' in agenda && 'resources' in agenda) {
          calcProgress(agenda);
        }
      });

      eventManager.listen('creating-items-done', function () {
        scope.agendas.forEach(function (agenda) {
          calcProgress(agenda);
        });
      });

      var lockedSummativeList = [];
      var force_unlocked_list = [];
      scope.$watch("moduleMapData", function () {
        init();
      });

      function sendSummInfo() {
        // if(scope.moduleMapData.module_id === 28 || scope.moduleMapData.module_id === 2 || scope.moduleMapData.module_id === 321){
        var unlockedSummativeList = [];
        scope.agendas.forEach(function (agenda) {
          agenda.resources.forEach(function (summ) {
            unlockedSummativeList.push(scope.resourceMapping[summ].slug);
          });
        });
        $timeout(function () {
          eventManager.broadcast('got-c4-summative-data', { unlocked: unlockedSummativeList, force_unlock: force_unlocked_list });
        }, 500);
        // }        
      }

      scope.isReleventDiagLocked = function (resc) {
        //console.log('should hide : ', scope.resourceMapping[resc].slug, lockedSummativeList.indexOf(scope.resourceMapping[resc].slug));
        return lockedSummativeList.indexOf(scope.resourceMapping[resc].slug) > -1;
      };

      // var dayRef = ['SUN','MON','TUE','WED','THU','FRI','SAT']
      // scope.getFormattedDateDay = function(date){
      //   var day = (new Date(Date.parse(date))).getDay()
      //   return dayRef[day]
      // }
      // scope.getFormattedDateDayNum = function(date){
      //   var day = (new Date(Date.parse(date))).getDate()
      //   return day;
      // } 
      // var monthRef = ['January','February','March','April','May','June','July',
      // 'August','September','October','November','December']
      // scope.getFormattedDateMonth = function(date){
      //   var date_parse = new Date(date);
      //   return date_parse.getFullYear() + ' ' + monthRef[date_parse.getMonth()];
      // }
      scope.getFormattedFullDate = function (date) {
        return date.split('T')[0].split('-').join('/');
      };
      scope.isNewAgendaMonth = function (index) {
        if (index === 0) {
          return true;
        }
        var date1 = new Date(Date.parse(scope.agendas[index].date_close));
        var date2 = new Date(Date.parse(scope.agendas[index - 1].date_close));
        return date1.getFullYear() !== date2.getFullYear() || date1.getMonth() !== date2.getMonth();
      };

      scope.view_controller = {
        isStudentView: true,
        openSubMod: function openSubMod(slug) {
          // $log.log('opening sub mod:', slug)
          $timeout(function () {
            eventManager.broadcast('module:change:submodule', slug);
          }, 1000);
        },
        openMainMod: function openMainMod(slug) {
          eventManager.broadcast('module:change:meta', 'mtic_gr78_m_meta');
        }
      };
    }
  };
});
'use strict';

angular.module('mtic.components.modules.generalModuleMap').directive('lmapBottomPanelGeneral', function ($log, language, EventManager, DEV_VARIABLES, TeacherDataService, ModuleFilter, MapStateService) {
  return {

    template:'<div class="lmapBottomPanel"><div class="lmapBottomPanel__leftSide"><div class="lmapBottomPanel__starsWrap" ng-show="hasActiveItem()"><img ng-if="getMaxStarCount() > 0" class="lmapBottomPanel__star" ng-class="{\'lmapBottomPanel__star--disabled\': getCompleteStarCount() <= 0 }" src="assets/images/c3-module/star.png"> <img ng-if="getMaxStarCount() > 1" class="lmapBottomPanel__star" ng-class="{\'lmapBottomPanel__star--disabled\': getCompleteStarCount() <= 1 }" src="assets/images/c3-module/star.png"> <img ng-if="getMaxStarCount() > 2" class="lmapBottomPanel__star" ng-class="{\'lmapBottomPanel__star--disabled\': getCompleteStarCount() <= 2 }" src="assets/images/c3-module/star.png"></div><div class="lmapBottomPanel__moduleName"><div ng-show="hasActiveItem()" class="lmapBottomPanel__moduleNameText" ng-bind="getName()"></div><div ng-hide="hasActiveItem()" class="lmapBottomPanel__moduleNameText lmapBottomPanel__moduleNameText--disabled" ng-bind="getTranslation(\'14576\')">NO ITEM SELECTED</div></div></div><div class="lmapBottomPanel__rightSide" ng-style="{\'margin-right\': isLeaderboardAvailable() ? \'200px\': \'0px\'}"><button ng-if="!itemIsLocked()" type="button" class="button is-large is-primary" ng-click="itemClicked()" ng-show="hasActiveItem()" style="font-weight:600" ng-bind="getTranslation(\'start_item\')">START</button> <button ng-if="itemIsLocked()" ng-show="hasActiveItem()" ng-click="itemClickedTeacherCheck()" type="button" class="button is-large is-primary" style="font-weight:600"><i class="fa fa-lock" aria-hidden="true"></i></button></div></div>',
    scope: {
      'moduleMapData': '='
    },

    link: function link(scope, element) {
      scope.highlightedResource = {};
      scope.activeResource = {};
      var eventManager = new EventManager('lmapBottomPanel', scope);
      var activeAgenda = null;
      var interpeteAgendaLockStatus = function interpeteAgendaLockStatus() {
        if (activeAgenda.force_unlock === true) {
          return 'unlock';
        } else if (activeAgenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      };
      scope.itemIsLocked = function () {
        var isLocked = scope.highlightedResource.locked;
        if (activeAgenda && activeAgenda.resources && !(scope.highlightedResource.config && scope.highlightedResource.config.assessment_type && scope.highlightedResource.complete) && activeAgenda.resources.indexOf(scope.highlightedResource.id) > -1) {
          switch (interpeteAgendaLockStatus()) {
            case 'unlock':
              return false;
            case 'lock':
              return isLocked;
          }
        }
        return isLocked;
      };
      scope.itemClickedTeacherCheck = function () {
        if (TeacherDataService.isTeacherModuleView) {
          scope.itemClicked();
        }
      };
      scope.itemClicked = function () {
        if (!ModuleFilter.checkAvailable(scope.highlightedResource)) {
          scope.highlightedResource.locked = true;
          eventManager.broadcast('display-maintenance-message', scope.highlightedResource.slug);
          return;
        }
        if (!scope.itemIsLocked() || TeacherDataService.isTeacherModuleView) {
          eventManager.broadcast('module:open:resource', scope.highlightedResource);
        }
      };
      scope.dismissClicked = function () {
        eventManager.broadcast('module:dismiss:focus');
      };
      scope.isCustomResource = function () {
        return scope.highlightedResource.resource_type === 'custom_resource';
      };
      eventManager.listen('module:select:resource', function (e, resource) {
        $log.log('from bottom panel : ', resource);
        if (DEV_VARIABLES.RESOURCES.HIDE_THESE.indexOf(resource.slug) > -1 || resource.config && resource.config.hidden === true) {
          return;
        }

        scope.activeResource = resource;

        if (scope.moduleMapData === undefined || !scope.moduleMapData.children) {
          return;
        }
        var item_info = null;
        // $log.log('select resource : ', resource, scope.moduleMapData)
        for (var i = 0; i < scope.moduleMapData.children.length; i++) {
          if (scope.moduleMapData.children[i].slug === resource.slug) {
            item_info = scope.moduleMapData.children[i];
            break;
          }
        }
        //If this item is already focused on, open it

        if (scope.highlightedResource && !TeacherDataService.isTeacherWorkspaceView && (scope.highlightedResource.slug === item_info.slug || resource.map_config && resource.map_config.single_click_open) && (item_info.locked === false || scope.highlightedResource.config && scope.highlightedResource.config.assessment_type === 'summative' && !scope.itemIsLocked())) {
          eventManager.broadcast('module:open:resource', resource);
          return;
        } else {
          scope.highlightedResource = item_info;
        }
      });
      eventManager.listen('moduleview:agenda:selected', function (e, agenda) {
        activeAgenda = agenda;
      });
      eventManager.listen('module:dismiss:focus', function (e, data) {
        scope.highlightedResource = {};
      });

      scope.getTranslation = function (slug) {
        var caption = language.get(slug);
        if (!caption) {
          caption = slug;
        }
        return caption;
      };

      scope.getCompleteStarCount = function () {
        var resource = scope.highlightedResource;
        if (resource.resourceState) {
          if (resource.display.color === 'blue') {
            return Math.floor(resource.resourceState.score_max);
          }
          if (resource.resourceState.score_max >= 1) {
            return 3;
          } else if (resource.resourceState.score_max >= 0.8) {
            return 2;
          } else if (resource.resourceState.score_max >= 0.5) {
            return 1;
          }
          return 0;
        } else {
          return 0;
        }
      };

      scope.getMaxStarCount = function () {
        var resource = scope.highlightedResource;
        if (resource) {
          if (resource.resource_type === "assessment") {
            // console.log('getMaxStarCount', 3)
            return 0;
          } else if (resource.display) {
            if (resource.display.color === 'blue') {
              // console.log('getMaxStarCount', 1)
              return 1;
            } else {
              // console.log('getMaxStarCount', 3)
              return 3;
            }
          }
        }
        // console.log('getMaxStarCount', '0 (default)')
        return 0;
      };

      scope.getName = function () {
        var resource = scope.highlightedResource;
        var name;
        var resourceSlug = resource.slug;
        if (!resourceSlug || resourceSlug === 'run_like_math' || resourceSlug.indexOf('run_like_math') === -1 || resourceSlug.indexOf('lv_') === -1) {
          name = language.get(resourceSlug);
        } else {
          var splt = resourceSlug.split('_');
          var level = '';
          if (!isNaN(splt[splt.length - 1])) {
            level = splt[splt.length - 1];
          }
          var trans_slug = resourceSlug.replace('_' + level, '');
          name = language.get(trans_slug) + ' ' + level;
        }
        if (!name) {
          if (resource.name) {
            name = resource.name;
          } else {
            name = resource.slug;
          }
        }
        return name;
      };

      scope.isLeaderboardAvailable = function () {
        // $log.log('isLeaderboardAvailable', MapStateService.isLeaderboardAvailable)
        return MapStateService.isLeaderboardAvailable;
      };

      eventManager.listen('language:change', function () {
        $log.debug(scope.highlightedResource);
      });

      scope.hasActiveItem = function () {
        return true && scope.highlightedResource && scope.highlightedResource.name;
      };
      scope.$watch('moduleMapData', function () {
        if (scope.moduleMapData === undefined) {
          return;
        }

        // $log.log('MMD : ', scope.moduleMapData)

        if (scope.activeResource !== undefined) {
          var item_info = null;
          if (scope.moduleMapData.children) {
            for (var i = 0; i < scope.moduleMapData.children.length; i++) {
              if (scope.moduleMapData.children[i].slug === scope.activeResource.slug) {
                scope.highlightedResource = scope.moduleMapData.children[i];
                return;
              }
            }
          }
        }
      });
      scope.$on('$destroy', function () {
        eventManager.broadcast('module:dismiss:focus');
      });
    }
  };
});
'use strict';

/*
  The purpose of the LEARNING MAP is to contain the logic to display a Verlet enabled map
  With mouse navigation and not much else.

  It is different from the meta-map because it does not handle the entire
  meta module structure on its own, it just displays an array of resources.
  It does absolutely no post-processing on the structure of the resources.
  something else has to explicitely tell this what to show

  It also doesn't provide functions for the side and bottom panels like the meta map does.
*/

angular.module('mtic.components.modules.generalModuleMap').directive('learningMapGeneral', function (DEV_VARIABLES, GR78_ASSET_URL, $q, $timeout, TIMING_CONSTANTS, $log, $window, gr78MapItemFactory, VerletSystemService, TeacherDataService, learningMapUtil, PIXI, EventManager, language) {

  return {

    template:'<div class="inner-viewport" style="overflow:hidden;"><canvas id="canvas" width="300" height="300"></canvas></div>',
    scope: {
      moduleMapData: "="
    },
    link: function link(scope) {

      // event manager for coordination with rest of application
      var eventManager = new EventManager('gr78LearningMap', scope);
      var verlet_system = new VerletSystemService();
      ///////////////////
      // PRIVATE VARS //
      /////////////////

      var canvas_el = null;
      var app = null;
      var renderer = null;
      var drag_info = null;
      var canvasDimensions = null;
      var scale = null;
      var stage = null;
      var modules_container = null;
      var container = null;
      var lines_graphic = null;
      var selection_graphic = null;
      var items = [];
      var isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);

      var img_asset_paths = [GR78_ASSET_URL + "symlink.png", GR78_ASSET_URL + "item_blue_0.png", GR78_ASSET_URL + "item_blue_1.png", GR78_ASSET_URL + "item_red_0.png", GR78_ASSET_URL + "item_red_1.png", GR78_ASSET_URL + "item_red_2.png", GR78_ASSET_URL + "item_red_3.png", GR78_ASSET_URL + "item_black_0.png", GR78_ASSET_URL + "item_black_1.png", GR78_ASSET_URL + "item_black_2.png", GR78_ASSET_URL + "item_black_3.png", GR78_ASSET_URL + "item_blue_locked.png", GR78_ASSET_URL + "item_red_locked.png", GR78_ASSET_URL + "item_black_locked.png", GR78_ASSET_URL + "assessment.png", GR78_ASSET_URL + "assessment_complete.png", GR78_ASSET_URL + "selection.png"];
      var focus_item = null;
      var selection = null;

      /////////////
      // CONSTRUCTOR
      /////////////

      function init() {
        // retrieve template element references
        canvas_el = document.getElementById('canvas');
        if (!canvas_el) {
          return;
        }

        app = new PIXI.Application(300, 300, {
          autoResize: true,
          backgroundColor: 0xdee9fc,
          antialias: true,
          view: canvas_el
        });

        renderer = app.renderer;
        scale = 0.8;
        items = [];
        drag_info = learningMapUtil.getDragInfoSettings();

        canvasDimensions = {
          width: window.innerWidth,
          height: window.innerHeight - 50
        };

        stage = app.stage;
        stage.interactive = true;

        window.addEventListener("resize", onResize);
        onResize();
        renderer.render(stage);

        container = new PIXI.Sprite();
        container.interactive = true;
        container.scale.set(scale, scale);
        container.x = renderer.width / 2;
        container.y = renderer.height / 2;
        stage.addChildAt(container, 0);

        lines_graphic = new PIXI.Graphics();
        container.addChild(lines_graphic);

        app.ticker.add(update);

        canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else
        canvas_el.addEventListener('pointerdown', handleDoubleClick, false);

        stage.on('pointerdown', function (e) {
          drag_info.dragging = true;
          focus_item = null;
          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: container.x,
            y: container.y
          };
          drag_info.start_drag_mouse_pos = {
            x: renderer.plugins.interaction.eventData.data.global.x,
            y: renderer.plugins.interaction.eventData.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };
        });
        stage.on('pointerup', function (e) {
          if (window.DEBUG_TOUCH) {
            $log.log('g78_lmap pointerup ; ', JSON.stringify(drag_info));
          }
          drag_info.dragging = false;
        });

        if (window.DEBUG_TOUCH) {
          $log.log('g78_lmap pointerdown ; ', JSON.stringify(drag_info));
        }

        return loadAssets().then(function () {
          $log.debug('[[gr78MetaMap]] loadAssets.then');
          return;
        }).catch(function (err) {
          $log.error('[[gr78MetaMap]] loadAssets.then', err.message);
          $log.debug(err.stack);
        });
      }

      eventManager.listen('module:select:resource', function (e, data) {
        var mapResource = getItemBySlug(data.slug);
        if (mapResource === null) {
          return;
        }
        if (selection === mapResource) {
          eventManager.broadcast('module:open:resource', data);
          return;
        }
        selection = mapResource;
        mapResource.sprite.addChildAt(selection_graphic, 0);
        selection_graphic.scale.set(0);
      });

      eventManager.listen('module:center:resource', function (e, data) {
        focus_item = getItemBySlug(data.slug);
      });

      eventManager.listen('module:stop:pan', function () {
        focus_item = null;
      });

      eventManager.listen('resource:highlight:agenda', function (e, data) {
        $log.debug(data);
        var i, n, item;
        for (i = 0; i < items.length; i++) {
          item = items[i];
          item.hideAgendaHighlight();
          for (n = 0; n < data.length; n++) {
            if (item.slug === data[n].slug) {
              item.showAgendaHighlight();
              break;
            }
          }
        }
      });

      eventManager.listen('module:change:submodule', function (e, data) {
        $timeout(function () {
          verlet_system.deactivateAllBodies(true);
          $log.debug(data);
          $log.debug(scope);
          for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
            if (scope.moduleMapData.resources[i].slug === data) {
              scope.currentActiveSubModule = scope.moduleMapData.resources[i];
              var resource = scope.moduleMapData.resources[i];
              for (var n = 0; n < resource.children.length; n++) {

                if (resource.children[n].slug === 'mtic_g78_m1_beaker' || resource.children[n].slug === 'mtic_g78_m1_prop_table_b') {
                  continue;
                }

                verlet_system.activateBody(resource.children[n].slug, true);
              }
              break;
            }
          }
        }, TIMING_CONSTANTS.INSTANT);
      });
      /////////////
      // METHODS
      /////////////

      //Mousewheel zoom/in out at cursor position (like google maps)
      var handleScroll = function handleScroll(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = evt.detail < 0 || evt.wheelDelta > 0 ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.5, scale + direction / 15), 0.25);
        var diff = scale - start_scale;
        container.scale.set(scale, scale);

        //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
        var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
        container.position.x -= diff * pos.x;
        container.position.y -= diff * pos.y;

        evt.preventDefault();
        return false;
      };

      var handleDoubleClick = function handleDoubleClick(e) {
        e.preventDefault();
        return false;
      };

      var initMapDraw = function initMapDraw(moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        var combinedResourceMap = {};

        _.forEach(moduleMapData, function (someItem) {
          combinedResourceMap[someItem.slug] = someItem;
          loadChildren(someItem);
        });

        _.each(combinedResourceMap, function (resource) {
          createItem(resource, null);
        });
        _.forEach(items, function (item) {
          if (!item.locked) {
            item.unlock();
          }
        });
      };

      //This loops to control things that should update every frame
      var update = function update() {
        if (selection_graphic !== null) {
          //Rotate it a little bit
          selection_graphic.rotation = (selection_graphic.rotation - 0.015) % (Math.PI * 2);

          //Use UNIX time to scale the graphic with a sin function
          //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
          selection_graphic.scale.set((selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / 10);
        }

        //update the verlet force directed graph that positions the map items in that big jiggly web
        verlet_system.update();
        //   drawMapLines();
        if (drag_info.dragging) {
          var mouse_pos = {
            x: renderer.plugins.interaction.eventData.data.global.x,
            y: renderer.plugins.interaction.eventData.data.global.y
          };
          if (isNaN(mouse_pos.x) || isNaN(mouse_pos.y) || isMobile && renderer.plugins.interaction.eventData.data.identifier === 'MOUSE') {
            mouse_pos.x = drag_info.last_mouse_pos.x;
            mouse_pos.y = drag_info.last_mouse_pos.y;
          }

          //Move the map based on the mouse position
          container.position.x = drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
          container.position.y = drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);

          //vector of mouse movement since last update frame
          var delta_pos = {
            x: drag_info.last_mouse_pos.x - mouse_pos.x,
            y: drag_info.last_mouse_pos.y - mouse_pos.y
          };

          //add the mouse movement vector to the map movement velocity (inertia)
          drag_info.velocity = {
            x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
            y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
          };

          //store the current position in the last_mouse_pos to calculate the movement vector next frame
          drag_info.last_mouse_pos = {
            x: mouse_pos.x,
            y: mouse_pos.y
          };
        } else {
          //If they're not dragging, move the map based on its inertia and damp the inertia
          container.position.x -= drag_info.velocity.x;
          container.position.y -= drag_info.velocity.y;
          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;
        }
        focusItemTicker();

        lines_graphic.clear();
        lines_graphic.lineStyle(8, 0xCCCCDD, 1);
        var segments = verlet_system.getLineSegments();
        var i;
        for (i = 0; i < segments.solid.length; i++) {
          lines_graphic.moveTo(segments.solid[i].start.x, segments.solid[i].start.y);
          lines_graphic.lineTo(segments.solid[i].end.x, segments.solid[i].end.y);
        }
        lines_graphic.beginFill(0xFF0000, 1);
        for (i = 0; i < segments.dash.length; i++) {
          lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
        }
        lines_graphic.endFill();

        if (window.DEBUG_TOUCH) {
          $log.log('g78_lmap update ; ', JSON.stringify(drag_info));
        }
      };

      /**
       *Expand a subgroup to reveal child items
       *slug is a unique String that identifies the group MapItem
       **/
      var expandGroup = function expandGroup(slug) {
        if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(slug) > -1) {
          return;
        }
        //Cancel this mouse event if they were dragging more than 10 pixels
        if (drag_info.dragging) {
          if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
            return;
          }
        }

        if (verlet_system.deactivateBody(slug, true)) {
          var group = getItemBySlug(slug);
          //position all of the sub items so that they appear from where the clicked group icon is
          for (var i = 0; i < items.length; i++) {
            if (items[i].parentItem === group) {
              items[i].sprite.position.x = group.sprite.position.x;
              items[i].sprite.position.y = group.sprite.position.y;
              verlet_system.activateBody(items[i].slug, true);
            }
          }
        }
      };

      /**
       *Collapse a subgroup to hide child items
       *slug is a unique String that identifies the group MapItem
       **/
      var collapseGroup = function collapseGroup(slug) {
        var group = getItemBySlug(slug);
        if (group.isExpanded === true) {
          toggleGroupExpanded(group);
        }
      };

      /**
       *Toggle the expand/collapse of a given item group
       *group is a MapItem
       **/
      var toggleGroupExpanded = function toggleGroupExpanded(group) {
        group.isExpanded = !group.isExpanded;
        //    baseVerletSystem.hookUpConstraints();
      };

      //If focus item is defined, pan towards it
      var focusItemTicker = function focusItemTicker() {
        if (focus_item === null) {
          return;
        }
        var abs_pos = container.toGlobal(focus_item.sprite.position);
        container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
        container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
      };

      /**
       *Return a MapItem whose slug matches the passed slug
       *Returns null if no MapItem can be found
       */
      var getItemBySlug = function getItemBySlug(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      };

      var getItemById = function getItemById(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      };

      var onResize = function onResize() {
        canvasDimensions = {
          width: window.innerWidth,
          height: window.innerHeight - 52
        };
        stage.hitArea = new PIXI.Rectangle(0, 0, canvasDimensions.width, canvasDimensions.height);
        if (!document.getElementById('canvas')) {
          return;
        }
        document.getElementById('canvas').width = canvasDimensions.width;
        document.getElementById('canvas').height = canvasDimensions.height;

        renderer.resize(canvasDimensions.width, canvasDimensions.height);
      };

      // scope.$watch("moduleMapData", function (moduleMapData) {

      //this is what runs to initialize the map
      var loadAssets = function loadAssets() {
        $log.debug('[[gr78MetaMap]] loadAssets');
        return $q(function (resolve, reject) {
          try {
            if (!PIXI_gr78_Load_Cache) {
              PIXI.loader.reset();
              PIXI.loader.add(img_asset_paths).load(function () {
                // $log.debug('loaded resources', PIXI.loader.resources)
                PIXI_gr78_Load_Cache = true;
                initMap(resolve);
              });
            } else {
              initMap(resolve);
            }
          } catch (err) {
            $log.error('[[gr78MetaMap]]', err);
            reject(err);
          }
        });
      };

      var initMap = function initMap(resolve) {
        initMapDraw(scope.moduleMapData);

        $timeout(function () {
          verlet_system.deactivateAllBodies(true);
          for (var i = 0; i < scope.moduleMapData.length; i++) {
            if (scope.moduleMapData[i].slug.indexOf('mtic_g78_m2_sum') === -1) {
              verlet_system.activateBody(scope.moduleMapData[i].slug, true);
            }
          }
        }, TIMING_CONSTANTS.INSTANT);
        if (selection_graphic === null) {
          selection_graphic = new PIXI.Sprite(PIXI.loader.resources[GR78_ASSET_URL + 'selection.png'].texture);
          selection_graphic.anchor.set(0.5, 0.5);
          selection_graphic.scale.set(0.75, 0.75);
          selection_graphic.interactive = false;
          selection_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
        }

        resolve();
      };

      var loadChildren = function loadChildren(someItem) {
        someItem.childResourcemap = [];
        if (someItem.children === undefined) {
          return;
        }
        if (someItem.children.length > 0) {
          _.forEach(someItem.children, function (childItem) {
            someItem.childResourcemap[childItem.slug] = childItem;
            loadChildren(childItem);
          });
        }
      };

      var createItem = function createItem(resource, parentItem, start_hidden) {
        if (resource.display && !resource.display.position) {
          if (resource.children && resource.children.length > 0) {
            _.forEach(resource.children, function (childItem) {
              createItem(childItem, parentItem);
            });
          }
          return;
        }

        if (verlet_system.getBody(resource.slug) !== undefined) {
          return;
        }
        var displayItem;

        //Add this to the map logic array of items
        items.push(displayItem = new gr78MapItemFactory.createMapItem(resource, eventManager));

        //create a VerletBody for the item
        displayItem.parentItem = parentItem;

        container.addChild(displayItem.sprite);

        if (TeacherDataService.isTeacherModuleView) {
          resource.locked = false;
        }

        var children = [];
        //Build the child items
        _.forEach(resource.children, function (childItem) {
          children.push(createItem(childItem, displayItem, true));
        });

        //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
        //So we create its list of unlocked_by based on the items in the group
        //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
        //And add it to the unlocked_by of the group
        if (displayItem.unlocked_by && displayItem.unlocked_by.length === 0) {
          for (var i = 0; i < children.length; i++) {
            for (var n = 0; n < children[i].unlocked_by.length; n++) {
              var is_inner = true;
              for (var p = 0; p < children.length; p++) {
                //This is pointing from an item in the group to another item in the group
                if (children[i].unlocked_by[n] === children[p].slug) {
                  is_inner = false;
                }
              }
              //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
              if (is_inner) {
                displayItem.unlocked_by.push(children[i].unlocked_by[n]);
              }
            }
          }
        }

        displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        if (start_hidden) {
          displayItem.sprite.visible = false;
          verlet_system.deactivateBody(resource.slug);
        }

        //Add the expandGroup listener to the item
        if (resource.resource_type === "group") {
          displayItem.setDelegate(expandGroup.bind(this));
          displayItem.isExpanded = false;
        }
        return displayItem;
      };

      this.destroy = function () {
        $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");
        if (canvas_el) {
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll);
          canvas_el.removeEventListener('mousewheel', handleScroll);
          canvas_el.removeEventListener('pointerdown', handleDoubleClick);
        }
        stage.removeChildren();
        container.removeChildren();
        app.destroy();
        window.removeEventListener("resize", onResize);
        EXISTS = false;
      }.bind(this);

      scope.$on('$destroy', function () {
        this.destroy();
      }.bind(this));

      scope.$watch("moduleMapData", function (moduleMapData) {
        if (!moduleMapData) {

          return;
        }
        if (!EXISTS) {
          EXISTS = true;
          init();
        } else {
          initMap(function () {});
        }
      });
    }
  };
});

var PIXI_gr78_Load_Cache;
var EXISTS;
'use strict';

angular.module('mtic.components.modules.gr78', []).constant('GR78_ASSET_URL', 'assets/images/gr78/').constant('AGENDA_ASSETS_URL', 'assets/images/agenda/');
'use strict';

angular.module('mtic.components.modules.gr78').directive('gr78MetaMap', function (GR78_ASSET_URL, AGENDA_ASSETS_URL, DEV_VARIABLES, StudentDataService, PanelStateService, $timeout, TIMING_CONSTANTS, TeacherDataService, $q, $log, $http, $window, gr78MapItemFactory, MapDataMassage, MapStateService, VerletSystemService, learningMapUtil, PIXI, EventManager, language, flashPermission, userAccount, preliveCheck, MODULE_AVAILABLE_LANGUAGE, LocaleService, ModuleFilter, PlatformService) {

  return {

    template:'<div ng-hide="loading_done" style="position:absolute;top:0px;left:0px;width:100%;height:100%;background-color:#555;z-index:1000"><div class="loader"></div></div><div ng-if="!loadedIframeModule.active && !badBrowser" class="inner-viewport" ng-class="{\'agendaSplitView\': !isTeacherWorkspaceView}" id="canvas_container" style="overflow:hidden;"><div ng-if="!isTeacherWorkspaceView" class="no-select agendaSplitViewSidebar"><nav class="nav is-small" style="margin-bottom: 24px;"><div class="nav-center"><a class="nav-item is-tab studentAgendaPanel__tab" ng-if="!isTeacher" ng-class="{\'is-active studentAgendaPanel__tab--active\':isShowingAgendaPanel()}" ng-click="selectAgendaPanel()" ng-init="selectAgendaPanel()"><span class="icon studentAgendaPanel__navTabIcon"><img src="assets/images/agenda/icon-blue-agenda.png"></span> <span class="studentAgendaPanel__navTabText">Agenda</span></a> <a class="nav-item is-tab studentAgendaPanel__tab" ng-class="{\'is-active studentAgendaPanel__tab--active\':isShowingModulePanel()}" ng-click="selectModulePanel()"><span class="icon studentAgendaPanel__navTabIcon"><img src="assets/images/agenda/icon-module-blue.png"></span> <span class="studentAgendaPanel__navTabText" ng-bind="getTranslation(\'14569\')">Module</span></a></div></nav><div style="padding:12px;"><lmap-sidepanel-agenda ng-if="isShowingAgendaPanel() && !isTeacher" module-map-data="moduleMapData"></lmap-sidepanel-agenda><div ng-if="isShowingModulePanel() || isTeacher"><input class="agendaSearchField" placeholder="{{getLang(\'22608\')}}" ng-model="itemSearchInput" ng-change="itemSearchChange(itemSearchInput)"><teacher-students-agenda-perf-preview filtered-view="itemSearchInput" module-map="moduleMapData" view-controller="view_controller"></teacher-students-agenda-perf-preview></div></div><div class="no-select" ng-style="{ left: currentActiveSubModule.children || !isTeacherWorkspaceView ? \'350px\' : \'0px\' }" style="position:absolute; bottom:0px; right:0px;"></div></div><div ng-class="{\'agendaSplitView__main\': !isTeacherWorkspaceView}"><canvas id="module-item-map-canvas" width="300" height="300" style="float:right"></canvas><lmap-bottom-panel highlighted-resource="selectedResource" module-map-data="currentActiveSubModule" ng-show="isShowingAgendaPanel() || isShowingModulePanel()" ng-if="!isTeacherWorkspaceView"></lmap-bottom-panel><div class="breadcrumbs" ng-hide="isTeacherWorkspaceView" style="font-size: 1em; position:absolute; top: 12px;"><a ng-click="returnToMetaModules()">{{getLang(moduleMapData.resource_slug)}}</a> / <a>{{getLang(currentActiveSubModule.slug)}}</a></div></div></div><module-iframe ng-if="loadedIframeModule.active" module-map-data="loadedIframeModule.data"></module-iframe><div style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; display: flex; align-items: center; justify-content: center; padding-bottom:180px;background-color: #e9f0f3" ng-show="badBrowser"><div style="width:480px; max-width: 80%; font-size: 20px; text-align:center;"><div style="margin-bottom:18px;"><img src="assets/images/logos/login_mathemaTIC_logo.png"></div><div>This module is not yet available in the <b>MathemaTIC app</b> for Android and iOS.<div style="margin-top:18px; line-height:100%;"><small>Please revisit this module in a the browser or on a desktop.</small></div><button style="margin-top:30px" class="button is-small is-danger" ng-click="goBackToClasses()" ng-bind="getTranslation(\'27642\')">My Classes</button></div></div></div><div style="display:flex; position:fixed;right: 8px; top: 45px;" class="module-zoom-buttons"><button ng-click="zoom_function(1)" class="button" style="margin-right:3px;font-size:24px"><i class="fa fa-search-minus" aria-hidden="true"></i></button> <button ng-click="zoom_function(-1)" class="button" style="font-size:24px"><i class="fa fa-search-plus" aria-hidden="true"></i></button></div>',
    scope: {
      moduleMapData: "=",
      interceptClick: "=?",
      onItemClick: "<",
      workspaceData: "=?",
      interactionDisabled: "=?",
      disableVerlet: "=?",
      ocmtHse: "=?"
    },
    link: function link(scope, element) {
      scope.getTranslation = function (id) {
        return language.get(id);
      };
      scope.badBrowser = false;
      var middle_view_visible = false;
      scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
      /*
      if(window.isWebEmbedConnect && !scope.interceptClick && !navigator.userAgent.match(/Android/i)){
        //kickout to browser
        var userData = userAccount.getData();
        var cur_class = userAccount.getData().role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom();
        window.location.href = 'https://mathematic.lu/app2/'+'?web-open-browser&firebase_token='+userData.firebase_token+'&uuid='+userData.uuid+'&session_key='+userData.sessionKey+'&user_id='+userData.user_id+'&class_id='+cur_class;//window.location.href.replace('/?debugBrowsers#/web-embed-connect', '').replace('web-embed-connect', '').replace('web-embed-response', '').replace('&iam-logout', '')
      }
      */
      // else if(window.isWebEmbedConnect && !scope.interceptClick){
      //   scope.badBrowser = true;
      // }

      scope.isTeacher = userAccount.getData().role.isTeacher;
      // event manager for coordination with rest of application
      var eventManager = new EventManager('gr78MetaMap', scope);
      var verlet_system = new VerletSystemService();
      if (scope.disableVerlet) {
        verlet_system.toggle(false);
      }

      scope.goBackToClasses = function () {
        eventManager.broadcast("navbar:my-classes:click");
        eventManager.broadcast('module:close:resource');
      };
      ///////////////////
      // PRIVATE VARS //
      /////////////////

      var state = 0,
          leftMostMapItemPosition = 0,
          rightMostMapItemPosition = 0,
          topMostMapItemPosition = 0,
          allSummativeItems = [],
          languageOptions = [];
      var canvas_el = null;
      var app = null;
      var renderer = null;
      var drag_info = null;
      var canvasDimention = null;
      var scale = null;
      var stage = null;
      var meta_background = null;
      var modules_container = null;
      var container = null;
      var lines_graphic = null;
      var selection_graphic = null;
      var cloud_man = null;
      var items = [];
      var modules = [];
      var moduleContainerManager;
      var isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);

      var agendas_list = [];

      var img_asset_paths = [GR78_ASSET_URL + "symlink.png", GR78_ASSET_URL + "item_blue_0.png", GR78_ASSET_URL + "item_blue_1.png", GR78_ASSET_URL + "item_red_0.png", GR78_ASSET_URL + "item_red_1.png", GR78_ASSET_URL + "item_red_2.png", GR78_ASSET_URL + "item_red_3.png", GR78_ASSET_URL + "item_black_0.png", GR78_ASSET_URL + "item_black_1.png", GR78_ASSET_URL + "item_black_2.png", GR78_ASSET_URL + "item_black_3.png", GR78_ASSET_URL + "item_blue_locked.png", GR78_ASSET_URL + "item_red_locked.png", GR78_ASSET_URL + "item_black_locked.png", GR78_ASSET_URL + "assessment.png", GR78_ASSET_URL + "assessment_complete.png", GR78_ASSET_URL + "selection.png", GR78_ASSET_URL + "mtic_gr78_m0.png", GR78_ASSET_URL + "mtic_gr78_m1.png", GR78_ASSET_URL + "mtic_gr78_m2.png", GR78_ASSET_URL + "mtic_gr78_m3.png", GR78_ASSET_URL + "mtic_gr78_m4.png", GR78_ASSET_URL + "mtic_gr78_c4_m1.png", GR78_ASSET_URL + "mtic_gr78_c4_m6.png", GR78_ASSET_URL + "formative_gold.png", GR78_ASSET_URL + "formative_silver.png", GR78_ASSET_URL + "formative_locked.png", GR78_ASSET_URL + "formative_unlocked.png"];
      var focus_item = null;

      scope.hasAgendas = false;
      scope.loadedIframeModule = {
        active: false,
        data: []
      };
      scope.moduleProgress = 0.5;

      flashPermission.getPermission();

      var runDownModel = {};
      var highlightedItem = null;

      var zooming = false;

      var resourceLockManager = function ResourceLockManager(self) {
        var originalLockState = {};
        self.setOriginal = function (resourceId, isLocked) {
          if (!originalLockState[resourceId]) {
            originalLockState[resourceId] = isLocked;
          }
        };
        self.unlock = function (resourceIds) {
          self.reset();
          resourceIds.forEach(function (resourceId) {
            var item = getItemById(resourceId);
            if (item) {
              item.unlock();
            }
          });
        };
        self.lock = function (resourceIds) {
          self.reset();
          resourceIds.forEach(function (resourceId) {
            var item = getItemById(resourceId);
            if (TeacherDataService.isTeacherModuleView) {
              item.unlock();
            } else {
              if (item) {
                item.lock();
              }
            }
          });
        };
        self.reset = function () {
          items.forEach(function (item) {
            if (TeacherDataService.isTeacherModuleView) {
              item.unlock();
            } else {
              if (originalLockState[item.id] === true) {
                item.lock();
              } else if (originalLockState[item.id] === false) {
                item.unlock();
              }
            }
          });
        };
        return self;
      }({});

      scope.showAgenda = false;
      scope.selectedResource = {};
      function unlockpath(item_id, use_slug) {
        // $log.log('UNLOCK PATH : ', item_id, items )
        items.forEach(function (resource) {
          if (resource.id === item_id || use_slug && item_id === resource.slug) {
            resource.unlock();
            resource.unlockedByAgenda = true;
            if (resource.unlocked_by.length > 0) {
              resource.unlocked_by.forEach(function (higher_resource) {
                unlockpath(higher_resource, true);
              });
            }
          }
        });
      }

      eventManager.listen('moduleview:agenda:loaded', function (e, data) {
        // $log.log('agenda data : ', data)
        if (data.length > 0) {
          agendas_list = data;
          scope.hasAgendas = true;
          // scope.toggleAgenda();
          scope.selectAgendaPanel();
          data.forEach(function (agenda) {
            if (agenda.force_unlock) {
              if (agenda.force_unlock) {
                agenda.resources.forEach(function (item) {
                  unlockpath(item);
                });
              }
            }
          });
        } else {
          scope.hasAgendas = false;
        }
      });

      scope.hasAgendaOption = function () {
        return scope.hasAgendas;
      };
      scope.hasModuleOption = function () {
        return scope.currentActiveSubModule && scope.currentActiveSubModule.children;
      };

      scope.isShowingAgendaPanel = function () {
        return scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView;
      };
      scope.isShowingModulePanel = function () {
        //&& scope.hasModuleOption()
        return !scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView || scope.isTeacher;
      };

      scope.toggleAgenda = function () {
        if (scope.showAgenda) {
          scope.selectModulePanel();
        } else {
          scope.selectAgendaPanel();
        }
      };

      scope.selectAgendaPanel = function () {
        // $log.log('from select agenda panel')
        scope.showAgenda = true;
        PanelStateService.setAgendaShowing(scope.showAgenda);
        if (!scope.showAgenda) {
          eventManager.broadcast('moduleview:agenda:request');
        }
      };

      scope.selectModulePanel = function () {
        // $log.log('from select module panel')
        if (scope.showAgenda) {
          scope.showAgenda = false;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          for (var i = 0; i < items.length; i++) {
            items[i].undoAgendaHighlight();
          }
        }
      };

      scope.panelDisplay = {};
      scope.getLang = language.get;

      scope.isStudent = function () {
        return !userAccount.getData().role.isTeacher;
      };

      /////////////
      // CONSTRUCTOR
      /////////////


      // if(MODULE_AVAILABLE_LANGUAGE[scope.moduleMapData.resource_slug]){
      // $log.log('no ?')
      // var allowed_langs = ["fr"];
      // language.setAvailableOptions(allowed_langs)
      // }


      var _TOUCHED_POINTS = [];
      function init() {
        scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
        // retrieve template element references
        canvas_el = document.getElementById('module-item-map-canvas');
        if (!canvas_el) {
          return;
        }

        MapStateService.setMetaStateSlug('mtic_gr78_m_meta');

        app = new PIXI.Application(300, 300, {
          autoResize: true,
          backgroundColor: 0xdee9fc,
          antialias: true,
          view: canvas_el
        });

        renderer = app.renderer;
        scale = 0.45;
        items = [];

        drag_info = learningMapUtil.getDragInfoSettings();

        var sidepanel_width = 0;
        if (scope.isTeacher) {
          // var sidepanel = document.getElementById('teacher_sidepanel');
          // sidepanel_width = TeacherDataService.inTeacherAgendaView ? 60 : sidepanel.offsetWidth;
          // if(TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView){
          //   sidepanel_width += -30;
          // }
        }

        canvasDimention = {
          width: 0, //window.innerWidth - 180 - sidepanel_width,
          height: window.innerHeight - 50
        };
        stage = app.stage;
        stage.interactive = true;

        cloud_man = learningMapUtil.createCloudManager();
        stage.addChild(cloud_man.overlay_sprite);

        // if(TeacherDataService.isTeacherWorkspaceView){
        //   stage.x = -200;
        // }

        var meta_canvas = document.createElement("canvas");
        meta_canvas.width = 200;
        meta_canvas.height = 200;
        var ctx = meta_canvas.getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, 200);
        gradient.addColorStop(0, '#7DC5BA');
        gradient.addColorStop(1, '#A0E0DA');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 200, 200);

        var meta_tex = PIXI.Texture.fromCanvas(meta_canvas);

        meta_background = new PIXI.Sprite(meta_tex);
        stage.addChildAt(meta_background, 0);

        window.addEventListener("resize", onResize);

        // var isExpanded = TeacherDataService.inTeacherAgendaView || isMobile ? false : null
        // onResize(isExpanded);
        renderer.render(stage);

        container = new PIXI.Sprite();
        container.interactive = true;
        container.x = renderer.width / 2;
        container.y = renderer.height / 2;

        stage.addChildAt(container, 1);

        lines_graphic = new PIXI.Graphics();
        container.addChild(lines_graphic);

        container.scale.set(scale, scale);
        app.ticker.add(update);

        canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else

        // prevent browser from selecting other html text when double clicking the PIXI canvas
        canvas_el.addEventListener('pointerdown', handleDoubleClick, false);
        // scope.test_data = 'TESTING';
        stage.on('pointerdown', function (e) {
          var e_o = e.data.originalEvent;
          _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x: e_o.pageX, y: e_o.pageY });

          drag_info.dragging = true;
          focus_item = null;

          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: container.x,
            y: container.y
          };
          drag_info.start_drag_mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };
        });
        stage.on('pointermove', function (e) {
          if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
            var mouse_pos = {
              x: e.data.global.x,
              y: e.data.global.y
            };
            container.position.x = Math.min(1000, Math.max(drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x), 0));
            container.position.y = Math.min(1000, Math.max(drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y), 0));
            var delta_pos = {
              x: drag_info.last_mouse_pos.x - mouse_pos.x,
              y: drag_info.last_mouse_pos.y - mouse_pos.y
            };
            drag_info.velocity = {
              x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
              y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
            };
            drag_info.last_mouse_pos = {
              x: mouse_pos.x,
              y: mouse_pos.y
            };
          }
        });
        stage.on('pointerup', function (e) {
          if (window.DEBUG_TOUCH) {
            $log.log('g78_metamap pointerup ; ', JSON.stringify(drag_info));
          }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
          prev_diff = null;
        });

        // stage.on('pointermove', function(e){
        //   if(_TOUCHED_POINTS.length === 2){
        //     if(!prev_diff){
        //       prev_diff = Math.abs(_TOUCHED_POINTS[0].x - _TOUCHED_POINTS[1].x);
        //     }
        //     var e_o = e.data.originalEvent;
        //     var index = _TOUCHED_POINTS.findIndex(function(point, index) {
        //       if(point.pointer_id === e.pointerId){
        //         return true;
        //       }
        //     });

        //     _TOUCHED_POINTS[index].x = e_o.pageX;
        //     _TOUCHED_POINTS[index].y = e_o.pageY;

        //     var new_diff = Math.abs(_TOUCHED_POINTS[0].x - _TOUCHED_POINTS[1].x);

        //     $timeout(()=>{
        //       //scope.test_data = 'MOVING TWO :  ' + prev_diff + ' --- ' + new_diff;
        //       // _TOUCHED_POINTS.forEach((pt)=>{
        //       //   scope.test_data += '- POINT : X : '+pt.x+' Y: '+pt.y;
        //       // })
        //     })
        //   }
        // })
        stage.on('pointerout', function (e) {
          if (window.DEBUG_TOUCH) {
            $log.log('g78_metamap pointerup ; ', JSON.stringify(drag_info));
          }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
          prev_diff = null;
        });

        if (PIXI.loader.resources) {
          for (var ast in PIXI.loader.resources) {
            PIXI.loader.reset();
            PIXI_gr78_Load_Cache = false;
            break;
          }
        }

        if (window.DEBUG_TOUCH) {
          $log.log('g78_metamap pointerdown ; ', JSON.stringify(drag_info));
        }
        return loadAssets().then(function () {
          $log.debug('[[gr78MetaMap]] loadAssets.then');
          scope.loading_done = true;
          var isExpanded = TeacherDataService.inTeacherAgendaView ? false : null;
          onResize(isExpanded);
          return;
        }).catch(function (err) {
          $log.error('[[gr78MetaMap]] loadAssets.then', err.message);
          $log.debug(err.stack);
        });
      }

      scope.returnToMetaModules = function () {
        scope.loadedIframeModule.active = false;
        eventManager.broadcast('module:change:meta', 'mtic_gr78_m_meta');
      };

      eventManager.listen('module:close:resource', function (e, data) {
        $timeout(function () {
          if (MODULE_AVAILABLE_LANGUAGE.mtic_gr78_m_meta) {
            language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE.mtic_gr78_m_meta);
          } else if (languageOptions) {
            language.setAvailableOptions(languageOptions);
          }
        }, 200);
      });

      eventManager.listen('module:change:meta', function (e, data) {
        $timeout(function () {
          meta_background.visible = true;
          //Remove the focus from the selected item
          eventManager.broadcast('module:dismiss:focus');

          if (MODULE_AVAILABLE_LANGUAGE.mtic_gr78_m_meta) {
            language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE.mtic_gr78_m_meta);
          } else if (languageOptions) {
            language.setAvailableOptions(languageOptions);
          }

          scope.currentActiveSubModule = {};
          scope.panelDisplay = {
            slug: '',
            isExpanded: false,
            sub: {}
          };

          verlet_system.deactivateAllBodies(true);
          for (var i = 0; i < modules.length; i++) {
            verlet_system.activateBody(modules[i].slug, true);

            modules[i].graphics.interactive = true;
          }
          onResize();
        }, TIMING_CONSTANTS.INSTANT);
      });

      eventManager.listen('unlock-item', function (e, slug) {
        items.forEach(function (resource) {
          if (slug === resource.slug) {
            resource.unlock(true);
            resource.unlockedByAgenda = true;
          }
        });
        // var scopeResource = getResourceBySlug(slug);
        // scopeResource.locked = false;
      });
      eventManager.listen('module:change:submodule', function (e, data) {
        if (!languageOptions || languageOptions.length === 0) {
          languageOptions = language.getActiveLanguageOptions().map(function (lang) {
            return lang.slug;
          });
        }

        $timeout(function () {
          meta_background.visible = false;
          verlet_system.deactivateAllBodies(true);
          // $log.log('MODULE_AVAILABLE_LANGUAGE[data]', MODULE_AVAILABLE_LANGUAGE[data])
          if (MODULE_AVAILABLE_LANGUAGE[data]) {
            language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[data]);
          }

          MapStateService.setActiveModule(data);
          var resources = MapStateService.getSelectedResourcesForAgendaCreation();
          for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
            if (scope.moduleMapData.resources[i].slug === data) {
              scope.currentActiveSubModule = scope.moduleMapData.resources[i];
              var resource = scope.moduleMapData.resources[i];
              for (var n = 0; n < resource.children.length; n++) {
                //unselect any highlited item
                var item = getItemBySlug(resource.children[n].slug);
                if (item && TeacherDataService.isTeacherWorkspaceView) {
                  item.hideAgendaHighlight();
                }
                // if((resources && resources.contains && resources.contains(item.id))){
                //   item.showAgendaHighlight();
                // }
                if (DEV_VARIABLES.RESOURCES.HIDE_THESE.indexOf(resource.children[n].slug) > -1 || resource.children[n].config && resource.children[n].config.hidden === true) {
                  continue;
                }

                verlet_system.activateBody(resource.children[n].slug, true);
              }
              break;
            }
          }
          eventManager.broadcast('log:language:options', {
            available_language: scope.currentActiveSubModule.content.available_languages || 'none',
            current_url_version: LocaleService.getUrlVersion(),
            cycle: 'gr78'
          });
          language.setAvailableOptions(_.get(scope.currentActiveSubModule, ['content', 'available_languages', LocaleService.getUrlVersion()]));
          if (!scope.hasAgendaOption()) {
            scope.selectModulePanel();
          }
          // $log.log('from current active sub : ', scope.currentActiveSubModule)

          var isVerletNeeded = !scope.disableVerlet;
          if (scope.currentActiveSubModule.display && scope.currentActiveSubModule.display.isVerletDisabled) {
            isVerletNeeded = false;
          }
          verlet_system.toggle(isVerletNeeded);
          // $log.log('verlate is active : ' , isVerletNeeded, verlet_system.getCurrentEnabledStatus())

          if (scope.currentActiveSubModule.display.panel && scope.currentActiveSubModule.display) {
            scope.panelDisplay = {
              slug: scope.currentActiveSubModule.slug,
              isExpanded: true,
              sub: scope.currentActiveSubModule.display.panel
            };
          }
        }, TIMING_CONSTANTS.INSTANT);
      });

      eventManager.listen('module:open:resource', function (e, data) {
        MapStateService.setFocusSlug(data.slug);
      });

      var prehighlighted_list = [];
      eventManager.listen('highlight:map:items', function (e, list) {
        // $log.log('got prehighlighted list : ', list)
        prehighlighted_list = list;
        $timeout(function () {
          onResize();
        }, 500);
      });

      eventManager.listen('module:select:resource', function (e, data) {
        var scopeResource = getResourceBySlug(data.slug);
        if (scopeResource === null) {
          eventManager.broadcast('module:dismiss:focus');
          return;
        }

        if (scope.onItemClick && scope.interceptClick) {
          var item = getItemBySlug(data.slug);
          scope.onItemClick(scopeResource, item, data);
          // return;
        }
        $timeout(function () {
          scope.selectedResource = scopeResource;
        }, TIMING_CONSTANTS.INSTANT);

        var mapResource = getItemBySlug(data.slug);

        //This isn't a map item??
        if (mapResource === null) {
          return;
        }

        focus_item = mapResource;

        scope.scale_factor = focus_item && focus_item.type === 'assessment' ? 9.6 : 10;

        mapResource.sprite.addChildAt(selection_graphic, 0);
        selection_graphic.scale.set(0);

        //Find the module that contains the selected item and open it
        var module_slug = '';
        for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
          if (scope.moduleMapData.resources[i].children.indexOf(scopeResource) > -1) {
            if (MapStateService.getActiveModule() !== scope.moduleMapData.resources[i].slug) {
              eventManager.broadcast('module:change:submodule', scope.moduleMapData.resources[i].slug);
              eventManager.broadcast('update:submodule:slug:route:name', { slug: scope.moduleMapData.resources[i].slug, name: scope.moduleMapData.resources[i].name });
              MapStateService.setActiveModule(scope.moduleMapData.resources[i].slug);
            }
          }
        }

        if (TeacherDataService.inTeacherAgendaView && !middle_view_visible) {
          middle_view_visible = true;
          onResize();
        }
      });

      eventManager.listen('module:center:resource', function (e, data) {
        focus_item = getItemBySlug(data.slug);
        // $log.log('FOCUS ON THIS : ', data)
      });

      eventManager.listen('module:stop:pan', function () {
        focus_item = null;
      });

      /////////////
      // METHODS
      /////////////

      //Mousewheel zoom/in out at cursor position (like google maps)
      var handleScroll = function handleScroll(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = evt.detail < 0 || evt.wheelDelta > 0 ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.0, scale + direction / 15), 0.25);
        var diff = scale - start_scale;
        container.scale.set(scale, scale);

        //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
        // var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
        // container.position.x -= diff * pos.x;
        // container.position.y -= diff * pos.y;

        evt.preventDefault();
        return false;
      };

      var handleDoubleClick = function handleDoubleClick(e) {
        e.preventDefault();
        return false;
      };

      var initMapDraw = function initMapDraw(moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        var combinedResourceMap = {};
        // $log.log("modulemapdata : ", moduleMapData)

        _.forEach(moduleMapData.children, function (someItem) {
          combinedResourceMap[someItem.slug] = someItem;
          loadChildren(someItem);
        });

        var currentModuleChildrenDisplayItems = [];
        _.each(combinedResourceMap, function (resource) {
          var item = createItem(resource, null);
          if (!item) {
            return;
          }
          currentModuleChildrenDisplayItems.push(item);
          if (item.sprite && item.sprite.position && item.sprite.position.x < leftMostMapItemPosition) {
            leftMostMapItemPosition = item.sprite.position.x;
          }
          if (item.sprite && item.sprite.position && item.sprite.position.x && item.sprite.position.x > rightMostMapItemPosition) {
            rightMostMapItemPosition = item.sprite.position.x;
          }
          if (item.sprite && item.sprite.position && item.sprite.position.y && item.sprite.position.y < topMostMapItemPosition) {
            topMostMapItemPosition = item.sprite.position.y;
          }
        });

        // $log.log('currentModuleChildrenDisplayItems : ', moduleMapData)

        var summativeItem = _.find(currentModuleChildrenDisplayItems, function (each) {
          return each.slug.indexOf('sum') > -1 && each.resource_type === 'assessment';
        });
        if (summativeItem) {
          //  $log.log('summative g78 : ', summativeItem)
          summativeItem.sprite.position.set(leftMostMapItemPosition + (rightMostMapItemPosition - leftMostMapItemPosition) / 2 - summativeItem.sprite.width / 2, topMostMapItemPosition - 150);
          summativeItem.initialX = summativeItem.sprite.position.x;
          allSummativeItems.push(summativeItem);
        }

        _.forEach(items, function (item) {
          if (!item.locked) {
            item.unlock();
          }
          if (MapDataMassage.getTempUnlocks()) {
            if (_.indexOf(MapDataMassage.getTempUnlocks(), item.slug) !== -1) {
              item.unlock();
            }
          }
        });

        if (agendas_list.length > 0) {
          agendas_list.forEach(function (agenda) {
            if (agenda.force_unlock) {
              agenda.resources.forEach(function (item) {
                unlockpath(item);
              });
            }
          });
        }

        eventManager.broadcast('creating-items-done');
      };

      var updateItemsHighlighterAnimation = function updateItemsHighlighterAnimation() {
        angular.forEach(items, function (each) {
          if (each.selection_graphic) {
            //Rotate it a little bit
            each.selection_graphic.rotation = (each.selection_graphic.rotation - 0.015) % (Math.PI * 2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.selection_graphic.scale.set((each.selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / scope.scale_factor);
          }
          if (each.highlight_graphic) {
            //Rotate it a little bit
            each.highlight_graphic.rotation = (each.highlight_graphic.rotation - 0.015) % (Math.PI * 2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.highlight_graphic.scale.set((each.highlight_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / 10);
          }
        });
      };

      var prev_diff;

      //This loops to control things that should update every frame
      var update = function update() {
        if (selection_graphic !== null && !scope.interceptClick) {

          //Rotate it a little bit
          selection_graphic.rotation = (selection_graphic.rotation - 0.015) % (Math.PI * 2);

          //Use UNIX time to scale the graphic with a sin function
          //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
          selection_graphic.scale.set((selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / scope.scale_factor);
        }
        if (TeacherDataService.isTeacherWorkspaceView) {
          updateItemsHighlighterAnimation();
        }
        //update the fade in animation
        cloud_man.update();

        //update the verlet force directed graph that positions the map items in that big jiggly web
        verlet_system.update();

        if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
          drag_info.velocity = {
            x: drag_info.velocity.x * 0.954,
            y: drag_info.velocity.y * 0.954
          };
        } else {
          container.position.x = Math.min(1000, Math.max(container.position.x - drag_info.velocity.x, 0));
          container.position.y = Math.min(1000, Math.max(container.position.y - drag_info.velocity.y, 0));
          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;
        }

        focusItemTicker();

        lines_graphic.clear();
        if (!scope.ocmtHse) {
          lines_graphic.lineStyle(8, 0xCCCCDD, 1);
          var segments = verlet_system.getLineSegments();
          var i;
          for (i = 0; i < segments.solid.length; i++) {
            var cur_seg = segments.solid[i];
            lines_graphic.lineStyle(8, 0xCCCCDD, 1);
            if (scope.item_path_slug.indexOf(cur_seg.id) > -1) {
              lines_graphic.lineStyle(8, 0XFFCC00, 1);
            }
            lines_graphic.moveTo(cur_seg.start.x, cur_seg.start.y);
            lines_graphic.lineTo(cur_seg.end.x, cur_seg.end.y);
          }
          lines_graphic.beginFill(0xFF0000, 1);
          for (i = 0; i < segments.dash.length; i++) {
            lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
          }
          lines_graphic.endFill();
        }

        if (window.DEBUG_TOUCH) {
          $log.log('g78_metamap update ; ', JSON.stringify(drag_info));
        }
      };

      scope.item_path_slug = [];
      function createHighlightedSegments(slug) {
        if (!slug) {
          scope.item_path_slug = [];
          return;
        }
        items.forEach(function (resource) {
          if (slug === resource.slug) {
            scope.item_path_slug.push(slug);
            if (resource.unlocked_by.length > 0) {
              resource.unlocked_by.forEach(function (higher_resource) {
                createHighlightedSegments(higher_resource);
              });
            }
          }
        });
        // $log.log('scope.item_path_slug , ', scope.item_path_slug)
      }

      eventManager.listen('highlight:path', function (e, data) {
        scope.item_path_slug = [];
        // $log.log('HIGHLIGHT THIS : ', data)
        // var use_slug = data.slug.split(':')[1].trim();
        var use = data.slug;
        if (data.clear) {
          use = false;
        }
        createHighlightedSegments(use);
      });

      /**
       *Expand a subgroup to reveal child items
       *slug is a unique String that identifies the group MapItem
       **/
      var expandGroup = function expandGroup(slug) {
        //Cancel this mouse event if they were dragging more than 10 pixels
        if (drag_info.dragging) {
          if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
            return;
          }
        }

        if (verlet_system.deactivateBody(slug, true)) {
          var group = getItemBySlug(slug);
          //position all of the sub items so that they appear from where the clicked group icon is
          for (var i = 0; i < items.length; i++) {
            if (items[i].parentItem === group) {
              items[i].sprite.position.x = group.sprite.position.x;
              items[i].sprite.position.y = group.sprite.position.y;
              verlet_system.activateBody(items[i].slug, true);
            }
          }
          // toggleGroupExpanded(group);
        }
      };

      /**
       *Collapse a subgroup to hide child items
       *slug is a unique String that identifies the group MapItem
       **/
      var collapseGroup = function collapseGroup(slug) {
        var group = getItemBySlug(slug);
        if (group.isExpanded === true) {
          toggleGroupExpanded(group);
        }
      };

      /**
       *Toggle the expand/collapse of a given item group
       *group is a MapItem
       **/
      var toggleGroupExpanded = function toggleGroupExpanded(group) {
        group.isExpanded = !group.isExpanded;
        //    baseVerletSystem.hookUpConstraints();
      };

      //If focus item is defined, pan towards it
      var focusItemTicker = function focusItemTicker() {
        if (focus_item === null) {
          return;
        }
        var abs_pos = container.toGlobal(focus_item.sprite.position);
        container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
        container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
      };

      /**
       *Return a MapItem whose slug matches the passed slug
       *Returns null if no MapItem can be found
       */
      var getItemBySlug = function getItemBySlug(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      };

      var getItemById = function getItemById(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      };

      var getResourceBySlug = function getResourceBySlug(slug) {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n++) {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === slug) {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      };

      ////////////////
      //
      ////////////////
      var onResize = function onResize(sidepanel_expanded) {
        var _canvasEl = document.getElementById('module-item-map-canvas');
        if (!_canvasEl) {
          return;
        }

        var sidepanel_width = TeacherDataService.sidepanelStatus ? 260 : 60;
        var canv_width;
        // var sidepanel = document.getElementById('teacher_sidepanel');
        if (!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView) {
          if (sidepanel_expanded === true || sidepanel_expanded === false) {
            sidepanel_width = sidepanel_expanded ? 140 : -200;
          } else {
            sidepanel_width = 0;
          }
          canv_width = _canvasEl.parentElement.offsetWidth - sidepanel_width;
        } else {
          var middleview = document.getElementById('agenda_middleview');
          if (middleview) {
            sidepanel_width += 300;
          }
          if (!TeacherDataService.inTeacherAgendaView) {
            sidepanel_width += -30;
          }
          canv_width = window.innerWidth - 370 - sidepanel_width;
        }

        canvasDimention = {
          width: canv_width,
          height: window.innerHeight - 35
        };

        _canvasEl.width = canvasDimention.width;
        _canvasEl.height = canvasDimention.height;

        meta_background.width = canvasDimention.width;
        meta_background.height = canvasDimention.height;

        renderer.resize(canvasDimention.width, canvasDimention.height);
        cloud_man.onResize(canvasDimention.width, canvasDimention.height);

        if (container && renderer) {
          scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width / 800) : scale;
          container.scale.set(scale, scale);
          container.x = renderer.width / 2;
          container.y = renderer.height / 2;
        }
      };

      // scope.$watch("moduleMapData", function (moduleMapData) {

      //this is what runs to initialize the map
      var loadAssets = function loadAssets() {
        $log.debug('[[gr78MetaMap]] loadAssets');
        return $q(function (resolve, reject) {
          try {
            if (!PIXI_gr78_Load_Cache) {
              PIXI.loader.add(img_asset_paths).load(function () {
                // $log.debug('loaded resources', PIXI.loader.resources)
                PIXI_gr78_Load_Cache = true;
                initMap(resolve);
              });
            } else {
              initMap(resolve);
            }
          } catch (err) {
            $log.error('[[gr78MetaMap]]', err);
            reject(err);
          }
        });
      };

      var initMap = function initMap(resolve) {
        $log.debug('[[gr78MetaMap]] initMap');
        modules = [];
        var i, n, p;

        for (i = 0; i < scope.moduleMapData.resources.length; i++) {
          if ((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) && (scope.moduleMapData.resources[i].id === 923 || scope.moduleMapData.resources[i].id === 955)) {
            //hide these
          } else {
            initMapDraw(scope.moduleMapData.resources[i]);
            //if(!scope.workspaceData || !scope.workspaceData.modules || scope.workspaceData.modules.length===0){
            var module_container = createModuleContainer(scope.moduleMapData.resources[i]);
            modules.push(module_container);
            //}
          }

          //Add all the bad boys to the verlet_system
        }
        //moduleContainerManager.translationChanged();
        $log.debug('[[gr78MetaMap]] initMap.initMapDraw done');

        verlet_system.deactivateAllBodies(true);

        for (i = 0; i < modules.length; i++) {
          verlet_system.activateBody(modules[i].slug, true);
        }
        $log.debug('[[gr78MetaMap]] initMap.verlet_system done');
        var active_module = MapStateService.getActiveModule();
        for (n = 0; n < modules.length; n++) {
          if (modules[n].slug === active_module) {
            moduleClicked(modules[n]);

            var active_items = MapStateService.getActiveItems();

            verlet_system.deactivateAllBodies(true);

            for (p = 0; p < active_items.length; p++) {
              var item = getItemBySlug(active_items[p]);
              var pos = MapStateService.getItemState(active_items[p]);
              if (!item) {
                continue;
              }
              item.sprite.position.x = pos.x;
              item.sprite.position.y = pos.y;
              verlet_system.activateBody(active_items[p], true);
            }
          }
        }

        selection_graphic = new PIXI.Sprite(PIXI.loader.resources[GR78_ASSET_URL + 'selection.png'].texture);
        selection_graphic.anchor.set(0.5, 0.5);
        selection_graphic.scale.set(0.75, 0.75);
        selection_graphic.interactive = false;
        selection_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);

        if (!PanelStateService.agendaShowing()) {
          scope.toggleAgenda();
        }

        //If an item was selected before we left the map, find it and highlight it as we return.
        var focus_slug = MapStateService.getFocusSlug();
        for (n = 0; n < scope.moduleMapData.resources.length; n++) {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === focus_slug) {
              var item_info = scope.moduleMapData.resources[n].children[i];
              // var item_evt_info = {
              //   slug : item_info.slug,
              //   id : item_info.id
              // };
              //brodcast the selection events
              eventManager.broadcast('module:center:resource', item_info);
              eventManager.broadcast('module:select:resource', item_info);
              if (focus_item === null) {
                break;
              }
              //center on the resource immediately
              if (focus_item) {
                var abs_pos = container.toGlobal(focus_item.sprite.position);
                container.x += -(abs_pos.x - 125 - app.renderer.width / 2);
                container.y += -(abs_pos.y + 80 - app.renderer.height / 2);
              }

              break;
            }
          }
        }
        if (focus_item) {
          if (scope.moduleMapData.resources[n] !== undefined && scope.moduleMapData.resources[n].children[i] !== undefined) {
            $timeout(function () {
              scope.panelDisplay = scope.moduleMapData.resources[n].children[i];
            }, TIMING_CONSTANTS.INSTANT);
          }
        }

        // $log.log('INIT MAP CONTAINER POSITION : ', container.x)
        // if(container && renderer){
        //   scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width/800) : scale;
        //   container.scale.set(scale, scale);
        //   container.x = renderer.width / 2;
        //   container.y = renderer.height / 2;
        // }

        $log.debug('[[gr78MetaMap]] initMap.active_module done');
        resolve();
      };

      var module_clicked = false;
      var moduleClicked = function moduleClicked(module_container) {
        if (scope.interactionDisabled) {
          return;
        }
        module_clicked = true;

        // $log.log('MODULE CONTAINER : ', module_container)
        //DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(module_container.slug) === -1 || preliveCheck.isQCCheck()
        // if(!(module_container.content && module_container.content.lock_on && is_module_locked(module_container.content.lock_on))) {
        if (ModuleFilter.checkAvailable(module_container)) {
          if (scope.interceptClick) {
            if (scope.interceptClick.slug !== module_container.slug) {
              scope.interceptClick.slug = module_container.slug;
            } else if (!TeacherDataService.inTeacherAgendaView) {
              eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
            }

            scope.$apply();
          }
          var i;
          scope.moduleProgress = module_container.progress;
          $log.debug('[[gr78MetaMap]] clicked', module_container);

          if (module_container.content.container) {
            scope.loadedIframeModule.data = module_container;
            scope.loadedIframeModule.active = true;
          } else {
            for (i = 0; i < modules.length; i++) {
              modules[i].graphics.interactive = false;

              verlet_system.deactivateBody(modules[i].slug, true);
            }
            eventManager.broadcast('submodule:opened', {
              slug: module_container.slug,
              name: module_container.name
            });
            $timeout(function () {
              eventManager.broadcast('module:change:submodule', module_container.slug);
            }, TIMING_CONSTANTS.INSTANT);
          }
        } else {
          window.alert(language.get('module_is_locked'));
        }
      };

      var createModuleContainer = function createModuleContainer(module, reset) {
        //Set up the container sprite that will be used
        var do_lock = module.locked;
        //$log.log("MODULE : " , module)//DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(module.slug) > -1
        // $log.log('ModuleFilter.checkAvailable(module)', ModuleFilter.checkAvailable(module))
        if (!ModuleFilter.checkAvailable(module)) {
          do_lock = true;
        }
        //For drawing progress ring
        var sum = 0;
        var prog = 0;
        for (var i = 0; i < module.children.length; i++) {
          if (module.children[i].resource_type === 'symlink') {
            continue;
          }
          sum++;
          if (TeacherDataService.isTeacherWorkspaceView) {
            prog += workspace_list[module.children[i].id] ? 1 : 0;
          } else {
            prog += module.children[i].complete ? 1 : 0;
          }
        }
        if (TeacherDataService.isTeacherModuleView) {
          prog = 0;
        }
        var mod_graphics;
        if (reset) {
          modules.forEach(function (mod) {
            if (mod.slug === module.slug) {
              mod_graphics = mod.graphics;
            }
          });
          //mod_graphics = container.getChildAt(0);
          if (!mod_graphics) {
            return;
          }
          mod_graphics.clear();
        } else {
          mod_graphics = new PIXI.Graphics();
        }
        mod_graphics.beginFill(do_lock ? 0xC5FBF5 : 0xFFFFFF).drawCircle(0, 0, 145).endFill() //white border
        .moveTo(0, 0).beginFill(0x33ACE0).arc(0, 0, 146, -Math.PI / 2, prog / sum * Math.PI * 2 - Math.PI / 2); //progress ring
        var mod_image = PIXI.Sprite.fromImage(GR78_ASSET_URL + (do_lock ? "center_lock" : module.slug) + ".png");
        mod_image.anchor.set(0.5);
        var img_size = module.slug.indexOf('ocmt') > -1 ? 325 : 250;
        mod_image.width = img_size;
        mod_image.height = img_size;
        mod_graphics.addChild(mod_image);

        container.addChild(mod_graphics);
        mod_graphics.buttonMode = true;
        mod_graphics.interactive = true;
        mod_graphics.x = module.display.position.x;
        mod_graphics.y = module.display.position.y + 300;
        // if(module.id === 69){
        //   mod_graphics.y -= 30;
        // }

        var tooltip = new PIXI.Graphics();
        mod_graphics.addChild(tooltip);

        var drawTooltip = function drawTooltip() {
          tooltip.removeChildren();
          tooltip.clear();

          var textInfo = new PIXI.Text(language.get(module.slug), {
            fontFamily: 'Arial',
            align: 'center',
            fontSize: isMobile ? 40 : 32,
            fill: 0xFFFFFF,
            dropShadow: false,
            wordWrap: true,
            wordWrapWidth: 400
          });

          tooltip.beginFill(do_lock ? 0x63a19a : 0x333c42);
          tooltip.drawRoundedRect(0, 0, textInfo.width + 40, textInfo.height + 20, 8);
          tooltip.endFill();

          tooltip.addChild(textInfo);
          textInfo.position.set(20, 10);
          tooltip.position.set(-tooltip.width / 2, -tooltip.height - 170);
        };

        eventManager.listen('language:change', drawTooltip);
        drawTooltip();

        var module_container = {
          graphics: mod_graphics,
          slug: module.slug,
          id: module.id,
          name: module.name,
          content: module.content,
          children: module.children,
          progress: prog / sum
        };
        if (reset) {
          mod_graphics.off('pointertap');
        }
        mod_graphics.on('pointertap', function (e) {
          //PIXI is receiving mouse events from other targets
          if (e.data.originalEvent.target && e.data.originalEvent.target.id !== 'module-item-map-canvas') {
            return;
          }
          $timeout(function () {
            if (!zooming) {
              moduleClicked(module_container);
            }
          }, 10);
        });

        // eventManager.listen('destroy-c3-map', function(){
        //   PIXI_gr78_Load_Cache = false;
        // })


        eventManager.listen('module:dismiss:focus', function (e, data) {
          scope.selectedResource = {};
          if (selection_graphic && selection_graphic.parent !== null) {
            selection_graphic.parent.removeChild(selection_graphic);
          }
        });

        var connection = [];
        if (modules.length > 0) {
          //    connection.push(modules[modules.length - 1].slug);
        }

        verlet_system.createBody(module.slug, mod_graphics, connection);
        return module_container;
      };

      var loadChildren = function loadChildren(someItem) {
        someItem.childResourcemap = [];

        if (someItem.children === undefined) {
          return;
        }
        if (someItem.children.length > 0) {
          _.forEach(someItem.children, function (childItem) {
            someItem.childResourcemap[childItem.slug] = childItem;
            loadChildren(childItem);
          });
        }
      };
      var interpeteAgendaLockStatus = function interpeteAgendaLockStatus(agenda) {
        if (agenda.force_unlock === true) {
          return 'unlock';
        } else if (agenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      };

      var summative_list = [];

      eventManager.listen('got-c4-summative-data', function (e, args) {
        $timeout(function () {
          summative_list.forEach(function (summ) {
            if (args && args.unlocked.indexOf(summ.name) > -1) {
              // $log.log(MapStateService.getActiveModule());
              var name_check = summ.val.slug.replace('g78', 'gr78');
              args.force_unlock = args.force_unlock || [];
              var start_visible = MapStateService.getActiveModule() && summ.val.config.assessment_type === 'summative' && name_check.indexOf(MapStateService.getActiveModule()) > -1;
              createItem(summ.val, summ.parent, !start_visible, true, args.force_unlock.indexOf(summ.name) > -1);
            }
          });
        }, 500);
      });

      var createItem = function createItem(resource, parentItem, start_hidden, build, force_unlock) {
        var isSummative = false;
        if ((resource.slug.indexOf('summative') > -1 || resource.config.assessment_type === 'summative') && !resource.config.show_summative) {
          isSummative = true;
          if (!build && !TeacherDataService.isTeacherModuleView && !TeacherDataService.isTeacherWorkspaceView) {
            summative_list.push({ name: resource.slug, val: resource, parent: parentItem });
            return;
          }
        } else if (resource.children && resource.children.length > 0) {
          _.forEach(resource.children, function (childItem) {
            createItem(childItem, parentItem);
          });
          return;
        }

        if (verlet_system.getBody(resource.slug) !== undefined) {
          return;
        }
        var displayItem;

        if (TeacherDataService.isTeacherModuleView || TeacherDataService.isTeacherWorkspaceView) {
          resource.locked = false;
        }
        //Add this to the map logic array of items
        items.push(displayItem = new gr78MapItemFactory.createMapItem(resource, eventManager));
        resourceLockManager.setOriginal(displayItem.id, displayItem.locked);
        //create a VerletBody for the item
        displayItem.parentItem = parentItem;
        //     displayItem.sprite.position.x += Math.random() * 10;
        //    displayItem.sprite.position.y += Math.random() * 10;
        container.addChild(displayItem.sprite);

        //Setup verlet body dragging
        /*
          displayItem.sprite.on('pointerdown', function(evt) {
            var dragFunc = function(tickerEvt) {
              var item = displayItem;
              var abs_pos = container.toGlobal(item.sprite.position);
              var xPos = renderer.plugins.interaction.eventData.data.global.x;
              var yPos = renderer.plugins.interaction.eventData.data.global.y;
              if (isNaN(xPos) || isNaN(yPos)) {
                return;
              }
              item.sprite.position.x -= abs_pos.x - xPos;
              item.sprite.position.y -= abs_pos.y - yPos;
            };
             stage.on('pointerup', function(e) {
              app.ticker.remove(dragFunc);
            });
             app.ticker.add(dragFunc);
            evt.stopPropagation();
          });
          */
        var children = [];
        //Build the child items
        _.forEach(resource.children, function (childItem) {
          children.push(createItem(childItem, displayItem, true));
        });

        //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
        //So we create its list of unlocked_by based on the items in the group
        //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
        //And add it to the unlocked_by of the group
        if (displayItem.unlocked_by.length === 0) {
          for (var i = 0; i < children.length; i++) {
            for (var n = 0; n < children[i].unlocked_by.length; n++) {
              var is_inner = true;
              for (var p = 0; p < children.length; p++) {
                //This is pointing from an item in the group to another item in the group
                if (children[i].unlocked_by[n] === children[p].slug) {
                  is_inner = false;
                }
              }
              //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
              if (is_inner) {
                displayItem.unlocked_by.push(children[i].unlocked_by[n]);
              }
            }
          }
        }

        // displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        if (!isSummative) {
          displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        } else {
          displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, false, !resource.complete);
        }
        if (start_hidden) {
          displayItem.sprite.visible = false;
          verlet_system.deactivateBody(resource.slug);
        }

        //Add the expandGroup listener to the item
        if (resource.resource_type === "group") {
          displayItem.setDelegate(expandGroup.bind(this));
          displayItem.isExpanded = false;
        }
        if (isSummative) {
          resource.locked = resource.unlocked_by && resource.unlocked_by.length > 0 ? resource.locked : false;
          if (force_unlock) {
            displayItem.unlock(true);
          }
          displayItem.sprite.position.x = -900;
          displayItem.sprite.position.y = -500;
        }
        if (prehighlighted_list.indexOf(resource.id) > -1) {
          // $log.log('PREHIGHLIGHTING : ', resource.slug)
          $timeout(function () {
            displayItem.showAgendaHighlight(true);
          }, 100);
        }
        return displayItem;
      };

      scope.$on('$destroy', function () {
        $log.log('from g78 map destroy');
        // language.resetAvilableOptions();
        EXISTS = false;
        MapStateService.setActiveModule("");
        //first save the state
        var active_items = verlet_system.getActiveSlugs();

        for (var i = 0; i < active_items.length; i++) {
          var item = getItemBySlug(active_items[i]);
          if (item) {
            MapStateService.setItemState(active_items[i], {
              x: item.sprite.position.x,
              y: item.sprite.position.y
            });
          }
        }

        MapStateService.setActiveItems(active_items);

        PIXI.loader.reset();
        PIXI_gr78_Load_Cache = false;
        stage.destroy(true);

        $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");
        if (canvas_el) {

          canvas_el.getContext('webgl').getExtension('WEBGL_lose_context').loseContext();
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll); // for Firefox
          canvas_el.removeEventListener('mousewheel', handleScroll); // for everyone else

          // prevent browser from selecting other html text when double clicking the PIXI canvas
          canvas_el.removeEventListener('pointerdown', handleDoubleClick);
        }
        verlet_system.clear();
        app.destroy();
        modules = [];
        window.removeEventListener("resize", onResize);
      });

      scope.$watch("moduleMapData", function (moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        if (MODULE_AVAILABLE_LANGUAGE[moduleMapData.resource_slug] && !(MapStateService.getFocusSlug() !== "" && moduleMapData.resource_slug.indexOf('meta') > -1)) {
          language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[moduleMapData.resource_slug]);
        }
        for (var i = 0; i < moduleMapData.resources.length; i++) {
          switch (moduleMapData.resources[i].slug) {
            case 'mtic_gr78_m2':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapTwo(moduleMapData.resources[i].children);
              break;
            case 'mtic_gr78_m1':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapOne(moduleMapData.resources[i].children);
              break;
            case 'mtic_gr78_m6':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapOne(moduleMapData.resources[i].children);
              break;
          }
        }

        if (!moduleMapData || EXISTS) {
          return;
        }

        var timer = window.isWebEmbedConnect ? 500 : 0;
        $timeout(function () {
          EXISTS = true;
          init();
        }, timer);
      });

      eventManager.listen('moduleview:agenda:selected', function (e, agenda) {
        for (var i = 0; i < items.length; i++) {
          //items[i].hideAgendaHighlight();
        }
        if (!agenda || !agenda.resources) {
          return;
        }
        switch (interpeteAgendaLockStatus(agenda)) {
          case 'unlock':
            return resourceLockManager.unlock(agenda.resources);
          // case 'lock':
          //   return resourceLockManager.lock(agenda.resources);
          // default:
          //   return resourceLockManager.reset();
        }
      });

      var workspace_list = {};
      var users_list = [];
      scope.$watch('[workspaceData.users, workspaceData.modules]', function (val) {
        var timer = window.isWebEmbedConnect && TeacherDataService.isTeacherWorkspaceView ? 500 : 50;
        // $log.log('workspace data : ' , scope.workspaceData, items)
        $timeout(function () {
          if (scope.workspaceData && scope.workspaceData.modules.length > 0 && (!scope.currentActiveSubModule || !scope.currentActiveSubModule.children)) {
            workspace_list = {};
            users_list = [];
            scope.workspaceData.users.forEach(function (user) {
              users_list.push(user.user_id);
            });

            scope.workspaceData.modules.forEach(function (work) {
              if (users_list.indexOf(work.user_id) > -1) {
                workspace_list[work.resource_id] = scope.workspaceData.users.length === 1 && (work.completed || workspace_list[work.resource_id]) ? true : false;
              }
            });

            //modules.forEach(function(built_mod){
            //container.removeChild(built_mod.graphics);
            //})

            // modules = [];
            for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
              if ((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) && (scope.moduleMapData.resources[i].id === 923 || scope.moduleMapData.resources[i].id === 955)) {
                //hide these
              } else {
                var module_container = createModuleContainer(scope.moduleMapData.resources[i], true);
                //modules.push(module_container);
              }
            }
          }
        }, timer);

        scope.itemSearchChange = function (val) {
          scope.filteredNameList = [];
          if (!scope.itemsNameList) {
            return;
          }
          if (val.trim() !== '') {
            scope.filteredNameList = scope.itemsNameList.filter(function (name) {
              var nameMod = name.name.toLowerCase();
              var valMod = val.toLowerCase();
              var bool_val;
              try {
                bool_val = nameMod.match(valMod);
              } catch (e) {
                bool_val = false;
              }
              return bool_val;
            });
          }
          // $log.log('scope.filteredNameList', scope.filteredNameList);
        };

        scope.view_controller = {
          isStudentView: true,
          isModulePanelView: true,
          openSubMod: function openSubMod(slug) {
            // $log.log('opening sub mod:', slug)
            $timeout(function () {
              eventManager.broadcast('module:change:submodule', slug);
            }, 1000);
          },
          openMainMod: function openMainMod(slug) {
            eventManager.broadcast('module:change:meta', 'mtic_gr78_m_meta');
          }
        };

        eventManager.listen('sidepanel:toggled', function (e, val) {
          if (!PlatformService.isPhonePortrait()) {
            onResize(val);
          }
        });

        eventManager.listen('hide_item_selection_highlight', function (e, resource) {
          var item = getItemBySlug(resource.slug);
          item.hideAgendaHighlight(true);
        });

        eventManager.listen('toggle_item_selection_highlight', function (e, slug) {
          var item = getItemBySlug(slug);
          item.showAgendaHighlight();
        });

        scope.zoom_function = function (val) {
          handleScroll({ detail: val, preventDefault: function preventDefault() {} });
          zooming = true;
          $timeout(function () {
            zooming = false;
          }, 10);
        };

        eventManager.listen('offline-post-call-resolved', function () {
          if (!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0 || !module_clicked) {
            for (var texture in PIXI.TextureCache) {
              var tmp = PIXI.Texture.removeTextureFromCache(texture);
              tmp.destroy(true);
            }
            eventManager.broadcast('refresh:current:tab');
            eventManager.broadcast('student:cycle:open');
          }
        });
      });
    }
  };
});

var PIXI_gr78_Load_Cache;
var EXISTS;
'use strict';

angular.module('mtic.components.modules.gr78').directive('lmapSidepanelNode', function ($log, language, EventManager, PanelStateService) {
  return {

    template:'<div ng-if="resource.slug !== \'mtic_g78_m1_beaker\' && resource.slug !== \'mtic_g78_m1_prop_table_b\'"><div ng-click="onNodeClick()" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:100%; cursor: pointer; padding: 2px 4px; border-bottom:1px solid #f1f1f1;" ng-style="getStyleModifiers()"><span style="display:inline-block; position:relative; top:3px; margin-right:6px;"><i ng-if="selected" ng-attr-class="fa fa-star" aria-hidden="true"></i> <i ng-attr-class="fa {{getIconCssClasses()}}" aria-hidden="true"></i></span> <span ng-bind="getName()"></span></div><div style="padding-left:20px;" ng-show="resource.isExpanded"><lmap-sidepanel-node ng-repeat="subresource in subresources" resource="subresource" module-map-data="moduleMapData"></lmap-sidepanel-node></div></div>',
    scope: {
      'resource': '=',
      'moduleMapData': '='
    },

    link: function link(scope, element) {
      var eventManager = new EventManager('lmapSidepanelNode', scope);

      scope.selected = false;
      scope.subresources = [];
      scope.databaseResource = {};
      var activeAgenda = null;
      var interpeteAgendaLockStatus = function interpeteAgendaLockStatus() {
        if (activeAgenda.force_unlock === true) {
          return 'unlock';
        } else if (activeAgenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      };
      scope.$watch('resource', function (resource) {
        if (resource) {
          //       $log.debug('[[lmapSidepanelNode]] rendering', scope.resource, resource)
          scope.subresources = resource.sub || [];
          scope.databaseResource = getDbResource(resource.slug);
        }
      });

      eventManager.listen('moduleview:agenda:selected', function (e, agenda) {
        activeAgenda = agenda;
      });
      eventManager.listen('module:select:resource', function (e, data) {
        if (data.slug === scope.resource.slug) {
          scope.selected = true;
        } else {
          scope.selected = false;
        }
      });
      eventManager.listen('module:dismiss:focus', function (e, data) {
        scope.selected = false;
      });

      scope.itemIsLocked = function () {
        var isLocked = scope.databaseResource ? scope.databaseResource.locked : true;
        if (activeAgenda && activeAgenda.resources && scope.databaseResource && activeAgenda.resources.indexOf(scope.databaseResource.id) > -1) {
          switch (interpeteAgendaLockStatus()) {
            case 'unlock':
              return false;
            case 'lock':
              return true;
          }
        }
        return isLocked;
      };
      scope.getName = function () {
        var name;
        /*
        if(scope.resource.slug && scope.resource.slug.indexOf("_m0")>1){
          name = language.get(scope.resource.slug+'_short');
        }else{
          name = language.get(scope.resource.slug);
        }*/

        name = language.get(scope.resource.slug);

        if (!name) {
          if (scope.databaseResource.name) {
            name = scope.databaseResource.name;
          } else {
            name = scope.resource.slug;
          }
        }
        return name;
      };

      scope.getIconCssClasses = function () {
        var shape = '';
        var color = '';
        if (scope.resource.slug === 'mtic_g78_m1_diag') {
          color = 'color-bubble-icon-assessment';
          shape = 'fa-check-circle';
        } else {
          if (scope.subresources.length > 0) {
            color = 'color-bubble-icon-group';
            shape = 'fa-stop';
          } else {

            color = 'color-bubble-icon-' + (scope.databaseResource.display && scope.databaseResource.display.color ? scope.databaseResource.display.color : 'blue');
            shape = 'fa-circle';
            // var databaseResource = getDbResource(scope.resource.slug);
            if (scope.databaseResource.complete) {
              shape = 'fa-check-circle';
            }
          }
        }
        return shape + ' ' + color;
      };

      scope.onNodeClick = function () {
        if (scope.subresources.length > 0) {
          toggleExpansion();
        } else {
          if (!scope.itemIsLocked()) {
            // var item_evt_info = {
            //   slug : scope.databaseResource.slug,
            //   id : scope.databaseResource.id
            // }
            eventManager.broadcast('module:select:resource', scope.databaseResource);
            eventManager.broadcast('module:center:resource', scope.databaseResource);
          }
        }
      };

      scope.getStyleModifiers = function () {
        if (scope.subresources.length > 0) {
          return {};
        } else {
          return { 'font-weight': 'bold' };
        }
      };

      var toggleExpansion = function toggleExpansion() {
        scope.resource.isExpanded = !scope.resource.isExpanded;
        PanelStateService.setResourceExpanded(scope.resource.slug, scope.resource.isExpanded);
      };

      var getDbResource = function getDbResource(slug, resources) {
        var passedChildren = false;
        if (!resources) {
          if (scope.moduleMapData && scope.moduleMapData.children) {
            resources = scope.moduleMapData.children;
          } else if (scope.moduleMapData && scope.moduleMapData.resources && Array.isArray(scope.moduleMapData.resources)) {
            resources = scope.moduleMapData.resources;
          } else {
            $log.warn('[[lmapSidepanelNode]] MISSING CHILDREN FOR `moduleMapData`');
            resources = [];
          }
        } else {
          passedChildren = true;
        }

        for (var i = 0; i < resources.length; i++) {
          var resource = resources[i];
          if (resource.slug === slug) {
            return resource;
          }
          if (resource.children && resource.children.length > 0) {
            resource = getDbResource(slug, resource.children);
            if (resource) {
              return resource;
            }
          }
        }
        if (passedChildren) {
          return false;
        } else {
          $log.warn("[[lmapSidepanelNode]] Could not find databaseResource for ", slug, scope);
          return {};
        }
      };

      if (scope.resource && !language.get(scope.resource.slug)) {
        $log.warn('No text defined for ', scope.resource.slug);
      }

      if (scope.resource && PanelStateService.getResourceExpanded(scope.resource.slug)) {
        toggleExpansion();
      }
    }
  };
});
'use strict';

angular.module('mtic.components.modules.gr78').directive('lmapSidepanelAgenda', function ($log, $q, language, EventManager, StudentDataService, PanelStateService, $timeout) {
  return {

    template:'<div><div ng-hide="loadingStatus.done">Loading ...</div><div ng-show="loadingStatus.done" ng-if="loadingStatus.error">An Error has occured!</div><div ng-show="loadingStatus.done" ng-if="!loadingStatus.error"><button ng-hide="true" type="button" class="button" ng-click="refresh()"><i class="fa fa-refresh" aria-hidden="true"></i></button><div class="studentSidebarAgendaUnit" ng-repeat="agenda in agendas track by $index"><div class="studentSidebarAgendaUnit__monthAndYear" ng-show="isNewAgendaMonth($index)"><span class="studentSidebarAgendaUnit__monthAndYearText" ng-bind="moment(agenda.date_close).format(\'YYYY MMMM\')"></span></div><div class="studentSidebarAgendaUnit__overviewInfo"><div class="studentSidebarAgendaUnit__overviewDays"><div class="studentSidebarAgendaUnit__overviewCalendarDay" ng-bind="moment(agenda.date_close).format(\'DD\')"></div><div class="studentSidebarAgendaUnit__overviewWeekDay" ng-bind="moment(agenda.date_close).format(\'ddd\')"></div></div><div class="studentSidebarAgendaUnit__nameAndProgress"><div class="studentSidebarAgendaUnit__name" title="{{language.get(agenda.description)}}" ng-bind="language.get(agenda.description)"></div><div class="studentSidebarAgendaUnit__progressBar"><div class="studentSidebarAgendaUnit__progressBarFill" ng-style="{\'width\':agenda.progress.prop*100+\'%\'}"></div></div></div></div><teacher-students-agenda-perf-preview module-map="moduleMapData" filtered-resources="agenda.resources" view-controller="view_controller" agenda-progress-map="agenda.resource_progress_map"></teacher-students-agenda-perf-preview></div></div></div>',
    scope: {
      'moduleMapData': '='
    },

    link: function link(scope, element) {
      var eventManager = new EventManager('lmapSidepanelAgendaNode', scope);
      moment.locale(language.getCurrentSelectedLanguage());
      scope.language = language;
      var selectedResourceId = -1;
      var studentAgendaItemHashMap = {};
      scope.loadingStatus = {
        done: false,
        error: false
      };
      scope.agendas = [];
      scope.active_agenda = {};
      scope.databaseResource = {};
      scope.resourceMapping = {};
      scope.agenda_progress = {
        total: 0,
        score: 0
      };

      scope.moment = moment;

      scope.getName = function (resourceId) {
        var name = '#(N/A)';
        if (scope.resourceMapping[resourceId]) {
          var resource = scope.resourceMapping[resourceId];
          /*
           if(resource.slug && (resource.slug.indexOf("_m0")>1||resource.slug.indexOf("_m4")>1)){
            name = language.get(resource.slug+'_short');
          }else{
            name = language.get(resource.slug);
          }*/

          name = language.get(resource.slug);

          if (!name) {
            if (resource.name) {
              name = resource.name;
            } else {
              name = resource.slug;
            }
          }
        }

        return name;
      };

      scope.getIconCssClasses = function (resourceId) {
        var shape = '';
        var color = '';
        var resource = scope.resourceMapping[resourceId];
        if (resource) {
          color = 'color-bubble-icon-' + (resource.display.color ? resource.display.color : 'blue');
          if (resourceIsComplete(resourceId)) {
            shape = 'fa-check-circle';
          } else {
            shape = 'fa-circle-o';
          }
        }
        return shape + ' ' + color;
      };
      scope.selectAgenda = function (agenda) {
        // scope.active_agenda = agenda;
        if (agenda && agenda.id) {
          //eventManager.broadcast('moduleview:agenda:selected', agenda);
          PanelStateService.setActiveAgenda(agenda.id);
        }
      };
      scope.onNodeClick = function (resourceId) {
        var resource = scope.resourceMapping[resourceId];
        var isLocked = isThisResourceLocked(resource);
        $log.debug('[[lmapSidepanelAgenda]] onNodeClick', resource, resourceId, isLocked);
        if (!isLocked && selectedResourceId === Number(resource.id)) {
          eventManager.broadcast('module:open:resource', resource);
        } else if (resource) {
          // var item_evt_info = {
          //   slug : resource.slug,
          //   id : resource.id
          // }
          eventManager.broadcast('module:select:resource', resource);
          eventManager.broadcast('module:center:resource', resource);
        }
      };
      scope.isSelected = function (resourceId) {
        return selectedResourceId === Number(resourceId);
      };
      scope.refresh = function () {
        eventManager.broadcast('agendapanel:refresh');
      };
      var isThisResourceLocked = function isThisResourceLocked(resource) {
        var isLocked = resource.locked;
        switch (interpeteAgendaLockStatus()) {
          case 'unlock':
            return false;
          case 'lock':
            return true;
          default:
            return isLocked;
        }
      };
      var interpeteAgendaLockStatus = function interpeteAgendaLockStatus() {
        if (scope.active_agenda.force_unlock === true) {
          return 'unlock';
        } else if (scope.active_agenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      };
      var resourceIsComplete = function resourceIsComplete(resourceId) {
        var mapResource = scope.resourceMapping[resourceId];
        var studentAgendaItemResource = studentAgendaItemHashMap[resourceId];
        return studentAgendaItemResource && studentAgendaItemResource.resource_completed || mapResource.resourceState && mapResource.resourceState.complete;
      };
      var placeCustomInMap = function placeCustomInMap(resource) {
        var parent_slug = resource.content.position_data.parent_slug;
        var index = Number(resource.content.position_data.index);
        // $log.log('scope.modulemapdata : ' , scope.moduleMapData)
        if (parent_slug === scope.moduleMapData.slug) {
          scope.moduleMapData.resources.splice(index, 0, resource);
          return;
        }

        scope.moduleMapData.resources.forEach(function (sub_mod) {

          if (sub_mod.display && sub_mod.display.panel) {
            if (sub_mod.slug === parent_slug) {
              sub_mod.display.panel.splice(index, 0, resource);
              return;
            }
            sub_mod.display.panel.forEach(function (sub) {
              checkResourceAndInsert(sub, resource);
            });
          }
        });
      };
      var checkResourceAndInsert = function checkResourceAndInsert(sub, resource) {
        if (sub.sub) {
          if (sub.slug === resource.content.position_data.parent_slug) {
            sub.sub.splice(Number(resource.content.position_data.index), 0, resource);
          } else {
            sub.sub.forEach(function (sub_sub) {
              checkResourceAndInsert(sub_sub, resource);
            });
          }
        }
      };
      var checkIfResourcesAreInMapElseAttemptToGrab = function checkIfResourcesAreInMapElseAttemptToGrab(agendaData) {
        return $q.all(agendaData.map(function (agenda) {
          return $q.all(agenda.resources.map(function (resourceId) {
            if (!scope.resourceMapping[resourceId]) {
              // $log.log('lmap get custom : ', resourceId)
              return StudentDataService.getCustomResource(resourceId).then(function (resource) {
                scope.resourceMapping[resourceId] = resource;
                if (resource.content && resource.content.position_data) {
                  placeCustomInMap(resource);
                }
                // $log.log('mapping custom : ', resource)
                return;
              });
            } else {
              return $q.resolve();
            }
          }));
        })).then(function () {
          return agendaData;
        });
      };
      var force_unlock_summatives = [];
      var calcProgress = function calcProgress(agenda) {
        agenda.progress = {};
        agenda.progress.total = 0;
        agenda.progress.score = 0;
        agenda.resource_progress_map = {};
        studentAgendaItemHashMap = {};
        agenda.StudentAgendaItems.forEach(function (studentAgendaItem) {
          studentAgendaItemHashMap[studentAgendaItem.resource_id] = studentAgendaItem;
        });
        agenda.resources.forEach(function (resourceId) {
          var resource = scope.resourceMapping[resourceId];
          if (resource && resource.display) {
            if (resource.resource_type === "custom_resource") {
              agenda.progress.score = studentAgendaItemHashMap[resourceId] ? agenda.progress.score + 1 : agenda.progress.score;
              agenda.resource_progress_map[resource.slug] = studentAgendaItemHashMap[resourceId] ? true : false;
            } else if (!agenda.force_redo || agenda.force_redo && studentAgendaItemHashMap[resource.id]) {
              agenda.progress.score += resource.complete ? 1 : 0;
              agenda.resource_progress_map[resource.slug] = resource.complete;
            } else {
              agenda.resource_progress_map[resource.slug] = false;
              if (resource.config && resource.config.assessment_type && (agenda.force_redo && resource.complete || agenda.force_unlock)) {
                resource.locked = false;
                if (force_unlocked_list.indexOf(resource.slug) === -1) {
                  force_unlocked_list.push(resource.slug);
                }
                resource.locked = false;
                eventManager.broadcast('unlock-item', resource.slug);
              }
            }

            agenda.progress.total++;
          }
        });
        agenda.progress.prop = agenda.progress.score / agenda.progress.total;
        // $log.log('agenda progress : ', agenda, studentAgendaItemHashMap)//, scope.resourceMapping)
      };

      var init = function init() {
        scope.resourceMapping = {};
        scope.loadingStatus.done = false;
        scope.loadingStatus.error = false;
        return $q.all([$q(function (resolve) {
          scope.moduleMapData.resources.forEach(function (moduleMap) {
            moduleMap.children.forEach(function (resource) {
              scope.resourceMapping[resource.id] = angular.copy(resource);
              if (resource.children) {
                resource.children.forEach(function (sub) {
                  scope.resourceMapping[sub.id] = angular.copy(sub);
                });
              }
            });
          });
          resolve();
        }), StudentDataService.getAgendas()]).then(function (datas) {
          return checkIfResourcesAreInMapElseAttemptToGrab(datas[1]);
        }).then(function (agendaData) {
          eventManager.broadcast('moduleview:agenda:loaded', agendaData);
          scope.agendas = agendaData;
          scope.agendas.sort(dateSort);
          // $log.log('got agendas : ', agendaData)
          scope.agendas.forEach(function (agenda) {
            calcProgress(agenda);
          });
          var active_agenda_index = 0;
          if (PanelStateService.getActiveAgenda() !== undefined) {
            var target_id = PanelStateService.getActiveAgenda();
            for (var i = 0; i < agendaData.length; i++) {
              if (agendaData[i].id === target_id) {
                active_agenda_index = i;
                break;
              }
            }
          }

          scope.active_agenda = agendaData[active_agenda_index];
          sendSummInfo();

          //eventManager.broadcast('moduleview:agenda:selected', agendaData[active_agenda_index]);
        }).then(function () {
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = false;
        }).catch(function (err) {
          $log.error(err);
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = true;
        });
      };

      function dateSort(a, b) {
        if (Date.parse(a.date_close) < Date.parse(b.date_close)) {
          return -1;
        }
        if (Date.parse(a.date_close) > Date.parse(b.date_close)) {
          return 1;
        }
        return 0;
      }

      eventManager.listen('agendapanel:refresh', function () {
        init();
      });

      eventManager.listen('module:select:resource', function (e, resource) {
        selectedResourceId = Number(resource.id);
      });

      eventManager.listen('module:dismiss:focus', function (e, data) {
        selectedResourceId = -1;
      });
      //There must be a better way :thinking:
      eventManager.listen('moduleview:agenda:request', function (e) {
        //eventManager.broadcast('moduleview:agenda:selected', scope.active_agenda);
      });

      // eventManager.listen('moduleview:agenda:selected', function(e, agenda) {
      //   $log.log('is this ever triggered ? ')
      //   if (agenda && agenda !== null && 'StudentAgendaItems' in agenda && 'resources' in agenda) {
      //       calcProgress(agenda);
      //     }
      // })

      eventManager.listen('creating-items-done', function () {
        scope.agendas.forEach(function (agenda) {
          calcProgress(agenda);
        });
      });

      var lockedSummativeList = [];
      var force_unlocked_list = [];
      scope.$watch("moduleMapData", function () {
        init();
      });

      function sendSummInfo() {
        // if(scope.moduleMapData.module_id === 28 || scope.moduleMapData.module_id === 2 || scope.moduleMapData.module_id === 321){
        var unlockedSummativeList = [];
        scope.agendas.forEach(function (agenda) {
          agenda.resources.forEach(function (summ) {
            unlockedSummativeList.push(scope.resourceMapping[summ].slug);
          });
        });
        $timeout(function () {
          eventManager.broadcast('got-c4-summative-data', { unlocked: unlockedSummativeList, force_unlock: force_unlocked_list });
        }, 500);
        // }        
      }

      scope.isReleventDiagLocked = function (resc) {
        //console.log('should hide : ', scope.resourceMapping[resc].slug, lockedSummativeList.indexOf(scope.resourceMapping[resc].slug));
        return lockedSummativeList.indexOf(scope.resourceMapping[resc].slug) > -1;
      };

      // var dayRef = ['SUN','MON','TUE','WED','THU','FRI','SAT']
      // scope.getFormattedDateDay = function(date){
      //   var day = (new Date(Date.parse(date))).getDay()
      //   return dayRef[day]
      // }
      // scope.getFormattedDateDayNum = function(date){
      //   var day = (new Date(Date.parse(date))).getDate()
      //   return day;
      // } 
      // var monthRef = ['January','February','March','April','May','June','July',
      // 'August','September','October','November','December']
      // scope.getFormattedDateMonth = function(date){
      //   var date_parse = new Date(date);
      //   return date_parse.getFullYear() + ' ' + monthRef[date_parse.getMonth()];
      // }
      scope.getFormattedFullDate = function (date) {
        return date.split('T')[0].split('-').join('/');
      };
      scope.isNewAgendaMonth = function (index) {
        if (index === 0) {
          return true;
        }
        var date1 = new Date(Date.parse(scope.agendas[index].date_close));
        var date2 = new Date(Date.parse(scope.agendas[index - 1].date_close));
        return date1.getFullYear() !== date2.getFullYear() || date1.getMonth() !== date2.getMonth();
      };

      scope.view_controller = {
        isStudentView: true,
        openSubMod: function openSubMod(slug) {
          // $log.log('opening sub mod:', slug)
          $timeout(function () {
            eventManager.broadcast('module:change:submodule', slug);
          }, 1000);
        },
        openMainMod: function openMainMod(slug) {
          eventManager.broadcast('module:change:meta', 'mtic_gr78_m_meta');
        }
      };
    }
  };
});
'use strict';

angular.module('mtic.components.modules.gr78').directive('lmapBottomPanel', function ($log, language, EventManager, DEV_VARIABLES, TeacherDataService, ModuleFilter) {
  return {

    template:'<div class="lmapBottomPanel"><div class="lmapBottomPanel__leftSide"><div class="lmapBottomPanel__starsWrap" ng-show="hasActiveItem()"><img ng-if="getMaxStarCount() > 0" class="lmapBottomPanel__star" ng-class="{\'lmapBottomPanel__star--disabled\': getCompleteStarCount() <= 0 }" src="assets/images/c3-module/star.png"> <img ng-if="getMaxStarCount() > 1" class="lmapBottomPanel__star" ng-class="{\'lmapBottomPanel__star--disabled\': getCompleteStarCount() <= 1 }" src="assets/images/c3-module/star.png"> <img ng-if="getMaxStarCount() > 2" class="lmapBottomPanel__star" ng-class="{\'lmapBottomPanel__star--disabled\': getCompleteStarCount() <= 2 }" src="assets/images/c3-module/star.png"></div><div class="lmapBottomPanel__moduleName"><div ng-show="hasActiveItem()" class="lmapBottomPanel__moduleNameText" ng-bind="getName()"></div><div ng-hide="hasActiveItem()" class="lmapBottomPanel__moduleNameText lmapBottomPanel__moduleNameText--disabled" ng-bind="getTranslation(\'14576\')">NO ITEM SELECTED</div></div></div><div class="lmapBottomPanel__rightSide" ng-class="{\'is-leaderboard-active\': true}"><button ng-if="!itemIsLocked()" type="button" class="button is-large is-primary" ng-click="itemClicked()" ng-show="hasActiveItem()" style="font-weight:600" ng-bind="getTranslation(\'start_item\')">START</button> <button ng-if="itemIsLocked()" ng-show="hasActiveItem()" ng-click="itemClickedTeacherCheck()" type="button" class="button is-large is-primary" style="font-weight:600"><i class="fa fa-lock" aria-hidden="true"></i></button></div></div>',
    scope: {
      'moduleMapData': '='
    },

    link: function link(scope, element) {
      scope.highlightedResource = {};
      scope.activeResource = {};
      var eventManager = new EventManager('lmapBottomPanel', scope);
      var activeAgenda = null;
      var interpeteAgendaLockStatus = function interpeteAgendaLockStatus() {
        if (activeAgenda.force_unlock === true) {
          return 'unlock';
        } else if (activeAgenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      };
      scope.itemIsLocked = function () {
        var isLocked = scope.highlightedResource.locked;
        if (activeAgenda && activeAgenda.resources && !(scope.highlightedResource.config && scope.highlightedResource.config.assessment_type && scope.highlightedResource.complete) && activeAgenda.resources.indexOf(scope.highlightedResource.id) > -1) {
          switch (interpeteAgendaLockStatus()) {
            case 'unlock':
              return false;
            case 'lock':
              return isLocked;
          }
        }
        return isLocked;
      };
      scope.itemClickedTeacherCheck = function () {
        if (TeacherDataService.isTeacherModuleView) {
          scope.itemClicked();
        }
      };
      scope.itemClicked = function () {
        if (!ModuleFilter.checkAvailable(scope.highlightedResource)) {
          scope.highlightedResource.locked = true;
          eventManager.broadcast('display-maintenance-message', scope.highlightedResource.slug);
          return;
        }
        if (!scope.itemIsLocked() || TeacherDataService.isTeacherModuleView) {
          eventManager.broadcast('module:open:resource', scope.highlightedResource);
        }
      };
      scope.dismissClicked = function () {
        eventManager.broadcast('module:dismiss:focus');
      };
      scope.isCustomResource = function () {
        return scope.highlightedResource.resource_type === 'custom_resource';
      };
      eventManager.listen('module:select:resource', function (e, resource) {
        if (DEV_VARIABLES.RESOURCES.HIDE_THESE.indexOf(resource.slug) > -1 || resource.config && resource.config.hidden === true) {
          return;
        }

        scope.activeResource = resource;

        if (scope.moduleMapData === undefined) {
          return;
        }
        var item_info = null;
        // $log.log('select resource : ', resource, scope.moduleMapData)
        for (var i = 0; i < scope.moduleMapData.children.length; i++) {
          if (scope.moduleMapData.children[i].slug === resource.slug) {
            item_info = scope.moduleMapData.children[i];
            break;
          }
        }
        //If this item is already focused on, open it

        if (scope.highlightedResource && !TeacherDataService.isTeacherWorkspaceView && scope.highlightedResource.slug === item_info.slug && (item_info.locked === false || scope.highlightedResource.config && scope.highlightedResource.config.assessment_type === 'summative' && !scope.itemIsLocked())) {
          eventManager.broadcast('module:open:resource', resource);
          return;
        } else {
          scope.highlightedResource = item_info;
        }
      });
      eventManager.listen('moduleview:agenda:selected', function (e, agenda) {
        activeAgenda = agenda;
      });
      eventManager.listen('module:dismiss:focus', function (e, data) {
        scope.highlightedResource = {};
      });

      scope.getTranslation = function (slug) {
        var caption = language.get(slug);
        if (!caption) {
          caption = slug;
        }
        return caption;
      };

      scope.getCompleteStarCount = function () {
        var resource = scope.highlightedResource;
        if (resource.resourceState) {
          if (resource.display.color === 'blue') {
            return Math.floor(resource.resourceState.score_max);
          }
          if (resource.resourceState.score_max >= 1) {
            return 3;
          } else if (resource.resourceState.score_max >= 0.8) {
            return 2;
          } else if (resource.resourceState.score_max >= 0.5) {
            return 1;
          }
          return 0;
        } else {
          return 0;
        }
      };

      scope.getMaxStarCount = function () {
        var resource = scope.highlightedResource;
        if (resource) {
          if (resource.resource_type === "assessment") {
            // console.log('getMaxStarCount', 3)
            return 0;
          } else if (resource.display) {
            if (resource.display.color === 'blue') {
              // console.log('getMaxStarCount', 1)
              return 1;
            } else {
              // console.log('getMaxStarCount', 3)
              return 3;
            }
          }
        }
        // console.log('getMaxStarCount', '0 (default)')
        return 0;
      };

      scope.getName = function () {
        var resource = scope.highlightedResource;
        var name = language.get(resource.slug);
        if (!name) {
          if (resource.name) {
            name = resource.name;
          } else {
            name = resource.slug;
          }
        }
        return name;
      };

      eventManager.listen('language:change', function () {
        $log.debug(scope.highlightedResource);
      });

      scope.hasActiveItem = function () {
        return true && scope.highlightedResource && scope.highlightedResource.name;
      };
      scope.$watch('moduleMapData', function () {
        if (scope.moduleMapData === undefined) {
          return;
        }

        // $log.log('MMD : ', scope.moduleMapData)

        if (scope.activeResource !== undefined) {
          var item_info = null;
          if (scope.moduleMapData.children) {
            for (var i = 0; i < scope.moduleMapData.children.length; i++) {
              if (scope.moduleMapData.children[i].slug === scope.activeResource.slug) {
                scope.highlightedResource = scope.moduleMapData.children[i];
                return;
              }
            }
          }
        }
      });
      scope.$on('$destroy', function () {
        eventManager.broadcast('module:dismiss:focus');
      });
    }
  };
});
'use strict';

/*
  The purpose of the LEARNING MAP is to contain the logic to display a Verlet enabled map
  With mouse navigation and not much else.

  It is different from the meta-map because it does not handle the entire
  meta module structure on its own, it just displays an array of resources.
  It does absolutely no post-processing on the structure of the resources.
  something else has to explicitely tell this what to show

  It also doesn't provide functions for the side and bottom panels like the meta map does.
*/

angular.module('mtic.components.modules.gr78').directive('gr78LearningMap', function (DEV_VARIABLES, GR78_ASSET_URL, $q, $timeout, TIMING_CONSTANTS, $log, $window, gr78MapItemFactory, VerletSystemService, TeacherDataService, learningMapUtil, PIXI, EventManager, language) {

  return {

    template:'<div class="inner-viewport" style="overflow:hidden;"><canvas id="canvas" width="300" height="300"></canvas></div>',
    scope: {
      moduleMapData: "="
    },
    link: function link(scope) {

      // event manager for coordination with rest of application
      var eventManager = new EventManager('gr78LearningMap', scope);
      var verlet_system = new VerletSystemService();
      ///////////////////
      // PRIVATE VARS //
      /////////////////

      var canvas_el = null;
      var app = null;
      var renderer = null;
      var drag_info = null;
      var canvasDimensions = null;
      var scale = null;
      var stage = null;
      var modules_container = null;
      var container = null;
      var lines_graphic = null;
      var selection_graphic = null;
      var items = [];
      var isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);

      var img_asset_paths = [GR78_ASSET_URL + "symlink.png", GR78_ASSET_URL + "item_blue_0.png", GR78_ASSET_URL + "item_blue_1.png", GR78_ASSET_URL + "item_red_0.png", GR78_ASSET_URL + "item_red_1.png", GR78_ASSET_URL + "item_red_2.png", GR78_ASSET_URL + "item_red_3.png", GR78_ASSET_URL + "item_black_0.png", GR78_ASSET_URL + "item_black_1.png", GR78_ASSET_URL + "item_black_2.png", GR78_ASSET_URL + "item_black_3.png", GR78_ASSET_URL + "item_blue_locked.png", GR78_ASSET_URL + "item_red_locked.png", GR78_ASSET_URL + "item_black_locked.png", GR78_ASSET_URL + "assessment.png", GR78_ASSET_URL + "assessment_complete.png", GR78_ASSET_URL + "selection.png"];
      var focus_item = null;
      var selection = null;

      /////////////
      // CONSTRUCTOR
      /////////////

      function init() {
        // retrieve template element references
        canvas_el = document.getElementById('canvas');
        if (!canvas_el) {
          return;
        }

        app = new PIXI.Application(300, 300, {
          autoResize: true,
          backgroundColor: 0xdee9fc,
          antialias: true,
          view: canvas_el
        });

        renderer = app.renderer;
        scale = 0.8;
        items = [];
        drag_info = learningMapUtil.getDragInfoSettings();

        canvasDimensions = {
          width: window.innerWidth,
          height: window.innerHeight - 50
        };

        stage = app.stage;
        stage.interactive = true;

        window.addEventListener("resize", onResize);
        onResize();
        renderer.render(stage);

        container = new PIXI.Sprite();
        container.interactive = true;
        container.scale.set(scale, scale);
        container.x = renderer.width / 2;
        container.y = renderer.height / 2;
        stage.addChildAt(container, 0);

        lines_graphic = new PIXI.Graphics();
        container.addChild(lines_graphic);

        app.ticker.add(update);

        canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else
        canvas_el.addEventListener('pointerdown', handleDoubleClick, false);

        stage.on('pointerdown', function (e) {
          drag_info.dragging = true;
          focus_item = null;
          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: container.x,
            y: container.y
          };
          drag_info.start_drag_mouse_pos = {
            x: renderer.plugins.interaction.eventData.data.global.x,
            y: renderer.plugins.interaction.eventData.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };
        });
        stage.on('pointerup', function (e) {
          if (window.DEBUG_TOUCH) {
            $log.log('g78_lmap pointerup ; ', JSON.stringify(drag_info));
          }
          drag_info.dragging = false;
        });

        if (window.DEBUG_TOUCH) {
          $log.log('g78_lmap pointerdown ; ', JSON.stringify(drag_info));
        }

        return loadAssets().then(function () {
          $log.debug('[[gr78MetaMap]] loadAssets.then');
          return;
        }).catch(function (err) {
          $log.error('[[gr78MetaMap]] loadAssets.then', err.message);
          $log.debug(err.stack);
        });
      }

      eventManager.listen('module:select:resource', function (e, data) {
        var mapResource = getItemBySlug(data.slug);
        if (mapResource === null) {
          return;
        }
        if (selection === mapResource) {
          eventManager.broadcast('module:open:resource', data);
          return;
        }
        selection = mapResource;
        mapResource.sprite.addChildAt(selection_graphic, 0);
        selection_graphic.scale.set(0);
      });

      eventManager.listen('module:center:resource', function (e, data) {
        focus_item = getItemBySlug(data.slug);
      });

      eventManager.listen('module:stop:pan', function () {
        focus_item = null;
      });

      eventManager.listen('resource:highlight:agenda', function (e, data) {
        $log.debug(data);
        var i, n, item;
        for (i = 0; i < items.length; i++) {
          item = items[i];
          item.hideAgendaHighlight();
          for (n = 0; n < data.length; n++) {
            if (item.slug === data[n].slug) {
              item.showAgendaHighlight();
              break;
            }
          }
        }
      });

      eventManager.listen('module:change:submodule', function (e, data) {
        $timeout(function () {
          verlet_system.deactivateAllBodies(true);
          $log.debug(data);
          $log.debug(scope);
          for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
            if (scope.moduleMapData.resources[i].slug === data) {
              scope.currentActiveSubModule = scope.moduleMapData.resources[i];
              var resource = scope.moduleMapData.resources[i];
              for (var n = 0; n < resource.children.length; n++) {

                if (resource.children[n].slug === 'mtic_g78_m1_beaker' || resource.children[n].slug === 'mtic_g78_m1_prop_table_b') {
                  continue;
                }

                verlet_system.activateBody(resource.children[n].slug, true);
              }
              break;
            }
          }
        }, TIMING_CONSTANTS.INSTANT);
      });
      /////////////
      // METHODS
      /////////////

      //Mousewheel zoom/in out at cursor position (like google maps)
      var handleScroll = function handleScroll(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = evt.detail < 0 || evt.wheelDelta > 0 ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.5, scale + direction / 15), 0.25);
        var diff = scale - start_scale;
        container.scale.set(scale, scale);

        //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
        var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
        container.position.x -= diff * pos.x;
        container.position.y -= diff * pos.y;

        evt.preventDefault();
        return false;
      };

      var handleDoubleClick = function handleDoubleClick(e) {
        e.preventDefault();
        return false;
      };

      var initMapDraw = function initMapDraw(moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        var combinedResourceMap = {};

        _.forEach(moduleMapData, function (someItem) {
          combinedResourceMap[someItem.slug] = someItem;
          loadChildren(someItem);
        });

        _.each(combinedResourceMap, function (resource) {
          createItem(resource, null);
        });
        _.forEach(items, function (item) {
          if (!item.locked) {
            item.unlock();
          }
        });
      };

      //This loops to control things that should update every frame
      var update = function update() {
        if (selection_graphic !== null) {
          //Rotate it a little bit
          selection_graphic.rotation = (selection_graphic.rotation - 0.015) % (Math.PI * 2);

          //Use UNIX time to scale the graphic with a sin function
          //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
          selection_graphic.scale.set((selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / 10);
        }

        //update the verlet force directed graph that positions the map items in that big jiggly web
        verlet_system.update();
        //   drawMapLines();
        if (drag_info.dragging) {
          var mouse_pos = {
            x: renderer.plugins.interaction.eventData.data.global.x,
            y: renderer.plugins.interaction.eventData.data.global.y
          };
          if (isNaN(mouse_pos.x) || isNaN(mouse_pos.y) || isMobile && renderer.plugins.interaction.eventData.data.identifier === 'MOUSE') {
            mouse_pos.x = drag_info.last_mouse_pos.x;
            mouse_pos.y = drag_info.last_mouse_pos.y;
          }

          //Move the map based on the mouse position
          container.position.x = drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
          container.position.y = drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);

          //vector of mouse movement since last update frame
          var delta_pos = {
            x: drag_info.last_mouse_pos.x - mouse_pos.x,
            y: drag_info.last_mouse_pos.y - mouse_pos.y
          };

          //add the mouse movement vector to the map movement velocity (inertia)
          drag_info.velocity = {
            x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
            y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
          };

          //store the current position in the last_mouse_pos to calculate the movement vector next frame
          drag_info.last_mouse_pos = {
            x: mouse_pos.x,
            y: mouse_pos.y
          };
        } else {
          //If they're not dragging, move the map based on its inertia and damp the inertia
          container.position.x -= drag_info.velocity.x;
          container.position.y -= drag_info.velocity.y;
          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;
        }
        focusItemTicker();

        lines_graphic.clear();
        lines_graphic.lineStyle(8, 0xCCCCDD, 1);
        var segments = verlet_system.getLineSegments();
        var i;
        for (i = 0; i < segments.solid.length; i++) {
          lines_graphic.moveTo(segments.solid[i].start.x, segments.solid[i].start.y);
          lines_graphic.lineTo(segments.solid[i].end.x, segments.solid[i].end.y);
        }
        lines_graphic.beginFill(0xFF0000, 1);
        for (i = 0; i < segments.dash.length; i++) {
          lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
        }
        lines_graphic.endFill();

        if (window.DEBUG_TOUCH) {
          $log.log('g78_lmap update ; ', JSON.stringify(drag_info));
        }
      };

      /**
       *Expand a subgroup to reveal child items
       *slug is a unique String that identifies the group MapItem
       **/
      var expandGroup = function expandGroup(slug) {
        if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(slug) > -1) {
          return;
        }
        //Cancel this mouse event if they were dragging more than 10 pixels
        if (drag_info.dragging) {
          if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
            return;
          }
        }

        if (verlet_system.deactivateBody(slug, true)) {
          var group = getItemBySlug(slug);
          //position all of the sub items so that they appear from where the clicked group icon is
          for (var i = 0; i < items.length; i++) {
            if (items[i].parentItem === group) {
              items[i].sprite.position.x = group.sprite.position.x;
              items[i].sprite.position.y = group.sprite.position.y;
              verlet_system.activateBody(items[i].slug, true);
            }
          }
        }
      };

      /**
       *Collapse a subgroup to hide child items
       *slug is a unique String that identifies the group MapItem
       **/
      var collapseGroup = function collapseGroup(slug) {
        var group = getItemBySlug(slug);
        if (group.isExpanded === true) {
          toggleGroupExpanded(group);
        }
      };

      /**
       *Toggle the expand/collapse of a given item group
       *group is a MapItem
       **/
      var toggleGroupExpanded = function toggleGroupExpanded(group) {
        group.isExpanded = !group.isExpanded;
        //    baseVerletSystem.hookUpConstraints();
      };

      //If focus item is defined, pan towards it
      var focusItemTicker = function focusItemTicker() {
        if (focus_item === null) {
          return;
        }
        var abs_pos = container.toGlobal(focus_item.sprite.position);
        container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
        container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
      };

      /**
       *Return a MapItem whose slug matches the passed slug
       *Returns null if no MapItem can be found
       */
      var getItemBySlug = function getItemBySlug(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      };

      var getItemById = function getItemById(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      };

      var onResize = function onResize() {
        canvasDimensions = {
          width: window.innerWidth,
          height: window.innerHeight - 52
        };
        stage.hitArea = new PIXI.Rectangle(0, 0, canvasDimensions.width, canvasDimensions.height);
        if (!document.getElementById('canvas')) {
          return;
        }
        document.getElementById('canvas').width = canvasDimensions.width;
        document.getElementById('canvas').height = canvasDimensions.height;

        renderer.resize(canvasDimensions.width, canvasDimensions.height);
      };

      // scope.$watch("moduleMapData", function (moduleMapData) {

      //this is what runs to initialize the map
      var loadAssets = function loadAssets() {
        $log.debug('[[gr78MetaMap]] loadAssets');
        return $q(function (resolve, reject) {
          try {
            if (!PIXI_gr78_Load_Cache) {
              PIXI.loader.reset();
              PIXI.loader.add(img_asset_paths).load(function () {
                // $log.debug('loaded resources', PIXI.loader.resources)
                PIXI_gr78_Load_Cache = true;
                initMap(resolve);
              });
            } else {
              initMap(resolve);
            }
          } catch (err) {
            $log.error('[[gr78MetaMap]]', err);
            reject(err);
          }
        });
      };

      var initMap = function initMap(resolve) {
        initMapDraw(scope.moduleMapData);

        $timeout(function () {
          verlet_system.deactivateAllBodies(true);
          for (var i = 0; i < scope.moduleMapData.length; i++) {
            if (scope.moduleMapData[i].slug.indexOf('mtic_g78_m2_sum') === -1) {
              verlet_system.activateBody(scope.moduleMapData[i].slug, true);
            }
          }
        }, TIMING_CONSTANTS.INSTANT);
        if (selection_graphic === null) {
          selection_graphic = new PIXI.Sprite(PIXI.loader.resources[GR78_ASSET_URL + 'selection.png'].texture);
          selection_graphic.anchor.set(0.5, 0.5);
          selection_graphic.scale.set(0.75, 0.75);
          selection_graphic.interactive = false;
          selection_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
        }

        resolve();
      };

      var loadChildren = function loadChildren(someItem) {
        someItem.childResourcemap = [];
        if (someItem.children === undefined) {
          return;
        }
        if (someItem.children.length > 0) {
          _.forEach(someItem.children, function (childItem) {
            someItem.childResourcemap[childItem.slug] = childItem;
            loadChildren(childItem);
          });
        }
      };

      var createItem = function createItem(resource, parentItem, start_hidden) {
        if (resource.display && !resource.display.position) {
          if (resource.children && resource.children.length > 0) {
            _.forEach(resource.children, function (childItem) {
              createItem(childItem, parentItem);
            });
          }
          return;
        }

        if (verlet_system.getBody(resource.slug) !== undefined) {
          return;
        }
        var displayItem;

        //Add this to the map logic array of items
        items.push(displayItem = new gr78MapItemFactory.createMapItem(resource, eventManager));

        //create a VerletBody for the item
        displayItem.parentItem = parentItem;

        container.addChild(displayItem.sprite);

        if (TeacherDataService.isTeacherModuleView) {
          resource.locked = false;
        }

        var children = [];
        //Build the child items
        _.forEach(resource.children, function (childItem) {
          children.push(createItem(childItem, displayItem, true));
        });

        //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
        //So we create its list of unlocked_by based on the items in the group
        //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
        //And add it to the unlocked_by of the group
        if (displayItem.unlocked_by && displayItem.unlocked_by.length === 0) {
          for (var i = 0; i < children.length; i++) {
            for (var n = 0; n < children[i].unlocked_by.length; n++) {
              var is_inner = true;
              for (var p = 0; p < children.length; p++) {
                //This is pointing from an item in the group to another item in the group
                if (children[i].unlocked_by[n] === children[p].slug) {
                  is_inner = false;
                }
              }
              //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
              if (is_inner) {
                displayItem.unlocked_by.push(children[i].unlocked_by[n]);
              }
            }
          }
        }

        displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        if (start_hidden) {
          displayItem.sprite.visible = false;
          verlet_system.deactivateBody(resource.slug);
        }

        //Add the expandGroup listener to the item
        if (resource.resource_type === "group") {
          displayItem.setDelegate(expandGroup.bind(this));
          displayItem.isExpanded = false;
        }
        return displayItem;
      };

      this.destroy = function () {
        $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");
        if (canvas_el) {
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll);
          canvas_el.removeEventListener('mousewheel', handleScroll);
          canvas_el.removeEventListener('pointerdown', handleDoubleClick);
        }
        stage.removeChildren();
        container.removeChildren();
        app.destroy();
        window.removeEventListener("resize", onResize);
        EXISTS = false;
      }.bind(this);

      scope.$on('$destroy', function () {
        this.destroy();
      }.bind(this));

      scope.$watch("moduleMapData", function (moduleMapData) {
        if (!moduleMapData) {

          return;
        }
        if (!EXISTS) {
          EXISTS = true;
          init();
        } else {
          initMap(function () {});
        }
      });
    }
  };
});

var PIXI_gr78_Load_Cache;
var EXISTS;
'use strict';

angular.module('mtic.components.modules', ['ngPostMessage', 'pixi', 'mtic.components.mtic_resource', 'mtic.components.modules.qcModule', 'mtic.components.modules.learningMap', 'mtic.components.modules.gr78', 'mtic.components.modules.bubbleModule', 'mtic.components.modules.c3', 'mtic.components.modules.moduleIframe', 'mtic.components.modules.c4', 'mtic.components.modules.generalModuleMap']);

angular.module('mtic.components.modules').directive('mticModules', function ($log, preliveCheck, api, EventManager, language, WindowOpener, TeacherDataService, $timeout, MapStateService, $q, userAccount, $sce, PlatformService, cordovaMessenger) {
      return {
            template:'<div ng-if="currentResource"><mtic-resource window-id="{{windowId}}" resource="currentResource" module-id="moduleMapData.module_id" class-id="moduleMapData.class_id"></mtic-resource></div><ng-switch ng-hide="noModule" on="currentModule" ng-if="!currentResource && currentModule" ng-class="mSelectedModuleView"><iframe ng-src="{{trustSrc(custom_resource_url)}}" ng-switch-when="custom_resource" style="width:90%;margin-left:5%;background-color:#fff;height:100%;position:fixed"></iframe><module-meta-map ng-switch-default module-map-data="moduleMapData"></module-meta-map><qc-module ng-switch-when="qc_module" module-map-data="moduleMapData"></qc-module><div class="module-view-toggle" ng-click="mToggleModuleView($event)"><div class="inner-container"><div class="map-icon module-view-icon"></div><div class="text-toggle"><div class="slider"></div></div><div class="list-icon module-view-icon"></div></div></div></ng-switch><style>\r\n\r\n.fr-only-dialogue {\r\n  width:600px;\r\n  display: block;\r\n  position: absolute;\r\n  margin-top: 12px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  border: 1px solid #d4d4d4;\r\n  padding: 24px 48px;\r\n  text-align: center;\r\n  font-size: 16px;\r\n  box-shadow: 1px 2px 4px 0px rgba(0,0,0,0.1);\r\n  transition: 0.2s ease-in all;\r\n}\r\n\r\n.fr-only-dialogue--hidden {\r\n  pointer-events: none;\r\n  opacity: 0;\r\n}\r\n\r\n.fr-only-dialogue__closeButton {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 12px;\r\n  color: #333;\r\n  opacity: 0.4;\r\n  cursor: pointer;\r\n  transition: 0.12s ease-out all;\r\n}\r\n\r\n.fr-only-dialogue__closeButton:hover {\r\n  opacity: 0.7;\r\n}\r\n\r\n</style><div ng-if="item_maintenance" class="fr-only-dialogue" ng-class="{\'fr-only-dialogue--hidden\': itemMaintenanceMsgHidden}" style="z-index: 2;"><div class="fr-only-dialogue__closeButton" ng-click="hide_maintenance_msg()">&#10006;</div><p class="fr-only-dialogue__paragraph"><span ng-bind="get_item_maintenance_message()">{{}}</span></p></div><div ng-if="noModule" class="container"><div class="section match-body-background"><div class="level"><div class="level-item has-text-centered"><div class="box"><p class="title">This account does not have access to any content yet.</p></div></div></div></div></div>',
            scope: {
                  'moduleMapData': '=module'
            },
            link: function link(scope) {
                  scope.isPrelive = preliveCheck.isPreliveCheck();
                  TeacherDataService.isTeacherWorkspaceView = false;
                  var eventManager = new EventManager("mticModules", scope);
                  var isExternalLink = function isExternalLink(resource) {
                        return resource && resource.content ? resource.content.container === 'link' : false;
                  };
                  scope.windowId = 'loadedResource';
                  if (scope.moduleMapData && MapStateService.getModuleModalsInvertedVisibility(scope.moduleMapData.resource_slug)) {
                        scope.modalHidden = true;
                  } else {
                        scope.modalHidden = false;
                  }

                  scope.hideModal = function (is_gr78) {
                        if (is_gr78) {
                              scope.modal2Hidden = true;
                        } else {
                              scope.modalHidden = true;
                        }
                        MapStateService.setModuleModalsInvertedVisibility(scope.moduleMapData.resource_slug, true);
                  };

                  var noclass_items = [1236, 1240, 1244, 1248];
                  eventManager.listen('module:open:resource', function (e, currentResource) {
                        if (isExternalLink(currentResource)) {
                              WindowOpener.open(currentResource.hostUrl, scope.windowId);
                        }
                        if (currentResource.url || noclass_items.indexOf(currentResource.id) > -1 || currentResource.resource_type === 'embedded_notification') {
                              return;
                        }
                        scope.currentResource = currentResource;
                  });
                  eventManager.listen('module:close:resource', function (e, args) {
                        if (!(args && args.isPassive)) {
                              delete scope.currentResource;
                              if (!args) {
                                    eventManager.broadcast('app:module:open');
                              }
                        }
                  });

                  var updateCounter = 0;
                  var updateCurrentModule = function updateCurrentModule(moduleMapData) {
                        delete scope.currentResource;
                        scope.currentModule = moduleMapData.resource_slug;
                        scope.noModule = false;
                        updateCounter = 0;
                        //manually clean route names if not in workspace view
                        if (!TeacherDataService.isTeacherWorkspaceView) {
                              eventManager.broadcast('update:resource:slug:route:name', { slug: "", name: "" });
                              eventManager.broadcast("hide:back:arrow");
                              eventManager.broadcast("hide:back:module:arrow");
                              eventManager.broadcast('update:submodule:slug:route:name', { slug: "", name: "" });
                        }
                  };

                  scope.$watch('moduleMapData', function (moduleMapData) {
                        $log.debug('[[mticModules]] INIT', moduleMapData);
                        updateCounter++;
                        if (moduleMapData) {
                              $timeout(function () {
                                    if (scope.currentResource && scope.currentResource.slug.indexOf('mtic_c3_m56_') > -1 && !userAccount.getData().role.isTeacher) //(scope.currentModule && scope.currentModule.indexOf('_m56_') > -1)
                                          {
                                                var defer = $q.defer();
                                                eventManager.broadcast('module:updateAndClose:resource', defer);
                                                defer.promise.then(function () {
                                                      updateCurrentModule(moduleMapData);
                                                });
                                          } else {
                                          updateCurrentModule(moduleMapData);
                                    }
                              });
                        } else if (updateCounter > 2) {
                              scope.noModule = true;
                        }
                  });

                  eventManager.listen('open:custom:resource', function (e, data) {
                        $log.log('got open custom request : ', data);
                        var modified_url = data.url.indexOf('http') === -1 ? 'https://' + data.url : data.url;
                        if (PlatformService.isApp) {
                              cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: modified_url });
                        } else {
                              window.open(modified_url, '_blank');
                        }
                        //scope.custom_resource_url = data.url;
                        //scope.currentModule = 'custom_resource';
                        //eventManager.broadcast('module:open:resource', data)
                        var user_data = userAccount.getData();
                        var stateUpdate = {
                              "slug": data.slug,
                              "score": 1,
                              "complete": true,
                              "time_spent": 0,
                              "time_stamp": Date.now(),
                              "resource_id": data.id,
                              "module_id": scope.moduleMapData.module_id,
                              "component_instances": {},
                              "app_state": {},
                              "log_data": {},
                              "class_id": userAccount.getActiveClassroom()
                        };
                        api.submitStudentResourceState(stateUpdate).then(function (response) {
                              eventManager.broadcast('refresh-agenda-sidepanel', data);
                              // $log.log('response : ', response)
                              //eventManager.broadcast('navbar:seen_info_popup')
                        });
                  });

                  scope.trustSrc = function (src) {
                        return $sce.trustAsResourceUrl(src);
                  };
                  scope.get_translation = function (slug) {
                        return language.get(slug);
                  };
                  scope.hide_maintenance_msg = function () {
                        scope.item_maintenance = false;
                        scope.itemMaintenanceMsgHidden = true;
                  };
                  eventManager.listen('display-maintenance-message', function (e, slug) {
                        scope.itemMaintenanceMsgHidden = false;
                        scope.item_maintenance = true;
                        scope.current_item = slug;
                  });
                  eventManager.listen('request-next-item', function (e, slug) {
                        $log.log('got item request : ', slug);
                        var found_resources = [];
                        _.each(scope.moduleMapData.resources, function (submod) {
                              if (submod.children) {
                                    _.each(submod.children, function (item) {
                                          if (item.unlocked_by.indexOf(slug) > -1 && !(item.config && item.config.assessment_type)) {
                                                found_resources.push(item);
                                          }
                                    });
                              }
                        });
                        $log.log('found item request : ', found_resources);
                        MapStateService.setNextAvailableItem(found_resources.length === 1 ? found_resources[0] : null);
                        //eventManager.broadcast('response-next-item', found_resources[0].slug)
                  });
                  scope.get_item_maintenance_message = function () {
                        var txt = language.getCurrentSelectedLanguage() === 'en' ? ' is under maintenance.' : ' en maintenance.';
                        return language.get(scope.current_item) + txt;
                  };

                  // Mobile View
                  scope.mModuleView = { LIST: 'module-list-view', MAP: 'module-map-view' };
                  scope.mSelectedModuleView = scope.mModuleView.MAP;
                  scope.mToggleModuleView = function (e) {
                        if (!e.srcElement.classList.contains('module-view-icon') && !e.srcElement.classList.contains('text-toggle')) {
                              e.preventDefault();
                              e.stopImmediatePropagation();
                              return;
                        }
                        scope.mSelectedModuleView = scope.mSelectedModuleView === scope.mModuleView.LIST ? scope.mModuleView.MAP : scope.mModuleView.LIST;
                  };
                  scope.$watch('mSelectedModuleView', function (view) {
                        window.console.warn('mSelectedModuleView: ' + view);
                  });
                  // End of Mobile View
            }
      };
});
'use strict';

angular.module('mtic.components.modules').directive('c4Module1', function (GR78_ASSET_URL, C4_ASSET_URL, DEV_VARIABLES, StudentDataService, TeacherDataService, PanelStateService, $timeout, TIMING_CONSTANTS, $q, $log, $http, $window, gr78MapItemFactory, MapDataMassage, MapStateService, VerletSystemService, learningMapUtil, PIXI, EventManager, flashPermission, language, userAccount, api, preliveCheck, SessionDataService, LocaleService, IAMManager, ModuleFilter, PlatformService) {

  return {

    template:'<div ng-hide="loading_done" style="position:absolute;top:0px;left:0px;width:100%;height:100%;background-color:#555;z-index:1000"><div class="loader"></div></div><div class="inner-viewport agendaSplitView" style="overflow:hidden;"><div class="agendaSplitViewSidebar no-select" ng-if="!isTeacherWorkspaceView"><nav class="nav is-small" style="margin-bottom: 24px;"><div class="nav-center"><a class="nav-item is-tab studentAgendaPanel__tab" ng-if="!isTeacher" ng-class="{\'is-active studentAgendaPanel__tab--active\':isShowingAgendaPanel()}" ng-click="selectAgendaPanel()" ng-init="selectAgendaPanel()"><span class="icon studentAgendaPanel__navTabIcon"><img src="assets/images/agenda/icon-blue-agenda.png"></span> <span class="studentAgendaPanel__navTabText">Agenda</span></a> <a class="nav-item is-tab studentAgendaPanel__tab" ng-class="{\'is-active studentAgendaPanel__tab--active\':isShowingModulePanel()}" ng-click="selectModulePanel()"><span class="icon studentAgendaPanel__navTabIcon"><img src="assets/images/agenda/icon-module-blue.png"></span> <span class="studentAgendaPanel__navTabText" ng-bind="getTranslation(\'14569\')">Module</span></a></div></nav><div style="padding:12px;"><lmap-sidepanel-agenda ng-show="isShowingAgendaPanel() && !isTeacher" module-map-data="moduleMapData"></lmap-sidepanel-agenda><div ng-show="isShowingModulePanel() || isTeacher"><input class="agendaSearchField" placeholder="{{getLang(\'22608\')}}" ng-model="itemSearchInput" ng-change="itemSearchChange(itemSearchInput)"><teacher-students-agenda-perf-preview filtered-view="itemSearchInput" module-map="moduleMapData" view-controller="view_controller"></teacher-students-agenda-perf-preview></div></div></div><div class="agendaSplitView__main"><canvas id="canvas-c4-module-m1" width="300" height="300" ng-style="{\'pointer-events\':!show_baseline_test_prompt}" style="float:right"></canvas><lmap-bottom-panel ng-show="isShowingAgendaPanel() || isShowingModulePanel()" highlighted-resource="selectedResource" module-map-data="currentActiveSubModule" ng-if="!isTeacherWorkspaceView"></lmap-bottom-panel><div class="breadcrumbs" ng-hide="isTeacherWorkspaceView" style="font-size: 1em; position:absolute; top: 12px;"><a ng-click="returnToMetaModules()">{{getLang(moduleMapData.resource_slug)}}</a> / <a>{{getLang(currentActiveSubModule.slug)}}</a></div></div></div><div style="display:flex; position:fixed;right: 8px; top: 45px;" ng-style="{\'bottom\':isTeacherWorkspaceView ? \'10px\':\'100px\'}" class="module-zoom-buttons"><button ng-click="zoom_function(1)" class="button" style="margin-right:3px;font-size:24px"><i class="fa fa-search-minus" aria-hidden="true"></i></button> <button ng-click="zoom_function(-1)" class="button" style="font-size:24px"><i class="fa fa-search-plus" aria-hidden="true"></i></button></div>',
    scope: {
      moduleMapData: "=",
      interceptClick: "=?",
      onItemClick: "<",
      workspaceData: "=?",
      interactionDisabled: "=?"
    },
    link: function link(scope, element) {

      scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;

      var middle_view_visible = false;

      var eventManager = new EventManager('gr78MetaMap', scope);
      var userData = userAccount.getData();
      scope.isTeacher = userAccount.getData().role.isTeacher;

      function checkForStudentTest() {
        //asssessment bubble stuff
        showing_student_assesment = false;
        var userData = userAccount.getData();
        var token_saved_url = IAMManager.getSavedUrlParamsForToken();

        // $log.log("Locale saved baseline/quest: ", LocaleService.hasCompletedStudentBase, LocaleService.hasCompletedStudentQuest);

        var group_id = userData.role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom(); //userAccount.getActiveClassroom();//
        var app_link;

        var is_app = window.isWebEmbedConnect || window.location.href.indexOf('web-embed-connect') !== -1 || token_saved_url.indexOf('web-embed-connect') !== -1;

        // if(!scope.interceptClick && is_app && !PlatformService.isIos){
        //     scope.badBrowser = false;
        //     // $log.log('using updated version : ', window.isUpdatedVersion)
        //     if(!navigator.userAgent.match(/Android/i) && (window.location.href.indexOf('?redirect-from-prelive') > -1 || window.updatedVersion)){
        //       app_link = 'http://mthmtc.vretta.com/qc/mtic_v2/pre-live/dist/?web-embed-response&user_id='+userData.user_id+'&session_key='+userData.sessionKey+'&group_id='+group_id+'&is_teacher='+userData.role.isTeacher+'&current_language='+language.getCurrentSelectedLanguage();
        //     }else{
        //       //older version OR android
        //       var firstDelim = /\?/.test(window.location.href) ? '&' : '?';
        //       app_link = window.location.href + firstDelim + 'web-embed-response&user_id='+userData.user_id+'&session_key='+userData.sessionKey+'&group_id='+group_id+'&is_teacher='+userData.role.isTeacher+'&current_language='+language.getCurrentSelectedLanguage();
        //     }

        //     eventManager.broadcast('change-prelive-message', app_link.replace('#&', '#/web-embed-connect&'))
        //     window.location.href = app_link.replace('#&', '#/web-embed-connect&');
        //     $timeout(function(){
        //       userAccount.logout();
        //     },100)

        //     return;
        // }else{
        //   if (group_id !== 4594){ // TODO: apply group settings and read from there rather than hard-coding test C4 class like this
        //     // if (!scope.interceptClick && ((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent)) && !window.MSStream)){
        //     //   //This is an android or ios device visiting the page NOT in the mathematic app
        //     //   scope.badBrowser = true;
        //     //   return;
        //     // }
        //   }
        init();
        scope.inited = true;
        // }
      }

      // event manager for coordination with rest of application
      var verlet_system = new VerletSystemService();
      // var assessment_bubble;
      var showing_student_assesment = false;
      ///////////////////
      // PRIVATE VARS //
      /////////////////
      ///
      // var student_baseline = {
      //   hostUrl: 'https://d3kdl9636cazwt.cloudfront.net/containers/inbook/v2.4.66/index.html?host=cloudfront&repo=mtic_baseline_assessment&cloudfrontVersion=v1.0.6',
      //   module_id: 57,
      //   slug: 'mtic_baseline_assessment',
      //   id: 1244,
      //   resources: '',
      //   class_id: null,
      // }

      var state = 0;
      var canvas_el = null;
      var app = null;
      var renderer = null;
      var drag_info = null;
      var canvasDimention = null;
      var scale = null;
      var stage = null;
      var meta_gradient = null;
      var meta_bg = null;
      var repeating_clouds = null;
      var container = null;
      var meta_container = null;
      var lines_graphic = null;
      var selection_graphic = null;
      var cloud_man = null;
      var items = [];
      var modules = [];
      var img_asset_paths = [GR78_ASSET_URL + "symlink.png", GR78_ASSET_URL + "item_blue_0.png", GR78_ASSET_URL + "item_blue_1.png", GR78_ASSET_URL + "item_red_0.png", GR78_ASSET_URL + "item_red_1.png", GR78_ASSET_URL + "item_red_2.png", GR78_ASSET_URL + "item_red_3.png", GR78_ASSET_URL + "item_black_0.png", GR78_ASSET_URL + "item_black_1.png", GR78_ASSET_URL + "item_black_2.png", GR78_ASSET_URL + "item_black_3.png", GR78_ASSET_URL + "item_blue_locked.png", GR78_ASSET_URL + "item_red_locked.png", GR78_ASSET_URL + "item_black_locked.png", GR78_ASSET_URL + "assessment.png", GR78_ASSET_URL + "assessment_complete.png", GR78_ASSET_URL + "selection.png", GR78_ASSET_URL + "formative_gold.png", GR78_ASSET_URL + "formative_silver.png", GR78_ASSET_URL + "formative_locked.png", GR78_ASSET_URL + "formative_unlocked.png"];

      var c4_asset_paths = [C4_ASSET_URL + 'background.png', C4_ASSET_URL + 'background_clouds.png', C4_ASSET_URL + 'c4_m1.png', C4_ASSET_URL + 'c4_m2.png', C4_ASSET_URL + 'c4_m3.png', C4_ASSET_URL + 'c4_m4.png', C4_ASSET_URL + 'c4_m5.png', C4_ASSET_URL + 'c4_m6.png'];

      var focus_item = null;
      var CANVAS_EL_ID = 'canvas-c4-module-m1';
      var isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);

      // scope.show_baseline_test_prompt = false;
      // var baseline_to_true = function(){
      //   if(student_baseline.slug === 'mtic_student_onboarding'){
      //     eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true});
      //   }else{
      //     scope.show_baseline_test_prompt = true;
      //   }
      //   scope.$apply();
      // }

      scope.hasAgendas = false;

      flashPermission.getPermission();

      var runDownModel = {};
      var highlightedItem = null;
      var resourceLockManager = function ResourceLockManager(self) {
        var originalLockState = {};
        self.setOriginal = function (resourceId, isLocked) {
          if (!originalLockState[resourceId]) {
            originalLockState[resourceId] = isLocked;
          }
        };
        self.unlock = function (resourceIds) {
          self.reset();
          resourceIds.forEach(function (resourceId) {
            var item = getItemById(resourceId);
            if (item) {
              item.unlock();
            }
          });
        };
        self.lock = function (resourceIds) {
          self.reset();
          resourceIds.forEach(function (resourceId) {
            var item = getItemById(resourceId);
            if (item) {
              item.lock();
            }
          });
        };
        self.reset = function () {
          items.forEach(function (item) {
            if (originalLockState[item.id] === true) {
              item.lock();
            } else if (originalLockState[item.id] === false) {
              item.unlock();
            }
          });
        };
        return self;
      }({});

      scope.showAgenda = false;
      scope.selectedResource = {};
      function unlockpath(item_id, use_slug) {
        // $log.log('UNLOCK PATH : ', item_id, items )
        items.forEach(function (resource) {
          if (resource.id === item_id || use_slug && item_id === resource.slug) {
            resource.unlock();
            resource.unlockedByAgenda = true;
            if (resource.unlocked_by.length > 0) {
              resource.unlocked_by.forEach(function (higher_resource) {
                unlockpath(higher_resource, true);
              });
            }
          }
        });
      }

      var agendas_list = [];
      eventManager.listen('moduleview:agenda:loaded', function (e, data) {
        if (data.length > 0) {
          scope.hasAgendas = true;
          agendas_list = data;
          scope.selectAgendaPanel();
          data.forEach(function (agenda) {
            if (agenda.force_unlock) {
              agenda.resources.forEach(function (item) {
                unlockpath(item);
              });
            }
          });
        } else {
          scope.hasAgendas = false;
        }
        // $log.log('got agenda info : ', scope.hasAgendas)
        // scope.toggleAgenda();
      });

      scope.hasAgendaOption = function () {
        return scope.hasAgendas;
      };
      scope.hasModuleOption = function () {
        return true && scope.currentActiveSubModule && scope.currentActiveSubModule.children;
      };

      scope.isShowingAgendaPanel = function () {
        return scope.showAgenda;
      };
      scope.isShowingModulePanel = function () {
        return !scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView;
      };

      scope.toggleAgenda = function () {
        if (scope.showAgenda) {
          // scope.selectModulePanel();
        } else {
          scope.selectAgendaPanel();
        }
      };

      scope.selectAgendaPanel = function () {
        if (!scope.showAgenda) {
          scope.showAgenda = true;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          eventManager.broadcast('moduleview:agenda:request');
        }
      };

      scope.selectModulePanel = function () {
        if (scope.showAgenda) {
          scope.showAgenda = false;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          for (var i = 0; i < items.length; i++) {
            items[i].undoAgendaHighlight();
          }
        }
      };
      scope.getTranslation = function (slug) {
        return language.get(slug);
      };

      scope.panelDisplay = {};
      scope.getLang = language.get;

      scope.isStudent = function () {
        return !userAccount.getData().role.isTeacher;
      };
      /////////////
      // CONSTRUCTOR
      /////////////

      var _TOUCHED_POINTS = [];
      function init() {
        //scope.isNotTeacherWorkspaceView = !TeacherDataService.isTeacherWorkspaceView;
        // retrieve template element references
        canvas_el = document.getElementById(CANVAS_EL_ID);
        // $log.log('INITING C4 MAP', canvas_el)
        if (!canvas_el) {
          return;
        }

        app = new PIXI.Application(300, 300, {
          autoResize: true,
          //backgroundColor: 0x46a0d7,
          backgroundColor: 0xdee9fc,
          antialias: true,
          view: canvas_el
        });

        MapStateService.setMetaStateSlug('mtic_c4_m_meta');

        var cvs = document.createElement('canvas');
        cvs.width = 1;
        cvs.height = 64;
        var ctx = cvs.getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, 64);
        gradient.addColorStop(0, '#0087ca');
        gradient.addColorStop(1, '#a7d3ec');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 1, 64);
        meta_gradient = new PIXI.Sprite(PIXI.Texture.fromCanvas(cvs));

        meta_bg = PIXI.Sprite.fromImage(C4_ASSET_URL + 'background.png');
        meta_bg.anchor.set(0.5, 1);

        repeating_clouds = new PIXI.extras.TilingSprite(PIXI.Texture.fromImage(C4_ASSET_URL + 'background_clouds.png'));
        repeating_clouds.anchor.set(0, 1);
        repeating_clouds.height = 60;

        renderer = app.renderer;
        scale = 0.45;
        items = [];

        drag_info = learningMapUtil.getDragInfoSettings();

        var sidepanel_width = 0;
        if (scope.isTeacher) {
          var sidepanel = document.getElementById('teacher_sidepanel');
          sidepanel_width = TeacherDataService.inTeacherAgendaView ? 60 : sidepanel.offsetWidth;
          if (TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView) {
            sidepanel_width += -30;
          }
        }

        canvasDimention = {
          width: window.innerWidth - 180 - sidepanel_width,
          height: window.innerHeight - 50
        };

        stage = app.stage;
        stage.interactive = true;

        cloud_man = learningMapUtil.createCloudManager();
        stage.addChild(cloud_man.overlay_sprite);

        window.addEventListener("resize", onResize);

        container = new PIXI.Sprite();
        container.interactive = true;

        meta_container = new PIXI.Sprite();
        //meta_container.scale.set(0.5);
        // if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1200){
        //   meta_container.scale.set(0.4);
        // }

        //scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width/800) : scale;
        //meta_container.scale.set(scale, scale);
        meta_container.x = renderer.width / 2;
        meta_container.y = renderer.height / 2;

        stage.addChildAt(meta_container, 0);

        renderer.render(stage);
        // if(TeacherDataService.isTeacherWorkspaceView){
        //   stage.x = -200;
        // }

        container.x = renderer.width / 2;
        container.y = renderer.height / 2 - 60;
        stage.addChildAt(container, 0);
        stage.addChildAt(meta_bg, 0);
        stage.addChildAt(repeating_clouds, 0);
        stage.addChildAt(meta_gradient, 0);

        lines_graphic = new PIXI.Graphics();
        container.addChild(lines_graphic);

        container.scale.set(scale, scale);
        app.ticker.add(update);

        canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else

        // prevent browser from selecting other html text when double clicking the PIXI canvas
        canvas_el.addEventListener('pointerdown', handleDoubleClick, false);

        stage.on('pointerdown', function (e) {
          var e_o = e.data.originalEvent;
          _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x: e_o.pageX, y: e_o.pageY });

          drag_info.dragging = true;

          focus_item = null;

          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: container.x,
            y: container.y
          };
          drag_info.start_drag_pos_meta = {
            x: meta_container.x,
            y: meta_container.y
          };
          drag_info.start_drag_mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };
        });

        stage.on('pointermove', function (e) {
          if (!drag_info.dragging) {
            return;
          }
          var mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };

          if (!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0) {
            meta_container.position.x = Math.min(1000, Math.max(drag_info.start_drag_pos_meta.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x), 0));
            meta_container.position.y = Math.min(1000, Math.max(drag_info.start_drag_pos_meta.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y), 0));
          } else {
            container.position.x = Math.min(1000, Math.max(drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x), 0));
            container.position.y = Math.min(1000, Math.max(drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y), 0));
          }

          var delta_pos = {
            x: drag_info.last_mouse_pos.x - mouse_pos.x,
            y: drag_info.last_mouse_pos.y - mouse_pos.y
          };

          drag_info.velocity = {
            x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
            y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
          };

          drag_info.last_mouse_pos = {
            x: mouse_pos.x,
            y: mouse_pos.y
          };
        });

        stage.on('pointerup', function (e) {
          if (window.DEBUG_TOUCH) {
            $log.log('c4 pointerup ; ', JSON.stringify(drag_info), e);
          }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });

        stage.on('pointerout', function (e) {
          if (window.DEBUG_TOUCH) {
            $log.log('c4 pointerup ; ', JSON.stringify(drag_info), e);
          }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });

        verlet_system.toggle(false);

        if (window.DEBUG_TOUCH) {
          $log.log('c4 pointerdown ; ', JSON.stringify(drag_info));
        }

        eventManager.broadcast('teacherStudentWorkspace:studentFilter:request');

        return loadAssets().then(function () {
          $log.debug('[[gr78MetaMap]] loadAssets.then');
          scope.loading_done = true;
          var isExpanded = TeacherDataService.inTeacherAgendaView ? false : null;
          onResize(isExpanded);
          return;
        }).catch(function (err) {
          $log.error('[[gr78MetaMap]] loadAssets.then', err.message);
          $log.debug(err.stack);
        });
      }

      scope.returnToMetaModules = function () {
        eventManager.broadcast('module:change:meta', 'c4_meta_module');
      };

      eventManager.listen('module:change:meta', function (e, data) {
        $timeout(function () {
          //Remove the focus from the selected item
          eventManager.broadcast('module:dismiss:focus');
          scope.currentActiveSubModule = {};
          scope.panelDisplay = {
            slug: '',
            isExpanded: false,
            sub: {}
          };

          verlet_system.deactivateAllBodies(true);
          meta_container.visible = true;
          onResize();
        }, TIMING_CONSTANTS.INSTANT);
      });

      eventManager.listen('unlock-item', function (e, slug) {
        items.forEach(function (resource) {
          if (slug === resource.slug) {
            resource.unlock(true);
            resource.unlockedByAgenda = true;
          }
        });
        // var scopeResource = getResourceBySlug(slug);
        // scopeResource.locked = false;
      });
      eventManager.listen('module:change:submodule', function (e, data) {
        $timeout(function () {
          verlet_system.deactivateAllBodies(true);
          meta_container.visible = false;
          MapStateService.setActiveModule(data);

          var resources = MapStateService.getSelectedResourcesForAgendaCreation();
          for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
            if (scope.moduleMapData.resources[i].slug === data) {
              scope.currentActiveSubModule = scope.moduleMapData.resources[i];
              var resource = scope.moduleMapData.resources[i];
              for (var n = 0; n < resource.children.length; n++) {
                var item = getItemBySlug(resource.children[n].slug);
                if (item && TeacherDataService.isTeacherWorkspaceView) {
                  item.hideAgendaHighlight();
                }
                // if((resources && resources.contains && resources.contains(item.id))){
                //   item.showAgendaHighlight();
                // }
                if (DEV_VARIABLES.RESOURCES.HIDE_THESE.indexOf(resource.children[n].slug) > -1 || resource.children[n].config && resource.children[n].config.hidden === true) {
                  continue;
                }
                verlet_system.activateBody(resource.children[n].slug, true);
              }
              break;
            }
          }
          language.setAvailableOptions(_.get(scope.currentActiveSubModule, ['content', 'available_languages', LocaleService.getUrlVersion()]));
          if (scope.currentActiveSubModule.display && scope.currentActiveSubModule.display.panel) {
            scope.panelDisplay = {
              slug: scope.currentActiveSubModule.slug,
              isExpanded: true,
              sub: scope.currentActiveSubModule.display.panel
            };
          }
        }, TIMING_CONSTANTS.INSTANT);
      });

      eventManager.listen('module:open:resource', function (e, data) {
        MapStateService.setFocusSlug(data.slug);
      });

      var prehighlighted_list = [];
      eventManager.listen('highlight:map:items', function (e, list) {
        // $log.log('got prehighlighted list : ', list)
        prehighlighted_list = list;
        $timeout(function () {
          onResize();
        }, 500);
      });

      eventManager.listen('module:select:resource', function (e, data) {
        var scopeResource = getResourceBySlug(data.slug);
        if (scopeResource === null) {
          eventManager.broadcast('module:dismiss:focus');
          return;
        }
        if (data.locked) {
          scopeResource.locked = true;
        }
        if (scope.onItemClick && scope.interceptClick) {
          var item = getItemBySlug(data.slug);
          scope.onItemClick(scopeResource, item, data);
        }
        $timeout(function () {
          scope.selectedResource = scopeResource;
        }, TIMING_CONSTANTS.INSTANT);

        var mapResource = getItemBySlug(data.slug);
        //This isn't a map item??
        if (mapResource === null) {
          return;
        }

        focus_item = mapResource;

        scope.scale_factor = focus_item && focus_item.type === 'assessment' && focus_item.config.assessment_type !== 'formative' ? 9.6 : 10;

        verlet_system.setConstraintLength(60);

        mapResource.sprite.addChildAt(selection_graphic, 0);
        selection_graphic.scale.set(0);

        //Find the module that contains the selected item and open it
        var module_slug = '';
        for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
          if (scope.moduleMapData.resources[i].children.indexOf(scopeResource) > -1) {
            if (MapStateService.getActiveModule() !== scope.moduleMapData.resources[i].slug) {
              eventManager.broadcast('module:change:submodule', scope.moduleMapData.resources[i].slug);
              eventManager.broadcast('update:submodule:slug:route:name', { slug: scope.moduleMapData.resources[i].slug, name: scope.moduleMapData.resources[i].name });
              MapStateService.setActiveModule(scope.moduleMapData.resources[i].slug);
            }
          }
        }

        if (TeacherDataService.inTeacherAgendaView && !middle_view_visible) {
          middle_view_visible = true;
          onResize();
        }
      });

      eventManager.listen('module:center:resource', function (e, data) {
        focus_item = getItemBySlug(data.slug);
      });

      eventManager.listen('module:stop:pan', function () {
        focus_item = null;
      });

      /////////////
      // METHODS
      /////////////

      //Mousewheel zoom/in out at cursor position (like google maps)
      var handleScroll = function handleScroll(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = evt.detail < 0 || evt.wheelDelta > 0 ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.0, scale + direction / 15), 0.25);
        var diff = scale - start_scale;
        container.scale.set(scale, scale);
        meta_container.scale.set(scale, scale);

        //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
        // var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
        // container.position.x -= diff * pos.x;
        // container.position.y -= diff * pos.y;

        evt.preventDefault();
        return false;
      };

      var handleDoubleClick = function handleDoubleClick(e) {
        e.preventDefault();
        return false;
      };

      var initMapDraw = function initMapDraw(moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        var combinedResourceMap = {};

        _.forEach(moduleMapData.children, function (someItem) {
          combinedResourceMap[someItem.slug] = someItem;
          loadChildren(someItem);
        });

        _.each(combinedResourceMap, function (resource) {
          createItem(resource, null);
        });
        _.forEach(items, function (item) {
          if (!item.locked) {
            item.unlock();
          }
          if (MapDataMassage.getTempUnlocks()) {
            if (_.indexOf(MapDataMassage.getTempUnlocks(), item.slug) !== -1) {
              item.unlock();
            }
          }
        });
        if (agendas_list.length > 0) {
          agendas_list.forEach(function (agenda) {
            if (agenda.force_unlock) {
              agenda.resources.forEach(function (item) {
                unlockpath(item);
              });
            }
          });
        }

        eventManager.broadcast('creating-items-done');
      };

      var updateItemsHighlighterAnimation = function updateItemsHighlighterAnimation() {
        angular.forEach(items, function (each) {
          if (each.selection_graphic) {
            //Rotate it a little bit
            each.selection_graphic.rotation = (each.selection_graphic.rotation - 0.015) % (Math.PI * 2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.selection_graphic.scale.set((each.selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / scope.scale_factor);
          }

          if (each.highlight_graphic) {
            //Rotate it a little bit
            each.highlight_graphic.rotation = (each.highlight_graphic.rotation - 0.015) % (Math.PI * 2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.highlight_graphic.scale.set((each.highlight_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / 10);
          }
        });
      };
      //This loops to control things that should update every frame
      var update = function update() {
        if (selection_graphic !== null && !scope.interceptClick) {
          //Rotate it a little bit
          selection_graphic.rotation = (selection_graphic.rotation - 0.015) % (Math.PI * 2);

          //Use UNIX time to scale the graphic with a sin function
          //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')

          selection_graphic.scale.set((selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / scope.scale_factor);
        }

        if (TeacherDataService.isTeacherWorkspaceView) {
          updateItemsHighlighterAnimation();
        }
        //update the fade in animation
        cloud_man.update();

        //update the verlet force directed graph that positions the map items in that big jiggly web
        verlet_system.update();
        //   drawMapLines();
        if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
          drag_info.velocity = {
            x: drag_info.velocity.x * 0.954,
            y: drag_info.velocity.y * 0.954
          };
        } else {
          //If they're not dragging, move the map based on its inertia and damp the inertia
          if (!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0) {
            meta_container.position.x = Math.min(1000, Math.max(meta_container.position.x - drag_info.velocity.x, 0));
            meta_container.position.y = Math.min(1000, Math.max(meta_container.position.y - drag_info.velocity.y, 0));
          } else {
            container.position.x = Math.min(1000, Math.max(container.position.x - drag_info.velocity.x, 0));
            container.position.y = Math.min(1000, Math.max(container.position.y - drag_info.velocity.y, 0));
          }

          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;
        }
        focusItemTicker();

        lines_graphic.clear();
        lines_graphic.lineStyle(8, 0xCCCCDD, 1);
        var segments = verlet_system.getLineSegments();
        var i;
        for (i = 0; i < segments.solid.length; i++) {
          var cur_seg = segments.solid[i];
          lines_graphic.lineStyle(8, 0xCCCCDD, 1);
          if (scope.item_path_slug.indexOf(cur_seg.id) > -1) {
            lines_graphic.lineStyle(8, 0XFFCC00, 1);
          }
          lines_graphic.moveTo(cur_seg.start.x, cur_seg.start.y);
          lines_graphic.lineTo(cur_seg.end.x, cur_seg.end.y);
        }
        lines_graphic.beginFill(0xFF0000, 1);
        for (i = 0; i < segments.dash.length; i++) {
          lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
        }
        lines_graphic.endFill();

        if (window.DEBUG_TOUCH) {
          $log.log('c4 update ; ', JSON.stringify(drag_info));
        }
      };

      scope.item_path_slug = [];
      function createHighlightedSegments(slug) {
        if (!slug) {
          scope.item_path_slug = [];
          return;
        }
        items.forEach(function (resource) {
          if (slug === resource.slug) {
            scope.item_path_slug.push(slug);
            if (resource.unlocked_by.length > 0) {
              resource.unlocked_by.forEach(function (higher_resource) {
                createHighlightedSegments(higher_resource);
              });
            }
          }
        });
        // $log.log('scope.item_path_slug , ', scope.item_path_slug)
      }

      eventManager.listen('highlight:path', function (e, data) {
        scope.item_path_slug = [];
        // $log.log('HIGHLIGHT THIS : ', data)
        // var use_slug = data.slug.split(':')[1].trim();
        var use = data.slug;
        if (data.clear) {
          use = false;
        }
        createHighlightedSegments(use);
      });

      /**
       *Expand a subgroup to reveal child items
       *slug is a unique String that identifies the group MapItem
       **/
      var expandGroup = function expandGroup(slug) {
        //Cancel this mouse event if they were dragging more than 10 pixels
        if (drag_info.dragging) {
          if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
            return;
          }
        }

        if (verlet_system.deactivateBody(slug, true)) {
          var group = getItemBySlug(slug);
          //position all of the sub items so that they appear from where the clicked group icon is
          for (var i = 0; i < items.length; i++) {
            if (items[i].parentItem === group) {
              items[i].sprite.position.x = group.sprite.position.x;
              items[i].sprite.position.y = group.sprite.position.y;
              verlet_system.activateBody(items[i].slug, true);
            }
          }
          // toggleGroupExpanded(group);
        }
      };

      /**
       *Collapse a subgroup to hide child items
       *slug is a unique String that identifies the group MapItem
       **/
      var collapseGroup = function collapseGroup(slug) {
        var group = getItemBySlug(slug);
        if (group.isExpanded === true) {
          toggleGroupExpanded(group);
        }
      };

      /**
       *Toggle the expand/collapse of a given item group
       *group is a MapItem
       **/
      var toggleGroupExpanded = function toggleGroupExpanded(group) {
        group.isExpanded = !group.isExpanded;
        //    baseVerletSystem.hookUpConstraints();
      };

      //If focus item is defined, pan towards it
      var focusItemTicker = function focusItemTicker() {
        if (focus_item === null) {
          return;
        }
        var abs_pos = container.toGlobal(focus_item.sprite.position);
        container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
        container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
      };

      /**
       *Return a MapItem whose slug matches the passed slug
       *Returns null if no MapItem can be found
       */
      var getItemBySlug = function getItemBySlug(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      };

      var getItemById = function getItemById(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      };

      var getResourceBySlug = function getResourceBySlug(slug) {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n++) {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === slug) {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      };

      ////////////////
      //
      ////////////////
      var onResize = function onResize(sidepanel_expanded) {
        var _canvasEl = document.getElementById(CANVAS_EL_ID);
        if (!_canvasEl) {
          return;
        }

        var sidepanel_width = TeacherDataService.sidepanelStatus ? 260 : 60;
        var canv_width;
        // var sidepanel = document.getElementById('teacher_sidepanel');
        if (!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView) {
          if (sidepanel_expanded === true || sidepanel_expanded === false) {
            sidepanel_width = sidepanel_expanded ? 140 : -200;
          } else {
            sidepanel_width = 0;
          }
          canv_width = _canvasEl.parentElement.offsetWidth - sidepanel_width;
        } else {
          var middleview = document.getElementById('agenda_middleview');
          if (middleview) {
            sidepanel_width += 300;
          }
          if (!TeacherDataService.inTeacherAgendaView) {
            sidepanel_width += -30;
          }
          canv_width = window.innerWidth - 370 - sidepanel_width;
        }

        canvasDimention = {
          width: canv_width,
          height: window.innerHeight - 35
        };

        _canvasEl.width = canvasDimention.width;
        _canvasEl.height = canvasDimention.height;

        renderer.resize(canvasDimention.width, canvasDimention.height);
        cloud_man.onResize(canvasDimention.width, canvasDimention.height);

        meta_bg.position.x = canvasDimention.width / 2;
        meta_bg.position.y = canvasDimention.height - 8;

        repeating_clouds.position.y = canvasDimention.height - 8;
        repeating_clouds.width = canvasDimention.width;

        scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width / 800) : scale;
        meta_container.scale.set(scale, scale);
        meta_container.x = renderer.width / 2;
        meta_container.y = renderer.height / 2;

        container.scale.set(scale, scale);
        container.x = renderer.width / 2;
        container.y = renderer.height / 2;

        meta_gradient.width = canvasDimention.width;
        meta_gradient.height = canvasDimention.height;
      };

      // scope.$watch("moduleMapData", function (moduleMapData) {

      //this is what runs to initialize the map
      var loadAssets = function loadAssets() {
        $log.debug('[[gr78MetaMap]] loadAssets');
        return $q(function (resolve, reject) {
          try {
            if (!PIXI_gr78_Load_Cache || !PIXI_c4_Load_Cache) {
              PIXI.loader.reset();

              if (!PIXI_gr78_Load_Cache) {
                PIXI.loader.add(img_asset_paths);
              }
              if (!PIXI_c4_Load_Cache) {
                PIXI.loader.add(c4_asset_paths);
              }

              PIXI.loader.load(function () {
                PIXI_gr78_Load_Cache = true;
                PIXI_c4_Load_Cache = true;
                initMap(resolve);
              });
            } else {
              initMap(resolve);
            }
          } catch (err) {
            $log.error('[[gr78MetaMap]]', err);
            reject(err);
          }
        });
      };

      var initMap = function initMap(resolve) {
        $log.debug('[[gr78MetaMap]] initMap');

        modules = [];
        var i, n, p;
        for (i = 0; i < scope.moduleMapData.resources.length; i++) {
          initMapDraw(scope.moduleMapData.resources[i]);
          var module_container = createModuleContainer(scope.moduleMapData.resources[i]);
          modules.push(module_container);
          //Add all the bad boys to the verlet_system
        }
        $log.debug('[[gr78MetaMap]] initMap.initMapDraw done');

        verlet_system.deactivateAllBodies(true);

        $log.debug('[[gr78MetaMap]] initMap.verlet_system done');
        var active_module = MapStateService.getActiveModule();
        for (n = 0; n < modules.length; n++) {
          if (modules[n].slug === active_module) {
            moduleClicked(modules[n]);

            var active_items = MapStateService.getActiveItems();

            verlet_system.deactivateAllBodies(true);

            for (p = 0; p < active_items.length; p++) {
              var item = getItemBySlug(active_items[p]);
              var pos = MapStateService.getItemState(active_items[p]);
              item.sprite.position.x = pos.x;
              item.sprite.position.y = pos.y;
              verlet_system.activateBody(active_items[p], true);
            }
          }
        }

        selection_graphic = new PIXI.Sprite(PIXI.loader.resources[GR78_ASSET_URL + 'selection.png'].texture);
        selection_graphic.anchor.set(0.5, 0.5);
        selection_graphic.scale.set(0.75, 0.75);
        selection_graphic.interactive = false;
        selection_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);

        if (!PanelStateService.agendaShowing()) {
          scope.toggleAgenda();
        }

        //If an item was selected before we left the map, find it and highlight it as we return.
        var focus_slug = MapStateService.getFocusSlug();
        for (n = 0; n < scope.moduleMapData.resources.length; n++) {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === focus_slug) {
              var item_info = scope.moduleMapData.resources[n].children[i];
              var item_evt_info = {
                slug: item_info.slug,
                id: item_info.id
              };
              //brodcast the selection events
              eventManager.broadcast('module:center:resource', item_evt_info);
              eventManager.broadcast('module:select:resource', item_evt_info);

              //center on the resource immediately
              if (focus_item) {
                var abs_pos = container.toGlobal(focus_item.sprite.position);
                container.x += -(abs_pos.x - 125 - app.renderer.width / 2);
                container.y += -(abs_pos.y + 80 - app.renderer.height / 2);
              }

              break;
            }
          }
        }
        if (focus_item) {
          if (scope.moduleMapData.resources[n] !== undefined && scope.moduleMapData.resources[n].children[i] !== undefined) {
            $timeout(function () {
              scope.panelDisplay = scope.moduleMapData.resources[n].children[i];
            }, TIMING_CONSTANTS.INSTANT);
          }
        }

        $log.debug('[[gr78MetaMap]] initMap.active_module done');
        resolve();
      };

      var module_clicked = false;
      var moduleClicked = function moduleClicked(module_container) {
        if (scope.interactionDisabled) {
          return;
        }
        module_clicked = true;
        if (ModuleFilter.checkAvailable(module_container)) {
          if (scope.interceptClick) {
            if (scope.interceptClick.slug !== module_container.slug) {
              scope.interceptClick.slug = module_container.slug;
            } else if (!TeacherDataService.inTeacherAgendaView) {
              eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
            }
            scope.$apply();
          }
          var i;
          eventManager.broadcast('submodule:opened', {
            slug: module_container.slug,
            name: module_container.name
          });
          $timeout(function () {
            eventManager.broadcast('module:change:submodule', module_container.slug);
          }, TIMING_CONSTANTS.INSTANT);
        } else {
          window.alert(language.get('module_is_locked'));
        }
      };
      var is_module_locked = function is_module_locked(lock_arr) {
        for (var i = 0; i < lock_arr.length; i++) {
          var lock_name = lock_arr[i];
          if (LocaleService.checkUrlVersion(lock_name)) {
            return true;
          }
        }
        return false;
      };

      var createModuleContainer = function createModuleContainer(module, reset) {
        //Set up the container sprite that will be used
        var do_lock = module.locked;
        //$log.log("MODULE : " , module)//DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(module.slug) > -1
        // $log.log('ModuleFilter.checkAvailable(module)', ModuleFilter.checkAvailable(module))
        if (!ModuleFilter.checkAvailable(module)) {
          do_lock = true;
        }

        //For drawing progress ring
        var sum = 0;
        var prog = 0;
        for (var i = 0; i < module.children.length; i++) {
          if (module.children[i].resource_type === 'symlink' || module.children[i].resource_type === 'assessment' && module.children[i].config.assessment_type && module.children[i].config.assessment_type === 'formative') {
            continue;
          }
          sum++;
          if (TeacherDataService.isTeacherWorkspaceView) {
            prog += workspace_list[module.children[i].id] ? 1 : 0;
          } else {
            prog += module.children[i].complete ? 1 : 0;
          }
        }
        if (TeacherDataService.isTeacherModuleView) {
          prog = 0;
        }
        var mod_names = ['c4_m1', 'c4_m2', 'c4_m3', 'c4_m4', 'c4_m5', 'c4_m6'];
        var mod_graphics;
        if (reset) {
          modules.forEach(function (mod) {
            if (mod.slug === module.slug) {
              mod_graphics = mod.graphics;
            }
          });
          //mod_graphics = container.getChildAt(0);
          if (!mod_graphics) {
            return;
          }
          mod_graphics.clear();
        } else {
          mod_graphics = new PIXI.Graphics();
        }

        if (do_lock) {
          mod_graphics.beginFill(0xC5FBF5).drawCircle(0, 0, 130).endFill(); //white border for lock
        }

        mod_graphics.buttonMode = true;
        mod_graphics.interactive = true;

        if (mod_names.indexOf(module.slug) > -1) {
          var mod_sprite = PIXI.Sprite.fromImage(do_lock ? GR78_ASSET_URL + 'center_lock.png' : C4_ASSET_URL + module.slug + '.png');
          mod_sprite.scale.set(do_lock ? 1.4 : 2);
          mod_sprite.anchor.set(0.5);
          mod_graphics.addChild(mod_sprite);
        }

        var textInfo = new PIXI.Text(language.get(module.slug), {
          fontFamily: 'Arial',
          align: 'center',
          fontSize: isMobile ? 38 : 22,
          fill: 0xFFFFFF
        });
        textInfo.y = 25;
        textInfo.anchor.set(0.5);
        var text_width = textInfo.width;

        var tooltip = new PIXI.Graphics();
        tooltip.beginFill(do_lock ? 0x63a19a : 0x0971b3).drawRoundedRect(-(text_width + 40) / 2, 0, text_width + 40, 75, 10);
        tooltip.moveTo(-15, 75);
        tooltip.lineTo(15, 75);
        tooltip.lineTo(0, 100);
        tooltip.lineTo(-15, 75);

        tooltip.endFill();
        tooltip.beginFill(0x075a8f);
        tooltip.drawRect(-(text_width + 40) / 2 + 10, 45, text_width + 20, 15);
        tooltip.endFill();

        tooltip.beginFill(0x33ccff);
        tooltip.drawRect(-(text_width + 40) / 2 + 10, 45, (text_width + 20) * (prog / sum), 15);
        tooltip.endFill();

        tooltip.y = -220;
        //tooltip.x -= (text_width+40)/2
        mod_graphics.addChild(tooltip);

        meta_container.addChild(mod_graphics);
        //meta_container.scale.set(0.5);

        // if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1200){
        //   meta_container.scale.set(0.4);
        // }
        mod_graphics.buttonMode = true;
        mod_graphics.interactive = true;

        var mod_index = mod_names.indexOf(module.slug);

        mod_graphics.x = mod_index % 3 * 450 - 450;
        mod_graphics.y = (mod_index - 3 >= 0 ? 400 : 0) - 200;

        eventManager.listen('language:change', function () {
          textInfo.text = language.get(module.slug);
          text_width = textInfo.width;
          tooltip.clear();
          tooltip.beginFill(0x0971b3).drawRoundedRect(-(text_width + 40) / 2, 0, text_width + 40, 75, 10);
          tooltip.moveTo(-15, 75);
          tooltip.lineTo(15, 75);
          tooltip.lineTo(0, 100);
          tooltip.lineTo(-15, 75);

          tooltip.endFill();
          tooltip.beginFill(0x075a8f);
          tooltip.drawRect(-(text_width + 40) / 2 + 20, 45, text_width, 15);
          tooltip.endFill();

          tooltip.beginFill(0x33ccff);
          tooltip.drawRect(-(text_width + 40) / 2 + 20, 45, text_width * (prog / sum), 25);
          tooltip.endFill();
          textInfo.x = tooltip.width / 2 - textInfo.width / 2 - 20;
        });
        tooltip.addChild(textInfo);
        textInfo.x = tooltip.width / 2 - textInfo.width / 2 - 20;

        var module_container = {
          graphics: mod_graphics,
          slug: module.slug,
          name: module.name,
          children: module.children
        };

        if (reset) {
          mod_graphics.off('pointertap');
        }
        mod_graphics.on('pointertap', function (e) {
          if (e.data.originalEvent.target && e.data.originalEvent.target.id !== 'canvas-c4-module-m1') {
            return;
          }
          $timeout(function () {
            if (!zooming) {
              moduleClicked(module_container);
            }
          }, 10);
        });

        eventManager.listen('module:dismiss:focus', function (e, data) {
          scope.selectedResource = {};
          if (selection_graphic.parent !== null) {
            selection_graphic.parent.removeChild(selection_graphic);
          }
        });
        var connection = [];

        //verlet_system.createBody(module.slug, mod_graphics, connection);
        return module_container;
      };

      var loadChildren = function loadChildren(someItem) {
        someItem.childResourcemap = [];

        if (someItem.children === undefined) {
          return;
        }
        if (someItem.children.length > 0) {
          _.forEach(someItem.children, function (childItem) {
            someItem.childResourcemap[childItem.slug] = childItem;
            loadChildren(childItem);
          });
        }
      };
      var interpeteAgendaLockStatus = function interpeteAgendaLockStatus(agenda) {
        if (agenda.force_unlock === true) {
          return 'unlock';
        } else if (agenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      };

      var summative_list = [];

      eventManager.listen('got-c4-summative-data', function (e, args) {
        $timeout(function () {
          summative_list.forEach(function (summ) {
            if (args && args.unlocked.indexOf(summ.name) > -1) {
              // $log.log(MapStateService.getActiveModule());
              var name_check = summ.val.slug.replace('g78', 'gr78');
              args.force_unlock = args.force_unlock || [];
              var start_visible = MapStateService.getActiveModule() && summ.val.config.assessment_type === 'summative' && name_check.indexOf(MapStateService.getActiveModule()) > -1;
              createItem(summ.val, summ.parent, !start_visible, true, args.force_unlock.indexOf(summ.name) > -1);
            }
          });
        }, 500);
      });

      var createItem = function createItem(resource, parentItem, start_hidden, build, force_unlock) {
        var isSummative = false;
        if (resource.slug.indexOf('summative') > -1 || resource.config.assessment_type === 'summative') {
          isSummative = true;
          if (!build && !TeacherDataService.isTeacherModuleView && !TeacherDataService.isTeacherWorkspaceView) {
            summative_list.push({ name: resource.slug, val: resource, parent: parentItem });
            return;
          }
        } else if (resource.children && resource.children.length > 0) {
          _.forEach(resource.children, function (childItem) {
            createItem(childItem, parentItem);
          });
          return;
        }

        if (verlet_system.getBody(resource.slug) !== undefined) {
          return;
        }
        var displayItem;

        if (TeacherDataService.isTeacherModuleView || TeacherDataService.isTeacherWorkspaceView) {
          resource.locked = false;
        }
        //Add this to the map logic array of items
        // $log.log('before call : ', resource)
        var lockedVersions = _.get(resource, ['content', 'lock_on']);
        _.each(lockedVersions, function (currentLock) {
          if (LocaleService.checkUrlVersion(currentLock)) {
            resource.locked = true;
          }
        });
        items.push(displayItem = new gr78MapItemFactory.createMapItem(resource, eventManager));
        resourceLockManager.setOriginal(displayItem.id, displayItem.locked);
        //create a VerletBody for the item
        displayItem.parentItem = parentItem;
        //     displayItem.sprite.position.x += Math.random() * 10;
        //    displayItem.sprite.position.y += Math.random() * 10;
        container.addChild(displayItem.sprite);

        //Setup verlet body dragging
        /*
          displayItem.sprite.on('pointerdown', function(evt) {
            var dragFunc = function(tickerEvt) {
              var item = displayItem;
              var abs_pos = container.toGlobal(item.sprite.position);
              var xPos = renderer.plugins.interaction.eventData.data.global.x;
              var yPos = renderer.plugins.interaction.eventData.data.global.y;
              if (isNaN(xPos) || isNaN(yPos)) {
                return;
              }
              item.sprite.position.x -= abs_pos.x - xPos;
              item.sprite.position.y -= abs_pos.y - yPos;
            };
             stage.on('pointerup', function(e) {
              app.ticker.remove(dragFunc);
            });
             app.ticker.add(dragFunc);
            evt.stopPropagation();
          });
          */
        var children = [];
        //Build the child items
        _.forEach(resource.children, function (childItem) {
          children.push(createItem(childItem, displayItem, true));
        });

        //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
        //So we create its list of unlocked_by based on the items in the group
        //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
        //And add it to the unlocked_by of the group
        if (displayItem.unlocked_by.length === 0) {
          for (var i = 0; i < children.length; i++) {
            for (var n = 0; n < children[i].unlocked_by.length; n++) {
              var is_inner = true;
              for (var p = 0; p < children.length; p++) {
                //This is pointing from an item in the group to another item in the group
                if (children[i].unlocked_by[n] === children[p].slug) {
                  is_inner = false;
                }
              }
              //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
              if (is_inner) {
                displayItem.unlocked_by.push(children[i].unlocked_by[n]);
              }
            }
          }
        }

        if (!isSummative) {
          displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        } else {
          displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, false, !resource.complete);
        }
        if (start_hidden) {
          displayItem.sprite.visible = false;
          verlet_system.deactivateBody(resource.slug);
        }
        displayItem.sprite.position.x = displayItem.sprite.position.x * 15;
        displayItem.sprite.position.y = displayItem.sprite.position.y * 15;
        //Add the expandGroup listener to the item
        if (resource.resource_type === "group") {
          displayItem.setDelegate(expandGroup.bind(this));
          displayItem.isExpanded = false;
        }
        if (isSummative) {
          resource.locked = resource.unlocked_by && resource.unlocked_by.length > 0 ? resource.locked : false;
          if (force_unlock) {
            displayItem.unlock(true);
          }
          displayItem.sprite.position.x = -900;
          displayItem.sprite.position.y = -500;
        }
        if (prehighlighted_list.indexOf(resource.id) > -1) {
          // $log.log('PREHIGHLIGHTING : ', resource.slug)
          $timeout(function () {
            displayItem.showAgendaHighlight(true);
          }, 100);
        }
        return displayItem;
      };
      this.destroy = function () {
        // $log.log('destroying from c4:')
        // scope.hide_baseline_prompt();
        EXISTS = false;
        eventManager.broadcast('c4:hide_student_test');
        if (!scope.inited) {
          return;
        }
        MapStateService.setActiveModule("");
        //first save the state
        var active_items = verlet_system.getActiveSlugs();
        PIXI_gr78_Load_Cache = false;

        for (var i = 0; i < active_items.length; i++) {
          var item = getItemBySlug(active_items[i]);
          if (item) {
            MapStateService.setItemState(active_items[i], {
              x: item.sprite.position.x,
              y: item.sprite.position.y
            });
          }
        }

        MapStateService.setActiveItems(active_items);

        $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");
        if (canvas_el) {
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll); // for Firefox
          canvas_el.removeEventListener('mousewheel', handleScroll); // for everyone else

          // prevent browser from selecting other html text when double clicking the PIXI canvas
          canvas_el.removeEventListener('pointerdown', handleDoubleClick);
        }
        stage.removeChildren();
        container.removeChildren();
        app.destroy();
        window.removeEventListener("resize", onResize);
      }.bind(this);

      scope.$on('$destroy', function () {
        this.destroy();
      }.bind(this));

      scope.$watch("moduleMapData", function (moduleMapData) {

        if (!moduleMapData || EXISTS) {
          return;
        }
        $timeout(function () {
          EXISTS = true;
          checkForStudentTest();
        });
      });

      eventManager.listen('moduleview:agenda:selected', function (e, agenda) {
        for (var i = 0; i < items.length; i++) {
          //items[i].hideAgendaHighlight();
        }
        if (!agenda || !agenda.resources) {
          return;
        }
        switch (interpeteAgendaLockStatus(agenda)) {
          case 'unlock':
            return resourceLockManager.unlock(agenda.resources, true);
          // case 'lock':
          //   return resourceLockManager.lock(agenda.resources);
          // default:
          //   return resourceLockManager.reset();
        }
      });

      // scope.show_baseline = function(){
      //   scope.show_baseline_test_prompt = false;
      //   language.setAvailableOptions(['de'])
      //   eventManager.broadcast('module:open:resource', student_baseline);
      //   showing_student_assesment = true;
      // }

      // scope.hide_baseline_prompt = function(){
      //   scope.show_baseline_test_prompt = false;
      // }

      var workspace_list = {};
      var users_list = [];
      scope.$watch('[workspaceData.users, workspaceData.modules]', function (val) {
        var timer = window.isWebEmbedConnect && TeacherDataService.isTeacherWorkspaceView ? 500 : 50;

        $timeout(function () {
          if (scope.workspaceData && scope.workspaceData.modules.length > 0 && (!scope.currentActiveSubModule || !scope.currentActiveSubModule.children)) {
            workspace_list = {};
            users_list = [];
            scope.workspaceData.users.forEach(function (user) {
              users_list.push(user.user_id);
            });

            scope.workspaceData.modules.forEach(function (work) {
              if (users_list.indexOf(work.user_id) > -1) {
                workspace_list[work.resource_id] = scope.workspaceData.users.length === 1 && (work.completed || workspace_list[work.resource_id]) ? true : false;
              }
            });

            for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
              var module_container = createModuleContainer(scope.moduleMapData.resources[i], true);
            }
          }
        }, timer);
      });

      scope.itemSearchChange = function (val) {
        scope.filteredNameList = [];
        if (!scope.itemsNameList) {
          return;
        }
        if (val.trim() !== '') {
          scope.filteredNameList = scope.itemsNameList.filter(function (name) {
            var nameMod = name.name.toLowerCase();
            var valMod = val.toLowerCase();
            var bool_val;
            try {
              bool_val = nameMod.match(valMod);
            } catch (e) {
              bool_val = false;
            }
            return bool_val;
          });
        }
        // $log.log('scope.filteredNameList', scope.filteredNameList);
      };

      scope.view_controller = {
        isStudentView: true,
        isModulePanelView: true,
        openSubMod: function openSubMod(slug) {
          // $log.log('opening sub mod:', slug)
          $timeout(function () {
            eventManager.broadcast('module:change:submodule', slug);
          }, 1000);
        },
        openMainMod: function openMainMod(slug) {
          eventManager.broadcast('module:change:meta', 'c4_meta_module');
        }
      };

      eventManager.listen('sidepanel:toggled', function (e, val) {
        if (!PlatformService.isPhonePortrait()) {
          onResize(val);
        }
      });

      eventManager.listen('hide_item_selection_highlight', function (e, resource) {
        var item = getItemBySlug(resource.slug);
        item.hideAgendaHighlight(true);
      });

      eventManager.listen('toggle_item_selection_highlight', function (e, slug) {
        var item = getItemBySlug(slug);
        item.showAgendaHighlight();
      });

      var zooming = false;
      scope.zoom_function = function (val) {
        handleScroll({ detail: val, preventDefault: function preventDefault() {} });
        zooming = true;
        $timeout(function () {
          zooming = false;
        }, 10);
      };

      eventManager.listen('offline-post-call-resolved', function () {
        if (!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0 || !module_clicked) {
          for (var texture in PIXI.TextureCache) {
            var tmp = PIXI.Texture.removeTextureFromCache(texture);
            tmp.destroy(true);
          }
          eventManager.broadcast('refresh:current:tab');
          eventManager.broadcast('student:cycle:open');
        }
      });
    }
  };
});

var PIXI_c4_Load_Cache;
var PIXI_gr78_Load_Cache;
var EXISTS;
'use strict';

angular.module('mtic.components.modules.c3').service('runLikeMathItemFactory', function (C3_ASSET_URL, EventManager, $log, $timeout, TIMING_CONSTANTS, language, TeacherDataService) {
  var eventManager = new EventManager("runLikeMathItemFactory");
  var currentActiveItem = null;
  var getIconTexture = function getIconTexture(count, subModuleSprite) {
    var starIcon;
    var starsSprite = PIXI.BaseTexture.fromImage(C3_ASSET_URL + "stars.png");
    var spriteTexture;
    if (count) {
      spriteTexture = new PIXI.Texture(starsSprite, new PIXI.Rectangle(count * 90, 0, 90, 49));
      starIcon = new PIXI.Sprite(spriteTexture);
      starIcon.position.x = subModuleSprite.position.x - 20;
      starIcon.position.y = subModuleSprite.position.y - subModuleSprite.height / 2;
    }

    return starIcon;
  };

  var getStars = function getStars(item_info) {
    var levelData = {};
    var score = item_info.resourceState.score_max;
    if (score >= 1) {
      levelData.starsAchieved = 3;
      levelData.badged = true;
    } else if (score >= 0.75) {
      levelData.starsAchieved = 3;
    } else if (score >= 0.5) {
      levelData.starsAchieved = 2;
    } else if (score >= 0.25) {
      levelData.starsAchieved = 1;
    }

    return levelData;
  };

  return {
    getCurrentActiveItem: function getCurrentActiveItem() {
      return currentActiveItem;
    },
    createMapItem: function MapItem(item_info, onItemClick, positioningParams, count, stage) {

      // Grab Relevant data for item
      this.resource_info = item_info;
      this.slug = item_info.slug;
      this.type = item_info.resource_type;
      this.studentWork = item_info.studentWork;
      this.container = item_info.content.container;
      this.complete = item_info.complete;
      this.locked = item_info.locked;
      this.unlocked_by = item_info.unlocked_by;
      this.content = item_info.content;
      this.verletBody = null;
      this.parentItem = null;
      var sprite,
          icon,
          agenda_highlight = null;
      var startClickPos = {
        x: 0,
        y: 0
      };
      var buttonImage = PIXI.BaseTexture.fromImage(C3_ASSET_URL + "numpadBtn_orange.png");
      var buttonTexture = new PIXI.Texture(buttonImage, new PIXI.Rectangle(0, 110, 135, 100));
      sprite = new PIXI.Sprite(buttonTexture);
      sprite.width = 90;
      sprite.height = 100;
      var colIndex = count % positioningParams.maxPerRow;
      if (colIndex === 0) {
        sprite.position.x = positioningParams.paddingLeft;
      } else {
        sprite.position.x = positioningParams.paddingLeft + colIndex * (positioningParams.width + positioningParams.paddingBetweenItem);
      }

      var rowIndex = Math.floor(count / positioningParams.maxPerRow);
      if (rowIndex === 0) {
        sprite.position.y = positioningParams.paddingTop;
      } else {
        sprite.position.y = positioningParams.paddingTop + rowIndex * (positioningParams.height + positioningParams.paddingBetweenItem);
      }

      var textInfo;
      this.setupText = function (count, sprite) {
        // Text Information
        textInfo = new PIXI.Text(count + 1);
        textInfo.style.align = "center";
        textInfo.style.fill = "white";
        textInfo.style.fontFamily = "vanilla-extract-edit";
        textInfo.style.fontSize = 50;
        textInfo.style.fontWeight = 'bold';
        textInfo.position.set(sprite.position.x + (sprite.width - textInfo.width) / 2, sprite.position.y + (sprite.height - textInfo.height) / 2);
        stage.addChild(textInfo);
      };

      this.clearText = function () {
        textInfo.setText("");
        textInfo.updateText();
      };

      this.updateText = function (val) {
        textInfo.setText(val);
        textInfo.updateText();
      };

      this.getItemInfo = function () {
        return item_info;
      };

      this.setItemComplete = function () {
        if (this.studentWork) {
          this.studentWork.completions++;
        } else {
          this.studentWork = {
            completions: 1
          };
        }
      };

      this.selectStar = function (texture) {
        this.icon.texture = texture;
      };

      this.icon = new PIXI.Sprite();
      sprite.addChild(this.icon);
      this.sprite = sprite;
    }
  };
});
'use strict';

angular.module('mtic.components.modules.c3').directive('c3RunLikeMathModuleSelect', function ($log, $timeout, TIMING_CONSTANTS, EventManager, C3_META_ASSET_URL, PIXI, language, MODULE_AVAILABLE_LANGUAGE, MapStateService, userAccount, preliveCheck, DEV_VARIABLES, C3_ASSET_URL, TeacherDataService, PlatformService) {

  return {
    template:'<div ng-hide="currentActiveSubModule != null || badBrowser" class="inner-viewport"><canvas id="c3-run-like-math-map-canvas"></canvas></div><div class="breadcrumbs" style="font-size: 1em; position:absolute; top:12px; left:12px;"><a ng-click="returnToMetaModules()">{{getLang(moduleMapData.resource_slug)}}</a> / <a>{{getLang(currentActiveSubModule.slug)}}</a></div><div style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; display: flex; align-items: center; justify-content: center; padding-bottom:180px;background-color: #e9f0f3" ng-show="badBrowser"><div style="width:480px; max-width: 80%; font-size: 20px; text-align:center;"><div style="margin-bottom:18px;"><img src="assets/images/logos/login_mathemaTIC_logo.png"></div><div>This module is not yet available in the <b>MathemaTIC app</b> for Android and iOS.<div style="margin-top:18px; line-height:100%;"><small>Please revisit this module in a the browser or on a desktop.</small></div><button style="margin-top:30px" class="button is-small is-danger" ng-click="goBackToClasses()">My Classes</button></div></div></div>', //<canvas id="canvas" width="300" height="300"></canvas>',
    scope: {
      moduleMapData: "=moduleMapData",
      interceptClick: "=?"

    },
    link: function link(scope) {
      scope.badBrowser = false;
      /*
      if(window.isWebEmbedConnect && !scope.interceptClick){
        //kickout to browser
        var userData = userAccount.getData();
        var cur_class = userAccount.getData().role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom();
        window.location.href = window.location.href.replace('/?debugBrowsers#/web-embed-connect', '').replace('web-embed-response', '').replace('&iam-logout', '')+'?web-open-browser&firebase_token='+userData.firebase_token+'&uuid='+userData.uuid+'&session_key='+userData.sessionKey+'&user_id='+userData.user_id+'&class_id='+cur_class;
      }else */
      if (window.isWebEmbedConnect && !scope.interceptClick) {
        //scope.badBrowser = true;
      }
      var eventManager = new EventManager('c3RunLikeMathModuleSelect', scope);
      var planetContainer,
          startx = 620,
          starty = 250,
          planetInfos = [{ slug: "run_like_math_addition", name: "Addition" }, { slug: "run_like_math_subtraction", name: "Subtraction" }, { slug: "run_like_math_multiplication", name: "Multiplication" }, { slug: "run_like_math_division", name: "Division" }];
      var positions = [{ x: 0 + startx, y: 275 + starty, width: 200, height: 200 }, { x: 200 + startx, y: 100 + starty, width: 100, height: 100 }, { x: 0 + startx, y: 25 + starty, width: 100, height: 100 }, { x: -200 + startx, y: 100 + starty, width: 100, height: 100 }];
      var canvas_el,
          focusedIndex = 0,
          planetSprites;
      var canvasDimension;var sBackground;var sBlackScreen;var sShip;var sStars;var container;var Planets = [];var app;scope.currentActiveSubModule = null;

      scope.goBackToClasses = function () {
        eventManager.broadcast("navbar:my-classes:click");
        eventManager.broadcast('module:close:resource');
      };

      scope.hasModuleOption = function () {
        return true && scope.currentActiveSubModule && scope.currentActiveSubModule.children;
      };

      scope.$watch('moduleMapData', function (moduleMapData) {
        // if (!moduleMapData || EXISTS) {
        //   return;
        // }
        $timeout(function () {
          Initialize();
          setSubmodule(MapStateService.getActiveModule());
          EXISTS = true;
        }, 100);
      });

      eventManager.listen('module:change:submodule', function (e, slug) {
        if (MODULE_AVAILABLE_LANGUAGE[slug]) {
          language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[slug]);
        }
      });

      eventManager.listen('module:change:meta', function (e, slug) {
        language.resetAvilableOptions();
        if (MODULE_AVAILABLE_LANGUAGE[slug]) {
          language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[slug]);
        }
        if (MapStateService.getActiveModule() === 'run_like_math') {
          MapStateService.setActiveModule(scope.moduleMapData.slug);
          eventManager.broadcast('module:close:resource', { isPassive: true });
        }
      });

      var lastSlug;
      var setSubmodule = function setSubmodule(slug) {
        var i;
        for (i = 0; i < scope.moduleMapData.resources.length; i++) {
          if (slug === scope.moduleMapData.resources[i].slug) {
            scope.interceptClick = {
              slug: slug
            };
            eventManager.broadcast("submodule:change:in:run_like_math", scope.moduleMapData.resources[i]);
          }
        }

        return;
      };

      var populatePlanetContainer = function populatePlanetContainer(focusIndex, initialCall) {
        Planets = [];
        var indexCount = 0;
        for (var i = focusIndex; i < focusIndex + 4; i++) {
          var actualIndex = i % 4;
          var planet = new Planet(planetSprites[actualIndex], positions[indexCount].x, positions[indexCount].y, positions[indexCount].width, positions[indexCount].height, planetInfos[actualIndex].slug, planetInfos[actualIndex].name, initialCall);
          Planets.push(planet);
          indexCount++;
        }
      };

      var createOpenButton = function createOpenButton() {
        var openButton = new PIXI.Sprite.fromImage(C3_ASSET_URL + 'playbutton.png');
        openButton.buttonMode = true;
        openButton.interactive = true;
        openButton.width = 336;
        openButton.height = 115;
        openButton.position.set(positions[0].x - 165, positions[0].y + 50);
        openButton.on('pointertap', function (e) {
          var cur_slug = Planets[0].sprite.slug;
          $timeout(function () {
            setSubmodule(cur_slug);
          }, TIMING_CONSTANTS.INSTANT);
        });

        var graphics = new PIXI.Graphics();
        var setupText = function setupText() {
          openButton.removeChild(graphics);
          graphics.removeChildren();
          graphics.clear();
          graphics = new PIXI.Graphics();
          var textInfo = new PIXI.Text(language.get("16290"));
          textInfo.style.align = "center";
          textInfo.style.fill = "white";
          textInfo.style.fontFamily = "vanilla-extract-edit";
          textInfo.style.fontSize = 70;
          graphics.addChild(textInfo);
          textInfo.x += 20;
          textInfo.y = openButton.height / 2 - textInfo.height / 2 - 10;
          graphics.position.set(20, 0);
          openButton.addChild(graphics);
        };
        setupText();
        container.addChild(openButton);

        eventManager.listen('language:change', function () {
          setupText();
        });
      };

      var setupLeftAndRightArrows = function setupLeftAndRightArrows() {
        var rightArrow = new PIXI.Sprite.fromImage(C3_ASSET_URL + 'arrow.png');
        rightArrow.interactive = true;
        rightArrow.buttonMode = true;
        rightArrow.y = 350;
        rightArrow.x = 350 + positions[0].width + 235;
        rightArrow.on('pointertap', function (e) {
          focusedIndex += 1;
          reDrawPlanetContainer(focusedIndex);
        });
        container.addChild(rightArrow);

        var leftArrow = new PIXI.Sprite.fromImage(C3_ASSET_URL + 'left_arrow.png');
        leftArrow.interactive = true;
        leftArrow.buttonMode = true;
        leftArrow.y = 350;
        leftArrow.x = 350;
        leftArrow.on('pointertap', function (e) {
          focusedIndex -= 1;
          if (focusedIndex < 0) {
            focusedIndex = 3;
          }
          reDrawPlanetContainer(focusedIndex);
        });
        container.addChild(leftArrow);
      };

      var setupHeadingText = function setupHeadingText() {
        var graphics = new PIXI.Graphics();
        var textInfo = new PIXI.Text("MathleTIC");
        textInfo.style.align = "center";
        textInfo.style.fill = "white";
        textInfo.style.fontFamily = "vanilla-extract-edit";
        textInfo.style.fontSize = 65;
        graphics.addChild(textInfo);
        graphics.position.set(positions[2].x - textInfo.width / 2, 20); //((openButton.width-textInfo.width)/2,openButton.height/2);
        container.addChild(graphics);
      };

      var Initialize = function Initialize() {
        PIXI.ticker.shared.add(delta_resize);
        canvas_el = document.getElementById('c3-run-like-math-map-canvas');
        var width = canvas_el.parentElement.clientWidth;
        var height = canvas_el.parentElement.clientHeight;
        canvasDimension = {
          width: width,
          height: height
          // Create the application and container
        };app = PIXI.autoDetectRenderer(canvasDimension.width, canvasDimension.height, {
          autoResize: true,
          backgroundColor: 0x18052b,
          view: canvas_el
        });
        // Load Assets
        container = new PIXI.Container();
        container.alpha = 0.01;
        setupHeadingText();
        createOpenButton();
        //add left right arrows
        setupLeftAndRightArrows();
        planetContainer = new PIXI.Container();
        Planets = [];
        planetSprites = [];
        for (var i = 0; i < 4; i++) {
          var planetSprite = new PIXI.Sprite.fromImage(C3_ASSET_URL + 'moon.png');
          planetSprites.push(planetSprite);
        }

        populatePlanetContainer(0, true);
        container.addChild(planetContainer);
        // if(TeacherDataService.isTeacherWorkspaceView){
        //   container.scale.set(1,0.9);
        // }
        container.y += 100;
        //if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1200){
        //container.x -= 100;
        //container.y += 50;
        //container.scale.set(0.6,0.6)
        //}
        //else if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1400){
        //   //container.y += 50;
        //   container.scale.set(0.8,0.8)
        // }
        window.addEventListener("resize", onResize);
        $timeout(function () {
          onResize();
          container.alpha = 1;
        }, 200);
      };

      var removeAllChild = function removeAllChild(pContainer) {
        while (pContainer.children[0]) {
          while (pContainer.children[0].children[0]) {
            pContainer.children[0].removeChild(pContainer.children[0].children[0]);
          }
          pContainer.removeChild(pContainer.children[0]);
        }
      };

      var reDrawPlanetContainer = function reDrawPlanetContainer(focusIndex) {
        removeAllChild(planetContainer);
        populatePlanetContainer(focusIndex);
        container.addChild(planetContainer);
      };

      var updateSpriteAnimation = function updateSpriteAnimation() {
        angular.forEach(Planets, function (each) {
          var diffX = each.sprite.moveToX - each.sprite.x;
          var diffY = each.sprite.moveToY - each.sprite.y;
          if (diffX !== 0) {
            each.sprite.x += each.diffX / 10;
          }

          if (diffY !== 0) {
            each.sprite.y += each.diffY / 10;
          }
        });
      };

      // Update Function
      function delta_resize(delta) {
        updateSpriteAnimation();
        app.render(container);
      }

      eventManager.listen('module:change:meta', function (data) {
        scope.currentActiveSubModule = null;
      });

      // Define Planet Object
      var Planet = function Planet(sprite, xPos, yPos, width, height, slug, title, initialCall) {
        var _this = this;

        this.xPos = xPos;
        this.yPos = yPos;
        // Sprite
        this.sprite = sprite;
        this.sprite.width = width;
        this.sprite.height = height;
        if (initialCall) {
          this.sprite.x = this.xPos;
          this.sprite.y = this.yPos;
        }
        this.sprite.moveToX = this.xPos;
        this.sprite.moveToY = this.yPos;
        this.diffX = this.sprite.moveToX - this.sprite.x;
        this.diffY = this.sprite.moveToY - this.sprite.y;
        sprite.anchor.set(0.5, 1);
        this.sprite.slug = slug;
        var graphics = new PIXI.Graphics();

        var setupText = function setupText() {

          // Text Information
          _this.sprite.removeChild(graphics);
          graphics.removeChildren();
          graphics.clear();
          var textInfo = new PIXI.Text(language.get(slug));
          textInfo.style.align = "center";
          textInfo.style.fill = "white";
          textInfo.style.fontFamily = "vanilla-extract-edit";
          textInfo.style.fontSize = 150;
          graphics.position.set(-(textInfo.width / 2), -985);
          graphics.addChild(textInfo);
          _this.sprite.addChild(graphics);
        };

        setupText();
        eventManager.listen('language:change', function () {
          setupText();
        });
        // this.sprite.addChild(graphics);
        // Add everything to the stage
        planetContainer.addChild(this.sprite);
      };

      this.destroy = function () {
        eventManager.broadcast('destroy-c3-run-like-math-map');
        if (planetContainer) {
          planetContainer.removeChildren();
        }
        container.removeChildren();
        app.destroy();
        PIXI.ticker.shared.remove(delta_resize);
        EXISTS = false;

        window.removeEventListener("resize", onResize);
      }.bind(this);

      scope.$on('$destroy', function () {
        this.destroy();
      }.bind(this));

      eventManager.listen('module:change:meta', function (e, slug) {
        eventManager.broadcast("close:current:module", slug);
      });

      scope.returnToMetaModules = function () {
        eventManager.broadcast('module:change:meta', {});
      };

      function onResize(sidepanel_expanded) {
        if (!canvas_el) {
          return;
        }

        var sidepanel_width = 0;
        if (sidepanel_expanded === true || sidepanel_expanded === false) {
          sidepanel_width = sidepanel_expanded ? 140 : -200;
        }

        var canvasDimention = {
          width: canvas_el.parentElement.clientWidth - sidepanel_width,
          height: canvas_el.parentElement.clientHeight
        };

        canvas_el.width = canvasDimention.width;
        canvas_el.height = canvasDimention.height;

        app.resize(canvasDimention.width, canvasDimention.height);
        $log.log('from resize : ', planetContainer.width, container.width, app.width, canvas_el.parentElement.clientWidth);
        if (container && app) {
          var scale = Math.min(0.8, app.width / 800);
          container.scale.set(scale, scale);
          container.x = app.width / 2 - container.width - 80;
          container.y = app.height / 2 - container.height / 2;
        }
      }
      eventManager.listen('sidepanel:toggled', function (e, val) {
        if (!PlatformService.isPhonePortrait()) {
          onResize(val);
        }
      });

      scope.getLang = language.get;
    }
  };
});

var PIXI_Load_Cache;
var EXISTS;
'use strict';

angular.module('mtic.components.modules.c3').directive('c3Module1', function (C3_ASSET_URL, $log, $http, mapItemFactory, EventManager, TeacherDataService, $timeout, userAccount, PlatformService) {
  return {
    template:'<canvas id="canvas" width="300" height="300" style="float:right"></canvas><div style="display:flex; position:fixed;right: 8px; top: 45px;"><button ng-click="zoom_function(1)" class="button" style="margin-right:3px;font-size:24px"><i class="fa fa-search-minus" aria-hidden="true"></i></button> <button ng-click="zoom_function(-1)" class="button" style="font-size:24px"><i class="fa fa-search-plus" aria-hidden="true"></i></button></div>',
    scope: {
      moduleMapData: "=moduleMapData",
      onItemClick: '<',
      submodId: '=?',
      agendasList: '=?'
    },
    link: function link(scope) {
      if (!scope.submodId) {
        scope.submodId = 'm1v2';
      }
      var submod_mapping = {
        m1: {
          backgroundColor: 0x51b357,
          mapName: ''
        },
        m1v2: {
          backgroundColor: 0x51b357,
          mapName: 'm1v2_'
        },
        m34: {
          backgroundColor: 0x00c1df,
          mapName: 'm34_'
        },
        m56: {
          backgroundColor: 0x43BED1,
          mapName: 'm56_'
        }
      };

      scope.isWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
      scope.isTeacher = userAccount.getData().role.isTeacher;
      var thiz = this;
      var doUpdate = false;
      var eventManager = new EventManager('c3Module', scope);
      var canvasDimention;
      //PIXI Rendering Settings
      var isAndroid = navigator.userAgent.match(/Android/i);
      var renderer;
      if (isAndroid) {
        renderer = new PIXI.CanvasRenderer(256, 256, {
          autoResize: true,
          backgroundColor: submod_mapping[scope.submodId].backgroundColor,
          view: document.getElementById('canvas')
        });
      } else {
        renderer = PIXI.autoDetectRenderer(256, 256, {
          autoResize: true,
          backgroundColor: submod_mapping[scope.submodId].backgroundColor,
          view: document.getElementById('canvas')
        });
      }

      var sidepanel_width = 0;
      if (scope.isTeacher) {
        var sidepanel = document.getElementById('teacher_sidepanel');
        sidepanel_width = TeacherDataService.inTeacherAgendaView ? 60 : sidepanel.offsetWidth;
        if (!TeacherDataService.inTeacherAgendaView && TeacherDataService.isWorkspaceView) {
          sidepanel_width += -30;
        }
      }

      canvasDimention = {
        width: window.innerWidth - sidepanel_width - 180,
        height: window.innerHeight - 50
        //REMOVE THIS ONCE AGENDA
        // if(!scope.isTeacher){
        //   canvasDimention.width = window.innerWidth;
        // }
        //end
        // var workspaceAdjustingScale = {
        //   x:0.7,
        //   y:0.7
        // }

      };var scale = canvasDimention.width / window.innerWidth;

      $log.log('SETTING IMAGE DIMENSIONS : ', canvasDimention.width, window.innerWidth, scale);
      // if(scope.isWorkspaceView && window.screen.width < 1200){
      //   scale = 0.4;
      // }else if(scope.isWorkspaceView && window.screen.width < 1400){
      //   scale = 0.5;
      // }
      var stage = new PIXI.Container();
      var graphics = new PIXI.Graphics();
      var sprite;
      var isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);
      stage.interactive = true;
      stage.addChild(graphics);
      thiz.renderer = renderer;
      //console.log('stage m1 : ', stage.children)

      //Handles the intro animation/fade in
      var cloud_man = function CloudManager() {
        var progress = 0;
        var randomMod = Math.random();
        var clouds = [];
        var overlay = new PIXI.Graphics();

        overlay.beginFill(0x0b2732);
        overlay.drawRect(0, 0, 100, 100);
        overlay.endFill();

        var overlay_sprite = new PIXI.Sprite(overlay.generateCanvasTexture(PIXI.SCALE_MODES.NEAREST));
        // overlay_sprite.position.x = overlay_sprite.width/2;
        // overlay_sprite.position.y = overlay_sprite.height/2;
        // $log.log("width-height",overlay_sprite.width,overlay_sprite.height);
        return {
          overlay_sprite: overlay_sprite,
          update: function update() {
            progress = Math.min(progress + 1, 100);
            overlay_sprite.alpha = (100 - progress) / 100.0;
          },
          onResize: function onResize(width, height) {
            overlay_sprite.width = width;
            overlay_sprite.height = height;
          }
        };
      }();
      stage.addChild(cloud_man.overlay_sprite);
      var items = [];

      //Object that tracks intertial click and drag panning around the screen
      var drag_info = {
        dragging: false,
        velocity: {
          x: 0,
          y: 0
        },
        last_mouse_pos: {
          x: 0,
          y: 0
        },
        start_drag_mouse_pos: {
          x: 0,
          y: 0
        },
        start_drag_pos: {
          x: 0,
          y: 0
        }

        //On a click, pull the pixel color at the mouse position from the gl render and create some particles
      };var makeGrass = function makeGrass() {
        renderer.render(stage);
        var gl = renderer.gl;
        var pixelValues = new Uint8Array(4);
        if (gl) {
          gl.readPixels(renderer.plugins.interaction.eventData.data.global.x, renderer.height - renderer.plugins.interaction.eventData.data.global.y, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixelValues);
        }
        for (var i = 0; i < 10; i++) {
          /*jshint bitwise: false*/
          var hex = Math.min(Math.max(0, pixelValues[0] - 15 + Math.random() * 50), 255) << 16 | Math.min(Math.max(0, pixelValues[1] - 15 + Math.random() * 50), 255) << 8 | Math.min(Math.max(0, pixelValues[2] - 15 + Math.random() * 50), 255);
          /*jshint bitwise: true*/
          var particle = new PIXI.Sprite(thiz.grass_tex);
          particle.tint = hex;
          thiz.particle_container.addChild(particle);
          particle.x = (drag_info.last_mouse_pos.x - sprite.x - Math.random() * 5) / scale;
          particle.y = (drag_info.last_mouse_pos.y - sprite.y - Math.random() * 5) / scale;
          particle.vel = {
            x: Math.random() * 5 - 2.5,
            y: -Math.random() * 4
          };
          particle.anchor.set(0.5, 0.5);
          particle.scale.set(1.5 + Math.random(), 1.5 + Math.random());
        }
      };

      //This loops to control things that should update every frame
      var update = function update() {
        if (!doUpdate || !renderer) {
          return;
        }
        //update the fade in animation
        cloud_man.update();

        //Update the particle system
        for (var i = 0; i < thiz.particle_container.children.length; i++) {
          var child = thiz.particle_container.children[i];
          child.vel.y += 0.15;
          child.vel.x *= 0.95;
          child.vel.y *= 0.95;
          child.transform.position.y += child.vel.y;
          child.transform.position.x += child.vel.x;

          child.transform.scale.x *= 0.8 + Math.random() / 5; //0.93;
          child.transform.scale.y *= 0.8 + Math.random() / 5; //0.93;

          if (child.transform.scale.x < 0.05) {
            thiz.particle_container.removeChild(child);
            i--;
          }
        }

        //mouse drag map panning
        if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
          drag_info.velocity = {
            x: drag_info.velocity.x * 0.954,
            y: drag_info.velocity.y * 0.954
          };
        } else {
          //If they're not dragging, move the map based on its inertia and damp the inertia
          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;

          sprite.position.x -= drag_info.velocity.x;
          sprite.position.y -= drag_info.velocity.y;
        }

        //Ater dragging, center the map if it is smaller than the window dimensions or clamp the position if the map is larger than the window dimensions
        // if (window.innerWidth > sprite.width + 200) {
        //   sprite.position.x = window.innerWidth / 2 - sprite.width / 2;
        //   if(scope.isTeacher){
        //     sprite.position.x -= 100;
        //   }
        // } else {
        // sprite.position.x = Math.max((window.innerWidth - sprite.width - 100), Math.min(+100, sprite.position.x));
        // }

        if (sprite && window.innerHeight > sprite.height + 200) {
          sprite.position.y = window.innerHeight / 2 - sprite.height / 2;
        } else if (sprite) {
          sprite.position.y = Math.max(window.innerHeight - sprite.height - 100, Math.min(100, sprite.position.y));
        }

        if (sprite) {
          sprite.x = Math.max(Math.min(renderer.width / 2 - sprite.width / 2 + 250, sprite.position.x), renderer.width / 2 - sprite.width / 2 - 250); // - 200/scale;
        }
        //render the map (with PIXI) and request another update loop call from the canvas context
        renderer.render(stage);
        requestAnimationFrame(update);

        if (window.DEBUG_TOUCH) {
          $log.log('c3m1 update ; ', JSON.stringify(drag_info));
        }
      };

      thiz.onResize = function (sidepanel_expanded) {
        var _canvasEl = document.getElementById('canvas');
        if (!_canvasEl) {
          return;
        }
        var sidepanel_width = TeacherDataService.sidepanelStatus ? 260 : 60;
        var canv_width;
        if (!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView) {
          if (sidepanel_expanded === true || sidepanel_expanded === false) {
            sidepanel_width = sidepanel_expanded ? 140 : -200;
          } else {
            sidepanel_width = 0;
          }
          canv_width = _canvasEl.parentElement.parentElement.offsetWidth - sidepanel_width;
        } else {
          var middleview = document.getElementById('agenda_middleview');
          if (middleview) {
            sidepanel_width += 300;
          }
          if (!TeacherDataService.inTeacherAgendaView) {
            sidepanel_width += -30;
          }
          canv_width = window.innerWidth - 370 - sidepanel_width;
        }

        canvasDimention = {
          width: canv_width,
          height: window.innerHeight - 35
        };

        scale = canvasDimention.width / window.innerWidth;
        scale = isMobile ? scale * 0.75 : scale;
        if (thiz.sprite && sidepanel_expanded !== true && sidepanel_expanded !== false) {
          thiz.sprite.scale.set(scale, scale);
        }

        //REMOVE THIS ONCE AGENDA
        // if(!scope.isTeacher){
        //   canvasDimention.width = window.innerWidth;
        // }
        //end

        if (_canvasEl && canvasDimention) {

          _canvasEl.width = canvasDimention.width;
          _canvasEl.height = canvasDimention.height;

          renderer.resize(canvasDimention.width, canvasDimention.height);
          cloud_man.onResize(canvasDimention.width, canvasDimention.height);
          // cloud_man.onResize(canvasDimention.width+((1-workspaceAdjustingScale.x)*canvasDimention.width), canvasDimention.height+((1-workspaceAdjustingScale.y)*canvasDimention.height));
          // $log.log("resized-width-height",canvasDimention.width,canvasDimention.height);
        }
      };

      scope.$watch("moduleMapData", function (moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        //this is what runs to initialize the map
        if (!PIXI_Load_Cache || !PIXI.loader.resources[C3_ASSET_URL + submod_mapping[scope.submodId].mapName + "map.png"]) {
          PIXI.loader.reset();
          PIXI.loader.add([C3_ASSET_URL + "map.png", C3_ASSET_URL + "m1v2_map.png", C3_ASSET_URL + "m34_map.png", C3_ASSET_URL + "m56_map.png", C3_ASSET_URL + "star.png", C3_ASSET_URL + "item_blue_0.png", C3_ASSET_URL + "item_blue_1.png", C3_ASSET_URL + "item_red_0.png", C3_ASSET_URL + "item_red_1.png", C3_ASSET_URL + "item_red_2.png", C3_ASSET_URL + "item_red_3.png", C3_ASSET_URL + "item_black_0.png", C3_ASSET_URL + "item_black_1.png", C3_ASSET_URL + "item_black_2.png", C3_ASSET_URL + "item_black_3.png", C3_ASSET_URL + "item_blue_locked.png", C3_ASSET_URL + "item_red_locked.png", C3_ASSET_URL + "item_black_locked.png", C3_ASSET_URL + "item_af_locked.png", C3_ASSET_URL + "item_af.png", C3_ASSET_URL + "item_test.png", C3_ASSET_URL + "assessment.png", C3_ASSET_URL + "assessment_complete.png", C3_ASSET_URL + "item_test_locked.png"]).load(function () {
            PIXI_Load_Cache = true;
            $timeout(function () {
              init(moduleMapData.resources);
            });
          });
        } else {
          $timeout(function () {
            init(moduleMapData.resources);
          });
        }
      });

      var _TOUCHED_POINTS = [];
      var init = function init(moduleMapData) {
        $log.debug('[[c3Module]] INIT', moduleMapData);
        var combinedResourceMap = {};
        _.forEach(moduleMapData, function (someItem) {
          combinedResourceMap[someItem.slug] = someItem;
        });
        if (Object.keys(combinedResourceMap).length !== moduleMapData.length) {
          throw "some resourceMap slugs are not unique!";
        }

        sprite = new PIXI.Sprite(PIXI.loader.resources[C3_ASSET_URL + submod_mapping[scope.submodId].mapName + "map.png"].texture);
        sprite.interactive = true;

        // if(TeacherDataService.isTeacherWorkspaceView)
        // {
        // sprite.y =  sprite.height / 2;
        // }else{
        // $log.log('sprite data : ', renderer.width, sprite.width)
        sprite.x = renderer.width / 2 - sprite.width / 2 + 200 / scale;
        sprite.y = renderer.height / 2 - sprite.height / 2;
        // }

        stage.addChildAt(sprite, 0);
        thiz.sprite = sprite;

        thiz.sprite.scale.set(scale, scale);

        thiz.particle_container = new PIXI.Sprite();
        sprite.addChild(thiz.particle_container);
        var grass_graphic = new PIXI.Graphics();
        grass_graphic.beginFill(0xFFFFFF);
        grass_graphic.drawCircle(5, 5, 5);
        grass_graphic.endFill();
        thiz.grass_tex = grass_graphic.generateCanvasTexture(PIXI.SCALE_MODES.NEAREST);

        stage.on('pointerdown', function (e) {
          var e_o = e.data.originalEvent;
          _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x: e_o.pageX, y: e_o.pageY });

          drag_info.dragging = true;

          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: sprite.x,
            y: sprite.y
          };
          drag_info.start_drag_mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };

          if (window.DEBUG_TOUCH) {
            $log.log('c3m1 pointerdown ; ', JSON.stringify(drag_info));
          }
        });

        stage.on('pointermove', function (e) {
          if (!drag_info.dragging) {
            return;
          }

          var mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
            //Move the map based on the mouse position
          };sprite.position.x = drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
          sprite.position.y = drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);

          //vector of mouse movement since last update frame
          var delta_pos = {
            x: drag_info.last_mouse_pos.x - mouse_pos.x,
            y: drag_info.last_mouse_pos.y - mouse_pos.y
          };

          //add the mouse movement vector to the map movement velocity (inertia)
          drag_info.velocity = {
            x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
            y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
          };

          drag_info.last_mouse_pos = {
            x: mouse_pos.x,
            y: mouse_pos.y
          };
        });

        stage.on('pointerup', function (e) {
          drag_info.dragging = false;
          if (window.DEBUG_TOUCH) {
            $log.log('c3m1 pointerup ; ', JSON.stringify(drag_info), e);
          }
          if (Math.abs(drag_info.start_drag_pos.x - sprite.x) < 5 && Math.abs(drag_info.start_drag_pos.y - sprite.y) < 5) {
            makeGrass();
          }

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });
        stage.on('pointerout', function (e) {
          drag_info.dragging = false;
          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });

        _.each(combinedResourceMap, function (resource) {
          if (!resource.display.position) {
            return;
          }
          var displayItem;
          if (TeacherDataService.isTeacherModuleView) {
            resource.locked = false;
          }
          items.push(displayItem = new mapItemFactory.createMapItem(resource, scope.onItemClick, eventManager));
          if (resource.slug === 'mtic_c3_m1_assessment') {
            if (resource.studentWork !== null) {
              if (resource.complete) {
                // $log.debug(resource.slug + " completed ");
                displayItem.addCompleteStar();
              }
            }
          }
          displayItem.sprite.position.x -= 20;
          displayItem.sprite.position.y -= 15;
          sprite.addChild(displayItem.sprite);
        });
        _.forEach(items, function (item) {
          if (!item.locked || item.unlockedByAgenda) {
            item.unlock();
          }
        });

        if (TeacherDataService.inTeacherAgendaView) {
          eventManager.broadcast('agenda:request:selected');
        }

        if (scope.agendasList && scope.agendasList.length > 0) {
          scope.agendasList.forEach(function (agenda) {
            if (agenda.force_unlock) {
              agenda.resources.forEach(function (item) {
                unlockpath(item);
              });
            }
          });
        }
        doUpdate = true;
        update();
      };

      eventManager.listen('agenda:respond:selected', function (e, data) {
        // $log.log('GOT AGENDA RESPONSE : ' , data)
        items.forEach(function (cur) {
          cur.hideAgendaHighlight();
        });
        data.forEach(function (item) {
          var get_item = getItemBySlug(item.slug);
          if (get_item) {
            get_item.showAgendaHighlight(true);
          }
        });
      });

      eventManager.listen('module:change:meta', function (e, slug) {
        eventManager.broadcast("close:current:module", slug);
      });

      renderer.render(stage);
      window.addEventListener("resize", thiz.onResize);
      //var isExpanded = TeacherDataService.inTeacherAgendaView || isMobile ? false : null;
      thiz.onResize();

      $timeout(function () {
        var _canvasEl = document.getElementById('canvas');
        if (_canvasEl) {
          _canvasEl.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
          _canvasEl.addEventListener('mousewheel', handleScroll, false); // for everyone else
        }
      }, 1000);

      eventManager.listen('destroy-c3-map', function () {
        destroy_this();
      });

      var currentHighlighted;
      eventManager.listen('module:select:resource', function (e, data) {
        // $log.log('got event module:select:resource ', data)
        var scopeResource = getResourceBySlug(data.slug);
        if (scopeResource === null) {
          eventManager.broadcast('module:dismiss:focus');
          eventManager.broadcast('module:change:metaToSub', data);
          return;
        }
        if (scope.onItemClick) {
          // $log.log('from item click listen')
          var item = getItemBySlug(data.slug);
          scope.onItemClick(scopeResource, item, data);
        } else {
          if (currentHighlighted) {
            currentHighlighted.hideAgendaHighlight();
          }
          var get_item = getItemBySlug(data.slug);
          if (get_item) {
            get_item.showAgendaHighlight(true);
            currentHighlighted = get_item;
          }
        }

        $timeout(function () {
          thiz.onResize();
        }, 100);
      });

      var getItemBySlug = function getItemBySlug(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      };

      var getItemById = function getItemById(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      };

      var getResourceBySlug = function getResourceBySlug(slug) {
        var i, n;
        for (n = 0; n < scope.moduleMapData.children.length; n++) {
          if (scope.moduleMapData.children[n].slug === slug) {
            return scope.moduleMapData.children[n];
          }
        }
        return null;
      };

      eventManager.listen('sidepanel:toggled', function (e, val) {
        if (!PlatformService.isPhonePortrait()) {
          thiz.onResize(val);
        }
      });

      // eventManager.listen('module:center:resource', function(e, data) {
      //   $log.log('c3, do you get this : ', data)
      //   //focus_item = getItemBySlug(data.slug);
      // })

      eventManager.listen('hide_item_selection_highlight', function (e, resource) {
        // $log.log('got hide ? ', resource)
        var item = getItemBySlug(resource.slug);
        if (item) {
          item.hideAgendaHighlight(true);
        }
      });

      eventManager.listen('toggle_item_selection_highlight', function (e, slug) {
        // $log.log('got toggle_item_selection_highlight ? ', slug)
        var item = getItemBySlug(slug);
        item.showAgendaHighlight();
      });

      eventManager.listen('moduleview:agenda:loaded', function (e, data) {
        if (data.length > 0) {
          scope.agendasList = data;
          data.forEach(function (agenda) {
            if (agenda.force_unlock) {
              agenda.resources.forEach(function (item) {
                unlockpath(item);
              });
            }
          });
        }
      });
      scope.$watch('agendasList', function (data) {
        if (data) {
          data.forEach(function (agenda) {
            if (agenda.force_unlock) {
              agenda.resources.forEach(function (item) {
                unlockpath(item);
              });
            }
          });
        }
      });
      function unlockpath(item_id, use_slug) {
        items.forEach(function (resource) {
          if (resource.id === item_id || use_slug && item_id === resource.slug) {
            resource.unlock();
            resource.unlockedByAgenda = true;
            if (resource.unlocked_by.length > 0) {
              resource.unlocked_by.forEach(function (higher_resource) {
                unlockpath(higher_resource, true);
              });
            }
          }
        });
      }

      eventManager.listen('offline-post-call-resolved', function () {
        destroy_this(true);
        eventManager.broadcast('refresh:current:tab');
        eventManager.broadcast('student:cycle:open');
      });
      function destroy_this(clear_cache) {
        doUpdate = false;
        PIXI_Load_Cache = false;
        var _canvasEl = document.getElementById('canvas');
        _canvasEl.removeEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        _canvasEl.removeEventListener('mousewheel', handleScroll, false); // for everyone else
        window.removeEventListener("resize", thiz.onResize);

        if (stage) {
          stage.removeChildren();
        }
        if (clear_cache) {
          for (var texture in PIXI.TextureCache) {
            var tmp = PIXI.Texture.removeTextureFromCache(texture);
            tmp.destroy(true);
          }
        }
        if (renderer) {
          renderer.destroy(true);
        }
      }

      scope.$on('$destroy', function () {
        destroy_this();
      });

      var zooming = false;
      scope.zoom_function = function (val) {
        handleScroll({ detail: val, preventDefault: function preventDefault() {} });
        zooming = true;
        $timeout(function () {
          zooming = false;
        }, 10);
      };
      var handleScroll = function handleScroll(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = evt.detail < 0 || evt.wheelDelta > 0 ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.0, scale + direction / 15), 0.25);
        var diff = scale - start_scale;

        thiz.sprite.scale.set(scale, scale);

        evt.preventDefault();
        return false;
      };
    }
  };
});

var PIXI_Load_Cache;
'use strict';

angular.module('mtic.components.modules.bubbleModule', []).component('bubbleModule', {
  template:'',
  bindings: {
    moduleMapData: '<'
  },
  controllerAs: 'bubbleModule',
  controller: function controller(EventManager, $scope) {
    var eventManager = new EventManager('bubbleModule', $scope);
    var bubbleModule = this;
  }
});
'use strict';

angular.module('mtic.components.modules.bubbleModule').service('BubbleModuleItem', function ($log, $timeout, TIMING_CONSTANTS, language, EventManager, DEV_VARIABLES, ModuleFilter) {

  // event manager
  var eventManager = new EventManager('BubbleModuleItem');

  // constructor
  return function BubbleModuleItem(item_info, ASSET_URL, eventBindings) {
    var bubbleModuleItem = this;
    // Public Variables
    bubbleModuleItem.id = item_info.id;
    bubbleModuleItem.name = item_info.name;
    bubbleModuleItem.slug = item_info.slug;
    bubbleModuleItem.type = item_info.resource_type;
    bubbleModuleItem.studentWork = item_info.studentWork;
    bubbleModuleItem.container = item_info.content.container;
    bubbleModuleItem.complete = item_info.complete;
    bubbleModuleItem.locked = item_info.locked;
    bubbleModuleItem.unlocked_by = item_info.unlocked_by;
    bubbleModuleItem.content = item_info.content;
    bubbleModuleItem.verletBody = null;
    bubbleModuleItem.parentItem = null;
    bubbleModuleItem.complete = item_info.complete;

    // Private Variables
    var agenda_highlight = null;
    var unclickableTypes = ['symlink'];
    var icon = new PIXI.Sprite();
    var sprite = bubbleModuleItem.sprite = new PIXI.Sprite();
    var startClickPos = {
      x: 0,
      y: 0
    };
    var mouseOver, mouseOut, pointerdown, tooltip;

    // DEV complete
    if (DEV_VARIABLES.RESOURCES.MARK_COMPLETE.indexOf(bubbleModuleItem.slug) > -1) {
      bubbleModuleItem.complete = true;
    }

    //Handle group stuff
    if (item_info.children && item_info.children.length > 0) {
      bubbleModuleItem.locked = true;
      var i = 0;
      for (i = 0; i < item_info.children.length; i++) {
        bubbleModuleItem.locked = bubbleModuleItem.locked && item_info.children[i].locked;
      }
      item_info.locked = bubbleModuleItem.locked;

      bubbleModuleItem.complete = true;
      for (i = 0; i < item_info.children.length; i++) {
        bubbleModuleItem.complete = bubbleModuleItem.complete && item_info.children[i].complete;
      }
      item_info.complete = bubbleModuleItem.complete;
      item_info.resourceState = {};
      item_info.resourceState.score_max = bubbleModuleItem.complete ? 1 : 0;
    }
    // Unlock DEV
    if (DEV_VARIABLES.RESOURCES.UNLOCK_THESE.indexOf(this.slug) > -1) {
      this.locked = false;
    }

    // Private Methods

    var getIconFilename = function getIconFilename(item_info) {
      //assessments are easy
      if (item_info.resource_type === 'assessment') {
        if (item_info.complete) {
          return 'assessment_complete.png';
        }
        return 'assessment.png';
      }

      //get the color from item_info.display.color, fall back to "red" if it isn't defined
      var color_string = item_info.display.color !== undefined ? item_info.display.color : 'red';

      var suffix;
      if (item_info.locked) {
        suffix = "_locked";
      } else {
        if (!item_info.resourceState) {
          suffix = "_0";
        } else {
          var count = Math.floor(item_info.resourceState.score_max * 3);
          if (color_string === 'blue') {
            count = Math.min(count, 1);
          }
          suffix = "_" + count;
        }
      }
      var filename = "item_" + color_string + suffix + ".png";
      return filename;
    };

    var getItemDisplayName = function getItemDisplayName() {
      var itemDisplayName;
      if (item_info.display && item_info.display.nameLangId) {
        itemDisplayName = language.get(item_info.display.nameLangId);
      } else {
        itemDisplayName = language.get(item_info.slug, null, true);
      }
      if (!itemDisplayName) {
        itemDisplayName = item_info.name;
      }
      return itemDisplayName;
    };

    // Public Methods
    bubbleModuleItem.setDelegate = function (del) {
      var boundClick = function (e) {
        del(bubbleModuleItem.slug);
      }.bind(bubbleModuleItem);
      sprite.on('pointertap', boundClick);
    };

    bubbleModuleItem.updateIcon = function () {
      if (bubbleModuleItem.type === 'symlink') {
        icon.texture = PIXI.loader.resources[ASSET_URL + "symlink.png"].texture;
      } else {
        icon.texture = PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)].texture;
      }
    };
    bubbleModuleItem.buildTooltip = function () {
      if (tooltip !== null && tooltip !== undefined) {
        sprite.removeChild(tooltip);
        tooltip.interactive = false;
      }
      tooltip = new PIXI.Sprite();
      // Text Information
      var textInfo = new PIXI.Text(getItemDisplayName(), {
        fontFamily: 'Arial',
        align: 'center',
        fontSize: 24,
        fill: 0xFFFFFF,
        dropShadow: true,
        dropShadowDistance: 1,
        dropShadowBlur: 0,
        wordWrap: true,
        wordWrapWidth: 200
      });

      var tooltip_graphics = new PIXI.Graphics();

      var drawTooltipContainer = function drawTooltipContainer() {
        tooltip_graphics.clear();
        // Draw Text Bubble that wraps around the text
        tooltip_graphics.lineStyle(0);
        tooltip_graphics.beginFill(0x3B5763);
        tooltip_graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 20, 10);
        tooltip_graphics.endFill();

        // Draw Triangle pointing to planet
        tooltip_graphics.beginFill(0x3B5763);
        tooltip_graphics.moveTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
        tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2, textInfo.y - 18);
        tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2 + 5, textInfo.y - 10);
        tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
        tooltip_graphics.endFill();
        tooltip_graphics.x = -tooltip_graphics.width / 2 + 20;
        tooltip_graphics.y = icon.height / 2 + 10;
      };

      drawTooltipContainer();

      tooltip.addChild(tooltip_graphics);
      tooltip_graphics.addChild(textInfo);
      sprite.addChild(tooltip);
      tooltip.interactiveChildren = false;
      tooltip.visible = false;

      eventManager.listen('language:change', function () {
        if (textInfo === undefined) {
          return;
        }
        textInfo.setText(getItemDisplayName());
        drawTooltipContainer();
      });
    };
    bubbleModuleItem.onButtonClick = function () {
      if (unclickableTypes.indexOf(bubbleModuleItem.type) > -1) {
        return;
      }
      //Cancel click events if they dragged more than 100 pixels
      var curPos = sprite.toGlobal(new PIXI.Point(0, 0));
      if (Math.pow(startClickPos.x - curPos.x, 2) + Math.pow(startClickPos.y - curPos.y, 2) > 100 * 100) {
        return;
      }

      $log.debug('[[BubbleModuleItem]] clicking on', item_info, 'LOCK STATUS:::::::::::::', bubbleModuleItem.locked);
      if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug) > -1) {
        bubbleModuleItem.locked = true;
      }
      if (!ModuleFilter.checkAvailable(item_info)) {
        bubbleModuleItem.locked = true;
        item_info.locked = true;
        eventManager.broadcast('display-maintenance-message', item_info.slug);
        return;
      }
      $timeout(function () {
        sprite.scale.set(1, 1);
        if (eventBindings.onItemClick) {
          eventBindings.onItemClick(item_info, bubbleModuleItem);
        }
        // eventManager.broadcast('module:select:resource', item_info);
        // eventManager.broadcast('module:stop:pan')
      }, TIMING_CONSTANTS.INSTANT);
    };
    bubbleModuleItem.unlock = function () {
      item_info.locked = false;
      bubbleModuleItem.locked = false;
      bubbleModuleItem.updateIcon();
    };
    bubbleModuleItem.lock = function () {
      item_info.locked = true;
      bubbleModuleItem.locked = true;
      bubbleModuleItem.updateIcon();
    };
    bubbleModuleItem.getItemInfo = function () {
      return item_info;
    };
    bubbleModuleItem.setItemComplete = function () {
      bubbleModuleItem.updateIcon();
      if (bubbleModuleItem.studentWork) {
        bubbleModuleItem.studentWork.completions++;
      } else {
        bubbleModuleItem.studentWork = {
          completions: 1
        };
      }
    };
    //For setting up verlet links to items inside a folder
    //items in minimized folders should verlet links to their parent
    bubbleModuleItem.getLinkedBody = function () {
      if (bubbleModuleItem.shouldBeOnMap()) {
        return bubbleModuleItem.verletBody;
      } else {
        return bubbleModuleItem.parentItem.getLinkedBody();
      }
    };
    //Map items inside mimized folder items get ignored
    bubbleModuleItem.shouldBeOnMap = function () {
      if (bubbleModuleItem.parentItem !== null) {
        return bubbleModuleItem.parentItem.isExpanded;
      } else {
        return bubbleModuleItem.isExpanded === true ? false : true;
      }
    };
    bubbleModuleItem.showHighlight = function () {
      if (bubbleModuleItem.type === 'symlink') {
        return;
      }
      if (tooltip) {
        tooltip.visible = true;
      }
      sprite.scale.set(1.1, 1.1);
      if (sprite.parent !== null) {
        sprite.parent.setChildIndex(sprite, sprite.parent.children.length - 1);
      }
    };
    bubbleModuleItem.undoAgendaHighlight = function () {};
    bubbleModuleItem.showAgendaHighlight = function () {
      // $log.log('show agenda prehighlight : ', agenda_highlight)
      if (agenda_highlight === null) {
        agenda_highlight = new PIXI.Graphics();
        agenda_highlight.lineStyle(8, 0xAAAABB);
        agenda_highlight.drawCircle(0, 0, 45);
        icon.addChild(agenda_highlight);
      } else {
        bubbleModuleItem.hideAgendaHighlight();
      }
    };
    bubbleModuleItem.hideAgendaHighlight = function () {
      if (agenda_highlight !== null) {
        icon.removeChild(agenda_highlight);
        agenda_highlight = null;
      }
    };
    bubbleModuleItem.hideHighlight = function () {
      if (tooltip) {
        tooltip.visible = false;
      }
      sprite.scale.set(1, 1);
    };
    bubbleModuleItem.pointerdown = function () {
      sprite.scale.set(0.9, 0.9);
      startClickPos = sprite.toGlobal(new PIXI.Point(0, 0));
      if (window.DEBUG_TOUCH) {
        $log.log('bubbleModuleItem pointdown ; ', JSON.stringify(startClickPos));
      }
    };

    // INIT
    icon.anchor.set(0.5, 0.5);
    mouseOver = bubbleModuleItem.showHighlight.bind(bubbleModuleItem);
    mouseOut = bubbleModuleItem.hideHighlight.bind(bubbleModuleItem);
    pointerdown = bubbleModuleItem.pointerdown.bind(bubbleModuleItem);

    sprite.on('mouseover', function () {
      mouseOver();
    });
    sprite.on('pointerout', function () {
      mouseOut();
    });
    sprite.on('pointerdown', function () {
      pointerdown();
    });

    if (item_info.resource_type !== "group") {
      var boundClick = bubbleModuleItem.onButtonClick.bind(bubbleModuleItem);
      sprite.on('pointertap', boundClick);
    } else if (item_info.resource_type !== 'symlink') {
      bubbleModuleItem.open = false;
    }

    bubbleModuleItem.updateIcon();
    if (bubbleModuleItem.type === "group") {
      var bg = new PIXI.Sprite(icon.texture);
      bg.width += 20;
      bg.height += 20;

      bg.anchor.set(0.5, 0.5);
      sprite.addChild(bg);
    }
    sprite.addChild(icon);

    if (item_info.display.position !== undefined) {
      sprite.position.set(item_info.display.position.x, item_info.display.position.y);
    } else {
      sprite.position.set(0, 0);
    }
    sprite.interactive = true;
    sprite.buttonMode = true;
    bubbleModuleItem.buildTooltip();
  };
});
'use strict';

angular.module('mtic.components.modules.bubbleModule').component('bubbleLearningMap', {
  template: '<div class="inner-viewport" style="overflow:hidden;"><canvas id="canvas-bubble-learning-map" width="300" height="300"></canvas></div>',
  bindings: {
    moduleMapData: '<',
    assetUrl: '@',
    onItemClick: '<',
    highlighted: '<'
  },
  controllerAs: 'learningMap',
  controller: function controller(EventManager, language, BubbleModuleItem, VerletSystemService, TeacherDataService, learningMapUtil, PIXI, GR78_ASSET_URL, $scope, $element, $q, $timeout, TIMING_CONSTANTS, $log, $window) {
    var learningMap = this;

    ///////////////////
    // PRIVATE VARS //
    /////////////////
    var eventManager = new EventManager('learningMap', $scope);
    var verlet_system = new VerletSystemService();

    var canvas_el = null;
    var app = null;
    var renderer = null;
    var drag_info = null;
    var canvasDimensions = null;
    var scale = null;
    var stage = null;
    var modules_container = null;
    var container = null;
    var lines_graphic = null;
    var selection_graphic = null;
    var mapItems = [];

    var isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);

    var img_asset_paths_default = ["symlink.png", "item_blue_0.png", "item_blue_1.png", "item_red_0.png", "item_red_1.png", "item_red_2.png", "item_red_3.png", "item_black_0.png", "item_black_1.png", "item_black_2.png", "item_black_3.png", "item_blue_locked.png", "item_red_locked.png", "item_black_locked.png", "assessment.png", "assessment_complete.png", "selection_highlight.png", "selection.png"];
    var focus_item = null;
    var selection = null;
    // var CANVAS_EL_ID = 'canvas-bubble-learning-map'
    canvas_el = $element.children().children()[0];

    /////////////////
    // CONSTRUCTOR //
    /////////////////

    function init() {

      // retrieve template element references
      // canvas_el = document.getElementById(CANVAS_EL_ID);
      if (!canvas_el) {
        return;
      }

      app = new PIXI.Application(300, 300, {
        autoResize: true,
        backgroundColor: 0xdee9fc,
        antialias: true,
        view: canvas_el
      });

      renderer = app.renderer;
      scale = 0.8;
      mapItems = [];

      drag_info = learningMapUtil.getDragInfoSettings();

      canvasDimensions = {
        width: window.innerWidth,
        height: window.innerHeight - 50
      };

      stage = app.stage;
      stage.interactive = true;

      window.addEventListener("resize", onResize);
      onResize();
      renderer.render(stage);

      container = new PIXI.Sprite();
      container.interactive = true;
      container.scale.set(scale, scale);
      container.x = renderer.width / 2;
      container.y = renderer.height / 2;
      stage.addChildAt(container, 0);

      lines_graphic = new PIXI.Graphics();
      container.addChild(lines_graphic);

      app.ticker.add(update);

      canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
      canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else
      canvas_el.addEventListener('pointerdown', handleDoubleClick, false);

      stage.on('pointerdown', function (e) {
        drag_info.dragging = true;
        focus_item = null;
        drag_info.velocity = {
          x: 0,
          y: 0
        };
        drag_info.start_drag_pos = {
          x: container.x,
          y: container.y
        };
        drag_info.start_drag_mouse_pos = {
          x: renderer.plugins.interaction.eventData.data.global.x,
          y: renderer.plugins.interaction.eventData.data.global.y
        };
        drag_info.last_mouse_pos = {
          x: drag_info.start_drag_mouse_pos.x,
          y: drag_info.start_drag_mouse_pos.y
        };
        if (window.DEBUG_TOUCH) {
          $log.log('bubbleModule pointerdown ; ', JSON.stringify(drag_info));
        }
      });
      stage.on('pointerup', function (e) {
        if (window.DEBUG_TOUCH) {
          $log.log('bubbleModule pointerup ; ', JSON.stringify(e));
        }
        drag_info.dragging = false;
      });

      if (PIXI.loader.resources) {
        for (var ast in PIXI.loader.resources) {
          PIXI_CACHE_INDICATOR[learningMap.assetUrl] = false;
          break;
        }
      }

      return loadAssets().then(function () {
        $log.debug('[[learningMap]] loadAssets.then');
        return;
      }).catch(function (err) {
        $log.error('[[learningMap]] loadAssets.then', err.message);
        $log.debug(err.stack);
      });
    }

    /////////////////////
    // PRIVATE METHODS //
    /////////////////////
    //Mousewheel zoom/in out at cursor position (like google maps)
    var handleScroll = function handleScroll(evt) {
      if (!evt) {
        return;
      }
      //normalize the wheel delta because browsers send all sorts of values
      var direction = evt.detail < 0 || evt.wheelDelta > 0 ? 1 : -1;

      //store the current scale so we can calculate the difference
      var start_scale = scale;
      scale = Math.max(Math.min(1.5, scale + direction / 15), 0.25);
      var diff = scale - start_scale;
      container.scale.set(scale, scale);

      //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
      var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
      container.position.x -= diff * pos.x;
      container.position.y -= diff * pos.y;

      evt.preventDefault();
      return false;
    };
    var handleDoubleClick = function handleDoubleClick(e) {
      if (window.DEBUG_TOUCH) {
        $log.log('bubbleModule pointdown PREVENTDEFAULT ; ', JSON.stringify(e));
      }
      e.preventDefault();
      return false;
    };

    var initMapDraw = function initMapDraw(moduleMapData) {
      if (!moduleMapData) {
        return;
      }
      var combinedResourceMap = {};

      _.forEach(moduleMapData, function (someItem) {
        combinedResourceMap[someItem.slug] = someItem;
        loadChildren(someItem);
      });

      _.each(combinedResourceMap, function (resource) {
        createItem(resource, null);
      });
      _.forEach(mapItems, function (item) {
        if (!item.locked) {
          item.unlock();
        }
      });
    };
    //This loops to control things that should update every frame
    var update = function update() {
      if (selection_graphic !== null) {
        //Rotate it a little bit
        selection_graphic.rotation = (selection_graphic.rotation - 0.015) % (Math.PI * 2);

        //Use UNIX time to scale the graphic with a sin function
        //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
        selection_graphic.scale.set((selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / 10);
      }

      //update the verlet force directed graph that positions the map items in that big jiggly web

      verlet_system.update();
      //   drawMapLines();
      if (drag_info.dragging) {
        var mouse_pos = {
          x: renderer.plugins.interaction.eventData.data.global.x,
          y: renderer.plugins.interaction.eventData.data.global.y
        };
        if (isNaN(mouse_pos.x) || isNaN(mouse_pos.y) || isMobile && renderer.plugins.interaction.eventData.data.identifier === 'MOUSE') {
          mouse_pos.x = drag_info.last_mouse_pos.x;
          mouse_pos.y = drag_info.last_mouse_pos.y;
        }

        //Move the map based on the mouse position
        container.position.x = drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
        container.position.y = drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);

        //vector of mouse movement since last update frame
        var delta_pos = {
          x: drag_info.last_mouse_pos.x - mouse_pos.x,
          y: drag_info.last_mouse_pos.y - mouse_pos.y
        };

        //add the mouse movement vector to the map movement velocity (inertia)
        drag_info.velocity = {
          x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
          y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
        };

        //store the current position in the last_mouse_pos to calculate the movement vector next frame
        drag_info.last_mouse_pos = {
          x: mouse_pos.x,
          y: mouse_pos.y
        };
      } else {
        //If they're not dragging, move the map based on its inertia and damp the inertia
        container.position.x -= drag_info.velocity.x;
        container.position.y -= drag_info.velocity.y;
        drag_info.velocity.x *= 0.84;
        drag_info.velocity.y *= 0.84;
      }
      focusItemTicker();

      lines_graphic.clear();
      lines_graphic.lineStyle(8, 0xCCCCDD, 1);
      var segments = verlet_system.getLineSegments();
      var i;
      for (i = 0; i < segments.solid.length; i++) {
        lines_graphic.moveTo(segments.solid[i].start.x, segments.solid[i].start.y);
        lines_graphic.lineTo(segments.solid[i].end.x, segments.solid[i].end.y);
      }
      lines_graphic.beginFill(0xFF0000, 1);
      for (i = 0; i < segments.dash.length; i++) {
        lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
      }
      lines_graphic.endFill();

      if (window.DEBUG_TOUCH) {
        $log.log('bubbleModule update ;', JSON.stringify(drag_info));
      }
    };
    /**
     *Expand a subgroup to reveal child items
     *slug is a unique String that identifies the group MapItem
     **/
    var expandGroup = function expandGroup(slug) {
      //Cancel this mouse event if they were dragging more than 10 pixels
      if (drag_info.dragging) {
        if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
          return;
        }
      }

      if (verlet_system.deactivateBody(slug, true)) {
        var group = getItemBySlug(slug);
        //position all of the sub items so that they appear from where the clicked group icon is
        for (var i = 0; i < mapItems.length; i++) {
          if (mapItems[i].parentItem === group) {
            mapItems[i].sprite.position.x = group.sprite.position.x;
            mapItems[i].sprite.position.y = group.sprite.position.y;
            verlet_system.activateBody(mapItems[i].slug, true);
          }
        }
      }
    };
    /**
     *Collapse a subgroup to hide child items
     *slug is a unique String that identifies the group MapItem
     **/
    var collapseGroup = function collapseGroup(slug) {
      var group = getItemBySlug(slug);
      if (group.isExpanded === true) {
        toggleGroupExpanded(group);
      }
    };
    /**
     *Toggle the expand/collapse of a given item group
     *group is a MapItem
     **/
    var toggleGroupExpanded = function toggleGroupExpanded(group) {
      group.isExpanded = !group.isExpanded;
      //    baseVerletSystem.hookUpConstraints();
    };
    //If focus item is defined, pan towards it
    var focusItemTicker = function focusItemTicker() {
      if (focus_item === null) {
        return;
      }
      var abs_pos = container.toGlobal(focus_item.sprite.position);
      container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
      container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
    };
    /**
     *Return a MapItem whose slug matches the passed slug
     *Returns null if no MapItem can be found
     */
    var getItemBySlug = function getItemBySlug(slug) {
      for (var i = 0; i < mapItems.length; i++) {
        if (mapItems[i].slug === slug) {
          return mapItems[i];
        }
      }
      return null;
    };

    var getItemById = function getItemById(id) {
      for (var i = 0; i < mapItems.length; i++) {
        if (mapItems[i].id === id) {
          return mapItems[i];
        }
      }
      return null;
    };

    var onResize = function onResize() {
      canvasDimensions = {
        width: window.innerWidth,
        height: window.innerHeight - 52
      };
      stage.hitArea = new PIXI.Rectangle(0, 0, canvasDimensions.width, canvasDimensions.height);
      if (!canvas_el) {
        return;
      }
      canvas_el.width = canvasDimensions.width;
      canvas_el.height = canvasDimensions.height;

      renderer.resize(canvasDimensions.width, canvasDimensions.height);
    };
    //this is what runs to initialize the map
    var loadAssets = function loadAssets() {
      $log.debug('[[learningMap]] loadAssets');
      return $q(function (resolve, reject) {
        try {
          if (!PIXI_CACHE_INDICATOR[learningMap.assetUrl]) {
            PIXI.loader.reset();
            PIXI.loader.add(img_asset_paths_default.map(function (imgPath) {
              return learningMap.assetUrl + imgPath;
            })).load(function () {
              PIXI_CACHE_INDICATOR[learningMap.assetUrl] = true;
              initMap(resolve);
            });
          } else {
            initMap(resolve);
          }
        } catch (err) {
          $log.error('[[learningMap]]', err);
          reject(err);
        }
      });
    };
    var loadChildren = function loadChildren(someItem) {
      someItem.childResourcemap = [];
      if (someItem.children === undefined) {
        return;
      }
      if (someItem.children.length > 0) {
        _.forEach(someItem.children, function (childItem) {
          someItem.childResourcemap[childItem.slug] = childItem;
          loadChildren(childItem);
        });
      }
    };
    var initMap = function initMap(resolve) {

      initMapDraw(learningMap.moduleMapData);

      $timeout(function () {
        verlet_system.deactivateAllBodies(true);
        for (var i = 0; i < learningMap.moduleMapData.length; i++) {
          if (learningMap.moduleMapData[i].slug.indexOf('mtic_g78_m2_sum') === -1) {
            verlet_system.activateBody(learningMap.moduleMapData[i].slug, true);
          }
        }
      }, TIMING_CONSTANTS.INSTANT);

      if (selection_graphic === null) {
        selection_graphic = new PIXI.Sprite(PIXI.loader.resources[learningMap.assetUrl + 'selection.png'].texture);
        selection_graphic.anchor.set(0.5, 0.5);
        selection_graphic.scale.set(0.75, 0.75);
        selection_graphic.interactive = false;
        selection_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
      }

      var highlighthed = learningMap.highlighted || [];

      mapItems.forEach(function (mapItem) {
        if (highlighthed.indexOf(mapItem.id) > -1) {
          mapItem.showAgendaHighlight();
        } else {
          mapItem.hideAgendaHighlight();
        }
      });

      resolve();
    };

    var createItem = function createItem(resource, parentItem, start_hidden) {
      if (!resource.display.position && resource.slug.indexOf('diagnostic') < 0) {
        if (resource.children && resource.children.length > 0) {
          _.forEach(resource.children, function (childItem) {
            createItem(childItem, parentItem);
          });
        }
        return;
      }

      if (verlet_system.getBody(resource.slug) !== undefined) {
        return;
      }
      var displayItem;

      //Add this to the map logic array of items
      mapItems.push(displayItem = new BubbleModuleItem(resource, learningMap.assetUrl, {
        onItemClick: learningMap.onItemClick
      }));

      //create a VerletBody for the item
      displayItem.parentItem = parentItem;

      container.addChild(displayItem.sprite);

      var children = [];
      //Build the child items
      _.forEach(resource.children, function (childItem) {
        children.push(createItem(childItem, displayItem, true));
      });

      //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
      //So we create its list of unlocked_by based on the items in the group
      //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
      //And add it to the unlocked_by of the group
      if (displayItem.unlocked_by.length === 0) {
        for (var i = 0; i < children.length; i++) {
          for (var n = 0; n < children[i].unlocked_by.length; n++) {
            var is_inner = true;
            for (var p = 0; p < children.length; p++) {
              //This is pointing from an item in the group to another item in the group
              if (children[i].unlocked_by[n] === children[p].slug) {
                is_inner = false;
              }
            }
            //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
            if (is_inner) {
              displayItem.unlocked_by.push(children[i].unlocked_by[n]);
            }
          }
        }
      }

      displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
      if (start_hidden) {
        displayItem.sprite.visible = false;
        verlet_system.deactivateBody(resource.slug);
      }

      //Add the expandGroup listener to the item
      if (resource.resource_type === "group") {
        displayItem.setDelegate(expandGroup.bind(this));
        displayItem.isExpanded = false;
      }
      return displayItem;
    };

    // INIT
    learningMap.$onChanges = function () {
      $log.debug('[[learningMap]] onChanges....', learningMap);
      BUBBLE_MODULE_CACHE.ITEM_POSITIONS.saved = true;
      if (!learningMap.moduleMapData) {
        return;
      }
      $log.debug('[[learningMap]] INIT!');
      if (!BUBBLE_MODULE_CACHE.EXISTS) {
        BUBBLE_MODULE_CACHE.EXISTS = true;
        init();
      } else {
        initMap(function () {});
      }
    };

    learningMap.$onDestroy = function () {

      $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");

      if (canvas_el) {
        canvas_el.removeEventListener('DOMMouseScroll', handleScroll);
        canvas_el.removeEventListener('mousewheel', handleScroll);
        canvas_el.removeEventListener('pointerdown', handleDoubleClick);
      }

      try {
        stage.removeChildren();
        container.removeChildren();
        app.destroy();
      } catch (e) {
        $log.warn('expected vars are undefined', {
          stage: stage,
          container: container,
          app: app
        });
      }

      window.removeEventListener("resize", onResize);
      BUBBLE_MODULE_CACHE.EXISTS = false;
    };
  }
});

// TODO: this seems to be in the wrong place?
var PIXI_CACHE_INDICATOR = {};
var BUBBLE_MODULE_CACHE = {
  EXISTS: false,
  ITEM_POSITIONS: {
    saved: true,
    positions: []
  }
};
'use strict';

angular.module('mtic.components.login').component('mticPostIamRegistrationSchool', {
  template:'<style>\n#school_box{\n  max-height: 200px;\n  overflow-y: scroll;\n  width:280px;\n  left:10px;\n  position: relative;\n}\n#school_box::-webkit-scrollbar-track\n{\n  background-color: #FFFFFF;\n}\n\n#school_box::-webkit-scrollbar\n{\n  width: 8px;\n}\n\n#school_box::-webkit-scrollbar-thumb\n{\n  border-radius: 10px;\n  height:40px;\n  background-color: #999999;\n}\n#school_select::after{\n  border-color: #333 !important;\n}\n.school_selected_box{\n  border:2px solid #3a99d8; border-radius:5px;\n}\n.school_selected_text{\n  color: #3a99d8 !important;\n}\n</style><div style="padding-top:0px !important"><img style="margin:auto;display:block;margin-bottom:15px !important" src="https://s3.eu-central-1.amazonaws.com/mtic-items/interface/illustration_school.png"><div class="field" ng-hide="true"><label class="label">{{text.COUNTRY}}</label><</div><div class="field"><label ng-hide="selection.isStudent" class="label" style="color:#31a9dd;text-align: center;font-size:20px" ng-bind="language.get(\'14556\')">Connect to your school</label><div style="margin:auto; width: 300px"><div ng-hide="selection.isStudent" select-box options="selection.schoolType.list" model="selection.schoolType.selected" style="position:relative;min-width: 300px;font-size:16px" display-function="\'name\'" on-change="selection.school.set" filler-text="language.get(\'14557\')"></div></div><div style="margin:auto; width: 300px"><input type="text" class="input" ng-change="selection.filterSchools(selection.schoolFilter)" ng-model="selection.schoolFilter" style="width:300px" placeholder="{{language.get(\'14558\')}}"></div><div ng-if="!selection.school.hide" style="background-color:#fff;height:220px;border-radius:5px;margin-top:5px"><div id="school_box"><mtic-post-iam-registration-school-one ng-repeat="school in selection.school.list | filter: { hide_registration: false}" ng-hide="school.hide" name-slug="school.name_slug" name-long="school.name_long" id="school.id" select="selection.selectSchool" is-selected="selection.school.isSelected"></mtic-post-iam-registration-school-one></div></div></div></div>',
  bindings: {
    countries: '<',
    selections: '='
  },
  controllerAs: 'selection',
  controller: function controller($scope, $log, $timeout, language) {
    $scope.language = language;
    var selection = this;
    var text = $scope.text = {
      WELCOME: 'Welcome {{firstName}} {{lastName}}, please proceed to choose your school below.',
      TITLE: 'Microsoft Login',
      INVALIDACCOUNT: 'Invalid Account Type!',
      SCHOOL: 'School',
      COUNTRY: 'Country',
      CONTINUE: 'Continue',
      IAMEMAIL: 'IAM Email'
    };
    selection.country = {
      selected: null,
      list: [],
      set: function set(countries) {
        this.list = countries;
        this.selected = countries[0];
        selection.schoolType.set(this.selected);
      }
    };

    selection.schoolType = {
      hide: true,
      selected: null,
      list: [],
      set: function set(country) {
        selection.schoolType.hide = false;
        selection.schoolType.list = country.children;
        selection.schoolType.selected = null;
        if (selection.isStudent) {
          selection.schoolType.selected = country.children[0];
          selection.school.set(country.children[0]);
        }
      }
    };

    selection.school = {
      hide: true,
      selected: null,
      list: [],
      set: function set(schoolType) {
        if (!schoolType) {
          return;
        }
        selection.school.hide = false;
        selection.school.list = schoolType.children;
        selection.school.selected = null;
        selection.school.list = sortSchoolList(selection.school.list);
      },
      isSelected: function isSelected(school) {
        return selection.school.selected ? school.id === selection.school.selected.id : false;
      },

      filter: {}
    };

    selection.selectSchool = function () {
      throw new Error('Did not `init` mticPostIamRegistrationSchool!');
    };

    var sortSchoolList = function sortSchoolList(schoolList) {
      //_.sortBy(schoolList, 'description');
      _.each(schoolList, function (school) {
        if (school.description) {
          var name_split = school.description.split(';'); // temp :: feature of currently data model used, likely not to last
          var nameSlug = name_split[0];
          name_split.splice(0, 1);
          var nameLong = name_split.join(';'); // likely not necessary, dont think semi-colon used too much... but just in case
          school.name_slug = nameSlug;
          school.name_long = nameLong;
        }
      });

      schoolList = _.sortBy(schoolList, function (school) {
        var modified_slug = latinize(school.name_slug); //school.name_slug.latinize()
        return modified_slug;
      });
      return schoolList;
    };

    var validateInnerStr = function validateInnerStr(match, str) {
      if (!str) {
        return false;
      }
      var outer = String(normalizeInnerSpaces(str)).toLowerCase();
      var inner = String(match).toLowerCase();
      // console.log('validateInnerStr (1->1):', inner, outer, outer.indexOf(inner))
      if (outer.indexOf(inner) !== -1) {
        return true;
      }
      return false;
    };

    var validateFilterTerm = function validateFilterTerm(term, fields) {
      var oneMatch = false;
      _.each(fields, function (fieldStr) {
        // console.log('validate filter term/field (1->1):', validateInnerStr(term, fieldStr))
        oneMatch = oneMatch || validateInnerStr(term, fieldStr);
      });
      return oneMatch;
    };

    var validateFilterList = function validateFilterList(terms, fields) {
      // console.log('validateFilterList (n->n):', terms, fields)
      var allMatch = true;
      _.each(terms, function (term) {
        // console.log('validate filter term/fields (1->n):', term, validateFilterTerm(term, fields))
        allMatch = allMatch && validateFilterTerm(term, fields);
      });
      return allMatch;
    };

    var normalizeInnerSpaces = function normalizeInnerSpaces(str) {
      return str.replace(/\s\s+/g, ' ');
    };

    var filterStr;
    selection.filterSchools = function (_filterStr) {
      filterStr = _filterStr;
      filterSchoolsUpdate_debounced();
    };

    var filterSchoolsUpdate = function filterSchoolsUpdate() {
      $timeout(function () {
        ///// testing ///////
        // selection.school = {list:[
        //   {description:'mamer', GroupInfo: {infos: { full_address: 'abc abcdefgh' } }},
        //   {description:'test 2', GroupInfo: {infos: { full_address: 'abc abcdefgh' } }},
        //   {description:'test 3', GroupInfo: {infos: { full_address: 'abc mamerian shdfjkd' } }}
        // ]}
        //////////
        var filterList;
        var isFilterActive = false;
        if (!selection.school) {
          return false;
        }
        if (filterStr) {
          var filterStrTrimmed = normalizeInnerSpaces(filterStr);
          if (filterStrTrimmed !== '' && filterStrTrimmed !== ' ') {
            isFilterActive = true;
            filterList = filterStrTrimmed.split(' ');
          }
        }
        // $log.log(' ------- FILTER ------- ');
        _.each(selection.school.list, function (school) {
          if (!isFilterActive) {
            // $log.log('FILTER NOT ACTIVE');
            school.hide = false;
          } else {
            var address = '';
            if (school.GroupInfo && validateFilterList(filterList, [school.description, school.GroupInfo.infos.full_address])) {
              // $log.log('FILTER PASSED');
              school.hide = false;
            } else {
              // $log.log('FILTER FAILED');
              school.hide = true;
            }
          }
        });
      });
    };
    var filterSchoolsUpdate_debounced = _.throttle(filterSchoolsUpdate, 500);

    selection.$onInit = function () {
      selection.countries[0].children = selection.countries[0].children.filter(function (cur) {
        //filtering portugal
        return cur.id !== 2831 && cur.id !== 3579;
      });
      selection.country.set(selection.countries);
      selection.selectSchool = function (school) {
        selection.selections.selectSchool(school);
        selection.school.selected = school;
        selection.school.filter.description = school.name;
      };
    };
    selection.$onChange = function () {
      selection.country.set(selection.countries);
    };

    ///DEALING WITH SPECIAL CHARACTERS FOR SORTING
    var Latinise = {};
    Latinise.latin_map = {
      "Á": "A",
      "Ă": "A",
      "Ắ": "A",
      "Ặ": "A",
      "Ằ": "A",
      "Ẳ": "A",
      "Ẵ": "A",
      "Ǎ": "A",
      "Â": "A",
      "Ấ": "A",
      "Ậ": "A",
      "Ầ": "A",
      "Ẩ": "A",
      "Ẫ": "A",
      "Ä": "A",
      "Ǟ": "A",
      "Ȧ": "A",
      "Ǡ": "A",
      "Ạ": "A",
      "Ȁ": "A",
      "À": "A",
      "Ả": "A",
      "Ȃ": "A",
      "Ā": "A",
      "Ą": "A",
      "Å": "A",
      "Ǻ": "A",
      "Ḁ": "A",
      "Ⱥ": "A",
      "Ã": "A",
      "Ꜳ": "AA",
      "Æ": "AE",
      "Ǽ": "AE",
      "Ǣ": "AE",
      "Ꜵ": "AO",
      "Ꜷ": "AU",
      "Ꜹ": "AV",
      "Ꜻ": "AV",
      "Ꜽ": "AY",
      "Ḃ": "B",
      "Ḅ": "B",
      "Ɓ": "B",
      "Ḇ": "B",
      "Ƀ": "B",
      "Ƃ": "B",
      "Ć": "C",
      "Č": "C",
      "Ç": "C",
      "Ḉ": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Ƈ": "C",
      "Ȼ": "C",
      "Ď": "D",
      "Ḑ": "D",
      "Ḓ": "D",
      "Ḋ": "D",
      "Ḍ": "D",
      "Ɗ": "D",
      "Ḏ": "D",
      "ǲ": "D",
      "ǅ": "D",
      "Đ": "D",
      "Ƌ": "D",
      "Ǳ": "DZ",
      "Ǆ": "DZ",
      "É": "E",
      "Ĕ": "E",
      "Ě": "E",
      "Ȩ": "E",
      "Ḝ": "E",
      "Ê": "E",
      "Ế": "E",
      "Ệ": "E",
      "Ề": "E",
      "Ể": "E",
      "Ễ": "E",
      "Ḙ": "E",
      "Ë": "E",
      "Ė": "E",
      "Ẹ": "E",
      "Ȅ": "E",
      "È": "E",
      "Ẻ": "E",
      "Ȇ": "E",
      "Ē": "E",
      "Ḗ": "E",
      "Ḕ": "E",
      "Ę": "E",
      "Ɇ": "E",
      "Ẽ": "E",
      "Ḛ": "E",
      "Ꝫ": "ET",
      "Ḟ": "F",
      "Ƒ": "F",
      "Ǵ": "G",
      "Ğ": "G",
      "Ǧ": "G",
      "Ģ": "G",
      "Ĝ": "G",
      "Ġ": "G",
      "Ɠ": "G",
      "Ḡ": "G",
      "Ǥ": "G",
      "Ḫ": "H",
      "Ȟ": "H",
      "Ḩ": "H",
      "Ĥ": "H",
      "Ⱨ": "H",
      "Ḧ": "H",
      "Ḣ": "H",
      "Ḥ": "H",
      "Ħ": "H",
      "Í": "I",
      "Ĭ": "I",
      "Ǐ": "I",
      "Î": "I",
      "Ï": "I",
      "Ḯ": "I",
      "İ": "I",
      "Ị": "I",
      "Ȉ": "I",
      "Ì": "I",
      "Ỉ": "I",
      "Ȋ": "I",
      "Ī": "I",
      "Į": "I",
      "Ɨ": "I",
      "Ĩ": "I",
      "Ḭ": "I",
      "Ꝺ": "D",
      "Ꝼ": "F",
      "Ᵹ": "G",
      "Ꞃ": "R",
      "Ꞅ": "S",
      "Ꞇ": "T",
      "Ꝭ": "IS",
      "Ĵ": "J",
      "Ɉ": "J",
      "Ḱ": "K",
      "Ǩ": "K",
      "Ķ": "K",
      "Ⱪ": "K",
      "Ꝃ": "K",
      "Ḳ": "K",
      "Ƙ": "K",
      "Ḵ": "K",
      "Ꝁ": "K",
      "Ꝅ": "K",
      "Ĺ": "L",
      "Ƚ": "L",
      "Ľ": "L",
      "Ļ": "L",
      "Ḽ": "L",
      "Ḷ": "L",
      "Ḹ": "L",
      "Ⱡ": "L",
      "Ꝉ": "L",
      "Ḻ": "L",
      "Ŀ": "L",
      "Ɫ": "L",
      "ǈ": "L",
      "Ł": "L",
      "Ǉ": "LJ",
      "Ḿ": "M",
      "Ṁ": "M",
      "Ṃ": "M",
      "Ɱ": "M",
      "Ń": "N",
      "Ň": "N",
      "Ņ": "N",
      "Ṋ": "N",
      "Ṅ": "N",
      "Ṇ": "N",
      "Ǹ": "N",
      "Ɲ": "N",
      "Ṉ": "N",
      "Ƞ": "N",
      "ǋ": "N",
      "Ñ": "N",
      "Ǌ": "NJ",
      "Ó": "O",
      "Ŏ": "O",
      "Ǒ": "O",
      "Ô": "O",
      "Ố": "O",
      "Ộ": "O",
      "Ồ": "O",
      "Ổ": "O",
      "Ỗ": "O",
      "Ö": "O",
      "Ȫ": "O",
      "Ȯ": "O",
      "Ȱ": "O",
      "Ọ": "O",
      "Ő": "O",
      "Ȍ": "O",
      "Ò": "O",
      "Ỏ": "O",
      "Ơ": "O",
      "Ớ": "O",
      "Ợ": "O",
      "Ờ": "O",
      "Ở": "O",
      "Ỡ": "O",
      "Ȏ": "O",
      "Ꝋ": "O",
      "Ꝍ": "O",
      "Ō": "O",
      "Ṓ": "O",
      "Ṑ": "O",
      "Ɵ": "O",
      "Ǫ": "O",
      "Ǭ": "O",
      "Ø": "O",
      "Ǿ": "O",
      "Õ": "O",
      "Ṍ": "O",
      "Ṏ": "O",
      "Ȭ": "O",
      "Ƣ": "OI",
      "Ꝏ": "OO",
      "Ɛ": "E",
      "Ɔ": "O",
      "Ȣ": "OU",
      "Ṕ": "P",
      "Ṗ": "P",
      "Ꝓ": "P",
      "Ƥ": "P",
      "Ꝕ": "P",
      "Ᵽ": "P",
      "Ꝑ": "P",
      "Ꝙ": "Q",
      "Ꝗ": "Q",
      "Ŕ": "R",
      "Ř": "R",
      "Ŗ": "R",
      "Ṙ": "R",
      "Ṛ": "R",
      "Ṝ": "R",
      "Ȑ": "R",
      "Ȓ": "R",
      "Ṟ": "R",
      "Ɍ": "R",
      "Ɽ": "R",
      "Ꜿ": "C",
      "Ǝ": "E",
      "Ś": "S",
      "Ṥ": "S",
      "Š": "S",
      "Ṧ": "S",
      "Ş": "S",
      "Ŝ": "S",
      "Ș": "S",
      "Ṡ": "S",
      "Ṣ": "S",
      "Ṩ": "S",
      "Ť": "T",
      "Ţ": "T",
      "Ṱ": "T",
      "Ț": "T",
      "Ⱦ": "T",
      "Ṫ": "T",
      "Ṭ": "T",
      "Ƭ": "T",
      "Ṯ": "T",
      "Ʈ": "T",
      "Ŧ": "T",
      "Ɐ": "A",
      "Ꞁ": "L",
      "Ɯ": "M",
      "Ʌ": "V",
      "Ꜩ": "TZ",
      "Ú": "U",
      "Ŭ": "U",
      "Ǔ": "U",
      "Û": "U",
      "Ṷ": "U",
      "Ü": "U",
      "Ǘ": "U",
      "Ǚ": "U",
      "Ǜ": "U",
      "Ǖ": "U",
      "Ṳ": "U",
      "Ụ": "U",
      "Ű": "U",
      "Ȕ": "U",
      "Ù": "U",
      "Ủ": "U",
      "Ư": "U",
      "Ứ": "U",
      "Ự": "U",
      "Ừ": "U",
      "Ử": "U",
      "Ữ": "U",
      "Ȗ": "U",
      "Ū": "U",
      "Ṻ": "U",
      "Ų": "U",
      "Ů": "U",
      "Ũ": "U",
      "Ṹ": "U",
      "Ṵ": "U",
      "Ꝟ": "V",
      "Ṿ": "V",
      "Ʋ": "V",
      "Ṽ": "V",
      "Ꝡ": "VY",
      "Ẃ": "W",
      "Ŵ": "W",
      "Ẅ": "W",
      "Ẇ": "W",
      "Ẉ": "W",
      "Ẁ": "W",
      "Ⱳ": "W",
      "Ẍ": "X",
      "Ẋ": "X",
      "Ý": "Y",
      "Ŷ": "Y",
      "Ÿ": "Y",
      "Ẏ": "Y",
      "Ỵ": "Y",
      "Ỳ": "Y",
      "Ƴ": "Y",
      "Ỷ": "Y",
      "Ỿ": "Y",
      "Ȳ": "Y",
      "Ɏ": "Y",
      "Ỹ": "Y",
      "Ź": "Z",
      "Ž": "Z",
      "Ẑ": "Z",
      "Ⱬ": "Z",
      "Ż": "Z",
      "Ẓ": "Z",
      "Ȥ": "Z",
      "Ẕ": "Z",
      "Ƶ": "Z",
      "Ĳ": "IJ",
      "Œ": "OE",
      "ᴀ": "A",
      "ᴁ": "AE",
      "ʙ": "B",
      "ᴃ": "B",
      "ᴄ": "C",
      "ᴅ": "D",
      "ᴇ": "E",
      "ꜰ": "F",
      "ɢ": "G",
      "ʛ": "G",
      "ʜ": "H",
      "ɪ": "I",
      "ʁ": "R",
      "ᴊ": "J",
      "ᴋ": "K",
      "ʟ": "L",
      "ᴌ": "L",
      "ᴍ": "M",
      "ɴ": "N",
      "ᴏ": "O",
      "ɶ": "OE",
      "ᴐ": "O",
      "ᴕ": "OU",
      "ᴘ": "P",
      "ʀ": "R",
      "ᴎ": "N",
      "ᴙ": "R",
      "ꜱ": "S",
      "ᴛ": "T",
      "ⱻ": "E",
      "ᴚ": "R",
      "ᴜ": "U",
      "ᴠ": "V",
      "ᴡ": "W",
      "ʏ": "Y",
      "ᴢ": "Z",
      "á": "a",
      "ă": "a",
      "ắ": "a",
      "ặ": "a",
      "ằ": "a",
      "ẳ": "a",
      "ẵ": "a",
      "ǎ": "a",
      "â": "a",
      "ấ": "a",
      "ậ": "a",
      "ầ": "a",
      "ẩ": "a",
      "ẫ": "a",
      "ä": "a",
      "ǟ": "a",
      "ȧ": "a",
      "ǡ": "a",
      "ạ": "a",
      "ȁ": "a",
      "à": "a",
      "ả": "a",
      "ȃ": "a",
      "ā": "a",
      "ą": "a",
      "ᶏ": "a",
      "ẚ": "a",
      "å": "a",
      "ǻ": "a",
      "ḁ": "a",
      "ⱥ": "a",
      "ã": "a",
      "ꜳ": "aa",
      "æ": "ae",
      "ǽ": "ae",
      "ǣ": "ae",
      "ꜵ": "ao",
      "ꜷ": "au",
      "ꜹ": "av",
      "ꜻ": "av",
      "ꜽ": "ay",
      "ḃ": "b",
      "ḅ": "b",
      "ɓ": "b",
      "ḇ": "b",
      "ᵬ": "b",
      "ᶀ": "b",
      "ƀ": "b",
      "ƃ": "b",
      "ɵ": "o",
      "ć": "c",
      "č": "c",
      "ç": "c",
      "ḉ": "c",
      "ĉ": "c",
      "ɕ": "c",
      "ċ": "c",
      "ƈ": "c",
      "ȼ": "c",
      "ď": "d",
      "ḑ": "d",
      "ḓ": "d",
      "ȡ": "d",
      "ḋ": "d",
      "ḍ": "d",
      "ɗ": "d",
      "ᶑ": "d",
      "ḏ": "d",
      "ᵭ": "d",
      "ᶁ": "d",
      "đ": "d",
      "ɖ": "d",
      "ƌ": "d",
      "ı": "i",
      "ȷ": "j",
      "ɟ": "j",
      "ʄ": "j",
      "ǳ": "dz",
      "ǆ": "dz",
      "é": "e",
      "ĕ": "e",
      "ě": "e",
      "ȩ": "e",
      "ḝ": "e",
      "ê": "e",
      "ế": "e",
      "ệ": "e",
      "ề": "e",
      "ể": "e",
      "ễ": "e",
      "ḙ": "e",
      "ë": "e",
      "ė": "e",
      "ẹ": "e",
      "ȅ": "e",
      "è": "e",
      "ẻ": "e",
      "ȇ": "e",
      "ē": "e",
      "ḗ": "e",
      "ḕ": "e",
      "ⱸ": "e",
      "ę": "e",
      "ᶒ": "e",
      "ɇ": "e",
      "ẽ": "e",
      "ḛ": "e",
      "ꝫ": "et",
      "ḟ": "f",
      "ƒ": "f",
      "ᵮ": "f",
      "ᶂ": "f",
      "ǵ": "g",
      "ğ": "g",
      "ǧ": "g",
      "ģ": "g",
      "ĝ": "g",
      "ġ": "g",
      "ɠ": "g",
      "ḡ": "g",
      "ᶃ": "g",
      "ǥ": "g",
      "ḫ": "h",
      "ȟ": "h",
      "ḩ": "h",
      "ĥ": "h",
      "ⱨ": "h",
      "ḧ": "h",
      "ḣ": "h",
      "ḥ": "h",
      "ɦ": "h",
      "ẖ": "h",
      "ħ": "h",
      "ƕ": "hv",
      "í": "i",
      "ĭ": "i",
      "ǐ": "i",
      "î": "i",
      "ï": "i",
      "ḯ": "i",
      "ị": "i",
      "ȉ": "i",
      "ì": "i",
      "ỉ": "i",
      "ȋ": "i",
      "ī": "i",
      "į": "i",
      "ᶖ": "i",
      "ɨ": "i",
      "ĩ": "i",
      "ḭ": "i",
      "ꝺ": "d",
      "ꝼ": "f",
      "ᵹ": "g",
      "ꞃ": "r",
      "ꞅ": "s",
      "ꞇ": "t",
      "ꝭ": "is",
      "ǰ": "j",
      "ĵ": "j",
      "ʝ": "j",
      "ɉ": "j",
      "ḱ": "k",
      "ǩ": "k",
      "ķ": "k",
      "ⱪ": "k",
      "ꝃ": "k",
      "ḳ": "k",
      "ƙ": "k",
      "ḵ": "k",
      "ᶄ": "k",
      "ꝁ": "k",
      "ꝅ": "k",
      "ĺ": "l",
      "ƚ": "l",
      "ɬ": "l",
      "ľ": "l",
      "ļ": "l",
      "ḽ": "l",
      "ȴ": "l",
      "ḷ": "l",
      "ḹ": "l",
      "ⱡ": "l",
      "ꝉ": "l",
      "ḻ": "l",
      "ŀ": "l",
      "ɫ": "l",
      "ᶅ": "l",
      "ɭ": "l",
      "ł": "l",
      "ǉ": "lj",
      "ſ": "s",
      "ẜ": "s",
      "ẛ": "s",
      "ẝ": "s",
      "ḿ": "m",
      "ṁ": "m",
      "ṃ": "m",
      "ɱ": "m",
      "ᵯ": "m",
      "ᶆ": "m",
      "ń": "n",
      "ň": "n",
      "ņ": "n",
      "ṋ": "n",
      "ȵ": "n",
      "ṅ": "n",
      "ṇ": "n",
      "ǹ": "n",
      "ɲ": "n",
      "ṉ": "n",
      "ƞ": "n",
      "ᵰ": "n",
      "ᶇ": "n",
      "ɳ": "n",
      "ñ": "n",
      "ǌ": "nj",
      "ó": "o",
      "ŏ": "o",
      "ǒ": "o",
      "ô": "o",
      "ố": "o",
      "ộ": "o",
      "ồ": "o",
      "ổ": "o",
      "ỗ": "o",
      "ö": "o",
      "ȫ": "o",
      "ȯ": "o",
      "ȱ": "o",
      "ọ": "o",
      "ő": "o",
      "ȍ": "o",
      "ò": "o",
      "ỏ": "o",
      "ơ": "o",
      "ớ": "o",
      "ợ": "o",
      "ờ": "o",
      "ở": "o",
      "ỡ": "o",
      "ȏ": "o",
      "ꝋ": "o",
      "ꝍ": "o",
      "ⱺ": "o",
      "ō": "o",
      "ṓ": "o",
      "ṑ": "o",
      "ǫ": "o",
      "ǭ": "o",
      "ø": "o",
      "ǿ": "o",
      "õ": "o",
      "ṍ": "o",
      "ṏ": "o",
      "ȭ": "o",
      "ƣ": "oi",
      "ꝏ": "oo",
      "ɛ": "e",
      "ᶓ": "e",
      "ɔ": "o",
      "ᶗ": "o",
      "ȣ": "ou",
      "ṕ": "p",
      "ṗ": "p",
      "ꝓ": "p",
      "ƥ": "p",
      "ᵱ": "p",
      "ᶈ": "p",
      "ꝕ": "p",
      "ᵽ": "p",
      "ꝑ": "p",
      "ꝙ": "q",
      "ʠ": "q",
      "ɋ": "q",
      "ꝗ": "q",
      "ŕ": "r",
      "ř": "r",
      "ŗ": "r",
      "ṙ": "r",
      "ṛ": "r",
      "ṝ": "r",
      "ȑ": "r",
      "ɾ": "r",
      "ᵳ": "r",
      "ȓ": "r",
      "ṟ": "r",
      "ɼ": "r",
      "ᵲ": "r",
      "ᶉ": "r",
      "ɍ": "r",
      "ɽ": "r",
      "ↄ": "c",
      "ꜿ": "c",
      "ɘ": "e",
      "ɿ": "r",
      "ś": "s",
      "ṥ": "s",
      "š": "s",
      "ṧ": "s",
      "ş": "s",
      "ŝ": "s",
      "ș": "s",
      "ṡ": "s",
      "ṣ": "s",
      "ṩ": "s",
      "ʂ": "s",
      "ᵴ": "s",
      "ᶊ": "s",
      "ȿ": "s",
      "ɡ": "g",
      "ᴑ": "o",
      "ᴓ": "o",
      "ᴝ": "u",
      "ť": "t",
      "ţ": "t",
      "ṱ": "t",
      "ț": "t",
      "ȶ": "t",
      "ẗ": "t",
      "ⱦ": "t",
      "ṫ": "t",
      "ṭ": "t",
      "ƭ": "t",
      "ṯ": "t",
      "ᵵ": "t",
      "ƫ": "t",
      "ʈ": "t",
      "ŧ": "t",
      "ᵺ": "th",
      "ɐ": "a",
      "ᴂ": "ae",
      "ǝ": "e",
      "ᵷ": "g",
      "ɥ": "h",
      "ʮ": "h",
      "ʯ": "h",
      "ᴉ": "i",
      "ʞ": "k",
      "ꞁ": "l",
      "ɯ": "m",
      "ɰ": "m",
      "ᴔ": "oe",
      "ɹ": "r",
      "ɻ": "r",
      "ɺ": "r",
      "ⱹ": "r",
      "ʇ": "t",
      "ʌ": "v",
      "ʍ": "w",
      "ʎ": "y",
      "ꜩ": "tz",
      "ú": "u",
      "ŭ": "u",
      "ǔ": "u",
      "û": "u",
      "ṷ": "u",
      "ü": "u",
      "ǘ": "u",
      "ǚ": "u",
      "ǜ": "u",
      "ǖ": "u",
      "ṳ": "u",
      "ụ": "u",
      "ű": "u",
      "ȕ": "u",
      "ù": "u",
      "ủ": "u",
      "ư": "u",
      "ứ": "u",
      "ự": "u",
      "ừ": "u",
      "ử": "u",
      "ữ": "u",
      "ȗ": "u",
      "ū": "u",
      "ṻ": "u",
      "ų": "u",
      "ᶙ": "u",
      "ů": "u",
      "ũ": "u",
      "ṹ": "u",
      "ṵ": "u",
      "ᵫ": "ue",
      "ꝸ": "um",
      "ⱴ": "v",
      "ꝟ": "v",
      "ṿ": "v",
      "ʋ": "v",
      "ᶌ": "v",
      "ⱱ": "v",
      "ṽ": "v",
      "ꝡ": "vy",
      "ẃ": "w",
      "ŵ": "w",
      "ẅ": "w",
      "ẇ": "w",
      "ẉ": "w",
      "ẁ": "w",
      "ⱳ": "w",
      "ẘ": "w",
      "ẍ": "x",
      "ẋ": "x",
      "ᶍ": "x",
      "ý": "y",
      "ŷ": "y",
      "ÿ": "y",
      "ẏ": "y",
      "ỵ": "y",
      "ỳ": "y",
      "ƴ": "y",
      "ỷ": "y",
      "ỿ": "y",
      "ȳ": "y",
      "ẙ": "y",
      "ɏ": "y",
      "ỹ": "y",
      "ź": "z",
      "ž": "z",
      "ẑ": "z",
      "ʑ": "z",
      "ⱬ": "z",
      "ż": "z",
      "ẓ": "z",
      "ȥ": "z",
      "ẕ": "z",
      "ᵶ": "z",
      "ᶎ": "z",
      "ʐ": "z",
      "ƶ": "z",
      "ɀ": "z",
      "ﬀ": "ff",
      "ﬃ": "ffi",
      "ﬄ": "ffl",
      "ﬁ": "fi",
      "ﬂ": "fl",
      "ĳ": "ij",
      "œ": "oe",
      "ﬆ": "st",
      "ₐ": "a",
      "ₑ": "e",
      "ᵢ": "i",
      "ⱼ": "j",
      "ₒ": "o",
      "ᵣ": "r",
      "ᵤ": "u",
      "ᵥ": "v",
      "ₓ": "x" };
    //String.prototype.latinise=function(){return this.replace(/[^A-Za-z0-9\[\] ]/g,function(a){return Latinise.latin_map[a]||a})};
    //String.prototype.latinize=String.prototype.latinise;
    //String.prototype.isLatin=function(){return this===this.latinise()}

    function latinize(str) {
      return str.replace(/[^A-Za-z0-9\[\] ]/g, function (a) {
        return Latinise.latin_map[a] || a;
      });
    }
  }
});
'use strict';

angular.module('mtic.components.login').component('mticPostIamRegistrationModule', {

  template:'<div><div class="field" ng-hide="true"><label class="label">{{text.COUNTRY}}</label><p class="control"><div select-box options="selection.country.list" model="selection.country.selected" style="position:relative;min-width: 200px;" display-function="\'name\'" on-change="selection.moduleType.set"></div></p></div><div class="field"><input ng-hide="true" type="text" class="input" ng-model-disabled="selection.moduleType.filter.description"><div style="max-height: 200px;overflow-y: scroll;"><mtic-post-iam-registration-module-option ng-if="!selection.moduleType.hide" ng-repeat="moduleType in selection.moduleType.list | fuzzyBy: \'description\': selection.moduleType.filter.description" name="moduleType.description" id="moduleType.id" infos="moduleType.GroupInfo.infos" select="selection.selectModule" is-selected="selection.moduleType.isSelected"></mtic-post-iam-registration-module-option></div></div></div>',

  bindings: {
    countries: '<',
    selections: '='
  },

  controllerAs: 'selection',

  controller: function controller($scope, $log, language, api) {

    // this
    var selection = this;

    // event manager


    // model
    var text = $scope.text = {
      WELCOME: 'Welcome {{firstName}} {{lastName}}, please proceed to choose your school below.',
      TITLE: 'Microsoft Login',
      INVALIDACCOUNT: 'Invalid Account Type!',
      SCHOOL: 'School',
      COUNTRY: 'Country',
      CONTINUE: 'Continue',
      IAMEMAIL: 'IAM Email'
    };

    selection.country = {
      selected: null,
      list: [],
      set: function set(countries) {
        $log.debug('[[mticPostIamRegistrationModule]] countries set', countries);
        this.list = countries;
        this.selected = countries[0];
        selection.moduleType.set(this.selected);
      }
    };

    selection.moduleType = {
      hide: true,
      selected: null,
      list: [],
      set: function set(country) {
        $log.debug('[[mticPostIamRegistrationModule]] moduleType set', country);
        var firstSubId = country.children[0].children[0].id;
        api.getNoSchoolClasses(firstSubId).then(function (classes) {
          selection.moduleType.hide = false;
          selection.moduleType.list = classes;
          selection.moduleType.selected = null;
        });
      },
      isSelected: function isSelected(moduleType) {
        return selection.moduleType.selected ? moduleType.id === selection.moduleType.selected.id : false;
      },
      filter: {}
    };

    selection.selectModule = function () {
      throw new Error('Did not `init` mticPostIamRegistrationSchool!');
    };

    selection.$onInit = function () {
      selection.country.set(selection.countries);
      selection.selectModule = function (moduleType) {
        selection.selections.selectModule(moduleType);
        selection.moduleType.selected = moduleType;
        selection.moduleType.filter.description = moduleType.name;
      };
    };

    selection.$onChange = function () {
      selection.country.set(selection.countries);
    };
  }
});
'use strict';

angular.module('mtic.components.login').component('mticFinalizationAccountSetup', {

  template:'<div><span class="tag is-info"><b style="margin-right: 10px;">IAM Email:</b> {{setup.profile.unique_name}}</span><br><language-span lang-id="8169"></language-span><div role="group" style="margin-top:15px;"><a type="button" ng-class="setup.isSelected(8166);" ng-click="setup.setType(8166);"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 130 100" xml:space="preserve" style="enable-background:new 0 0 130 100;width: 35px;transform: translate(0%,15%);"><g><path d="M53,36.2c0,0-0.4,0.7-2,0.7c-0.7,0-1.1-0.2-1.4-0.3c-0.4-0.2-0.6-0.4-0.6-0.4c0-3.3,1-7.3,1.3-8.6c-0.3-0.2-0.5-0.6-0.5-1 c0-0.5,0.4-1,0.9-1.1v-2.2l0.6,0.3v1.9c0.5,0.1,0.9,0.6,0.9,1.1c0,0.4-0.2,0.8-0.5,1c0.2,0.9,0.7,2.8,1,5C52.9,33.8,53,35,53,36.2z"></path><path d="M77.3,25C77.3,25,77.3,25,77.3,25c0-0.7,0-1.4-0.2-2.1c-0.1-0.4-0.2-0.6-0.5-0.8c-0.4-0.2-0.7-0.5-1.1-0.7 c-1-0.5-2-0.8-3.1-1.1c-2.4-0.5-4.7-0.6-7.1-0.5c-1,0-2,0.1-3,0.3c-1.7,0.2-3.3,0.7-4.8,1.5c-0.6,0.3-1,0.5-1.1,1.2 c-0.4,1.5-0.3,3.9-0.4,5.4c0,0,0,0.1,0,0.1C57,28,58,27.7,59,27.5c0.3-0.1,0.6-0.1,0.8-0.2c1.9-0.3,3.8-0.4,5.7-0.4 c1.8,0,3.6,0,5.3,0.1c1.3,0.1,2.6,0.3,3.9,0.5c0.3,0,0.6,0.1,0.9,0.2l1.7,0.5c0,0,0,0,0,0C77.4,27.5,77.4,25.8,77.3,25z"></path><path d="M84.9,21.2c-2.1,1.2-4.1,2.3-6.2,3.5l-0.3,0.2v-0.1l0,0c0-0.1,0-0.3,0-0.4c0-0.5,0-1.2-0.2-1.8c-0.1-0.5-0.4-1.1-1-1.5 L77.1,21c-0.3-0.2-0.7-0.4-1.1-0.6c-1-0.5-2.1-0.9-3.4-1.1c-1.8-0.4-3.7-0.6-5.9-0.6c-0.5,0-1,0-1.5,0c-1.2,0.1-2.2,0.1-3.1,0.3 c-2.1,0.3-3.8,0.8-5.2,1.7c-0.6,0.3-1.3,0.8-1.6,1.9C55.1,23.2,55,24,55,24.9l-0.5-0.3l-1.1-0.6l-0.1-0.1l-0.5-0.3l-0.1-0.1 l-1.4-0.8c-0.8-0.5-1.7-1-2.7-1.5c0.4-0.3,0.7-0.5,1.1-0.7c5.4-3.1,10.9-6.1,16.3-9.2c0.6-0.3,1-0.3,1.6,0 c5.5,3.1,11.1,6.2,16.6,9.4C84.4,20.8,84.6,20.9,84.9,21.2z"></path></g><path d="M79.5,34.9c0,6.9-5.6,12.4-12.4,12.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-6.6,12.4-6.6C73.9,28.3,79.5,28.1,79.5,34.9z"></path><path d="M103.4,63.5L87.6,50.8c-1.3-1.3-2.8-1.7-4.9-1.6H52.1c-2.2,0-3.6,0.3-4.9,1.6L31.5,63.5c-1.3,1.2-1.9,3-1.8,4.8 c0.2,1.8,1.1,3.4,2.6,4.4L48.7,84c0.6,0.4,1.3,0.7,2,0.9l0.1,8.1l16.6,0L84,93l0.1-8.1c0.7-0.2,1.4-0.4,2-0.9l16.5-11.3 c1.5-1,2.4-2.6,2.6-4.4C105.3,66.5,104.6,64.8,103.4,63.5z M45,67l5.7-4.2l0,8.2L45,67z M79.8,73.9l-0.5,0.3 c-2.7,1.9-3.4,5.6-1.5,8.3c0.5,0.8,1.2,1.4,2,1.8v1.8l-12.4,2.4L55,86.1v-1.8c0.8-0.4,1.5-1,2-1.8c1.9-2.7,1.2-6.4-1.5-8.3L55,73.9 v-6.7l12.3,2.4l0.1,0l12.4-2.4L79.8,73.9L79.8,73.9z M84.1,70.9l0-8.2l5.7,4.2L84.1,70.9z"></path></svg><language-span lang-id="8166"></language-span></a> <a type="button" style="margin-left: 10px;" ng-class="setup.isSelected(8165);" ng-click="setup.setType(8165);"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 130 100" xml:space="preserve" style="enable-background:new 0 0 130 100;width: 35px;transform: translate(0%,15%);"><circle cx="43" cy="35.3" r="12.8"></circle><path d="M72.5,79c1.1,0,2.3-0.4,3.2-1.3l16.4-16.4c1.7-1.7,1.8-4.6,0-6.3c-1.7-1.7-4.6-1.7-6.3,0L72.6,68c0,0-8-7.7-13.6-13.4 c-1.6-1.6-2.9-2.8-7.2-2.8c-3.6,0-18,0-18,0c-4.2,0-8.6,3.9-8.6,8.1v31.9h33V67.5l10.7,10.2C69.7,78.5,71.4,79,72.5,79z"></path><g><polygon points="116.5,92.2 64,92.2 64,88.2 112.5,88.2 112.5,16 13.8,16 13.8,88.2 22.2,88.2 22.2,92.2 9.8,92.2 9.8,12 116.5,12"></polygon></g></svg><language-span lang-id="8165"></language-span></a></div></div>',

  bindings: {
    flow: '=',
    profile: '<'
  },

  controllerAs: 'setup',

  controller: function controller($scope, language, EventManager, IAM_CODES) {

    // this
    var setup = this;

    // event manager
    var eventManager = new EventManager('mticFinalizationAccountSetup', $scope);

    // model
    $scope.language = language;
    setup.isSelected = function (id) {
      var isSelected = setup.flow.accountType === id;
      if (isSelected) {
        return {
          'button': true,
          'btn-new-mtic': true,
          'selected': true
        };
      } else {
        return {
          'button': true,
          'btn-new-mtic': true,
          'not-selected': true
        };
      }
    };
    setup.setType = function (id) {
      if (setup.flow.isTesting) {
        setup.flow.setType(id, 'account');
        if (id === IAM_CODES.LANG.TEACHER) {
          setup.flow.setType(IAM_CODES.LANG.TEACHER, 'account');
          setup.flow.setType(IAM_CODES.LANG.RETURNING, 'returning');
        }
      }
    };
  }
});
'use strict';

angular.module('mtic.components.login').component('mticFinalizationAccountReturning', {

  template:'<div style="margin-top:15px;"><language-span lang-id="8170"></language-span><div role="group" style="margin-top:15px;"><a type="button" ng-class="ret.isSelected(8171)" ng-click="ret.setType(8171)"><language-span lang-id="8171"></language-span></a> <a type="button" ng-class="ret.isSelected(8172)" ng-click="ret.setType(8172)" style="margin-left: 10px;"><language-span lang-id="8172"></language-span></a></div></div>',

  bindings: {
    'flow': '='
  },

  controllerAs: 'ret',

  controller: function controller($scope, EventManager, userAccount, IAM_CODES) {

    var eventManager = new EventManager('mticFinalizationAccountReturning', $scope);

    var ret = this;

    ret.isSelected = function (id) {
      var isSelected = ret.flow.returningType === id;
      if (isSelected) {
        return {
          'button': true,
          'btn-new-mtic': true,
          'selected': true
        };
      } else {
        return {
          'button': true,
          'btn-new-mtic': true,
          'not-selected': true
        };
      }
    };

    ret.setType = function (id) {
      if (!ret.teacherSelected()) {
        ret.flow.setType(id, 'returning');
      } else {
        ret.flow.setType(IAM_CODES.LANG.RETURNING, 'returning');
      }
    };

    ret.teacherSelected = function () {
      return Number(ret.flow.accountType) === IAM_CODES.LANG.TEACHER;
    };
  }
});
'use strict';

angular.module('mtic.components.login').component('mticFinalizationAccountRegistration', {

  template:'<div class="card"><div class="card-content" ng-show="reg.flow.returningType === 8171"><language-span lang-id="8174"></language-span><form style="margin-top:15px;text-align: center;" ng-submit="reg.mticInfo.login()"><input class="input" type="text" placeholder="{{language.get(\'8158\')}}" ng-model="reg.mticInfo.username"> <input class="input" type="password" placeholder="{{language.get(\'8159\')}}" ng-model="reg.mticInfo.userpassword"> <input type="submit" class="button btn-returning" value="{{language.get(\'8178\')}}"></form></div><div class="card-content" ng-show="reg.flow.returningType === 8172"><div ng-show="reg.flow.accountType === 8166"><language-span lang-id="8175"></language-span><form style="margin-top:15px;text-align: center;" ng-submit="reg.iamInfo.validateStudent()"><input class="input" type="text" placeholder="{{language.get(\'8795\')}}" ng-model="reg.iamInfo.classCode"> <input type="submit" class="button btn-student-class-code" value="{{language.get(\'8179\')}}"></form></div><div ng-show="reg.flow.accountType === 8165">N/A</div></div><div ng-show="reg.messageHandler.display" ng-class="reg.messageHandler.getClass()" role="alert" ng-bind="reg.messageHandler.get()"></div></div>',

  bindings: {
    flow: '=',
    info: '=',
    profile: '='
  },

  controllerAs: 'reg',

  controller: function controller($scope, $log, $timeout, TIMING_CONSTANTS, language, EventManager, api, IAMManager, userAccount, IAM_CODES, LOGIN_CONSTANTS) {

    // self
    var reg = this;

    // event manager
    var eventManager = new EventManager('mticFinalizationAccountRegistration', $scope);

    // constants

    // model
    $scope.language = language;
    var msfUser = reg.profile || {};
    var msfEmail = msfUser.unique_name;

    // utils
    var isEmptyString = function isEmptyString(str) {
      return !str || str.replace(/\ /g, '').length === 0 || str === null || str === undefined;
    };

    var isValidCode = function isValidCode(code) {
      return !(isNaN(code) || code < 1);
    };

    var parseCode = function parseCode(code) {
      var codes = code.split('-');
      if (codes.length !== 2) {
        return null;
      } else {
        var codesParsed = {
          class_id: codes[1],
          teacher_id: codes[0]
        };
        if (isValidCode(codesParsed.class_id) && isValidCode(codesParsed.teacher_id)) {
          return codesParsed;
        } else {
          return null;
        }
      }
    };

    var messageHandler = reg.messageHandler = {
      message: null,
      type: 'info',
      display: false,
      timeoutCancel: null,
      ext: '',
      hide: function hide() {
        messageHandler.display = false;
      },
      show: function show() {
        messageHandler.display = true;
      },
      get: function get() {
        return language.get(this.message) + this.ext;
      },
      getClass: function getClass() {
        switch (messageHandler.type) {
          case 'success':
            return { 'notification': true, 'is-success': true };
          case 'error':
            return { 'notification': true, 'is-danger': true };
          default:
            return { 'notification': true, 'is-info': true };
        }
      },
      set: function set(langId) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
        var ext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        messageHandler.type = ['info', 'error', 'success'].indexOf(type) > -1 ? type : 'info';
        messageHandler.message = langId;
        $timeout(function () {
          messageHandler.show();
        }, TIMING_CONSTANTS.SCOPE_REFRESH_DELAY_MS);
        messageHandler.ext = ext ? ext : '';
        if (messageHandler.timeoutCancel) {
          $timeout.cancel(messageHandler.timeoutCancel);
        }
        messageHandler.timeoutCancel = $timeout(messageHandler.hide, TIMING_CONSTANTS.MESSAGE_HIDE_DELAY_MS);
      }
    };

    var mticInfo = reg.mticInfo = {

      username: '',

      userpassword: '',

      determineAccountType: function determineAccountType() {
        if (Number(reg.flow.accountType) === IAM_CODES.TEACHER) {
          return LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER;
        } else {
          return LOGIN_CONSTANTS.ACCOUNT_TYPES.STUDENT;
        }
      },

      login: function login() {

        if (isEmptyString(mticInfo.username) || isEmptyString(mticInfo.userpassword)) {
          messageHandler.set(11306, 'error');
          return;
        }

        messageHandler.set(8147, 'info');

        api.nonSystematicLogin(mticInfo.username, mticInfo.userpassword).then(function (res) {
          var roles = res.roles,
              session_key = res.session_key,
              user_id = res.user_id;
          var role = userAccount.determineRole(roles);
          var req = {
            session_key: session_key,
            user_id: user_id
          };
          if (role.role_type === mticInfo.determineAccountType()) {
            return api.linkIam(msfUser, req);
          } else {
            throw { message: 'INVALID_ROLE' };
          }
        }).then(function () {
          messageHandler.set(8147, 'info');
          return api.login({ uuid: mticInfo.username, password: mticInfo.userpassword });
        }).catch(function (res) {

          var message = res.message;
          var stack = res.stack;
          $log.info(res);

          if (message === 'NOT_FOUND__USER_AUTHS') {
            messageHandler.set(8157, 'error');
          } else if (message === 'INVALID_ROLE') {
            messageHandler.set(8154, 'error');
          }

          if (message === 'BAD_PASSWORD') {
            messageHandler.set(11308, 'error');
          } else {
            messageHandler.set(8152, 'error');
          }
        });
      }
    };

    reg.iamInfo = {

      classCode: '',

      teacherCode: '',

      validateStudent: function validateStudent() {

        var parsedCode = parseCode(reg.iamInfo.classCode);

        if (parsedCode !== null) {

          var firstName = reg.info.firstName,
              lastName = reg.info.lastName,
              username = reg.info.username,
              password = reg.info.password,
              iam = reg.info.iam,
              iamUser = reg.info.iamUser;

          var teacher_id = parsedCode.teacher_id,
              class_id = parsedCode.class_id;

          return api.signUpStudent(teacher_id, class_id, username, password, firstName, lastName).then(function () {
            api.nonSystematicLogin(username, password);
          }).then(function (res) {
            var session_key = res.session_key;
            var user_id = res.session_key;
            messageHandler.set(8254, 'info');
            return api.linkIam(msfUser, {
              session_key: session_key,
              user_id: user_id
            });
          }).then(function () {
            messageHandler.set(8254, 'info');
            return api.login({
              uuid: username,
              password: password
            });
          }).catch(function (res) {
            var message = res.message,
                stack = res.stack;
            // $log.debug(res)
            if (message === 'NOT_FOUND_USER_ROLES') {
              messageHandler.set(8253, 'error');
            } else {
              messageHandler.set(8152, 'error');
            }
          });
        } else {
          messageHandler.set(8253, 'error');
        }
      },
      validateTeacher: function validateTeacher() {
        $log.info('validateTeacher!! is WIP');
      }
    };

    reg.$onChanges = function () {
      msfUser = reg.profile;
      msfEmail = msfUser.unique_name;
    };

    reg.$onInit = function () {
      msfUser = reg.profile;
      msfEmail = msfUser.unique_name;
    };
  }
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsWorkspaceTab', function ($log, TeacherDataService, $timeout, TIMING_CONSTANTS) {
  return {
    template:'<div class="panel panel1"><bubble-learning-map asset-url="assets/images/gr78/" on-item-click="selectResource" module-map-data="modules.current.children" highlighted="agendaEditor.mods.resources.initial"></bubble-learning-map><div select-box options="students" model="student" style="position:relative;font-size:12px;width: 200px;margin-top:30px;float:right" filler-text="getTranslation(\'31671\')" display-function="\'display_name\'"></div></div>',
    scope: {
      resources: '=',
      students: '=',
      selectedStudents: '=',
      selectedResources: '=',
      selectedClass: '='
    },
    link: function link(scope, element) {
      scope.modules = {
        list: [],
        current: null,
        currentChild: null
      };
      scope.selected = {
        resources: {},
        students: {}
      };
      scope.splitResources = {};
      scope.splitResourcesTitles = [{ type: 'lesson', caption: 'Lessons' }, { type: 'assessment', caption: 'Assessments' }];
      scope.addStudentsToFilter = function (student) {
        scope.selectedStudents.push(student);
      };
      scope.toggleResourceSelection = function (resource) {
        if (scope.selected.resources[resource.id]) {
          delete scope.selected.resources[resource.id];
        } else {
          scope.selected.resources[resource.id] = resource;
        }
        scope.selectedResources = _.map(scope.selected.resources);
      };
      scope.toggleStudentSelection = function (student) {
        if (scope.selected.students[student.user_id]) {
          delete scope.selected.students[student.user_id];
        } else {
          scope.selected.students[student.user_id] = student;
        }
        scope.selectedStudents = _.map(scope.selected.students);
      };
      scope.setSelectedStudent = function (student) {
        scope.selected.students = {};
        scope.selected.students[student.user_id] = student;
        scope.selectedStudents = _.map(scope.selected.students);
      };
      scope.tab = {
        current: 'lesson',
        switch: function _switch(tab) {
          this.current = tab;
        },
        isActive: function isActive(tab) {
          return this.current === tab;
        }
      };

      scope.style = {
        forResource: function forResource(resource) {
          if (scope.selected.resources[resource.id]) {
            return {
              'background-color': '#f5f5f5'
            };
          } else {
            return {};
          }
        },
        forStudent: function forStudent(student) {
          if (scope.selected.students[student.user_id]) {
            return {
              'background-color': '#f5f5f5'
            };
          } else {
            return {};
          }
        }
      };
      scope.$watch('resources', function (resources) {
        if (resources) {
          resources.forEach(function (resource) {
            if (!scope.splitResources[resource.resource_type]) {
              scope.splitResources[resource.resource_type] = [];
            }
            scope.splitResources[resource.resource_type].push(resource);
          });
        }
      });

      scope.$watch('selectedClass', function (classroom) {
        if (classroom) {
          TeacherDataService.getClassFullModules(classroom.id).then(function (moduleListFlat) {
            //console.log('got modules !', moduleListFlat)
            scope.modules.list = moduleListFlat;
            scope.modules.current = scope.modules.list[0];
          });
        }
      });

      scope.selectResource = function (resource, bubbleModuleItem) {
        $timeout(function () {
          //console.log('CLICKED ON RESOURCE : ', resource, bubbleModuleItem)
        }, TIMING_CONSTANTS.INSTANT);
      };
    }
  };
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsWorkspaceCard', function ($log, $q, $sce, Firebase, EventManager, language, TeacherDataService) {
  return {
    template:'<div ng-if="!loadingStatus.done" ng-bind="getTranslation(\'27697\')" class="student-card-loading">Loading...</div><div ng-if="loadingStatus.done"><div ng-if="loadingStatus.error">An Error Occurred While Loading The Data.</div><div ng-if="!loadingStatus.error" id="student_panel_card"><div ng-show="shouldShowStudentName()" class="student-name"><div class="student-icon"></div><b class="display-name" ng-bind="rowData.studentName"></b><div class="percentage">%</div><div class="time">Time</div></div><div class="studentCard studentCard--itemA" ng-class="cardStatus" ng-click="rowData.cardStyle.isover=!rowData.cardStyle.isover"><div class="card-status"></div><table class="historique-progress-row"><tr><td class="col-stars"><img ng-repeat="star in completeStarCount" class="complete" src="assets/images/c3-module/star@1x.png"> <img ng-repeat="star in maxStarCount" class="max" src="assets/images/c3-module/star-fade@1x.png"></td><td class="col-badge" ng-if="log.score == 1 && log.slug.indexOf(\'run_like_math\') > -1"><img src="assets/images/c3-module/badge@2x.png"></td><td class="col-badge badge-placeholder" ng-if="log.score < 1 && log.slug.indexOf(\'run_like_math\') > -1"><img src="assets/images/c3-module/badge-fade@2x.png"></td><td class="col-itemname"><div class="item-name" ng-bind="getName(rowData)">...</div><div class="additional" ng-if="rowData.cardStyle.isover"><b ng-bind="rowData.studentName"></b><br><span ng-bind="getFormattedTime()"></span></div></td><td class="col-score"><span ng-show="log.score || log.score === 0" ng-bind="getResultPercentage()"></span></td><td class="col-time"><span ng-bind="returnTimeSpent()">...</span></td></tr></table></div><a ng-show="shouldShowLoadMore()" ng-click="filterToStudent()" ng-bind="getTranslation(\'load_more\')">load more...</a></div></div>',
    scope: {
      log: '=',
      classId: '=',
      selectedStudent: '=?',
      prevlog: '=',
      studentsList: '=',
      resourceListing: '=',
      parentResource: '=',
      nextlog: '='
    },
    link: function link(scope) {
      var eventManager = new EventManager('workspace_card', scope);

      scope.getTranslation = function (id, fallbackText) {
        if (fallbackText) {
          return language.get(id) !== "NA" ? language.get(id) : fallbackText;
        }
        return language.get(id);
      };

      scope.shouldShowStudentName = function () {
        if (!scope.prevlog || scope.log.user_id !== scope.prevlog.user_id) {
          return true;
        }
        return false;
      };

      scope.shouldShowLoadMore = function () {
        if (scope.nextlog === true || scope.nextlog && scope.log.user_id !== scope.nextlog.user_id) {
          return true;
        }
        return false;
      };

      scope.filterToStudent = function () {
        eventManager.broadcast('response:tab:options', { student: { user: infoMaps.users[scope.log.user_id] } });
      };

      scope.moment = moment;

      var infoMaps = {
        users: {},
        resources: {}
      };
      var runLikeMathModuleId = 192;
      scope.loadingStatus = {
        done: false,
        failed: false,
        processing: false
      };
      scope.rowData = {
        inProgress: false,
        isComplete: false,
        studentName: '',
        resourceName: '',
        date: '',
        year: '',
        timeStarted: '',
        time: '',
        timeText: '',
        completeText: '',
        text: '',
        compiledTimeSentenceID: '',
        cardStyle: {
          // 'padding': '4px'
        },
        timeClass: {}
      };

      var min2digit = function min2digit(str) {
        if (('' + str).length < 2) {
          return '0' + str;
        }
        return str;
      };

      scope.returnTimeSpent = function () {
        scope.time_spent = Number(moment(scope.log.timeSpent)) / 1000; //(Number(moment(scope.log.timeEnded)) - Number(moment(scope.log.timeStarted)))/1000;
        scope.time_spent = Math.max(0, Math.min(scope.time_spent, 1200));
        scope.time_text = min2digit(Math.floor(scope.time_spent / 60)) + ':' + min2digit(Math.min(59, Math.round(scope.time_spent % 60)));
        return scope.time_text;
      };

      scope.getResultPercentage = function () {
        return Math.round(scope.log.score * 100) + '%';
      };

      if (scope.log.score) {
        scope.score_text = scope.getTranslation('27745') + ' ' + Math.round(scope.log.score * 100) + '%'; // 'score:'
      }

      var getStarsFromScore = function getStarsFromScore(score, maxStars) {
        var stars = 0;
        var parent = scope.parentResource;
        var scoring = { '0.5': 1, '0.8': 2, '1': 3 };
        if (parent && parent.config.map_config && parent.config.map_config.item_scoring_breakdown) {
          scoring = parent.config.map_config.item_scoring_breakdown;
        }

        //this is hard coded for the old rlm module
        if (scope.parentResource.parent_resource_id === runLikeMathModuleId) {
          scoring = { '0.25': 1, '0.5': 2, '0.75': 3, '1': 4 };
        }

        var max_scoring_found = 0;
        for (var score_point in scoring) {
          if (scoring[score_point] && score >= Number(score_point) && Number(score_point) > max_scoring_found) {
            stars = scoring[score_point];
            max_scoring_found = Number(score_point);
          }
        }

        var result = Math.min(stars, maxStars);
        return result;
      };

      function getCompleteStarCount(resource) {
        if (resource && resource.display && scope.log.completed && resource.resource_type !== "assessment") {
          var max_stars = resource.display.color === 'blue' ? 1 : 3;
          var num = getStarsFromScore(scope.log.score, max_stars); //Math.floor(scope.log.score * max_stars);
          scope.completeStarCount = num === 0 ? [] : setupNumArray(num);
        } else {
          scope.completeStarCount = [];
        }
      }

      function getMaxStarCount(resource) {
        if (resource.resource_type === "assessment" || !resource.display || !scope.log.completed) {
          scope.maxStarCount = [];
        } else {
          var num = scope.completeStarCount.length || 0;
          if (resource.display.color === 'blue') {
            scope.maxStarCount = setupNumArray(1 - num);
          } else {
            scope.maxStarCount = setupNumArray(3 - num);
          }
        }
      }

      function setupNumArray(num) {
        var arr = [];
        for (var i = 0; i < num; i++) {
          arr.push(i);
        }
        return arr;
      }

      scope.getName = function (log) {
        if (log.resource_type === 'custom_resource') {
          return log.name;
        }
        if (log.slug.indexOf('run_like_math') === -1) {
          return language.get(log.slug);
        } else {
          var splt = log.slug.split('_');
          var level = '';
          if (!isNaN(splt[splt.length - 1])) {
            level = splt[splt.length - 1];
          }
          var trans_slug = log.slug.replace('_' + level, '');
          // if(log.slug.indexOf('subtraction') > -1){   But why
          //   if(level === '3'){
          //     level = '1'
          //   }else if(level === '1'){
          //     level = '3';
          //   }
          // }
          return language.get(trans_slug + '_short').replace('__', level);
        }
      };

      scope.getFormattedTime = function () {
        return moment(scope.rowData.timeStarted).format('MMM DD') + ', ' + moment(scope.rowData.timeStarted).format('YYYY');
      };

      var parseLog = function parseLog(log) {
        scope.loadingStatus.done = false;
        scope.loadingStatus.error = false;
        scope.loadingStatus.processing = true;
        var student = infoMaps.users[log.user_id] || {};
        var resource = scope.resourceListing || {};
        // scope.rowData.date = moment(log.timeStarted).format('MMM DD')
        // scope.rowData.year = moment(log.timeStarted).format('YYYY');

        if (scope.rowData.year < 2000 && log.alternative_start) {
          log.timeStarted = log.alternative_start;
          // scope.rowData.date = moment(log.timeStarted).format('MMM DD')
          // scope.rowData.year = moment(log.timeStarted).format('YYYY');
          //console.log('replacing wrong date!', log )
        }

        scope.rowData.timeStarted = log.timeStarted;

        var currentHour = Number(moment(log.timeStarted).format('H'));
        var timeText = '';
        if (currentHour >= 7 && currentHour < 12) {
          timeText = '27731'; // Morning
        } else if (currentHour >= 12 && currentHour < 17) {
          timeText = '27732'; // 'Afternoon'
        } else {
          timeText = '27733'; // 'Evening &amp;<br> Weekend'
          scope.rowData.timeClass['studentCard__time--evening'] = true;
        }
        scope.rowData.time = timeText;
        scope.rowData.timeText = moment(log.timeStarted).locale('en').fromNow(true);
        // scope.rowData.timeAgo = String(scope.rowData.timeText).incudes('days') ? 'days' : 'months';
        // scope.rowData.timeAgo = scope.rowData.timeText.indexOf('days') > 0 ? 'days' : 'months';
        // scope.rowData.timeAgo = 'days';
        scope.rowData.typeOf = _typeof(scope.rowData.timeText);
        scope.rowData.timeAgoNumber = moment(log.timeStarted).locale('en').fromNow(true).match(/\d+/) || '1';
        if (!log.timeEnded) {
          scope.rowData.inProgress = true;
          //scope.rowData.timeText = moment(log.timeEnded).fromNow()
        } else if (moment().diff(moment(log.timeStarted), 'hours') > 5) {
          scope.rowData.inProgress = false;
        } else {
          scope.rowData.inProgress = false;
        }
        if (!scope.rowData.inProgress) {
          scope.rowData.isComplete = log.completed;
          scope.rowData.completeText = resource.resource_type === 'assessment' ? 'assessment' : 'lesson';
        } else {
          scope.rowData.isComplete = false;
          scope.rowData.completeText = 'This in progress and was started ';
        }
        scope.rowData.studentName = student.display_name;
        scope.rowData.resourceName = resource.name;

        if (log.completed) {
          if (scope.rowData.completeText === 'lesson') {
            if (scope.rowData.timeText.indexOf('day') >= 0) {
              scope.rowData.compiledTimeSentenceID = '27738';
            } else if (scope.rowData.timeText.indexOf('month') >= 0) {
              scope.rowData.compiledTimeSentenceID = '27739';
            } else if (scope.rowData.timeText.indexOf('hour') >= 0) {
              scope.rowData.compiledTimeSentenceID = '28504';
            } else {
              scope.rowData.compiledTimeSentenceID = '28505';
            }
          } else {
            if (scope.rowData.timeText.indexOf('day') >= 0) {
              scope.rowData.compiledTimeSentenceID = '27740';
            } else if (scope.rowData.timeText.indexOf('month') >= 0) {
              scope.rowData.compiledTimeSentenceID = '27739';
            } else if (scope.rowData.timeText.indexOf('hour') >= 0) {
              scope.rowData.compiledTimeSentenceID = '28506';
            } else {
              scope.rowData.compiledTimeSentenceID = '28507';
            }
          }
        } else {
          if (scope.rowData.completeText === 'lesson') {
            if (scope.rowData.timeText.indexOf('day') >= 0) {
              scope.rowData.compiledTimeSentenceID = '27736';
            } else if (scope.rowData.timeText.indexOf('month') >= 0) {
              scope.rowData.compiledTimeSentenceID = '27737';
            } else if (scope.rowData.timeText.indexOf('hour') >= 0) {
              scope.rowData.compiledTimeSentenceID = '28502';
            } else {
              scope.rowData.compiledTimeSentenceID = '28503';
            }
          } else {
            if (scope.rowData.timeText.indexOf('day') >= 0) {
              scope.rowData.compiledTimeSentenceID = '27742';
            } else if (scope.rowData.timeText.indexOf('month') >= 0) {
              scope.rowData.compiledTimeSentenceID = '27743';
            } else if (scope.rowData.timeText.indexOf('hour') >= 0) {
              scope.rowData.compiledTimeSentenceID = '28508';
            } else {
              scope.rowData.compiledTimeSentenceID = '28509';
            }
          }
        }
        // scope.rowData.text = scope.getTranslation(scope.rowData.compiledTimeSentenceID).replace('x', scope.rowData.timeAgoNumber);
        scope.cardStatus = scope.rowData.inProgress ? 'in-progress' : scope.rowData.isComplete ? 'complete' : '';
        scope.loadingStatus.done = true;
        scope.loadingStatus.error = false;
        scope.loadingStatus.processing = false;
        scope.rowData.slug = log.slug;
        scope.rowData.resource_type = log.resource_type;
        scope.rowData.name = log.name;
        getCompleteStarCount(resource);
        getMaxStarCount(resource);
        eventManager.broadcast('teacherStudentWorkspace:studentFilter:request');
      };

      var init = function init() {
        scope.loadingStatus.done = false;
        scope.loadingStatus.error = false;
        scope.loadingStatus.processing = true;
        // $q.all([
        //   TeacherDataService.getClassStudentMap(scope.classId, null, true, false).then(function(students){
        infoMaps.users = scope.studentsList;
        //   }),
        //   TeacherDataService.getModuleResourceListFlatMap(scope.classId).then(function(resources){
        infoMaps.resources = scope.resourceListing; //scope.resourcesList
        //   })
        // ]).then(function(){
        // scope.fbRef = Firebase.database().ref(['timeline', scope.classId, scope.log.$id].join('/'));
        // ['value', 'child_added', 'child_changed', 'child_removed', 'child_moved'].map(function(eventName){
        //     scope.fbRef.on(eventName, function(snap){
        //         scope.fbRef.once('value', function(snap){
        //             // console.log(snap.val())
        //             parseLog(snap.val())
        //         }).catch(function(err){
        //             $log.error(err);
        //             scope.loadingStatus.done = true;
        //             scope.loadingStatus.error = true;
        //         })
        //     })
        // })
        parseLog(scope.log);
        // }).catch(function(err){
        //   $log.error(err);
        //   scope.loadingStatus.done = true;
        //   scope.loadingStatus.error = true;
        // })
      };
      init();
      // language.resetAvilableOptions();
    }

  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsWorkspace', function ($log, $q, api, EventManager, TeacherDataService, Firebase, $timeout, TIMING_CONSTANTS, language, ModuleFilter, PlatformService) {
  return {
    template:'<div class="placeholder-pane"><span ng-hide="loadingStatus.done" ng-bind="getTranslation(\'27697\')">Loading...</span><div ng-show="loadingStatus.done"><span class="font-vanilla"></span><div ng-if="loadingStatus.error">Failed To Load Logs</div><div ng-if="!loadingStatus.error"><div class="filterSideBar"><div class="mobile-header"><div class="title">WORKSPACE</div><div select-box options="filterElements.data.users" model="studentModel.student" on-change="setSelectedStudent" filler-text="getTranslation(\'14575\')" clickable-filler="true" display-function="\'display_name\'" class="students-select-box"></div><div select-box options="mTimeFilters" model="mSelectedTimeFilter" on-change="setSelectedTimeFilter" display-function="\'label\'" class="time-filter-dropdown"></div></div><div select-box options="filterElements.data.users" model="studentModel.student" on-change="setSelectedStudent" filler-text="getTranslation(\'14575\')" clickable-filler="true" display-function="\'display_name\'" class="students-select-box desktop"></div><div ng-show="mismatch" ng-bind="getTranslation(\'srs_discrepancy\')">There may be some discrepancy between the results on the sidepanel and results shown on the map</div><span ng-show="loadingLogs">Loading...</span><ul ng-hide="loadingLogs" class="student-list"><li style="margin-bottom:20px" ng-show="diagnosticResult.users.length > 0 && filterElements.data.users && filterElements.data.users.length>0 && module_filtered_list && module_filtered_list.length>0"><a ng-click="showDiagnosticResult()" ng-bind="\'Show Diagnostics Result\'"></a></li><table ng-show="testing.length > 0" class="main-column-headers historique-progress-row align-bottom"><tr><td class="col-stars"></td><td class="col-itemname"></td><td class="col-score">%</td><td class="col-time"><span ng-bind="getTranslation(\'28224\')"></span><br>(m:s)</td></tr></table><li ng-repeat="log in testing = ( module_filtered_list | wsTime:filterElements.selected.wsTime | inArray:filterElements.selected.users:\'user_id\'| inArray:filterElements.selected.resources:\'resource_id\':\'id\' )"><teacher-students-workspace-card log="log" prevlog="testing[$index - 1]" nextlog="getNextLog(testing[$index + 1])" class-id="selectedClass.id" students-list="infoMaps.users" resource-listing="getResourceListing(log)" parent-resource="getParentResource(log)"></teacher-students-workspace-card></li></ul><div ng-hide="data.logs">Loading ...</div><div ng-show="!loadingLogs && testing.length < 1 && loadingStatus.done && !loadingStatus.error" style="font-size: 18px" ng-bind="getTranslation(\'27458\')">There is no data to display for the selected class, module or student</div></div><div class="timeLine" style="background-color: #DEE9FC">{{modules.current.slug}}<ng-switch ng-hide="diagnosticResult.show" on="currentModule"><module-meta-map ng-switch-default module-map-data="moduleMapData" intercept-click="intercept" on-item-click="selectResource" workspace-data="{modules: srs_log_data, users: filterElements.selected.users}"></module-meta-map></ng-switch><div ng-if="diagnosticResult.show" ng-init="diagnosticResult.headers = getHeaders(testing)" class="modal" ng-click="$event.stoppropagation();$event.stopEv" ng-class="{\'is-active\':(diagnosticResult.show)}"><div class="modal-background"></div><div class="modal-card"><header class="modal-card-head"><p class="modal-card-title text-center font-size-20">Diagnostics Result</p></header><section class="modal-card-body"><div><table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"><thead><tr><th>Student</th><th ng-repeat="(key,value) in diagnosticResult.headers track by $index" ng-bind="\'Q\'+($index+1)"></th></tr></thead><tbody ng-init="diagnosticResult.users = getDiagnosticsTakenUsers(filterElements.data.users,module_filtered_list)"><tr ng-repeat="user in diagnosticResult.users"><td ng-bind="user.display_name"></td><td ng-repeat="(key,value) in user.headers"><div ng-init="value.validation = getValidation(value)">{{user.validation}} <i ng-show="value.validation" class="fa fa-check-circle" aria-hidden="true" style="color:#5dc46e"></i> <i ng-hide="value.validation" class="fa fa-times-circle" aria-hidden="true" style="color:#f00"></i></div></td></tr></tbody></table></div></section><footer class="modal-card-foot"><div class="text-center width-100-percent"><button class="button background-color-3398db color-white min-width100" ng-click="closeDiagnosticResultModal()">Close</button></div></footer></div></div><div class="breadcrumbs" style="position:absolute; top:12px; left:12px; padding:8px; border-radius:4px; background-color: rgba(220, 227, 230, 0.9);"><a href="#" ng-click="modules.current = null">{{getLang(moduleMapData.resource_slug)}}</a> /&nbsp;<div select-box options="unlockedModulesList" model="modules.current" style="position:relative; font-size:12px; display:inline-block; margin-left:3px; min-width:180px" filler-text="getTranslation(\'14574\')" display-function="displayModule" clickable-filler="true"></div></div></div></div></div></div><div class="route-path"><div class="route-brand">{{$root.isMTIC ? \'MathemaTIC\' : \'OCMT-HSE\'}}</div><div class="route-screen" ng-bind="getTranslation(\'14568\')">Activity Log</div></div><style>\r\n.filterSideBar::-webkit-scrollbar-track\r\n{\r\n  background-color: #f1f1f1;\r\n  margin-top:20px;\r\n  margin-bottom:20px;\r\n}\r\n\r\n.filterSideBar::-webkit-scrollbar\r\n{\r\n  width: 8px;\r\n}\r\n\r\n.filterSideBar::-webkit-scrollbar-thumb\r\n{\r\n  border-radius: 10px;\r\n  height:40px;\r\n  background-color: #999999;\r\n}\r\n</style>',
    scope: {
      selectedClass: '='
    },
    link: function link(scope, element) {
      scope.studentModel = {};

      // $timeout(function(){
      //   moment.locale(language.getCurrentSelectedLanguage());
      // }, 800);

      var eventManager = new EventManager('teacherStudentsWorkspace', scope);
      var screen_width = 0;
      var is_mobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (is_mobile) {
        screen_width = window.screen.width;
      } else {
        screen_width = window.innerWidth;
      }
      if (screen_width < 1200) {
        var timer = is_mobile ? 500 : 0;
        $timeout(function () {
          eventManager.broadcast('teacher:toggle:Sidepanel', false);
        }, timer);
      }
      var filteredResources;
      var selectedStudent;
      TeacherDataService.isTeacherWorkspaceView = true;
      scope.$on('$destroy', function () {
        TeacherDataService.isTeacherWorkspaceView = false;
      });
      scope.slugs = {
        addition: ["run_like_math_addition_lv_1", "run_like_math_addition_lv_2", "run_like_math_addition_lv_3", "run_like_math_addition_lv_4", "run_like_math_addition_lv_5", "run_like_math_addition_lv_6", "run_like_math_addition_lv_7", "run_like_math_addition_lv_8", "run_like_math_addition_lv_9", "run_like_math_addition_lv_10"],
        subtraction: ["run_like_math_subtraction_lv_1", "run_like_math_subtraction_lv_2", "run_like_math_subtraction_lv_3", "run_like_math_subtraction_lv_4", "run_like_math_subtraction_lv_5", "run_like_math_subtraction_lv_6", "run_like_math_subtraction_lv_7", "run_like_math_subtraction_lv_8", "run_like_math_subtraction_lv_9", "run_like_math_subtraction_lv_10"],
        division: ["run_like_math_division_lv_1", "run_like_math_division_lv_2", "run_like_math_division_lv_3", "run_like_math_division_lv_4", "run_like_math_division_lv_5", "run_like_math_division_lv_6", "run_like_math_division_lv_7", "run_like_math_division_lv_8", "run_like_math_division_lv_9", "run_like_math_division_lv_10"],
        multiplication: ["run_like_math_multiplication_lv_1", "run_like_math_multiplication_lv_2", "run_like_math_multiplication_lv_3", "run_like_math_multiplication_lv_4", "run_like_math_multiplication_lv_5", "run_like_math_multiplication_lv_6", "run_like_math_multiplication_lv_7", "run_like_math_multiplication_lv_8", "run_like_math_multiplication_lv_9", "run_like_math_multiplication_lv_10"]
      };
      scope.Utils = {
        keys: Object.keys
      };
      scope.selected = {};
      scope.selected.resources = {};
      scope.filterElements = {
        limits: {
          firebase: 200,
          angular: 20
        },
        data: {
          users: [],
          resources: []
        },
        selected: {
          users: [],
          resources: []
        }
      };
      scope.data = {
        logs: []
      };
      scope.infoMaps = {
        users: {},
        resources: {}
      };
      scope.loadingStatus = {
        done: false,
        failed: false
      };
      scope.modules = {
        list: [],
        current: null,
        currentChild: null
      };
      scope.diagnosticResult = {
        show: false,
        headers: []
      };
      scope.logs = [];

      scope.showDiagnosticResult = function () {
        scope.diagnosticResult.show = true;
      };

      scope.closeDiagnosticResultModal = function () {
        scope.diagnosticResult.show = false;
        scope.diagnosticResult.users = [];
        scope.diagnosticResult.headers = [];
      };

      var has_been_inited = false;
      var init = function init(class_id) {
        if (has_been_inited) {
          return;
        }
        scope.loadingStatus.done = false;
        scope.loadingStatus.error = false;
        $q.all([TeacherDataService.getClassStudentMap(class_id, null, true, false).then(function (students) {
          scope.filterElements.data.users = _.orderBy(_.toArray(students), [function (student) {
            return student.info.last_name.toLowerCase();
          }, function (student) {
            return student.info.first_name.toLowerCase();
          }]);
          scope.infoMaps.users = students;
          if (filters_to_workspace) {
            return;
          }
          scope.filterElements.selected.users = scope.filterElements.data.users;
        }), TeacherDataService.getModuleResourceListFlatMap(class_id).then(function (resources) {
          scope.filterElements.data.resources = _.toArray(resources);
          scope.infoMaps.resources = resources;
          scope.module_filtered_list = scope.data.logs;
        })]).then(function () {
          if (has_been_inited) {
            return;
          }
          // scope.loadingStatus.done = true;
          // scope.loadingStatus.error = false;
          scope.setSelectedStudent(scope.studentModel.student);
          loadLogs(class_id);
        }).catch(function (error) {
          $log.error(error);
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = true;
          has_been_inited = false;
        });
      };

      var loadLogs = function loadLogs(class_id, user_id, resource_id) {
        var log_data = [];
        if (scope.loadingLogs && (selectedStudent || scope.modules.current)) {
          return;
        }

        scope.loadingLogs = true;
        scope.data.logs = [];
        //This one uses srsl for the sidepanel
        api.getClassResourceStates(class_id, false, true, true, user_id, resource_id).then(function (data) {
          data = data.sort(function (a, b) {
            if (a.User.ClassWorks[0].StudentResourceStateLogs.id < b.User.ClassWorks[0].StudentResourceStateLogs.id) {
              return 1;
            } else if (a.User.ClassWorks[0].StudentResourceStateLogs.id > b.User.ClassWorks[0].StudentResourceStateLogs.id) {
              return -1;
            }
            return 0;
          });
          data.forEach(function (work) {
            work.User.ClassWorks.forEach(function (class_work) {
              //class_work.StudentResourceStateLogs.forEach((srsl)=>{
              var srsl = class_work.StudentResourceStateLogs;
              if (srsl) {
                var score = scope.infoMaps.resources[class_work.Resource.id] && scope.infoMaps.resources[class_work.Resource.id].display.color === "blue" && srsl.completed ? 1 : srsl.score;
                log_data.push({
                  timeSpent: srsl.time_spent,
                  timeStarted: srsl.time_stamp,
                  timeEnded: srsl.time_stamp,
                  score: score,
                  resource_id: class_work.Resource.id,
                  completed: srsl.completed,
                  user_id: work.user_id,
                  alternative_start: srsl.created_at,
                  // app_state: class_work.StudentResourceStateLogs,
                  slug: class_work.Resource.slug,
                  resource_type: class_work.Resource.resource_type,
                  name: class_work.Resource.name
                });
              }
              //})
            });
          });
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = false;
          scope.loadingLogs = false;
          has_been_inited = true;
          scope.module_filtered_list = scope.data.logs = log_data;
          //This one uses srs for the map
          api.getClassResourceStates(class_id, false, true, false, user_id, resource_id).then(function (srs_data) {
            scope.srs_log_data = [];
            srs_data.forEach(function (work) {
              work.User.ClassWorks.forEach(function (class_work) {
                //class_work.StudentResourceStateLogs.forEach((srsl)=>{
                var srs = class_work.WorkBatch.StudentResourceState;
                if (srs) {
                  var score = scope.infoMaps.resources[class_work.WorkBatch.Resource.id] && scope.infoMaps.resources[class_work.WorkBatch.Resource.id].display.color === "blue" && srs.complete ? 1 : srs.score_max;
                  scope.srs_log_data.push({
                    score: score,
                    resource_id: class_work.WorkBatch.Resource.id,
                    completed: srs.complete,
                    user_id: work.user_id,
                    slug: class_work.WorkBatch.Resource.slug,
                    resource_type: class_work.WorkBatch.Resource.resource_type,
                    name: class_work.WorkBatch.Resource.name
                  });
                }
                //})
              });
            });
            try {
              computeModuleStats();
            } catch (e) {
              // no module selected
            }
          }).catch(function (error) {
            has_been_inited = false;
            scope.loadingLogs = false;
            $log.error(error);
            scope.loadingStatus.done = true;
            scope.loadingStatus.error = true;
          });
        }).catch(function (error) {
          has_been_inited = false;
          scope.loadingLogs = false;
          $log.error(error);
          scope.loadingStatus.done = true;
          scope.loadingStatus.error = true;
        });
      };

      scope.dateSorter = function (card) {
        return new Date(card.timeStarted).getTime() * -1;
      };

      scope.getResourceListing = function (log) {
        return scope.infoMaps.resources[log.resource_id];
      };

      scope.getParentResource = function (log) {
        if (!scope.infoMaps.resources[log.resource_id]) {
          return null;
        }
        return scope.infoMaps.resources[scope.infoMaps.resources[log.resource_id].parent_resource_id];
      };

      scope.unlockedModulesList = [];

      scope.$watch('selectedClass', function (classroom) {
        if (classroom) {
          refresh();
          init(classroom.id);
          TeacherDataService.getClassFullModules(classroom.id).then(function (moduleListFlat) {
            scope.modules.list = moduleListFlat;
            //scope.modules.current = scope.modules.list[0];
          });

          TeacherDataService.getStudentWorkForModuleOfTeacher(classroom.id, true).then(function (moduleData) {
            scope.moduleMapData = moduleData;
            scope.currentModule = moduleData.resource_slug;
            eventManager.broadcast("teacher:select:dropdown", { "activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_slug": scope.moduleMapData.resource_slug });
          });

          scope.setSelectedStudent();
        }
      });

      scope.$watch('modules.list', function () {
        scope.unlockedModulesList = [];
        _.forEach(scope.modules.list, function (module) {
          if (ModuleFilter.checkAvailable(module)) {
            scope.unlockedModulesList.push(module);
          }
        });
      });

      scope.returnUnlockedModulesList = function () {
        var availableModules = _.map(scope.modules.list, function (module) {
          ModuleFilter.checkAvailable(module);
        });

        return availableModules;
      };

      scope.$watch('modules.current.id', function (newval, oldval) {
        if (oldval !== newval && !(scope.modules.current && scope.modules.current.slug === 'run_like_math')) {
          loadLogs(scope.selectedClass.id, selectedStudent ? selectedStudent.user_id : null, newval);
        }

        if (newval) {
          eventManager.broadcast("teacher:select:dropdown", { "activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_id": newval });
        } else if (scope.moduleMapData) {
          eventManager.broadcast("teacher:select:dropdown", { "activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_slug": scope.moduleMapData.resource_slug });
        }
      });

      scope.module_filtered_list = [];
      scope.srs_log_data = [];
      var computing = false;
      var computeModuleStats = function computeModuleStats() {
        if (computing) {
          return;
        }
        computing = true;
        var cur_module;
        if (scope.modules && scope.modules.current) {
          cur_module = scope.modules.current;
        }
        if (cur_module) {
          // if(scope.moduleMapData && scope.moduleMapData.module_id === 11){
          //   var temp = scope.currentModule;
          //   scope.currentModule='';
          //   $timeout(function(){
          //     scope.currentModule = temp;
          //     scope.selected.resources = {};
          //     scope.filterElements.selected.resources = [];
          //     var runLikeMathModuleId = 192;
          //     scope.module_filtered_list = _.filter(scope.data.logs, function(log){
          //       if(cur_module.id ===runLikeMathModuleId){
          //         return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[scope.infoMaps.resources[log.resource_id].parent_resource_id].parent_resource_id === cur_module.id)
          //       }
          //       else{
          //         return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[log.resource_id].parent_resource_id === cur_module.id)
          //       }
          //     })
          //     scope.srs_log_data = _.filter(scope.srs_log_data, function(log){
          //       if(cur_module.id ===runLikeMathModuleId){
          //         return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[scope.infoMaps.resources[log.resource_id].parent_resource_id].parent_resource_id === cur_module.id)
          //       }
          //       else{
          //         return (log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[log.resource_id].parent_resource_id === cur_module.id)
          //       }
          //     })
          //     eventManager.broadcast('module:change:submodule', cur_module.slug);
          //     eventManager.broadcast('submodule:opened', {
          //       slug: cur_module.slug,
          //       name: cur_module.name
          //     });

          //     scope.loadingLogs = false;
          //     computing = false;
          //   }, 100)
          // }
          // else{
          scope.selected.resources = {};
          scope.filterElements.selected.resources = [];
          scope.module_filtered_list = _.filter(scope.data.logs, function (log) {
            return log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[log.resource_id].parent_resource_id === cur_module.id;
          });
          scope.srs_log_data = _.filter(scope.srs_log_data, function (log) {
            return log.resource_id && scope.infoMaps.resources[log.resource_id] && scope.infoMaps.resources[log.resource_id].parent_resource_id === cur_module.id;
          });
          eventManager.broadcast('module:change:submodule', cur_module.slug);
          eventManager.broadcast('submodule:opened', {
            slug: cur_module.slug,
            name: cur_module.name
          });
          computing = false;
          // }
          if (selectedStudent) {
            compareSrsSrsl();

            eventManager.broadcast("teacherStudentWorkspace:studentFilter:change", {
              list: getFilteredResources(),
              selectedStudent: selectedStudent
            });
          }
        } else {
          scope.selected.resources = {};
          scope.filterElements.selected.resources = [];
          scope.module_filtered_list = scope.data.logs;
          eventManager.broadcast('submodule:closed', {});
          eventManager.broadcast('module:change:meta', scope.moduleMapData ? scope.moduleMapData.resource_slug : null);
          computing = false;
        }
      };

      eventManager.listen('ready-for-filters', function () {
        if (TeacherDataService.isTeacherWorkspaceView) {
          $timeout(function () {
            if (selectedStudent) {
              filteredResources = _.filter(scope.module_filtered_list, function (item) {
                return item.user_id === selectedStudent.user_id;
              });
            } else {
              filteredResources = [];
            }
            eventManager.broadcast("teacherStudentWorkspace:studentFilter:change", { list: filteredResources, selectedStudent: selectedStudent });
          }, 300);
        }
      });

      scope.fromNow = function (time) {
        return moment(time).fromNow();
      };

      scope.getTranslation = function (slug) {
        return language.get(slug);
      };
      scope.getLang = language.get;

      scope.selectResource = function (resource, bubbleModuleItem) {
        $timeout(function () {
          scope.toggleResourceSelection(resource);
          // scope.filterElements.selected.resources.add(angular.extend(resource, {
          //   deselect: bubbleModuleItem.hideAgendaHighlight
          // }));
          bubbleModuleItem.showAgendaHighlight();
        }, TIMING_CONSTANTS.INSTANT);
      };

      function compareSrsSrsl() {
        var srs_score_map = {};var srsl_score_map = {};
        _.each(scope.module_filtered_list, function (val) {
          if (val.score) {
            srsl_score_map[val.resource_id] = srsl_score_map[val.resource_id] ? Math.max(srsl_score_map[val.resource_id], val.score) : val.score;
          }
        });
        _.each(scope.srs_log_data, function (val) {
          if (val.score) {
            srs_score_map[val.resource_id] = srs_score_map[val.resource_id] ? Math.max(srs_score_map[val.resource_id], val.score) : val.score;
          }
        });
        scope.mismatch = false;
        _.each(srsl_score_map, function (val, key) {
          if (!srs_score_map[key] && srs_score_map[key] !== 0 || srs_score_map[key] !== val) {
            scope.mismatch = true;
          }
        });
        _.each(srs_score_map, function (val, key) {
          if (!srsl_score_map[key] && srsl_score_map[key] !== 0 || srsl_score_map[key] !== val) {
            scope.mismatch = true;
          }
        });
      }

      function refresh() {
        scope.modules.current = null;
        scope.selected = {};
        scope.selected.resources = {};
        scope.selected.students = {};
        scope.filterElements.selected.users = [];
        scope.filterElements.selected.resources = [];
        scope.module_filtered_list = [];
        filters_to_workspace = false;
        has_been_inited = false;
      }

      scope.setSelectedStudent = function (student) {
        if (selectedStudent === student || !selectedStudent && !student) {
          return;
        }
        // scope.loadingStatus.done = false;
        // scope.loadingStatus.error = false;
        selectedStudent = student;
        var module_data_id = scope.modules.current ? scope.modules.current.id : null;
        if (!module_data_id && scope.moduleMapData) {
          module_data_id = scope.moduleMapData.resource_slug;
        }

        if (!selectedStudent) {
          scope.studentModel.student = null;
          scope.removeStudentFilter();
          loadLogs(scope.selectedClass.id, null, scope.modules.current ? scope.modules.current.id : null);
          eventManager.broadcast("teacherStudentWorkspace:studentFilter:change", { list: [], selectedStudent: selectedStudent });
          return;
        }
        scope.selected.students = {};
        scope.filterElements.selected.users = [];
        scope.selected.students[selectedStudent.user_id] = selectedStudent;
        scope.filterElements.selected.users = _.map(scope.selected.students);

        loadLogs(scope.selectedClass.id, selectedStudent.user_id, scope.modules.current ? scope.modules.current.id : null);
        eventManager.broadcast("teacherStudentWorkspace:studentFilter:change", {
          list: getFilteredResources(),
          selectedStudent: selectedStudent
        });

        if (scope.modules.current) {
          eventManager.broadcast("teacher:select:dropdown", { "activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_id": module_data_id });
        } else if (module_data_id) {
          eventManager.broadcast("teacher:select:dropdown", { "activity_log": "Modules", "user_id": !selectedStudent ? [] : selectedStudent.user_id, "group_id": scope.selectedClass.id, "resource_slug": module_data_id });
        }
      };

      var getFilteredResources = function getFilteredResources() {
        if (selectedStudent) {
          var filteredResources = _.filter(scope.srs_log_data, function (item) {
            return item.user_id === selectedStudent.user_id;
          });
          return filteredResources;
        }
        return [];
      };

      $log.debug('teacherStudentWorkspace:studentFilter:request RECEIVED');

      eventManager.listen('teacherStudentWorkspace:studentFilter:request', _.throttle(function () {
        eventManager.broadcast("teacherStudentWorkspace:studentFilter:change", {
          list: getFilteredResources(),
          selectedStudent: selectedStudent
        });
      }, 500, {
        leading: true,
        trailing: true
      }));

      scope.removeStudentFilter = function () {
        scope.filterElements.selected.users = [];
        scope.filterElements.selected.users = scope.filterElements.data.users;
      };

      scope.toggleResourceSelection = function (resource) {
        if (scope.selected.resources[resource.id]) {
          delete scope.selected.resources[resource.id];
        } else {
          scope.selected.resources[resource.id] = resource;
        }
        scope.filterElements.selected.resources = _.map(scope.selected.resources);
      };

      eventManager.listen('retrigger-workspace-filters', function (e, args) {
        if (!args) {
          args = scope.modules.current ? scope.modules.current.slug : null;
        }
        scope.modules.current = null;
        $timeout(function () {
          if (args === "run_like_math") {
            scope.moduleMapData.resources.forEach(function (mod) {
              if (mod.slug === args) {
                scope.modules.current = mod;
              }
            });
          } else {
            scope.modules.list.forEach(function (mod) {
              if (mod.slug === args) {
                scope.modules.current = mod;
              }
            });
          }
        }, 50);
      });

      eventManager.listen('creating-items-done', function (e) {
        eventManager.broadcast("teacherStudentWorkspace:studentFilter:change", {
          list: getFilteredResources(),
          selectedStudent: selectedStudent
        });
        computeModuleStats();
      });

      scope.intercept = {};
      scope.$watch('intercept.slug', function (clicked_slug) {
        if (clicked_slug) {
          scope.modules.list.forEach(function (mod) {
            if (mod.slug === clicked_slug) {
              scope.modules.current = mod;
            }
          });
        }
      });
      scope.getValidation = function (scene) {
        if (!scene) {
          return false;
        } else {
          var validation = true;
          Object.keys(scene).forEach(function (each) {
            validation = validation && scene[each].validation;
          });
          return validation;
        }
      };

      scope.getHeaders = function (filteredList) {
        var stateData;
        filteredList.forEach(function (each) {
          if (each.slug === 'mtic_g78_m0_diag') {
            stateData = each.app_state[0].app_state.state_data;
          }
        });
        return stateData;
      };

      scope.getDiagnosticsTakenUsers = function (allUsers, moduleFilteredList) {
        var filteredUsers = [];
        allUsers.forEach(function (user) {
          moduleFilteredList.forEach(function (each) {
            if (each.user_id === user.user_id && each.slug.indexOf("mtic_g78_m0_diag") > -1) {
              var userWithDiagnostic = angular.copy(user);
              userWithDiagnostic.headers = angular.copy(each.app_state[0].app_state.state_data);
              filteredUsers.push(userWithDiagnostic);
            }
          });
        });

        return filteredUsers;
      };

      eventManager.listen('module:change:run_like_math', function (e, mod) {
        $timeout(function () {
          scope.modules.current = mod;
        }, 100);
      });

      eventManager.listen('submodule:change:in:run_like_math', function (e, mod) {
        $timeout(function () {
          scope.modules.current = mod;
        }, 100);
      });

      eventManager.listen("close:current:module", function (e, mod) {
        scope.modules.current = null;
      });

      var filters_to_workspace = false;
      $timeout(function () {
        eventManager.broadcast('request:tab:options');
      }, 100);
      eventManager.listen('response:tab:options', function (e, args) {
        if (!args) {
          return;
        }
        if (args.module) {
          scope.modules.list.forEach(function (mod) {
            if (args && mod.slug === args.module.slug) {
              scope.modules.current = mod;
            }
          });
        }
        scope.studentModel.student = args.student.user;
        scope.setSelectedStudent(args.student.user);
        filters_to_workspace = true;
      });

      eventManager.listen('module:change:meta', function (e, data) {
        scope.modules.current = null;
      });

      scope.displayModule = function (option) {
        return scope.getTranslation(option.slug);
      };

      scope.customDateSorter = function (card) {
        var time = new Date(card.timeStarted).getTime();
        return time;
      };

      scope.getNextLog = function (log) {
        if (selectedStudent || scope.modules.current) {
          return false;
        }
        return log || true;
      };

      /********************************** Mobile View ***********************************/

      /****** Setting Student table height *****/
      scope.mEls = {};
      var unwatch_studentTable = scope.$watch(function () {
        if (!PlatformService.isPhonePortrait()) {
          return false;
        }
        scope.mEls.pageHeader = scope.mEls.pageHeader || document.querySelector('#nav-display-for-certificate');
        scope.mEls.workspaceHeader = scope.mEls.workspaceHeader || document.querySelector('.teacher-page.workspace-nav .mobile-header');
        scope.mEls.studentTable = scope.mEls.studentTable || document.querySelector('.teacher-page.workspace-nav .student-list');
        return !!(scope.mEls.pageHeader && scope.mEls.workspaceHeader && scope.mEls.studentTable && scope.loadingStatus.done && !scope.loadingLogs);
      }, function (rendered) {
        if (rendered) {
          $timeout(function () {
            setStudentTableHeight();
          }, 100);
          unwatch_studentTable();
        }
      });
      function setStudentTableHeight() {
        var remHeight = 0;
        [scope.mEls.pageHeader, scope.mEls.workspaceHeader].map(function (el) {
          remHeight += el ? el.getBoundingClientRect().height : 0;
        });
        scope.mEls.studentTable.style.height = window.innerHeight - remHeight + 'px';
        mSetDropdownMenuHeight('body', '.students-select-box', 0.7);
      }
      window.removeEventListener('resize', mOnResize_studentTable);
      window.addEventListener('resize', mOnResize_studentTable);
      function mOnResize_studentTable() {
        // in case for some reason mobile browser changes visible viewport height (hides address bar etc)
        if (PlatformService.isPhonePortrait()) {
          setStudentTableHeight();
        }
      }
      /*** End of Setting Student table height ***/

      /**
       * Calculates height for dropdown menu
       * @param containerSelector Container element to base available height against.
       * @param dropdownSelector Dropdown selector
       * @param pct Percentage of container height to use.
       */
      function mSetDropdownMenuHeight(containerSelector, dropdownSelector, pct) {
        var container = document.querySelector(containerSelector);
        var menu = container.querySelector(dropdownSelector + ' .selectBox__options');
        var maxMenuHeight = container.offsetHeight * pct + 'px';
        menu.style['max-height'] = maxMenuHeight;
      }

      scope.mTimeFilters = [{
        id: 'all',
        label: 'All time ranges'
      }, {
        id: 'today',
        label: 'Today'
      }, {
        id: '1week',
        label: '1 Week'
      }, {
        id: '2weeks',
        label: '2 Weeks'
      }, {
        id: '1month',
        label: '1 Month'
      }];
      scope.mTimeFiltersById = {};
      scope.mTimeFilters.map(function (filter) {
        scope.mTimeFiltersById[filter.id] = filter;
      });
      scope.mSelectedTimeFilter = scope.mTimeFiltersById.all;
      scope.setSelectedTimeFilter = function (timeFilter) {
        scope.mSelectedTimeFilter = timeFilter;
      };
      scope.$watch('mSelectedTimeFilter', function (val) {
        scope.filterElements.selected.wsTime = scope.mSelectedTimeFilter;
      });
      /****************************** End of Mobile View ********************************/
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsReports', function ($http, $log, EventManager, userAccount, api, DATA_HOST) {
  return {
    template:'<div class="placeholder-pane">Reports will go in this page.</div>',
    scope: {
      selectedClass: '='
    },
    link: function link(scope, element) {

      var eventManager = new EventManager('teacherStudentsReports', scope);
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherModules', function ($http, $log, $timeout, TIMING_CONSTANTS, EventManager, TeacherDataService, MapStateService) {
  return {
    template:'<div class="teacher-students-modules placeholder-pane"><mtic-modules intercept-click="interceptClick" module="moduleData" style="position:absolute; top:2px; left:0px;width: 100%;height: 100%;"></mtic-modules><nav-bar-route-view style="overflow: hidden;" add-text="\'Modules\'"></nav-bar-route-view></div>',
    scope: {
      selectedClass: '=',
      interceptClick: '=?'
    },
    link: function link(scope, element) {

      var eventManager = new EventManager('teacherModules', scope);
      var screen_width = 0;
      var is_mobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (is_mobile) {
        screen_width = window.screen.width;
      } else {
        screen_width = window.innerWidth;
      }
      if (screen_width < 1200) {
        var timer = is_mobile ? 500 : 0;
        $timeout(function () {
          eventManager.broadcast('teacher:toggle:Sidepanel', false);
        }, timer);
      }
      //scope.interceptClick = scope.interceptClick || null;

      TeacherDataService.isTeacherModuleView = true;
      scope.$on('$destroy', function () {
        TeacherDataService.isTeacherModuleView = false;
        MapStateService.setActiveModule("");
      });

      var init = function init(firstInit) {
        scope.moduleData = null;
        eventManager.broadcast("teacherStudentWorkspace:studentFilter:change", { list: [] });
        TeacherDataService.getStudentWorkForModuleOfTeacher(scope.selectedClass.id, true).then(function (moduleData) {
          if (firstInit) {
            $log.debug('[[teacherModules]] RE-INITED', moduleData);
            scope.moduleData = moduleData;
          } else {
            $log.debug('[[teacherModules]] RE-INITED', moduleData);
            $timeout(function () {
              scope.moduleData = moduleData;
            }, TIMING_CONSTANTS.INSTANT);
          }
        });
      };

      eventManager.listen('teacher:cycle:open', function (e) {
        init(true);
      });
      eventManager.listen('app:module:open', function (e) {
        init();
      });
      init(true);

      scope.$watch('selectedClass', function (selectedClass) {
        if (selectedClass) {
          $log.log('selectedClass: ', selectedClass);
          eventManager.broadcast('teacher:cycle:open', { cycle: TeacherDataService.currentActiveMeta ? TeacherDataService.currentActiveMeta.slug : '' });
        }
      });
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsAddremove', function ($http, $log, $q, language, EventManager, TeacherDataService, $timeout, LocaleService, api, preliveCheck) {

  return {

    template:'<div class="mtic-resource-loader-container-wrap" ng-hide="loadingStatus.done"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div class="route-path"><div class="route-brand">MathemaTIC</div><div class="route-screen">Accounts</div></div><div style="position:absolute; top:0px; bottom:0px; right:0px; left:0px; overflow:auto;" id="studentStatsDashboard"><div><div class="button-container" style="position: fixed; bottom: 10px; right: 10px"><button ng-show="warning_timer_delay && (students.length === 0 || students.length === undefined || students.length === null || show_add_info)" type="button" class="button" ng-click="show_add_info = false; warning_timer_delay = false"><i class="fa fa-arrow-down item-list-icon" aria-hidden="true"></i> <span ng-bind="language.get(\'14579\')">Hide</span></button> <button ng-show="(removeStudentEditMode || unArchiveStudentEditMode)" type="button" class="button" ng-click="onDoneClicked()" ng-bind="language.get(\'16289\')">Done</button> <button ng-show="showActiveStudents && !removeStudentEditMode" type="button" class="button" ng-click="removeStudentEditMode=true"><i class="fa fa-minus item-list-icon" aria-hidden="true"></i> <span ng-bind="language.get(\'16280\')">Remove Student</span></button> <button ng-show="showArchivedStudents && !unArchiveStudentEditMode" type="button" class="button" ng-click="unArchiveStudentEditMode=true"><i class="fa fa-arrow-left item-list-icon" aria-hidden="true"></i> <span ng-bind="language.get(\'16285\')">Un-archive Student</span></button> <button type="button" class="button" ng-click="show_info_and_scroll()"><i class="fa fa-plus item-list-icon" aria-hidden="true"></i> <span ng-bind="getTranslation(\'14778\')">Add Student</span></button> <button type="button" class="button" ng-click="refresh()"><i class="fa fa-refresh item-list-icon" aria-hidden="true"></i><language-span lang-id="reload"></language-span></button></div><table ng-init="showActiveStudents=true" ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-narrow is-hoverable is-fullwidth" style="width: auto; margin: auto;background-color:transparent"><tr class="background-transparent"><td style="border:0px"></td><td colspan="8" style="border:0px"><div class="tabs"><ul><li ng-click="showActiveStudentsTab()" ng-class="{\'is-active\':showActiveStudents && !showArchivedStudents}"><a><span ng-bind="language.get(\'16278\')">Active Students</span> ({{students.length||0}})</a></li><li ng-disabled="removeStudentEditMode" ng-click="showArchivedStudentsTab()" ng-class="{\'is-active\':showArchivedStudents}"><a><span ng-bind="language.get(\'16279\')">Archived Students</span> ({{archivedStudents.length||0}})</a></li></ul></div></td></tr><tr class="background-transparent"><th class="left-align white" style="max-width: 160px"><div class="cursor-pointer" ng-click="changeSortOrder(\'FIRST_NAME\',sort.order)"><span ng-bind="language.get(\'11299\')"></span> <i ng-show="sort.by==\'first_name\' && students && students.length>1" class="fa font-size-16-force" ng-class="{\'fa-sort-asc\':sort.order==\'ASC\',\'fa-sort-desc\':sort.order==\'DESC\',\'margin-top-5\':sort.order==\'ASC\'}" aria-hidden="true"></i></div></th><th class="left-alig" style="max-width: 160px"><div class="cursor-pointer" ng-click="changeSortOrder(\'LAST_NAME\',sort.order)"><span ng-bind="language.get(\'11300\')"></span> <i ng-show="sort.by==\'last_name\'&& students && students.length>1" class="fa font-size-16-force" ng-class="{\'fa-sort-asc\':sort.order==\'ASC\',\'fa-sort-desc\':sort.order==\'DESC\',\'margin-top-5\':sort.order==\'ASC\'}" aria-hidden="true"></i></div></th></tr><tr ng-show="showActiveStudents && !showArchivedStudents" class="background-transparent" ng-repeat="student in students | orderBy:customOrder()"><a ng-if="false" ng-click="showGeneratePDFModal(student)" ng-bind="\'PDF\'"></a><td class="left-align" ng-class-disabled="{\'background-light-gray\':student.isSelectedForRemoval,\'background-white\':!student.isSelectedForRemoval}" ng-bind="student.user.info.first_name"></td><td class="left-align" ng-class-disabled="{\'background-light-gray\':student.isSelectedForRemoval,\'background-white\':!student.isSelectedForRemoval}" ng-bind="student.user.info.last_name"></td></tr><tr ng-if="showArchivedStudents" ng-repeat="student in archivedStudents | orderBy:\'info.last_name\'" class="background-transparent"><td class="left-align" ng-class-disabled="{\'background-light-gray\':student.isSelectedForUnarchive,\'background-white\':!student.isSelectedForUnarchive}" ng-bind="student.user.info.first_name"></td><td class="left-align" ng-class-disabled="{\'background-light-gray\':student.isSelectedForUnarchive,\'background-white\':!student.isSelectedForUnarchive}" ng-bind="student.user.info.last_name"></td></tr><tr class="row-footer background-transparent" ng-show="students && students.length>0"><th style="border:0px" colspan="1"></th><th class="left-align" style="border:0px" colspan="{{1+modules.length}}"><div ng-if="false"><a ng-click="downloadAllStudentProgressPdf(students)"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> <span ng-bind="\'Export as pdf\'"></span></a></div></th></tr></table><div ng-if="warning_timer_delay && (students.length === 0 || students.length === undefined || students.length === null || show_add_info)" class="no-students-registered" style="margin: 0 auto; width: 600px;"></div><div ng-if="loadingStatus.error"><h4>Vous ne voyez pas vos élèves?</h4><p></p></div></div></div><div class="modal" ng-class="{\'is-active\':(showArchiveStudentConfirmModal||showUnArchiveStudentConfirmModal)}"><div class="modal-background"></div><div class="modal-card max-width375"><header class="modal-card-head"><p ng-if="showArchiveStudentConfirmModal" class="modal-card-title text-center" ng-bind="language.get(\'16288\')">Archive Students</p><p ng-if="showUnArchiveStudentConfirmModal" class="modal-card-title text-center" ng-bind="language.get(\'16285\')">Un-archive Students</p></header><section class="modal-card-body"><div><p ng-if="showArchiveStudentConfirmModal" class="text-center margin-bottom20" ng-bind="language.get(\'16281\')">The following students will be moved to the Archived Students list.</p><p ng-if="showUnArchiveStudentConfirmModal" class="text-center margin-bottom20" ng-bind="language.get(\'16286\')">The following students will be moved back to the Active Students list.</p><div><ul><li ng-if="showArchiveStudentConfirmModal" class="font-bold" ng-repeat="student in students | filter:{isSelectedForRemoval:true }" ng-bind="student.user.info.first_name+\' \'+student.user.info.last_name"></li><li ng-if="showUnArchiveStudentConfirmModal" class="font-bold" ng-repeat="student in archivedStudents | filter:{isSelectedForUnarchive:true }" ng-bind="student.user.info.first_name+\' \'+student.user.info.last_name"></li></ul></div></div></section><footer class="modal-card-foot"><div class="text-center"><p class="margin-bottom20" ng-if="showArchiveStudentConfirmModal" ng-bind="language.get(\'16282\')">Are you sure you want to remove these students from Active Students list?</p><p class="margin-bottom20" ng-if="showUnArchiveStudentConfirmModal" ng-bind="language.get(\'16287\')">Are you sure you want to un-archive these students and move them back to the Active Students list?</p><button class="button background-color-3398db color-white min-width100" ng-disabled="statusChangeStarted" ng-click="onCancelStudentStatusChange()" ng-bind="language.get(\'16284\')">No</button> <button class="button background-color-3398db color-white min-width100" ng-disabled="statusChangeStarted" ng-click="onConfirmStudentStatusChange()" ng-bind="language.get(\'16283\')">Yes</button></div></footer></div></div><div ng-if="false" class="modal" ng-class="{\'is-active\':(pdfGeneration.isGeneratePdfModalVisible)}"><div class="modal-background"></div><div class="modal-card max-width375"><header class="modal-card-head"><p class="modal-card-title text-center font-size-20">Export Student PDF</p></header><section class="modal-card-body"><div><div class="field"><div class="control"><label class="checkbox"><input type="checkbox" ng-model="pdfGeneration.showExportDate"> Show date of export</label></div></div></div></section><footer class="modal-card-foot"><div class="text-center width-100-percent"><button class="button background-color-3398db color-white min-width100" ng-disabled="pdfGeneration.generatingPdf" ng-click="downloadStudentProgressPdf(pdfGeneration.selectedStudent,pdfGeneration.showExportDate)">Generate</button></div></footer></div></div>',

    scope: {
      selectedClass: '='
    },
    link: function link(scope, element) {
      scope.isPrelive = function () {
        return preliveCheck.isPreliveCheck();
      };
      scope.archivedStudents = [];
      scope.showActiveStudents = true;
      scope.sort = {
        order: 'ASC',
        by: 'first_name',
        prevSortBy: 'first_name'
      };
      scope.pdfGeneration = {
        isGeneratePdfModalVisible: false,
        selectedStudent: {},
        showExportDate: false
      };

      scope.showGeneratePDFModal = function (student) {
        scope.pdfGeneration.isGeneratePdfModalVisible = true;
        scope.pdfGeneration.selectedStudent = student;
      };

      var getProgressRingForPdf = function getProgressRingForPdf(size, score, lock) {
        var url = 'https://s3.eu-central-1.amazonaws.com/mtic-items/interface/';
        if (lock) {
          url += 'teachview-ring-' + size + '-locked.png';
        } else {
          var num = score ? Math.min(21, Math.round(21 * score)) : 0;
          if (num === 0) {
            url += 'teachview-ring-' + size + '-blank.png';
          } else {
            if (String(num).length === 1) {
              num = '0' + num;
            }
            url += 'teachview-ring-' + size + '-fill00' + num + '.png';
          }
        }
        return url;
      };

      var createRingImage = function createRingImage(imageSource, imageWidth, imageStartPositionX, imageStartPositionY, specialElementHandlers, doc) {
        var defer = $q.defer();
        var img = document.createElement('img'); //new Image(); // width, height values are optional params 
        img.width = imageWidth;
        img.src = imageSource;
        img.style.display = "inline-block";
        img.setAttribute("style", "display : inline");
        var body = document.createElement("body");
        body.appendChild(img);
        doc.fromHTML(body, imageStartPositionX, imageStartPositionY, {
          'width': 10, // max width of content on PDF
          'elementHandlers': specialElementHandlers
        }, function (bla) {
          // $log.log(bla);
          defer.resolve();
        });

        return defer.promise;
      };

      scope.downloadStudentProgressPdf = function (student, shouldShowExportDate) {
        if (scope.pdfGeneration.generatingPdf) {
          return;
        }
        scope.pdfGeneration.generatingPdf = true;
        var name = student.user.info.first_name + " " + student.user.info.last_name;
        var doc = new jsPDF();
        doc.text(20, 20, "Name: " + name);
        doc.text(20, 30, "Class: " + scope.selectedClass.name);
        if (shouldShowExportDate) {
          doc.text(20, 40, "Date of Export: " + moment().format('YYYY-MM-DD'));
        }

        var promises = [];
        angular.forEach(scope.modules, function (each, index) {
          var stats = student.moduleWorkSummary[each.resource_id].stats;
          var specialElementHandlers = {
            '#editor': function editor(element, renderer) {
              return true;
            },
            '.controls': function controls(element, renderer) {
              return true;
            }
          };
          var starty = 60;
          doc.text(20, starty + 10 + index * 20, scope.getModuleName(each));
          var startx = 120;
          var firstProgressRingSrc = getProgressRingForPdf('small', stats.diagnostic.score_max_mean, stats.diagnostic.locked);
          var secondProgressRingSrc = getProgressRingForPdf('large', stats.lessons.score_max_mean, stats.diagnostic.locked);
          var thirdProgressRingSrc = getProgressRingForPdf('small', stats.summative.score_max_mean, stats.summative.locked);
          promises.push(createRingImage(firstProgressRingSrc, "10", startx, starty + 2.5 + index * 20, specialElementHandlers, doc));
          promises.push(createRingImage(secondProgressRingSrc, "15", startx + 10, starty + index * 20, specialElementHandlers, doc));
          promises.push(createRingImage(thirdProgressRingSrc, "10", startx + 10 + 15, starty + 2.5 + index * 20, specialElementHandlers, doc));
        });

        $q.all(promises).then(function () {
          doc.save(scope.selectedClass.id + "_" + student.user.user_id + '.pdf');
          scope.pdfGeneration = {};
        }, function (err) {
          scope.pdfGeneration.generatingPdf = false;
        });
      };

      scope.downloadAllStudentProgressPdf = function (students) {
        var promises = [];
        var doc = new jsPDF();
        var rowStartX = 10;
        var rowStartY = 20;
        var verticalDiffBetweenItems = 15;
        var pageWidth = doc.internal.pageSize.width - rowStartX;
        var columnWidth = pageWidth / (scope.modules.length + 2);
        doc.setFontSize(10);
        doc.text(rowStartX, rowStartY, language.get('11299'));
        doc.text(rowStartX + columnWidth, rowStartY, language.get('11300'));
        angular.forEach(scope.modules, function (each, index) {
          var splitTitle = doc.splitTextToSize(scope.getModuleName(each), columnWidth);
          doc.text(rowStartX + columnWidth * (index + 2), rowStartY, splitTitle);
        });
        doc.setFontSize(9);
        students.forEach(function (student, studentIndex) {
          var splitFirstName = doc.splitTextToSize(student.user.info.first_name, columnWidth);
          var splitLastName = doc.splitTextToSize(student.user.info.last_name, columnWidth);
          doc.text(rowStartX, rowStartY + verticalDiffBetweenItems * (studentIndex + 1), splitFirstName);
          doc.text(rowStartX + columnWidth, rowStartY + verticalDiffBetweenItems * (studentIndex + 1), splitLastName);

          angular.forEach(scope.modules, function (each, index) {
            var stats = student.moduleWorkSummary[each.resource_id].stats;
            var specialElementHandlers = {
              '#editor': function editor(element, renderer) {
                return true;
              },
              '.controls': function controls(element, renderer) {
                return true;
              }
            };

            var starty = 60;
            // doc.text(20, starty+10+(index*20), scope.getModuleName(each));
            var startx = 120;
            var firstProgressRingSrc = getProgressRingForPdf('small', stats.diagnostic.score_max_mean, stats.diagnostic.locked);
            var secondProgressRingSrc = getProgressRingForPdf('large', stats.lessons.score_max_mean, stats.diagnostic.locked);
            var thirdProgressRingSrc = getProgressRingForPdf('small', stats.summative.score_max_mean, stats.summative.locked);
            promises.push(createRingImage(firstProgressRingSrc, "3", rowStartX + columnWidth * (index + 2), rowStartY - 2 + verticalDiffBetweenItems * (studentIndex + 1), specialElementHandlers, doc));
            promises.push(createRingImage(secondProgressRingSrc, "5", rowStartX + columnWidth * (index + 2) + 3, rowStartY - 3 + verticalDiffBetweenItems * (studentIndex + 1), specialElementHandlers, doc));
            promises.push(createRingImage(thirdProgressRingSrc, "3", rowStartX + columnWidth * (index + 2) + 3 + 5, rowStartY - 2 + verticalDiffBetweenItems * (studentIndex + 1), specialElementHandlers, doc));
          });
        });
        $q.all(promises).then(function () {
          doc.save(scope.selectedClass.id + "_all" + '.pdf');
        });
      };

      scope.changeSortOrder = function (by, order) {

        if (by === 'FIRST_NAME') {
          scope.sort.by = 'first_name';
        }
        if (by === 'LAST_NAME') {
          scope.sort.by = 'last_name';
        }
        scope.sort.order = order === 'ASC' && scope.sort.prevSortBy === scope.sort.by ? 'DESC' : 'ASC';
        scope.sort.prevSortBy = scope.sort.by;
      };

      scope.customOrder = function () {
        var sortOrder = scope.sort.order === "ASC" ? '-' : '';
        var sortString = (sortOrder || "") + "user.info." + scope.sort.by;
        // $log.log(sortString);

        return sortString;
      };

      scope.getTranslation = function (id) {
        return language.get(id);
      };

      scope.showArchivedStudentsTab = function () {
        if (!scope.removeStudentEditMode) {
          scope.showActiveStudents = false;
          scope.showArchivedStudents = true;
          exitStudentEditForArchiveMode();
        }
      };

      scope.showActiveStudentsTab = function () {
        if (!scope.unArchiveStudentEditMode) {
          scope.showActiveStudents = true;
          scope.showArchivedStudents = false;
          exitStudentEditForArchiveMode();
        }
      };

      var exitStudentEditForArchiveMode = function exitStudentEditForArchiveMode() {
        scope.removeStudentEditMode = false;
        scope.unArchiveStudentEditMode = false;
        scope.showArchiveStudentConfirmModal = false;
        scope.showUnArchiveStudentConfirmModal = false;
      };

      // var exitStudentEditForUnArchiveMode = function(){
      //   scope.unArchiveStudentEditMode = false;
      //   scope.showUnArchiveStudentConfirmModal = false;
      // }

      var archiveStudent = function archiveStudent(student, isArchived) {
        return api.archiveStudent(scope.selectedClass.id, student.user.user_id, isArchived);
      };

      var onConfirmArchiveStudents = function onConfirmArchiveStudents() {
        if (scope.statusChangeStarted) {
          return;
        }

        scope.statusChangeStarted = true;
        var selectedStudents = _.filter(scope.students, function (student) {
          return student.isSelectedForRemoval;
        });

        var archivePromises = [];
        selectedStudents.forEach(function (student) {
          archivePromises.push(archiveStudent(student, true));
        });

        $q.all(archivePromises).then(function () {
          scope.students = _.filter(scope.students, function (student) {
            if (student.isSelectedForRemoval) {
              scope.archivedStudents.push(student);
            }

            return !student.isSelectedForRemoval;
          });
          scope.statusChangeStarted = false;
          exitStudentEditForArchiveMode();
        });
      };

      var onCancelArchiveStudents = function onCancelArchiveStudents() {
        if (scope.statusChangeStarted) {
          return;
        }

        scope.students.forEach(function (student) {
          student.isSelectedForRemoval = false;
        });
        exitStudentEditForArchiveMode();
      };

      var archiveStudents = function archiveStudents() {
        var selectedStudents = _.filter(scope.students, function (student) {
          return student.isSelectedForRemoval;
        });

        if (!selectedStudents || selectedStudents.length === 0) {
          exitStudentEditForArchiveMode();
        } else {
          scope.showArchiveStudentConfirmModal = true;
          // archiveStudent(selectedStudents[0]);
        }
      };

      var unArchiveStudents = function unArchiveStudents() {
        var selectedStudents = _.filter(scope.archivedStudents, function (student) {
          return student.isSelectedForUnarchive;
        });

        if (!selectedStudents || selectedStudents.length === 0) {
          exitStudentEditForArchiveMode();
        } else {
          scope.showUnArchiveStudentConfirmModal = true;
          // archiveStudent(selectedStudents[0]);
        }
      };

      scope.onDoneClicked = function () {
        if (scope.removeStudentEditMode) {
          archiveStudents();
        } else if (scope.unArchiveStudentEditMode) {
          unArchiveStudents();
        }
      };

      // this
      scope.warning_timer_delay = false;
      $timeout(function () {
        scope.warning_timer_delay = true;
      }, 1000);

      // event manager
      var eventManager = new EventManager('teacherStudentsDashboard', scope);

      scope.load_workspace = function (student, module) {
        eventManager.broadcast('dashboard:to:workspace', { student: student, module: module });
      };

      // model
      scope.loadingStatus = {
        done: false,
        failed: false
      };
      scope.refresh = function () {
        init(scope.selectedClass, true);
      };
      scope.getModuleName = function (module) {
        var name = language.get(module.slug);
        if (!name) {
          name = module.slug;
        }
        return name;
      };

      scope.language = language;

      var init = function init(classroom, reset) {
        scope.loadingStatus.done = false;
        scope.loadingStatus.failed = false;
        scope.students = [];
        var trueCondition = true === true;

        $q.all([TeacherDataService.getModuleListFlat(classroom.id).then(function (modules) {
          scope.modules = modules.filter(function (module) {
            return !module.hasSubModules;
          });
          return;
        }), TeacherDataService.getClassStats(classroom.id, true).then(function (studentWork) {
          scope.students = studentWork;
          // if(preliveCheck.isPreliveCheck()){
          TeacherDataService.getArchivedClassStats(classroom.id, true, null, true).then(function (studentWork) {
            scope.archivedStudents = studentWork;
          });
          // }
        })]).then(function () {
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = false;
        }).catch(function () {
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
        });
      };

      var onConfirmUnArchiveStudents = function onConfirmUnArchiveStudents() {
        if (scope.statusChangeStarted) {
          return;
        }

        scope.statusChangeStarted = true;
        var selectedStudents = _.filter(scope.archivedStudents, function (student) {
          return student.isSelectedForUnarchive;
        });

        var unArchivePromises = [];
        selectedStudents.forEach(function (student) {
          unArchivePromises.push(archiveStudent(student, false));
        });

        $q.all(unArchivePromises).then(function () {
          scope.archivedStudents = _.filter(scope.archivedStudents, function (student) {
            if (student.isSelectedForUnarchive) {
              scope.students.push(student);
            }

            return !student.isSelectedForUnarchive;
          });
          scope.statusChangeStarted = false;
          exitStudentEditForArchiveMode();
        });
      };

      var onCancelUnArchiveStudents = function onCancelUnArchiveStudents() {
        if (scope.statusChangeStarted) {
          return;
        }

        scope.archivedStudents.forEach(function (student) {
          student.isSelectedForUnarchive = false;
        });
        exitStudentEditForArchiveMode();
      };

      scope.onConfirmStudentStatusChange = function () {
        if (scope.showArchiveStudentConfirmModal) {
          onConfirmArchiveStudents();
        } else if (scope.showUnArchiveStudentConfirmModal) {
          onConfirmUnArchiveStudents();
        }
      };

      scope.onCancelStudentStatusChange = function () {
        if (scope.showArchiveStudentConfirmModal) {
          onCancelArchiveStudents();
        } else if (scope.showUnArchiveStudentConfirmModal) {
          onCancelUnArchiveStudents();
        }
      };

      TeacherDataService.getUserClasses().then(function (classes) {
        scope.classes = classes;
        scope.$watch('selectedClass', function (classroom) {
          if (classroom) {
            init(classroom);
          }
        });
      });

      //custom filter to order teacher view modules, based on cycle
      scope.customModuleFilter = function (module) {
        var gr78 = ["mtic_gr78_m1", "mtic_gr78_m0", "mtic_gr78_m2", "mtic_gr78_m3", "mtic_gr78_c4_m1", "mtic_gr78_c4_m6"];
        var c4 = ["c4_m1", "c4_m2", "c4_m3", "c4_m4", "c4_m5", "c4_m6"];
        var c3 = ["mtic_c3_m1", "mtic_c3_m3", "run_like_math_addition", "run_like_math_subtraction", "run_like_math_multiplication", "run_like_math_division"];
        if (gr78.indexOf(module.slug) > -1) {
          return gr78.indexOf(module.slug);
        } else if (c3.indexOf(module.slug) > -1) {
          return c3.indexOf(module.slug);
        } else if (c4.indexOf(module.slug) > -1) {
          return c4.indexOf(module.slug);
        }
      };

      scope.show_info_and_scroll = function () {
        scope.show_add_info = true;scope.warning_timer_delay = true;
        $timeout(function () {
          document.getElementById('studentStatsDashboard').scrollTo(0, document.body.scrollHeight);
        }, 100);
      };

      scope.isLuxUser = function () {
        return LocaleService.getCurrentLocale() === 'LUXEMBOURG';
      };
    }

  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsLeaderboardListing', function (language) {
  return {
    template:'<div class="leaderboardCompetition__item"><div ng-if="available" class="leaderboardCompetition__itemBox"><div class="leaderboardCompetition__itemImgWrap"><img ng-src="{{image}}" ng-attr-alt="title" class="leaderboardCompetition__itemImage"></div><div class="leaderboardCompetition__itemTitle" ng-bind="title">Title</div></div><div ng-if="!available" class="leaderboardCompetition__itemBox leaderboardCompetition__itemBox--empty"></div><div class="leaderboardCompetition__itemLink" ng-if="available" ng-click="linkFunc()" ng-bind="getTranslation(\'view_results\')">View Results</div></div>',
    restrict: 'E',
    scope: {
      title: '=',
      image: '=',
      available: '=?',
      linkFunc: '=?'
    },
    link: function link(scope, element) {

      scope.getTranslation = function (id) {
        return language.get(id);
      };
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsItemZoom', function ($log, $q, EventManager, TeacherDataService, Firebase) {
    return {
        template:'<div class="placeholder-pane"><select ng-options="resource as resource.name for resource in data.resources track by resource.id" ng-model="data.selectedResource" ng-change="lookAt()"></select><table class="table"><thead><th>Name</th><th></th></thead><tbody><tr ng-repeat="student in data.students"><td ng-bind="student.display_name"></td><td><div ng-if="data.resourceSummaries[student.user_id]"><teacher-students-item-zoom-render resource-summary="data.resourceSummaries[student.user_id]" resource="data.selectedResource"></teacher-students-item-zoom-render></div><div ng-if="!data.resourceSummaries[student.user_id]">No Work</div></td></tr></tbody></table></div>',
        scope: {
            selectedClass: '='
        },
        link: function link(scope) {
            var eventManager = new EventManager('teacherStudentsItemZoom', scope);
            scope.data = {
                resources: [],
                students: [],
                resourceSummaries: [],
                selectedResource: null
            };
            scope.infoMaps = {
                resources: {}
            };
            scope.loadingStatus = {
                done: false,
                failed: false
            };
            var init = function init(class_id) {
                scope.loadingStatus.done = false;
                scope.loadingStatus.error = false;
                $q.all([TeacherDataService.getClassStudents(class_id).then(function (students) {
                    // $log.log('HERe!!!')
                    scope.data.students = students;
                }), TeacherDataService.getModuleResourceListFlatMap(class_id).then(function (resources) {
                    scope.data.resources = _.toArray(resources);
                    scope.infoMaps.resources = resources;
                })]).then(function () {
                    scope.loadingStatus.done = true;
                    scope.loadingStatus.error = false;
                    scope.data.selectedResource = scope.data.resources[0];
                    loadLogs(class_id);
                }).catch(function (error) {
                    $log.error(error);
                    scope.loadingStatus.done = true;
                    scope.loadingStatus.error = true;
                });
            };
            var loadLogs = function loadLogs(class_id) {
                $log.debug('[[teacherStudentsItemZoom]]', ['resourceSummary', class_id, scope.data.selectedResource.id].join('/'));
                scope.data.resourceSummaries = Firebase.to3wBoundObject(['resourceSummary', class_id, scope.data.selectedResource.id]);
            };
            scope.lookAt = function () {
                $log.debug("[[teacherStudentsItemZoom]] looking at");
                loadLogs(scope.selectedClass.id);
            };
            scope.$watch('selectedClass', function (classroom) {
                if (classroom) {
                    init(classroom.id);
                }
            });
        }
    };
});
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsDashboard', function ($log, $q, language, EventManager, API_CONFIG, PanelFactory, TeacherDataService, $timeout, LocaleService, api, preliveCheck, $interval, userAccount, apiMethods, $http, ModuleFilter, PlatformService, cordovaMessenger, $rootScope, URL_VERSIONS, GenericPopup) {

  return {

    template:'<div class="teacher-students-dashboard"><div class="mtic-resource-loader-container-wrap" ng-hide="loadingStatus.done"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div style="position:absolute; top:0px; bottom:0px; right:0px; left:0px; overflow:auto; background-color: #fff;" id="studentStatsDashboard"><div ng-if="!loadingStatus.done" style="padding:4rem;" class="top-loading" ng-bind="getTranslation(\'27697\')">Loading...</div><div ng-if="loadingStatus.failed" style="padding:4rem;" ng-bind="getTranslation(\'28251\', \'Failed to load data\')">Failed to load data</div><div ng-if="loadingStatus.done && (!students || students.length==0)" style="padding:4rem;" ng-bind="getTranslation(\'27652\')">You don\'t have any students in your class yet!</div><div ng-if="(students && students.length>0)" class="desktop-view"><div ng-switch="filters.perspective"><div ng-switch-when="modules" style="overflow:auto;"><div class="dashboard__modules"><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-fullwidth stickyHeaderTableLeft dashboard__table dashboard__table--modules"><tr class="dashboard__modulesHeaderRow"><th class="dashboard__editStudentCell"></th><th class="dashboard__personNameCell is-clickable" ng-click="changeSortOrder(\'FIRST_NAME\',sort.order)"><span ng-bind="language.get(\'11299\')"></span><sort-icon sort-by="\'first_name\'" sort-by-target="sort.by" sort-by-order="sort.order"></sort-icon></th><th class="dashboard__personNameCell is-clickable" ng-click="changeSortOrder(\'LAST_NAME\',sort.order)"><span ng-bind="language.get(\'11300\')"></span><sort-icon sort-by="\'last_name\'" sort-by-target="sort.by" sort-by-order="sort.order"></sort-icon></th><th class="dashboard__pdfCell"><span ng-bind="language.get(\'30823\')">Student Report</span></th></tr></table><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-hoverable is-fullwidth dashboard__modulesTable dashboard__table dashboard__table--modules"><tr class="dashboard__modulesHeaderRow"><th class="dashboard__editStudentCell"></th><th class="dashboard__personNameCell"></th><th class="dashboard__personNameCell"></th><th class="dashboard__pdfCell"></th></tr><tr ng-repeat="student in students | orderBy:customOrder()" style="height:44px;"><td class="dashboard__editStudentCell"><button class="button is-light is-small" ng-click="startEditStudent(student)"><i class="fa fa-cog" aria-hidden="true"></i></button></td><td class="dashboard__personNameCell" ng-bind="student.user.info.first_name" ng-attr-title="{{ student.user.info.first_name }}"></td><td class="dashboard__personNameCell" ng-bind="student.user.info.last_name" ng-attr-title="{{ student.user.info.last_name }}"></td><td class="dashboard__pdfCell is-clickable" ng-click="pdfModal.open(student)"><i class="fa fa-file-pdf-o dashboard__pdfCellIcon" aria-hidden="true"></i></td></tr></table><div class="scrollTable scrollTable--modules"><div class="box-inner"><div class="fixedNavWrap" ng-style="{\'width\': scrollableWidth + \'px\' }"><div class="scrollTable__nav"><button class="button scrollTable__arrow" ng-touchstart="scrollButtonDown(true)" ng-touchend="scrollButtonUp()" ng-mousedown="scrollButtonDown(true)" ng-mouseup="scrollButtonUp()" ng-click="checkIfIosAndScroll(true)" ng-class="{\'scrollTable__arrow--disabled\': scrollTableAtStartPos}"><i class="fa fa-angle-left" aria-hidden="true"></i></button><div class="scrollTable__navTitle" ng-bind="getTranslation(14569)">Modules</div><button class="button scrollTable__arrow" ng-touchstart="scrollButtonDown(false)" ng-touchend="scrollButtonUp()" ng-mousedown="scrollButtonDown(false)" ng-mouseup="scrollButtonUp()" ng-click="checkIfIosAndScroll()" ng-class="{\'scrollTable__arrow--disabled\': scrollTableAtEndPos}"><i class="fa fa-angle-right" aria-hidden="true"></i></button></div></div><div class="scrollTable__scrollDiv"><div class="scrollTableFixedWrap" ng-style="{\'width\': scrollableWidth + \'px\' }"><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-hoverable is-fullwidth fixedHeaderTable dashboard__table" style="white-space:normal;margin-bottom:0;" ng-init="runScrollTableSetUp()"><thead><tr class="dashboard__modulesHeaderRow" ng-style="{\'height\': agendaTopRowHeight + \'px\'}"><th class="col-module" ng-repeat="module in modules | orderBy:customModuleFilter" ng-attr-title="{{getModuleName(module)}}" style="height:133px"><div><img ng-src="{{getModuleIconAssetUrl(module.slug, meta_mod)}}" width="30px" max-width="30px" height="30px" max-height="30px" style="margin-left:auto;margin-right:auto;display:block;"></div><div class="module-name-container"><div class="module-name"><span ng-bind="getModuleName(module)"></span></div></div></th><th></th></tr></thead></table></div><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-hoverable is-fullwidth dashboard__table" style="white-space:normal;margin-bottom:0;"><tr class="dashboard__modulesHeaderRow dashboard__hiddenCell dashboard__modulesWatchResize"><th class="col-module" ng-repeat="module in modules | orderBy:customModuleFilter" ng-attr-title="{{getModuleName(module)}}" style="height:133px"><div><img ng-src="{{getModuleIconAssetUrl(module.slug, meta_mod)}}" width="30px" max-width="30px" height="30px" max-height="30px" style="margin-left:auto;margin-right:auto;display:block;"></div><div class="module-name-container"><div class="module-name"><span ng-bind="getModuleName(module)"></span></div></div></th><th></th></tr><tr ng-repeat="student in students | orderBy:customOrder()" style="height:44px"><td class="col-module" ng-repeat="module in modules | orderBy:customModuleFilter"><teacher-students-dashboard-cell module="module" stats="student.moduleWorkSummary[module.resource_id].stats" ng-click="load_workspace(student, module)"></teacher-students-dashboard-cell></td><td></td></tr></table></div></div></div></div></div><div ng-switch-when="agenda" ng-class="{\'diagnosticDrillTables\': focusOnDiagnosticMode }" style="display:flex"><div class="dashboard__agenda"><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-hoverable is-fullwidth stickyHeaderTableLeft dashboard__agendaTable dashboard__table"><tr class="dashboard__agendaHeaderRow" ng-style="{\'height\': agendaTopRowHeight + \'px\'}"><th class="dashboard__editStudentCell"></th><th class="dashboard__personNameCell is-clickable" ng-click="changeSortOrder(\'FIRST_NAME\',sort.order)"><span ng-bind="language.get(\'11299\')"></span><sort-icon sort-by="\'first_name\'" sort-by-target="sort.by" sort-by-order="sort.order"></sort-icon></th><th class="dashboard__personNameCell is-clickable" ng-click="changeSortOrder(\'LAST_NAME\',sort.order)"><span ng-bind="language.get(\'11300\')"></span><sort-icon sort-by="\'last_name\'" sort-by-target="sort.by" sort-by-order="sort.order"></sort-icon></th><th class="dashboard__completionPercentageCell">%</th><th class="capitalize dashboard__cumulativeTimeCell" ng-bind="getTranslation(\'28224\')">Time Spent</th></tr></table><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-hoverable is-fullwidth dashboard__agendaTable dashboard__table" style="position:absolute;"><tr class="dashboard__agendaHeaderRow dashboard__hiddenCell" ng-style="{\'height\': agendaTopRowHeight + \'px\'}"><th class="dashboard__editStudentCell"></th><th class="dashboard__personNameCell"></th><th class="dashboard__personNameCell"></th><th class="dashboard__completionPercentageCell">%</th><th class="capitalize dashboard__cumulativeTimeCell">Time Spent</th></tr><tr ng-repeat="student in students | orderBy:customOrder() | filter:studentsAgendaFilter" ng-class="{{\'dboardRow\' + $index}}" style="height:44px"><td class="dashboard__editStudentCell"><button class="button is-light is-small" ng-click="startEditStudent(student)"><i class="fa fa-cog" aria-hidden="true"></i></button></td><td class="dashboard__personNameCell" ng-bind="student.user.info.first_name" ng-attr-title="{{ student.user.info.first_name }}"></td><td class="dashboard__personNameCell" ng-bind="student.user.info.last_name" ng-attr-title="{{ student.user.info.last_name }}"></td><td class="dashboard__completionPercentageCell"><span ng-if="!focusOnDiagnosticMode" ng-bind="decToPerc(agendaData.units[filters.agendaFocus].studentPerformances[student.user.user_id].completionsPerc)" style="color:#66cc66"></span></td><td class="dashboard__cumulativeTimeCell"><span ng-if="!focusOnDiagnosticMode && timeSecToMin(agendaData.units[filters.agendaFocus].studentPerformances[student.user.user_id].time_cummul) > 0"><span ng-bind="timeSecToMin(agendaData.units[filters.agendaFocus].studentPerformances[student.user.user_id].time_cummul)"></span>&nbsp;<span>min</span></span> <span ng-if="focusOnDiagnosticMode && diagnosticData.calculatedValues.time_spent[student.user.user_id]"><span ng-bind="timeSecToMin(diagnosticData.calculatedValues.time_spent[student.user.user_id])"></span>&nbsp;<span>min</span></span></td></tr></table></div><div class="scrollTable scrollTable--agenda"><div class="box-inner"><div class="fixedNavWrap" ng-style="{\'width\': scrollableWidth + \'px\' }"><div class="scrollTable__nav"><button class="button scrollTable__arrow" ng-touchstart="scrollButtonDown(true)" ng-touchend="scrollButtonUp()" ng-mousedown="scrollButtonDown(true)" ng-mouseup="scrollButtonUp()" ng-click="checkIfIosAndScroll(true)" ng-class="{\'scrollTable__arrow--disabled\': scrollTableAtStartPos}"><i class="fa fa-angle-left" aria-hidden="true"></i></button><div class="scrollTable__navTitle" ng-bind="getTranslation(14567)" ng-if="!focusOnDiagnosticMode">Agenda</div><div class="scrollTable__navTitle" ng-bind="getTranslation(focusedResource.slug)" ng-if="focusOnDiagnosticMode">Diagnostic</div><button class="button scrollTable__arrow" ng-touchstart="scrollButtonDown(false)" ng-touchend="scrollButtonUp()" ng-mousedown="scrollButtonDown(false)" ng-mouseup="scrollButtonUp()" ng-click="checkIfIosAndScroll()" ng-class="{\'scrollTable__arrow--disabled\': scrollTableAtEndPos}"><i class="fa fa-angle-right" aria-hidden="true"></i></button></div></div><div class="scrollTable__scrollDiv"><div class="dashboard__agendaTablesRight" ng-if="!focusOnDiagnosticMode"><div class="scrollTableFixedWrap" ng-style="{\'width\': scrollableWidth + \'px\' }"><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-hoverable is-fullwidth fixedHeaderTable" style="white-space:normal;margin-bottom:0;"><tr class="dashboard__agendaHeaderRow" ng-style="{\'height\': agendaTopRowHeight + \'px\'}"><th class="col-module dashboard__editStudentCell is-clickable" ng-repeat="agendaResource in agendaData.units[filters.agendaFocus].resourceRefs" ng-attr-title="{{getName(agendaResource.slug)}}" ng-style="{\'padding-right\': $index === 0 ? \'1px\' : null}" ng-click="focusOnDiagnostic(agendaResource)"><div class="scrollTable__scrollCell"><img ng-repeat="img in getItemImage(agendaResource) track by $index" ng-if="$index === 0" ng-src="https://d3kdl9636cazwt.cloudfront.net/website/image-previews/{{img}}.jpg" onerror="this.style.display=\'none\'"></div><div class="module-name-container"><div class="module-name"><span ng-bind="getName(agendaResource, true)" ng-style="{\'color\': getNameColor(agendaResource)}"></span></div></div></th><th></th></tr><tr style="visibility: collapse;"><td ng-repeat="agendaResource in agendaData.units[filters.agendaFocus].resourceRefs"></td><td></td></tr></table></div><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-hoverable is-fullwidth" style="white-space:normal;margin-bottom:0;"><tr class="dashboard__agendaHeaderRow dashboard__hiddenCell dashboard__agendaWatchResize" ng-style="{\'height\': agendaTopRowHeight + \'px\'}"><th class="col-module dashboard__editStudentCell is-clickable" ng-repeat="agendaResource in agendaData.units[filters.agendaFocus].resourceRefs" ng-attr-title="{{getName(agendaResource.slug)}}" ng-click="focusOnDiagnostic(agendaResource)"><div style="max-width:130px"><img ng-repeat="img in getItemImage(agendaResource) track by $index" ng-if="$index === 0" ng-src="https://d3kdl9636cazwt.cloudfront.net/website/image-previews/{{img}}.jpg" onerror="this.style.display=\'none\'"></div><div class="module-name-container"><div class="module-name"><span ng-bind="getName(agendaResource.slug)"></span></div></div></th><th></th></tr><tr ng-repeat="student in students | orderBy:customOrder() | filter:studentsAgendaFilter" style="height:44px"><td class="col-module scrollTable__scrollCell" ng-repeat="agendaResource in agendaData.units[filters.agendaFocus].resourceRefs"><span class="scrollTable__studentCell"><i ng-show="agendaData.units[filters.agendaFocus].studentPerformances[student.user.user_id].completions[agendaResource.id] && agendaData.units[filters.agendaFocus].studentPerformances[student.user.user_id].scores[agendaResource.id] >= 0.8" class="fa fa-check-circle" aria-hidden="true"></i> <i ng-show="agendaData.units[filters.agendaFocus].studentPerformances[student.user.user_id].completions[agendaResource.id] == false || (agendaData.units[filters.agendaFocus].studentPerformances[student.user.user_id].scores[agendaResource.id] != undefined && agendaData.units[filters.agendaFocus].studentPerformances[student.user.user_id].scores[agendaResource.id] < 0.8)" class="fa fa-exclamation-circle" aria-hidden="true"></i></span></td><td></td></tr></table></div><div class="dashboard__agendaTablesRight" ng-if="focusOnDiagnosticMode"><div class="scrollTableFixedWrap" ng-style="{\'width\': scrollableWidth + \'px\' }"><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-hoverable is-fullwidth fixedHeaderTable" style="white-space:normal;margin-bottom:0;" ng-init="runScrollTableSetUp()"><tr class="dashboard__agendaHeaderRow" ng-style="{\'height\': agendaTopRowHeight + \'px\'}"><th class="col-module dashboard__editStudentCell" ng-repeat="question in diagnosticData.questions track by $index"><div class="drillTable__headingContent"><p class="dashboard__diagnosticQuestionParagraph" ng-bind="getDiagnosticTranslation( question.list[0].question.raw_text, question.list[0].question.question_translation_id )"></p><p class="dashboard__diagnosticExpectedResponse" ng-if="response.question_id === question.list[0].question.question_id" ng-repeat="response in diagnosticData.expectedResponses[question.unique_question_id]" ng-bind="getDiagnosticTranslation( response.raw_text, response.expected_translation_id )"></p></div></th><th></th></tr></table></div><table ng-if="!loadingStatus.error" class="table is-bordered progress-table is-striped is-hoverable is-fullwidth" style="white-space:normal;margin-bottom:0;"><tr class="dashboard__agendaHeaderRow dashboard__hiddenCell dashboard__agendaWatchResize" ng-style="{\'height\': agendaTopRowHeight + \'px\'}"><th class="col-module dashboard__editStudentCell" ng-repeat="question in diagnosticData.questions" ng-attr-title="{{getTranslation(question.list[0].question.question_translation_id)}}"><div class="drillTable__headingContent"><div class="module-name"><span ng-bind="getTranslation(question.list[0].question.question_translation_id)"></span></div></div></th><th></th></tr><tr ng-repeat="student in students | orderBy:customOrder() | filter:studentsAgendaFilter" ng-class="{{\'dboardRow\' + $index}}" style="height:44px"><td class="col-module scrollTable__scrollCell" ng-repeat="question in diagnosticData.questions"><div class="dashboard__tdInner"><span class="dashboard__outdatedQuestionAsterisk" ng-if="::checkIfQuestionOutdated( diagnosticData.responses[student.user.user_id][question.unique_question_id][0].question_id, question.list[0].question.question_id )" ng-attr-title="{{ getDiagnosticTranslation( diagnosticData.questionIdMap[diagnosticData.responses[student.user.user_id][question.unique_question_id][0].question_id].question_translation_id) }}"><i class="fa fa-asterisk" aria-hidden="true"></i></span><div class="dashboard__tdParagraph" ng-repeat="response in diagnosticData.responses[student.user.user_id][question.unique_question_id]" ng-class="{\'colorRed\': !response.is_correct}"><div ng-class="{\'tag\':response.error_code_id, \'is-warning\':response.error_code_id}" ng-click="showResponsePopup(response.error_code_id)" ng-bind="getDiagnosticTranslation( response.raw_text, response.translation_id, true, response.is_correct, response.error_code_id )"></div></div></div></td><td></td></tr></table></div></div></div></div></div></div></div><div ng-if="loadingStatus.done" class="dashboard-bottom-buttons"><div class="agendaArchiveButton button is-light" style="position:absolute; bottom:20px; left:20px;" ng-click="archivedStudents.showModal = true"><span class="icon"><i class="fa fa-trash"></i></span> <span ng-bind="getTranslation(\'27658\')">Removed Students</span></div><button class="button is-success add-students" style="position:absolute; bottom:20px; right:20px;" ng-click="addStudents.showModal = true"><span class="icon"><i class="fa fa-plus" aria-hidden="true"></i></span> <span ng-bind="getTranslation(\'27653\')">Add Students</span></button></div><div ng-class="{\'is-active\' : pdfModal.visible }" ng-if="pdfModal.visible" class="modal mticBulmaModal mticBulmaModal--innerPanels dashboardPdfModal"><div class="modal-card dashboardPdfModal__card"><header class="modal-card-head"><div class="modal-card-title"><span class="agendaBox__headerPretext mticText__blue" ng-bind="getTranslation(\'31674\')">Student Reports</span></div><button class="delete" aria-label="close" ng-click="pdfModal.close()"></button></header><section class="modal-card-body dashboardPdfModal__body" ng-show="pdfModal.loading"><div class="loader" style="margin-top:0px"></div></section><section class="modal-card-body dashboardPdfModal__body" ng-show="!pdfModal.loading"><div class="dashboardPdfModal__leftPanel"><div select-box options="students" model="selected_student" style="position:relative;font-size:12px;width: 200px;margin-top:30px;float:right" filler-text="getTranslation(\'31671\')" display-function="display_students" on-change="on_student_change"></div><div class="dashboardPdfModal__leftPanelBottom"><h2 class="dashboardPdfModal__studentName" ng-bind="selected_student.user.info.first_name+\' \'+selected_student.user.info.last_name">Vitor Constancio</h2><div class="dashboardPdfModal__learningReportButton" ng-click="download_student_pdf()" ng-bind="getTranslation(\'31670\')">Download Student Learning Report</div></div></div><div class="dashboardPdfModal__rightPanel"><table class="dashboardPdfModal__table"><tr class="dashboardPdfModal__row"><th class="dashboardPdfModal__th"><span ng-bind="getTranslation(\'module_translation\')">Module</span></th><th class="dashboardPdfModal__th"><div class="dashboardPdfModal__thInnerDiv"><span ng-bind="getTranslation(27493)">Diagnostic</span></div></th><th class="dashboardPdfModal__th"><div class="dashboardPdfModal__thInnerDiv"><span ng-bind="getTranslation(\'mtic_g78_m5_summative\')">Summative</span></div></th><th class="dashboardPdfModal__th" ng-show="on_qc()"><div class="dashboardPdfModal__thInnerDiv"><span style="width:100%">Formative</span></div></th></tr><tr class="dashboardPdfModal__row" ng-repeat="module in modules | orderBy:customModuleFilter" ng-hide="module.slug.indexOf(\'run_like_math\') > -1"><td class="dashboardPdfModal__td"><span ng-bind="getModuleName(module)"></span></td><td class="dashboardPdfModal__td"><span class="dashboardPdfModal__tdLink" ng-repeat="diag in assessment_availability_map[module.resource_id].diagnostic" ng-show="assessment_availability_map[module.resource_id].diagnostic" ng-click="download_module_pdf(module, true, diag.id)">{{getTranslation(diag.slug)}}<br></span> <span class="dashboardPdfModal__tdLink" style="color:#999 !important" ng-hide="assessment_availability_map[module.resource_id].diagnostic" ng-bind="getTranslation(\'31669\')">Unavailable</span></td><td class="dashboardPdfModal__td"><span class="dashboardPdfModal__tdLink" ng-repeat="summ in assessment_availability_map[module.resource_id].summative" ng-show="assessment_availability_map[module.resource_id].summative" ng-click="download_module_pdf(module, false, summ.id)">{{getTranslation(summ.slug)}}<br></span> <span class="dashboardPdfModal__tdLink" style="color:#999 !important" ng-hide="assessment_availability_map[module.resource_id].summative" ng-bind="getTranslation(\'31669\')">Unavailable</span></td><td class="dashboardPdfModal__td" ng-show="on_qc()"><span class="dashboardPdfModal__tdLink" ng-show="assessment_availability_map[module.resource_id].formative"><div ng-repeat="form_asst in assessment_availability_map[module.resource_id].formative"><span ng-bind="getTranslation(form_asst.slug)" style="color:#333 !important;cursor:default"></span> <span ng-bind="getTranslation(\'31668\')" ng-click="download_module_pdf(module, false, form_asst.id)">Download</span><br><br></div></span> <span class="dashboardPdfModal__tdLink" style="color:#999 !important" ng-hide="assessment_availability_map[module.resource_id].formative" ng-bind="getTranslation(\'31669\')">Unavailable</span></td></tr></table></div></section><footer class="modal-card-foot"></footer></div></div><div ng-if="archivedStudents.showModal" class="modal mticBulmaModal is-active"><div class="modal-background" ng-click="archivedStudents.showModal = false"></div><div class="modal-card"><header class="modal-card-head"><p class="modal-card-title"><span class="agendaBox__headerText" ng-bind="getTranslation(\'27659\')">Restore Students Accounts</span></p><button class="delete" aria-label="close" ng-click="archivedStudents.showModal = false"></button></header><section class="modal-card-body"><table class="table is-hover is-striped"><tr><th class="is-clickable"><span ng-bind="language.get(\'11299\')"></span></th><th class="is-clickable"><span ng-bind="language.get(\'11300\')"></span></th><th></th></tr><tr ng-repeat="student in archivedStudents | orderBy:\'info.last_name\'"><td ng-bind="student.info.first_name"></td><td ng-bind="student.info.last_name"></td><td><button class="button is-dark" ng-click="restoreStudent(student)" ng-class="{\'is-loading\': student.isRestoring}" ng-bind="getTranslation(\'27665\')">Restore</button></td></tr></table></section></div></div><div ng-if="editStudent.showModal" class="modal mticBulmaModal is-active"><div class="modal-background" ng-click="closeEditStudent()"></div><div class="modal-card"><header class="modal-card-head"><p class="modal-card-title"><span class="agendaBox__headerText" ng-bind="getTranslation(\'27660\')">Edit Student Account</span></p><button class="delete" aria-label="close" ng-click="closeEditStudent()"></button></header><section class="modal-card-body"><div>{{getStudenName(editStudent.activeStudent)}}</div><button class="button is-danger is-small" ng-disabled="editStudent.showRemoveConfirmation" ng-click="editStudent.showRemoveConfirmation = true" ng-bind="getTranslation(\'27661\')">Remove from Class</button><br><br>Username: <span style="user-select:text !important;font-weight: bold" ng-bind="editStudent.activeStudent.user.auths[0].uuid"></span><br><button ng-show="!editStudent.updating_password && editStudent.activeStudent.user.auths[0].auth_type===\'localStrategy\'" class="button is-info is-small" ng-click="editStudent.showPasswordreset = !editStudent.showPasswordreset">Change Student Password</button><div ng-show="!editStudent.updating_password && editStudent.showPasswordreset"><input ng-model="editStudent.newPassword"> <button class="button is-success is-small" ng-click="resetStudentPassword(editStudent.activeStudent, editStudent.newPassword)">Submit</button></div><div ng-show="editStudent.show_password_feedback" ng-bind="editStudent.show_password_feedback"></div><div ng-show="editStudent.updating_password">Updating...</div><div style="margin-top:4rem;" ng-show="editStudent.showRemoveConfirmation"><span ng-bind="getTranslation(\'27662\')">Are you sure you want to remove this account from your class?</span><div><button class="button is-danger" ng-click="archiveStudent(editStudent.activeStudent)" ng-disabled="editStudent.activeStudent.isArchiving" ng-bind="getTranslation(\'27663\')">Yes</button> <button class="button" ng-click="editStudent.showRemoveConfirmation = false" ng-bind="getTranslation(\'27664\')">No</button></div></div></section></div></div><div ng-if="addStudents.showModal" class="modal mticBulmaModal is-active"><div class="modal-card"><header class="modal-card-head"><p class="modal-card-title"><span class="agendaBox__headerText" ng-bind="getTranslation(\'27454\')">Adding Students to Your Class</span></p><button class="delete" aria-label="close" ng-click="addStudents.showModal = false"></button></header><section class="modal-card-body"><div ng-if="isLuxUser()" style="margin-top:20px;margin-bottom:15px;font-size: 16px; font-weight: 600;"><span ng-bind="getTranslation(\'14572\')">Once your students are logged on MathemaTIC through IAM, give them this class code to enter and join the class:</span></div><div ng-if="!isLuxUser()" style="margin-top:20px;font-size: 16px; font-weight: 600;text-align: center;"><span>The following class code allows your students to connect to your class</span></div><div style="font-size:20px;text-align: center; color: #FF4D4D; width:100%; text-align: center; margin-top:15px; margin-bottom:30px;">Code: <span class="text-selectable" style="font-weight:900; margin-left:6px;">{{selectedClass.code}}</span></div></section><footer class="modal-card-foot"><button class="button is-warning" ng-click="addStudents.showModal = false" ng-bind="getTranslation(\'27896\')">Got it!</button></footer></div></div><div class="route-path" ng-if="$root.isMTIC"><div class="route-brand">MathemaTIC</div><div class="route-screen" ng-click="resetView()" style="cursor: pointer" ng-bind="getTranslation(\'27651\')">Dashboard</div><div><select ng-model="filters.perspective" ng-change="onFilterPerspectiveChange()"><option value="modules" ng-bind="getTranslation(\'14569\')">Modules</option><option value="agenda" ng-bind="getTranslation(\'27714\')">Agenda</option></select></div><div ng-switch="filters.perspective" ng-if="filters.perspective === \'modules-disabled\' || filters.perspective === \'agenda\'"><div ng-switch-when="modules-disabled"><select ng-model="filters.moduleFocus"><option value="overview">Overview</option><option ng-repeat="module in modules | orderBy:customModuleFilter" ng-value="module.id">{{getModuleName(module)}}</option></select></div><div ng-switch-when="agenda"><div ng-show="!agendaData.data && agendaData.isLoading" ng-bind="getTranslation(\'27697\')">Loading...</div><div ng-show="agendaData.data"><select ng-model="filters.agendaFocus" style="max-width: 250px; min-width: 150px;" ng-show="!focusOnDiagnosticMode"><option ng-repeat="agendaUnit in agendaData.data" ng-if="!agendaUnit.archived" ng-value="agendaUnit.id">{{getName(agendaUnit.description)}}</option></select><div class="route-screen is-clickable" style="margin: 0" ng-click="focusAwayFromDiagnostic()" ng-if="focusOnDiagnosticMode">/ <span ng-bind="getName(currentSelectedAgenda.description)">Agenda Name</span></div></div></div></div><div class="route-screen" ng-if="focusOnDiagnosticMode">/ <span ng-bind="getTranslation(focusedResource.slug)">Diagnostic Name</span></div></div><div class="route-path" ng-if="$root.isOCMT"><div class="route-brand">OCMT-HSE</div></div><div ng-if="false" class="modal" ng-class="{\'is-active\':(pdfGeneration.isGeneratePdfModalVisible)}"><div class="modal-background"></div><div class="modal-card max-width375"><header class="modal-card-head"><p class="modal-card-title text-center font-size-20">Export Student PDF</p></header><section class="modal-card-body"><div><div class="field"><div class="control"><label class="checkbox"><input type="checkbox" ng-model="pdfGeneration.showExportDate"> Show date of export</label></div></div></div></section><footer class="modal-card-foot"><div class="text-center width-100-percent"><button class="button background-color-3398db color-white min-width100" ng-disabled="pdfGeneration.generatingPdf" ng-click="downloadStudentProgressPdf(pdfGeneration.selectedStudent,pdfGeneration.showExportDate)">Generate</button></div></footer></div></div><div class="mobile-view"><div class="dashboard-header"><div class="top-section"><div class="class-name">{{selectedClass.name}}</div><div class="title">DASHBOARD</div></div><div class="header-controls"><div class="sort-by-dropdown"><div class="dropdown-toggle" ng-click="mSortByToggle()"><div class="caption">SORT BY</div><i class="fa fa-chevron-down" aria-hidden="true"></i></div><div class="dropdown-menu" ng-class="{opened: mSortByOpened}"><div class="menu-item" ng-class="{selected: (item.id === mSelectedSortBy)}" ng-repeat="item in mSortByDropItems track by $index" ng-click="mSortStudentsBy(item.id)">{{item.title}}</div></div></div></div></div><div class="dashboard-table"><div class="table-header"><div class="column displayName"><div class="caption">Name</div></div><div class="column module" ng-style="{\'background-image\': \'url(\'+ getModuleIconAssetUrl(mSelectedModule.slug, meta_mod) + \')\'}"><div class="module-dropdown"><div class="dropdown-toggle" ng-click="mModuleToggle()"><div class="caption">{{language.get(mSelectedModule.slug)}}</div><i class="fa fa-chevron-down" aria-hidden="true"></i></div><div class="dropdown-menu" ng-class="{opened: mModuleDropdownOpened}"><div class="menu-item" ng-style="{\'background-image\': \'url(\'+ getModuleIconAssetUrl(module.slug, meta_mod) + \')\'}" ng-class="{selected: (module.slug === mSelectedModule.slug)}" ng-repeat="module in modules track by $index" ng-click="mSelectModule(module)">{{language.get(module.slug)}}</div></div></div></div></div><div class="table-contents"><div class="student" ng-repeat="student in students track by $index"><div class="column displayName" ng-click="mStudentNameClick(student)"><div class="value">{{student.user.display_name}}</div></div><div class="column module"><div ng-if="$root.isOCMT" class="module-charts"><div class="diagnostic"><div ng-class="[\'circle\', mStudentStats[student.user.user_id][mSelectedModule.resource_id].diagnostic.color]"><div class="value">{{mStudentStats[student.user.user_id][mSelectedModule.resource_id].diagnostic.value}}</div></div></div><div class="lessons"><div ng-class="[\'circle\', mStudentStats[student.user.user_id][mSelectedModule.resource_id].lessons.color]"><div class="value">{{mStudentStats[student.user.user_id][mSelectedModule.resource_id].lessons.value}}</div></div></div><div class="summative"><div ng-class="[\'circle\', mStudentStats[student.user.user_id][mSelectedModule.resource_id].summative.color]"><div class="value">{{mStudentStats[student.user.user_id][mSelectedModule.resource_id].summative.value}}</div></div></div></div><teacher-students-dashboard-cell class="teacher-students-dashboard-cell" ng-if="$root.isMTIC" module="mSelectedModule" stats="mStudentStats[student.user.user_id][mSelectedModule.resource_id]"></teacher-students-dashboard-cell></div></div></div></div><div class="student-profile" ng-if="mStudentProfileDisplayed"><div class="profile-header"><div class="student-profile-title">STUDENT PROFILE</div><div class="close-button" ng-click="mCloseStudentProfile()"><i class="fa fa-times" aria-hidden="true"></i></div></div><div class="profile-body"><div class="top-section"><div class="profile-tabs"><div ng-class="[\'profile-tab\', {active: (tab === mActiveStudentProfileTab)}]" ng-repeat="tab in mStudentProfileTabs track by $index" ng-click="mClickStudentProfileTab(tab)">{{tab.label}}</div></div><div class="header-top"><div class="student-dropdown"><div class="dropdown-toggle" ng-click="mStudentToggle()"><div class="caption">{{mSelectedStudent.user.display_name}}</div><i class="fa fa-chevron-down" aria-hidden="true"></i></div><div class="dropdown-menu" ng-class="{opened: mStudentDropdownOpened}"><div class="menu-item" ng-class="{selected: (student === mSelectedStudent)}" ng-repeat="student in students track by $index" ng-click="mSelectStudent(student)">{{student.user.display_name}}</div></div></div></div><div class="last-login">Last Login</div></div><div class="performance-container" ng-if="mActiveStudentProfileTab.id === \'studentPerformance\'"><div class="modules-table"><div class="table-header"><div class="column topics">Topics</div><div class="column performance">Performance</div></div><div class="table-contents"><div class="module" ng-repeat="module in mStudentProfileModules track by $index"><div class="column topics"><img ng-src="{{getModuleIconAssetUrl(module.slug, meta_mod)}}" class="student-module-icon"><div class="value">{{module.name}}</div></div><div class="column performance"><div ng-if="$root.isOCMT" class="module-charts"><div class="module-chart diagnostic"><div ng-class="[\'circle\', mStudentStats[mSelectedStudent.user.user_id][module.resource_id].diagnostic.color]"><div class="value">{{mStudentStats[mSelectedStudent.user.user_id][module.resource_id].diagnostic.value}}</div></div></div><div class="module-chart lessons"><div ng-class="[\'circle\', mStudentStats[mSelectedStudent.user.user_id][module.resource_id].lessons.color]"><div class="value">{{mStudentStats[mSelectedStudent.user.user_id][module.resource_id].lessons.value}}</div></div></div><div class="module-chart summative"><div ng-class="[\'circle\', mStudentStats[mSelectedStudent.user.user_id][module.resource_id].summative.color]"><div class="value">{{mStudentStats[mSelectedStudent.user.user_id][module.resource_id].summative.value}}</div></div></div></div><teacher-students-dashboard-cell class="teacher-students-dashboard-cell" ng-if="$root.isMTIC" module="module" stats="mSelectedStudent.moduleWorkSummary[module.resource_id].stats"></teacher-students-dashboard-cell></div></div></div></div></div><div class="accounts-container" ng-if="mActiveStudentProfileTab.id === \'manageAccounts\'"><div class="data-section"><div class="field username"><div class="label">Username :</div><div class="value">{{mSelectedStudent.user.user_name}}</div></div><div class="field email"><div class="label">Email :</div><div class="value">{{mSelectedStudent.user.info.email}}</div></div><div class="field password"><div class="label">Password :</div><div class="value">*********</div></div></div><div class="controls-section"><div class="control reset-password" ng-click="mOpenResetPassword()"><div class="label">Reset Password</div></div><div class="control transfer-student"><div class="label">Transfer Student</div></div><div class="control delete-student" ng-click="mOpenDeleteStudentDlg()"><div class="label">Delete Student</div></div></div></div></div><div ng-if="mDeleteStudentDlgDisplayed" class="delete-student modal-dialog-container"><div class="mticCard"><div class="mticCard__header"><span class="mticCard__headerText">Delete Student</span> <span class="mticCard__close" ng-click="mCloseDeleteStudentDlg()"><span class="char-icon">&#10006;</span> <i class="fa fa-times-circle" aria-hidden="true"></i></span></div><div class="mticCard__body" ng-class="{processing: mDeletingStudent}"><div class="question">Are you sure you want to remove this account from your class?</div><div class="buttons"><a ng-disabled="mDeletingStudent" class="button delete-btn mticCard__button" ng-click="mDeleteStudent()">Yes</a> <a ng-disabled="mDeletingStudent" class="button cancel-btn mticCard__button" ng-click="mCloseDeleteStudentDlg()">No</a></div><div ng-show="mDeletingStudent">Deleting Student...</div></div></div></div></div><div ng-if="mResetPasswordDisplayed" class="reset-student-password modal-dialog-container"><div class="mticCard"><div class="mticCard__header"><span class="mticCard__headerText">Reset Password</span> <span class="mticCard__close" ng-click="mCloseResetPassword()"><span class="char-icon">&#10006;</span> <i class="fa fa-times-circle" aria-hidden="true"></i></span></div><div class="mticCard__body" ng-class="{processing: mResettingPassword}"><span class="mticCard__enterNewPassword">Enter new password:</span><div class="new-password-section"><input type="password" placeholder="Password:" ng-disabled="mResettingPassword" class="input mticCard__newPasswordInput" ng-model="mNewPassword"><div class="show-hide-password" ng-class="{hidden: mResetPasswordHidden}" ng-click="mShowHidePassword()"></div></div><a ng-disabled="mResettingPassword" class="button mticCard__button" ng-click="mResetStudentPassword(mSelectedStudent, mNewPassword)">Submit</a><div class="processing-text" ng-show="mResettingPassword">Processing...</div></div></div></div></div></div></div>',

    scope: {
      selectedClass: '='
    },
    link: function link(scope, element) {
      scope.isModuleAvailable = function (module) {
        // $log.log('module being checked', module)
        return ModuleFilter.checkAvailable(module);
      };

      scope.isPrelive = function () {
        return preliveCheck.isPreliveCheck();
      };
      scope.archivedStudents = [];
      scope.showActiveStudents = true;
      scope.filters = {};
      var resetFilter = function resetFilter() {
        scope.filters = {
          perspective: 'modules'
        };
      };
      scope.sort = {
        order: 'ASC',
        by: 'first_name',
        prevSortBy: 'first_name'
      };
      scope.editStudent = {
        showModal: false,
        activeStudent: null
      };
      scope.archivedStudents = {
        showModal: false
      };
      scope.addStudents = {
        showModal: false
      };
      scope.pdfGeneration = {
        isGeneratePdfModalVisible: false,
        selectedStudent: {},
        showExportDate: false
      };
      scope.agendaData = {
        isLoading: false,
        isLoaded: false,
        data: null

        // event manager
      };var eventManager = new EventManager('teacherStudentsDashboard', scope);

      scope.closeEditStudent = function () {
        scope.editStudent = {
          showModal: false
        };
      };
      scope.startEditStudent = function (student) {
        scope.editStudent.showModal = true;
        scope.editStudent.activeStudent = student;
        // student.user.user_id
      };

      scope.getStudenName = function (student) {
        return student.user.info.first_name + " " + student.user.info.last_name;
      };

      scope.load_workspace = function (student, module) {
        // $log.log('broadcasting!', student, module )
        eventManager.broadcast('dashboard:to:workspace', { student: student, module: module });
        scope.focusOnDiagnosticMode = false;
      };

      scope.resetStudentPassword = function (student, password) {
        scope.editStudent.updating_password = true;
        scope.editStudent.show_password_feedback = null;
        api.postUserPasswordUpdate(student.user.user_id, password, userAccount.getActiveClassData().id).then(function (resonse) {
          scope.editStudent.newPassword = null;
          scope.editStudent.showPasswordreset = false;
          scope.editStudent.updating_password = false;
          scope.editStudent.show_password_feedback = 'Password has been changed';
        }).catch(function (err) {
          scope.editStudent.newPassword = null;
          scope.editStudent.showPasswordreset = false;
          scope.editStudent.updating_password = false;
          scope.editStudent.show_password_feedback = 'There was an error updating the password';
        });
      };

      eventManager.listen('filters:to:dashboard', function (e, args) {
        scope.focusOnDiagnosticMode = false;
        scope.filters.perspective = args.perspective;
        if (args.agendaFocus) {
          scope.filters.agendaFocus = args.agendaFocus;
          init(scope.selectedClass, true, true);
          //scope.updateAgendaData(true);
        }

        $timeout(function () {
          scope.onDashboardViewChange();
        }, 4000);
      });

      scope.showGeneratePDFModal = function (student) {
        scope.pdfGeneration.isGeneratePdfModalVisible = true;
        scope.pdfGeneration.selectedStudent = student;
      };

      scope.found_img = false;
      scope.agendaTopRowHeight = 136;
      scope.getItemImage = function (item) {
        scope.found_img = scope.found_img || PanelFactory.getItemImage(item) ? true : false;
        scope.agendaTopRowHeight = scope.found_img ? 200 : 136;
        return PanelFactory.getItemImage(item);
      };

      scope.getModuleIconAssetUrl = function (item_slug, item_parent_resource_id) {
        if (scope.meta_mod && scope.meta_mod[0].config && scope.meta_mod[0].config.map_config && scope.meta_mod[0].config.map_config.set_module_icon_names) {
          var asset_name = scope.meta_mod[0].config.map_config.set_module_icon_names[item_slug] || scope.meta_mod[0].config.map_config.set_module_icon_names.default;
          return scope.meta_mod[0].config.map_config.asset_url + asset_name + ".png";
        } else {
          return PanelFactory.getModuleIconAssetUrl(item_slug, item_parent_resource_id);
        }
      };

      var getProgressRingForPdf = function getProgressRingForPdf(size, score, lock) {
        var url = 'https://s3.eu-central-1.amazonaws.com/mtic-items/interface/';
        if (lock) {
          url += 'teachview-ring-' + size + '-locked.png';
        } else {
          var num = score ? Math.min(21, Math.round(21 * score)) : 0;
          if (num === 0) {
            url += 'teachview-ring-' + size + '-blank.png';
          } else {
            if (String(num).length === 1) {
              num = '0' + num;
            }
            url += 'teachview-ring-' + size + '-fill00' + num + '.png';
          }
        }
        return url;
      };

      var createRingImage = function createRingImage(imageSource, imageWidth, imageStartPositionX, imageStartPositionY, specialElementHandlers, doc) {
        var defer = $q.defer();
        var img = document.createElement('img'); //new Image(); // width, height values are optional params
        img.width = imageWidth;
        img.src = imageSource;
        img.style.display = "inline-block";
        img.setAttribute("style", "display : inline");
        var body = document.createElement("body");
        body.appendChild(img);
        doc.fromHTML(body, imageStartPositionX, imageStartPositionY, {
          'width': 10, // max width of content on PDF
          'elementHandlers': specialElementHandlers
        }, function (bla) {
          // $log.log(bla);
          defer.resolve();
        });

        return defer.promise;
      };

      scope.downloadStudentProgressPdf = function (student, shouldShowExportDate) {
        if (scope.pdfGeneration.generatingPdf) {
          return;
        }
        scope.pdfGeneration.generatingPdf = true;
        var name = student.user.info.first_name + " " + student.user.info.last_name;
        var doc = new jsPDF();
        doc.text(20, 20, "Name: " + name);
        doc.text(20, 30, "Class: " + scope.selectedClass.name);
        if (shouldShowExportDate) {
          doc.text(20, 40, "Date of Export: " + moment().format('YYYY-MM-DD'));
        }

        var promises = [];
        angular.forEach(scope.modules, function (each, index) {
          var stats = student.moduleWorkSummary[each.resource_id].stats;
          var specialElementHandlers = {
            '#editor': function editor(element, renderer) {
              return true;
            },
            '.controls': function controls(element, renderer) {
              return true;
            }
          };
          var starty = 60;
          doc.text(20, starty + 10 + index * 20, scope.getModuleName(each));
          var startx = 120;
          var firstProgressRingSrc = getProgressRingForPdf('small', stats.diagnostic.score_max_mean, stats.diagnostic.locked);
          var secondProgressRingSrc = getProgressRingForPdf('large', stats.lessons.score_max_mean, stats.diagnostic.locked);
          var thirdProgressRingSrc = getProgressRingForPdf('small', stats.summative.score_max_mean, stats.summative.locked);
          promises.push(createRingImage(firstProgressRingSrc, "10", startx, starty + 2.5 + index * 20, specialElementHandlers, doc));
          promises.push(createRingImage(secondProgressRingSrc, "15", startx + 10, starty + index * 20, specialElementHandlers, doc));
          promises.push(createRingImage(thirdProgressRingSrc, "10", startx + 10 + 15, starty + 2.5 + index * 20, specialElementHandlers, doc));
        });

        $q.all(promises).then(function () {
          doc.save(scope.selectedClass.id + "_" + student.user.user_id + '.pdf');
          scope.pdfGeneration = {};
        }, function (err) {
          scope.pdfGeneration.generatingPdf = false;
        });
      };

      scope.changeSortOrder = function (by, order) {
        if (by === 'FIRST_NAME') {
          scope.sort.by = 'first_name';
        }
        if (by === 'LAST_NAME') {
          scope.sort.by = 'last_name';
        }
        scope.sort.order = order === 'ASC' && scope.sort.prevSortBy === scope.sort.by ? 'DESC' : 'ASC';
        scope.sort.prevSortBy = scope.sort.by;
      };

      scope.customOrder = function () {
        var sortOrder = scope.sort.order === "ASC" ? '-' : '';
        var sortString = (sortOrder || "") + "user.info." + scope.sort.by;
        // $log.log(sortString);

        return sortString;
      };

      scope.timeSecToMin = function (seconds) {
        if (!seconds || isNaN(seconds)) {
          return 0;
        }
        return Math.max(1, Math.floor(seconds / 60000));
      };

      scope.decToPerc = function (dec) {
        if (dec || dec === 0) {
          return Math.floor(dec * 100) + '%';
        } else {
          return '0%';
        }
      };

      scope.getTranslation = function (id, fallbackText) {
        if (fallbackText) {
          return language.get(id) !== "NA" ? language.get(id) : fallbackText;
        }

        return language.get(id);
      };

      scope.onFilterPerspectiveChange = function () {
        scope.focusOnDiagnosticMode = false;
        // $log.log('onFilterPerspectiveChange', scope.filters.perspective)
        if (scope.filters.perspective === 'agenda') {
          scope.updateAgendaData(true);

          if (!scope.filters.agendaFocus) {
            scope.filters.agendaFocus = 'overview';
          }
          if (scope.currentSelectedAgenda) {
            eventManager.broadcast("teacher:select:dropdown", { "dashboard": "Agenda", "group_id": currentClassroom.id, "agenda_id": scope.currentSelectedAgenda.id });
          }
        } else {
          scope.agendaTopRowHeight = 136;
          eventManager.broadcast("teacher:select:dropdown", { "dashboard": "Modules", "group_id": currentClassroom.id, "resource_id": TeacherDataService.currentActiveMeta.resource_id });
        }
        $timeout(function () {
          scope.onDashboardViewChange();
        }, 66);
      };

      scope.$watch('filters.agendaFocus', function (val) {
        scope.focusOnDiagnosticMode = false;
        if (!val || !scope.agendaData || !scope.agendaData.data) {
          return;
        }
        scope.agendaData.data.forEach(function (agenda) {
          if (agenda.id === val) {
            scope.found_img = false;
            scope.currentSelectedAgenda = agenda;

            $timeout(function () {
              scope.onDashboardViewChange();
              eventManager.broadcast("teacher:select:dropdown", { "dashboard": "Agenda", "group_id": currentClassroom.id, "agenda_id": agenda.id });
            }, 66);
            // $log.log('AGENDA : '  , agenda)
          }
        });
      });
      scope.studentsAgendaFilter = function (student) {
        return scope.filters.agendaFocus === 'overview' || scope.currentSelectedAgenda && (scope.currentSelectedAgenda.is_for_all_class || scope.currentSelectedAgenda.students.indexOf(student.user.user_id) > -1);
      };

      scope.archiveStudent = function (student) {
        student.isArchiving = true;
        api.archiveStudent(scope.selectedClass.id, student.user.user_id, true).then(function () {
          student.isArchived = true;
          student.isRestored = false;
          scope.students = _.filter(scope.students, function (student) {
            return !student.isArchived;
          });
          scope.archivedStudents.push(student.user);
          student.isArchiving = false;
          scope.closeEditStudent();
        });
      };

      scope.restoreStudent = function (student) {
        student.isRestoring = true;
        api.archiveStudent(scope.selectedClass.id, student.user_id, false).then(function () {
          student.isRestored = true;
          student.isArchived = false;
          scope.archivedStudents = _.filter(scope.archivedStudents, function (student) {
            return !student.isArchived;
          });
          scope.students.push(student);
          student.isRestoring = false;
          scope.refresh();
        });
      };

      // TeacherDataService.getUserClasses().then(function(classes){
      //   scope.classes = classes;
      //   scope.$watch('selectedClass', function(classroom){
      //     if (classroom){
      //       // $log.log('selectedClass : ', classroom)
      //       eventManager.broadcast('teacherStudentsAgenda:init', classroom.id);
      //       scope.resetAgendaModalState();
      //       scope.view_controller.reset();
      //     }
      //   });
      // });

      scope.updateAgendaData = function (fromDashboard) {
        // $log.log('updateAgendaData', scope.agendaData.isLoaded, scope.agendaData.isLoading)
        var isClassAgendaInFocus = scope.agendaData.classId === currentClassroom.id;
        var isAgendaLoadingOrLoaded = scope.agendaData.isLoading || scope.agendaData.isLoaded;
        // StudentAgendaItems.i.{resource_id, resource_completed, user_id, resource_timespent}
        if (!(isClassAgendaInFocus && isAgendaLoadingOrLoaded)) {
          scope.agendaData.isLoading = true;
          scope.agendaData.isLoaded = false;
          scope.agendaData.classId = currentClassroom.id;
          scope.agendaData.data = null;
          // $log.log('updateAgendaData id ', currentClassroom.id);
          TeacherDataService.getClassAgendas(currentClassroom.id, true).then(function (res) {
            scope.agendaData.isLoading = false;
            // scope.agendaData.isLoaded = true;
            processAgendaDataForDashboard(res, fromDashboard);
          }).then(function (res) {
            // $log.log('updateAgendaData fail', res)
          });
        }
      };

      function dateOpenSort(a, b) {
        if (a.startTime.getTime() < b.startTime.getTime()) {
          return -1;
        }
        if (a.startTime.getTime() > b.startTime.getTime()) {
          return 1;
        }
        return 0;
      }

      var processAgendaDataForDashboard = function processAgendaDataForDashboard(data, fromDashboard) {
        scope.agendaData.data = data;

        var agendaRef = {};

        data.forEach(function (agenda) {
          agenda.startTime = new Date(agenda.date_open);
          agenda.endTime = new Date(agenda.date_close);
        });

        data = data.sort(dateOpenSort);

        _.each(data, function (agendaData) {
          if (agendaData.description.length > 27) {
            agendaData.description = agendaData.description.slice(0, 27) + "...";
          }

          if (!agendaData.archived) {
            // to do: need to respect order of custom units... although this should be sorted at the time of save
            var resourceRefs = agendaData.resourceRefs;
            if (resourceRefs[0].slug.indexOf('run_like_math') > -1) {
              resourceRefs.sort(function (a, b) {
                return Number(a.slug.split('_')[a.slug.split('_').length - 1]) > Number(b.slug.split('_')[b.slug.split('_').length - 1]) ? 1 : -1;
              });
            }
            var studentPerformances = {};
            if (agendaData.force_redo) {
              _.each(agendaData.StudentAgendaItems, function (perf) {
                var studentPerformance = studentPerformances[perf.user_id];
                if (!studentPerformance) {
                  studentPerformance = studentPerformances[perf.user_id] = {
                    time_cummul: 0,
                    score_cummul: 0,
                    completion_cummul: 0,
                    completions: {},
                    scores: {}
                  };
                }
                // $log.log('checking time  : ', perf.resource_timespent)
                studentPerformance.time_cummul += Math.min(1200000, Math.max(0, perf.resource_timespent));
                studentPerformance.score_cummul += perf.resource_performance;
                if (perf.resource_completed) {
                  studentPerformance.completion_cummul += 1;
                }
                studentPerformance.completions[perf.resource_id] = perf.resource_completed;
                studentPerformance.scores[perf.resource_id] = perf.resource_performance;
                if (resourceRefs) {
                  studentPerformance.completionsPerc = studentPerformance.completion_cummul / resourceRefs.length;
                  studentPerformance.scoresPerc = studentPerformance.score_cummul / resourceRefs.length;
                }
              });
            } else {
              //$log.log('student_completion_map : ', student_completion_map)
              var student_arr = agendaData.students;
              if (agendaData.is_for_all_class) {
                scope.students.forEach(function (std) {
                  student_arr.push(std.user.user_id);
                });
              }
              student_arr.forEach(function (student) {
                var studentPerformance = studentPerformances[student];
                if (!studentPerformance) {
                  studentPerformance = studentPerformances[student] = {
                    time_cummul: 0,
                    score_cummul: 0,
                    completion_cummul: 0,
                    completions: {},
                    scores: {}
                  };
                }
                agendaData.resources.forEach(function (resource) {
                  if (student_completion_map[student] && student_completion_map[student][resource]) {
                    var close_time = new Date(agendaData.date_close).getTime();
                    var resource_time = new Date(student_completion_map[student][resource].time_stamp_last).getTime();
                    //$log.log('COMPARING : ', close_time, resource_time)
                    studentPerformance.completions[resource] = student_completion_map[student][resource].completed && close_time > resource_time;
                    if (studentPerformance.completions[resource]) {
                      studentPerformance.completion_cummul += 1;
                      studentPerformance.time_cummul += Math.min(1200000, Math.max(0, student_completion_map[student][resource].time_spent));
                      studentPerformance.scores[resource] = student_completion_map[student][resource].score;
                      studentPerformance.score_cummul += student_completion_map[student][resource].score;
                    }
                  }
                });
                studentPerformance.completionsPerc = studentPerformance.completion_cummul / agendaData.resources.length;
                studentPerformance.scoresPerc = studentPerformance.score_cummul / agendaData.resources.length;
              });
            }
            agendaRef[agendaData.id] = {
              resourceRefs: resourceRefs,
              studentPerformances: studentPerformances
            };
          }
        });
        scope.agendaData.units = agendaRef;
        if (fromDashboard) {
          scope.agendaData.data.forEach(function (agenda) {
            if (agenda.id === scope.filters.agendaFocus) {
              scope.currentSelectedAgenda = agenda;
            }
          });
        } else {
          if (scope.agendaData.data.length > 0) {
            scope.filters.agendaFocus = scope.agendaData.data[0].id;
          }
        }
      };

      scope.getName = function (slug, full_resource) {
        if (full_resource) {
          if (slug.resource_type === 'custom_resource') {
            return slug.name;
          }
          slug = slug.slug;
        }
        if (slug === 'run_like_math' || slug.indexOf('run_like_math') === -1 || slug.indexOf('lv_') === -1) {
          return language.get(slug);
        } else {
          var splt = slug.split('_');
          var level = '';
          if (!isNaN(splt[splt.length - 1])) {
            level = splt[splt.length - 1];
          }
          var trans_slug = slug.replace('_' + level, '');
          return language.get(trans_slug) + ' ' + level;
        }
        //return language.get(slug);
      };

      var name_color_map = { 'red': '#E04356', 'blue': '#005BF3', 'black': '#3D3D3D' };
      scope.getNameColor = function (resource) {
        if (!resource.display || !resource.display.color) {
          return '#000';
        }
        return name_color_map[resource.display.color];
      };

      // TeacherDataService.getModuleListFlat(classroom.id);
      // TeacherDataService.getClassStats(classroom.id,true);
      // TeacherDataService.getClassAgendas(class_id)

      // this
      scope.warning_timer_delay = false;
      $timeout(function () {
        scope.warning_timer_delay = true;
      }, 1000);

      // model
      scope.loadingStatus = {
        done: false,
        failed: false
      };
      scope.refresh = function () {
        init(scope.selectedClass, true);
      };
      scope.getModuleName = function (module) {
        var name = language.get(module.slug);
        if (!name) {
          name = module.slug;
        }
        return name;
      };

      scope.language = language;
      var student_completion_map;
      var init = function init(classroom, reset, toAgendas) {
        scope.loadingStatus.done = false;
        scope.loadingStatus.failed = false;
        scope.students = [];

        student_completion_map = {};
        api.getClassResourceStates(classroom.id, false, true).then(function (data) {
          data.forEach(function (student_data) {
            student_completion_map[student_data.user_id] = {};
            student_data.User.ClassWorks.forEach(function (work) {
              var res_id = work.WorkBatch.Resource.id;
              if (!student_completion_map[student_data.user_id][res_id]) {
                student_completion_map[student_data.user_id][res_id] = {};
              }
              if (work.WorkBatch.StudentResourceState) {
                student_completion_map[student_data.user_id][res_id].completed = work.WorkBatch.StudentResourceState.complete;
                student_completion_map[student_data.user_id][res_id].time_stamp_last = work.WorkBatch.StudentResourceState.time_stamp_last;
                student_completion_map[student_data.user_id][res_id].time_spent = work.WorkBatch.StudentResourceState.time_spent_total;
                student_completion_map[student_data.user_id][res_id].score = work.WorkBatch.StudentResourceState.score_max;
              } else {
                student_completion_map[student_data.user_id][res_id].completed = false;
                student_completion_map[student_data.user_id][res_id].time_stamp_last = "now()";
                student_completion_map[student_data.user_id][res_id].time_spent = 0;
                student_completion_map[student_data.user_id][res_id].score = 0;
              }
            });
          });
        });
        var trueCondition = true === true;
        $q.all([TeacherDataService.getModuleListFlat(classroom.id).then(function (modules) {
          scope.modules = modules.filter(function (module) {
            return !module.hasSubModules && ModuleFilter.checkAvailable(module);
          });
          scope.meta_mod = modules.filter(function (module) {
            return module.slug.indexOf('_meta') > -1;
          });
          if (!scope.meta_mod || scope.meta_mod.length === 0) {
            scope.meta_mod.push(modules[0]);
          }
          TeacherDataService.currentActiveMeta = scope.meta_mod[0];
          return;
        }), TeacherDataService.getClassStats(classroom.id, true).then(function (studentWork) {
          scope.students = studentWork;

          // $log.log('students in dashboard: ', scope.students);
        }), TeacherDataService.getArchivedStudents(classroom.id).then(function (studentWork) {
          // $log.log('GOT ARCHIVED STUFF : ', studentWork)
          scope.archivedStudents = studentWork;
        })]).then(function () {
          //herE!!!!!!!
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = false;
          scope.runScrollTableSetUp();

          if (toAgendas) {
            scope.updateAgendaData(true);
          }
        })
        // Mobile View
        .then(function () {
          if (window.getComputedStyle(document.querySelector('.mobile-view')).display !== 'none') {
            scope.mStudentStats = getMobileStudentStats();
            scope.modules.splice(0, 0, {
              resource_id: 'overall',
              slug: 'Overall'
            });
            scope.mSelectedModule = scope.modules[0];
            scope.mSortStudentsBy('first_name');

            // Student Profile Modules list
            var sModules = scope.modules.slice(1);
            sortArrayBy(sModules, 'name');
            scope.mStudentProfileModules = sModules;
          }
        }).catch(function () {
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
        });
      };

      /******************************** Mobile View *********************************/

      /****** Setting Dashboard table height *****/
      scope.mEls = scope.mEls || {};
      var unwatch_dashboardTable = scope.$watch(function () {
        if (!PlatformService.isMobile) {
          return false;
        }
        scope.mEls.pageHeader = scope.mEls.pageHeader || document.querySelector('#nav-display-for-certificate');
        scope.mEls.dashboardHeader = scope.mEls.dashboardHeader || document.querySelector('.mobile-view .dashboard-header');
        scope.mEls.dashboardTable = scope.mEls.dashboardTable || document.querySelector('.mobile-view .dashboard-table');
        scope.mEls.footer = scope.mEls.footer || document.querySelector('.dashboard-bottom-buttons');
        return !!(scope.mEls.pageHeader && scope.mEls.dashboardHeader && scope.mEls.dashboardTable && scope.mEls.footer);
      }, function (rendered) {
        if (rendered) {
          setDashboardTableHeight();
          unwatch_dashboardTable();
        }
      });
      function setDashboardTableHeight() {
        var remHeight = 0;
        [scope.mEls.pageHeader, scope.mEls.dashboardHeader, scope.mEls.footer].map(function (el) {
          remHeight += el.getBoundingClientRect().height;
        });
        scope.mEls.dashboardTable.style.height = window.innerHeight - remHeight + 'px';
        mSetDropdownMenuHeight('.mobile-view .dashboard-table', '.module-dropdown');
      }
      window.removeEventListener('resize', mOnResize_dashboardTable);
      window.addEventListener('resize', mOnResize_dashboardTable);
      function mOnResize_dashboardTable() {
        // in case for some reason mobile browser changes visible viewport height (hides address bar etc)
        if (PlatformService.isMobile) {
          setDashboardTableHeight();
          setDashboardTableHeaderHeight();
        }
      }
      /*** End of Setting Dashboard table height ***/

      function getMobileStudentStats() {
        var stats = {};
        scope.students.map(function (student) {
          var studentId = student.user.user_id;
          var studentStats = stats[studentId] = {};
          var totalDiagnostic = 0,
              totalLessons = 0,
              totalSummative = 0;
          scope.modules.map(function (module) {
            var moduleId = module.resource_id;
            var wStats = student.moduleWorkSummary[moduleId].stats,
                diagnostic = Math.round(wStats.diagnostic.score_max_mean * 100),
                lessons = Math.round(wStats.lessons.score_max_mean * 100),
                summative = Math.round(wStats.summative.score_max_mean * 100);
            studentStats[moduleId] = {
              'diagnostic': {
                'value': diagnostic,
                'color': getChartColor(diagnostic),
                'score_max_mean': wStats.diagnostic.score_max_mean
              },
              'lessons': {
                'value': lessons,
                'color': getChartColor(lessons),
                'score_max_mean': wStats.lessons.score_max_mean
              },
              'summative': {
                'value': summative,
                'color': getChartColor(summative),
                'score_max_mean': wStats.summative.score_max_mean
              }
            };
            totalDiagnostic += studentStats[moduleId].diagnostic.value;
            totalLessons += studentStats[moduleId].lessons.value;
            totalSummative += studentStats[moduleId].summative.value;
          });
          var overallDiagnostic = Math.round(totalDiagnostic / scope.modules.length),
              overallLessons = Math.round(totalLessons / scope.modules.length),
              overallSummative = Math.round(totalSummative / scope.modules.length);
          studentStats.overall = {
            'diagnostic': {
              'value': overallDiagnostic,
              'color': getChartColor(overallDiagnostic),
              'score_max_mean': overallDiagnostic / 100
            },
            'lessons': {
              'value': overallLessons,
              'color': getChartColor(overallLessons),
              'score_max_mean': overallLessons / 100
            },
            'summative': {
              'value': overallSummative,
              'color': getChartColor(overallSummative),
              'score_max_mean': overallSummative / 100
            }
          };
        });
        return stats;
      }
      function getChartColor(val) {
        var color = '';
        if (val <= 50) {
          color = 'red';
        } else if (50 < val && val <= 80) {
          color = 'yellow';
        } else {
          color = 'green';
        }
        return color;
      }

      function getUnitValue(str, unit) {
        var index = str.indexOf(unit || 'px');
        return index !== -1 ? str.substring(0, index) : null;
      }

      scope.$watch('mSelectedModule', function (module) {
        setDashboardTableHeaderHeight();
      });

      function setDashboardTableHeaderHeight() {
        /********* Dynamic height for Dashboard table header on phones *************/
        scope.mTableHeaderEl = scope.mTableHeaderEl || document.querySelector('.dashboard-table .table-header');
        var headerStyle = window.getComputedStyle(scope.mTableHeaderEl);
        scope.mModuleCaptionEl = scope.moduleLabelEl || document.querySelector('.module-dropdown .dropdown-toggle .caption');
        var captionStyle = window.getComputedStyle(scope.mModuleCaptionEl),
            headerHeightRatio = PlatformService.isPhonePortrait() ? 1.2 : 1,
            minHeaderHeight_vw = PlatformService.isPhonePortrait() ? 13.8 : 5.5,
            minHeaderHeight = window.innerWidth * minHeaderHeight_vw / 100,
            captionHeight = Number(getUnitValue(captionStyle.height)),
            headerHeight = Number(getUnitValue(headerStyle.height));
        if (captionHeight > minHeaderHeight) {
          scope.mTableHeaderEl.style.height = captionHeight * headerHeightRatio + 'px';
        } else {
          scope.mTableHeaderEl.style.height = minHeaderHeight + 'px';
        }
        /******** End of Dynamic height for Dashboard table header on phones ********/
      }

      /**
       * Calculates height for dropdown menu
       * @param containerSelector Container element to base available height against.
       * @param dropdownSelector Dropdown selector
       * @param pct Percentage of container height to use.
       */
      function mSetDropdownMenuHeight(containerSelector, dropdownSelector, pct) {
        var container = document.querySelector(containerSelector);
        var menu = container.querySelector(dropdownSelector + ' .dropdown-menu');
        var defaultPct = 0.8;
        pct = pct || defaultPct;
        var maxMenuHeight = container.offsetHeight * pct + 'px';
        menu.style['max-height'] = maxMenuHeight;
      }

      scope.mSortByToggle = function () {
        scope.mSortByOpened = !scope.mSortByOpened;
      };
      scope.mSortStudentsBy = function (id) {
        scope.mSelectedSortBy = id;
        scope.mSortByOpened = false;
        scope.students.sort(function (a, b) {
          var va = a.user.info[id],
              vb = b.user.info[id];
          if (va > vb) {
            return 1;
          } else if (va < vb) {
            return -1;
          } else {
            return 0;
          }
        });
        mScrollTopStudents();
      };
      function sortArrayBy(arr, prop, desc) {
        if (!Array.isArray(arr) || !prop) {
          return;
        }
        arr.sort(function (a, b) {
          var va = a[prop],
              vb = b[prop];
          if (desc === true) {
            if (va < vb) {
              return 1;
            } else if (va > vb) {
              return -1;
            } else {
              return 0;
            }
          } else {
            if (va > vb) {
              return 1;
            } else if (va < vb) {
              return -1;
            } else {
              return 0;
            }
          }
        });
      }
      scope.mSelectModule = function (module) {
        scope.mSelectedModule = module;
        scope.mModuleDropdownOpened = false;
        mScrollTopStudents();
      };
      scope.mSelectStudent = function (student) {
        scope.mSelectedStudent = student;
        scope.mStudentDropdownOpened = false;
        if (scope.mActiveStudentProfileTab.id === 'studentPerformance') {
          mScrollTopTopics();
        }
      };
      function mScrollTopStudents() {
        document.querySelector('.dashboard-table .table-contents').scrollTop = 0;
      }
      function mScrollTopTopics() {
        document.querySelector('.performance-container .table-contents').scrollTop = 0;
      }
      scope.mModuleToggle = function () {
        scope.mModuleDropdownOpened = !scope.mModuleDropdownOpened;
      };

      closeOnOutsideClick('mModuleDropdownOpened', '.module-dropdown');
      closeOnOutsideClick('mSortByOpened', '.sort-by-dropdown');
      closeOnOutsideClick('mStudentDropdownOpened', '.student-dropdown');

      /**
       * Registers closing of dropdown when clicked outside of dropdown.
       * @param toggleProperty Scope property which toggles dropdown opened state.
       * @param dropdownSelector Dropdown selector.
       */
      function closeOnOutsideClick(toggleProperty, dropdownSelector) {
        scope.$watch(toggleProperty, function (opened) {
          var handlerName = 'documentClick_close_' + toggleProperty;
          if (opened) {
            document.addEventListener('click', scope[handlerName]);
          } else {
            document.removeEventListener('click', scope[handlerName]);
          }

          scope[handlerName] = scope[handlerName] || function (e) {
            if (!document.querySelector(dropdownSelector).contains(e.target)) {
              // ignore clicks from within dropdown
              e.preventDefault();
              e.stopImmediatePropagation();
              scope.$apply(function () {
                scope[toggleProperty] = false;
              });
            }
          };
        });
      }

      /**
       * Calculate height for specified element to fit the remaining available viewport height on Student Profile modal.
       * @param overflowElName Name used to identify the DOM element in scope.mEls
       * @param overflowElSelector Element selector.
       */
      function setStudentProfileElementHeight(overflowElName, overflowElSelector) {
        scope.mEls = scope.mEls || {};
        var unwatch = scope.$watch(function () {
          if (!PlatformService.isMobile) {
            return false;
          }
          scope.mEls.studentProfileHeader = document.querySelector('.mobile-view .student-profile .profile-header');
          scope.mEls.studentProfileTop = document.querySelector('.mobile-view .student-profile .profile-body .top-section');
          scope.mEls[overflowElName] = document.querySelector(overflowElSelector);
          return !!(scope.mEls.studentProfileHeader && scope.mEls.studentProfileTop && scope.mEls[overflowElName]);
        }, function (rendered) {
          if (rendered) {
            setOverflowElementHeight();
            unwatch(); // Kill the watcher - no need to keep running once the height has been set!!
          }
        });
        function setOverflowElementHeight() {
          var remHeight = 0;
          var bottomPaddingRatio = PlatformService.isPhonePortrait() ? 0.02 : 0.01;
          var bottomPadding = window.innerWidth * bottomPaddingRatio;
          [scope.mEls.studentProfileHeader, scope.mEls.studentProfileTop].map(function (el) {
            remHeight += el ? el.getBoundingClientRect().height : 0;
          });
          scope.mEls[overflowElName].style.height = window.innerHeight - remHeight - bottomPadding + 'px';
        }
        // Recalculate height in case mobile browser changes visible viewport height (shows/hides address bar, or other elements of browser interface)
        window.removeEventListener('resize', mOnResize_overflowElementHeight);
        window.addEventListener('resize', mOnResize_overflowElementHeight);
        function mOnResize_overflowElementHeight() {
          if (PlatformService.isMobile) {
            setOverflowElementHeight();
          }
        }
      }
      function setStudentProfileHeight(tab) {
        tab = tab || scope.mActiveStudentProfileTab;
        if (tab.id === 'studentPerformance') {
          setStudentProfileElementHeight('studentModulesTable', '.mobile-view .student-profile .modules-table');
        } else if (tab.id === 'manageAccounts') {
          setStudentProfileElementHeight('manageAccountsBody', '.mobile-view .student-profile .profile-body .accounts-container');
        }
      }

      scope.mStudentToggle = function () {
        if (!scope.mStudentDropdownOpened) {
          mSetDropdownMenuHeight('.profile-body', '.student-dropdown', 0.7);
        }
        scope.mStudentDropdownOpened = !scope.mStudentDropdownOpened;
      };
      scope.mSortByDropItems = [{
        id: 'first_name',
        title: 'First Name'
      }, {
        id: 'last_name',
        title: 'Last Name'
      }];
      scope.mSortByOpened = false;
      scope.mModuleDropdownOpened = false;
      scope.mStudentDropdownOpened = false;
      scope.mStudentProfileDisplayed = false;
      scope.mResetPasswordDisplayed = false;
      scope.mResetPasswordHidden = true;

      scope.mStudentNameClick = function (student) {
        scope.mOpenStudentProfile(student);
      };
      scope.$watch('mSelectedStudent', function (student) {
        if (scope.mStudentProfileDisplayed) {
          $timeout(function () {
            setStudentProfileHeight();
          }, 100);
        }
      });
      scope.mOpenStudentProfile = function (student) {
        scope.mSelectedStudent = student;
        setStudentProfileHeight(scope.mStudentProfileTabsById.studentPerformance);
        scope.mActiveStudentProfileTab = scope.mStudentProfileTabsById.studentPerformance;
        scope.mStudentProfileDisplayed = true;
      };
      scope.mCloseStudentProfile = function () {
        scope.mStudentProfileDisplayed = false;
      };
      scope.mOpenResetPassword = function (student) {
        scope.mResetPasswordDisplayed = true;
      };
      scope.mCloseResetPassword = function () {
        scope.mResetPasswordDisplayed = false;
      };
      scope.mOpenDeleteStudentDlg = function (student) {
        scope.mDeleteStudentDlgDisplayed = true;
      };
      scope.mCloseDeleteStudentDlg = function () {
        scope.mDeleteStudentDlgDisplayed = false;
      };
      scope.mStudentProfileTabs = [{
        id: 'studentPerformance',
        label: 'Student Performance'
      }, {
        id: 'manageAccounts',
        label: 'Manage Accounts'
      }];
      scope.mStudentProfileTabsById = {};
      scope.mStudentProfileTabs.map(function (tab) {
        scope.mStudentProfileTabsById[tab.id] = tab;
      });
      scope.mActiveStudentProfileTab = scope.mStudentProfileTabsById.studentPerformance;
      scope.mClickStudentProfileTab = function (tab) {
        setStudentProfileHeight(tab);
        scope.mActiveStudentProfileTab = tab;
      };
      scope.mResetStudentPassword = function (student, password) {
        scope.mResettingPassword = true;
        api.postUserPasswordUpdate(student.user.user_id, password, userAccount.getActiveClassData().id).then(function (resonse) {
          scope.mResettingPassword = false;
          scope.mResetPasswordDisplayed = false;
          GenericPopup.open('Reset Password', 'Password has been changed.');
        }).catch(function (err) {
          scope.mResettingPassword = false;
          scope.mResetPasswordDisplayed = false;
          GenericPopup.open('Reset Password', 'There was an error updating the password.');
        });
      };
      scope.mShowHidePassword = function () {
        scope.mResetPasswordHidden = !scope.mResetPasswordHidden;
      };
      scope.$watch('mResetPasswordHidden', function (hidden) {
        if (scope.mResetPasswordDisplayed) {
          var input = document.querySelector('.mticCard__newPasswordInput');
          input.type = hidden ? 'password' : 'text';
        }
      });
      scope.mDeleteStudent = function () {
        var student = scope.mSelectedStudent;
        scope.mDeletingStudent = true;

        api.archiveStudent(scope.selectedClass.id, student.user.user_id, true).then(function (response) {
          student.isArchived = true;
          student.isRestored = false;
          scope.students = _.filter(scope.students, function (student) {
            return !student.isArchived;
          });
          scope.archivedStudents.push(student.user);
          scope.mDeletingStudent = false;
          scope.mDeleteStudentDlgDisplayed = false;
          scope.mStudentProfileDisplayed = false;
          GenericPopup.open('Delete Student', 'Student ' + student.user.display_name + ' has been removed from your class.');
        }).catch(function (err) {
          scope.mDeletingStudent = false;
          scope.mDeleteStudentDlgDisplayed = false;
          GenericPopup.open('Delete Student', 'There was an error while removing the student from your class.');
        });
      };
      /**************************** End of Mobile View ******************************/

      var currentClassroom;

      TeacherDataService.getUserClasses().then(function (classes) {
        scope.classes = classes;
        scope.$watch('selectedClass', function (classroom) {
          // $log.log('selectedClass change')
          if (classroom) {
            currentClassroom = classroom;
            resetFilter();
            init(classroom);
          }
        });
      });

      //custom filter to order teacher view modules, based on cycle
      scope.customModuleFilter = function (module) {
        return module.display && module.display.order ? module.display.order : 0;
      };

      scope.show_info_and_scroll = function () {
        scope.show_add_info = true;scope.warning_timer_delay = true;
        $timeout(function () {
          document.getElementById('studentStatsDashboard').scrollTo(0, document.body.scrollHeight);
        }, 100);
      };

      scope.isLuxUser = function () {
        return LocaleService.getCurrentLocale() === 'LUXEMBOURG';
      };

      scope.resetView = function () {
        eventManager.broadcast('refresh:current:tab');
        resetHorizontalScrollPosition();
        scope.focusOnDiagnosticMode = false;
      };

      // var tableOffset = angular.element(document).find("#table-1").offset().top;
      // var $header = angular.element(document).find("#table-1 > thead").clone();
      // var $fixedHeader = angular.element(document).find("#header-fixed").append($header);

      // angular.element(document).find(window).bind("scroll", function() {
      //   var offset = angular.element(document).find(this).scrollTop();

      //   if (offset >= tableOffset && $fixedHeader.is(":hidden")) {
      //       $fixedHeader.show();
      //   }
      //   else if (offset < tableOffset) {
      //       $fixedHeader.hide();
      //   }
      // });

      eventManager.listen('sidepanel:toggled', function (e, val) {
        scope.scrollableWidth -= val ? 200 : -200;
      });

      var resizeThrottler = function resizeThrottler() {
        var resizeTimeout;
        // ignore resize events as long as an actualResizeHandler execution is in the queue
        if (!resizeTimeout) {
          resizeTimeout = $timeout(function () {
            resizeTimeout = null;
            // actualResizeHandler();
            scope.runScrollTableSetUp();
            // The actualResizeHandler will execute at a rate of 15fps
          }, 66);
        }
      };

      var setResizeEventlistener = function setResizeEventlistener() {
        window.addEventListener("resize", resizeThrottler, false);
      };

      setResizeEventlistener();

      scope.$on('$destroy', function () {
        window.removeEventListener("resize", resizeThrottler, false);
        window.removeEventListener('resize', mOnResize_dashboardTable);
      });

      scope.scrollableWidth = 0;

      scope.getScrollableWidth = function () {
        if (document.querySelector('.box-inner')) {
          scope.scrollableWidth = document.querySelector('.box-inner').clientWidth;
          // $log.log('scope.scrollableWidth', scope.scrollableWidth)
        }
      };

      var stop;
      var started = false;
      var boxInner;
      var scrollWidth;
      var shownWidth;
      var maxScrollableWidth;
      var fixedHeader;
      var scrollButtonHeldDown = false;

      scope.scrollButtonDown = function (leftClick) {
        scrollButtonHeldDown = true;
        scope.leftArrowClick(leftClick);
        window.addEventListener("pointerup", scope.scrollButtonUp, false);
      };
      scope.checkIfIosAndScroll = function (val) {
        if (PlatformService.isIos || PlatformService.isAndroid) {
          scope.leftArrowClick(val, true);
        }
      };

      scope.scrollButtonUp = function () {
        scrollButtonHeldDown = false;
        window.removeEventListener("pointerup", scope.scrollButtonUp, false);
      };

      scope.scrollTableAtStartPos = true;
      scope.scrollTableAtEndPos = true;

      var setButtonStatus = function setButtonStatus() {
        scope.scrollTableAtStartPos = boxInner.scrollLeft === 0;
        scope.scrollTableAtEndPos = boxInner.scrollLeft === maxScrollableWidth;
        // $log.log('boxInner.scrollLeft', boxInner.scrollLeft)
        // $log.log('maxScrollableWidth', maxScrollableWidth)
        // $log.log('scope.scrollTableAtStartPos', scope.scrollTableAtStartPos)
        // $log.log('scope.scrollTableAtEndPos', scope.scrollTableAtEndPos)
      };

      eventManager.listen('sidepanel:toggled', function (e, val) {
        $timeout(function () {
          scope.runScrollTableSetUp();
        }, 500);
      });

      scope.onDashboardViewChange = function () {
        if (boxInner) {
          scope.runScrollTableSetUp();
          resetHorizontalScrollPosition();
        } else {
          $timeout(scope.onDashboardViewChange, 100);
        }
      };

      // for when we want to enable native scrolling through dashboard

      // var setScrollListeners = function(){
      //   boxInner.removeEventListener('scroll', syncScrolls)
      //   boxInner.addEventListener('scroll', syncScrolls)
      // }

      // var syncScrolls = function (){
      //   fixedHeader.scrollLeft = boxInner.scrollLeft;
      // }

      var scrollTableWidthCheckAttempts = 0;

      scope.runScrollTableSetUp = function () {
        boxInner = document.querySelector('.scrollTable__scrollDiv');
        fixedHeader = document.querySelector('.scrollTableFixedWrap');

        if (boxInner) {
          scrollWidth = boxInner.scrollWidth;
          shownWidth = boxInner.clientWidth;
          maxScrollableWidth = scrollWidth - shownWidth;
          setButtonStatus();
        }

        // To get around the elements not being loaded up in time for the check
        if (scrollTableWidthCheckAttempts !== 3 && scrollWidth === shownWidth) {
          scrollTableWidthCheckAttempts++;
          $timeout(function () {
            scope.runScrollTableSetUp();
          }, 200);
        } else {
          scrollTableWidthCheckAttempts = 0;
        }

        scope.getScrollableWidth();
      };

      var resetHorizontalScrollPosition = function resetHorizontalScrollPosition() {
        fixedHeader.scrollLeft = 0;
        boxInner.scrollLeft = 0;
        scope.getScrollableWidth();
        setButtonStatus();
      };

      scope.leftArrowClick = function (leftClick, fast) {
        scope.runScrollTableSetUp();
        var speed = 3;
        var timing = fast ? 240 : 60;

        if (started) {
          return;
        }

        started = true;
        var dir = leftClick ? -1 : 1;

        var timer = 0;
        stop = $interval(function () {
          if (timer >= timing && !scrollButtonHeldDown) {
            $interval.cancel(stop);
            started = false;
            setButtonStatus();
          } else {
            timer += 5;

            fixedHeader.scrollLeft += speed * dir;
            boxInner.scrollLeft += speed * dir;
          }
        }, 5);
      };

      scope.on_student_change = function (new_student) {
        if (new_student !== scope.selected_student) {
          scope.pdfModal.open(new_student);
        }
      };

      scope.on_qc = function () {
        return scope.meta_mod[0].content.has_formatives; //preliveCheck.isQCCheck();
      };

      scope.download_module_pdf = function (mod, is_diag, resource_id) {
        if (pdf_download_disabled) {
          window.alert('The PDF download has been temporarily disabled');
          return;
        }

        var user_data = userAccount.getData();
        var class_data = userAccount.getActiveClassData();
        var headers = apiMethods.getAuthHeaders();
        var pdf_data = {
          "session_key": user_data.sessionKey,
          "student_id": scope.selected_student.user.user_id,
          "teacher_id": user_data.user_id,
          "module_id": "2",
          "diagnostic_assessment_resource_id": resource_id,
          "language": language.getCurrentSelectedLanguage(),
          "group_id": class_data.id,
          "auth_group_id": headers['X-Group-Id'],
          "classroom_name": class_data.name,
          "course_slug": scope.meta_mod[0].name,
          "module_slug": mod.slug,
          "student_name": scope.selected_student.user.info.first_name + " " + scope.selected_student.user.info.last_name,
          "teacher_names": user_data.fullName,
          "timezone": moment.tz.guess()
          // "date_from": "1535774400000",
          // "date_start": "1535601600000"
        };
        var params_path = '';
        for (var key in pdf_data) {
          params_path += key + '=' + encodeURIComponent(pdf_data[key]) + '&';
        }

        var pdfUrl = API_CONFIG.PDF_API + '/report-student-diagnostic?' + params_path + 'apiUrl=' + encodeURIComponent(API_CONFIG.REMOTE_API);
        if (PlatformService.isApp) {
          cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: pdfUrl });
        } else {
          var new_win = window.open(pdfUrl, '_blank');
          new_win.location.hash = '';
        }

        var reportType;

        if (is_diag) {
          reportType = "diagnostic";
        } else {
          reportType = "summative";
        }

        eventManager.broadcast("teacher:download:pdf", { "resource_id": resource_id, "user_id": user_data.user_id, "module_id": TeacherDataService.currentActiveMeta.resource_id, "report": reportType });
      };

      scope.download_student_pdf = function () {
        if (pdf_download_disabled) {
          window.alert('The PDF download has been temporarily disabled');
          return;
        }
        var user_data = userAccount.getData();
        // $log.log('user_data : '  , user_data)
        var class_data = userAccount.getActiveClassData();

        var headers = apiMethods.getAuthHeaders();
        var pdf_data = {
          "session_key": user_data.sessionKey,
          "student_id": scope.selected_student.user.user_id,
          "teacher_id": user_data.user_id,
          "language": language.getCurrentSelectedLanguage(),
          "group_id": class_data.id,
          "auth_group_id": headers['X-Group-Id'],
          "classroom_name": class_data.name,
          "course_slug": scope.meta_mod[0].name,
          "student_name": scope.selected_student.user.info.first_name + " " + scope.selected_student.user.info.last_name,
          "teacher_names": user_data.fullName
        };

        var params_path = '';
        for (var key in pdf_data) {
          params_path += key + '=' + encodeURIComponent(pdf_data[key]) + '&';
        }

        var pdfUrl = API_CONFIG.PDF_API + '/report-student-overall?' + params_path + 'apiUrl=' + encodeURIComponent(API_CONFIG.REMOTE_API);
        if (PlatformService.isApp) {
          cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: pdfUrl });
        } else {
          var new_win = window.open(pdfUrl, '_blank');
          new_win.location.hash = '';
        }

        eventManager.broadcast("teacher:download:pdf", { "user_id": user_data.user_id, "resource_id": TeacherDataService.currentActiveMeta.resource_id, "report": "learning report" });
      };

      scope.display_students = function (student) {
        return student.user.display_name;
      };

      scope.assessment_availability_map = {};
      scope.pdfModal = {
        visible: false,
        loading: false,

        open: function open(student) {
          scope.assessment_availability_map = {};
          this.loading = true;
          scope.selected_student = student;
          this.visible = true;
          TeacherDataService.getPdfAvailability(scope.selected_student.user.user_id, userAccount.getActiveClassData().id).then(function (data) {
            scope.pdfModal.loading = false;
            data.forEach(function (res) {
              //var res = log;
              if (res) {
                if (!scope.assessment_availability_map[res.parent_resource_id]) {
                  scope.assessment_availability_map[res.parent_resource_id] = {};
                }

                if (!scope.assessment_availability_map[res.parent_resource_id][res.config.assessment_type]) {
                  scope.assessment_availability_map[res.parent_resource_id][res.config.assessment_type] = [];
                }
                var add_assessment = true;
                _.each(scope.assessment_availability_map[res.parent_resource_id][res.config.assessment_type], function (assessm) {
                  if (assessm.slug === res.slug && assessm.id === res.id) {
                    add_assessment = false;
                  }
                });
                if (add_assessment) {
                  scope.assessment_availability_map[res.parent_resource_id][res.config.assessment_type].push({ slug: res.slug, id: res.id });
                }
              }
            });

            $log.log('POST PROCESS MAP : ', scope.assessment_availability_map, scope.meta_mod);
          }).catch(function (err) {
            scope.pdfModal.loading = false;
            window.alert('There was an issue retrieving the data, please try again');
            $log.log('err :  ', err);
            scope.pdfModal.visible = false;
          });
        },

        close: function close() {
          this.visible = false;
        }
      };

      scope.focusOnDiagnosticMode = false;
      scope.currentResource = null;

      scope.translations_map = {};
      var trueCond = true;
      var pdf_download_disabled = false; //!LocaleService.checkUrlVersion(URL_VERSIONS.Preview);//false; //
      scope.focusOnDiagnostic = function (resource) {
        $log.log('students', scope.students);
        // $log.log('resource', resource)
        if (resource.resource_type === 'assessment' || trueCond) {
          scope.focusOnDiagnosticMode = true;
          scope.focusedResource = resource;

          // $log.log('resource.id', resource.id)
          // $log.log('userAccount.getActiveClassData().id', userAccount.getActiveClassData().id)
          // $log.log('userAccount.getActiveClassData()', userAccount.getActiveClassData())

          // $log.log('scope.currentSelectedAgenda', scope.currentSelectedAgenda)
          var date_open = scope.currentSelectedAgenda.force_redo ? scope.currentSelectedAgenda.date_open : null;
          var date_close = scope.currentSelectedAgenda.force_redo ? scope.currentSelectedAgenda.date_close : null;

          TeacherDataService.getClassAssessmentData(resource.id, userAccount.getActiveClassData().id, date_open, date_close).then(function (data) {
            // $log.log('data', data)
            prepareDiagnosticDrillData(data);
            //extractTranslationPacks(data);
            var tran_packs = extractTranPackList(data);
            var tran_packs_safe = encodeURIComponent(JSON.stringify(tran_packs));
            // $log.log('EXTRACTED : ' , tran_packs)
            scope.translations_map = {};
            $http.get(API_CONFIG.PDF_API + '/translation-packs?packIds=' + tran_packs_safe + '&apiUrl=' + encodeURIComponent(API_CONFIG.REMOTE_API)).then(function (data) {
              var translations = data.data;
              $log.log('translations : ', translations);
              _.map(translations, function (pack_id, id_key) {
                if (pack_id.elements) {
                  _.map(pack_id.elements, function (val, element_key) {
                    var content = typeof val === 'string' ? JSON.parse(val) : val;
                    scope.translations_map[TRANPACK_PREFIX + id_key + '/' + element_key] = content.text;
                  });
                }
              });
            });
            scope.onDashboardViewChange();

            eventManager.broadcast("teacher:select", { "dashboard": "Agenda", "group_id": currentClassroom.id, "agenda_id": scope.currentSelectedAgenda.id, "resource_id": resource.id });
          });
        }
      };

      scope.focusAwayFromDiagnostic = function () {
        scope.focusOnDiagnosticMode = false;
        scope.onDashboardViewChange();

        eventManager.broadcast("teacher:select:dropdown", { "dashboard": "Agenda", "group_id": currentClassroom.id, "agenda_id": scope.currentSelectedAgenda.id });
      };

      function getFirebaseTranslation(translationCodedText) {
        return translation_regex_matcher(translationCodedText, function (translationId) {
          return scope.translations_map[translationId] && scope.translations_map[translationId][language.getCurrentSelectedLanguage()] ? scope.translations_map[translationId][language.getCurrentSelectedLanguage()].val : translationId;
        });
      }

      var translationPackAggr = [];
      var translation_mapper = {};
      var TRANPACK_PREFIX = 'TRANPACK://';
      var extractTranPackList = function extractTranPackList(asmtPerfData) {
        var aggArrProp = function aggArrProp(arr, prop) {
          if (arr) {
            _.each(arr, function (t) {
              aggTranslationPackId(t[prop]);
            });
          }
        };
        // aggArrProp(asmtPerfData.competencies, 'text'); // maybe not the right thing?
        aggArrProp(asmtPerfData.questions, 'question_translation_id');
        aggArrProp(asmtPerfData.question_response_fields, 'expected_translation_id');
        aggArrProp(asmtPerfData.question_response_fields, 'raw_text');
        for (var student_responses_key in asmtPerfData.question_responses) {
          var responses = asmtPerfData.question_responses[student_responses_key];
          if (responses) {
            aggArrProp(responses, 'translation_id');
            aggArrProp(responses, 'raw_text');
          }
        }
        return translationPackAggr;
      };
      var aggTranslationPackId = function aggTranslationPackId(translationCodedText) {
        if (translationCodedText) {
          translation_regex_matcher(translationCodedText, function (translationId) {
            var path = translationId.substr(TRANPACK_PREFIX.length, translationId.length);
            var pathParts = path.split('/');
            var packId = pathParts[0];
            if (packId && translationPackAggr.indexOf(packId) === -1) {
              translationPackAggr.push(packId);
            }
          });
        }
      };
      var translation_regex_matcher = function translation_regex_matcher(str, iterator) {
        var matched_results = str.match(/(TRANPACK:\/\/[^\s\,]+)/gm);
        if (matched_results && matched_results.length > 0) {
          matched_results.forEach(function (result) {
            var new_str = iterator(result);
            str = str.replace(result, new_str);
          });
        }
        return str;
      };

      scope.diagnosticData = {
        questions: [],
        question_responses: {},
        expectedResponses: {},
        questionIdMap: {},
        calculatedValues: {}
      };

      // var responsez = {};
      scope.questionIdToUnique = {};

      var prepareDiagnosticDrillData = function prepareDiagnosticDrillData(data) {
        scope.diagnosticData = {
          questions: [],
          question_responses: {},
          expectedResponses: {},
          questionIdMap: {},
          calculatedValues: {}
        };
        $log.log('pre data : ', data);
        var questions = {};

        scope.diagnosticData.calculatedValues = data.calculatedValues;

        scope.questionIdToUnique = {};
        _.each(data.questions, function (question) {
          scope.questionIdToUnique[question.question_id] = question.unique_question_id;
        });

        // $log.log('scope.questionIdToUnique', scope.questionIdToUnique)

        _.map(data.question_response_fields, function (response) {
          // $log.log('response', response)
          if (!scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]]) {
            scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]] = [];
          }

          // create array of all responses to the question (all revisions of the question and even all the responses to multi part questions. Filtering in template)
          scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]].push(response);
          scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]] = _.sortBy(scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]], 'question_response_order');
        });

        _.map(data.questions, function (question) {
          scope.diagnosticData.questionIdMap[question.question_id] = question;
        });

        // $log.log('scope.diagnosticData.questionIdMap', scope.diagnosticData.questionIdMap)
        // $log.log(scope.diagnosticData.expectedResponses)


        _.forEach(data.questions, function (a) {
          if (questions[a.unique_question_id]) {
            questions[a.unique_question_id].ids[a.question_id] = a;
          } else {
            questions[a.unique_question_id] = {
              order: a.question_order,
              scene_order: a.scene_order,
              ids: _defineProperty({}, a.question_id, a)
            };
          }
        });

        var questionArr = _.map(questions, function (questionMap, unique_question_id) {
          var questionList = _.map(questionMap.ids, function (question, question_id) {
            return {
              id: parseInt(question_id),
              question: question
            };
          });

          questionList = _.orderBy(questionList, 'id', 'desc');

          return {
            unique_question_id: unique_question_id,
            order: questionMap.order,
            scene_order: questionMap.scene_order,
            list: questionList
          };
        });

        questionArr = _.orderBy(questionArr, ['scene_order', 'order']);
        scope.diagnosticData.questions = questionArr;
        // $log.log('scope.diagnosticData.questions', scope.diagnosticData.questions)

        scope.diagnosticData.responses = {};

        for (var student in data.question_responses) {
          scope.diagnosticData.responses[student] = {};
          for (var i = 0; i < data.question_responses[student].length; i++) {
            var studentID = data.question_responses[student][i];
            var questionsOnpage = scope.diagnosticData.responses[student][scope.questionIdToUnique[studentID.question_id]];
            if (!questionsOnpage) {
              questionsOnpage = [];
            }
            questionsOnpage.push(studentID);

            scope.diagnosticData.responses[student][scope.questionIdToUnique[studentID.question_id]] = _.sortBy(questionsOnpage, 'question_response_order');
          }
        }

        // $log.log('scope.diagnosticData.responses', scope.diagnosticData.responses)
        $log.log('scope.diagnosticData', scope.diagnosticData);
      };

      language.loadTranspacks(['response_error_codes']);

      scope.showResponsePopup = function (error_code_id) {
        if (error_code_id) {
          window.alert(language.get('TRANPACK://response_error_codes/' + error_code_id));
        }
      };

      scope.getDiagnosticTranslation = function (raw_text, translation_id, is_response, is_correct, error_code_id) {
        if (error_code_id) {
          return 'Error Code: ' + error_code_id;
        }
        if (!raw_text && !translation_id && is_response && !is_correct) {
          return '';
        }
        if (raw_text) {
          return getFirebaseTranslation(raw_text);
        } else {
          return getFirebaseTranslation(translation_id);
        }
      };

      scope.checkIfQuestionOutdated = function (answeredID, currentID) {
        if (answeredID) {
          return answeredID !== currentID;
        }
      };
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsClassLeaderboard', function ($log, EventManager, language, $sce, userAccount, DEV_VARIABLES, TeacherDataService, cordovaMessenger, PlatformService) {
  return {
    template:'<style>\n  \n</style><div><iframe class="iframe-cover" ng-src="{{iframeUrl}}"></iframe></div>',
    scope: {
      selectedClass: '='
    },
    link: function link(scope) {

      var eventManager = new EventManager('teacherStudentsClassLeaderboard', scope);

      scope.getTranslation = function (slug) {
        return language.get(slug);
      };
      scope.lang_adjust = function (num) {
        return language.getCurrentSelectedLanguage() === 'en' ? num : num.replace('.', ',');
      };

      var init = function init() {
        $log.log('selectedClass >>> ', scope.selectedClass);
        var lang = language.getCurrentSelectedLanguage();
        var resource_id;
        if (TeacherDataService.currentActiveMeta) {
          resource_id = TeacherDataService.currentActiveMeta.resource_id;
        } else {
          var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));
          resource_id = Number(urlParams.get('module_id'));
        }
        var country = getCountryLeaderboard(scope.selectedClass.country);
        var iframeURl = 'https://demo.mathematic.org/teacher/leaderboards/district/' + country;
        iframeURl += '/foreignClassType/' + getForeignClassType(resource_id);
        iframeURl += '/foreignClassId/' + getForeignClassId();
        iframeURl += '/foreignId/' + getForeignUid();
        iframeURl += '/displayName/' + encodeURIComponent(getDisplayName()) + '/' + lang;

        if (TeacherDataService.getUserSchools().$$state.value.length === 1) {
          if (TeacherDataService.getUserSchools().$$state.value[0].name.toLowerCase().includes('baqa')) {
            scope.is_baqa = true;
          }
        }
        scope.iframeUrl = $sce.trustAsResourceUrl(iframeURl);
      };

      var getForeignClassType = function getForeignClassType(resourceId) {
        var classType = 'no_class'; // default
        $log.log('getForeignClassType', resourceId);
        DEV_VARIABLES.GROUPS.LUXEMBOURG.AVAILABLE_MODULES.forEach(function (moduleCollection) {
          if (moduleCollection.resource_id === resourceId) {
            classType = moduleCollection.foreign_slug;
          }
        });
        return classType;
      };

      var getForeignClassId = function getForeignClassId() {
        return scope.selectedClass.id;
      };

      var getForeignUid = function getForeignUid() {
        return userAccount.getData().user_id;
      };
      var getDisplayName = function getDisplayName() {
        return userAccount.getData().fullName;
      };

      /**
       * Please refer to groups.groupType == 'country' in the db for what country names its expecting
       * If updating this, please update the one in mtic2\src\components\dashboards\student\student-leaderboard\index.js as well :/
       * @param {string} country
       * @returns {string}
       */
      var getCountryLeaderboard = function getCountryLeaderboard(country) {
        var countryLowerCase = (country || '').toLowerCase();
        switch (countryLowerCase) {
          case 'testing':
            return 'testing';
          case 'israel':
            return 'baqa';
          default:
            return 'luxembourg';
        }
      };

      init();
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsAgendaSelectedList', function ($log, language, C4_ASSET_URL, GR78_ASSET_URL, PanelFactory, $timeout, api, EventManager, userAccount, preliveCheck, TeacherDataService, ModuleFilter, PlatformService, $q) {
  return {
    template:'<div class="agendaModListWrap"><ul><li class="agendaModListItem" ng-show="hasSelectedItem(item)" ng-repeat="item in moduleMapCopy" ng-if="item.show && isModuleAvailable(item) && (item.id !== 192 || !isAgendaView)"><div class="agendaModListItem__header agendaLiParent agendaLiParent--topLevel" ng-click="item.showSubMods = !item.showSubMods"><div class="agendaModListItem__headerTextWrap"><label ng-if="!viewController.isStudentView && viewController" class="agendaModListItem__checkBox agendaModListItem__checkBox--topLevel"><input id="{{item.slug}}" type="checkbox" class="mticCheckbox" ng-class="getListItemClass(item)" ng-if="viewController" ng-model="item.is_selected" ng-change="toggleItemSubSelection(item)"> <span ng-click="sendLabelClick(e , item.slug)"></span></label> <span class="agendaModListItem__hederText"><span ng-bind="getName(item.slug)"></span>&nbsp;<i class="agendaModListItem__expandIcon" style="display: inline" ng-class="item.showSubMods ? \'fa fa-caret-down\' : \'fa fa-caret-right\'" aria-hidden="true" ng-show="item.resource_type !== \'custom_resource\' && hasSelectedItem(item)"></i></span></div></div><div ui-tree style="margin-left:40px" ng-show="hasSelectedItem(item)" ng-if="item.display && item.display.panel && item.display.panel.length > 0"><ul ui-tree-nodes ng-model="item.display.panel"><li ui-tree-node class="agendaModListItem" ng-repeat="sub in item.display.panel" ng-if="sub.show && sub.is_selected" ng-class="{\'agendaModListItem--hasChildren\' : item.display.panel.length > 0}"><div ui-tree-handle ng-if="isTeacher && (sub.type === \'custom_resource\' || sub.resource_type === \'custom_resource\')" class="agendaModListItem__subItem"><div class="agendaModListItem__nameWrap"><label ng-mousedown="toggleCustomSelection(sub)" ng-if="!viewController.isStudentView" class="agendaModListItem__checkBox"><input id="{{sub.slug}}" type="checkbox" class="mticCheckbox" ng-class="getListItemClass(sub)" ng-if="viewController" ng-model="sub.is_selected" ng-change="toggleItemSubSelection(sub)"> <span ng-click="sendLabelClick(e , sub.slug)"></span></label><div class="agendaModListItem__checkIconWrap" ng-if="viewController.isStudentView && !viewController.isModulePanelView"><i class="fa agendaModListItem__checkIcon" aria-hidden="true" ng-class="getCheckIconClass(sub)"></i></div><span ng-click="selectChildItem(sub)" style="font-style: italic;" class="agendaLiChild agendaModListItem__customlink" ng-style="{\'opacity\':sub.transparent?\'0.5\':\'1\'}" ng-bind="getTranslation(sub.name)"></span></div></div><div ng-if="!isTeacher || (sub.type !== \'custom_resource\' && sub.resource_type !== \'custom_resource\')"><div class="agendaModListItem__nameWrap"><label ng-if="!viewController.isStudentView" class="agendaModListItem__checkBox"><input id="{{sub.slug}}" type="checkbox" class="mticCheckbox" ng-class="getListItemClass(sub)" ng-if="viewController" ng-model="sub.is_selected" ng-change="toggleItemSubSelection(sub)"> <span ng-click="sendLabelClick(e , sub.slug)"></span></label><div class="agendaModListItem__checkIconWrap" ng-if="viewController.isStudentView && !viewController.isModulePanelView"><i class="fa agendaModListItem__checkIcon" aria-hidden="true" ng-class="getCheckIconClass(sub)"></i></div><span ng-class="sub.sub && sub.sub.length > 0?\'agendaLiParent\':\'agendaLiChild\'" ng-click="sub.showSubs = !sub.showSubs; selectChildItem(sub)" ng-style="{\'opacity\':sub.transparent?\'0.5\':\'1\'}"><span class="agendaLiText" ng-bind="sub.name || getName(sub.slug)"></span>&nbsp; <i style="margin-top:5px" ng-if="(sub.type === \'custom_resource\' || sub.resource_type === \'custom_resource\')" class="fa fa-external-link" aria-hidden="true"></i> <i class="agendaModListItem__expandIcon" ng-if="sub.sub && sub.sub.length > 0" ng-class="sub.showSubs ? \'fa fa-caret-down\' : \'fa fa-caret-right\'" aria-hidden="true"></i></span><div class="agendaModListItem__linkicon" ng-if="(!sub.sub || sub.sub.length == 0) && (sub.show)" ng-click="copyLink(sub)"><i class="fa fa-link" aria-hidden="true"></i></div></div><div ui-tree ng-if="sub.showSubs && sub.sub && sub.sub.length > 0 && (sub.show)" ng-include="\'newmenu.html\'"></div></div></li></ul></div></li></ul></div><script type="text/ng-template" id="newmenu.html"><ul ui-tree-nodes="" class="filteredResourcesSubList" ng-model="sub.sub"> <li ui-tree-node ng-show="sub.show && sub.is_selected" class="agendaModListItem" ng-repeat="sub in sub.sub" ng-class="{\'agendaModListItem--hasChildren\' : sub.sub}"> <div ui-tree-handle ng-if="isTeacher && (sub.type === \'custom_resource\' || sub.resource_type === \'custom_resource\')" class="agendaModListItem__subItem"> <div class="agendaModListItem__nameWrap"> <label ng-mousedown="toggleCustomSelection(sub)" ng-if="!viewController.isStudentView" class="agendaModListItem__checkBox"> <input id="{{sub.slug}}" type="checkbox" class="mticCheckbox" ng-if="viewController" ng-model="sub.is_selected" ng-change="toggleItemSubSelection(sub)"> <span ng-click="sendLabelClick(e , sub.slug)"></span> </label> <div class="agendaModListItem__checkIconWrap" ng-if="viewController.isStudentView && !viewController.isModulePanelView"> <i class="fa agendaModListItem__checkIcon" aria-hidden="true" ng-class="getCheckIconClass(sub)"></i> </div> <span class="agendaModListItem__customlink" ng-style="{\'opacity\':sub.transparent?\'0.5\':\'1\'}" ng-click="sub.showSubs = !sub.showSubs;selectChildItem(sub, true)" ng-class="sub.sub && sub.sub.length > 0?\'agendaLiParent\':\'agendaLiChild\'" ng-bind="getTranslation(sub.name)"></span> </div> </div> <div ng-if="!isTeacher || (sub.type !== \'custom_resource\' && sub.resource_type !== \'custom_resource\')" class="agendaModListItem__subItem"> <div class="agendaModListItem__nameWrap"> <label style="align-self: center" ng-if="!viewController.isStudentView" class="agendaModListItem__checkBox"> <input id="{{sub.slug}}" type="checkbox" class="mticCheckbox" ng-class="getListItemClass(sub)" ng-if="viewController" ng-model="sub.is_selected" ng-change="toggleItemSubSelection(sub)"> <span ng-click="sendLabelClick(e , sub.slug)"></span> </label> <div class="agendaModListItem__checkIconWrap" ng-if="viewController.isStudentView && !viewController.isModulePanelView"> <i class="fa agendaModListItem__checkIcon" aria-hidden="true" ng-class="getCheckIconClass(sub)"></i> </div> <span style="align-self: center" ng-class="sub.sub && sub.sub.length > 0?\'agendaLiParent\':\'agendaLiChild\'" ng-click="sub.showSubs = !sub.showSubs; selectChildItem(sub)" ng-style="{\'opacity\':sub.transparent?\'0.5\':\'1\'}"> <span ng-bind="sub.name || getName(sub.slug)"></span>&nbsp; <i style="margin-top:5px" ng-if="(sub.type === \'custom_resource\' || sub.resource_type === \'custom_resource\')" class="fa fa-external-link" aria-hidden="true"></i> <i class="agendaModListItem__expandIcon" ng-if="sub.sub && sub.sub.length > 0" ng-class="sub.showSubs ? \'fa fa-caret-down\' : \'fa fa-caret-right\'" aria-hidden="true"></i> </span> <div class="agendaModListItem__linkicon" ng-if="(!sub.sub || sub.sub.length == 0) && (sub.show)" ng-click="copyLink(sub)"><i class="fa fa-link" aria-hidden="true"></i></div> </div> <div ng-if="sub.showSubs && sub.sub && sub.sub.length > 0 && (sub.show)" ng-include="\'newmenu.html\'"></div> </div> </li> </ul></script>',
    scope: {
      agendaData: '<',
      studentsList: '<',
      moduleMap: '<',
      dontCollapse: '=?',
      viewController: '=?',
      classId: '=?',
      agendaProgressMap: '=?',
      dontSelect: '<',
      unlockPath: '<',
      moduleMapCopy: '=?'
    },
    link: function link(scope, element) {
      scope.isAgendaView = TeacherDataService.inTeacherAgendaView;
      scope.getTranslation = function (slug) {
        return language.get(slug);
      };

      scope.isModuleAvailable = function (module) {
        // $log.log('module being checked', module)
        if (module.parent_resource_id !== 192) {
          return ModuleFilter.checkAvailable(module);
        } else {
          return false;
        }
      };
      var eventManager = new EventManager('teacherStudentsAgendaSelectedList', scope);
      scope.isQC = preliveCheck.isQCCheck();
      scope.isPrelive = preliveCheck.isPreliveCheck();
      scope.isTeacher = userAccount.getData().role.isTeacher;
      // $log.log('AGENDA DATA : ', scope.moduleMap)
      // var structured = scope.structured = {};
      var target_students;
      var student_count;

      // scope.getName = function(slug){
      //   // var modified = slug.split(':')[1];
      //   // modified = modified ? modified.trim() : slug;
      //   return language.get(slug);
      // }

      scope.getModuleIconAssetUrl = function (item) {
        if (scope.moduleMap && scope.moduleMap.meta_config && scope.moduleMap.meta_config.map_config && scope.moduleMap.meta_config.map_config.set_module_icon_names) {
          var asset_name = scope.moduleMap.meta_config.map_config.set_module_icon_names[item.slug] || scope.moduleMap.meta_config.map_config.set_module_icon_names.default;
          return scope.moduleMap.meta_config.map_config.asset_url + asset_name + ".png";
        }
        if (item.config.map_config && item.config.map_config.asset_url) {
          return item.config.map_config.asset_url + item.slug + '.png';
        }
        return PanelFactory.getModuleIconAssetUrl(item.slug);
      };

      function displayOrderSort(a, b) {
        if (!a.display || !b.display) {
          return 0;
        }
        if (a.display.order < b.display.order) {
          return -1;
        }
        if (a.display.order > b.display.order) {
          return 1;
        }
        return 0;
      }

      var loading_items;
      var loaded_preticked;
      function resetView(dontOverwrite, keepSelections) {
        if (!scope.moduleMap || loading_items) {
          return;
        }
        loading_items = true;
        scope.moduleMap.resources = scope.moduleMap.resources.sort(displayOrderSort);

        scope.asset_url = scope.moduleMap.resources && scope.moduleMap.resources[0].parent_resource_id === 99 ? GR78_ASSET_URL : C4_ASSET_URL;

        scope.inFilteredView = true;
        if (!dontOverwrite) {
          if (!scope.moduleMapCopy) {
            scope.moduleMapCopy = angular.copy(scope.moduleMap.resources);
          }
          scope.moduleMapCopy.forEach(function (sub_mod) {
            sub_mod.show = false;
            sub_mod.transparent = false;
            sub_mod.display.panel.forEach(function (sub_sub) {
              reset_shown(sub_sub);
            });
          });
          //scope.moduleMapCopy = angular.copy(scope.moduleMap.resources);
          //scope.moduleMapCopy = applySelections(temp, )
          scope.moduleMapCopy.forEach(function (sub_mod) {
            var indx = 0;
            sub_mod.children.forEach(function (item) {
              if (_.get(item, ['config', 'exclude'])) {
                sub_mod.children.splice(indx, 1);
                removePanelItem(sub_mod.slug + ': ' + item.slug);
              }
              indx++;
            });
          });
        }
        scope.moduleMapCopy.forEach(function (sub_mod) {
          if (sub_mod.display && sub_mod.display.panel) {
            sub_mod.display.panel.forEach(function (sub) {
              var sub_info = getPath(sub, sub_mod, dontOverwrite);
              var match = getRegMatch(sub_mod.slug); //!scope.filteredView ? true : (scope.getName(sub_mod.slug).toLowerCase()).match((scope.filteredView).toLowerCase()) &&  (scope.getName(sub_mod.slug).toLowerCase()).match((scope.filteredView).toLowerCase()).length > 0;
              sub_mod.show = sub_mod.show || sub_info.show || match;
              sub.show = sub.show || match;
            });
          }
        });
        if (scope.viewController && scope.viewController.preticked_items && !loaded_preticked) {
          loaded_preticked = true;
          // $log.log('preticked_items : ' , scope.viewController.preticked_items)
          scope.viewController.selectItemsFromId(scope.viewController.preticked_items);
          $timeout(function () {
            eventManager.broadcast('highlight:map:items', scope.viewController.preticked_items);
            loading_items = false;
          }, 250);
        } else {
          loading_items = false;
        }
        //  $log.log('sub mod info : ', scope.moduleMapCopy)
      }

      eventManager.listen('tick:module', function (e, slug) {
        scope.moduleMapCopy.forEach(function (mod) {
          if (mod.slug === slug) {
            // $log.log('got tick module : ', mod);
            mod.is_selected = true;
            scope.toggleItemSubSelection(mod, true);
          }
        });
      });

      scope.copyLink = function (sub) {
        scope.selectChildItem(sub);
        scope.viewController.copyItemLink();
      };

      function reset_shown(sub) {
        sub.show = false;
        sub.transparent = false;
        if (sub.sub) {
          sub.sub.forEach(function (sub_sub) {
            reset_shown(sub_sub);
          });
        }
      }

      // var loading = false;
      // eventManager.listen('done:creating:items', function(){
      //   if(loading){
      //     return;
      //   }
      //   loading = true;
      //   // $timeout(function(){
      //     loading = false;
      //     if(scope.viewController && scope.viewController.preticked_items){
      //       $log.log('preticked_items : ' , scope.viewController.preticked_items)
      //       scope.viewController.selectItemsFromId(scope.viewController.preticked_items);
      //     }
      //   // }, 1500)
      // })

      function removePanelItem(slug, parent) {
        var indx = 0;
        if (parent) {
          parent.forEach(function (child) {
            if (child.sub) {
              removePanelItem(slug, child.sub);
            } else if (child.slug === slug) {
              parent.splice(indx, 1);
            }
            indx++;
          });
          return;
        }
        scope.moduleMapCopy.forEach(function (sub_mod) {
          if (sub_mod.display && sub_mod.display.panel) {
            indx = 0;
            sub_mod.display.panel.forEach(function (sub) {
              if (sub.sub) {
                removePanelItem(slug, sub.sub);
              } else if (sub.slug === slug) {
                sub_mod.splice(indx, 1);
              }
              indx++;
            });
          }
        });
      }

      scope.hasSelectedItem = function (item) {
        if (item.sub) {
          var has_selected_child = false;
          item.sub.forEach(function (child) {
            if (child.sub) {
              child.sub.forEach(function (subchild) {
                has_selected_child = has_selected_child || subchild.is_selected;
              });
            } else {
              has_selected_child = has_selected_child || child.is_selected;
            }
          });

          return has_selected_child;
        } else {
          return item.is_selected;
        }
      };

      function getPath(sub, parent, resetTransparent) {
        if (sub.sub) {
          var sub_count = 0;
          sub.sub.forEach(function (sub_sub) {
            var sub_info = getPath(sub_sub, sub, resetTransparent);
            sub.show = sub.show || sub_info.show;
          });
        } else {
          sub.show = getItemFromSlug(sub.slug).is_selected;
        }
        var item_info = { show: sub.show };
        return item_info;
      }

      function hasVisibleSibling(parent) {
        var found = false;
        parent.forEach(function (child) {
          found = found || getRegMatch(child.slug); //(scope.getName(child.slug).toLowerCase()).match((scope.filteredView).toLowerCase()) &&  (scope.getName(child.slug).toLowerCase()).match((scope.filteredView).toLowerCase()).length > 0;
        });
        return found;
      }

      function getResourceIdFromSlug(slug) {
        // if(slug.indexOf(':') > -1){
        //   slug = slug.split(':')[1].trim();
        // }
        var id;
        for (var i = 0; i < scope.moduleMap.resources.length; i++) {
          var sub_mod = scope.moduleMap.resources[i].children;
          for (var j = 0; j < sub_mod.length; j++) {
            var resource = sub_mod[j];
            if (resource.children) {
              for (var k = 0; k < resource.children.length; k++) {
                var sub_resource = resource.children[k];
                if (sub_resource.slug === slug) {
                  return sub_resource.id;
                }
              }
            }
            if (resource.slug === slug) {
              return resource.id;
            }
          }
        }
        return false;
      }

      function getItemSlugFromId(resource_id) {
        var found_slug;
        scope.moduleMap.resources.forEach(function (sub_mod) {
          sub_mod.children.forEach(function (resource) {
            if (resource && resource.id === resource_id) {
              // $log.log('slug found : ', resource)
              found_slug = resource.slug;
            }
          });
        });
        return found_slug;
      }

      scope.$watch('agendaData', function () {
        resetView();
      });
      scope.$watch('studentsList', function () {
        resetView();
      });
      scope.$watch('moduleMap', function () {
        resetView();
      });

      scope.$watch('filteredView', function (new_val, old_val) {
        // $log.log('filter : ', old_val, new_val)
        if (old_val && old_val !== '' && new_val === '') {
          resetView(true, true);
          return;
        }
        resetView(false, true);
      });

      scope.$watch('filteredResources', function (val) {
        resetView();
      });

      var last_selected;
      scope.$watch('unlockPath', function (val) {
        if (val === false) {
          eventManager.broadcast('highlight:path', { slug: '', clear: true });
        } else if (val && last_selected && last_selected.is_selected) {
          eventManager.broadcast('highlight:path', { slug: last_selected.slug, clear: false });
        }
      });

      scope.selectItem = function (item, select, dontSelect, triggerSelection) {
        if (!item.sub && scope.inFilteredView && scope.viewController) {
          scope.viewController.highlightedItem = item;
          item.is_selected = triggerSelection ? !item.is_selected : item.is_selected;
          item.show = true;
          last_selected = item.is_selected ? item : '';
          if (scope.unlockPath) {
            eventManager.broadcast('highlight:path', { slug: item.slug, clear: false });
          }
          if (dontSelect) {
            return;
          }
          $timeout(function () {
            eventManager.broadcast('module:select:resource', { slug: item.slug, dontSelect: true, state: item.is_selected });
          }, 500);
          // $log.log('highlight this : ' , scope.viewController.highlightedItem, dontSelect)
        } else if (item.sub) {
          // $log.log('parent click : ' , item)
          item.is_selected = !item.is_selected;
        }
      };

      var cached_items = [];
      if (scope.viewController) {
        scope.viewController.selectItemBySlug = function (slug, select, dontSelect, triggerSelection) {
          scope.moduleMapCopy.forEach(function (sub_mod) {
            if (sub_mod.display && sub_mod.display.panel) {
              findAndHighlight(sub_mod.display.panel, slug, select, dontSelect, triggerSelection);
            }
          });
        };
        scope.viewController.getSelectedItems = function () {
          var selected = [];
          scope.moduleMapCopy.forEach(function (sub_mod) {
            if (sub_mod.display && sub_mod.display.panel) {
              if (Array.isArray(sub_mod.display.panel)) {
                var i = 0;
                sub_mod.display.panel.forEach(function (child) {
                  getSelected(child, selected, sub_mod.slug, i);
                  i++;
                });
              }
            }
          });
          // $log.log('GET SELECTED ITEMS : ', scope.moduleMapCopy)
          return selected;
        };
        eventManager.listen('agenda:request:selected', function () {
          eventManager.broadcast('agenda:respond:selected', scope.viewController.getSelectedItems());
        });
        scope.viewController.selectItemsFromId = function (item_arr) {
          $log.log('got resources : ', scope.viewController.cached_items, item_arr);
          if (scope.viewController.cached_items && scope.viewController.cached_items.length > 0) {
            //item_arr = scope.viewController.cached_items;
            scope.viewController.cached_items.forEach(function (item) {
              if (item.type === 'custom_resource') {
                item.content.position_data = {
                  parent_slug: item.parent_slug,
                  index: item.item_index
                };
                placeCustomInMap(item);
              }
            });
          }
          var custom_arr = [];
          item_arr.forEach(function (item_id) {
            var slug = getItemSlugFromId(item_id);
            if (slug) {
              // $log.log('tick this : ', slug, item_id);
              scope.viewController.selectItemBySlug(slug, true, false, true);
            } else if (scope.classId && typeof item_id === 'number') {
              var resource;

              custom_arr.push(api.getCustomResource(scope.classId, item_id));
              // .then(function(resources) {
              //   // $log.log('custom resources : ', resources)
              //   if(resources){
              //     custom_arr.push(resources[0])
              //     // placeCustomInMap(resources[0]);
              //   }
              // })
            }
          });
          $q.all(custom_arr).then(function (results) {
            var custom_resources_map = {};
            results.forEach(function (resources) {
              if (resources) {
                if (!custom_resources_map[resources[0].content.position_data.parent_slug]) {
                  custom_resources_map[resources[0].content.position_data.parent_slug] = [];
                }
                custom_resources_map[resources[0].content.position_data.parent_slug].push(resources[0]);
              }
            });
            for (var key in custom_resources_map) {
              if (custom_resources_map[key]) {
                custom_resources_map[key].sort(sorter);
              }
            }
            for (var el in custom_resources_map) {
              if (custom_resources_map[el]) {
                placeAllInMap(custom_resources_map[el]);
              }
            }
            $log.log('sorted : ', custom_resources_map);
          });
        };
      }

      function placeAllInMap(list) {
        list.forEach(function (resource) {
          placeCustomInMap(resource);
        });
      }

      function sorter(a, b) {
        var indx1 = Number(a.content.position_data.index);
        var indx2 = Number(b.content.position_data.index);
        if (indx1 < indx2) {
          return -1;
        }
        if (indx1 > indx2) {
          return 1;
        }
        return 0;
      }

      var placeCustomInMap = function placeCustomInMap(resource) {

        var parent_slug = resource.content.position_data.parent_slug;
        var index = Number(resource.content.position_data.index);
        if (parent_slug === scope.moduleMap.slug) {
          scope.moduleMapCopy.splice(index, 0, resource);
          return;
        }
        $log.log('place custom :  ', parent_slug, index, scope.moduleMap.slug);
        scope.moduleMapCopy.forEach(function (sub_mod) {
          if (sub_mod.display && sub_mod.display.panel) {
            if (sub_mod.slug === parent_slug) {
              sub_mod.display.panel.splice(index, 0, resource);
              resource.show = true;
              resource.is_selected = true;
              return;
            } else {
              sub_mod.display.panel.forEach(function (sub) {
                checkResourceAndInsert(sub, resource);
              });
            }
          }
        });
      };
      var checkResourceAndInsert = function checkResourceAndInsert(sub, resource) {
        if (sub.sub) {
          if (sub.slug === resource.content.position_data.parent_slug && (sub.sub.length <= Number(resource.content.position_data.index) || sub.sub[Number(resource.content.position_data.index)].slug !== resource.slug)) {
            sub.sub.splice(Number(resource.content.position_data.index), 0, resource);
            resource.show = true;
            resource.is_selected = true;
          } else {
            sub.sub.forEach(function (sub_sub) {
              checkResourceAndInsert(sub_sub, resource);
            });
          }
        }
      };
      function findAndHighlight(sub, slug, select, dontSelect, triggerSelection) {
        if (sub.slug === slug) {
          scope.selectItem(sub, select, dontSelect, triggerSelection);
        } else if (sub.sub) {
          sub.sub.forEach(function (sub_child) {
            findAndHighlight(sub_child, slug, select, dontSelect, triggerSelection);
          });
        } else if (Array.isArray(sub)) {
          sub.forEach(function (sub_child) {
            findAndHighlight(sub_child, slug, select, dontSelect, triggerSelection);
          });
        }
      }

      function getSelected(sub, arr, parent, index) {
        if (!sub.sub && sub.is_selected) {
          sub.parent_slug = parent;
          sub.item_index = index;
          arr.push(sub);
        } else if (sub.sub) {
          var i = 0;
          sub.sub.forEach(function (sub_child) {
            getSelected(sub_child, arr, sub.slug, i);
            i++;
          });
        }
      }

      scope.selectParent = function (item) {
        item.is_selected = !item.is_selected;
        // $log.log('FROM SELECT PARENT : ' , item)
      };

      scope.toggleItemSubSelection = function (item, parent_selection) {
        if (scope.viewController.isStudentView) {
          // $log.log('toggle student view : ' , item)
          return;
        }
        // $log.log('toggleItemSubSelection ?', item, parent_selection)
        // $timeout(function(){
        if (item.sub) {
          item.sub.forEach(function (child) {
            if (child.sub) {
              child.is_selected = item.is_selected;
            }
            scope.toggleItemSubSelection(child, item.is_selected);
          });

          eventManager.broadcast('highlight:path', { slug: '', clear: true });
        } else if (item.display && item.display.panel) {
          item.display.panel.forEach(function (child) {
            if (child.sub) {
              child.is_selected = item.is_selected;
            }
            scope.toggleItemSubSelection(child, item.is_selected);
          });
        } else {
          // $log.log('from item toggle1 : ' , parent_selection, item.slug, item.is_selected)
          if (parent_selection || parent_selection === false) {
            if (parent_selection === item.is_selected || !parent_selection && !item.is_selected) {
              // $log.log('from item toggle return : ' , parent_selection, item.slug, item.is_selected)
              return;
            }
            item.is_selected = parent_selection;
          }
          eventManager.broadcast('module:select:resource', { slug: item.slug, dontSelect: true, state: item.is_selected });
        }
        // }, 50)
      };

      function getItemFromSlug(slug) {
        // if(slug.indexOf('run_like_math') > -1){
        //   slug = 'run_like_math';
        // }
        for (var i = 0; i < scope.moduleMap.resources.length; i++) {
          if (scope.moduleMap.resources[i].slug === slug) {
            return scope.moduleMap.resources[i];
          }
          for (var j = 0; j < scope.moduleMap.resources[i].children.length; j++) {
            var item = scope.moduleMap.resources[i].children[j];
            if (item.slug === slug) {
              return item;
            }
          }
        }
      }

      scope.selectChildItem = function (item) {
        if (item.sub || scope.dontSelect) {
          return;
        }
        if (scope.viewController.highlightedItem) {
          eventManager.broadcast('hide_item_selection_highlight', scope.viewController.highlightedItem);
        }
        scope.viewController.highlightedItem = item;
        // $log.log('CLICKING ITEM : ', item )
        if (item.resource_type === 'custom_resource') {
          eventManager.broadcast('open:custom:resource', { url: item.content.value, slug: item.slug, id: item.id, name: item.name });
          //item.is_selected = !item.is_selected;
          return;
        }
        var item_to_broadcast = angular.copy(getItemFromSlug(item.slug));
        item_to_broadcast.dontSelect = true;
        item_to_broadcast.centerOnItem = true;
        item_to_broadcast.highlightItem = true;
        //item_to_broadcast.is_selected = !item_to_broadcast.is_selected;

        if (!ModuleFilter.checkAvailable(item)) {
          item.locked = true;
          item_to_broadcast.locked = true;
          eventManager.broadcast('display-maintenance-message', item.slug);
        }
        eventManager.broadcast('module:select:resource', item_to_broadcast);
        if (!scope.viewController || scope.viewController && scope.viewController.isStudentView) {
          return;
        }
        //item.is_selected = !item.is_selected;
        last_selected = item.is_selected ? item : '';
        if (scope.unlockPath) {
          eventManager.broadcast('highlight:path', { slug: item.slug, clear: !item.is_selected });
        }
      };

      scope.getListItemClass = function (item) {
        // $timeout(function(){
        var foundOne = false;var foundNotOne = false;
        var is_partial;
        if (item.display && item.display.panel) {
          item.display.panel.forEach(function (sub) {
            if (sub.is_selected) {
              foundOne = true;
            } else {
              foundNotOne = true;
            }
            is_partial = is_partial === 'mticCheckbox--partialSelection' ? is_partial : scope.getListItemClass(sub);
          });
          if (!foundNotOne) {
            item.is_selected = true;
            return is_partial;
          } else if (foundOne) {
            item.is_selected = true;
            return 'mticCheckbox--partialSelection';
          } else {
            item.is_selected = false;
            return '';
          }
        } else if (item.sub) {
          item.sub.forEach(function (sub) {
            if (sub.is_selected) {
              foundOne = true;
            } else {
              foundNotOne = true;
            }
            is_partial = is_partial === 'mticCheckbox--partialSelection' ? is_partial : scope.getListItemClass(sub);
          });
          if (!foundNotOne) {
            item.is_selected = true;
            return is_partial;
          } else if (foundOne) {
            item.is_selected = true;
            return 'mticCheckbox--partialSelection';
          } else {
            item.is_selected = false;
            return '';
          }
        } else {
          return '';
        }
        // }, 200)
      };

      scope.toggleCustomSelection = function (sub) {
        // $log.log('toggleCustomSelection', sub);
        sub.is_selected = !sub.is_selected;
      };

      scope.getCheckIconClass = function (item) {
        var foundOne = false;var foundNotOne = false;
        var is_partial;
        if (item.sub) {
          item.sub.forEach(function (sub) {
            var id = getResourceIdFromSlug(sub.slug);
            if (id && scope.filteredResources.indexOf(id) > -1) {
              var sub_state = scope.getCheckIconClass(sub);
              if (is_partial === 'fa-adjust' || sub_state === 'fa-adjust' || is_partial === 'fa-circle-thin' && sub_state === 'fa-check-circle' || sub_state === 'fa-circle-thin' && is_partial === 'fa-check-circle') {
                is_partial = 'fa-adjust';
              } else {
                is_partial = sub_state;
              }
            }
          });
          return is_partial;
        } else {
          return scope.agendaProgressMap[item.slug] ? 'fa-check-circle' : 'fa-circle-thin';
        }
      };

      scope.getName = function (slug) {
        if (slug === 'run_like_math' || slug.indexOf('run_like_math') === -1 || slug.indexOf('lv_') === -1) {
          return language.get(slug);
        } else {
          var splt = slug.split('_');
          var level = '';
          if (!isNaN(splt[splt.length - 1])) {
            level = splt[splt.length - 1];
          }
          var trans_slug = slug.replace('_' + level, '');
          //run_like_math_obj[trans_slug][language.getCurrentSelectedLanguage()]
          return language.get(trans_slug) + ' ' + level;
        }
      };

      function getRegMatch(slug) {
        var match = true;
        if (scope.filteredView) {
          try {
            match = scope.getName(slug).toLowerCase().match(scope.filteredView.toLowerCase()) && scope.getName(slug).toLowerCase().match(scope.filteredView.toLowerCase()).length > 0;
          } catch (e) {
            match = false;
          }
        }
        return match;
      }

      scope.sendLabelClick = function (e, id) {
        if (PlatformService.isIos) {
          var elm = document.getElementById(id);
          if (elm) {
            elm.click();
          }
        }
      };

      eventManager.listen('refresh-agenda-sidepanel', function (e, data) {
        $log.log('side panel refresh!');
        if (scope.agendaProgressMap) {
          scope.agendaProgressMap[data.slug] = data;
        }
      });

      resetView();
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsAgendaPerfPreview', function ($log, language, C4_ASSET_URL, GR78_ASSET_URL, PanelFactory, $timeout, api, EventManager, userAccount, preliveCheck, TeacherDataService, ModuleFilter, PlatformService, $q) {
  return {
    template:'<div class="agendaModListWrap"><ul><li class="agendaModListItem" ng-repeat="item in moduleMapCopy" ng-if="item.show && isModuleAvailable(item) && (item.id !== 192 || !isAgendaView)"><div class="agendaModListItem__header agendaLiParent agendaLiParent--topLevel" ng-click="item.showSubMods = !item.showSubMods"><img ng-src="{{getModuleIconAssetUrl(item)}}" width="30" height="30" style="margin-right:10px"><div class="agendaModListItem__headerTextWrap"><label ng-if="!viewController.isStudentView && viewController" class="agendaModListItem__checkBox agendaModListItem__checkBox--topLevel"><input id="{{item.slug}}" type="checkbox" class="mticCheckbox" ng-class="getListItemClass(item)" ng-if="viewController" ng-model="item.is_selected" ng-change="toggleItemSubSelection(item)"> <span ng-click="sendLabelClick(e , item.slug)"></span></label> <span class="agendaModListItem__hederText"><span ng-bind="getName(item.slug)"></span>&nbsp;<i class="agendaModListItem__expandIcon" style="display: inline" ng-class="item.showSubMods ? \'fa fa-caret-down\' : \'fa fa-caret-right\'" aria-hidden="true" ng-show="item.resource_type !== \'custom_resource\'"></i></span></div></div><div ui-tree style="margin-left:40px" ng-show="item.showSubMods" ng-if="item.display && item.display.panel && item.display.panel.length > 0"><ul ui-tree-nodes ng-model="item.display.panel"><li ui-tree-node class="agendaModListItem" ng-repeat="sub in item.display.panel" ng-if="sub.show" ng-class="{\'agendaModListItem--hasChildren\' : item.display.panel.length > 0}"><div ui-tree-handle ng-if="isTeacher && (sub.type === \'custom_resource\' || sub.resource_type === \'custom_resource\')" class="agendaModListItem__subItem" ng-class="{\'highlight_item_class\':viewController.highlightedItem.slug === sub.slug}"><div class="agendaModListItem__nameWrap"><label ng-mousedown="toggleCustomSelection(sub)" ng-if="!viewController.isStudentView" class="agendaModListItem__checkBox"><input id="{{sub.slug}}" type="checkbox" class="mticCheckbox" ng-class="getListItemClass(sub)" ng-if="viewController" ng-model="sub.is_selected" ng-change="toggleItemSubSelection(sub)"> <span ng-click="sendLabelClick(e , sub.slug)"></span></label><div class="agendaModListItem__checkIconWrap" ng-if="viewController.isStudentView && !viewController.isModulePanelView"><i class="fa agendaModListItem__checkIcon" aria-hidden="true" ng-class="getCheckIconClass(sub)"></i></div><span ng-click="selectChildItem(sub)" style="font-style: italic;" class="agendaLiChild agendaModListItem__customlink" ng-style="{\'opacity\':sub.transparent?\'0.5\':\'1\'}" ng-bind="getTranslation(sub.name)"></span></div></div><div ng-if="!isTeacher || (sub.type !== \'custom_resource\' && sub.resource_type !== \'custom_resource\')" class="agendaModListItem__subItem" ng-class="{\'highlight_item_class\':viewController.highlightedItem.slug === sub.slug}"><div class="agendaModListItem__nameWrap"><label ng-if="!viewController.isStudentView" class="agendaModListItem__checkBox"><input id="{{sub.slug}}" type="checkbox" class="mticCheckbox" ng-class="getListItemClass(sub)" ng-if="viewController" ng-model="sub.is_selected" ng-change="toggleItemSubSelection(sub)"> <span ng-click="sendLabelClick(e , sub.slug)"></span></label><div class="agendaModListItem__checkIconWrap" ng-if="viewController.isStudentView && !viewController.isModulePanelView"><i class="fa agendaModListItem__checkIcon" aria-hidden="true" ng-class="getCheckIconClass(sub)"></i></div><span ng-class="sub.sub && sub.sub.length > 0?\'agendaLiParent\':\'agendaLiChild\'" ng-click="sub.showSubs = !sub.showSubs; selectChildItem(sub)" ng-style="{\'opacity\':sub.transparent?\'0.5\':\'1\'}"><span class="agendaLiText" ng-bind="sub.name || getName(sub.slug)"></span>&nbsp; <i style="margin-top:5px" ng-if="(sub.type === \'custom_resource\' || sub.resource_type === \'custom_resource\')" class="fa fa-external-link" aria-hidden="true"></i> <i class="agendaModListItem__expandIcon" ng-if="sub.sub && sub.sub.length > 0" ng-class="sub.showSubs ? \'fa fa-caret-down\' : \'fa fa-caret-right\'" aria-hidden="true"></i></span></div><div ui-tree ng-if="sub.showSubs && sub.sub && sub.sub.length > 0 && (!filteredResources || sub.show)" ng-include="\'menu.html\'"></div></div></li></ul></div></li></ul></div><script type="text/ng-template" id="menu.html"><ul ui-tree-nodes="" class="filteredResourcesSubList" ng-model="sub.sub"> <li ui-tree-node ng-show="sub.show || !filteredResources" class="agendaModListItem" ng-repeat="sub in sub.sub" ng-class="{\'agendaModListItem--hasChildren\' : sub.sub}"> <div ui-tree-handle ng-if="isTeacher && (sub.type === \'custom_resource\' || sub.resource_type === \'custom_resource\')" class="agendaModListItem__subItem" ng-class="{\'highlight_item_class\':viewController.highlightedItem.slug === sub.slug}"> <div class="agendaModListItem__nameWrap"> <label ng-mousedown="toggleCustomSelection(sub)" ng-if="!viewController.isStudentView" class="agendaModListItem__checkBox"> <input id="{{sub.slug}}" type="checkbox" class="mticCheckbox" ng-if="viewController" ng-model="sub.is_selected" ng-change="toggleItemSubSelection(sub)"> <span ng-click="sendLabelClick(e , sub.slug)"></span> </label> <div class="agendaModListItem__checkIconWrap" ng-if="viewController.isStudentView && !viewController.isModulePanelView"> <i class="fa agendaModListItem__checkIcon" aria-hidden="true" ng-class="getCheckIconClass(sub)"></i> </div> <span class="agendaModListItem__customlink" ng-style="{\'opacity\':sub.transparent?\'0.5\':\'1\'}" ng-click="sub.showSubs = !sub.showSubs;selectChildItem(sub, true)" ng-class="sub.sub && sub.sub.length > 0?\'agendaLiParent\':\'agendaLiChild\'" ng-bind="getTranslation(sub.name)"></span> </div> </div> <div ng-if="!isTeacher || (sub.type !== \'custom_resource\' && sub.resource_type !== \'custom_resource\')" class="agendaModListItem__subItem" ng-class="{\'highlight_item_class\':viewController.highlightedItem.slug === sub.slug}"> <div class="agendaModListItem__nameWrap"> <label ng-if="!viewController.isStudentView" class="agendaModListItem__checkBox"> <input id="{{sub.slug}}" type="checkbox" class="mticCheckbox" ng-class="getListItemClass(sub)" ng-if="viewController" ng-model="sub.is_selected" ng-change="toggleItemSubSelection(sub)"> <span ng-click="sendLabelClick(e , sub.slug)"></span> </label> <div class="agendaModListItem__checkIconWrap" ng-if="viewController.isStudentView && !viewController.isModulePanelView"> <i class="fa agendaModListItem__checkIcon" aria-hidden="true" ng-class="getCheckIconClass(sub)"></i> </div> <span ng-class="sub.sub && sub.sub.length > 0?\'agendaLiParent\':\'agendaLiChild\'" ng-click="sub.showSubs = !sub.showSubs; selectChildItem(sub)" ng-style="{\'opacity\':sub.transparent?\'0.5\':\'1\'}"> <span ng-bind="sub.name || getName(sub.slug)"></span>&nbsp; <i style="margin-top:5px" ng-if="(sub.type === \'custom_resource\' || sub.resource_type === \'custom_resource\')" class="fa fa-external-link" aria-hidden="true"></i> <i class="agendaModListItem__expandIcon" ng-if="sub.sub && sub.sub.length > 0" ng-class="sub.showSubs ? \'fa fa-caret-down\' : \'fa fa-caret-right\'" aria-hidden="true"></i> </span> </div> <div ng-if="sub.showSubs && sub.sub && sub.sub.length > 0 && (!filteredResources || sub.show)" ng-include="\'menu.html\'"></div> </div> </li> </ul></script>',
    scope: {
      agendaData: '<',
      studentsList: '<',
      moduleMap: '<',
      filteredView: '=?',
      dontCollapse: '=?',
      viewController: '=?',
      filteredResources: '=?',
      classId: '=?',
      agendaProgressMap: '=?',
      dontSelect: '<',
      unlockPath: '<',
      moduleMapCopy: '=?'
    },
    link: function link(scope, element) {
      scope.isAgendaView = TeacherDataService.inTeacherAgendaView;
      scope.getTranslation = function (slug) {
        return language.get(slug);
      };

      scope.isModuleAvailable = function (module) {
        if (module.parent_resource_id !== 192) {
          return ModuleFilter.checkAvailable(module);
        } else {
          return false;
        }
      };
      var eventManager = new EventManager('teacherStudentsAgendaPerfPreview', scope);
      scope.isQC = preliveCheck.isQCCheck();
      scope.isPrelive = preliveCheck.isPreliveCheck();
      scope.isTeacher = userAccount.getData().role.isTeacher;
      var target_students;
      var student_count;

      // scope.getName = function(slug){
      //   // var modified = slug.split(':')[1];
      //   // modified = modified ? modified.trim() : slug;
      //   return language.get(slug);
      // }

      scope.getModuleIconAssetUrl = function (item) {
        if (scope.moduleMap && scope.moduleMap.meta_config && scope.moduleMap.meta_config.map_config && scope.moduleMap.meta_config.map_config.set_module_icon_names) {
          var asset_name = scope.moduleMap.meta_config.map_config.set_module_icon_names[item.slug] || scope.moduleMap.meta_config.map_config.set_module_icon_names.default;
          return scope.moduleMap.meta_config.map_config.asset_url + asset_name + ".png";
        }
        if (item.config.map_config && item.config.map_config.asset_url) {
          return item.config.map_config.asset_url + item.slug + '.png';
        }
        return PanelFactory.getModuleIconAssetUrl(item.slug);
      };

      function displayOrderSort(a, b) {
        if (!a.display || !b.display) {
          return 0;
        }
        if (a.display.order < b.display.order) {
          return -1;
        }
        if (a.display.order > b.display.order) {
          return 1;
        }
        return 0;
      }

      var loading_items;
      var loaded_preticked;
      function resetView(dontOverwrite, keepSelections) {
        if (!scope.moduleMap || loading_items) {
          return;
        }
        loading_items = true;
        scope.moduleMap.resources = scope.moduleMap.resources.sort(displayOrderSort);

        scope.asset_url = scope.moduleMap.resources && scope.moduleMap.resources[0].parent_resource_id === 99 ? GR78_ASSET_URL : C4_ASSET_URL;

        scope.inFilteredView = true;
        if (!dontOverwrite) {
          if (!scope.moduleMapCopy) {
            scope.moduleMapCopy = angular.copy(scope.moduleMap.resources);
          }
          scope.moduleMapCopy.forEach(function (sub_mod) {
            sub_mod.show = false;
            sub_mod.transparent = false;
            sub_mod.display.panel.forEach(function (sub_sub) {
              reset_shown(sub_sub);
            });
          });
          //scope.moduleMapCopy = angular.copy(scope.moduleMap.resources);
          //scope.moduleMapCopy = applySelections(temp, )
          scope.moduleMapCopy.forEach(function (sub_mod) {
            var indx = 0;
            sub_mod.children.forEach(function (item) {
              if (_.get(item, ['config', 'exclude'])) {
                sub_mod.children.splice(indx, 1);
                removePanelItem(sub_mod.slug + ': ' + item.slug);
              }
              indx++;
            });
          });
        }
        scope.moduleMapCopy.forEach(function (sub_mod) {
          if (sub_mod.display && sub_mod.display.panel) {
            sub_mod.display.panel.forEach(function (sub) {
              var sub_info = getPath(sub, sub_mod, dontOverwrite);
              var match = getRegMatch(sub_mod.slug); //!scope.filteredView ? true : (scope.getName(sub_mod.slug).toLowerCase()).match((scope.filteredView).toLowerCase()) &&  (scope.getName(sub_mod.slug).toLowerCase()).match((scope.filteredView).toLowerCase()).length > 0;
              sub_mod.show = sub_mod.show || sub_info.show || match && !scope.filteredResources;
              sub.show = sub.show || match && !scope.filteredResources;
            });
          }
        });
        if (scope.viewController && scope.viewController.preticked_items && !loaded_preticked) {
          loaded_preticked = true;
          scope.viewController.selectItemsFromId(scope.viewController.preticked_items);
          $timeout(function () {
            eventManager.broadcast('highlight:map:items', scope.viewController.preticked_items);
            loading_items = false;
          }, 250);
        } else {
          loading_items = false;
        }
      }

      eventManager.listen('tick:module', function (e, slug) {
        scope.moduleMapCopy.forEach(function (mod) {
          if (mod.slug === slug) {
            mod.is_selected = true;
            scope.toggleItemSubSelection(mod, true);
          }
        });
      });

      function reset_shown(sub) {
        sub.show = false;
        sub.transparent = false;
        if (sub.sub) {
          sub.sub.forEach(function (sub_sub) {
            reset_shown(sub_sub);
          });
        }
      }

      function removePanelItem(slug, parent) {
        var indx = 0;
        if (parent) {
          parent.forEach(function (child) {
            if (child.sub) {
              removePanelItem(slug, child.sub);
            } else if (child.slug === slug) {
              parent.splice(indx, 1);
            }
            indx++;
          });
          return;
        }
        scope.moduleMapCopy.forEach(function (sub_mod) {
          if (sub_mod.display && sub_mod.display.panel) {
            indx = 0;
            sub_mod.display.panel.forEach(function (sub) {
              if (sub.sub) {
                removePanelItem(slug, sub.sub);
              } else if (sub.slug === slug) {
                sub_mod.splice(indx, 1);
              }
              indx++;
            });
          }
        });
      }

      function getPath(sub, parent, resetTransparent) {
        if (sub.sub) {
          var sub_count = 0;
          sub.sub.forEach(function (sub_sub) {
            var sub_info = getPath(sub_sub, sub, resetTransparent);
            sub.show = sub.show || sub_info.show;
          });
        }
        var item_info = { show: sub.show };
        if (!scope.filteredResources) {
          var match = getRegMatch(sub.slug);

          sub.show = sub.show || match;
          sub.transparent = !match;

          if (parent.sub && !sub.show && scope.filteredView && scope.filteredView !== '') {
            sub.show = hasVisibleSibling(parent.sub);
            //sub.show;
          }
          if (resetTransparent) {
            sub.transparent = false;
          }
          item_info.show = sub.show;
        } else {
          var id = sub.id || getResourceIdFromSlug(sub.slug);
          sub.show = sub.show || scope.filteredResources.indexOf(id) > -1;
          item_info.show = sub.show;
        }
        return item_info;
      }

      function hasVisibleSibling(parent) {
        var found = false;
        parent.forEach(function (child) {
          found = found || getRegMatch(child.slug); //(scope.getName(child.slug).toLowerCase()).match((scope.filteredView).toLowerCase()) &&  (scope.getName(child.slug).toLowerCase()).match((scope.filteredView).toLowerCase()).length > 0;
        });
        return found;
      }

      function getResourceIdFromSlug(slug) {
        // if(slug.indexOf(':') > -1){
        //   slug = slug.split(':')[1].trim();
        // }
        var id;
        for (var i = 0; i < scope.moduleMap.resources.length; i++) {
          var sub_mod = scope.moduleMap.resources[i].children;
          for (var j = 0; j < sub_mod.length; j++) {
            var resource = sub_mod[j];
            if (resource.children) {
              for (var k = 0; k < resource.children.length; k++) {
                var sub_resource = resource.children[k];
                if (sub_resource.slug === slug) {
                  return sub_resource.id;
                }
              }
            }
            if (resource.slug === slug) {
              return resource.id;
            }
          }
        }
        return false;
      }

      function getItemSlugFromId(resource_id) {
        var found_slug;
        scope.moduleMap.resources.forEach(function (sub_mod) {
          sub_mod.children.forEach(function (resource) {
            if (resource && resource.id === resource_id) {
              found_slug = resource.slug;
            }
          });
        });
        return found_slug;
      }

      scope.$watch('agendaData', function () {
        resetView();
      });
      scope.$watch('studentsList', function () {
        resetView();
      });
      scope.$watch('moduleMap', function () {
        resetView();
      });

      scope.$watch('filteredView', function (new_val, old_val) {
        if (old_val && old_val !== '' && new_val === '') {
          resetView(true, true);
          return;
        }
        resetView(false, true);
      });

      scope.$watch('filteredResources', function (val) {
        resetView();
      });

      var last_selected;
      scope.$watch('unlockPath', function (val) {
        if (val === false) {
          eventManager.broadcast('highlight:path', { slug: '', clear: true });
        } else if (val && last_selected && last_selected.is_selected) {
          eventManager.broadcast('highlight:path', { slug: last_selected.slug, clear: false });
        }
      });

      scope.selectItem = function (item, select, dontSelect, triggerSelection) {
        if (!item.sub && scope.inFilteredView && scope.viewController) {
          scope.viewController.highlightedItem = item;
          item.is_selected = triggerSelection ? !item.is_selected : item.is_selected;
          item.show = true;
          last_selected = item.is_selected ? item : '';
          if (scope.unlockPath) {
            eventManager.broadcast('highlight:path', { slug: item.slug, clear: false });
          }
          if (dontSelect) {
            return;
          }
          $timeout(function () {
            eventManager.broadcast('module:select:resource', { slug: item.slug, dontSelect: true, state: item.is_selected });
          }, 500);
        } else if (item.sub) {
          // $log.log('parent click : ' , item)
          item.is_selected = !item.is_selected;
        }
      };

      var cached_items = [];
      if (scope.viewController) {
        scope.viewController.selectItemBySlug = function (slug, select, dontSelect, triggerSelection) {
          scope.moduleMapCopy.forEach(function (sub_mod) {
            if (sub_mod.display && sub_mod.display.panel) {
              findAndHighlight(sub_mod.display.panel, slug, select, dontSelect, triggerSelection);
            }
          });
        };
        scope.viewController.getSelectedItems = function () {
          var selected = [];
          scope.moduleMapCopy.forEach(function (sub_mod) {
            if (sub_mod.display && sub_mod.display.panel) {
              if (Array.isArray(sub_mod.display.panel)) {
                var i = 0;
                sub_mod.display.panel.forEach(function (child) {
                  getSelected(child, selected, sub_mod.slug, i);
                  i++;
                });
              }
            }
          });
          // $log.log('GET SELECTED ITEMS : ', scope.moduleMapCopy)
          return selected;
        };
        eventManager.listen('agenda:request:selected', function () {
          eventManager.broadcast('agenda:respond:selected', scope.viewController.getSelectedItems());
        });
        scope.viewController.selectItemsFromId = function (item_arr) {
          // $log.log('got resources : ' , scope.viewController.cached_items, item_arr)
          if (scope.viewController.cached_items && scope.viewController.cached_items.length > 0) {
            //item_arr = scope.viewController.cached_items;
            scope.viewController.cached_items.forEach(function (item) {
              if (item.type === 'custom_resource') {
                item.content.position_data = {
                  parent_slug: item.parent_slug,
                  index: item.item_index
                };
                placeCustomInMap(item);
              }
            });
          }
          var custom_arr = [];
          item_arr.forEach(function (item_id) {
            var slug = getItemSlugFromId(item_id);
            if (slug) {
              // $log.log('tick this : ', slug, item_id);
              scope.viewController.selectItemBySlug(slug, true, false, true);
            } else if (scope.classId && typeof item_id === 'number') {
              var resource;

              custom_arr.push(api.getCustomResource(scope.classId, item_id));
              // .then(function(resources) {
              //   // $log.log('custom resources : ', resources)
              //   if(resources){
              //     custom_arr.push(resources[0])
              //     // placeCustomInMap(resources[0]);
              //   }
              // })
            }
          });
          $q.all(custom_arr).then(function (results) {
            var custom_resources_map = {};
            results.forEach(function (resources) {
              if (resources) {
                if (!custom_resources_map[resources[0].content.position_data.parent_slug]) {
                  custom_resources_map[resources[0].content.position_data.parent_slug] = [];
                }
                custom_resources_map[resources[0].content.position_data.parent_slug].push(resources[0]);
              }
            });
            for (var key in custom_resources_map) {
              if (custom_resources_map[key]) {
                custom_resources_map[key].sort(sorter);
              }
            }
            for (var el in custom_resources_map) {
              if (custom_resources_map[el]) {
                placeAllInMap(custom_resources_map[el]);
              }
            }
            $log.log('sorted : ', custom_resources_map);
          });
        };
      }

      function placeAllInMap(list) {
        list.forEach(function (resource) {
          placeCustomInMap(resource);
        });
      }

      function sorter(a, b) {
        var indx1 = Number(a.content.position_data.index);
        var indx2 = Number(b.content.position_data.index);
        if (indx1 < indx2) {
          return -1;
        }
        if (indx1 > indx2) {
          return 1;
        }
        return 0;
      }

      var placeCustomInMap = function placeCustomInMap(resource) {

        var parent_slug = resource.content.position_data.parent_slug;
        var index = Number(resource.content.position_data.index);
        if (parent_slug === scope.moduleMap.slug) {
          scope.moduleMapCopy.splice(index, 0, resource);
          return;
        }
        $log.log('place custom :  ', parent_slug, index, scope.moduleMap.slug);
        scope.moduleMapCopy.forEach(function (sub_mod) {
          if (sub_mod.display && sub_mod.display.panel) {
            if (sub_mod.slug === parent_slug) {
              sub_mod.display.panel.splice(index, 0, resource);
              resource.show = true;
              resource.is_selected = true;
              return;
            } else {
              sub_mod.display.panel.forEach(function (sub) {
                checkResourceAndInsert(sub, resource);
              });
            }
          }
        });
      };
      var checkResourceAndInsert = function checkResourceAndInsert(sub, resource) {
        if (sub.sub) {
          if (sub.slug === resource.content.position_data.parent_slug && (sub.sub.length <= Number(resource.content.position_data.index) || sub.sub[Number(resource.content.position_data.index)].slug !== resource.slug)) {
            sub.sub.splice(Number(resource.content.position_data.index), 0, resource);
            resource.show = true;
            resource.is_selected = true;
          } else {
            sub.sub.forEach(function (sub_sub) {
              checkResourceAndInsert(sub_sub, resource);
            });
          }
        }
      };
      function findAndHighlight(sub, slug, select, dontSelect, triggerSelection) {
        if (sub.slug === slug) {
          scope.selectItem(sub, select, dontSelect, triggerSelection);
        } else if (sub.sub) {
          sub.sub.forEach(function (sub_child) {
            findAndHighlight(sub_child, slug, select, dontSelect, triggerSelection);
          });
        } else if (Array.isArray(sub)) {
          sub.forEach(function (sub_child) {
            findAndHighlight(sub_child, slug, select, dontSelect, triggerSelection);
          });
        }
      }

      function getSelected(sub, arr, parent, index) {
        if (!sub.sub && sub.is_selected) {
          sub.parent_slug = parent;
          sub.item_index = index;
          arr.push(sub);
        } else if (sub.sub) {
          var i = 0;
          sub.sub.forEach(function (sub_child) {
            getSelected(sub_child, arr, sub.slug, i);
            i++;
          });
        }
      }

      scope.selectParent = function (item) {
        item.is_selected = !item.is_selected;
      };

      scope.toggleItemSubSelection = function (item, parent_selection) {
        if (scope.viewController.isStudentView) {
          return;
        }
        if (item.sub) {
          item.sub.forEach(function (child) {
            if (child.sub) {
              child.is_selected = item.is_selected;
            }
            scope.toggleItemSubSelection(child, item.is_selected);
          });
          eventManager.broadcast('highlight:path', { slug: '', clear: true });
        } else if (item.display && item.display.panel) {
          item.display.panel.forEach(function (child) {
            if (child.sub) {
              child.is_selected = item.is_selected;
            }
            scope.toggleItemSubSelection(child, item.is_selected);
          });
        } else {
          if (parent_selection || parent_selection === false) {
            if (parent_selection === item.is_selected || !parent_selection && !item.is_selected) {
              return;
            }
            item.is_selected = parent_selection;
          }
          eventManager.broadcast('module:select:resource', { slug: item.slug, dontSelect: true, state: item.is_selected });
        }
      };

      function getItemFromSlug(slug) {
        // if(slug.indexOf('run_like_math') > -1){
        //   slug = 'run_like_math';
        // }
        for (var i = 0; i < scope.moduleMap.resources.length; i++) {
          if (scope.moduleMap.resources[i].slug === slug) {
            return scope.moduleMap.resources[i];
          }
          for (var j = 0; j < scope.moduleMap.resources[i].children.length; j++) {
            var item = scope.moduleMap.resources[i].children[j];
            if (item.slug === slug) {
              return item;
            }
          }
        }
      }

      scope.selectChildItem = function (item) {
        if (item.sub || scope.dontSelect) {
          return;
        }
        if (scope.viewController.highlightedItem) {
          eventManager.broadcast('hide_item_selection_highlight', scope.viewController.highlightedItem);
        }
        scope.viewController.highlightedItem = item;
        if (item.resource_type === 'custom_resource') {
          eventManager.broadcast('open:custom:resource', { url: item.content.value, slug: item.slug, id: item.id, name: item.name });
          return;
        }
        var item_to_broadcast = angular.copy(getItemFromSlug(item.slug));
        item_to_broadcast.dontSelect = true;
        item_to_broadcast.centerOnItem = true;
        item_to_broadcast.highlightItem = true;

        if (!ModuleFilter.checkAvailable(item)) {
          item.locked = true;
          item_to_broadcast.locked = true;
          eventManager.broadcast('display-maintenance-message', item.slug);
        }
        eventManager.broadcast('module:select:resource', item_to_broadcast);
        if (!scope.viewController || scope.viewController && scope.viewController.isStudentView) {
          return;
        }
        last_selected = item.is_selected ? item : '';
        if (scope.unlockPath) {
          eventManager.broadcast('highlight:path', { slug: item.slug, clear: !item.is_selected });
        }
      };

      eventManager.listen('module:select:resource', function (e, item) {
        if (item && (!item.dontSelect || item.state)) {
          scope.moduleMapCopy.forEach(function (sub_mod) {
            sub_mod.display.panel.forEach(function (sub) {
              if (sub.slug === item.slug) {
                sub.show = true;
              } else if (sub.sub) {
                sub.sub.forEach(function (child) {
                  if (child.slug === item.slug) {
                    sub_mod.showSubMods = true;
                    child.show = true;
                    sub.showSubs = true;
                    sub.show = true;
                  }
                });
              }
            });
          });
        }
      });

      scope.getListItemClass = function (item) {
        // $timeout(function(){
        var foundOne = false;var foundNotOne = false;
        var is_partial;
        if (item.display && item.display.panel) {
          item.display.panel.forEach(function (sub) {
            if (sub.is_selected) {
              foundOne = true;
            } else {
              foundNotOne = true;
            }
            is_partial = is_partial === 'mticCheckbox--partialSelection' ? is_partial : scope.getListItemClass(sub);
          });
          if (!foundNotOne) {
            item.is_selected = true;
            return is_partial;
          } else if (foundOne) {
            item.is_selected = true;
            return 'mticCheckbox--partialSelection';
          } else {
            item.is_selected = false;
            return '';
          }
        } else if (item.sub) {
          item.sub.forEach(function (sub) {
            if (sub.is_selected) {
              foundOne = true;
            } else {
              foundNotOne = true;
            }
            is_partial = is_partial === 'mticCheckbox--partialSelection' ? is_partial : scope.getListItemClass(sub);
          });
          if (!foundNotOne) {
            item.is_selected = true;
            return is_partial;
          } else if (foundOne) {
            item.is_selected = true;
            return 'mticCheckbox--partialSelection';
          } else {
            item.is_selected = false;
            return '';
          }
        } else {
          return '';
        }
        // }, 200)
      };

      scope.toggleCustomSelection = function (sub) {
        sub.is_selected = !sub.is_selected;
      };

      scope.getCheckIconClass = function (item) {
        var foundOne = false;var foundNotOne = false;
        var is_partial;
        if (item.sub) {
          item.sub.forEach(function (sub) {
            var id = getResourceIdFromSlug(sub.slug);
            if (id && scope.filteredResources.indexOf(id) > -1) {
              var sub_state = scope.getCheckIconClass(sub);
              if (is_partial === 'fa-adjust' || sub_state === 'fa-adjust' || is_partial === 'fa-circle-thin' && sub_state === 'fa-check-circle' || sub_state === 'fa-circle-thin' && is_partial === 'fa-check-circle') {
                is_partial = 'fa-adjust';
              } else {
                is_partial = sub_state;
              }
            }
          });
          return is_partial;
        } else {
          return scope.agendaProgressMap[item.slug] ? 'fa-check-circle' : 'fa-circle-thin';
        }
      };

      scope.getName = function (slug) {
        if (slug === 'run_like_math' || slug.indexOf('run_like_math') === -1 || slug.indexOf('lv_') === -1) {
          return language.get(slug);
        } else {
          var splt = slug.split('_');
          var level = '';
          if (!isNaN(splt[splt.length - 1])) {
            level = splt[splt.length - 1];
          }
          var trans_slug = slug.replace('_' + level, '');
          //run_like_math_obj[trans_slug][language.getCurrentSelectedLanguage()]
          return language.get(trans_slug) + ' ' + level;
        }
      };

      function getRegMatch(slug) {
        var match = true;
        if (scope.filteredView) {
          try {
            match = scope.getName(slug).toLowerCase().match(scope.filteredView.toLowerCase()) && scope.getName(slug).toLowerCase().match(scope.filteredView.toLowerCase()).length > 0;
          } catch (e) {
            match = false;
          }
        }
        return match;
      }

      scope.sendLabelClick = function (e, id) {
        if (PlatformService.isIos) {
          var elm = document.getElementById(id);
          if (elm) {
            elm.click();
          }
        }
      };

      eventManager.listen('refresh-agenda-sidepanel', function (e, data) {
        $log.log('side panel refresh!');
        if (scope.agendaProgressMap) {
          scope.agendaProgressMap[data.slug] = data;
        }
      });

      resetView();
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').component('teacherStudentsAgendaInfo', {
  template:'<div style="padding: 20px;"><h2 ng-bind="agendaInfo.description"></h2><span ng-bind="agendaInfo.day"></span></div><table class="table is-bordered agenda-info-table"><thead><th style="width:240px; vertical-align:middle;"><div><span>Student Name</span></div></th><th style="width:180px; vertical-align:middle;">All Tasks</th><th ng-repeat="col in agendaInfo.getCols()" class="fixed-width-col"><div><span ng-bind="agendaInfo.getResourceName(col.slug, col.name)"></span></div></th></thead><tbody><tr ng-repeat="row in agendaInfo.getRows()"><td ng-bind="row.student_name"></td><td><span ng-if="agendaInfo.hasAllTasksCompleted(row)"><i class="fa fa-check" aria-hidden="true"></i></span></td><td ng-repeat="col in agendaInfo.getCols()" style="text-align:center;"><span ng-if="row.resources[col.slug].resource_completed"><i class="fa fa-check" aria-hidden="true"></i></span></td></tr></tbody></table>',
  bindings: {
    agenda: '<',
    students: '<'
  },
  controllerAs: 'agendaInfo',
  controller: function controller(language, $log, $timeout) {
    var agendaInfo = this;
    // General Methods
    var getDay = function getDay(date) {
      return moment(date).format('MMM-DD');
    };
    var getResource = function getResource(resourceId) {
      for (var resourceIndex in agendaInfo.agenda.resourceRefs) {
        var resource = agendaInfo.agenda.resourceRefs[resourceIndex];
        if (Number(resource.id) === Number(resourceId)) {
          return resource;
        }
      }
      throw new Error('Missing Resource ID! ' + resourceId);
    };
    var makeNewStudentRow = function makeNewStudentRow(student) {
      var studentRow = {
        user_id: student.user_id,
        student_name: student.display_name,
        info: student.info,
        resources: {}
      };
      agendaInfo.resources.forEach(function (resource) {
        studentRow.resources[resource.slug] = {};
      });
      return studentRow;
    };

    // Table Functions
    agendaInfo.getRows = function () {
      return _.toArray(agendaInfo.studentRows);
    };
    agendaInfo.getCols = function () {
      return agendaInfo.resources;
    };
    agendaInfo.getResourceName = function (slug, name) {
      var text = language.get(slug);
      return text ? text : name;
    };
    agendaInfo.hasAllTasksCompleted = function (studentRow) {
      return _.filter(studentRow.resources, function (resourceWork) {
        return resourceWork.resource_completed;
      }).length === _.toArray(studentRow.resources).length;
    };
    // Init
    agendaInfo.$onChanges = function (obj) {
      $timeout(function () {
        agendaInfo.studentRows = {};
        agendaInfo.resources = [];
        agendaInfo.day = '';
        agendaInfo.description = '';

        // Grab time and description
        agendaInfo.day = getDay(agendaInfo.agenda.date_close);
        agendaInfo.description = agendaInfo.agenda.description;

        // Loop to get table collumns
        agendaInfo.agenda.resources.forEach(function (resourceId) {
          agendaInfo.resources.push(getResource(resourceId));
        });

        // Loop to get table rows
        agendaInfo.students.forEach(function (student) {
          agendaInfo.studentRows[student.user_id] = makeNewStudentRow(student);
        });

        // Update Rows
        agendaInfo.agenda.StudentAgendaItems.forEach(function (studentAgendaItem) {
          // var student = studentAgendaItem.user;
          var resource = studentAgendaItem.resource;
          var studentRow = agendaInfo.studentRows[studentAgendaItem.user_id];
          if (studentRow && studentRow.resources[resource.slug]) {
            studentRow.resources[resource.slug] = {
              resource_completed: studentAgendaItem.resource_completed,
              resource_performance: studentAgendaItem.resource_performance,
              completed_at: moment(studentAgendaItem.competeled_at).format('YYYY-MM-DD')
            };
          }
        });

        // $log.log('Agenda Info Change : ', agendaInfo.students)
      }, 500);
    };
  }
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsAgendaCalendar', function ($log, language, C4_ASSET_URL, GR78_ASSET_URL, $timeout, userAccount) {
  return {
    template:'<div class="dualCalendars" ng-if="!oneMonth && !listMode"><div class="dualCalendars__calendar"><div class="dualCalendars__calendarHead"><i class="fa fa-angle-left dualCalendars__calendarHeadArrow" aria-hidden="true" ng-class="{\'dualCalendars__calendarHeadArrow--light\': calendarData.pageCounter === 0 }" ng-click="calendarData.shiftMonths(-1, true)"></i><div class="dualCalendars__calendarHeadText">{{ moment({ month: calendarData.currentMonth, year: calendarData.currentYear }).format("MMMM YYYY") }}</div></div><table class="dualCalendars__calendarTable" style="font-size:16px"><tr style="font-weight:bold;"><th ng-bind="getTranslation(\'28468\').substring(0,1)">S</th><th ng-bind="getTranslation(\'28469\').substring(0,1)">M</th><th ng-bind="getTranslation(\'28470\').substring(0,1)">T</th><th ng-bind="getTranslation(\'28471\').substring(0,1)">W</th><th ng-bind="getTranslation(\'28472\').substring(0,1)">T</th><th ng-bind="getTranslation(\'28473\').substring(0,1)">F</th><th ng-bind="getTranslation(\'28474\').substring(0,1)">S</th></tr><tr ng-repeat="month_row in [0,1,2,3,4, 5]" ng-if="month_row < 5 || (calendarData.currentMonthArray[35] && calendarData.currentMonthArray[35] !== \'\')"><td ng-class="calendarData.getDatebasedStyle(month_row, $index, true)" ng-click="calendarData.setDateSelection(month_row, $index, true, null, true)" ng-repeat="day in calendarData.getDaysRow(month_row) track by $index">{{day}}</td></tr></table></div><div class="dualCalendars__calendarDivider"></div><div class="dualCalendars__calendar"><div class="dualCalendars__calendarHead"><div class="dualCalendars__calendarHeadText">{{ moment({ month: (calendarData.currentMonth+1)%12, year: calendarData.nextYear }).format("MMMM YYYY") }}</div><i class="fa fa-angle-right dualCalendars__calendarHeadArrow dualCalendars__calendarHeadArrow--rightAligned" ng-click="calendarData.shiftMonths(1, true)" aria-hidden="true"></i></div><table class="dualCalendars__calendarTable" style="font-size:16px"><tr style="font-weight:bold;"><th ng-bind="getTranslation(\'28468\').substring(0,1)">S</th><th ng-bind="getTranslation(\'28469\').substring(0,1)">M</th><th ng-bind="getTranslation(\'28470\').substring(0,1)">T</th><th ng-bind="getTranslation(\'28471\').substring(0,1)">W</th><th ng-bind="getTranslation(\'28472\').substring(0,1)">T</th><th ng-bind="getTranslation(\'28473\').substring(0,1)">F</th><th ng-bind="getTranslation(\'28474\').substring(0,1)">S</th></tr><tr ng-repeat="month_row in [0,1,2,3,4, 5]" ng-if="month_row < 5 || (calendarData.nextMonthArray[35] && calendarData.nextMonthArray[35] !== \'\')"><td ng-class="calendarData.getDatebasedStyle(month_row, $index, false)" ng-click="calendarData.setDateSelection(month_row, $index, false, null, true)" ng-repeat="day in calendarData.getDaysRow(month_row, true) track by $index">{{day}}</td></tr></table></div></div><div ng-if="oneMonth" ng-init="createFullCalendarAgendas()" class="agendaMonthCalendar"><div class="agendaMonthCalendar__inner"><table class="agendaMonthCalendar__table"><thead><tr class="agendaMonthCalendar__tableHeader"><th ng-bind="getTranslation(\'28468\')">Sun</th><th ng-bind="getTranslation(\'28469\')">Mon</th><th ng-bind="getTranslation(\'28470\')">Tue</th><th ng-bind="getTranslation(\'28471\')">Wed</th><th ng-bind="getTranslation(\'28472\')">Thu</th><th ng-bind="getTranslation(\'28473\')">Fri</th><th ng-bind="getTranslation(\'28474\')">Sat</th></tr></thead><tbody><tr ng-repeat="month_row in [0,1,2,3,4,5]" ng-if="month_row < 5 || (calendarData.currentMonthArray[35] && calendarData.currentMonthArray[35] !== \'\')"><td ng-repeat="day in calendarData.getDaysRow(month_row) track by $index" ng-init="parentIndex = $index" ng-class="{dateCell: !isOlderDate(day)}" ng-click="agendaOptions.showAgendaDialog($event, $index, month_row, day)"><span ng-class="checkTodayOrOlder(day)">{{day}}</span><div ng-repeat="agenda in agendasList" class="agendaMonthCalendar__agenda" ng-if="agendaOnDay(day, $index)" ng-click="agendaOptions.showAgendaOptions($event, agenda)" ng-class="agendaOnDay(day, $index)" ng-style="{\'background-color\':!agenda.CompetitionEntries||agenda.CompetitionEntries.length === 0?agendasColors[$index%agendasColors.length]:\'#FF3860\', \'margin-top\':getAgendaRibbonMargin(day, agenda)}"><div ng-if="agendaOnDay(day, $index) === \'agendaFullCalendarViewStart\' || parentIndex === 0 || day === 1" class="agendaMonthCalendar__agendaStarter"><img class="agendaMonthCalendar__agendaStarterImage" ng-src="{{getAgendaUrl(agenda)}}"> <span check-overflow agenda-closes-this-month="agendaClosesThisMonth" no-agendas-ending-this-month="noAgendasEndingThisMonth" no-agendas-starting-this-month="noAgendasStartingThisMonth" agenda-item="agenda" day-item="day" calendar-data="calendarData" ng-style="agendaOverflowCheck(agenda, day)" class="agendaMonthCalendar__agendaStarterTitle">{{getAgendaName(agenda)}}</span></div></div></td></tr></tbody></table></div></div><div ng-if="listMode" class="calendarListMode"><div class="calendarListMode__inner"><div class="calendarListModeitem" ng-if="agendaClosesThisMonth(agenda.date_close)" ng-repeat="agenda in agendasList track by $index"><div class="calendarListModeitem__date"><div class="calendarListModeitem__endingText" ng-bind="getTranslation(\'28490\')">END DATE</div><span class="calendarListModeitem__monthDate" ng-bind="moment(agenda.date_close).format(\'D\')"></span> <span class="calendarListModeitem__weekDay" ng-bind="moment(agenda.date_close).format(\'ddd\')"></span></div><div class="calendarListModeitem__assignmentInfo" ng-click="agendaOptions.showAgendaOptions($event, agenda)"><span class="calendarListModeitem__assignmentName" ng-bind="getAgendaName(agenda)"></span> <span class="calendarListModeitem__assignmentStarted" ng-show="hasAgendaStarted(agenda.date_open)" ng-bind="getTranslation(\'28492\')">NOT STARTED</span></div><div class="calendarListModeitem__agendaPerfPreview"><teacher-students-agenda-perf-preview filtered-resources="agenda.resources" module-map="moduleMapData" dont-select="true"></teacher-students-agenda-perf-preview></div></div><div class="calendarListModeitem--empty" ng-if="noAgendasEndingThisMonth()" ng-bind="getTranslation(\'28226\')">There is no Agenda Unit ending this month</div></div></div><div class="tooltipMenuPositioner" ng-style="{\'width\':agendaOptions.optionsShown?\'160px\':\'200px\'}"><div id="agendaCalendarOptions" ng-class="invertedMenu ? \'tooltipMenuInverted\' : \'tooltipMenu\'" ng-show="agendaOptions.optionsShown"><div class="tooltipMenu__option" ng-click="calendarData.editCurrentAgenda(true)" ng-if="!calendarData.currentAgenda.CompetitionEntries || calendarData.currentAgenda.CompetitionEntries.length === 0" ng-mouseenter="agendaOptions.hoveringOn = \'edit\'" ng-mouseleave="agendaOptions.hoveringOn = \'\'" ng-bind="getTranslation(\'27674\')">Edit</div><div class="tooltipMenu__option" ng-click="calendarData.loadCurrentAgendaReport()" ng-mouseenter="agendaOptions.hoveringOn = \'report\'" ng-mouseleave="agendaOptions.hoveringOn = \'\'" ng-bind="getTranslation(\'27675\')">View report</div><div class="tooltipMenu__option" ng-click="shareAgenda()" ng-mouseenter="agendaOptions.hoveringOn = \'share\'" ng-mouseleave="agendaOptions.hoveringOn = \'\'" ng-bind="getTranslation(\'share_agenda\')">Share Agenda</div><div style="padding-bottom:10px;" class="tooltipMenu__option" ng-click="calendarData.showArchiveConfirm = true" ng-mouseenter="agendaOptions.hoveringOn = \'archive\'" ng-mouseleave="agendaOptions.hoveringOn = \'\'" ng-bind="getTranslation(\'27676\')">Archive</div></div><div id="agendaCalendarDialog" class="tooltipMenu" ng-show="agendaOptions.dialogShown && !agendaOptions.optionsShown"><div style="border-bottom:none !important" class="tooltipMenu__option tooltipMenu__option--withIcon" ng-click="triggerAgendaCreate(true)" ng-mouseenter="agendaOptions.hoveringOn = \'new\'" ng-mouseleave="agendaOptions.hoveringOn = \'\'"><span class="icon"><img style="width:90%" src="assets/images/agenda/plus_icon.png"></span> <span style="text-align:left;margin-left:10px; padding:3px 5px 3px 10px; margin-left:10px; border-left:2px solid #393F48;" ng-bind="getTranslation(\'27704\')">Create new</span></div><div style="background-color:rgba(68,74,86,.95);width:100%"><div style="height:2px;width:90%;margin-left:5%;background-color:rgba(0,0,0,0.35)"></div></div><div style="padding-bottom:10px" class="tooltipMenu__option tooltipMenu__option--withIcon" ng-click="toImportAgenda()" ng-mouseenter="agendaOptions.hoveringOn = \'import\'" ng-mouseleave="agendaOptions.hoveringOn = \'\'"><span class="icon"><img style="width:90%" src="assets/images/agenda/import_icon.png"></span> <span style="text-align:left;margin-left:10px; padding:3px 5px 3px 10px; margin-left:10px; border-left:2px solid #393F48;" ng-bind="getTranslation(\'import_agenda\')">Import Agenda</span></div></div></div><div ng-if="showShareCode" style="position:fixed;left:0px;top:0px;z-index:10000;display:flex;justify-content:center;align-items:center;width:100%;height:100%;background-color:rgba(0,0,0,0.4)"><div style="display:flex;align-items:center;justify-content:center;flex-direction:column;width:400px;height:340px;background-color:#fff;border-radius:10px;padding:40px"><span style="width:100%" ng-bind="getTranslation(\'share_agenda_inst\')">Share this code with a teacher you would like to share this agenda with:</span><br><br><span ng-bind="shareCode" class="text-selectable" style="color:#ff0000;font-size:20px;"></span><br><button class="button is-primary" ng-click="hideShareCode()" ng-bind="getTranslation(\'got_it\')">Got it!</button></div></div>',
    scope: {
      calendarData: "=",
      oneMonth: "=?",
      newAgendaTrigger: "=?",
      agendasListOriginal: "=?",
      moduleMapData: "=?",
      studentList: "=?",
      listMode: "=?"
    },
    link: function link(scope, element) {
      var lastClickedDay;
      scope.getTranslation = function (id) {
        return language.get(id);
      };
      scope.moment = moment;
      scope.moment.locale(language.getCurrentSelectedLanguage());

      scope.resourceMapping = {};
      scope.month_array = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      scope.createFullCalendarAgendas = function () {
        // $log.log('FROM FULL CALENDAR INIT: ', scope.calendarData);
      };

      var getDateInfo = function getDateInfo(day) {
        if (day === "") {
          return;
        }
        var now_month = new Date().getMonth();
        var now_year = new Date().getFullYear();
        if (scope.calendarData.currentYear > now_year || scope.calendarData.currentMonth > now_month && scope.calendarData.currentYear >= now_year) {
          return;
        }
        return {
          now_month: now_month,
          now_year: now_year,
          today_date: new Date().getDate()
        };
      };
      scope.isOlderDate = function (day, dateInfo) {
        if (day === "") {
          return false;
        }
        dateInfo = dateInfo || getDateInfo(day);
        if (!dateInfo) {
          return false;
        }
        var isDateYearLaterCurrent = dateInfo.now_year > scope.calendarData.currentYear;
        var isDateMonthLaterCurrent = dateInfo.now_month > scope.calendarData.currentMonth;
        var isDateEarlierCurrent = Number(day) < dateInfo.today_date && dateInfo.now_month === scope.calendarData.currentMonth;
        if (isDateYearLaterCurrent || isDateMonthLaterCurrent || isDateEarlierCurrent) {
          return true;
        }
      };
      scope.checkTodayOrOlder = function (day) {
        var dateInfo = getDateInfo(day);
        if (dateInfo) {
          var isCurrentDate = dateInfo.today_date === Number(day);
          var isCurrentMonth = dateInfo.now_month === scope.calendarData.currentMonth;
          var isCurrentYear = dateInfo.now_year === scope.calendarData.currentYear;
          if (isCurrentDate && isCurrentMonth && isCurrentYear) {
            return 'todayDateCell';
          } else if (scope.isOlderDate(day, dateInfo)) {
            return 'olderDateCell';
          }
        }
      };

      function sortGenerator(method) {
        return function dateSort(a, b) {
          a[method].setUTCMilliseconds(0);
          b[method].setUTCMilliseconds(0);
          if (a[method].getTime() < b[method].getTime()) {
            return -1;
          } else if (a[method].getTime() > b[method].getTime()) {
            return 1;
          }
          if (a.id < b.id) {
            return -1;
          } else if (a.id > b.id) {
            return 1;
          }
          return 0;
        };
      }

      // $log.log('module map data : ' , scope.moduleMapData)
      var currentAssetUrl;
      scope.$watch('moduleMapData', function (val) {
        if (!scope.moduleMapData) {
          return;
        }
        if (scope.moduleMapData.resources && scope.moduleMapData.resources[0].slug.indexOf('gr78') > -1) {
          currentAssetUrl = GR78_ASSET_URL;
        } else if (scope.moduleMapData.resources && scope.moduleMapData.resources[0].slug.indexOf('c4') > -1) {
          currentAssetUrl = C4_ASSET_URL;
        } else {
          currentAssetUrl = 'assets/images/c3-meta/';
        }
        init_agendas();
      });

      scope.$watch('agendasListOriginal', function (val) {
        init_agendas();
      });

      function getParentResourceId(id) {
        var resource_parent;
        scope.moduleMapData.resources.forEach(function (cur_module) {
          cur_module.children.forEach(function (resource) {
            if (resource.id === id) {
              resource_parent = resource.parent_resource_id;
            }
          });
        });
        return resource_parent;
      }
      function getParentSlug(id) {
        var slug;
        scope.moduleMapData.resources.forEach(function (cur_module) {
          if (cur_module.id === id) {
            slug = cur_module.slug;
          }
        });
        return slug;
      }

      function init_agendas() {
        scope.agendasList = [];
        if (scope.agendasListOriginal) {
          scope.agendasListOriginal.forEach(function (agenda) {
            if (!agenda.archived) {
              scope.agendasList.push(agenda);
            }
          });
        }
        scope.agendasList.forEach(function (agenda) {
          agenda.startTime = new Date(agenda.date_open);
          agenda.endTime = new Date(agenda.date_close);
        });

        scope.agendasList = scope.agendasList.sort(sortGenerator(scope.listMode ? 'endTime' : 'startTime'));

        scope.agendasList = scope.agendasList.filter(function (agenda) {
          return scope.studentFilter(agenda);
        });

        scope.agendasList.forEach(function (agenda) {
          agenda.marginTop = getAgendaMarginCalculation(agenda);
          var current_resource_parent;
          var isCustom = false;
          agenda.resources.forEach(function (resource) {
            var get_parent = getParentResourceId(resource);
            if (!get_parent || current_resource_parent && get_parent !== current_resource_parent) {
              isCustom = true;
            }
            current_resource_parent = get_parent;
          });
          var parent_slug = getParentSlug(current_resource_parent);
          var isC3Module = current_resource_parent > 192 && current_resource_parent < 197;
          // $log.log('count diff : ', agenda.resources.length , getParentChildrenCount(current_resource_parent))
          //count difference to account for diag and summative
          if (getParentChildrenCount(current_resource_parent) - agenda.resources.length > 2) {
            isCustom = true;
          }
          agenda.img_url = isCustom ? 'assets/images/agenda/rulerPencil.png' : currentAssetUrl + parent_slug + '.png';

          if (scope.moduleMapData.meta_config && scope.moduleMapData.meta_config.map_config && scope.moduleMapData.meta_config.map_config.set_module_icon_names) {
            var asset_name = scope.moduleMapData.meta_config.map_config.set_module_icon_names[parent_slug] || scope.moduleMapData.meta_config.map_config.set_module_icon_names.default;
            agenda.img_url = scope.moduleMapData.meta_config.map_config.asset_url + asset_name + ".png";
          }
        });

        // $log.log('agendasList : ' , scope.agendasList);
      }

      function getParentChildrenCount(id) {
        var count = 0;
        scope.moduleMapData.resources.forEach(function (cur_module) {
          if (id === cur_module.id) {
            cur_module.children.forEach(function (child) {
              if (child.resource_type === 'lesson') {
                count++;
              }
            });
          }
        });
        return count;
      }

      scope.studentFilter = function (agenda) {
        //   $log.log('student filter : ', scope.studentList, agenda.students)
        if (agenda.is_for_all_class) {
          return true;
        }
        var found = false;
        scope.studentList.forEach(function (student) {
          if (student.selected && agenda.students.indexOf(student.user_id) > -1) {
            found = true;
          }
        });
        return found;
      };

      scope.$watch('calendarData.refreshCalendar', function (val) {
        if (val === null) {
          return;
        }
        // $log.log('refreshCalendar', val)
        init_agendas();
      });

      scope.agendasColors = ['#3499FD']; //, '#FE6462', '#71D4B7'];
      scope.agendaOnDay = function (day, agendaIndex) {
        if (day === "") {
          return false;
        }
        var compare_date = new Date(Number(scope.calendarData.currentYear), Number(scope.calendarData.currentMonth), Number(day));

        var agenda = scope.agendasList[agendaIndex];
        if (scope.compareDates.areEqual(agenda.startTime, compare_date)) {
          return 'agendaFullCalendarViewStart';
        } else if (scope.compareDates.isLater(compare_date, agenda.startTime) && scope.compareDates.isEarlier(compare_date, agenda.endTime)) {
          return 'agendaFullCalendarViewMid';
        } else if (scope.compareDates.areEqual(agenda.endTime, compare_date)) {
          return 'agendaFullCalendarViewEnd';
        }
        return false;
      };

      function getAgendaMarginCalculation(agenda) {
        var margin = 5;
        for (var i = 0; i < scope.agendasList.length; i++) {
          var cur = scope.agendasList[i];
          if (cur === agenda) {
            break;
          }
          if (scope.compareDates.wasOn(agenda.startTime, cur)) {
            margin = cur.marginTop + 35; //35//cur.marginTop>35?cur.marginTop+30:35;
          }
        }
        //   $log.log('TEST : ', agenda, margin)
        return margin;
      }

      scope.compareDates = {
        wasOn: function wasOn(date, agenda) {
          var timeless = new moment(date).format('YYYY-MM-DD'); //new Date((date.getMonth()+1)+'-'+date.getDate()+'-'+date.getFullYear())
          var timeless2 = new moment(agenda.startTime).format('YYYY-MM-DD'); //new Date((agenda.startTime.getMonth()+1)+'-'+agenda.startTime.getDate()+'-'+agenda.startTime.getFullYear())
          var timeless3 = new moment(agenda.endTime).format('YYYY-MM-DD'); //new Date((agenda.endTime.getMonth()+1)+'-'+agenda.endTime.getDate()+'-'+agenda.endTime.getFullYear())
          // $log.log('comparing : ' , timeless, timeless2, timeless3)
          return timeless >= timeless2 && timeless <= timeless3;
        },
        areEqual: function areEqual(date1, date2) {
          return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
        },
        isEarlier: function isEarlier(date1, date2) {
          var cond1 = date2.getDate() > date1.getDate();
          var cond2 = date2.getMonth() > date1.getMonth() || date2.getMonth() === date1.getMonth() && cond1;
          var cond3 = date2.getFullYear() > date1.getFullYear() || date2.getFullYear() === date1.getFullYear() && cond2;
          return cond3;
        },
        isLater: function isLater(date1, date2) {
          var cond1 = date1.getDate() > date2.getDate();
          var cond2 = date1.getMonth() > date2.getMonth() || date1.getMonth() === date2.getMonth() && cond1;
          var cond3 = date1.getFullYear() > date2.getFullYear() || date1.getFullYear() === date2.getFullYear() && cond2;
          return cond3;
        }
      };
      scope.getAgendaRibbonMargin = function (day, agenda) {
        var margin = agenda.marginTop;
        day = Number(day) < 10 ? '0' + day : day;
        var month = Number(scope.calendarData.currentMonth) + 1 < 10 ? '0' + (Number(scope.calendarData.currentMonth) + 1) : Number(scope.calendarData.currentMonth) + 1;
        // $log.log('checking : ' , scope.calendarData.currentYear+'-'+month+'-'+day)
        var compare_date = new moment(scope.calendarData.currentYear + '-' + month + '-' + day); //new Date();
        // compare_date.setFullYear(Number(scope.calendarData.currentYear));
        // compare_date.setMonth(Number(scope.calendarData.currentMonth));
        // compare_date.setDate(Number(day));
        // _.sortBy(scope.agendasList, 'date_open')
        for (var i = 0; i < scope.agendasList.length; i++) {
          var agenda_i = scope.agendasList[i];
          if (agenda_i === agenda) {
            break;
          }
          if (scope.compareDates.wasOn(compare_date, agenda_i)) {
            //   $log.log("cur margin : ", cur.marginTop, agenda.marginTop)
            margin = agenda.marginTop - agenda_i.marginTop - 30;
          }
        }
        // $log.log('margin calculation :: ', margin, i)
        return margin + 'px';
      };

      scope.getAgendaName = function (agenda) {
        return language.get(agenda.description);
        //   if(agenda.isCustom){
        //       return 'Custom Unit'
        //   }else{
        //       return language.get(agenda.module_slug);
        //   }
      };
      scope.getAgendaUrl = function (agenda) {
        return agenda.img_url;
        // return currentAssetUrl+agenda.module_slug+'.png';
      };

      scope.$on('calendar-month-change', function () {
        scope.agendaOptions.dialogShown = false;
      });

      scope.tooltipMenuPositioner = angular.element(document.querySelector('.tooltipMenuPositioner'));

      scope.agendaOptions = {
        showAgendaOptions: function showAgendaOptions(e, agenda) {
          if (scope.agendaOptions.optionsShown || scope.agendaOptions.dialogShown) {
            return;
          }
          scope.invertedMenu = e.pageY < 240;
          scope.calendarData.currentAgenda = agenda;
          $timeout(function () {
            scope.agendaOptions.optionsShown = true;
            document.addEventListener('pointerup', scope.agendaOptions.hideAgendaOptions);
            document.addEventListener('touchend', scope.agendaOptions.hideAgendaOptions);
            // $log.log('CLICKED AGENDA  : ', agenda)
            scope.tooltipMenuPositioner = angular.element(document.querySelector('.tooltipMenuPositioner'));
            scope.tooltipMenuPositioner.css('left', e.pageX + 'px');
            scope.tooltipMenuPositioner.css('top', e.pageY + 'px');
          }, 200);
        },
        hideAgendaOptions: function hideAgendaOptions() {
          $timeout(function () {
            scope.agendaOptions.optionsShown = false;
            document.removeEventListener('pointerup', scope.agendaOptions.hideAgendaOptions);
            document.removeEventListener('touchend', scope.agendaOptions.hideAgendaOptions);
          }, 100);
        },
        optionsShown: false,
        showAgendaDialog: function showAgendaDialog(e, day, month, day_val) {
          if (!day_val || scope.agendaOptions.dialogShown || scope.agendaOptions.optionsShown) {
            return;
          }
          $timeout(function () {
            var date = Number(scope.calendarData.currentMonthArray[month * 7 + day]);
            if (scope.checkTodayOrOlder(date + 1) === 'olderDateCell') {
              return;
            }
            lastClickedDay = day;
            scope.lastClickedMonthRow = month;
            scope.agendaOptions.dialogShown = true;
            document.addEventListener('pointerup', scope.agendaOptions.hideAgendaDialog);
            document.addEventListener('touchend', scope.agendaOptions.hideAgendaDialog);
            scope.tooltipMenuPositioner = angular.element(document.querySelector('.tooltipMenuPositioner'));
            scope.tooltipMenuPositioner.css('left', e.pageX + 'px');
            scope.tooltipMenuPositioner.css('top', e.pageY + 'px');
          }, 250);
        },
        hideAgendaDialog: function hideAgendaDialog() {
          $timeout(function () {
            scope.agendaOptions.dialogShown = false;
            document.removeEventListener('pointerup', scope.agendaOptions.hideAgendaDialog);
            document.removeEventListener('touchend', scope.agendaOptions.hideAgendaDialog);
          }, 100);
        },
        dialogShown: false
      };

      function hideAgendaMenusOnResize() {
        $timeout(function () {
          scope.agendaOptions.optionsShown = false;
          scope.agendaOptions.dialogShown = false;
        }, 100);
      }

      window.addEventListener('resize', hideAgendaMenusOnResize);

      scope.triggerAgendaCreate = function (fromDateCell) {
        // $log.log('CREATE NEW ANGEDA', scope.calendarData, lastClickedDay, scope.lastClickedMonthRow)
        if (lastClickedDay !== null && fromDateCell) {
          scope.calendarData.selectionDates.settingEndDate = false;
          scope.calendarData.setDateSelection(scope.lastClickedMonthRow, lastClickedDay, true, Number(scope.calendarData.currentMonth));
          var date_plus_one_week = new Date(Number(scope.calendarData.currentYear), Number(scope.calendarData.currentMonth), Number(scope.calendarData.currentMonthArray[scope.lastClickedMonthRow * 7 + lastClickedDay]) + 7);
          $log.log('creating on  : ', date_plus_one_week);
          // date_plus_one_week.setDate;
          // date_plus_one_week.setMonth(Number(scope.calendarData.currentMonth));
          // date_plus_one_week.setFullYear(Number(scope.calendarData.currentYear));
          var first_day_diff = angular.copy(date_plus_one_week);
          first_day_diff.setDate(1);
          var diff = first_day_diff.getDay();
          // $log.log(' checking set  : ' , Math.floor(date_plus_one_week.getDate()/7), date_plus_one_week.getDay(), scope.calendarData.currentMonth === date_plus_one_week.getMonth())
          scope.calendarData.setDateSelection(Math.floor((date_plus_one_week.getDate() + diff - 1) / 7), date_plus_one_week.getDay(), scope.calendarData.currentMonth === date_plus_one_week.getMonth(), date_plus_one_week.getMonth());
          // scope.calendarData.selectionDates.startDate.day = lastClickedDay;
          scope.calendarData.focusOnDate(false);
        }
        scope.newAgendaTrigger.showAgendaModule = true;
      };
      scope.shareAgenda = function () {
        scope.shareCode = userAccount.getData().user_id + '-' + scope.calendarData.currentAgenda.id;
        scope.showShareCode = true;
      };
      scope.hideShareCode = function () {
        scope.showShareCode = false;
      };
      scope.toImportAgenda = function () {
        scope.newAgendaTrigger.showAgendaModule = true;
        scope.newAgendaTrigger.selectImportAgenda();
      };

      scope.getFormattedDate = function (date) {
        var date_parse = new Date(date);
        return date_parse.getDate();
      };
      scope.hasAgendaStarted = function (date) {
        return Date.now() < Date.parse(date);
      };
      scope.agendaClosesThisMonth = function (date) {
        var date_parse = new Date(date);
        return date_parse.getMonth() === scope.calendarData.currentMonth && date_parse.getFullYear() === scope.calendarData.currentYear;
      };
      scope.noAgendasEndingThisMonth = function () {
        var found = false;
        scope.agendasList.forEach(function (agenda) {
          if (scope.agendaClosesThisMonth(agenda.date_close)) {
            found = true;
          }
        });
        return !found;
      };
      scope.noAgendasStartingThisMonth = function () {
        var found = false;
        scope.agendasList.forEach(function (agenda) {
          if (scope.agendaClosesThisMonth(agenda.date_open)) {
            found = true;
          }
        });
        return !found;
      };

      init_agendas();
    }
  };
});

angular.module('mtic.components.dashboards.teacher_general').directive("checkOverflow", function ($timeout) {
  return {
    scope: {
      "agendaItem": '=',
      "dayItem": '=',
      "calendarData": '=',
      "agendaClosesThisMonth": '=',
      "noAgendasEndingThisMonth": "=",
      "noAgendasStartingThisMonth": "="
    },
    link: function link(scope, element) {

      scope.agendaOverflowCheck = function (agenda, day) {
        var els = {
          agendaFullCalendarViewMid: document.querySelector(".dateCell"),
          agendaStart: document.querySelector(".agendaMonthCalendar__agendaStarter"),
          agendaStarterImage: document.querySelector(".agendaMonthCalendar__agendaStarterImage"),
          agendaFullCalendarViewEnd: document.querySelector(".agendaFullCalendarViewEnd")
        };

        var agendaCellDay = new Date(scope.calendarData.currentYear, scope.calendarData.currentMonth, Number(day));
        var currentDay = moment(agendaCellDay);
        var lastDayOfMonth = currentDay.clone().endOf('month');
        var firstDayOfMonth = currentDay.clone().startOf('month');
        var agendaOpenDate = new Date(agenda.date_open).getDate();
        var agendaOpenLastDayOfMonth = agendaOpenDate === lastDayOfMonth.date();

        var agendaEnd = moment(agenda.endTime);
        var agendaOpen = moment(agenda.openTime);
        var agendaLength = agendaEnd.diff(agendaOpen, "days");

        if (agendaLength > 3 && (!els.agendaFullCalendarViewMid || !els.agendaFullCalendarViewEnd && !scope.noAgendasEndingThisMonth() || !els.agendaStart && !scope.noAgendasStartingThisMonth() || !els.agendaStarterImage)) {
          return;
        }

        var daysToOverflow = 0;

        //Saturday check
        var daysTilSat = 6 - agendaCellDay.getDay();

        //End of agenda and end of month checks
        if (scope.agendaClosesThisMonth(agenda.endTime)) {
          var daysTilEndAgenda = agendaEnd.diff(currentDay, "days");

          daysToOverflow = Math.min(daysTilSat, daysTilEndAgenda);
        } else {
          var daysTilEndMonth = lastDayOfMonth.diff(currentDay, "days");

          daysToOverflow = Math.min(daysTilSat, daysTilEndMonth);
        }

        //calculating max width for span
        if (!els.agendaFullCalendarViewMid) {
          return;
        }
        var widthOfMid = els.agendaFullCalendarViewMid.clientWidth;

        var widthOfStart;
        if (!els.agendaStart) {
          widthOfStart = 0;
        } else {
          widthOfStart = els.agendaStart.clientWidth - els.agendaStarterImage.clientWidth;
        }

        var widthOfEnd;
        if (!els.agendaFullCalendarViewEnd) {
          widthOfEnd = widthOfStart;
        } else {
          widthOfEnd = els.agendaFullCalendarViewEnd.offsetWidth - els.agendaStarterImage.clientWidth;
        }

        var maxWidth;

        if (agendaLength === 1) {
          maxWidth = widthOfStart;
        } else if (agendaLength === 2 && scope.agendaClosesThisMonth()) {
          maxWidth = widthOfStart + widthOfEnd;
        } else {
          var midDaysToOverflow = daysToOverflow - 1;
          maxWidth = midDaysToOverflow * widthOfMid + widthOfStart + widthOfEnd;
        }

        return maxWidth.toString();
      };

      var setMaxWidth = function setMaxWidth() {
        var maxWidth = scope.agendaOverflowCheck(scope.agendaItem, scope.dayItem);
        if (maxWidth) {
          scope.maxWidth = maxWidth;
        }
      };
      scope.maxWidth = scope.agendaOverflowCheck(scope.agendaItem, scope.dayItem);
      $timeout(setMaxWidth, 0, true);
      $timeout(setMaxWidth, 300, true);
      scope.$watch('maxWidth', function () {
        element[0].style.overflow = "hidden";
        element[0].style.textOverflow = "ellipsis";
        element[0].style.maxWidth = scope.maxWidth + "px";
      });

      scope.$on('resize::resize', function () {
        setMaxWidth();
      });
    }
  };
});

angular.module('mtic.components.dashboards.teacher_general').directive("resize", function ($window) {
  return {
    link: function link(scope) {
      function onResize(e) {
        // Namespacing events with name of directive + event to avoid collisions
        scope.$broadcast('resize::resize');
      }

      function cleanUp() {
        angular.element($window).off('resize', onResize);
      }

      angular.element($window).on('resize', onResize);
      scope.$on('$destroy', cleanUp);
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsAgenda', function ($log, $timeout, TIMING_CONSTANTS, URL_VERSIONS, LocaleService, $q, language, EventManager, PanelFactory, TeacherDataService, api, MapStateService, GR78_ASSET_URL, C4_ASSET_URL, ModuleFilter, PlatformService, cordovaMessenger) {
  return {
    template:'<style>\n  .hide_this{\n    display:none;\n  }\n\n  #newAgendaSide .inner-viewport {\n    position: static !important;\n  }\n\n  #newAgendaSide .inner-viewport > .agendaSplitView__main {\n    position: absolute;\n    /*overflow-y: initial;\n    does not work in IE, therefore removed at source (see styles/agendaSplitView.less)*/\n  }\n\n  .copy_link_btn{\n    border-radius:4px;\n    align-self: flex-start;\n    cursor: pointer;\n    background-color: #59CCFB;\n    color:#fff;\n    font-size:12px;\n    display:flex;\n    align-items: center;\n    padding: 5px;\n    box-shadow: 0 3px #1fbbf9;\n  }\n  .copy_link_btn:hover{\n    background-color: #38c3fa;\n    box-shadow: 0 3px #06a2e0;\n\n  }\n  .copy_link_btn:active{\n    background-color: #0590c7;\n    box-shadow: #035a7c 0px 2px;\n    transform: translateY(2px);\n  }\n  .imgbox_bottom_row{\n    display: flex; flex-direction: row; justify-content: space-between;\n    padding:5px;align-items:center; padding: 0px 10px 7px 10px\n  }\n</style><div class="mtic-resource-loader-container-wrap" ng-hide="loadingStatus.done && !agendaSending"><div class="mtic-resource-loader" style="position: absolute; left: 0; right: 0; top: 30px"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div class="route-path"><div class="route-brand">{{$root.isMTIC ? \'MathemaTIC\' : \'OCMT-HSE\'}}</div><div class="route-screen" ng-click="resetAgendaView()" style="margin-right:20px;cursor:pointer;" ng-bind="getTranslation(\'27714\')">Agenda</div><div class="field has-addons" ng-hide="view_controller.custom_unit_view"><p class="control"><a class="button is-info" ng-click="goToCalendarMode()" style="font-size: 0.75rem;" ng-class="{\'is-inverted\': inListMode}"><i style="margin:2px" class="fa fa-calendar-plus-o"></i> <span ng-bind="getTranslation(\'27666\')">Calendar</span></a></p><p class="control"><a class="button is-info" ng-click="goToListMode()" style="font-size: 0.75rem;" ng-class="{\'is-inverted\': !inListMode}"><i style="margin:2px" class="fa fa-list-ul"></i> <span ng-bind="getTranslation(\'27667\')">List</span></a></p></div></div><div ng-if="loadingStatus.done && agendas.list.length === 0 && !view_controller.custom_unit_view" class="container teacherStudentsAgenda__container has-text-centered"><div class="teacherStudentsAgenda__welcomePage"><button ng-click="toggleAgendaModule(true)" class="button teacherStudentsAgenda__newAssignmentButton"><span class="icon"><i class="fa fa-plus teacherStudentsAgenda__newAssignmentButtonIcon"></i></span> <span class="teacherStudentsAgenda__newAssignmentButtonText" ng-bind="getTranslation(\'27668\')">Create New Assignment</span></button> <span class="teacherStudentsAgenda__welcomeText" ng-bind="getTranslation(\'27669\')">Welcome to the agenda. Click the button above to create your first assignment.</span> <img src="assets/images/agenda/agenda.png"></div></div><div ng-if="loadingStatus.done"><div ng-if="view_controller.calendar_view && agendas.list.length > 0" class="agendaSplitView" style="justify-content: center;"><div class="agendaSplitViewInner" style="height:100%;"><div class="agendaSplitViewNavbar"><div class="fullCalendarNavbar"><div class="fullCalendarNavbar__inner"><div class="button is-white fullCalendarNavbar__todayButton" ng-click="agenda_calendar.focusOnDate(false, true)" ng-bind="getTranslation(\'28280\')">Today</div><div class="fullCalendarNavbar__dateNav centered-flex"><span ng-click="agenda_calendar.shiftMonths(-1, true)" class="icon fullCalendarNavbar__arrow"><i class="fa fa-angle-left" aria-hidden="true"></i></span> <span ng-bind="getCalenderDisplayMonthAndYear(agenda_calendar.currentMonth, agenda_calendar.currentYear, true)" class="capitalize"></span> <span ng-click="agenda_calendar.shiftMonths(1, true)" class="icon fullCalendarNavbar__arrow"><i class="fa fa-angle-right" aria-hidden="true"></i></span></div><a class="button is-link is-outlined is-small fullCalendarNavbar__filter" ng-click="agenda_filter.showModal = true"><span ng-show="getNumStudentsSelected() === students.list.length" ng-bind="getTranslation(\'27673\')">No filter applied</span> <span ng-hide="getNumStudentsSelected() === students.list.length">Filtered to {{getNumStudentsSelected()}} of {{students.list.length}} students</span></a></div></div></div><div ng-if="!inListMode" style="padding-bottom: 120px;"><teacher-students-agenda-calendar style="width:100%;position:relative;margin-top:50px" one-month="true" calendar-data="agenda_calendar" new-agenda-trigger="new_agenda" agendas-list-original="agendas.list" module-map-data="moduleMapData" student-list="students.list"></teacher-students-agenda-calendar></div><div ng-if="inListMode" style="padding-bottom: 120px;"><teacher-students-agenda-calendar style="width:100%;position:relative;margin-top:50px" list-mode="true" calendar-data="agenda_calendar" new-agenda-trigger="new_agenda" agendas-list-original="agendas.list" module-map-data="moduleMapData" student-list="students.list"></teacher-students-agenda-calendar></div></div></div><div ng-hide="view_controller.custom_unit_view || agendas.list.length === 0"><div class="agendaArchiveButton button is-light" ng-click="agenda_archiver.toggleShowArchived(true)"><span class="icon"><i class="fa fa-trash"></i></span> <span ng-bind="getTranslation(\'27501\')">Archived Agenda Units</span></div><div class="newAgendaButton" ng-click="new_agenda.newAgendaFromToday()"><i class="fa fa-plus" aria-hidden="true"></i></div></div><div class="agendaSplitView" ng-if="view_controller.custom_unit_view"><div id="agendaSplitViewSidebar" class="agendaSplitViewSidebar" ng-class="collapseSideView ? \'agendaSplitViewSidebarCompact\':\'agendaSplitViewSidebarExpanded\'"><div ng-show="showCollapseIcon" class="collapse_icon" style="display:flex;justify-content:flex-end;width:100%;cursor: pointer;font-size:40px" ng-click="togglCollapseSideView()"><i ng-show="collapseSideView" class="fa fa-angle-double-right" aria-hidden="true" style="margin-right:40%;margin-top:10px"></i> <i ng-hide="collapseSideView" class="fa fa-angle-double-left" aria-hidden="true" style="margin-right:5%;margin-top:10px"></i></div><div class="agendaSplitViewSidebar__scrollableWrap" ng-style="{\'opacity\':collapseSideView?\'0\':\'1\'}"><img src="assets/images/agenda/agenda.png" style="width:60%; margin-left:20%"><div class="agendaSplitViewSidebar__titleWrap"><div class="agendaSplitViewSidebar__titleLabel" ng-bind="getTranslation(\'27682\')">Title:</div><div class="agendaSplitViewSidebar__titleTextWrap"><input class="agendaSplitViewSidebar__titleInput" type="text" maxlength="100" id="agenda-title" ng-blur="new_agenda.editTitle = false" ng-model="new_agenda.description"></div><span class="icon agendaSplitViewSidebar__titleEditIcon"><i class="fa fa-pencil-square-o"></i></span></div><div style="font-weight:bold;font-size:18px;margin-bottom:10px" ng-bind="getTranslation(\'agenda_items_included\')">Items included in the agenda:</div><teacher-students-agenda-selected-list module-map="moduleMapData" view-controller="view_controller" class-id="currentClassId" module-map-copy="moduleMapCopy"></teacher-students-agenda-selected-list></div><div class="agendaSplitViewSidebar__fixedBottom" ng-style="{\'opacity\':collapseSideView?\'0\':\'1\'}"><div class="agendaSplitViewSidebar__footer" ng-if="!view_controller.showCustomDraggable || custom_module_controller.current.length === 1"><div class="agendaSplitViewSidebar__footerButtonWrap" style="flex-direction: column"><label style="margin-bottom:10px"><input id="unlock_path_input" type="checkbox" class="mticCheckbox" ng-model="new_agenda.unlock_path"> <span ng-click="sendLabelClick(e , \'unlock_path_input\')" ng-bind="getTranslation(\'27692\')" style="float:left">Unlock path</span></label> <button class="button is-dark agendaSplitViewSidebar__customUnitButton" ng-click="view_controller.customActivityVisible = true" ng-disabled="view_controller.customActivityVisible" ng-style="{\'opacity\':view_controller.customActivityVisible?\'0.5\':\'1\'}" style="margin-bottom:10px"><span class="icon"><i class="fa fa-plus-square"></i></span> <span ng-bind="getTranslation(\'27683\')" style="font-size:14px !important">Insert Custom Activity</span></button> <a ng-if="showItemLinkListTable" class="button is-primary" style="margin-bottom:10px" ng-click="downloadLinksAsPdf()" ng-bind="getTranslation(\'item_links_download_csv\')">Download as CSV File</a> <a ng-if="view_controller.getSelectedItems().length > 1 && hideItemLinkListTable" class="button is-info" style="margin-bottom:10px" ng-click="openItemListLink()" ng-bind="getTranslation(\'item_links_show_links\')">Show item links list</a> <a ng-if="view_controller.getSelectedItems().length > 1 && showItemLinkListTable" class="button is-info" style="margin-bottom:10px" ng-click="hideItemsList()" ng-bind="getTranslation(\'item_links_hide_links\')">Show item links list</a></div><div ng-show="view_controller.custom_unit_view" style="display: flex"><button class="button is-success is-small wideButton" ng-click="view_controller.save_resources_continue()" ng-bind="getTranslation(\'27693\')">Save</button> <button class="button is-danger is-small wideButton" ng-click="view_controller.toCalendarView(true, true)" ng-bind="getTranslation(\'27448\')">Cancel</button></div></div><div class="agendaSplitViewSidebar__showCustomDraggable centered-flex" ng-if="view_controller.showCustomDraggable && custom_module_controller.current.length > 1"><div class="agendaSplitViewSidebar__customDraggableText" ng-bind="getTranslation(\'27690\')">Drag the custom activity up into the module map.</div><div ui-tree="treeOptions" style="border:1px #fff dashed;padding:5px;width:60%"><div ui-tree-nodes ng-model="custom_module_controller.current"><div ui-tree-node ng-repeat="item in custom_module_controller.current track by $index" ng-class="{\'hide_this\':!item.name && !isDragging}" ng-style="{\'opacity\': !item.name ? \'0\':\'1\'}" style="text-align:center;color:#333;font-size:14px;padding:5px;background-color:#fff;"><span ui-tree-handle ng-bind="item.name ? item.name : getTranslation(\'27686\')"></span></div></div></div></div></div></div><div class="agendaSplitView__main"><div ng-show="showItemLinkListTable"><table class="table is-striped agendaItemsListTable"><thead><tr><th ng-bind="getTranslation(\'item_links_item_name\')">Item Name</th><th ng-bind="getTranslation(\'item_links_link_url\')">Link URL</th></tr></thead><tbody><tr ng-repeat="item in url_list"><td ng-bind="language.get(item.name)"></td><td><a ng-click="openItemLink(item.url)" ng-bind="item.url" style="word-break: break-all"></a></td></tr></tbody></table></div><div ng-hide="showItemLinkListTable" style="display:flex;overflow:hidden" id="agendaRightView"><div class="agendaSplitViewMain__selectedItem" id="agenda_middleview"><input class="agendaSplitViewSidebar__searchField" placeholder="{{language.get(\'22608\')}}" ng-model="itemSearchInput" ng-change="itemSearchChange(itemSearchInput)"><teacher-students-agenda-perf-preview id="agendaPerfPreview" module-map="moduleMapData" filtered-view="itemSearchInput" view-controller="view_controller" class-id="currentClassId" unlock-path="new_agenda.unlock_path" module-map-copy="moduleMapCopy" style="overflow-y: auto"></teacher-students-agenda-perf-preview></div><div class="mapWrap"><div class="agendaSplitViewPadBox" style="display: none; height: 10px; width:100%"></div><div class="agendaBreadcrumbs" style="position:absolute"><div class="agendaBreadcrumbs__wrap"><a href="#" ng-click="view_controller.openMainMod()" ng-bind="selectedClass.name"></a> /<div select-box options="rlmFilteredList" model="modules.current" style="position:relative;font-size:12px;display:inline-block;margin-left: 3px" display-function="displayModule"></div></div></div><div id="agendaImgBox" class="agendaSplitViewMain__currentItemImageBox" ng-show="view_controller.highlightedItem"><span ng-click="view_controller.highlightedItem = null" style="float:right;color:#58CCFC;cursor:pointer;display:flex;padding: 2px"><i class="fa fa-times" aria-hidden="true"></i></span><div class="agendaSplitViewMain__currentItemImageWrap"><img class="agendaSplitViewMain__currentItemImage" ng-repeat="img in getCurrentItemImg() track by $index" ng-if="$index === shown_img_index" ng-src="https://d3kdl9636cazwt.cloudfront.net/website/image-previews/{{img}}.jpg" onerror="this.style.display=\'none\'" onload="this.style.display=\'block\'"></div><div class="centered-flex" style="height:20px"><div ng-repeat="item in getCurrentItemImg() track by $index" style="cursor:pointer;margin:10px 5px;width:10px;height:10px;border-radius:5px" ng-click="changeImgIndex($index)" ng-style="{\'background-color\':$index === shown_img_index?\'#0099FF\':\'#b8b8b8\'}"></div></div><div class="imgbox_bottom_row"><label><input id="inlcuded_unit_input" type="checkbox" class="mticCheckbox" style="margin-left:30px" ng-model="view_controller.highlightedItem.is_selected" ng-change="triggerAgendaSelection(view_controller.highlightedItem.slug)"> <span ng-click="sendLabelClick(e , \'inlcuded_unit_input\')" ng-bind="getTranslation(\'27681\')">Included in Unit</span></label><div class="copy_link_btn" ng-click="copyItemLink()"><i style="margin-top: 2px; margin-right: 4px;" class="fa fa-link" aria-hidden="true"></i><span ng-bind="getTranslation(\'item_links_copy_link\')">Copy Item Link</span></div></div></div><ng-switch ng-if="modules.current" on="modules.current.parent_resource_id"><module-meta-map ng-switch-default id="newAgendaSide" module-map-data="moduleMapData" intercept-click="intercept" on-item-click="selectResource"></module-meta-map></ng-switch></div></div><div ng-class="{\'is-active\' : view_controller.customActivityVisible }" class="modal mticBulmaModal mticBulmaModal--innerPanels"><div class="modal-card"><header class="modal-card-head"><div class="modal-card-title"><span class="agendaBox__headerText" ng-bind="getTranslation(\'28648\')">Custom Activity</span></div><button class="delete" aria-label="close" ng-click="view_controller.customActivityVisible = false"></button></header><section class="modal-card-body"><div class="agendaBox__panelsWrap"><div class="agendaBox__sidebar"><div class="agendaBox__sidebarHeading" ng-bind="getTranslation(\'28648\')">CUSTOM ACTIVITY</div><div class="agendaBox__sidebarItem agendaBox__sidebarItem--selected"><span ng-bind="getTranslation(\'27684\')">New</span></div></div><div class="agendaBox__main agendaBox__main--withpadding"><span style="font-size:20px;font-weight:bold" ng-click="custom_module_controller.editTitle = true" ng-bind="custom_module_controller.title !== \'\' ? custom_module_controller.title : getTranslation(\'27686\')" ng-show="!custom_module_controller.editTitle">Assignment 5B</span> <input type="text" style="border:1px #999 solid; width: 90%" placeholder="{{getTranslation(\'27686\')}}" ng-model="custom_module_controller.title" ng-show="custom_module_controller.editTitle" ng-blur="custom_module_controller.editTitle = false"><div style="border-bottom:1px #999 dashed;width:90%;height:1px;margin:20px 0px"></div><div><input type="text" style="border:1px #999 solid; width: 90%" ng-model="custom_module_controller.content" placeholder="{{getTranslation(\'27687\')}}"></div><div style="font-size:10px;margin-top:20px;display:flex"><label style="display: flex;"><input id="acknowledge_input" type="checkbox" class="mticCheckbox" ng-model="custom_module_controller.terms_box"> <span ng-click="sendLabelClick(e , \'acknowledge_input\')"><i ng-bind="getTranslation(\'27688\')">I acknowledge that the material I\'ve entered above respects all copyrights in my jurisdiction</i></span></label></div></div></div></section><footer class="modal-card-foot" style="justify-content: space-between;"><button class="button agendaBox__footerButton is-danger is-small" ng-click="view_controller.customActivityVisible = false"><span class="icon"><i class="fa fa-angle-left"></i></span><span ng-bind="getTranslation(\'27499\')">Back</span></button> <button class="button agendaBox__footerButton is-success is-small" ng-click="!custom_module_controller.terms_box ? custom_module_controller.uncheckedBoxClick() : custom_module_controller.createCustomUnit()"><span ng-bind="getTranslation(\'27498\')">Continue</span> <span class="icon"><i class="fa fa-angle-right"></i></span></button></footer></div></div><div ng-if="view_controller.customActivityVisiblezzz" style="z-index:11;position:absolute;top:10px;width:100%;height:100%;background-color:rgba(0,0,0,0.6)"><div id="custom_activity_box"><div class="agenda-box-header"><span class="agendaBox__headerText" ng-bind="getTranslation(\'28648\')">Custom Activity</span> <span ng-click="view_controller.customActivityVisible = false" style="line-height: 14px;"><img class="agendaBox__closeBtn" src="assets/images/agenda/closeBtn.png"></span></div><div style="display:flex" class="agenda-box-body"><div class="agendaBox__sidebar" style="height: unset; width: 30%;"><div class="agendaBox__sidebarHeading" ng-bind="getTranslation(\'28648\')">CUSTOM ACTIVITY</div><div class="agendaBox__sidebarItem agendaBox__sidebarItem--selected"><span ng-bind="getTranslation(\'27684\')">New</span></div><div class="agendaBox__sidebarItem"><span ng-bind="getTranslation(\'27685\')">Previously used</span></div></div><div style="width:65%;margin-left:5%;height:300px;display:flex;flex-direction:column"><span style="font-size:20px;font-weight:bold" ng-click="custom_module_controller.editTitle = true" ng-bind="custom_module_controller.title !== \'\' ? custom_module_controller.title : getTranslation(\'27686\')" ng-show="!custom_module_controller.editTitle">Assignment 5B</span> <input type="text" style="border:1px #999 solid; width: 90%" placeholder="{{getTranslation(\'27686\')}}" ng-model="custom_module_controller.title" ng-show="custom_module_controller.editTitle" ng-blur="custom_module_controller.editTitle = false"><div style="border-bottom:1px #999 dashed;width:90%;height:1px;margin:20px 0px"></div><div><input type="text" style="border:1px #999 solid; width: 90%" ng-model="custom_module_controller.content" placeholder="{{getTranslation(\'27687\')}}"></div><div style="font-size:10px;margin-top:20px;display:flex"><label style="display: flex;"><input id="acknowledge2_input" type="checkbox" class="mticCheckbox" ng-model="custom_module_controller.terms_box"> <span ng-click="sendLabelClick(e , \'acknowledge2_input\')"><i ng-bind="getTranslation(\'27688\')">I acknowledge that the material I\'ve entered above respects all copyrights in my jurisdiction</i></span></label></div></div></div><div style="display: flex;justify-content:space-between;padding:10px"><button class="button agendaBox__footerButton is-danger" ng-click="view_controller.customActivityVisible = false"><span class="icon"><i class="fa fa-angle-left"></i></span><span ng-bind="getTranslation(\'27499\')">Back</span></button> <button class="button agendaBox__footerButton is-success" ng-click="!custom_module_controller.terms_box ? custom_module_controller.uncheckedBoxClick() : custom_module_controller.createCustomUnit()"><span ng-bind="getTranslation(\'27498\')">Continue</span> <span class="icon"><i class="fa fa-angle-right"></i></span></button></div></div></div></div></div><div ng-class="{\'is-active\' : agenda_filter.showModal }" class="modal mticBulmaModal"><div class="modal-card"><header class="modal-card-head"><p class="modal-card-title"><span class="agendaBox__headerText" ng-bind="getTranslation(\'27695\')">Filter by Student</span></p><button class="delete" aria-label="close" ng-click="agenda_filter.showModal = false"></button></header><section class="modal-card-body"><div style="margin-bottom:3rem;" ng-bind="getTranslation(\'27694\')">Select the students you wish to include in the filter</div><table class="table is-hoverable"><thead><tr><th style="text-align: center;"><label class="mticCheckbox__Label"><input id="all_students_input" type="checkbox" class="mticCheckbox" ng-model="studentSelections.allSelected"> <span ng-click="sendLabelClick(e , \'all_students_input\')"></span></label></th><th><span ng-bind="language.get(\'11299\')"></span></th><th><span ng-bind="language.get(\'11300\')"></span></th></tr></thead><tbody><tr ng-repeat="student in students.list track by $index" class="agendaCalendarSidebar__tr"><td class="agendaCalendarSidebar__td agendaCalendarSidebar__td--checkbox"><label class="mticCheckbox__Label"><input id="{{\'student_input_\'+$index}}" type="checkbox" class="mticCheckbox" ng-model="student.selected" ng-change="refreshStudentFilter()"> <span ng-click="sendLabelClick(e , \'student_input_\'+$index)"></span></label></td><td><span ng-bind="student.info.first_name"></span></td><td><span ng-bind="(student.info.last_name).toUpperCase()"></span></td></tr></tbody></table><div ng-if="students.list.length === 0" ng-bind="getTranslation(\'27897\')">There are no students assigned to this class</div></section><footer class="modal-card-foot"></footer></div></div><div ng-class="{\'is-active\' : agenda_archiver.showArchived }" class="modal mticBulmaModal"><div class="modal-card"><header class="modal-card-head"><p class="modal-card-title"><span class="agendaBox__headerText" ng-bind="getTranslation(\'27501\')">Archived Agenda Units</span></p><button class="delete" aria-label="close" ng-click="agenda_archiver.toggleShowArchived(false)"></button></header><section class="modal-card-body" style="max-height:600px !important"><table class="table is-striped is-hover"><tr><th ng-bind="getTranslation(\'27898\')">Title</th><th class="agendaArchiver_dateCell" ng-bind="getTranslation(\'27678\')">Date opened</th><th class="agendaArchiver_dateCell" ng-bind="getTranslation(\'27679\')">Date Closed</th><th></th></tr><tr ng-repeat="agenda in agendas.list track by $index" ng-if="agenda.archived"><td style="font-weight:bold"><span ng-bind="language.get(agenda.description)"></span></td><td><span ng-bind="getFormattedFullDate(agenda.date_open)"></span></td><td><span ng-bind="getFormattedFullDate(agenda.date_close)"></span></td><td><button class="button is-inverse is-small" ng-click="agenda_archiver.restoreAgenda(agenda)" ng-bind="getTranslation(\'27680\')">Restore</button></td></tr></table></section><footer class="modal-card-foot"></footer></div></div><div ng-class="{\'is-active\' : agenda_calendar.showArchiveConfirm }" class="modal mticBulmaModal mticBulmaModal--small"><div class="modal-card"><header class="modal-card-head"><p class="modal-card-title"><span class="agendaBox__headerText"></span></p><button class="delete" aria-label="close" ng-click="agenda_calendar.showArchiveConfirm = false"></button></header><section class="modal-card-body"><p class="mticBulmaModal__bodyP" ng-bind="getTranslation(\'27457\')">Are you sure you want to archive this Agenda Unit?</p></section><footer class="modal-card-foot"><button class="button" ng-click="agenda_calendar.showArchiveConfirm = false" style="margin-right:20px" ng-bind="getTranslation(\'27448\')">Cancel</button> <button class="button" ng-click="agenda_archiver.archiveCurrentAgenda()" ng-bind="getTranslation(\'27449\')">Confirm</button></footer></div></div></div><div ng-class="{\'is-active\' : new_agenda.showAgendaModule }" class="modal mticBulmaModal mticBulmaModal--innerPanels"><div class="modal-card"><header class="modal-card-head"><div class="modal-card-title"><span class="agendaBox__headerPretext mticText__blue" ng-show="!new_agenda.inEditMode" ng-bind="getTranslation(\'27453\')">Create New Unit</span> <span class="agendaBox__headerPretext mticText__blue" ng-show="new_agenda.inEditMode" ng-bind="getTranslation(\'27490\')">Edit Unit</span> <span ng-bind="getTranslation(new_agenda.agenda_current_page.header)" class="agendaBox__headerText">Select your topic</span></div><button class="delete" aria-label="close" ng-click="new_agenda.confirmWizardClose ? show_close_warning = true : resetAgendaModalState()"></button></header><section class="modal-card-body"><ng-switch on="new_agenda.agenda_current_page.page"><div ng-switch-when="module_selection_page" style="display:flex;width:100%;"><div class="agendaBox__sidebar"><div ng-show="modules.current.parent_resource_id !== 6091 && modules.current.parent_resource_id !== 6000" class="agendaBox__sidebarHeading" ng-style="{visibility: ($root.isMTIC ? \'visible\' : \'hidden\')}">LUXEMBOURG</div><div ng-hide="modules.current.parent_resource_id !== 6091 && modules.current.parent_resource_id !== 6000" class="agendaBox__sidebarHeading">Cambridge Assessment</div><div class="agendaBox__sidebarItem" ng-class="{\'agendaBox__sidebarItem--selected\': !(view_controller.showCustomUnits||view_controller.showAgendaImportPanel)}" ng-click="view_controller.showCustomUnits = false;view_controller.showAgendaImportPanel = false;" style="margin-left:20px"><ng-switch on="modules.current.parent_resource_id"><span ng-switch-default>CYCLE</span> <span ng-switch-when="6000">Stage 6</span> <span ng-switch-when="6091">Stage 6</span> <span ng-switch-when="99">ES: Cycle Inférieur</span> <span ng-switch-when="385">EF: Cycle 4</span> <span ng-switch-when="317">EF: Cycle 3</span></ng-switch></div><div ng-click="view_controller.showCustomUnits = true;view_controller.showAgendaImportPanel = false" class="agendaBox__sidebarFooter centered-flex" style="cursor:pointer" ng-class="{\'agendaModuleSelected\':view_controller.showCustomUnits&&!view_controller.showAgendaImportPanel}"><img class="agendaBox__customResourceIcon" ng-src="{{view_controller.showCustomUnits&&!view_controller.showAgendaImportPanel?\'assets/images/agenda/rulerPencil_blue.png\':\'assets/images/agenda/rulerPencil_black.png\'}}"> <span ng-bind="getTranslation(\'27492\')">Custom Resources</span></div><div ng-click="view_controller.showAgendaImportPanel = true" class="agendaBox__sidebarFooter centered-flex" style="margin-top:inherit !important;cursor:pointer" ng-class="{\'agendaModuleSelected\':view_controller.showAgendaImportPanel}"><img class="agendaBox__customResourceIcon" ng-src="{{view_controller.showAgendaImportPanel?\'assets/images/agenda/import_blue.png\':\'assets/images/agenda/import_black.png\'}}"> <span ng-bind="getTranslation(\'import_agenda\')">Import an agenda</span></div></div><div class="agendaBox__main"><div class="centered-flex agendaBox__mainHeader" style="font-size:10px;padding:20px" ng-style="{\'opacity\':isShowModuleFilterHeader()?\'1\':\'0.5\'}"><label class="agendaBox__inputWrap"><input id="diagnostic_input" type="checkbox" class="mticCheckbox" ng-model="new_agenda.module_checkbox_selections.diagnostic" ng-disabled="!isShowModuleFilterHeader()"> <span ng-click="sendLabelClick(e , \'diagnostic_input\')" ng-bind="getTranslation(\'27493\')">Diagnostic</span></label> <label class="agendaBox__inputWrap"><input id="formative_input" type="checkbox" class="mticCheckbox" ng-model="new_agenda.module_checkbox_selections.formative" ng-disabled="!isShowModuleFilterHeader()"> <span ng-click="sendLabelClick(e , \'formative_input\')" ng-bind="getTranslation(\'27494\')">Formative</span></label> <label class="agendaBox__inputWrap"><input id="summative_input" type="checkbox" class="mticCheckbox" ng-model="new_agenda.module_checkbox_selections.summative" ng-disabled="!isShowModuleFilterHeader() || no_summative"> <span ng-click="sendLabelClick(e , \'summative_input\')" ng-bind="getTranslation(\'27495\')">Summative</span></label></div><div class="agendaBox__mainBody"><ul ng-if="view_controller.showCustomUnits && !view_controller.showAgendaImportPanel && !new_agenda.inEditMode"><li class="agendaBox__moduleListItem centered-flex" style="margin:10px 0px"><button class="button is-success" ng-click="new_agenda.reset(); view_controller.toCustomView()" ng-bind="getTranslation(\'27670\')" style="font-size:14px !important">Create New Custom Unit</button></li><li class="agendaBox__moduleListItem" ng-if="!custom_unit.CompetitionEntries || custom_unit.CompetitionEntries.length === 0" ng-repeat="custom_unit in custom_units_list" ng-click="$parent.new_agenda.agenda_selected_module = \'\'; $parent.new_agenda.isCustomUnit = true; agenda_calendar.currentAgenda = custom_unit; agenda_calendar.editCurrentAgenda();" ng-class="$parent.new_agenda.agenda_selected_module_id === custom_unit.id ? \'agendaModuleSelected\':\'agendaModuleUnselected\'"><div class="agendaBox__moduleWrap"><img class="agendaBox__moduleIcon" src="assets/images/agenda/rulerPencil.png"> <span class="agendaBox__moduleName" ng-click="agenda_calendar.currentAgenda = custom_unit;agenda_calendar.editCurrentAgenda()">{{custom_unit.description}}</span><div class="agendaBox__selectedModuleIconWrap" ng-show="$parent.new_agenda.agenda_selected_module === \'\' && $parent.new_agenda.agenda_selected_module_id === custom_unit.id && item.parent_resource_id !== 192"><img ng-click="view_controller.toCustomView(true, true)" src="assets/images/agenda/tools_icon.png"></div></div></li></ul><ul ng-if="view_controller.showCustomUnits && !view_controller.showAgendaImportPanel && new_agenda.inEditMode"><li class="agendaBox__moduleListItem centered-flex" style="margin:10px 0px"><button class="button is-success" ng-click="new_agenda.reset(); view_controller.toCustomView()" ng-bind="getTranslation(\'27670\')" style="font-size:14px !important">Create New Custom Unit</button></li><li class="agendaBox__moduleListItem" ng-if="!custom_unit.CompetitionEntries || custom_unit.CompetitionEntries.length === 0" ng-repeat="custom_unit in all_custom_units_list" ng-click="$parent.new_agenda.agenda_selected_module = \'\'; $parent.new_agenda.isCustomUnit = true; agenda_calendar.currentAgenda = custom_unit; agenda_calendar.editCurrentAgenda(true);" ng-class="$parent.new_agenda.agenda_selected_module_id === custom_unit.id ? \'agendaModuleSelected\':\'agendaModuleUnselected\'"><div class="agendaBox__moduleWrap"><img class="agendaBox__moduleIcon" src="assets/images/agenda/rulerPencil.png"> <span class="agendaBox__moduleName" ng-click="agenda_calendar.currentAgenda = custom_unit;agenda_calendar.editCurrentAgenda(true)">{{custom_unit.description}}</span><div class="agendaBox__selectedModuleIconWrap" ng-show="$parent.new_agenda.agenda_selected_module === \'\' && $parent.new_agenda.agenda_selected_module_id === custom_unit.id && item.parent_resource_id !== 192"><img ng-click="view_controller.toCustomView(true, true)" src="assets/images/agenda/tools_icon.png"></div></div></li></ul><ul ng-if="!view_controller.showCustomUnits && !view_controller.showAgendaImportPanel"><li class="agendaBox__moduleListItem" ng-class="$parent.new_agenda.agenda_selected_module === item.slug? \'agendaModuleSelected\':\'agendaModuleUnselected\'" ng-repeat="item in moduleMapData.resources" ng-if="checkModuleAvailable(item) && item.id !== 192" ng-click="$parent.new_agenda.agenda_selected_module = item.slug;$parent.new_agenda.isCustomUnit = false; agenda_calendar.uncheckDiagnosticFormative();"><div class="agendaBox__moduleWrap"><img class="agendaBox__moduleIcon" ng-src="{{getModuleIconAssetUrl(item)}}"> <span class="agendaBox__moduleName">{{language.get(item.slug)}}</span><div class="agendaBox__selectedModuleIconWrap" ng-show="$parent.new_agenda.agenda_selected_module === item.slug && item.parent_resource_id !== 192"><img ng-click="view_controller.toCustomView(false, false, item.slug);view_controller.openSubMod(item.slug)" src="assets/images/agenda/tools_icon.png"></div></div></li></ul><div ng-if="view_controller.showAgendaImportPanel" style="padding:40px"><span ng-bind="getTranslation(\'enter_agenda_code\')">Enter the code for the agenda:</span><br><div style="display:flex;margin-top:10px"><input class="text-selectable" type="text" maxlength="11" ng-model="agendaImporter.agendaImportCode" style="margin-right:10px"> <button class="button is-primary" ng-disable="!agendaImporter.agendaImportCode" ng-click="agendaImporter.importAgenda()" ng-bind="getTranslation(\'import\')">import</button></div></div></div></div></div><div ng-switch-when="date_selection_page" class="agendaBox__dateSelectionPage"><div class="agendaBox__dateSelectionPageHeader" ng-bind="getTranslation(\'27450\')">Click to adjust the start and end dates</div><div class="agendaBox__dateSelectionPageDivider"></div><div class="agendaBox__dateSelectionPageControls"><div class="agendaBox__dateSelectionPageRangeWrap" ng-click="agenda_calendar.focusOnDate(false)"><div class="agendaBox__dateSelectionPageRangeText" ng-bind="getTranslation(\'27451\')">Start</div><span class="agendaBox__selectionDates button" ng-class="agenda_calendar.selectionDates.settingEndDate ? null:\'button--mticBlue\'" ng-bind="moment(agenda_calendar.getDateMonthDay(true)).format(\'ddd D MMMM YYYY\')">Thu Apr 5</span></div><div class="agendaBox__arrowWrap"><img src="assets/images/agenda/arrow.png"></div><div class="agendaBox__dateSelectionPageRangeWrap" ng-click="agenda_calendar.focusOnDate(true)"><div class="agendaBox__dateSelectionPageRangeText" ng-bind="getTranslation(\'27452\')">End</div><span class="agendaBox__selectionDates button" ng-class="agenda_calendar.selectionDates.settingEndDate ? \'button--mticBlue\': null" ng-bind="moment(agenda_calendar.getDateMonthDay(false)).format(\'ddd D MMMM YYYY\')">Thu Apr 12</span></div></div><teacher-students-agenda-calendar style="width:480px" calendar-data="agenda_calendar"></teacher-students-agenda-calendar></div><div ng-switch-when="student_selection_page" style="display:flex;width:100%;"><div class="agendaBox__sidebar"><div class="agendaBox__sidebarHeading" ng-bind="getTranslation(\'27454\')">ASSIGN TO</div><div class="agendaBox__sidebarItem" ng-click="agenda_student_selection.switchTab(\'class\')" ng-class="agenda_student_selection.tab_selection === \'class\' ? \'agendaBox__sidebarItem--selected\' : null" ng-bind="getTranslation(\'27455\')">My Class</div><div class="agendaBox__sidebarItem" ng-click="agenda_student_selection.switchTab(\'student\')" ng-class="agenda_student_selection.tab_selection === \'student\' ? \'agendaBox__sidebarItem--selected\' : null" ng-bind="getTranslation(\'27456\')">Students</div><div class="agendaBox__sidebarFooter centered-flex"><label><input type="checkbox" class="mticCheckbox" ng-model="agenda_student_selection.forceReattempt" id="force_redo_input"><span ng-click="sendLabelClick(e , \'force_redo_input\')" ng-bind="getTranslation(\'27496\')">Force re-attempt</span></label></div></div><div class="agendaBox__main"><div class="agendaBox__mainHeader"><div class="agendaBox__mainHeaderGroupDropdown">(<span ng-bind="getTranslation(\'27497\')">Select students</span>)</div></div><div class="agendaBox__mainBody"><label ng-repeat="student in students.list track by $index" style="width:100%;padding:10px; display: flex; align-items: center;" class="mticCheckbox__Label"><input type="checkbox" class="mticCheckbox" ng-model="student.selected" id="{{\'selected_student_input_\'+$index}}"> <span style="flex: 1;" ng-bind="student.info.first_name" ng-click="sendLabelClick(e , \'selected_student_input_\'+$index)"></span><div style="flex: 1;" ng-bind="(student.info.last_name).toUpperCase()"></div></label></div></div></div></ng-switch></section><footer class="modal-card-foot" style="justify-content: space-between;"><button class="button agendaBox__footerButton" ng-disabled="new_agenda.cur_index === 0" ng-click="new_agenda.move_page(-1)"><span class="icon"><i class="fa fa-angle-left"></i></span><span ng-bind="getTranslation(\'27499\')">Back</span></button><div class="centered-flex"><div ng-repeat="page in new_agenda.agenda_pages track by $index" ng-style="{\'background-color\' : $parent.new_agenda.cur_index === $index ? \'#ccc\':\'#fff\'}" style="width:14px;height:14px;border-radius:7px;border: 2px #ccc solid;margin-right:10px"></div></div><button class="button agendaBox__footerButton" ng-if="new_agenda.cur_index < 2" ng-disabled="!new_agenda.isCustomUnit && new_agenda.agenda_selected_module === \'\' && new_agenda.cur_index === 0" ng-click="new_agenda.move_page(1)" style="background-color:#66CC66"><span ng-bind="getTranslation(\'27498\')">Continue</span> <span class="icon"><i class="fa fa-angle-right"></i></span></button> <button ng-if="new_agenda.cur_index > 1" class="button agendaBox__footerButton" ng-class="new_agenda.get_button_state(true)" ng-click="new_agenda.move_page(1)" style="background-color:#66CC66"><span ng-hide="new_agenda.inEditMode" ng-bind="getTranslation(\'27671\')">Create</span> <span ng-show="new_agenda.inEditMode" ng-bind="getTranslation(\'27500\')">Update</span> <span class="icon"><i class="fa fa-angle-right"></i></span></button></footer></div></div><div ng-class="{\'is-active\' : show_close_warning }" class="modal mticBulmaModal mticBulmaModal--small"><div class="modal-card"><header class="modal-card-head" style="justify-content: flex-end;"><button class="delete" ng-click="show_close_warning = false; navigate_from_agenda_warning = false;" aria-label="close"></button></header><section class="modal-card-body"><span ng-if="!navigate_from_agenda_warning" class="mticBulmaModal__bodyText" ng-bind="getTranslation(\'27447\')">Do you really want to close? All of your changes will be lost.</span> <span ng-if="navigate_from_agenda_warning" class="mticBulmaModal__bodyText" ng-bind="getTranslation(\'27696\')">Are you sure you want to navigate away from this page? All changes will be lost if you leave this page.</span></section><footer class="modal-card-foot" style="justify-content: space-between"><button class="button" ng-click="show_close_warning = false; agenda_nav_move = false; navigate_from_agenda_warning = false; new_agenda.confirmWizardClose = false;" ng-bind="getTranslation(\'27448\')">Cancel</button> <button class="button" ng-click="toggleAgendaModule(false)" ng-bind="getTranslation(\'27449\')">Confirm</button></footer></div></div>',
    scope: {
      selectedClass: '='
    },

    link: function link(scope, element) {
      TeacherDataService.isTeacherWorkspaceView = true;
      TeacherDataService.inTeacherAgendaView = true;
      scope.$on('$destroy', function () {
        MapStateService.setSelectedResourcesForAgendaCreation({});
        TeacherDataService.isTeacherWorkspaceView = false;
        TeacherDataService.inTeacherAgendaView = false;
      });

      scope.checkModuleAvailable = ModuleFilter.checkAvailable;

      var eventManager = new EventManager('teacherStudentsAgenda', scope);

      scope.isPreview = LocaleService.checkUrlVersion(URL_VERSIONS.Preview);

      scope.getTranslation = function (id) {
        return language.get(id);
      };

      scope.moment = moment;

      scope.calendarEvents = [];
      scope.language = language;
      scope.nonItemUpdates = {
        title: false,
        date: false,
        assignee: false
      };
      scope.confirmation = {
        showSendConfirmation: false
      };
      var lastItemImage;
      scope.shown_img_index = 0;
      scope.isDragging = false;
      scope.sideAreaRouterList = [];
      scope.selectedSubmod = 0;

      /**********************
          Needed Data
       **********************/
      scope.loadingStatus = {
        done: false,
        failed: false,
        refresh: false
      };
      scope.modules = {
        list: [],
        current: null,
        currentChild: null
      };
      scope.agendas = {
        list: [],
        selected: null
      };
      scope.students = {
        list: [],
        selected: null
      };

      scope.refresh = function () {
        eventManager.broadcast('teacherStudentsAgenda:refresh');
      };

      scope.isMeta = true;
      scope.$watch('modules.current', function (cur_module) {
        // $log.log('MODULES>CURRENT : ' , cur_module)
        scope.isMeta = true;
        $timeout(function () {
          if (cur_module) {
            scope.isMeta = scope.selectedSubmod > 0 ? false : true;
            scope.selectedSubmod++;
            // $log.log('watching modules current : ',  cur_module, scope.selectedSubmod)
            eventManager.broadcast('module:change:submodule', cur_module.slug);
          }
        }, 100);
      });

      scope.intercept = {};
      scope.$watch('intercept.slug', function (clicked_slug) {
        if (clicked_slug) {
          scope.modules.list.forEach(function (mod) {
            if (mod.slug === clicked_slug) {
              scope.modules.current = mod;
            }
          });
        }
      });

      scope.loadReport = function (agenda_unit_id) {
        eventManager.broadcast('agenda:to:dashboard', { agenda_unit_id: agenda_unit_id });
      };

      scope.isShowModuleFilterHeader = function () {
        return !(scope.new_agenda.agenda_selected_module.indexOf('run_like_math') > -1 || scope.view_controller.showAgendaImportPanel || scope.view_controller.showCustomUnits || scope.new_agenda && scope.new_agenda.isCustomUnit);
      };
      scope.$watch('new_agenda.agenda_selected_module', function (val) {
        if (!scope.moduleMapData) {
          return;
        }
        scope.no_summative = true && val;
        scope.moduleMapData.resources.forEach(function (mod) {
          if (mod.slug === scope.new_agenda.agenda_selected_module) {
            mod.children.forEach(function (item) {
              if (item && item.config && item.config.assessment_type === "summative") {
                scope.no_summative = false;
              }
            });
          }
        });
      });

      scope.addDocListener = function (agenda) {
        // $log.log('showing panel')
        agenda.showPanel = true; //!agenda.showPanel;
        var func = function func() {
          // $timeout(function(){
          // $log.log('hiding panel')
          document.removeEventListener('click', func);
          agenda.showPanel = false;
          // }, 100)
        };
        $timeout(function () {
          if (agenda.showPanel) {
            document.addEventListener('click', func);
          }
        }, 100);
      };
      scope.goToCalendarMode = function () {
        scope.inCalendarMode = true;
        scope.inListMode = false;
      };
      scope.goToListMode = function () {
        scope.inCalendarMode = false;
        scope.inListMode = true;
      };

      /**
       * Side tab router
       * @type {Object}
       */
      scope.sideAreaRouter = {
        current: 'agenda-viewer-map',
        set: function set(id, data) {
          $log.debug('[[teacherStudentsAgenda]] setting...', id, data);
          this.data = {};
          this.current = id;
          if (data) {
            // $log.log('Select New Agenda : ', data)

            if (data.students && !data.is_for_all_class) {
              scope.sideAreaRouterList = [];
              data.students.forEach(function (student) {
                scope.students.list.forEach(function (cur_student) {
                  if (cur_student.user_id === student) {
                    scope.sideAreaRouterList.push(cur_student);
                  }
                });
              });
            } else if (data.students && data.is_for_all_class) {
              scope.sideAreaRouterList = scope.students.list;
            }

            this.data = data;
          }
        },
        data: {},
        reset: function reset() {
          this.set('agenda-viewer-map', {});
        },
        reload: function reload() {
          var id = this.id;
          $log.debug('[[teacherStudentsAgenda]] reloading...', id);
          var sideAreaRouter = this;
          sideAreaRouter.set('agenda-viewer-map', sideAreaRouter.data);
          $timeout(function () {
            sideAreaRouter.set(id, sideAreaRouter.data);
          }, TIMING_CONSTANTS.INSTANT);
        }
        /**
         * Agenda Editor Methods
         * Todo: move to another component
         * @type {Object}
         */
      };scope.agendaEditor = {
        creationOpen: false,
        beingEdited: {},
        showItemList: true,
        assign_types: [{ id: 'class', name: 'Class' }, { id: 'students', name: 'Student(s)' }],
        reset: function reset() {
          this.beingEdited = {
            description: '',
            date_open: moment().format('YYYY-MM-DD'),
            date_close: moment().add(1, 'weeks').format('YYYY-MM-DD'),
            assign_type: this.assign_types[0]
          };
          this.mods.students.list = {};
          this.mods.resources.reset();
          this.mods.attributes.reset();
        },
        mods: {
          students: {
            getIds: function getIds() {
              return Object.keys(this.list);
            },
            list: {},
            add: function add(studentToAdd) {
              if (studentToAdd) {
                this.list[studentToAdd.user_id] = studentToAdd;
              }
            },
            remove: function remove(studentId) {
              if (this.list[studentId]) {
                delete this.list[studentId];
              }
            },
            get: function get() {
              // $log.log('getting students list:')
              return _.toArray(this.list);
            }
          },
          resources: {
            selectedCustom: {},
            existing: {},
            custom: {},
            list: [],
            initial: [],
            reset: function reset() {
              this.list = [];
              this.existing = {};
              this.custom = {};
              this.deSelectCustom();
              this.initial = [];
            },
            set: function set(resourceRefs) {
              this.reset();
              resourceRefs.forEach(function (resource) {
                scope.agendaEditor.mods.resources.add(resource);
              });
              this.initial = this.getIds();
            },
            moveDown: function moveDown(resourceId, resourceIndex) {
              if (resourceIndex < this.list.length - 1) {
                this.list.splice(resourceIndex + 1, 0, this.list.splice(resourceIndex, 1)[0]);
              }
            },
            moveUp: function moveUp(resourceId, resourceIndex) {
              if (resourceIndex > 0) {
                this.list.splice(resourceIndex - 1, 0, this.list.splice(resourceIndex, 1)[0]);
              }
            },
            getIds: function getIds() {
              return this.list.map(function (r) {
                return r.id;
              });
            },
            getCustomDefsMap: function getCustomDefsMap() {
              return this.custom;
            },
            getCustomDefsArray: function getCustomDefsArray() {
              return _.toArray(this.custom);
            },
            add: function add(resourceToAdd) {
              if (resourceToAdd && !this.existing[resourceToAdd.id]) {
                this.list.push(this.existing[resourceToAdd.id] = angular.copy(resourceToAdd));
              }
            },
            contains: function contains(resourceId) {
              var exists = false;
              if (resourceId) {
                angular.forEach(this.list, function (each) {
                  if (each.id === resourceId) {
                    exists = true;
                  }
                });
              }

              return exists;
            },
            remove: function remove(resourceId) {
              if (this.existing[resourceId]) {
                this.list = this.list.filter(function (r) {
                  return r.id !== resourceId;
                });
                if (this.existing[resourceId].deselect) {
                  this.existing[resourceId].deselect();
                }
                delete this.existing[resourceId];
                if (this.custom[resourceId]) {
                  delete this.custom[resourceId];
                }
              }
            },
            selectCustom: function selectCustom(resourceId) {
              if (this.custom[resourceId]) {
                var customResourceDetails = this.custom[resourceId];
                this.selectedCustom = {
                  value: customResourceDetails.content.value,
                  name: customResourceDetails.name,
                  slug: customResourceDetails.slug,
                  id: customResourceDetails.id,
                  exists: true
                };
              }
            },
            deSelectCustom: function deSelectCustom() {
              this.selectedCustom = {
                value: '',
                name: ''
              };
            },
            updateCustom: function updateCustom() {
              var selectedCustom = this.selectedCustom;
              var id = selectedCustom.id;
              this.custom[id].name = selectedCustom.name;
              this.custom[id].content.value = selectedCustom.value;
              this.existing[id].name = selectedCustom.name;
              this.deSelectCustom();
            },
            addCustom: function addCustom() {
              var newCustom = this.selectedCustom;
              var slug = [_.toArray(this.custom).length, String(Date.now()), Math.random().toString(36).substr(3, 7)].join('_');
              if (!isValidURL(newCustom.value)) {
                window.alert(scope.getTranslation('27689')); // please enter a valid url
              } else {
                this.list.push(this.existing[slug] = {
                  type: 'custom_resource',
                  name: newCustom.name,
                  id: slug
                });
                this.custom[slug] = {
                  type: 'custom_resource',
                  name: newCustom.name,
                  slug: slug,
                  content: {
                    value: newCustom.value,
                    container: 'link'
                  }
                };
                this.deSelectCustom();
              }
            }
          },
          hideFromStudents: false,
          attributes: {
            reset: function reset() {
              this.force_unlock.checkboxValue = false;
              this.force_unlock.set(null);
              this.force_redo = false;
              this.attempt_limit = null;
            },
            set: function set(agenda) {
              this.force_unlock.set(agenda.force_unlock || null);
              this.force_redo = !!agenda.force_redo;
              this.attempt_limit = agenda.attempt_limit || null;
            },
            get: function get() {
              return {
                force_unlock: this.force_unlock.get(),
                force_redo: this.force_redo
                // attempt_limit: this.attempt_limit < 0 ? null : this.attempt_limit,
              };
            },
            force_unlock: {
              value: '0',
              checkBoxValue: true,
              set: function set(value) {
                if (value === null) {
                  this.value = '0';
                  this.checkBoxValue = false;
                } else if (value === false) {
                  this.value = '1';
                  this.checkBoxValue = false;
                } else if (value === true) {
                  this.value = '2';
                  this.checkBoxValue = true;
                } else {
                  //default to null
                  this.value = '0';
                  this.checkBoxValue = false;
                }
              },
              update: function update() {
                if (this.checkboxValue) {
                  this.set(true);
                } else {
                  this.set(null);
                }
              },
              get: function get() {
                return this.value === '0' ? null : this.value === '1' ? false : true;
              }
            }
          }
        }

        /**********************
          Agenda Updates/Saves
         **********************/
      };scope.createNewAgenda = function () {
        scope.agendaEditor.creationOpen = true;
        scope.agendaEditor.asEdit = false;
        scope.agendas.selected = null;
        scope.agendaEditor.reset();
        scope.sideAreaRouter.reset();
        MapStateService.setSelectedResourcesForAgendaCreation({});
      };
      scope.cancelNewAgenda = function () {
        scope.atItemAddPart = false;
        scope.agendaEditor.creationOpen = false;
        scope.agendaEditor.asEdit = false;
        scope.agendaEditor.reset();
        scope.sideAreaRouter.reset();
        scope.loadingStatus.refresh = true;
        MapStateService.setSelectedResourcesForAgendaCreation({});
        $timeout(function () {
          scope.loadingStatus.refresh = false;
        });
      };
      scope.selectAgenda = function (agenda) {
        scope.agendas.selected = angular.copy(agenda);
        scope.agendaEditor.creationOpen = true;
        scope.agendaEditor.asEdit = true;
        scope.agendaEditor.reset();
        scope.sideAreaRouter.reset();
        scope.agendaEditor.beingEdited.description = agenda.description;
        scope.agendaEditor.beingEdited.date_open = agenda.date_open;
        scope.agendaEditor.mods.attributes.set(agenda);
        scope.agendaEditor.beingEdited.date_close = moment(agenda.date_close).format('YYYY-MM-DD');
        scope.agendaEditor.mods.resources.custom = angular.copy(agenda.custom_resources);
        scope.agendaEditor.mods.resources.set(agenda.resourceRefs);
        if (agenda.is_for_all_class) {
          scope.agendaEditor.beingEdited.assign_type = scope.agendaEditor.assign_types[0];
        } else {
          scope.agendaEditor.beingEdited.assign_type = scope.agendaEditor.assign_types[1];

          agenda.students.forEach(function (student) {
            scope.students.list.forEach(function (cur_student) {
              if (cur_student.user_id === student) {
                scope.agendaEditor.mods.students.add(cur_student);
              }
            });
          });

          // $log.log('from select: ', scope.students.list)
        }
        MapStateService.setSelectedResourcesForAgendaCreation(scope.agendaEditor.mods.resources);
      };
      scope.getList = function () {
        // $log.log('from get list : ', scope.agendas.selected)
        if (scope.agendas.selected && scope.agendas.selected.is_for_all_class) {
          return scope.students.list;
        } else if (scope.agendas.selected) {
          return scope.agendaEditor.mods.students;
        } else {
          return [];
        }
      };
      scope.showArchived = false;
      scope.toggleShowArchived = function () {
        scope.showArchived = !scope.showArchived;
      };
      scope.archiveAgenda = function (agenda, shouldArchive) {
        // $log.log('from archive agenda', agenda)

        var agendaUpdates = { archived: shouldArchive };
        agendaUpdates.published = shouldArchive ? false : true; //agenda.published;
        TeacherDataService.updateAgenda(currentClassId, agenda.id, agendaUpdates).then(function (data) {
          eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
        }).catch(function (err) {
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
          $log.error(err);
          window.alert(language.get('agenda_error_update'));
        });
      };
      scope.updateAgenda = function (extraProperties) {
        var agendaUpdates = angular.copy(scope.agendaEditor.beingEdited);
        if (extraProperties) {
          for (var key in extraProperties) {
            agendaUpdates[key] = extraProperties[key];
          }
        }
        agendaUpdates.date_close = moment(agendaUpdates.date_close).hour(23).minute(59).second(59).toDate();
        var agendaMods = scope.agendaEditor.mods;
        var agendaAttributes = scope.agendaEditor.mods.attributes.get();
        var allBad = agendaIsInvalid();
        if (!allBad && !scope.agendaSending) {
          scope.agendaSending = true;
          var original = scope.agendas.selected;
          agendaUpdates.resources = agendaMods.resources.getIds();
          agendaUpdates.custom_resources = agendaMods.resources.getCustomDefsArray();
          var studentIdsInt = [];
          if (agendaUpdates.assign_type.id !== 'class') {
            agendaMods.students.getIds().forEach(function (id) {
              studentIdsInt.push(Number(id));
            });
          }
          agendaUpdates.students = studentIdsInt;
          agendaUpdates.force_unlock = agendaAttributes.force_unlock;
          agendaUpdates.published = !agendaMods.hideFromStudents;

          // $log.log('updating agenda : ', agendaUpdates);
          return TeacherDataService.updateAgenda(currentClassId, original.id, agendaUpdates).then(function (data) {
            // if(!doNotRefresh){
            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
            // scope.confirmation.showSendConfirmation = false
            // }
          }).catch(function (err) {
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            window.alert(language.get('agenda_error_update'));
          });
        } else {
          window.alert(allBad);
        }
      };
      scope.togglePublishAgenda = function (agenda, publish, dontShowConfirmation) {
        var goodTogo = true;
        if (scope.agendaEditor.creationOpen && !dontShowConfirmation) {
          goodTogo = window.confirm("There is some unsaved work, this will be lost if you proceed.\nContinue?");
        }
        if (goodTogo) {
          return TeacherDataService.togglePublishAgenda(currentClassId, agenda.id, !!publish).then(function () {
            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
          }).catch(function (err) {
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            window.alert(language.get('agenda_error_publish'));
          });
        }
      };

      scope.deleteAgenda = function () {
        return TeacherDataService.deleteAgenda(currentClassId, scope.agendas.selected.id).then(function () {
          eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
        }).catch(function (err) {
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
          $log.error(err);
          window.alert(language.get('agenda_error_delete'));
        });
      };
      scope.saveAgenda = function () {
        var agendaInfo = scope.agendaEditor.beingEdited;
        var agendaMods = scope.agendaEditor.mods;
        var allBad = agendaIsInvalid();
        if (!allBad && !scope.agendaSending) {
          scope.agendaEditor.asEdit = false;
          scope.loadingStatus.done = false;
          scope.loadingStatus.failed = false;
          scope.agendaSending = true;
          var studentIdsInt = [];
          if (agendaInfo.assign_type.id !== 'class') {
            agendaMods.students.getIds().forEach(function (id) {
              studentIdsInt.push(Number(id));
            });
          }

          TeacherDataService.createAgenda(currentClassId, agendaMods.resources.getIds(), agendaInfo.description, agendaInfo.date_close, agendaInfo.date_open, agendaMods.resources.getCustomDefsMap(), studentIdsInt, scope.modules.current.id, agendaMods.attributes.get(), agendaMods.hideFromStudents).then(function () {
            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
          }).catch(function (err) {
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            window.alert(language.get('agenda_error_save'));
          });
        } else {
          window.alert(allBad);
        }
      };
      scope.saveAndPublishAgenda = function () {
        var agendaInfo = scope.agendaEditor.beingEdited;
        var agendaMods = scope.agendaEditor.mods;
        var allBad = agendaIsInvalid();
        if (!allBad && !scope.agendaSending) {
          scope.agendaEditor.asEdit = false;
          scope.loadingStatus.done = false;
          scope.loadingStatus.failed = false;
          scope.agendaSending = true;
          if (agendaMods.hideFromStudents === null) {
            // $log.log('returning')
            return;
          }
          TeacherDataService.createAgenda(currentClassId, agendaMods.resources.getIds(), agendaInfo.description, agendaInfo.date_close, agendaInfo.date_open, agendaMods.resources.getCustomDefsMap(), agendaInfo.assign_type.id === 'class' ? [] : agendaMods.students.getIds(), scope.modules.current.id, agendaMods.attributes.get(), agendaMods.hideFromStudents).then(function (agenda) {
            // scope.togglePublishAgenda(agenda,true,true).then(function(data){
            //   $log.log(data);
            $timeout(function () {
              scope.agendaSending = false;
              scope.confirmation.showSendConfirmation = false;
              eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
            }, 100);
            // });
          }).catch(function (err) {
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            // scope.agendaSending = false;
            $log.error(err);
            window.alert(language.get('agenda_error_save'));
          });
        } else {
          window.alert(allBad);
        }
      };

      scope.onSendToStudents = function (agenda) {
        if (!scope.agendas.selected) {
          scope.saveAndPublishAgenda();
        } else if (scope.agendas.selected) {
          scope.updateAgenda({ published: true });
        }
      };

      scope.onSaveDraftClicked = function () {
        if (scope.agendas.selected) {
          scope.updateAgenda();
        } else {
          scope.saveAgenda();
        }
      };

      scope.getResourceName = function (resource) {
        return resource.resource_type === 'custom_resource' ? resource.name : language.get(resource.slug) || resource.name;
      };

      scope.studentSelections = { allSelected: true };
      var timeout_selection = false;
      scope.$watch('studentSelections.allSelected', function (val) {
        if (timeout_selection) {
          return;
        }
        scope.students.list.forEach(function (student) {
          student.selected = val;
        });
        scope.agenda_calendar.refreshCalendar = !scope.agenda_calendar.refreshCalendar;
      });
      scope.refreshStudentFilter = function () {
        var found_unselected = false;
        scope.students.list.forEach(function (std) {
          if (!std.selected) {
            found_unselected = true;
          }
        });
        timeout_selection = true;
        scope.studentSelections.allSelected = !found_unselected;
        $timeout(function () {
          timeout_selection = false;
        }, 100);
        scope.agenda_calendar.refreshCalendar = !scope.agenda_calendar.refreshCalendar;
      };

      scope.selectResource = function (resource, bubbleModuleItem, dontSelectList) {
        if (bubbleModuleItem) {
          var force = dontSelectList ? dontSelectList.state : null;
          // $log.log('from agenda select resource!', scope.view_controller.highlightedItem, dontSelectList)
          if (scope.view_controller.highlightedItem && dontSelectList && !dontSelectList.dontSelect) {
            eventManager.broadcast('hide_item_selection_highlight', scope.view_controller.highlightedItem);
          }
          bubbleModuleItem.showAgendaHighlight(force, dontSelectList && (dontSelectList.highlightItem || !dontSelectList.dontSelect));
        }

        if (scope.agendaEditor.mods.resources.contains(resource.id) && (!dontSelectList || dontSelectList.state === false)) {
          scope.agendaEditor.mods.resources.remove(resource.id);
        } else if (!dontSelectList || dontSelectList.state) {
          scope.agendaEditor.mods.resources.add(angular.extend(resource, {
            deselect: bubbleModuleItem ? bubbleModuleItem.showAgendaHighlight : null
          }));
        }

        // $log.log('SELECT RESOURCE : ', scope.agendaEditor.mods.resources,bubbleModuleItem, dontSelectList)


        if (dontSelectList && dontSelectList.dontSelect) {
          return;
        }
        scope.view_controller.selectItemBySlug(resource.slug, scope.agendaEditor.mods.resources.contains(resource.id), true);
        MapStateService.setSelectedResourcesForAgendaCreation(scope.agendaEditor.mods.resources);
      };
      /**********************
              Generic
       **********************/
      var isValidURL = function isValidURL(str) {
        var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
        var regex = new RegExp(expression);
        if (!str) {
          return false;
        } else {
          return str.match(regex);
        }
      };
      var agendaIsInvalid = function agendaIsInvalid() {
        var agenda = scope.agendaEditor.beingEdited;
        if (!agenda.description) {
          return language.get('22946'); //'Please enter a valid agenda description.';
        } else if (moment(agenda.date_close).hour(23).minute(59).second(59) < moment.now()) {
          return language.get('22950'); //'The date that you selected has passed. Please select a future date.';
        } else if (!scope.agendaEditor.mods.resources.list || scope.agendaEditor.mods.resources.list.length === 0) {
          return language.get('22947'); //'Please assign items.';
        } else if (scope.agendaEditor.beingEdited.assign_type.id === 'students' && scope.agendaEditor.mods.students.get().length === 0) {
          return language.get('agenda_empty_student_list');
        } else {
          return false;
        }
      };
      var formatTime = function formatTime(time) {
        var mm = moment(time);
        return [mm.format('YYYY-MM-DD'), 'at', mm.format('ha z')].join(' '); //the default timezone is set at src/index.module.js
      };
      var resourceIsCustom = function resourceIsCustom(resource) {
        return resource.resource_type === 'custom_resource';
      };
      scope.formatTime = formatTime;
      scope.resourceIsCustom = resourceIsCustom;
      scope.getDay = function (date) {
        return moment(date).format('DD');
      };
      scope.getMonth = function (date) {
        return moment(date).format('MMM').toUpperCase();
      };

      var getEventDisplay = function getEventDisplay(openDate, CloseDate, isPublished) {
        var color = "green";
        var now = moment();
        if (now.diff(CloseDate) < 0 && isPublished) {
          color = "green";
        } else if (now.diff(CloseDate) > 0 && isPublished) {
          color = "gray";
        } else {
          color = "red";
        }

        return {
          color: color
        };
      };

      var updateCalendarEvents = function updateCalendarEvents(agendas) {
        var events = [];
        angular.forEach(agendas, function (agenda) {
          var eventOpenDate = moment(agenda.date_open);
          var eventCloseDate = moment(agenda.date_close);
          var display = getEventDisplay(eventOpenDate, eventCloseDate, agenda.published);
          var eventMonth = {
            display: display,
            eventDate: eventCloseDate,
            description: agenda.description,
            onClick: function onClick(agenda) {
              if (agenda.published) {
                scope.sideAreaRouter.set('agenda-info', agenda);
              } else {
                scope.selectAgenda(agenda);
              }
            },
            onClickParams: agenda
          };
          events.push(eventMonth);
        });

        scope.calendarEvents = events;
        eventManager.broadcast("calendarEvents:updated", events);
      };

      /**********************
              Watchers
       **********************/
      var currentClassId;

      scope.inListMode = false;
      scope.toCreationMode = function () {
        scope.inCreateListMode = true;
      };
      scope.hasAgendaStarted = function (date) {
        return Date.now() < Date.parse(date);
      };
      scope.getFormattedDate = function (date) {
        var formatted = date.split('T')[0].split('-');
        return formatted[2] + '';
      };
      var dayRef = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      scope.getFormattedDateDay = function (date) {
        var day = new Date(Date.parse(date)).getDay();
        return dayRef[day];
      };
      var monthRef = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      scope.getFormattedDateMonth = function (date) {
        var formatted = date.split('T')[0].split('-');
        return formatted[0] + ' ' + monthRef[Number(formatted[1]) - 1];
      };
      scope.isFirstShown = function (agenda_index) {
        if (agenda_index === 0) {
          return true;
        }
        return scope.getFormattedDateMonth(scope.agendas.list[agenda_index].date_open) !== scope.getFormattedDateMonth(scope.agendas.list[agenda_index - 1].date_open);
      };
      function dateSort(a, b) {
        if (Date.parse(a.date_open) < Date.parse(b.date_open)) {
          return 1;
        }
        if (Date.parse(a.date_open) > Date.parse(b.date_open)) {
          return -1;
        }
        return 0;
      }

      scope.panelDisplay = {
        slug: 'c4_m2',
        isExpanded: false,
        sub: {}
      };

      eventManager.listen('teacherStudentsAgenda:refresh', function (e, selectNewest) {
        scope.loadingStatus.done = false;
        scope.loadingStatus.failed = false;
        return TeacherDataService.getClassAgendas(currentClassId, true).then(function (agendas) {
          // $log.log('from agenda refresh : ', agendas)
          scope.agendas.list = agendas;
          scope.agendas.list.sort(dateSort);
          updateCalendarEvents(scope.agendas.list);
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = false;
          scope.agendaEditor.creationOpen = false;
          scope.agendaEditor.asEdit = false;
          scope.atItemAddPart = false;
          // scope.agendaEditor.reset();
          // scope.sideAreaRouter.reset();

          scope.loadingStatus.refresh = true;
          createCustomUnitsList();
          if (selectNewest === true) {
            var newest_id = _.max(_.map(scope.agendas.list, 'id'));
            var newest = _.find(scope.agendas.list, function (a) {
              return a.id === newest_id;
            });
            scope.agenda_calendar.currentAgenda = newest;
            scope.agenda_calendar.editCurrentAgenda(true);
            scope.new_agenda.move_page(1);
          }
          $timeout(function () {
            scope.confirmation.showSendConfirmation = false;
            scope.loadingStatus.refresh = false;
            scope.agendaSending = false;
          });
        }).catch(function (error) {
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
          scope.sideAreaRouter.reload();
          $log.error(error);
        });
      });

      function displayOrderSort(a, b) {
        if (!a.display || !b.display) {
          return 0;
        }
        if (a.display.order < b.display.order) {
          return -1;
        }
        if (a.display.order > b.display.order) {
          return 1;
        }
        return 0;
      }

      function createCustomUnitsList() {
        scope.custom_units_list = [];
        scope.all_custom_units_list = [];
        scope.agendas.list.forEach(function (agenda) {
          var is_custom = true;
          scope.moduleMapData.resources.forEach(function (mod) {
            if (mod.slug === agenda.description) {
              is_custom = false;
            }
          });
          if (is_custom && !agenda.archived) {
            scope.all_custom_units_list.push(agenda);
          }
        });
        _.forEach(scope.all_custom_units_list, function (el) {
          var is_duplicate = false;
          scope.custom_units_list.forEach(function (unit) {
            is_duplicate = is_duplicate || arraysEqual(unit.resources, el.resources) && el.description === unit.description;
          });
          if (!is_duplicate) {
            scope.custom_units_list.push(el);
          }
        });
      }
      function arraysEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) {
          return false;
        }
        for (var i = arr1.length; i--;) {
          if (arr1[i] !== arr2[i]) {
            return false;
          }
        }

        return true;
      }

      eventManager.listen('teacherStudentsAgenda:init', function (e, class_id) {
        scope.loadingStatus.done = false;
        scope.loadingStatus.failed = false;
        scope.agendaEditor.creationOpen = false;
        scope.agendaEditor.reset();
        scope.sideAreaRouter.reset();
        scope.resetAgendaModalState();
        currentClassId = class_id;
        scope.currentClassId = class_id;
        $timeout(function () {
          $q.all([TeacherDataService.getClassFullModulesStructured(class_id).then(function (moduleListFlat) {
            moduleListFlat.resources = moduleListFlat.resources.sort(displayOrderSort);
            // $log.log('moduleListFlat : ', moduleListFlat)
            scope.moduleMapData = moduleListFlat;
            scope.asset_url = scope.moduleMapData.resources && scope.moduleMapData.resources[0].parent_resource_id === 99 ? GR78_ASSET_URL : C4_ASSET_URL;

            scope.modules.list = moduleListFlat.resources;
            scope.modules.current = scope.modules.list[0];
            scope.itemsNameList = [];
            scope.rlmFilteredList = [];
            scope.modules.list.forEach(function (mod) {
              //filtering out c3 rlm modules
              if (mod.parent_resource_id !== 192 && ModuleFilter.checkAvailable(mod) && mod.id !== 192) {
                scope.rlmFilteredList.push(mod);
              }
              mod.children.forEach(function (lesson) {
                if (lesson) {
                  var name = language.get(lesson.slug);
                  if (name !== lesson.slug) {
                    scope.itemsNameList.push({ slug: lesson.slug, name: language.get(lesson.slug), id: lesson.id });
                  }
                }
              });
            });
            // $log.log('list : ', scope.itemsNameList)
          }), TeacherDataService.getClassStudents(class_id, null, true, false).then(function (currentStudents) {
            // $log.log('from get class students: ', currentStudents)
            scope.students.list = currentStudents;
            scope.students.list.forEach(function (student) {
              student.selected = true;
            });
            // $log.log('from init: ', scope.students.list)
          }), TeacherDataService.getClassAgendas(class_id, true).then(function (agendas) {
            // $log.log('from agenda init : ', agendas)
            scope.agendas.list = agendas;
            scope.agendas.list.sort(dateSort);
            updateCalendarEvents(scope.agendas.list);
            createCustomUnitsList();
          })]).then(function () {
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = false;
          }).catch(function (err) {
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            //window.alert('Something went wrong, failed to delete Agenda')
          });
        }, 500);
      });

      /**********************
            INIT
      **********************/
      TeacherDataService.getUserClasses().then(function (classes) {
        scope.classes = classes;
        scope.$watch('selectedClass', function (classroom) {
          if (classroom) {
            // $log.log('selectedClass : ', classroom)
            eventManager.broadcast('teacherStudentsAgenda:init', classroom.id);
            scope.resetAgendaModalState();
            scope.view_controller.reset();
          }
        });
      });

      scope.displaySelectedStudents = function (option) {
        return [option.info.first_name, option.info.last_name].join(' ');
      };

      scope.displayModule = function (option) {
        return language.get(option.slug);
      };

      scope.addSummativeToAgenda = function () {
        scope.moduleMapData.resources.forEach(function (resc) {
          if (resc.id === scope.modules.current.id) {
            resc.children.forEach(function (child) {
              if (child.slug.indexOf('summative') > -1) {
                scope.agendaEditor.mods.resources.add(child);
              }
            });
          }
        });
      };

      scope.atItemAddPart = false;
      scope.getAgendaBgClass = function () {
        if (scope.agendaEditor.creationOpen && !scope.atItemAddPart) {
          return 'agenda-bg-grey';
        } else if (scope.atItemAddPart) {
          return 'agenda-bg-light-grey';
        } else {
          return 'agenda-bg-white';
        }
      };

      scope.itemAddPartToggle = function (bool) {
        if (bool === false) {
          scope.atItemAddPart = false;
        } else {
          scope.atItemAddPart = true;
        }
      };

      scope.filteredNameList = [];
      scope.itemSearchChange = function (val) {
        scope.filteredNameList = [];
        if (!scope.itemsNameList) {
          return;
        }
        if (val.trim() !== '') {
          scope.filteredNameList = scope.itemsNameList.filter(function (name) {
            var nameMod = name.name.toLowerCase();
            var valMod = val.toLowerCase();
            var bool_val;
            try {
              bool_val = nameMod.match(valMod);
            } catch (e) {
              bool_val = false;
            }
            return bool_val;
          });
        }
        // $log.log('scope.filteredNameList', scope.filteredNameList);
      };

      eventManager.listen('language:change', function () {
        scope.itemsNameList = [];
        scope.modules.list.forEach(function (module) {
          module.children.forEach(function (lesson) {
            var name = language.get(lesson.slug);
            if (name !== lesson.slug) {
              scope.itemsNameList.push({ slug: lesson.slug, name: language.get(lesson.slug), id: lesson.id });
            }
          });
        });
      });

      eventManager.listen('calendar:date:selected', function (e, date) {
        if (date && !scope.agendaEditor.creationOpen) {
          scope.createNewAgenda();
          scope.agendaEditor.beingEdited.date_close = date.format("YYYY-MM-DD");
        } else if (date && scope.agendaEditor.creationOpen) {
          scope.agendaEditor.beingEdited.date_close = date.format("YYYY-MM-DD");
          scope.nonItemUpdates.date = false;
          dateChanged();
        }
      });

      scope.initializeAgendaCreationDisplay = function () {
        scope.atItemAddPart = true;
        $timeout(function () {
          if (scope.agendaEditor.asEdit) {
            if (!scope.agendas.selected.description) {
              scope.nonItemUpdates.title = true;
            }
          } else {
            scope.nonItemUpdates.title = true;
            scope.nonItemUpdates.date = true;
            scope.nonItemUpdates.assignee = true;
          }
        }, 50);
        $timeout(function () {
          if (scope.agendaEditor.asEdit) {
            if (!scope.agendas.selected.description) {
              document.getElementById("agenda-title").focus();
            }
          } else {
            document.getElementById("agenda-date").focus();
          }
        }, 100);
      };

      scope.onDateFocused = function () {
        scope.nonItemUpdates.date = true;
        $timeout(function () {
          document.getElementById("agenda-date").focus();
        }, 50);
      };

      var dateChanged = function dateChanged() {
        if (scope.nonItemUpdates.title) {
          $timeout(function () {
            document.getElementById("agenda-title").focus();
          }, 50);
        }
      };

      document.onclick = function () {
        $timeout(function () {
          if (scope.atItemAddPart && (scope.nonItemUpdates.title || scope.nonItemUpdates.date || scope.nonItemUpdates.assignee)) {
            scope.nonItemUpdates = {};
          }
        });
      };

      scope.getAgendaBgColor = function (agenda) {
        if (!agenda.published) {
          return 'agenda-bg-red';
        } else if (moment(agenda.date_close) < moment.now()) {
          return 'agenda-bg-grey';
        } else {
          return 'agenda-bg-green';
        }
      };

      scope.scrollToOptions = function (visibility) {
        if (visibility) {
          $timeout(function () {
            document.getElementById('agendaItemsOption').scrollIntoView();
          }, 50);
        }
      };

      scope.$watch('agendaEditor.beingEdited.date_close', function (val) {
        scope.nonItemUpdates.date = false;
        if (val && scope.agendaEditor.creationOpen && scope.nonItemUpdates.title) {
          dateChanged();
        }
      });

      //NEW STUFF
      scope.new_agenda = {
        unlock_path: true,
        description: '',
        unitResourcesList: [],
        isCustomUnit: false,
        showAgendaModule: false,
        confirmWizardClose: false,
        selectImportAgenda: function selectImportAgenda() {
          scope.view_controller.showAgendaImportPanel = true;
        },
        agenda_pages: [{
          page: 'module_selection_page',
          header: '27502' // select your topic
        }, {
          page: 'date_selection_page',
          header: '27491' //when
        }, {
          page: 'student_selection_page',
          header: '27672' // who?
        }],
        cur_index: 0,
        agenda_current_page: {
          page: 'module_selection_page',
          header: '27502' // select your topic
        },
        module_checkbox_selections: {
          diagnostic: true,
          formative: true,
          summative: false
        },
        agenda_selected_module: '',
        move_page: function move_page(index) {
          // if(scope.new_agenda.get_button_state(index).indexOf('disabled') > -1){
          //   return;
          // }
          var new_index = scope.new_agenda.cur_index + index;
          if (new_index > -1 && new_index < scope.new_agenda.agenda_pages.length) {
            scope.new_agenda.agenda_current_page = scope.new_agenda.agenda_pages[new_index];
            scope.new_agenda.cur_index = new_index;
            // if(scope.new_agenda.editAgendaId && scope.new_agenda.inEditMode){
            //   createNewAgendaV2(true);
            // }
          } else if (new_index >= scope.new_agenda.agenda_pages.length) {
            scope.new_agenda.showAgendaModule = false;
            createNewAgendaV2();
          }
        },
        get_button_state: function get_button_state(continue_btn) {
          if (continue_btn) {
            if (scope.new_agenda.cur_index < scope.new_agenda.agenda_pages.length && (scope.new_agenda.isCustomUnit || scope.new_agenda.agenda_selected_module !== '')) {
              return 'agenda_footer_buttons_enabled';
            } else {
              return 'agenda_footer_buttons_disabled';
            }
          } else {
            if (scope.new_agenda.cur_index > 0) {
              return 'agenda_footer_buttons_enabled';
            } else {
              return 'agenda_footer_buttons_disabled';
            }
          }
        },
        reset: function reset() {
          scope.new_agenda = {};
          scope.new_agenda = angular.copy(new_agenda_default);
        },
        newAgendaFromToday: function newAgendaFromToday() {
          scope.resetAgendaModalState();
          scope.new_agenda.showAgendaModule = true;
        }
      };
      var new_agenda_default = angular.copy(scope.new_agenda);

      function getConvertedDate(date, isStart) {
        var diff = 1; //isStart ? 0 : 1;
        var start_date = new Date();
        // $log.log('start_date MONTH 0', start_date.getMonth(), date)
        start_date.setDate(1);
        start_date.setMonth(start_date.getMonth() + date.page);
        // $log.log('start_date MONTH 1', start_date.getMonth())
        var mth_arr = constructMonthArrays(start_date.getMonth(), start_date.getFullYear());
        start_date.setDate(Number(mth_arr[date.month_row * 7 + date.day] + diff));
        // $log.log('start_date MONTH 2', start_date.getMonth())
        var moment_date;
        if (isStart) {
          moment_date = new moment(start_date).hour(0).minute(0).second(0).toDate();
        } else {
          moment_date = new moment(start_date).hour(23).minute(59).second(59).toDate();
        }
        // $log.log('start_date MONTH 3', start_date.getMonth())
        // $log.log('converted date : ' , start_date, moment_date);
        return moment_date;
      }

      function createNewAgendaV2(dontRefresh) {
        var resources = [];
        var students = [];
        var mod_id;
        var description = '';
        if (scope.new_agenda.isCustomUnit) {
          resources = scope.new_agenda.unitResourcesList;
          description = scope.new_agenda.description;
          mod_id = scope.modules.current.parent_resource_id;
        } else {
          description = scope.new_agenda.agenda_selected_module;

          scope.moduleMapData.resources.forEach(function (mod) {
            if (mod.slug === scope.new_agenda.agenda_selected_module) {
              mod.children.forEach(function (item) {
                if (item) {
                  // $log.log('adding item : ' , item)
                  if (item.config && item.config.assessment_type === "diagnostic") {
                    if (scope.new_agenda.module_checkbox_selections.diagnostic) {
                      resources.push(item.id);
                    }
                  } else if (item.config && item.config.assessment_type === "summative") {
                    if (scope.new_agenda.module_checkbox_selections.summative) {
                      resources.push(item.id);
                    }
                  } else if (scope.new_agenda.module_checkbox_selections.formative && (item.resource_type === "lesson" || item.config.assessment_type === "formative")) {
                    resources.push(item.id);
                  }
                }
              });
              mod_id = mod.id;
            }
          });
        }

        if (resources.length === 0) {
          window.alert(language.get('22947'));
          return;
        }

        var is_whole_class = true;
        scope.students.list.forEach(function (student) {
          if (student.selected) {
            students.push(student.user_id);
          } else {
            is_whole_class = false;
          }
        });

        if (is_whole_class) {
          students = [];
        }

        var start_date = getConvertedDate(scope.agenda_calendar.selectionDates.startDate, true);
        var end_date = getConvertedDate(scope.agenda_calendar.selectionDates.endDate);

        var custom_resources = {};
        scope.custom_module_controller.list.forEach(function (resource) {
          custom_resources[resource.slug] = {
            type: 'custom_resource',
            name: resource.name,
            slug: resource.slug,
            content: resource.content
          };
          custom_resources[resource.slug].content.position_data = {
            parent_slug: resource.parent_slug,
            index: resource.item_index
          };
          if (resource.id) {
            custom_resources[resource.slug].id = resource.id;
          }
        });

        if (scope.new_agenda.editAgendaId && scope.new_agenda.inEditMode) {
          var custom_arr = [];
          for (var key in custom_resources) {
            custom_arr.push(custom_resources[key]);
          }
          var agendaUpdates = {
            description: description,
            date_close: end_date,
            date_open: start_date,
            resources: resources,
            students: students,
            custom_resources: custom_arr,
            force_unlock: scope.new_agenda.unlock_path,
            force_redo: scope.agenda_student_selection.forceReattempt

            // $log.log('updating agenda : ', currentClassId, scope.new_agenda.editAgendaId, agendaUpdates);
          };return TeacherDataService.updateAgenda(currentClassId, scope.new_agenda.editAgendaId, agendaUpdates).then(function (data) {

            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
            if (!dontRefresh) {
              scope.resetAgendaModalState(true);
            }
          }).catch(function (err) {
            if (!dontRefresh) {
              scope.resetAgendaModalState(true);
            }
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            $log.error(err);
            window.alert(language.get('agenda_error_update'));
          });
        } else {
          TeacherDataService.createAgenda(currentClassId, resources, description, end_date, start_date, custom_resources, students, mod_id, {
            force_unlock: scope.new_agenda.unlock_path,
            force_redo: scope.agenda_student_selection.forceReattempt
          }, false).then(function () {
            eventManager.broadcast('teacherStudentsAgenda:refresh', currentClassId);
            if (!dontRefresh) {
              scope.resetAgendaModalState(true);
            }
          }).catch(function (err) {
            scope.loadingStatus.done = true;
            scope.loadingStatus.failed = true;
            if (!dontRefresh) {
              scope.resetAgendaModalState(true);
            }
            $log.error(err);
            window.alert(language.get('agenda_error_save'));
          });
        }

        // scope.resetAgendaModalState();
      }

      scope.resetAgendaView = function () {
        eventManager.broadcast('refresh:current:tab');
      };

      scope.resetAgendaModalState = function (reset_students) {
        scope.new_agenda.reset();
        scope.agenda_student_selection.reset();
        scope.agenda_calendar.reset();
        scope.custom_module_controller.reset();
        scope.view_controller.showAgendaImportPanel = false;

        scope.agenda_calendar.selectionDates.settingEndDate = false;

        current_date = new Date();
        var date_diff = getDateDiff(current_date);
        scope.agenda_calendar.setDateSelection(date_diff, current_date.getDay(), true, current_date.getMonth());
        var date_plus_one_week = new Date();
        date_plus_one_week.setDate(date_plus_one_week.getDate() + 7);
        var date_diff2 = getDateDiff(date_plus_one_week);
        scope.agenda_calendar.setDateSelection(date_diff2, date_plus_one_week.getDay(), current_date.getMonth() === date_plus_one_week.getMonth(), date_plus_one_week.getMonth());

        if (reset_students) {
          scope.students.list.forEach(function (student) {
            student.selected = true;
          });
        }
      };

      var current_date = new Date();
      scope.toggleAgendaModule = function (val) {
        scope.new_agenda.showAgendaModule = val;
        if (!val) {
          scope.resetAgendaModalState(true);
          scope.show_close_warning = false;
          if (scope.agenda_nav_move) {
            scope.agenda_nav_move = false;
            if (scope.saved_nav_option.class_change) {
              eventManager.broadcast('agenda_class_change_request_granted', scope.saved_nav_option.class_id);
            } else if (scope.saved_nav_option.goto_myclass) {
              eventManager.broadcast('agenda_myclasses_change_request_granted', null);
            } else {
              eventManager.broadcast('agenda_change_request_granted', scope.saved_nav_option);
            }
          }
          scope.saved_nav_option = '';
        }
      };
      var months_range = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      // var date_arr = [];
      function constructMonthArrays(month, year) {
        //var current_date = new Date();
        // for(var i = current_date.getMonth();i<12+current_date.getMonth();i++){
        var date_checker = new Date();
        date_checker.setFullYear(year);
        date_checker.setDate(1);
        date_checker.setMonth(month);

        month = month + 1;
        var month_arr = [];
        var totalDays = 1 + 2 * month + parseInt(3 * (month + 1) / 5) + year + parseInt(year / 4) - parseInt(year / 100) + parseInt(year / 400) + 2;
        var dayNo = date_checker.getDay(); //(totalDays%7)-1;
        var monthDays = months_range[month - 1];
        if (year / 4 % 1 === 0 && monthDays === 28) {
          monthDays = 29;
        }
        if (dayNo === -1) {
          dayNo = 6;
        }

        for (var k = 0; k < dayNo; k++) {
          month_arr.push('');
        }
        for (var h = 0; h < monthDays; h++) {
          month_arr.push(h);
        }
        for (var w = month_arr.length; w < Math.max(35, monthDays + dayNo); w++) {
          month_arr.push('');
        }

        // $log.log('CONSTRUCT MONTH ARRAY   : ',month, year, month_arr)
        // $log.log('date_arr : ', month_arr, year+'/'+month, monthDays, dayNo);
        return month_arr;
      }

      function getDateVal(year, month, day, start) {
        var checked_date_value = new Date(Number(year), Number(month), Number(day + 1));
        if (start) {
          checked_date_value.setHours(0, 0, 1);
        } else {
          checked_date_value.setHours(23, 59, 59);
        }
        return checked_date_value;
      }
      function isSameDate(date1, date2) {
        return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
      }

      scope.returnMonthAndYear = function (month, year, abbr) {
        var thisDate = new Date(year, month);
        return moment(thisDate).format((abbr ? 'MMM' : 'MMMM') + ' YYYY');
      };

      scope.getCalenderDisplayMonthAndYear = function (month, year, abbr) {
        // console.log("before ", thisDate)
        // console.log(moment(thisDate).format(`MMM YYYY`))

        // let thisDate = new Date(year, month);

        // console.log("after ", thisDate, month)
        // console.log(moment(thisDate).format(`MMM YYYY`))
        return moment(current_date).format((abbr ? 'MMM' : 'MMMM') + ' YYYY');
      };
      scope.lastModuleType = "initial";
      scope.month_array = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      scope.agenda_calendar = {
        reset: function reset() {
          // $log.log('FROM RESET', scope.agenda_calendar.pageCounter)
          //var counter_copy = scope.agenda_calendar.pageCounter;
          scope.agenda_calendar.focusOnDate(false, true);
          scope.agenda_calendar = {};
          scope.agenda_calendar = angular.copy(agenda_calendar_default);
          // scope.agenda_calendar.pageCounter = 0//counter_copy;
        },
        pageCounter: 0,
        currentMonth: current_date.getMonth(),
        currentYear: current_date.getFullYear(),
        nextYear: current_date.getMonth() === 11 ? current_date.getFullYear() + 1 : current_date.getFullYear(),
        currentMonthArray: constructMonthArrays(current_date.getMonth(), current_date.getFullYear()),
        nextMonthArray: constructMonthArrays((current_date.getMonth() + 1) % 12, current_date.getMonth() === 11 ? current_date.getFullYear() + 1 : current_date.getFullYear()),
        getDaysRow: function getDaysRow(index, isNext) {
          var arr = [];
          var month_indx = isNext ? scope.agenda_calendar.nextMonthArray : scope.agenda_calendar.currentMonthArray;
          for (var i = 0; i < 7; i++) {
            var val = month_indx[i + index * 7];
            if (month_indx[i + index * 7] === undefined || month_indx[i + index * 7] === null) {
              val = "";
            } else if (val !== "") {
              val++;
            }
            arr.push(val);
          }
          // $log.log('returning rows: ', arr)
          return arr;
        },
        shiftMonths: function shiftMonths(dir, allowPrevious) {
          if (scope.agenda_calendar.pageCounter + dir < 0 && !allowPrevious) {
            return;
          }
          scope.agenda_calendar.currentMonth = scope.agenda_calendar.currentMonth + dir;
          if (scope.agenda_calendar.currentMonth === -1) {
            current_date.setFullYear(current_date.getFullYear() - 1);
            current_date.setDate(1);
            current_date.setMonth(11);
            scope.agenda_calendar.currentMonth = 11;
          } else if (scope.agenda_calendar.currentMonth === 12) {
            current_date.setFullYear(current_date.getFullYear() + 1);
            current_date.setDate(1);
            current_date.setMonth(0);
            scope.agenda_calendar.currentMonth = 0;
          } else {
            current_date.setDate(1);
            current_date.setMonth(scope.agenda_calendar.currentMonth);
          }
          scope.agenda_calendar.pageCounter += dir;
          scope.agenda_calendar.currentYear = current_date.getFullYear();
          scope.agenda_calendar.nextYear = current_date.getMonth() === 11 ? current_date.getFullYear() + 1 : current_date.getFullYear();
          scope.agenda_calendar.currentMonthArray = constructMonthArrays(current_date.getMonth(), current_date.getFullYear());
          scope.agenda_calendar.nextMonthArray = constructMonthArrays((current_date.getMonth() + 1) % 12, current_date.getMonth() === 11 ? current_date.getFullYear() + 1 : current_date.getFullYear());

          // $log.log('SHIFT : ' , scope.agenda_calendar, current_date.getMonth()+'/'+current_date.getFullYear())
          scope.$broadcast('calendar-month-change');
        },
        selectionDates: {
          startDate: {
            page: 0,
            month_row: null,
            day: null
          },
          endDate: {
            page: 0,
            month_row: null,
            day: null
          },
          settingEndDate: false
        },
        setDateSelection: function setDateSelection(month_row, day, isCurrent, month_value, fromClick, full_year) {
          // $log.log('set date selection : ' , month_row, day, isCurrent, month_value, fromClick, full_year, scope.agenda_calendar.currentYear)
          if (!month_value && month_value !== 0) {
            month_value = isCurrent ? scope.agenda_calendar.currentMonth : scope.agenda_calendar.currentMonth + 1;
          }
          var year_to_use = full_year || scope.agenda_calendar.currentYear;
          if (!full_year && (month_value === 12 || scope.agenda_calendar.currentMonth === 11 && !isCurrent)) {
            year_to_use++;
            month_value = 0;
          }
          var arr_to_check = constructMonthArrays(month_value, year_to_use); //isCurrent ? scope.agenda_calendar.currentMonthArray : scope.agenda_calendar.nextMonthArray;
          // $log.log('setting selection date : ' , month_row, day,month_value,year_to_use, isCurrent, scope.agenda_calendar.selectionDates.settingEndDate, arr_to_check[month_row*7+day])
          if (!arr_to_check[month_row * 7 + day] && arr_to_check[month_row * 7 + day] !== 0 || arr_to_check[month_row * 7 + day] === "") {
            return;
          }
          var start = scope.agenda_calendar.selectionDates.startDate;
          var end = scope.agenda_calendar.selectionDates.endDate;
          var start_date_value;
          var end_date_value;

          var year_diff = year_to_use - new Date().getFullYear();

          var checked_date_value = getDateVal(year_to_use, month_value, Number(arr_to_check[month_row * 7 + day]), false);
          // $log.log('comparison : ',year_to_use, scope.agenda_calendar.currentYear, arr_to_check, month_row, day, checked_date_value, getTodayDateConverted())
          if (checked_date_value < getTodayDateConverted() && (!scope.new_agenda.inEditMode || fromClick)) {
            return;
          }

          var today_month = new Date().getMonth();
          if (scope.agenda_calendar.selectionDates.settingEndDate) {
            end.page = month_value - today_month + year_diff * 12; //isCurrent ? scope.agenda_calendar.pageCounter : scope.agenda_calendar.pageCounter+1;
            end.month_row = month_row;
            end.day = day;
            start_date_value = Number(start.page + 1 + '' + start.month_row + '' + start.day);
            end_date_value = Number(end.page + 1 + '' + end.month_row + '' + end.day);
            // $log.log('setting end date : ', end_date_value, month_value, today_month, year_diff)
            if (start_date_value >= end_date_value) {
              start.page = end.page;
              start.month_row = end.month_row;
              start.day = end.day;
            }
          } else {
            start.page = month_value - today_month + year_diff * 12; //isCurrent ? scope.agenda_calendar.pageCounter : scope.agenda_calendar.pageCounter+1;
            start.month_row = month_row;
            start.day = day;
            start_date_value = Number(start.page + 1 + '' + start.month_row + '' + start.day);
            end_date_value = Number(end.page + 1 + '' + end.month_row + '' + end.day);
            // $log.log('setting start date : ', start, start_date_value)
            if (start_date_value >= end_date_value) {
              end.page = start.page;
              end.month_row = start.month_row;
              end.day = start.day;
            }
            scope.agenda_calendar.selectionDates.settingEndDate = true;
          }
          // $log.log('selection date : ', scope.agenda_calendar.selectionDates)
        },
        getDatebasedStyle: function getDatebasedStyle(month_row, day, isCurrent) {
          var arr_to_check = isCurrent ? scope.agenda_calendar.currentMonthArray : scope.agenda_calendar.nextMonthArray;
          if (!arr_to_check[month_row * 7 + day] && arr_to_check[month_row * 7 + day] !== 0 || arr_to_check[month_row * 7 + day] === "") {
            return 'agendaDateCellRegular';
          }
          var month_value = isCurrent ? scope.agenda_calendar.currentMonth : scope.agenda_calendar.currentMonth + 1;
          // var page_check =  isCurrent ? scope.agenda_calendar.pageCounter : scope.agenda_calendar.pageCounter+1;
          var start_date_value = getConvertedDate(scope.agenda_calendar.selectionDates.startDate, true);
          var end_date_value = getConvertedDate(scope.agenda_calendar.selectionDates.endDate);
          var checked_date_value = getDateVal(scope.agenda_calendar.currentYear, month_value, Number(arr_to_check[month_row * 7 + day]), false);

          var full_class = '';

          if (checked_date_value < getTodayDateConverted(true)) {
            full_class = 'agendaDateCellRegularDisabled ';
          }
          if (isSameDate(start_date_value, checked_date_value)) {
            full_class += 'agendaDateCellStartDate';
          } else if (isSameDate(end_date_value, checked_date_value)) {
            full_class += 'agendaDateCellEndDate';
          } else if (start_date_value < checked_date_value && end_date_value > checked_date_value) {
            full_class += 'agendaDateCellBetweenDate';
          } else {
            full_class += 'agendaDateCellRegular';
          }
          return full_class;
        },
        focusOnDate: function focusOnDate(isEndDate, to_today) {
          // $log.log('focus on date : ' ,  scope.agenda_calendar)
          scope.agenda_calendar.selectionDates.settingEndDate = isEndDate;
          var page_diff = 0;
          if (to_today) {
            page_diff = scope.agenda_calendar.pageCounter * -1;
          } else {
            if (isEndDate) {
              page_diff = scope.agenda_calendar.selectionDates.endDate.page - scope.agenda_calendar.pageCounter;
            } else {
              page_diff = scope.agenda_calendar.selectionDates.startDate.page - scope.agenda_calendar.pageCounter;
            }
          }
          while (page_diff !== 0) {
            var dir = page_diff > 0 ? 1 : -1;
            scope.agenda_calendar.shiftMonths(dir, true);
            page_diff += dir * -1;
          }
        },
        showArchiveConfirm: false,
        loadCurrentAgendaReport: function loadCurrentAgendaReport() {
          // $log.log('loadCurrentAgendaReport',scope.agenda_calendar.currentAgenda)
          scope.loadReport(scope.agenda_calendar.currentAgenda.id);
        },
        editCurrentAgenda: function editCurrentAgenda(to_edit_mode) {

          scope.new_agenda.reset();

          scope.new_agenda.inEditMode = to_edit_mode || false;
          scope.new_agenda.showAgendaModule = true;
          scope.new_agenda.description = scope.agenda_calendar.currentAgenda.description;
          // $log.log("current : , ", scope.agenda_calendar.currentAgenda)

          scope.new_agenda.unitResourcesList = scope.agenda_calendar.currentAgenda.resources;

          scope.new_agenda.isCustomUnit = true;
          scope.new_agenda.editingCustomUnit = true;
          scope.moduleMapData.resources.forEach(function (mod) {
            if (mod.slug === scope.new_agenda.description) {
              scope.new_agenda.isCustomUnit = false;
              scope.new_agenda.editingCustomUnit = false;
              scope.new_agenda.agenda_selected_module = mod.slug;
            }
          });
          scope.view_controller.showCustomUnits = scope.new_agenda.isCustomUnit;
          scope.new_agenda.agenda_selected_module_id = scope.agenda_calendar.currentAgenda.id;

          scope.students.list.forEach(function (student) {
            if (!scope.agenda_calendar.currentAgenda.students || scope.agenda_calendar.currentAgenda.students.length === 0 || scope.agenda_calendar.currentAgenda.students.indexOf(student.user_id) > -1) {
              student.selected = true;
            } else {
              student.selected = false;
            }
          });

          var date_diff;var date_diff2;
          if (to_edit_mode) {
            scope.agenda_calendar.selectionDates.settingEndDate = false;
            var start_date = new Date(scope.agenda_calendar.currentAgenda.date_open);
            date_diff = getDateDiff(start_date);
            $log.log('to edit mode  : ', start_date.getMonth(), scope.agenda_calendar.currentMonth);
            scope.agenda_calendar.setDateSelection(date_diff, start_date.getDay(), true, start_date.getMonth(), false, start_date.getFullYear());
            var end_date = new Date(scope.agenda_calendar.currentAgenda.date_close);
            date_diff2 = getDateDiff(end_date);
            scope.agenda_calendar.setDateSelection(date_diff2, end_date.getDay(), start_date.getMonth() === end_date.getMonth(), end_date.getMonth(), false, end_date.getFullYear());

            scope.agenda_calendar.checkAssessmentTypes();
          }

          scope.new_agenda.unlock_path = scope.agenda_calendar.currentAgenda.force_unlock;
          scope.agenda_student_selection.forceReattempt = scope.agenda_calendar.currentAgenda.force_redo;
          scope.new_agenda.editAgendaId = scope.agenda_calendar.currentAgenda.id;
        },
        uncheckDiagnosticFormative: function uncheckDiagnosticFormative() {
          if (scope.new_agenda.agenda_selected_module.indexOf('run_like_math') > -1) {
            scope.new_agenda.module_checkbox_selections.diagnostic = false;
            scope.new_agenda.module_checkbox_selections.formative = true;
            scope.new_agenda.module_checkbox_selections.summative = false;

            scope.lastModuleType = "mathletic";
          } else if (scope.lastModuleType !== "regular") {
            scope.new_agenda.module_checkbox_selections.diagnostic = true;
            scope.new_agenda.module_checkbox_selections.formative = true;
            scope.new_agenda.module_checkbox_selections.summative = false;

            scope.lastModuleType = "regular";
          }
        },
        checkAssessmentTypes: function checkAssessmentTypes() {
          var hasDiagnostic = false;
          var hasSummative = false;
          var hasFormative = false;

          // $log.log("current agenda resources: " + scope.agenda_calendar.currentAgenda.resources);
          scope.agenda_calendar.currentAgenda.resources.forEach(function (resId) {
            var item = getItemFromId(resId);

            if (item.config.assessment_type === "diagnostic") {
              hasDiagnostic = true;
            } else if (item.config.assessment_type === "summative") {
              hasSummative = true;
            } else {
              hasFormative = true;
            }
          });

          scope.new_agenda.module_checkbox_selections.diagnostic = hasDiagnostic;
          scope.new_agenda.module_checkbox_selections.summative = hasSummative;
          scope.new_agenda.module_checkbox_selections.formative = hasFormative;
        },
        getDateMonthDay: function getDateMonthDay(forStart) {
          //$log.log('[[DATE TEST]]', scope.agenda_calendar.selectionDates)
          var date_use = scope.agenda_calendar.selectionDates.endDate;
          if (forStart) {
            date_use = scope.agenda_calendar.selectionDates.startDate;
          }
          var get_date = new moment(getConvertedDate(date_use, forStart));
          // var day = dayRef[get_date.day()].toLowerCase();
          // return day.replace(day[0], day[0].toUpperCase()) + ' ' + monthRef[get_date.month()] + ' ' + get_date.date();
          return get_date;
        }
      };
      var agenda_calendar_default = angular.copy(scope.agenda_calendar);

      function getTodayDateConverted(usePageCount) {
        var date_check = new Date();
        return date_check;
        // var date_val = usePageCount ? '1' : 1+date_check.getMonth()+'';
        // date_val += Math.floor((date_check.getDate()+date_check.getDay())/7)+''+date_check.getDay();
        // return Number(date_val);
      }

      function getDateDiff(date) {
        // $log.log('date : ', date)
        var first_day_diff = angular.copy(date);
        first_day_diff.setDate(1);
        var diff = first_day_diff.getDay();
        return Math.floor((date.getDate() + diff - 1) / 7);
      }

      scope.agenda_calendar.selectionDates.settingEndDate = false;
      var date_diff = getDateDiff(current_date);
      scope.agenda_calendar.setDateSelection(date_diff, current_date.getDay(), true, current_date.getMonth());
      var date_plus_one_week = new Date();
      date_plus_one_week.setDate(date_plus_one_week.getDate() + 7);
      var date_diff2 = getDateDiff(date_plus_one_week);
      scope.agenda_calendar.setDateSelection(date_diff2, date_plus_one_week.getDay(), current_date.getMonth() === date_plus_one_week.getMonth(), date_plus_one_week.getMonth());

      function getDayName(day, month, year) {
        var totalDays = day + 2 * month + parseInt(3 * (month + 1) / 5) + year + parseInt(year / 4) - parseInt(year / 100) + parseInt(year / 400) + 2;
        // Mod of the total number of days with 7 gives us the day number
        var dayNo = totalDays % 7;
        // if the resultant mod of 7 is 0 then its Saturday so assign the dayNo to 7
        if (dayNo === 0) {
          dayNo = 7;
        }
        return dayNo - 1; // return the repective Day Name from the array
      }

      scope.agenda_student_selection = {
        tab_selection: 'class',
        switchTab: function switchTab(val) {
          scope.agenda_student_selection.tab_selection = val;
          if (val === 'class') {
            scope.students.list.forEach(function (student) {
              student.selected = true;
            });
          } else if (val === 'student') {
            scope.students.list.forEach(function (student) {
              student.selected = false;
            });
          }
        },
        forceReattempt: true,
        reset: function reset() {
          scope.agenda_student_selection = {};
          scope.agenda_student_selection = angular.copy(agenda_student_selection_default);
        }
      };
      var agenda_student_selection_default = angular.copy(scope.agenda_student_selection);

      scope.agenda_filter = {
        showModal: false
      };

      scope.agenda_archiver = {
        showArchived: false,
        toggleShowArchived: function toggleShowArchived(val) {
          // $log.log('toggle show archive : ', val )
          scope.agenda_archiver.showArchived = val;
        },
        archiveCurrentAgenda: function archiveCurrentAgenda() {
          // $log.log('archive this : ' , scope.agenda_calendar.currentAgenda)
          scope.archiveAgenda(scope.agenda_calendar.currentAgenda, true);
          scope.agenda_calendar.showArchiveConfirm = false;
        },
        restoreAgenda: function restoreAgenda(agenda) {
          // $log.log('unarchive this : ' , agenda)
          scope.archiveAgenda(agenda, false);
        }

      };

      scope.getFormattedFullDate = function (date) {
        var date_parse = new Date(date);
        return date_parse.getFullYear() + '-' + monthRef[date_parse.getMonth()] + '-' + date_parse.getDate();
      };

      scope.getNumStudentsSelected = function () {
        var count = 0;
        try {
          _.each(scope.students.list, function (student) {
            if (student && student.selected) {
              count++;
            }
          });
          return count;
        } catch (e) {
          // $log.log('getNumStudentsSelected', count, scope.students.list)
          return 0;
        }
      };

      var get_parent_slug = function get_parent_slug(id_list) {
        for (var x = id_list.length - 1; x > -1; x--) {
          var id = id_list[x];
          for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
            var mod = scope.moduleMapData.resources[i];
            for (var j = 0; j < mod.children.length; j++) {
              var item = mod.children[j];
              if (item.id === id) {
                return mod.slug;
              }
            }
          }
        }
      };
      scope.view_controller = {
        calendar_view: true,
        custom_unit_view: false,
        highlightedItem: null,
        customActivityVisible: false,
        showAgendaImportPanel: false,
        cached_items: [],
        toCustomView: function toCustomView(applyCustomSelection, delay, setModuleSlug) {
          var time = 0;
          if (delay) {
            time = 200;
          }
          $timeout(function () {
            if (scope.new_agenda.editAgendaId) {
              scope.view_controller.cached_items = [];
            }
            eventManager.broadcast('teacher:toggle:Sidepanel', false);
            scope.view_controller.calendar_view = false;
            scope.new_agenda.showAgendaModule = false;
            // $log.log('checking : ' , scope.new_agenda.editAgendaId)
            scope.new_agenda.description = setModuleSlug ? language.get(setModuleSlug) : scope.new_agenda.description || scope.getTranslation('28844');
            if (!scope.new_agenda.inEditMode || !scope.new_agenda.editingCustomUnit) {
              // if (!scope.new_agenda.description){
              //   scope.new_agenda.description = scope.getTranslation('28844');
              // }
              scope.view_controller.highlightedItem = null;
            }
            scope.new_agenda.agenda_selected_module = '';
            if (applyCustomSelection) {
              if (setModuleSlug) {
                scope.view_controller.preticked_items = [];
                scope.moduleMapData.resources.forEach(function (mod) {
                  if (mod.slug === setModuleSlug) {
                    scope.modules.current = mod;
                    mod.children.forEach(function (item) {
                      if (item) {
                        if (item.config && item.config.assessment_type === "diagnostic") {
                          if (scope.new_agenda.module_checkbox_selections.diagnostic) {
                            scope.view_controller.preticked_items.push(item.id);
                          }
                        } else if (item.config && item.config.assessment_type === "summative") {
                          if (scope.new_agenda.module_checkbox_selections.summative) {
                            scope.view_controller.preticked_items.push(item.id);
                          }
                        } else if (scope.new_agenda.module_checkbox_selections.formative && (item.resource_type === "lesson" || item.config.assessment_type === "formative")) {
                          scope.view_controller.preticked_items.push(item.id);
                        }
                      }
                    });
                  }
                });
                // $timeout(function(){
                //   eventManager.broadcast('tick:module', setModuleSlug)
                // }, 500)
              } else {
                scope.view_controller.preticked_items = scope.new_agenda.unitResourcesList;
                var parent_slug = get_parent_slug(scope.view_controller.preticked_items);
                //if(parent_slug && parent_slug.indexOf('run_like_math') === -1){
                scope.view_controller.openSubMod(parent_slug);
                //}
              }

              // $log.log('apply ticks : ', scope.view_controller.preticked_items)
            }
            scope.view_controller.custom_unit_view = true;

            if (scope.custom_units_list.length > 0 && !scope.custom_units_list[0].id) {
              scope.custom_units_list.splice(0, 1);
            }
          }, time);
        },
        toCalendarView: function toCalendarView(keepPopup, keep_temp) {
          scope.isMeta = true;
          var temp = scope.new_agenda.agenda_selected_module_id;
          scope.resetAgendaModalState(true);
          scope.view_controller.custom_unit_view = false;
          scope.view_controller.calendar_view = true;
          scope.new_agenda.showAgendaModule = keepPopup || false;
          scope.view_controller.preticked_items = null;
          scope.new_agenda.confirmWizardClose = true;
          if (keep_temp) {
            scope.new_agenda.agenda_selected_module_id = temp;
          }
        },
        save_resources_continue: function save_resources_continue() {
          var resources = scope.view_controller.getSelectedItems();
          scope.view_controller.cached_items = resources;
          // $log.log('save resource continue  : ', resources)
          var resources_id = [];
          resources.forEach(function (item) {
            if ((item.type === 'custom_resource' || item.resource_type === 'custom_resource') && item.slug) {
              resources_id.push(item.id ? item.id : item.slug);
              scope.custom_module_controller.list.push(item);
            } else {
              if (item.id && resources_id.indexOf(item.id) === -1) {
                resources_id.push(item.id);
              } else {
                var slug_id = getItemFromSlug(item.slug);
                if (slug_id) {
                  resources_id.push(slug_id.id);
                }
              }
            }
          });
          if (resources_id.length === 0) {
            window.alert(language.get('22947'));
            return;
          }
          //scope.new_agenda.move_page(1);
          scope.new_agenda.isCustomUnit = true;
          scope.new_agenda.editingCustomUnit = true;
          scope.new_agenda.unitResourcesList = resources_id;
          scope.new_agenda.showAgendaModule = true;
          scope.view_controller.custom_unit_view = false;
          scope.view_controller.calendar_view = true;
          scope.view_controller.showCustomUnits = true;

          if (scope.new_agenda.editAgendaId && scope.new_agenda.inEditMode) {
            createNewAgendaV2(true);
          } else {
            scope.custom_units_list.splice(0, 0, { description: scope.new_agenda.description, resources: resources_id });
          }
        },
        showCustomDraggable: false,
        openSubMod: function openSubMod(slug) {
          // $log.log('open sub mod : ' , slug)
          scope.isMeta = false;
          $timeout(function () {
            eventManager.broadcast('module:change:submodule', slug);
            // eventManager.broadcast('retrigger-workspace-filters', slug);
          }, 1000);
        },
        openMainMod: function openMainMod(slug) {
          scope.isMeta = true;
          scope.view_controller.highlightedItem = null;
          eventManager.broadcast('module:change:meta', slug);
        },
        reset: function reset() {
          scope.view_controller = {};
          scope.view_controller = angular.copy(view_controller_default);
        },
        copyItemLink: function copyItemLink(item) {
          scope.copyItemLink();
        }
      };
      var view_controller_default = angular.copy(scope.view_controller);

      eventManager.listen('module:change:meta', function () {
        scope.isMeta = true;
        scope.view_controller.highlightedItem = null;
      });

      function getItemFromSlug(slug) {
        for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
          for (var j = 0; j < scope.moduleMapData.resources[i].children.length; j++) {
            var item = scope.moduleMapData.resources[i].children[j];

            if (item.slug === slug) {
              return item;
            }
          }
        }
      }

      function getItemFromId(id) {
        for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
          for (var j = 0; j < scope.moduleMapData.resources[i].children.length; j++) {
            var item = scope.moduleMapData.resources[i].children[j];

            if (item.id === id) {
              return item;
            }
          }
        }
      }

      scope.custom_module_controller = {
        current: [{}],
        list: [],
        toTitleEdit: function toTitleEdit() {
          scope.custom_module_controller.editTitle = true;
          // document.getElementById('custom_activity_box').addEventListener('pointerdown', endTitleEdit)
        },
        content: '',
        title: '', // custom module title
        editTitle: false,
        uncheckedBoxClick: function uncheckedBoxClick() {
          window.alert(scope.getTranslation('27735')); //'You must click the check box to proceed.'
        },
        createCustomUnit: function createCustomUnit() {
          var slug = [_.toArray(this.custom).length, String(Date.now()), Math.random().toString(36).substr(3, 7)].join('_');
          if (!isValidURL(scope.custom_module_controller.content)) {
            window.alert(scope.getTranslation('27689')); // please enter a valid url
          } else {
            // scope.custom_module_controller.current = [];
            scope.custom_module_controller.current.push({
              type: 'custom_resource',
              name: scope.custom_module_controller.title || 'custom_resource',
              slug: slug,
              content: {
                value: scope.custom_module_controller.content,
                container: 'link'
              },
              show: true,
              is_selected: true
            });
            // $log.log('CREATING CUSTOM UNIT :  ', scope.custom_module_controller.current)

            scope.view_controller.showCustomDraggable = true;
            scope.view_controller.customActivityVisible = false;
          }
        },
        reset: function reset() {
          scope.custom_module_controller = {};
          scope.custom_module_controller = angular.copy(custom_module_controller_default);
        }
      };
      var custom_module_controller_default = angular.copy(scope.custom_module_controller);

      scope.getModuleIconAssetUrl = function (item) {
        if (scope.moduleMapData && scope.moduleMapData.meta_config && scope.moduleMapData.meta_config.map_config && scope.moduleMapData.meta_config.map_config.set_module_icon_names) {
          var asset_name = scope.moduleMapData.meta_config.map_config.set_module_icon_names[item.slug] || scope.moduleMapData.meta_config.map_config.set_module_icon_names.default;
          return scope.moduleMapData.meta_config.map_config.asset_url + asset_name + ".png";
        }
        if (item.config.map_config && item.config.map_config.asset_url) {
          return item.config.map_config.asset_url + item.slug + '.png';
        }
        return PanelFactory.getModuleIconAssetUrl(item.slug, null, item.parent_resource_id);
      };

      var last_image_url = '';
      scope.getCurrentItemImg = function () {
        if (!scope.view_controller.highlightedItem) {
          return;
        }
        var item = getItemFromSlug(scope.view_controller.highlightedItem.slug);
        if (!item) {
          return;
        }
        if (item !== lastItemImage) {
          lastItemImage = item;
          scope.shown_img_index = 0;
        }
        // $log.log('view_controller.highlightedItem : ', item, scope.view_controller.highlightedItem);
        var cur_img = PanelFactory.getItemImage(item);
        return cur_img;
      };

      scope.getSelectedItemUrl = function (override_item) {
        var item_to_use = override_item || scope.view_controller.highlightedItem;
        var item = getItemFromSlug(item_to_use.slug);
        if (!item_to_use || !scope.modules.list || item.config.assessment_type === "summative") {
          return '';
        }
        var location_host = window.location.host;
        if (location_host.indexOf('mathematic.org') > -1 || location_host.indexOf('mathematic.lu') > -1) {
          location_host += '/app2';
        }
        return window.location.href.split('://')[0] + '://' + location_host + '/#open_item_link=true&module_id=' + scope.modules.list[0].parent_resource_id + '&item_id=' + getItemFromSlug(item_to_use.slug).id;
      };

      scope.togglCollapseSideView = function () {
        scope.collapseSideView = !scope.collapseSideView;
        eventManager.broadcast('triggerMapResize');
      };

      scope.showCollapseIcon = window.innerWidth < 1225;
      window.addEventListener("resize", function () {
        scope.showCollapseIcon = window.innerWidth < 1225;
        if (window.innerWidth >= 1225) {
          scope.collapseSideView = false;
        }
      });

      scope.openItemListLink = function () {
        scope.url_list = [];
        _.each(scope.view_controller.getSelectedItems(), function (item) {
          var item_url = scope.getSelectedItemUrl(item);
          if (item_url) {
            scope.url_list.push({ name: item.slug, url: item_url });
          }
        });
        scope.hideItemLinkListTable = false;
        $timeout(function () {
          scope.showItemLinkListTable = true;
        }, 200);
      };

      scope.openItemLink = function (url) {
        if (PlatformService.isApp) {
          cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: url });
        } else {
          window.open(url, '_blank');
        }
      };

      scope.copyItemLink = function () {
        if (!navigator.clipboard) {
          //edge and ie support
          var textArea = document.createElement("textarea");
          textArea.value = scope.getSelectedItemUrl();
          textArea.style.position = "fixed";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          return;
        }
        navigator.clipboard.writeText(scope.getSelectedItemUrl());
      };

      scope.downloadLinksAsPdf = function () {
        var filename = 'item_links_' + moment().format('YYYYMMDD') + '.csv';
        var file_text = 'sep=;\n' + language.get('item_links_item_name') + ';' + language.get('item_links_link_url') + '\r\n';
        _.each(scope.url_list, function (item) {
          var item_name = language.get(item.name);
          file_text += '"' + item_name.split(';').join('\;') + '"' + ';' + item.url + '\r\n';
        });

        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(file_text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      };

      scope.hideItemLinkListTable = true;
      scope.hideItemsList = function () {
        scope.showItemLinkListTable = false;
        $timeout(function () {
          scope.hideItemLinkListTable = true;
        }, 200);
      };
      eventManager.listen('module:select:resource', function (e, item) {
        if (scope.showItemLinkListTable) {
          scope.openItemListLink();
        }
      });

      scope.$watch('view_controller.highlightedItem', function (val, old) {
        scope.shown_img_index = 0;
        if (val) {
          var agendaImgBox = document.getElementById('agendaImgBox');
          // if(agendaImgBox){       
          //   var _canvasEl = document.getElementById('module-item-map-canvas')
          //   var middleview = document.getElementById('agenda_middleview')
          //   agendaImgBox.style.top = _canvasEl.height/2 - agendaImgBox.offsetHeight/2 - 380 + 'px'
          //   agendaImgBox.style.left = _canvasEl.width/2 - agendaImgBox.offsetWidth/2 + middleview.offsetWidth - 120 + 'px'
          // }
        } else {
          eventManager.broadcast('hide_item_selection_highlight', old);
        }
      });

      scope.changeImgIndex = function (index) {
        scope.shown_img_index = index;
      };

      scope.treeOptions = {
        dragStart: function dragStart(evt, smth) {
          // $log.log('DRAGGING START:  ', evt, smth)
          scope.isDragging = true;
        },
        dragStop: function dragStop() {
          // $log.log('DRAGGING STOP:  ')
          scope.isDragging = false;
        }
      };

      eventManager.listen('request_agenda_change', function (e, option) {
        // $log.log('got agenda change request : ', option)
        if (scope.new_agenda.showAgendaModule || scope.view_controller.custom_unit_view) {
          scope.show_close_warning = true;
          scope.navigate_from_agenda_warning = true;
          scope.agenda_nav_move = true;
          scope.saved_nav_option = option;
        } else {
          if (option.class_change) {
            eventManager.broadcast('agenda_class_change_request_granted', option.class_id);
            return;
          } else if (option.goto_myclass) {
            eventManager.broadcast('agenda_myclasses_change_request_granted', null);
          }
          eventManager.broadcast('agenda_change_request_granted', option);
        }
      });

      eventManager.listen('module:change:metaToSub', function (e, data) {
        if (!data.parent_resource_id) {
          var item = getItemFromSlug(data.slug);
          data.parent_resource_id = item.parent_resource_id;
        }
        var mod;
        for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
          if (scope.moduleMapData.resources[i].id === data.parent_resource_id) {
            mod = scope.moduleMapData.resources[i];
            break;
          }
        }
        scope.modules.current = mod;
        $timeout(function () {
          eventManager.broadcast('module:select:resource', data);
        }, 500);
      });

      eventManager.listen('retrigger-workspace-filters', function (e, args) {
        scope.modules.current = null;
        $timeout(function () {
          // if(args==="run_like_math"){
          //   scope.moduleMapData.resources.forEach( function(mod){
          //     if(mod.slug === args){
          //       scope.modules.current = mod;
          //     }
          //   });
          // }else{
          scope.modules.list.forEach(function (mod) {
            if (mod.slug === args) {
              scope.modules.current = mod;
            }
          });
          // }
        }, 50);
      });
      eventManager.listen('module:change:run_like_math', function (e, mod) {
        // $log.log('here !')
        $timeout(function () {
          scope.modules.current = mod;
        }, 100);
      });

      scope.triggerAgendaSelection = function (slug) {
        eventManager.broadcast('toggle_item_selection_highlight', slug);
      };
      scope.filtered_get = function (slug) {
        if (slug === 'run_like_math' || slug.indexOf('run_like_math') === -1 || slug.indexOf('lv_') === -1) {
          return language.get(slug);
        } else {
          var splt = slug.split('_');
          var level = '';
          if (!isNaN(splt[splt.length - 1])) {
            level = splt[splt.length - 1];
          }
          var trans_slug = slug.replace('_' + level, '');
          //run_like_math_obj[trans_slug][language.getCurrentSelectedLanguage()]
          return language.get(trans_slug) + ' ' + level;
        }
      };
      scope.agendaImporter = {
        agendaImportCode: '',
        importAgenda: function importAgenda() {
          var regex = /^[0-9]*\-[0-9]+$/;
          var matches = scope.agendaImporter.agendaImportCode.match(regex);
          if (!matches) {
            window.alert(scope.getTranslation('enter_valid_code'));
            return;
          }
          var agenda_code = scope.agendaImporter.agendaImportCode.split('-')[1];
          for (var i = 0; i < scope.agendas.list.length; i++) {
            if (scope.agendas.list[i].id + '' === agenda_code) {
              window.alert('Agenda already exists');
              return;
            }
          }

          // $log.log('importing : ' , scope.agendaImporter.agendaImportCode )
          TeacherDataService.importAgenda(scope.currentClassId, scope.agendaImporter.agendaImportCode).then(function (agenda) {
            // $log.log('imported agenda : ' , agenda)
            eventManager.broadcast('teacherStudentsAgenda:refresh', true);
          }).catch(function (err) {
            $log.log('ERROR IMPORTING : ', err);
            window.alert('There was an error, could not import agenda');
          });
        }
      };

      scope.sendLabelClick = function (e, id) {
        if (PlatformService.isIos) {
          var elm = document.getElementById(id);
          if (elm) {
            elm.click();
          }
        }
      };
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsAccountsV2', function ($q, $log, EventManager, TeacherDataService) {
  return {
    template:'<div ng-if="flags.notSetup" class="placeholder-pane">Student account settings will go in this page. (including instructions for IAM)<br>At the moment, this page has been disabled for your account. As we are still in the process of setting things up.</div><div ng-if="!flags.notSetup"><span ng-show="flags.loading" class="placeholder-pane">Loading...</span><div ng-hide="flags.loading"><div ng-if="flags.error" class="placeholder-pane">Something happened while loading your data, please check you internet connection.</div><table ng-if="!flags.error" class="table is-bordered"><thead><th>Student Pin</th><th>User Name</th><th>Password</th></thead><tbody><tr ng-repeat="student in students.list"><td>{{student.user_id}}</td><td>{{student.user_name}}</td><td>{{students.getPassword(student.user_name)}}</td></tr></tbody></table></div></div>',
    scope: {
      selectedClass: '='
    },
    link: function link(scope, element) {

      /**
       * THIS PAGE ONLY SHOWS UP TO THE USERS LISTED UNDER
       * teacher-students/ scope.showAccountsTab
       */

      $log.error('teacherStudentsAccountsV2 :::: should not be appearing');
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsAccounts', function ($q, $log, EventManager, TeacherDataService) {
  return {
    template:'<div ng-if="flags.notSetup" class="placeholder-pane">Student account settings will go in this page. (including instructions for IAM)<br>At the moment, this page has been disabled for your account. As we are still in the process of setting things up.</div><div ng-if="!flags.notSetup"><span ng-show="flags.loading" class="placeholder-pane">Loading...</span><div ng-hide="flags.loading"><div ng-if="flags.error" class="placeholder-pane">Something happened while loading your data, please check you internet connection.</div><table ng-if="!flags.error" class="table is-bordered"><thead><th>Student Pin</th><th>User Name</th><th>Password</th></thead><tbody><tr ng-repeat="student in classList"><td>{{student.student_pin}}</td><td>{{student.student_username}}</td><td>{{student.student_password}}</td></tr></tbody></table></div></div>',
    scope: {
      selectedClass: '='
    },
    link: function link(scope, element) {

      /**
       * THIS PAGE ONLY SHOWS UP TO THE USERS LISTED UNDER
       * teacher-students/ scope.showAccountsTab
       */

      var eventManager = new EventManager('teacherStudentsAccounts', scope);
      scope.flags = {
        loading: true,
        error: false,
        notSetup: false
      };
      scope.$watch('selectedClass', function (classroom) {
        if (classroom) {
          init(classroom.id);
        }
      });
      var init = function init(classId) {
        scope.flags.loading = true;
        scope.flags.error = false;
        scope.flags.notSetup = false;
        TeacherDataService.getC3ClassStudents_customForUser().then(function (classListWithPasswords) {
          scope.classList = classListWithPasswords;
        }).then(function () {
          scope.flags.loading = false;
          scope.flags.error = false;
          scope.flags.notSetup = false;
        }).catch(function () {
          scope.flags.loading = false;
          scope.flags.error = false;
          scope.flags.notSetup = true;
        });
      };
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudents', function ($http, $log, $q, EventManager, language, userAccount, api, DATA_HOST, PanelFactory, PlatformService, TeacherDataService, $timeout, $rootScope) {
  return {
    template:'<div id="route-view-position-cert" class="route-view-content" ng-class="{\'is-side-menu-expanded\': $root.sidebarExpanded}" style="overflow: hidden !important; padding:0px !important"><div class="mtic-resource-loader-container-wrap" ng-hide="loadingStatus.done"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div ng-show="loadingStatus.done" ng-if="loadingStatus.failed">Something happend! Please check your internet connection.</div><ng-switch ng-show="loadingStatus.done" ng-if="!loadingStatus.failed" on="nav.getSelection()"><div ng-switch-when="dashboard"><teacher-students-dashboard selected-class="selectedClass"></teacher-students-dashboard></div><div ng-switch-when="studentsAddRemove"><teacher-students-addremove selected-class="selectedClass"></teacher-students-addremove></div><div ng-switch-when="agenda"><teacher-students-agenda selected-class="selectedClass"></teacher-students-agenda></div><div ng-switch-when="reports"><teacher-students-reports selected-class="selectedClass"></teacher-students-reports></div><div ng-switch-when="modules"><teacher-modules selected-class="selectedClass"></teacher-modules></div><div ng-switch-when="workspace"><teacher-students-workspace selected-class="selectedClass"></teacher-students-workspace></div><div ng-switch-when="accounts"><teacher-students-accounts selected-class="selectedClass"></teacher-students-accounts></div><div ng-switch-when="items"><teacher-students-item-zoom selected-class="selectedClass"></teacher-students-item-zoom></div><div ng-switch-when="docs"><teacher-documents selected-class="selectedClass"></teacher-documents></div><div ng-switch-when="class-leaderboard"><teacher-students-class-leaderboard selected-class="selectedClass"></teacher-students-class-leaderboard></div><div ng-switch-when="share-class"><teacher-share-class selected-class="selectedClass"></teacher-share-class></div></ng-switch><div ng-if="showPortraitModeWarning" class="modal mticBulmaModal mticBulmaModal--small portraitModeWarning"><div class="modal-card"><header class="modal-card-head"><p class="modal-card-title"><span class="agendaBox__headerText"></span></p><button class="delete" aria-label="close" ng-click="hidePortraidModeWarning()"></button></header><section class="modal-card-body"><p class="mticBulmaModal__bodyP" ng-bind="getProperTranslation(\'rotate_device\')">For best experience, rotate your iPad horizontally</p></section><footer class="modal-card-foot"><button class="button" ng-click="hidePortraidModeWarning()">OK</button></footer></div></div></div><div class="route-stub"><div class="route-path"><div class="route-brand">{{$root.isMTIC ? \'Mathematic\' : \'OCMT-HSE\'}}</div></div></div><div class="menu side-menu" ng-class="{\'is-expanded\': $root.sidebarExpanded}" id="teacher_sidepanel"><div class="inner-menu-container"><div class="extra-menu-option"><div class="extra-menu-wrapper"><div class="user-full-name">{{fullName()}}</div><div class="user-id"><span class="caption">{{getProperTranslation(\'11297\')}}:</span><span class="value">{{userId()}}</span></div></div><div class="selected-class-wrapper"><div class="current-class-caption" ng-bind="getProperTranslation(\'27650\')">Current Class</div><div class="current-class-name" ng-bind="selectedClass.name"></div><div class="current-class-code standard">(Code: <span style="user-select: text !important; -webkit-user-select: text !important; -ms-user-select: text !important; -moz-user-select: text !important;" ng-bind="selectedClass.code"></span>)</div><div class="current-class-code ocmt-mobile"><span class="caption">{{getProperTranslation(\'14582\')}}</span> <span class="value" ng-bind="selectedClass.code"></span></div></div><div select-box options="classes" model="selectedClass" style="font-size:12px;min-width: 210px;" filler-text="getTranslation(\'14575\')" display-function="\'fullname\'" on-change="selectClass" no-width="true" is-view-switch="true"></div><nav-bar-my-classes></nav-bar-my-classes></div><div class="menu-options"><div class="menu-option" ng-repeat="opt in nav.getAllSelections()" ng-class="{\'is-active\':nav.isSelection(opt.id), \'is-desktop\':!isMobile}" ng-click="nav.setSelection(opt.id)" ng-attr-data-opt="{{opt}}" ng-hide="isHiddenTab(opt.id)"><img ng-src="{{getSidebarIcon(opt.id)}}" ng-attr-title="{{getTranslation(opt.id)}}"><div class="menu-option-label"><span ng-bind="getTranslation(opt.id)"></span></div></div></div></div></div><div class="side-menu-toggle" ng-click="$root.sidebarExpanded = !$root.sidebarExpanded"><i id="side-menu-display-forcertificate" class="fa fa-bars" aria-hidden="true" style="color:#ccc;"></i></div>',
    scope: {},
    link: function link(scope, element) {

      var eventManager = new EventManager('teacherStudents', scope);
      var redirect_class = null;
      scope.isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);

      scope.loadingStatus = {
        reset: function reset() {
          this.done = false;
          this.failed = false;
        },
        okay: function okay() {
          this.done = true;
          this.failed = false;
        },
        error: function error(_error) {
          $log.error(_error);
          this.done = true;
          this.failed = _error || true;
        },
        done: false,
        failed: false
      };

      scope.fullName = function () {
        return userAccount.getData().fullName;
      };
      scope.userId = function () {
        return userAccount.getData().user_id;
      };

      scope.flags = {
        accountsV2: false,
        accountsV1: false
      };
      $rootScope.sidebarExpanded = PlatformService.isPhonePortrait() && window.location.href.indexOf('open_item_link') === -1 ? false : true;

      eventManager.listen('teacher:toggle:Sidepanel', function (e, val) {
        $rootScope.sidebarExpanded = val;
      });
      scope.$watch('$root.sidebarExpanded', function (val) {
        // $log.log('SIDEPANEL TOGGLED : ', val)
        TeacherDataService.sidepanelStatus = val;
        eventManager.broadcast('sidepanel:toggled', val);
      });

      eventManager.listen('teacher:selectClass', function (e, classroom) {
        scope.loadingStatus.reset();
        userAccount.setActiveClassFull(classroom);
        $q.all([PanelFactory.setupScopedMenuForStudentPanel(scope, classroom.id)]).then(function () {
          scope.loadingStatus.okay();
        }).catch(function (error) {
          scope.loadingStatus.error(error);
        });
      });

      scope.selectClass = function () {
        language.resetAvilableOptions();
        eventManager.broadcast('teacher:selectClass', scope.selectedClass);
        //        console.log("triggered select class: ", scope.selectedClass)
      };

      scope.$watch('selectedClass', function (val) {
        if (val) {
          scope.selectClass();
        }
      });

      scope.$watch('nav.selection', function (val) {
        if (val) {
          $rootScope.pageNav = val + '-nav';
          if (PlatformService.isPhonePortrait()) {
            $rootScope.sidebarExpanded = false;
          }
        }
      });

      var betaTabs = ['agenda', 'workspace'];

      var optionIdToTransId = {
        'studentsAddRemove': 'studentsAddRemove',
        'dashboard': 14566,
        'agenda': 14567,
        'workspace': 14568,
        'modules': 14569,
        'docs': 14570,
        'share-class': 14586,
        'class-leaderboard': 29373
      };

      scope.getTranslation = function (option_id) {
        //        console.log('[[TEACHER TAB IDs]]', option_id)
        var translationId = optionIdToTransId[option_id];
        if (translationId) {
          return language.get(translationId);
        } else {
          return '';
        }
      };

      scope.getProperTranslation = function (id) {
        return language.get(id);
      };

      scope.isHiddenTab = function (option_id) {
        return false && option_id === 'class-leaderboard';
      };

      scope.isBetaTab = function (option) {
        if (_.indexOf(betaTabs, option.id) !== -1) {
          return true;
        }
        return false;
      };

      scope.showPortraitModeWarning = true;
      scope.hidePortraidModeWarning = function () {
        scope.showPortraitModeWarning = false;
      };

      scope.getSidebarIcon = function (tabSlug) {
        return 'assets/images/navbar/' + tabSlug + '.png';
      };

      function list_compare(item, list) {
        var found = false;
        list.forEach(function (this_class) {
          if (this_class.id === item.id) {
            found = true;
          }
        });
        return found;
      }

      // PanelFactory.setupScopedMenu(scope, [
      //   {id: 'dashboard', name: 'Dashboard'},
      //   // {id: 'agenda', name: 'Agenda'},
      //   // {id: 'reports', name: 'Reports'},
      //   {id: 'workspace', name: 'Workspace'},
      //   // {id: 'items', name: 'Item View'},
      //   {id: 'accounts', name: 'Accounts', disable: !scope.showAccountsTab }
      // ]);

      TeacherDataService.getUserClasses(true).then(function (classes) {
        scope.classes = classes;
        scope.selectedClass = scope.classes[0];
        if (TeacherDataService.activeClassroomId) {
          _.each(scope.classes, function (classroom) {
            if (classroom.id === TeacherDataService.activeClassroomId) {
              scope.selectedClass = classroom;
            }
          });
        }
        // $log.log('[[scope.selectedClass]]', scope.selectedClass);
        eventManager.broadcast('teacher:selectClass', scope.selectedClass);

        TeacherDataService.getModuleListFlat(scope.selectedClass.id);

        //Added this to prepend the type name
        TeacherDataService.getSchoolClasses(true, TeacherDataService.activeSchoolId, false).then(function (classes) {
          //filtering out archived classes
          scope.classes = scope.classes.filter(function (cur_class) {
            return list_compare(cur_class, classes);
          });
          scope.classes.forEach(function (cur_class) {

            //auto redirect

            if (redirect_class && cur_class.id === redirect_class) {
              $timeout(function () {
                //console.log('redirect class from list : ', redirect_class)
                scope.selectedClass = cur_class;
                scope.nav.setSelection('modules');
              }, 1000);
            }

            if (TeacherDataService.getUserSchools().$$state.value.length > 1) {
              var school_name = '';
              TeacherDataService.getUserSchools().$$state.value.forEach(function (school) {
                if (school.id === TeacherDataService.activeSchoolId) {
                  school_name = school.name;
                }
              });
              if (school_name !== '') {
                cur_class.fullname = cur_class.getType() ? school_name + ' - ' + cur_class.getType() + ' - ' + cur_class.name : school_name + ' - ' + cur_class.name;
              } else {
                cur_class.fullname = cur_class.getType() ? cur_class.getType() + ' - ' + cur_class.name : cur_class.name;
              }
            } else {
              cur_class.fullname = cur_class.name;
            }
          });

          scope.classes = scope.classes.sort(function (a, b) {
            return a.fullname > b.fullname;
          });
        });
      });

      eventManager.listen('dashboard:to:workspace', function (e, args) {
        scope.nav.setSelection('workspace', null, args);
        //  var timer = PlatformService.isApp ? 1000 : 250;
        //  $timeout(function(){
        //   eventManager.broadcast('filters:to:workspace', args)
        //  }, timer)
      });

      eventManager.listen('agenda:to:dashboard', function (e, args) {
        scope.nav.setSelection('dashboard');
        $timeout(function () {
          eventManager.broadcast('filters:to:dashboard', { perspective: 'agenda', agendaFocus: args.agenda_unit_id });
        }, 250);
      });

      eventManager.listen('refresh:current:tab', function (e) {
        scope.nav.resetSelection();
      });

      eventManager.listen('agenda_change_request_granted', function (e, option) {
        // $log.log('agenda change reuqest granted: ', option);
        if (!scope.nav) {
          return;
        }
        scope.nav.setSelection(option, true);
      });

      var option_set_from_request;
      eventManager.listen('set:nav:selection', function (e, option) {
        if (!scope.nav) {
          option_set_from_request = option;
          return;
        }
        scope.nav.setSelection(option);
      });

      scope.$watch('nav', function (newval, old) {
        if (!old && newval && option_set_from_request) {
          scope.nav.setSelection(option_set_from_request);
          option_set_from_request = null;
        }
      });

      eventManager.listen('goto-module-tab', function (e, args) {
        redirect_class = parseFloat(args);
        //        console.log('redirect class : ', redirect_class)
      });
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsItemZoomRender', function (language) {
    return {
        template:'<table class="table" ng-if="!disabled"><thead><th ng-repeat="checkpointMeta in checkpoints" ng-bind="language.get(checkpointMeta.langId)"></th></thead><tbody><tr><td ng-repeat="checkpointData in checkpointDatas"><ng-switch on="checkpointData.componentType"><div ng-switch-when="inbookFramePlayer">Last Reached Point is Slide ({{checkpointData.state.frameCounter}})<br><b>History</b><br><ol><li ng-repeat="history in checkpointData.logdata">{{history.eventName}} -> {{history.eventData}}</li></ol></div></ng-switch></td></tr></tbody></table><div ng-show="disabled">This feature has not been enabled for this lesson yet.</div>',
        scope: {
            resourceSummary: '=',
            resource: '='
        },
        link: function link(scope) {
            scope.language = language;
            scope.checkpointDatas = [];
            scope.checkpoints = [
                //    {
                // 	componentId: 'mtic_g78_m1_rule_three/framePlayer',
                // 	langId: 'inbook_framePlayer'//ToDO, change to real langId
                // }
            ];
            if (scope.resource.config.checkpoints) {
                scope.checkpoints = scope.resource.config.checkpoints;
            } else {
                scope.disabled = true;
            }
            var instances = JSON.parse(scope.resourceSummary.component_instances);
            var state = JSON.parse(scope.resourceSummary.app_state);
            var logData = scope.resourceSummary.log_data;
            scope.checkpointDatas = scope.checkpoints.filter(function (config) {
                return state[config.componentId] && instances[config.componentId];
            }).map(function (config) {
                return {
                    componentType: instances[config.componentId],
                    componentId: config.componentId,
                    state: state[config.componentId],
                    logdata: logData.filter(function (componentLog) {
                        return componentLog.componentId === config.componentId;
                    })
                };
            });
        }
    };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherShareClass', function ($http, $log, EventManager, userAccount, api, DATA_HOST, language) {
  return {
    template:'<section class="placeholder-pane content section shareClassPage"><div class="container shareClass__container"><p class="shareClass__paragraph"><span ng-bind="getTranslation(\'14587\').split(\'mathematic\')[0]">To share this class with another teacher, send an email to:</span> <a href="mailto:mathematic@vretta.com">mathematic@vretta.com</a></p><p class="shareClass__paragraph" ng-bind="getTranslation(\'14588\')">Put <b>"Share my MathemaTIC Class"</b> in the subject line.</p><p class="shareClass__paragraph" ng-bind="getTranslation(\'14589\')">Include your <b>class code</b>, and the <b>IAM email address</b> of the teacher you wish to share the class with.</p><p class="shareClass__paragraph" ng-bind="getTranslation(\'16814\')">Please note that your class can be shared only if your colleague has already created a MathemaTIC account.</p></div></section>',
    scope: {},
    link: function link(scope, element) {

      var eventManager = new EventManager('teacherShareClass', scope);

      scope.getTranslation = function (id) {
        return language.get(id);
      };
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherParents', function ($http, $log, EventManager, userAccount, api, DATA_HOST) {
  return {
    template:'<div class="placeholder-pane">Parent-related information will go in this page.</div>',
    scope: {},
    link: function link(scope, element) {

      var eventManager = new EventManager('teacherParents', scope);
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherDocumentsFaqVideos', function ($http, $log, $sce, EventManager, language, PlatformService, cordovaMessenger) {
  return {
    template:'<div class="teacherDocumentsFaqVideos teacherDocumentsCard" style="width: auto;"><div class="teacherDocumentsCard__row" ng-repeat="video in videos"><div style="width: auto;" class="teacherDocumentsCard__col teacherDocumentsCard__col--title"><div class="clickable" ng-click="toggleVideoView(video)"><a class="teacherDocumentsCard__link"><span class="toggle-caret"><span ng-hide="video.isExpanded"><i class="fa fa-chevron-right" aria-hidden="true"></i></span> <span ng-show="video.isExpanded"><i class="fa fa-chevron-down" aria-hidden="true"></i></span></span> <span class="teacherDocumentsCard__DocTitle" ng-bind="getTranslation(video.headerTrans)"></span></a></div><div ng-if="video.isExpanded" style="padding-left:20px"><div style="font-size:0.8em; margin:0.2em;"><span ng-bind="getTranslation(video.preVideTextTrans)"></span></div><div><iframe class="youtubeFaqEmbed" ng-src="{{video.iframeSrc}}"></iframe></div></div></div></div></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope, element) {

      // event manager
      // var eventManager = new EventManager('teacherDocumentsFaqVideos', scope);

      scope.videos = []; // re-defined further down... should move this to a file loaded in from S3

      scope.toggleVideoView = function (video) {
        video.isExpanded = !video.isExpanded;
        // $log.log('toggle')
      };

      scope.getTranslation = function (id) {
        return language.get(id);
      };

      var processVideoLinks = function processVideoLinks() {
        _.each(scope.videos, function (video) {
          video.iframeSrc = $sce.trustAsResourceUrl(video.videoUrl);
        });
      };

      scope.videos = [{
        "videoUrl": "https://player.vimeo.com/video/710798778?h=389c174a79&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_2_header",
        "preVideTextTrans": "faq_video_2_pre_vid_text"
      }, {
        "videoUrl": "https://player.vimeo.com/video/710798819?h=077b84c4fc&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_3_header",
        "preVideTextTrans": "faq_video_3_pre_vid_text"
      }, {
        "videoUrl": "https://player.vimeo.com/video/710798854?h=028097de1e&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_4_header",
        "preVideTextTrans": "faq_video_4_pre_vid_text"
      }, {
        "videoUrl": "https://player.vimeo.com/video/710798882?h=3508b6a970&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_5_header",
        "preVideTextTrans": "faq_video_5_pre_vid_text"
      }, {
        "videoUrl": "https://player.vimeo.com/video/710798931?h=18cba6adfa&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_6_header",
        "preVideTextTrans": "faq_video_6_pre_vid_text"
      }, {
        "videoUrl": "https://player.vimeo.com/video/710798973?h=f39bbff766&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_7_header",
        "preVideTextTrans": "faq_video_7_pre_vid_text"
      }, {
        "videoUrl": "https://player.vimeo.com/video/710799025?h=e47ac1fe82&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_8_header",
        "preVideTextTrans": "faq_video_8_pre_vid_text"
      }, {
        "videoUrl": "https://player.vimeo.com/video/710799061?h=b76bef076d&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_9_header",
        "preVideTextTrans": "faq_video_9_pre_vid_text"
      }, {
        "videoUrl": "https://player.vimeo.com/video/710798252?h=861d734fc3&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_10_header",
        "preVideTextTrans": "faq_video_10_pre_vid_text"
      }, {
        "videoUrl": "https://player.vimeo.com/video/710797974?h=dc20ba1e3b&title=0&byline=0&portrait=0",
        "headerTrans": "faq_video_11_header",
        "preVideTextTrans": "faq_video_11_pre_vid_text"
      }, {
        "videoUrl": "https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/326/authoring/Video_Meet_the_Developers_final_1_1/1624311378082/Video_Meet_the_Developers_final_1_1.mp4",
        "headerTrans": "faq_video_12_header",
        "preVideTextTrans": "faq_video_12_pre_vid_text"
      }];

      processVideoLinks();
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherDocumentsCard', function ($http, $log, $sce, EventManager, language, PlatformService, cordovaMessenger) {
  return {
    template:'<div class="teacherDocumentsCard"><div class="teacherDocumentsCard__row teacherDocumentsCard__row--head"><div class="teacherDocumentsCard__col teacherDocumentsCard__col--title"><h3 class="teacherDocumentsCard__title" ng-bind="getTranslation(cardTitle)"></h3></div><div class="teacherDocumentsCard__col teacherDocumentsCard__col--doc" ng-if="!singleDocs"><i class="fa fa-file-pdf-o teacherDocumentsCard__pdfIcon" aria-hidden="true"></i></div></div><div class="teacherDocumentsCard__row" ng-if="docs" ng-repeat="doc in docs"><div class="teacherDocumentsCard__col teacherDocumentsCard__col--title"><span class="teacherDocumentsCard__DocTitle" ng-bind="getTranslation(doc.title)"></span></div><div class="teacherDocumentsCard__col teacherDocumentsCard__col--doc"><a class="teacherDocumentsCard__link" ng-if="doc.pdf" ng-click="clickPdf(doc, \'pdf\')">PDF</a> <a class="teacherDocumentsCard__link" ng-if="doc.docx" ng-click="clickPdf(doc, \'docx\')">Docx</a></div></div><div class="teacherDocumentsCard__row" ng-if="singleDocs" ng-repeat="doc in singleDocs"><div class="teacherDocumentsCard__col teacherDocumentsCard__col--title"><a class="teacherDocumentsCard__link" ng-click="clickPdf(doc, \'doc\')"><span class="teacherDocumentsCard__DocTitle" ng-bind="getTranslation(doc.title) + doc.titleAppend"></span></a></div></div></div>',
    restrict: 'E',
    scope: {
      cardTitle: '=',
      docs: '=?',
      singleDocs: '=?',
      titleAppend: '=?'
    },
    link: function link(scope, element) {

      // event manager
      var eventManager = new EventManager('teacherDocumentsCard', scope);

      scope.isWebEmbed = window.isWebEmbedConnect;

      scope.getTranslation = function (id) {
        return language.get(id);
      };

      scope.clickPdf = function (doc, type) {
        var link = doc[type];
        $log.log(doc);
        if (PlatformService.isApp) {
          cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: link });
        } else {
          var new_win = window.open($sce.trustAsResourceUrl(link), '_blank');
          new_win.location.hash = '';
        }

        eventManager.broadcast("teacher:download:instructions", scope.getTranslation(doc.title) + "_" + language.getCurrentSelectedLanguage().toUpperCase());
      };
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherDocuments', function ($http, $log, EventManager, userAccount, api, DATA_HOST, language, $sce) {
  return {
    template:'<div class="content newStyle"><div class="route-path"><div class="route-brand">MathemaTIC</div><div class="route-screen"><span ng-bind="getTranslation(\'14570\')">Documents</span></div></div><div class="documentsPage"><h2 class="heading2" ng-bind-disabled="getTranslation()">FAQ & Videos</h2><teacher-documents-faq-videos></teacher-documents-faq-videos><h2 class="heading2" ng-bind="getTranslation(\'27706\')">Fiches Didactiques</h2><teacher-documents-card card-title="cards.c3.title" docs="cards.c3.docs"></teacher-documents-card><teacher-documents-card card-title="cards.c4.title" docs="cards.c4.docs"></teacher-documents-card><teacher-documents-card card-title="cards.chapters.title" docs="cards.chapters.docs"></teacher-documents-card><h2 class="heading2" ng-bind="getTranslation(\'27705\')">Communications</h2><teacher-documents-card card-title="cards.instructionManuals.title" single-docs="cards.instructionManuals.singleDocs"></teacher-documents-card><h2 class="heading2" ng-bind="getTranslation(\'27705999\')">Data Protection and Privacy Policy</h2><teacher-documents-card card-title="cards.dataprotections.title" docs="cards.dataprotections.docs"></teacher-documents-card><div style="width:80%;height:100%" ng-if="clicked_linked && isWebEmbed"><div style="-webkit-overflow-scrolling: touch;overflow: auto;"><iframe style="width:720px;height:700px" ng-src="{{clicked_linked}}" scrolling="yes"></iframe></div></div></div></div>',
    scope: {},
    link: function link(scope, element) {

      var eventManager = new EventManager('teacherDocuments', scope);

      scope.getTranslation = function (id) {
        return language.get(id);
      };

      scope.cards = {

        c3: {
          title: 'EF: Cycle 3',
          docs: [{
            title: 'mtic_c3_m1',
            pdf: 'https://vretta.app.box.com/s/nud57mnlt0226wcoc3sva38m335wtg4u'
            //docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Cycle%203%20-%20Modul%201%20-%20Textaufgaben%20-%20Didaktisches%20Leitblatt.docx?alt=media&token=29ec1a16-3beb-4de0-af67-eb8f8a10e94a'
          }, {
            title: 'mtic_c3_m2',
            pdf: 'https://vretta.app.box.com/s/4v5qw7zv7yxmz5w5h70ipjia7wyh4nfe'
            //docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/mtic2%2Fteacher%2Fstatic_assets%2FCycle%203%20-%20Modul%202%20-%20MathleTIC%20-%20Handreichungen.docx?alt=media&token=b9321d86-461d-4227-bd6e-652aaee53b06'
          }, {
            title: 'mtic_c3_m3',
            pdf: 'https://vretta.app.box.com/s/8pdmn3napm806vjh4uluui8lusgnsmu5'
            //docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Cycle%203%20-%20Modul%201%20-%20Textaufgaben%20-%20Didaktisches%20Leitblatt.docx?alt=media&token=29ec1a16-3beb-4de0-af67-eb8f8a10e94a'
          }, {
            title: 'mtic_c3_m4',
            pdf: 'https://vretta.app.box.com/s/8ls53se0o5yjoc82n5fwhofh26enlhij'
          }]
        },

        c4: {
          title: 'EF: Cycle 4',
          docs: [{
            title: 'c4_m1',
            pdf: 'https://vretta.box.com/s/mm626zbrw3l7jv8tqqwmxdkj2aduogeb'
            // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%201%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=2fe52dd9-d6b8-45ad-a216-a9c9a51d30e2'
          }, {
            title: 'c4_m2',
            pdf: 'https://vretta.box.com/s/n9gdr2z2hnagp2z3iuql0tipzptryn1e'
            // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%202%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=3139b3b7-3248-4543-9f28-c3b6b6129a1d'
          }, {
            title: 'c4_m3',
            pdf: 'https://vretta.box.com/s/kkckqapguexas8ajjrze8a14qaqae0w7'
            // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%203%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=22ce5bc8-204c-4089-b6c5-eecc510805ec'
          }, {
            title: 'c4_m4',
            pdf: 'https://vretta.box.com/s/aayct3fjmze226sonlvkqpa4fl15x0sn'
            // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%204%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=c7e8c193-5ba3-42e4-9df0-12e5fc55dc3d'
          }, {
            title: 'c4_m5',
            pdf: 'https://vretta.box.com/s/iaacv82n5yeii9e9fx4gni7h40826biy'
            // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%205%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=831d1c8c-ad8e-47a1-96d6-7898c045287f'
          }, {
            title: 'c4_m6',
            pdf: 'https://vretta.box.com/s/owdnbz3vqwdl84tna4enfn9wojsby222'
            // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%206%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=5a8a850d-8f9d-4249-99cf-d43dbb6548c2'
          }, {
            title: 'mtic_c3_m2',
            pdf: 'https://vretta.box.com/s/271pqfn1clgcdccdwxv2idjs9zr7jdgr'
            // docx: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010-Module%206%20MathemaTIC%20-%20Fiche%20Didactique.docx?alt=media&token=5a8a850d-8f9d-4249-99cf-d43dbb6548c2'
          }]
        },

        letterToTeachers: {
          title: '27702',
          singleDocs: [{
            title: '27702',
            doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010_lettre-enseignant.pdf?alt=media&token=8b4ada52-e008-4e19-94fd-74521ab774d3',
            titleAppend: ''
          }]
        },

        letterToParents: {
          title: '27703',
          singleDocs: [{
            title: '27703',
            doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010_lettre-parents_all.pdf?alt=media&token=1b9bfe5c-9aee-4078-9c88-9d51a8f1c5a4',
            titleAppend: ' - all'
          }, {
            title: '27703',
            doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010_lettre-parents_fr.pdf?alt=media&token=98dcf2b8-9414-4707-b269-cb12b61e76e1',
            titleAppend: ' - fr'
          }, {
            title: '27703',
            doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2F20171010_lettre-parents_lux.pdf?alt=media&token=bb5c5cea-09ad-4c98-83d0-1276a565354c',
            titleAppend: ' - lux'
          }]
        },

        // The following files are in firebase. Location: /mtic2/teacher/static_assets/
        instructionManuals: {
          title: '27700',
          singleDocs: [{
            title: '27700',
            doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/mtic2%2Fteacher%2Fstatic_assets%2FMathemaTIC_lu%20Instruction%20Manual_LU_FR.pdf?alt=media&token=7d6363c7-0bbc-4d89-bdb4-f8a2f0ca0ce6',
            titleAppend: ' - fr'
          }, {
            title: '27700',
            doc: 'https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/mtic2%2Fteacher%2Fstatic_assets%2FMathemaTIC_lu%20Instruction%20Manual_LU_%20EN.pdf?alt=media&token=426f2d4f-87f7-44bc-9bee-e02eb428c1e8',
            titleAppend: ' - en'
          }]
        },

        chapters: {
          title: 'docs_chapters_title',
          docs: [{
            title: 'ES MathemaTIC Lessonplan - Angles et construction géométriques',
            pdf: 'https://vretta.box.com/s/1tked0xcj9ygdbn3n58u43qqd9ois7aa'
          }, {
            title: 'ES MathemaTIC Lessonplan - Racines carrées et Pythagore',
            pdf: 'https://vretta.box.com/s/vlin4wnqmwsendmwx9hhnhckekrezql5'
          }, {
            title: 'ES MathemaTIC Lessonplan - Transformations du plan',
            pdf: 'https://vretta.box.com/s/98tjxkkc321wfxmmshleibqn2ewi49di'
          }, {
            title: 'ES MathemaTIC Lessonplan - Statistiques',
            pdf: 'https://vretta.box.com/s/a6fmj7lteoq0sxx77j0vjepztdyv2ne6'
          }]
        },
        dataprotections: {
          title: ' ',
          docs: [{
            title: 'dataprotectionen',
            pdf: 'https://vrettamedia.s3.amazonaws.com/MTIC/FAQs%26Docs/MathemaTIC-Data_Protection%26Privacy_Policy-EN.pdf'
          }, {
            title: 'dataprotectionfr',
            pdf: 'https://vrettamedia.s3.amazonaws.com/MTIC/FAQs%26Docs/MathemaTIC-Data_Protection%26Privacy_Policy-FR.pdf'
          }, {
            title: 'dataprotectionde',
            pdf: 'https://vrettamedia.s3.amazonaws.com/MTIC/FAQs%26Docs/MathemaTIC-Data_Protection%26Privacy_Policy-DE.pdf'
          }, {
            title: 'dataprotectionpt',
            pdf: 'https://vrettamedia.s3.amazonaws.com/MTIC/FAQs%26Docs/MathemaTIC-Data_Protection%26Privacy_Policy-PT.pdf'
          }]
        }

      };
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').component('teacherClassesStudents', {

  template:'<div class="mtic-resource-loader-container-wrap" ng-show="$ctrl.flags.loading"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div class="placeholder-pane" ng-if="!$ctrl.flags.loading"><div ng-if="$ctrl.flags.error">{{$ctrl.flags.error}}</div><div ng-if="!$ctrl.flags.error"><div ng-if="!$ctrl.schools.hasNone" ng-hide="$ctrl.schools.hasMany"><b>{{text.SCHOOL}} :</b> {{$ctrl.schools.selected.name}}<br></div><div class="field" ng-if="!$ctrl.schools.hasNone" ng-show="$ctrl.schools.hasMany"><label class="label">{{text.SCHOOL}}</label><p class="control"><span class="select"><select ng-options="school as school.name for school in $ctrl.schools.list track by school.id" ng-model="$ctrl.schools.selected"></select></span></p></div><div ng-if="$ctrl.schools.hasNone">{{text.ACCOUNTSETUPISBAD}}</div><teacher-classes-students-return ng-if="!$ctrl.schools.hasNone" school="$ctrl.schools.selected"></teacher-classes-students-return></div></div>',
  bindings: {},
  controllerAs: '$ctrl',
  controller: function controller($scope, $log, language, EventManager, TeacherDataService) {

    var eventManager = new EventManager('teacherClassesSchools', $scope);

    $scope.language = language;
    var $ctrl = this;
    var text = $scope.text = {
      SCHOOL: 'School',
      MODULES: 'Module',
      CLASSES: 'Classes',
      ACCOUNTSETUPISBAD: 'Your account appears to not be configured correctly.'
    };
    $ctrl.flags = {
      loading: true,
      error: null,
      reset: function reset() {
        this.loading = true;
        this.error = null;
      },
      done: function done(error) {
        this.loading = false;
        if (error) {
          this.error = error;
        }
      }
    };

    $ctrl.schools = {
      list: [],
      hasMany: false,
      hasNone: false,
      filter: {},
      selected: null
    };

    var getSchools = function getSchools(reset) {
      return TeacherDataService.getUserSchools(null, reset).then(function (schools) {
        $ctrl.schools.list = schools;
        $ctrl.schools.hasMany = schools.length > 1;
        $ctrl.schools.hasNone = schools.length < 1;
        $ctrl.schools.selected = schools[0];
      });
    };

    $ctrl.$onInit = function () {
      $ctrl.flags.reset();
      getSchools(true).then(function () {
        $ctrl.flags.done();
      }).catch(function (err) {
        $log.error(err);
        $ctrl.flags.done(err.message);
      });
    };
  }
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').component('teacherClassesSchools', {
  template:'<div class="teacher-classes-schools"><div class="mtic-resource-loader-container-wrap" ng-show="$ctrl.flags.loading"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div class="placeholder-pane" ng-if="!$ctrl.flags.loading"><div ng-if="$ctrl.flags.error">{{$ctrl.flags.error}}</div><div ng-if="!$ctrl.flags.error"><div ng-if="!$ctrl.schools.hasNone" ng-hide="$ctrl.schools.hasMany" class="active-classes-title"><strong ng-bind="language.get(\'14559\')">Your Active Classes</strong> ({{$ctrl.schools.selected.name}})</div><div class="position-relative"><button class="button position-absolute color-white top-negative-30 right-0 font-size-16 width-150" ng-class="{\'background-color-black\':openedEditClassStatusMode,\'background-color-3398db\':!openedEditClassStatusMode}" ng-click="openEditClassStatus()"><span class="color-white" ng-show="!openedEditClassStatusMode" ng-bind="getTranslation(\'27640\')">Manage Classes</span> <span class="color-white" ng-show="openedEditClassStatusMode" ng-bind="getTranslation(\'27645\')">Done</span></button></div><div class="field" ng-if="!$ctrl.schools.hasNone" ng-show="$ctrl.schools.hasMany"><label class="label">{{text.SCHOOL}}</label><p class="control"><span class="select"><select ng-options="school as school.name for school in $ctrl.schools.list track by school.id" ng-model="$ctrl.schools.selected"></select></span></p></div><div ng-if="$ctrl.schools.hasNone">{{text.ACCOUNTSETUPISBAD}}</div><teacher-classes-schools-classes ng-if="!$ctrl.schools.hasNone" school="$ctrl.schools.selected" modules="$ctrl.modules.list" classes="$ctrl.classes.list" add-mode="$ctrl.schools.addMode"></teacher-classes-schools-classes><div ng-if="!$ctrl.schools.hasNone" ng-show="!openedEditClassStatusMode" class="color-ced3d7" ng-hide="$ctrl.schools.hasMany"><button class="button font-size-16 background-transparent color-ced3d7" ng-click="archivedSection.showingArchivedClasses = !archivedSection.showingArchivedClasses"><span class="color-abb6b9" ng-hide="archivedSection.showingArchivedClasses" ng-bind="getTranslation(\'27641\')">Show archived classes</span> <span class="color-abb6b9" ng-show="archivedSection.showingArchivedClasses" ng-bind="getTranslation(\'28496\')">Hide Archived Classes</span></button></div><div ng-if="!$ctrl.schools.hasNone && openedEditClassStatusMode"><strong class="font-size-24" ng-bind="getTranslation(\'27648\')">Your Archived Classes</strong></div><teacher-classes-schools-classes ng-if="!$ctrl.schools.hasNone" ng-show="archivedSection.showingArchivedClasses || openedEditClassStatusMode" archived-status="archivedSection.hasArchived" school="$ctrl.schools.selected" modules="$ctrl.modules.list" classes="$ctrl.classes.list"></teacher-classes-schools-classes></div></div></div>',
  bindings: {},
  controllerAs: '$ctrl',
  controller: function controller($scope, $log, language, EventManager, TeacherDataService, LocaleService) {
    var eventManager = new EventManager('teacherClassesSchools', $scope);
    $scope.language = language;
    $scope.getTranslation = function (slug) {
      return language.get(slug);
    };
    var $ctrl = this;
    var text = $scope.text = {
      SCHOOL: 'School',
      MODULES: 'Module',
      CLASSES: 'Classes',
      ACCOUNTSETUPISBAD: 'Your account appears to not be configured correctly.'
    };
    $ctrl.flags = {
      loading: true,
      error: null,
      reset: function reset() {
        this.loading = true;
        this.error = null;
      },
      done: function done(error) {
        this.loading = false;
        if (error) {
          this.error = error;
        }
      }
    };
    $scope.archivedSection = {
      showingArchivedClasses: false,
      hasArchived: true
    };

    $ctrl.schools = {
      list: [],
      hasMany: false,
      hasNone: false,
      filter: {},
      selected: null
    };
    $ctrl.classes = {
      list: []
    };

    var getSchools = function getSchools() {
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return TeacherDataService.getUserSchools(null, reset).then(function (schools) {
        $ctrl.schools.list = schools;
        $ctrl.schools.hasMany = schools.length > 1;
        $ctrl.schools.hasNone = schools.length < 1;
        $ctrl.schools.selected = schools[0];
      });
    };

    $scope.isLux = LocaleService.getCurrentLocale() === 'LUXEMBOURG';

    $scope.openEditClassStatus = function () {
      $scope.openedEditClassStatusMode = !$scope.openedEditClassStatusMode;
      if ($scope.openedEditClassStatusMode) {
        eventManager.broadcast("edit:class:status:mode:on");
      } else {
        eventManager.broadcast("edit:class:status:mode:off");
      }
    };

    $ctrl.$onInit = function () {
      $ctrl.flags.reset();
      getSchools(true).then(function () {
        $ctrl.flags.done();
      }).catch(function (err) {
        $log.error(err);
        $ctrl.flags.done(err.message);
      });
    };
  }
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherClassesArchived', function ($http, $log, EventManager, userAccount, api, DATA_HOST) {
  return {
    template:'<div class="placeholder-pane">You have no archived classes.</div>',
    scope: {},
    link: function link(scope, element) {

      var eventManager = new EventManager('teacherClassesArchived', scope);
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherClassesActive', function ($q, $log, EventManager, TeacherDataService) {
  return {
    template:'<div class="mtic-resource-loader-container-wrap" ng-hide="loadingStatus.done"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div class="placeholder-pane" ng-if="!loadingStatus.error"><strong>Access Codes for New Students</strong><table class="table" style="width:auto; font-size: 140%;"><tr ng-repeat="classroom in classes.list"><th><span ng-hide="classroom.editable"><a ng-click="classroom.editable = true"><i class="fa fa-pencil item-list-icon" aria-hidden="true"></i></a> {{classroom.name}}</span><form ng-if="classroom.editable" ng-submit="updateClassName(classroom.id, classroom.name)"><a ng-click="classroom.editable = false"><i class="fa fa-ban item-list-icon" aria-hidden="true"></i></a> <input type="text" ng-model="classroom.name"></form></th><th>{{classroom.description}}</th><td>{{teacher.user_id}}C{{classroom.id}}</td></tr></table><div style="border: 1px solid black;margin:10px;padding:10px;"><b>Make new Class</b><br>Class Name: <input type="text" ng-model="classes.new.name"><br>Class Description: <input type="text" ng-model="classes.new.description"><br>School Selected:<select ng-options="school as school.name for school in schools.list track by school.id" ng-model="schools.selected"></select><br><button type="button" ng-click="createClass(classes.new.name, classes.new.description)">Create</button></div></div><div class="placeholder-pane" ng-if="loadingStatus.error">An Error Occured While Loading Your Data!</div>',
    scope: {},
    link: function link(scope, element) {
      scope.loadingStatus = {
        done: false,
        error: false
      };
      scope.schools = {
        list: [],
        selected: {}
      };
      scope.classes = {
        list: [],
        new: {
          reset: function reset() {
            this.name = '';
            this.description = '';
          },
          name: '',
          description: ''
        }
      };
      var eventManager = new EventManager('teacherClassesActive', scope);

      scope.updateClassName = function (classId, name) {
        TeacherDataService.updateClassName(classId, name).then(function () {
          TeacherDataService.getUserClasses(true).then(function (classes) {
            scope.classes.list = classes;
            scope.classes.new.reset();
          });
        });
      };

      scope.createClass = function (name, description) {
        TeacherDataService.createClass(scope.schools.selected.id, name, description, function () {
          TeacherDataService.getUserClasses(true).then(function (classes) {
            scope.classes.list = classes;
            scope.classes.new.reset();
          });
        });
      };

      // init
      scope.teacher = {};
      $q.all([TeacherDataService.getUserId(function (user_id) {
        scope.teacher.user_id = user_id;
      }), TeacherDataService.getUserClasses().then(function (classes) {
        scope.classes.list = classes;
      }), TeacherDataService.getUserSchools(function (schools) {
        scope.schools.list = schools;
        if (!scope.schools.selected) {
          scope.schools.selected = scope.schools[0];
        }
      })]).then(function () {
        scope.loadingStatus.done = true;
        scope.loadingStatus.error = false;
      }).catch(function (err) {
        $log.error(err);
        scope.loadingStatus.done = true;
        scope.loadingStatus.error = true;
      });
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('teacherClasses', function ($http, $log, EventManager, userAccount, api, DATA_HOST, PanelFactory, language, apiTranslationService) {
  return {
    template:'<div class="teacher-classes route-view-content is-no-side-panel"><teacher-classes-schools></teacher-classes-schools><div class="route-path"><div class="route-brand">{{$root.isMTIC ? \'Mathematic\' : \'OCMT-HSE\'}}</div><div class="route-screen"><span ng-show="!active_slug">Classes</span> <span ng-show="active_slug" ng-bind="getSlugTrans()">Questionnaiere</span></div></div></div>',
    scope: {},
    link: function link(scope, element) {

      scope.getTranslation = function (translationId) {
        if (active_data && active_data.resource_type === 'embedded_notification') {
          return apiTranslationService.getTranslation(translationId);
        }
        if (translationId) {
          return language.get(translationId);
        } else {
          return '';
        }
      };

      var eventManager = new EventManager('teacherClasses', scope);
      var active_data;
      eventManager.listen('module:open:resource', function (e, data) {
        scope.active_slug = data.notification_slug ? data.notification_slug : data.slug;
        active_data = data;
        //scope.status.show = true;
      });

      scope.getSlugTrans = function () {
        var trans = '/ ' + scope.getTranslation(scope.active_slug);
        //this part is added for notifications that need the followup flag
        if (active_data && active_data.is_follow_up) {
          trans += ' - ' + language.get('follow_up');
        }
        return trans;
      };

      eventManager.listen('module:close:resource', function (e, data) {
        //scope.status.show = false;
        scope.active_slug = null;
      });
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.teacher_general').directive('classStudentPerformance', function ($log, $q, $timeout, EventManager, StudentDataService, language) {
      return {
            template:'<b>Stats</b> <button type="button" ng-click="goToClassManager()">goToClassManager</button> <span ng-if="isLoading">Loading...</span>{{currentSelectedClass}}<ng-switch on="viewShown"><class-performance-table ng-switch-when="classTable" students="studentWork" current-module="currentModule"></class-performance-table><class-lesson-summary ng-switch-when="student" class-id="classroom.id" user-id="currentSelectedStudent.user_id"></class-lesson-summary></ng-switch>',
            scope: {
                  classroom: '=classroom'
            },
            link: function link(scope) {
                  var eventManager = new EventManager('teacherDashboard/classStudentPerformance', scope);
                  scope.getTranslation = function (id) {
                        return language.get(id);
                  };
                  scope.studentWork = null;
                  scope.currentModule = '1';
                  scope.isLoading = true;
                  scope.currentSelectedStudent = null;
                  scope.viewShown = 'classTable';

                  StudentDataService.getClassStats(scope.classroom.id).then(function (studentWork) {
                        scope.studentWork = studentWork;
                        scope.isLoading = false;
                  });

                  eventManager.listen('teacher:selectStudent', function (e, student) {
                        scope.currentSelectedStudent = student;
                        scope.viewShown = 'student';
                  });

                  eventManager.listen('teacher:unselectStudent', function (e) {
                        scope.currentSelectedStudent = null;
                        scope.viewShown = 'classTable';
                  });

                  scope.goToClassManager = function () {
                        eventManager.broadcast('teacher:openView', 'classManager');
                  };
            }
      };
});
'use strict';

angular.module('mtic.components.dashboards.student_general').directive('studentModules', function ($http, $log, $timeout, TIMING_CONSTANTS, DEV_VARIABLES, EventManager, StudentDataService, PlatformService, MapStateService) {
  return {
    template:'<div class="student-modules"><mtic-modules ng-if="moduleMapData" module="moduleMapData"></mtic-modules><div class="mtic-resource-loader-container" ng-hide="moduleMapData"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div ng-if="isLeaderboardAvailable() && !isLeaderboardHidden" ng-click="activateLeaderboard()" ng-style="{cursor: \'pointer\', \'position\':\'fixed\', \'bottom\':\'0px\', right:\'0px\'}"><img style="width:190px; position: relative; top: 8px; left: 5px;" src="https://mtic-items.s3.eu-central-1.amazonaws.com/website/competitions/leaderboard-button.png"><div style="position: absolute; bottom:10px; left:0px; right:0px; text-align:center;color:#fff;">Challenge</div><div class="cat-mascot"><img src="https://firebasestorage.googleapis.com/v0/b/calculating-cats.appspot.com/o/module-map%2Flevel-indicator.png?alt=media&token=f164c368-1f23-405d-a918-8e06389b89ea"></div></div></div>',
    scope: {
      selectedClass: '='
    },
    link: function link(scope, element) {

      scope.moduleDataReady = false;
      MapStateService.isLeaderboardAvailable = false;
      scope.isLeaderboardAvailable = function () {
        return MapStateService.isLeaderboardAvailable;
      };
      scope.isLeaderboardHidden = false;
      // console.log(StudentDataService.getUserSchools())
      if (StudentDataService.getUserSchools().$$state.value.length === 1) {
        if (StudentDataService.getUserSchools().$$state.value[0].name.toLowerCase().includes('baqa')) {
          scope.is_baqa = true;
        }
      }

      var eventManager = new EventManager('studentModules', scope);
      var screen_width = 0;
      var is_mobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (is_mobile) {
        screen_width = window.screen.width;
      } else {
        screen_width = window.innerWidth;
      }
      if (screen_width < 1200) {
        var timer = is_mobile ? 500 : 0;
        $timeout(function () {
          eventManager.broadcast('student:toggle:Sidepanel', false);
        }, timer);
      }
      // eventManager.listen('') // isLeaderboardHidden


      scope.$on('$destroy', function () {
        MapStateService.setActiveModule("");
      });

      scope.activateLeaderboard = function () {
        //$log.log('activateLeaderboard', scope.selectedClass, scope.moduleMapData)

        eventManager.broadcast('student:leaderboard:open', {
          classId: scope.selectedClass.id,
          classType: renderLeaderboardClassTypeFromModuleId(scope.selectedClass.module_id),
          classCountry: scope.selectedClass.country
        });
      };

      eventManager.listen('activate:leaderboard', function () {
        if (scope.isLeaderboardAvailable() && !scope.isLeaderboardHidden) {
          scope.activateLeaderboard();
        }
      });

      var checkForOpenLeaderboards = function checkForOpenLeaderboards() {
        if (scope.selectedClass) {
          var isValid = true;
          // _.each(DEV_VARIABLES.GROUPS.LUXEMBOURG.TEACHERLESS_MODULES, function(classModule){
          //   if (classModule.group_id === scope.selectedClass.id){
          //     isValid = false;
          //   }
          // })
          if (!isValid) {
            return false;
          }
          var districtId = 'luxembourg';
          var classType = renderLeaderboardClassTypeFromModuleId(scope.selectedClass.module_id);
          var path = 'https://us-central1-calculating-cats.cloudfunctions.net/hasLeaderboardsOpen';
          // $log.log('hasLeaderboardsOpen >> classType', classType)
          $http.post(path, { districtId: districtId, classType: classType }).then(function (res) {
            //$log.log('hasLeaderboardsOpen', res)
            try {
              if (res.data.data.isValid) {
                $timeout(function () {
                  MapStateService.isLeaderboardAvailable = true;
                });
              }
            } catch (e) {}
          });
        }
      };

      var renderLeaderboardClassTypeFromModuleId = function renderLeaderboardClassTypeFromModuleId(moduleId) {
        var classType = 'no_class'; // default
        DEV_VARIABLES.GROUPS.LUXEMBOURG.AVAILABLE_MODULES.forEach(function (moduleCollection) {
          if (moduleCollection.module_id === moduleId) {
            classType = moduleCollection.foreign_slug;
          }
        });
        return classType;
      };

      var init = function init(firstInit, triggerRefresh) {
        scope.moduleDataReady = false;
        scope.moduleMapData = null;
        checkForOpenLeaderboards();
        StudentDataService.getModuleData(true).then(function (moduleMapData) {
          if (triggerRefresh) {
            $log.debug('[[studentModules]] RE-INITED (refresh)', moduleMapData);
            scope.moduleMapData = moduleMapData;
            $timeout(function () {
              eventManager.broadcast('app:module:refresh/ready', {});
            }, TIMING_CONSTANTS.STUDENT_DATA_REFRESH_DELAY_MS);
          } else if (firstInit) {
            $log.debug('[[studentModules]] RE-INITED (first)', moduleMapData);
            scope.moduleMapData = moduleMapData;
            eventManager.broadcast('app:secondary:opened', moduleMapData.resource_slug);
          } else {
            $log.debug('[[studentModules]] RE-INITED', moduleMapData);
            $timeout(function () {
              scope.moduleMapData = moduleMapData;
            }, TIMING_CONSTANTS.INSTANT);
          }
        });
      };

      // EVENT SETUP
      eventManager.listen('student:cycle:open', function (e) {
        $log.log('student:cycle:open');
        init(true);
      });

      eventManager.listen('module:change:submodule', function (e) {
        scope.isLeaderboardHidden = false; // bad idea... they cant bring it back
      });

      eventManager.listen('module:open:resource', function (e) {
        scope.isLeaderboardHidden = true; // bad idea... they cant bring it back
      });

      // 

      eventManager.listen('app:module:open', function (e) {
        $log.log('app:module:open');
        init(false);
      });

      eventManager.listen('module:reload:map', function (e, args) {
        init(false);
      });

      eventManager.listen('app:module:refresh', function (e) {
        init(false, true);
      });

      eventManager.listen('creating-items-done', function (e) {
        scope.moduleDataReady = true;
      });

      scope.$watch('selectedClass', function (selectedClass) {
        if (selectedClass) {
          // $log.log('selectedClass: ' , selectedClass)
          eventManager.broadcast('student:cycle:open', {});
          checkForOpenLeaderboards();
        }
      });
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.student_general').directive('studentLeaderboard', function ($log, EventManager, language, StudentDataService, userAccount, $sce, DEV_VARIABLES, PlatformService, cordovaMessenger) {
  return {
    template:'<div><iframe class="iframe-cover" ng-src="{{iframeUrl}}"></iframe></div>',
    scope: {
      classType: '='
    },
    link: function link(scope, element) {

      var eventManager = new EventManager('studentLeaderboard', scope);

      var init = function init() {
        var lang = language.getCurrentSelectedLanguage();
        var country = getCountryLeaderboard(StudentDataService.leaderboardConfig ? StudentDataService.leaderboardConfig.classCountry || '' : '');
        var url = 'https://demo.mathematic.org/student/leaderboards/district/' + country;
        url += '/foreignClassType/' + getForeignClassType();
        url += '/foreignClassId/' + getForeignClassId();
        url += '/foreignId/' + getForeignUid();
        url += '/displayName/' + encodeURIComponent(getDisplayName());
        url += '/' + lang;
        scope.iframeUrl = $sce.trustAsResourceUrl(url);
      };

      /**
       * Please refer to groups.groupType == 'country' in the db for what country names its expecting
       * If updating this, please update the one in mtic2\src\components\dashboards\teacher\teacher-students-class-leaderboard\index.js as well :/
       * @param {string} country
       * @returns {string}
       */
      var getCountryLeaderboard = function getCountryLeaderboard(country) {
        var countryLowerCase = (country || '').toLowerCase();
        switch (countryLowerCase) {
          case 'testing':
            return 'testing';
          case 'israel':
            return 'baqa';
          default:
            return 'luxembourg';
        }
      };

      var getForeignClassId = function getForeignClassId() {
        if (StudentDataService.leaderboardConfig) {

          var isNoClass = false;
          _.each(DEV_VARIABLES.GROUPS.LUXEMBOURG.TEACHERLESS_MODULES, function (classModule) {
            if (classModule.group_id === StudentDataService.leaderboardConfig.classId) {
              isNoClass = true;
            }
          });

          if (isNoClass) {
            return 'individualMode_' + getForeignUid();
          }

          return StudentDataService.leaderboardConfig.classId;
        }
        return 0;
      };
      var getForeignClassType = function getForeignClassType() {
        if (StudentDataService.leaderboardConfig) {
          return StudentDataService.leaderboardConfig.classType;
        }
        return 'cx';
      };

      var getForeignUid = function getForeignUid() {
        $log.log('user ids', userAccount.getData().uuid, userAccount.getData().user_id);
        return userAccount.getData().user_id;
      };
      var getDisplayName = function getDisplayName() {
        return userAccount.getData().fullName;
      };

      var optionIdToTransId = {
        'modules': 14569,
        'dashboard': 27651
      };
      scope.getTranslation = function (option_id) {
        var translationId = optionIdToTransId[option_id];
        if (translationId) {
          return language.get(translationId);
        } else {
          return '';
        }
      };
      scope.getProperTranslation = function (id) {
        return language.get(id);
      };

      init();
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.student_general').directive('studentDashboard', function ($http, $log, $timeout, TIMING_CONSTANTS, EventManager, StudentDataService, PlatformService, MapStateService, $window) {
  return {
    template:'<div class="student-dashboard"><div style="display: none"><mtic-modules ng-if="moduleMapData" module="moduleMapData"></mtic-modules></div><div class="inner-container"><div class="dashboard-header"><div class="title">DASHBOARD</div></div><div class="dashboard-table"><div class="table-header"><div class="column topics"><div class="caption">Topics</div></div><div class="column resources"><div class="caption">Resources</div></div></div><div class="table-contents" ng-hide="!moduleDataReady"><div class="module" ng-repeat="module in moduleMapData.resources track by $index"><div class="column displayName"><div class="value">{{module.name}}</div></div><div class="column resources"><div ng-if="$root.isOCMT" class="module-charts"><div class="diagnostic"><div ng-class="[\'circle\', module.progress_rings.diagnostic.color]"><div class="value">{{module.progress_rings.diagnostic.value}}</div></div></div><div class="lessons"><div ng-class="[\'circle\', module.progress_rings.lessons.color]"><div class="value">{{module.progress_rings.lessons.value}}</div></div></div><div class="summative"><div ng-class="[\'circle\', module.progress_rings.summative.color]"><div class="value">{{module.progress_rings.summative.value}}</div></div></div></div></div></div></div><div class="mtic-resource-loader-container-wrap" ng-hide="moduleDataReady"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div></div></div></div>',
    scope: {
      selectedClass: '='
    },
    link: function link(scope, element) {
      scope.moduleDataReady = false;

      var eventManager = new EventManager('studentModules', scope);
      var screen_width = 0;
      var is_mobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (is_mobile) {
        screen_width = window.screen.width;
      } else {
        screen_width = window.innerWidth;
      }
      if (screen_width < 1200) {
        var timer = is_mobile ? 500 : 0;
        $timeout(function () {
          eventManager.broadcast('student:toggle:Sidepanel', false);
        }, timer);
      }

      scope.$on('$destroy', function () {
        MapStateService.setActiveModule("");
      });

      var init = function init(firstInit, triggerRefresh) {
        scope.moduleDataReady = false;
        scope.moduleMapData = null;
        StudentDataService.getModuleData(true).then(function (moduleMapData) {
          if (triggerRefresh) {
            $log.debug('[[studentDashboard]] RE-INITED (refresh)', moduleMapData);
            scope.moduleMapData = moduleMapData;
            $timeout(function () {
              eventManager.broadcast('app:module:refresh/ready', {});
            }, TIMING_CONSTANTS.STUDENT_DATA_REFRESH_DELAY_MS);
          } else if (firstInit) {
            $log.debug('[[studentDashboard]] RE-INITED (first)', moduleMapData);
            scope.moduleMapData = moduleMapData;
            eventManager.broadcast('app:secondary:opened', moduleMapData.resource_slug);
          } else {
            $log.debug('[[studentDashboard]] RE-INITED', moduleMapData);
            $timeout(function () {
              scope.moduleMapData = moduleMapData;
            }, TIMING_CONSTANTS.INSTANT);
          }
        });
      };

      // EVENT SETUP
      eventManager.listen('student:cycle:open', function (e) {
        init(true);
      });

      eventManager.listen('app:module:open', function (e) {
        init(false);
      });

      eventManager.listen('app:module:refresh', function (e) {
        init(false, true);
      });

      eventManager.listen('creating-items-done', function (e) {
        scope.moduleDataReady = true;
      });

      scope.$watch('selectedClass', function (selectedClass) {
        if (selectedClass) {
          $log.log('selectedClass: ', selectedClass);
          eventManager.broadcast('student:cycle:open', {});
        }
      });

      /****** Setting Dashboard table height *****/
      scope.mEls = scope.mEls || {};
      var unwatch_dashboardTable = scope.$watch(function () {
        scope.mEls.pageHeader = scope.mEls.pageHeader || document.querySelector('#nav-display-for-certificate');
        scope.mEls.dashboardHeader = scope.mEls.dashboardHeader || document.querySelector('.inner-container .dashboard-header');
        scope.mEls.dashboardTable = scope.mEls.dashboardTable || document.querySelector('.inner-container .dashboard-table');
        return !!(scope.mEls.pageHeader && scope.mEls.pageHeader.clientHeight && scope.mEls.dashboardHeader && (PlatformService.isPhonePortrait() ? scope.mEls.dashboardHeader.clientHeight : true) && scope.mEls.dashboardTable);
      }, function (rendered) {
        if (rendered) {
          setDashboardTableHeight();
          unwatch_dashboardTable();
        }
      });
      function setDashboardTableHeight() {
        var remHeight = 0;
        [scope.mEls.pageHeader, scope.mEls.dashboardHeader].map(function (el) {
          remHeight += el ? el.getBoundingClientRect().height : 0;
        });
        scope.mEls.dashboardTable.style.height = window.innerHeight - remHeight + 'px';
      }
      window.removeEventListener('resize', mOnResize_dashboardTable);
      window.addEventListener('resize', mOnResize_dashboardTable);
      function mOnResize_dashboardTable() {
        // in case for some reason mobile browser changes visible viewport height (hides address bar etc)
        setDashboardTableHeight();
      }
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.student_general').directive('studentClass', function ($http, $log, $q, EventManager, language, userAccount, api, DATA_HOST, PanelFactory, PlatformService, StudentDataService, TeacherDataService, $timeout, $rootScope) {
  return {
    template:'<div id="route-view-position-cert" class="route-view-content" ng-class="{\'is-side-menu-expanded\': $root.sidebarExpanded}" style="overflow: hidden !important; padding:0px !important"><div class="mtic-resource-loader-container-wrap" ng-hide="loadingStatus.done"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div ng-show="loadingStatus.done" ng-if="loadingStatus.failed">Something happend! Please check your internet connection.</div><ng-switch ng-show="loadingStatus.done" ng-if="!loadingStatus.failed" on="nav.getSelection()"><div ng-switch-when="modules"><student-modules selected-class="selectedClass"></student-modules></div><div ng-switch-when="dashboard"><student-dashboard selected-class="selectedClass"></student-dashboard></div></ng-switch><div ng-if="showPortraitModeWarning" class="modal mticBulmaModal mticBulmaModal--small portraitModeWarning"><div class="modal-card"><header class="modal-card-head"><p class="modal-card-title"><span class="agendaBox__headerText"></span></p><button class="delete" aria-label="close" ng-click="hidePortraidModeWarning()"></button></header><section class="modal-card-body"><p class="mticBulmaModal__bodyP" ng-bind="getProperTranslation(\'rotate_device\')">For best experience, rotate your iPad horizontally</p></section><footer class="modal-card-foot"><button class="button" ng-click="hidePortraidModeWarning()">OK</button></footer></div></div></div><div class="route-stub"><div class="route-path"><div class="route-brand">{{$root.isMTIC ? \'Mathematic\' : \'OCMT-HSE\'}}</div></div></div><div class="menu side-menu" ng-class="{\'is-expanded\': $root.sidebarExpanded}" id="student_sidepanel"><div class="inner-menu-container"><div class="extra-menu-option"><div class="extra-menu-wrapper"><div class="user-full-name">{{fullName()}}</div><div class="user-id"><span class="caption">{{getProperTranslation(\'11331\')}}:</span><span class="value">{{userId()}}</span></div></div><div class="selected-class-wrapper"><div class="current-class-caption" ng-bind="getProperTranslation(\'27650\')">Current Class</div><div class="current-class-name" ng-bind="selectedClass.name"></div><div class="current-class-code standard">(Code: <span style="user-select: text !important; -webkit-user-select: text !important; -ms-user-select: text !important; -moz-user-select: text !important;" ng-bind="selectedClass.code"></span>)</div><div class="current-class-code ocmt-mobile"><span class="caption">{{getProperTranslation(\'14582\')}}</span> <span class="value" ng-bind="selectedClass.code"></span></div></div><div select-box options="classes" model="selectedClass" style="font-size:12px;min-width: 210px;" filler-text="getTranslation(\'14575\')" display-function="\'fullname\'" on-change="selectClass" no-width="true" is-view-switch="true"></div><nav-bar-my-classes></nav-bar-my-classes></div><div class="menu-options"><div class="menu-option" ng-repeat="opt in nav.getAllSelections()" ng-class="{\'is-active\':nav.isSelection(opt.id), \'is-desktop\':!isMobile}" ng-click="nav.setSelection(opt.id)" ng-attr-data-opt="{{opt}}" ng-hide="isHiddenTab(opt.id)"><img ng-src="{{getSidebarIcon(opt.id)}}" ng-attr-title="{{getTranslation(opt.id)}}"><div class="menu-option-label"><span ng-bind="getTranslation(opt.id)"></span></div></div></div></div></div><div class="side-menu-toggle" ng-click="$root.sidebarExpanded = !$root.sidebarExpanded"><i class="fa fa-bars" aria-hidden="true" style="color:#ccc;"></i></div>',
    scope: {},
    link: function link(scope, element) {

      var eventManager = new EventManager('studentClass', scope);
      var redirect_class = null;
      scope.isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);

      scope.loadingStatus = {
        reset: function reset() {
          this.done = false;
          this.failed = false;
        },
        okay: function okay() {
          this.done = true;
          this.failed = false;
        },
        error: function error(_error) {
          $log.error(_error);
          this.done = true;
          this.failed = _error || true;
        },
        done: false,
        failed: false
      };

      scope.fullName = function () {
        return userAccount.getData().fullName;
      };
      scope.userId = function () {
        return userAccount.getData().user_id;
      };

      scope.flags = {
        accountsV2: false,
        accountsV1: false
      };
      $rootScope.sidebarExpanded = PlatformService.isPhonePortrait() ? false : true;

      eventManager.listen('student:toggle:Sidepanel', function (e, val) {
        $rootScope.sidebarExpanded = val;
      });

      $rootScope.$watch('sidebarExpanded', function (val) {
        eventManager.broadcast('sidepanel:toggled', val);
      });

      StudentDataService.getClasses().then(function (classes) {
        scope.classes = classes;
        scope.selectedClass = scope.classes[0];
        if (userAccount.getActiveClassroom()) {
          _.each(scope.classes, function (classroom) {
            if (classroom.id === userAccount.getActiveClassroom()) {
              scope.selectedClass = classroom;
            }
            classroom.fullname = classroom.resource_type + ' - ' + classroom.name;
            classroom.code = TeacherDataService.renderClassCodeStr(classroom);
          });
        }
        eventManager.broadcast('student:selectClass', scope.selectedClass);
      });

      eventManager.listen('student:selectClass', function (e, classroom) {
        scope.loadingStatus.reset();
        userAccount.setActiveClassFull(classroom);
        var studentPages = [{ id: 'modules', name: 'Modules' }];
        if ($rootScope.isOCMT) {
          studentPages.push({ id: 'dashboard', name: 'Dashboard' });
        }
        $q.all([PanelFactory.setupOrUpdateScopedMenu(scope, studentPages)]).then(function () {
          scope.loadingStatus.okay();
          scope.nav.setSelection('modules');
        }).catch(function (error) {
          scope.loadingStatus.error(error);
        });
      });

      scope.selectClass = function () {
        language.resetAvilableOptions();
        eventManager.broadcast('student:selectClass', scope.selectedClass);
      };

      scope.$watch('selectedClass', function (val) {
        if (val) {
          scope.selectClass();
        }
      });

      scope.$watch('nav.selection', function (val) {
        if (val) {
          $rootScope.pageNav = val + '-nav';
          if (PlatformService.isPhonePortrait()) {
            $rootScope.sidebarExpanded = false;
          }
        }
      });

      var betaTabs = [];

      var optionIdToTransId = {
        'modules': 14569,
        'dashboard': 27651
      };

      scope.getTranslation = function (option_id) {
        var translationId = optionIdToTransId[option_id];
        if (translationId) {
          return language.get(translationId);
        } else {
          return '';
        }
      };

      scope.getProperTranslation = function (id) {
        return language.get(id);
      };

      scope.isHiddenTab = function (option_id) {
        return false;
      };

      scope.isBetaTab = function (option) {
        if (_.indexOf(betaTabs, option.id) !== -1) {
          return true;
        }
        return false;
      };

      scope.showPortraitModeWarning = true;
      scope.hidePortraidModeWarning = function () {
        scope.showPortraitModeWarning = false;
      };

      scope.getSidebarIcon = function (tabSlug) {
        return 'assets/images/navbar/' + tabSlug + '.png';
      };

      function list_compare(item, list) {
        var found = false;
        list.forEach(function (this_class) {
          if (this_class.id === item.id) {
            found = true;
          }
        });
        return found;
      }

      eventManager.listen('refresh:current:tab', function (e) {
        scope.nav.resetSelection();
      });

      eventManager.listen('goto-module-tab', function (e, args) {
        redirect_class = parseFloat(args);
      });
    }
  };
});
'use strict';

angular.module('mtic.components.dashboards.student_general').component('studentClasses', {
  template:'<div style="padding:60px;"><div id="real-classes"><label class="label" ng-bind="getTranslation(\'14581\')">Access your class</label><div ng-hide="studentClasses.classes_real.length || studentClasses.isGettingClasses"><div style="padding:40px; background-color:#fff; border-radius:30px; box-shadow: 2px 2px 10px rgba(0,0,0,.1); text-align:center"><div><form autocomplete="off"><span style="color: #FF4D4D; font-size: 1rem; line-height: 2rem;" ng-bind="getTranslation(\'14582\')">Class Code:</span> <input type="text" class="input" ng-model="studentClasses.firstClassCode" ng-keyup="$event.keyCode == 13 ? studentClasses.joinClass(studentClasses.firstClassCode) : null" ng-change="studentClasses.isProblemJoining=false; studentClasses.alreadyInClass=false;" style="width: 130px; text-align: center; color: #FF4D4D;"> <button class="button is-success" ng-hide="studentClasses.isJoiningClass || studentClasses.isProblemJoining" ng-disabled="!studentClasses.firstClassCode" ng-click="studentClasses.joinClass(studentClasses.firstClassCode)">OK</button></form></div><div style="margin:20px"><div class="notification is-warning" ng-show="studentClasses.isProblemJoining" ng-bind="getTranslation(\'28497\')">Problem joining class. Please contact support.</div><div class="notification is-warning" ng-show="studentClasses.alreadyInClass" ng-bind="getTranslation(studentClasses.errorMessage)">You are already enrolled in this class.</div></div><div style="margin-top:28px" ng-bind="getTranslation(\'14583\')">Ask your teacher for the class code.</div></div></div><div ng-show="studentClasses.classes_real.length"><student-classes-container classes="studentClasses.classes_real" on-select="studentClasses.onSelect"></student-classes-container></div></div><div id="teacherless-classes" ng-show="studentClasses.classes_teacherless.length"><label class="label" style="margin-top:60px;" ng-bind="getTranslation(\'14584\')">Access the modules</label><student-classes-container classes="studentClasses.classes_teacherless" on-select="studentClasses.onSelect" is-teacherless="true"></student-classes-container></div><div id="teacherless-classes" ng-show="studentClasses.classes_real.length"><label class="label" style="margin-top:60px;" ng-bind="getTranslation(\'14781\')">Join another class</label><div style="padding:40px; background-color:#fff; border-radius:30px; box-shadow: 2px 2px 10px rgba(0,0,0,.1); text-align:center"><div class="enterClassCodeBox"><span style="color: #FF4D4D; font-size: 1rem; line-height: 2rem;" ng-bind="getTranslation(\'14582\')">Class Code:</span><form autocomplete="off"><input type="text" class="input" ng-keyup="$event.keyCode == 13 ? studentClasses.joinClass(studentClasses.firstClassCode) : null" ng-change="studentClasses.isProblemJoining=false; studentClasses.alreadyInClass=false;" ng-model="studentClasses.firstClassCode" style="width: 130px; text-align: center; color: #FF4D4D;"> <button class="button is-success" ng-hide="studentClasses.isJoiningClass || studentClasses.isProblemJoining" ng-disabled="!studentClasses.firstClassCode || studentClasses.firstClassCode.length==0" ng-click="studentClasses.joinClass(studentClasses.firstClassCode)">OK</button></form></div><div style="margin:20px"><div class="notification is-warning" ng-show="studentClasses.isProblemJoining" ng-bind="getTranslation(\'28497\')">Problem joining class. Please contact support.</div><div class="notification is-warning" ng-show="studentClasses.alreadyInClass" ng-bind="getTranslation(studentClasses.errorMessage)">You are already enrolled in this class.</div></div></div></div></div>',
  bindings: {
    onSelect: '<',
    isGreyed: '<'
  },
  controllerAs: 'studentClasses',
  controller: function controller($scope, $q, $log, $timeout, IAMManager, StudentDataService, EventManager, language, DEV_VARIABLES, api, Firebase, userAccount, LocaleService) {
    var eventManager = new EventManager('studentClasses', $scope);
    var studentClasses = this;
    studentClasses.classes = [];
    studentClasses.classesToGrey = [];
    studentClasses.classesToHide = [];

    var init = function init() {
      getClasses();
    };

    function cycle_check() {
      var isLux = true; //LocaleService.getCurrentLocale() === 'LUXEMBOURG';
      var user_id = userAccount.getData().user_id;
      if (!LocaleService.hasTakenStudentCyclePrompt && isLux) {
        var last_sept = moment(moment().year() + '-08-01').toDate();
        if (moment().month() < 7) {
          last_sept = moment(moment().year() - 1 + '-08-01').toDate();
        }
        api.getUserResourceLatestAppState(user_id, 1248, last_sept).then(function (app_logs) {
          var taken_cycle_prompt = false;
          var is_c4_memeber = false;
          if (app_logs && Object.keys(app_logs).length !== 0) {
            taken_cycle_prompt = true;
            if (app_logs.app_state && app_logs.app_state.teacher_cycle_prompt && (app_logs.app_state.teacher_cycle_prompt.class_choice_c4_1 || app_logs.app_state.teacher_cycle_prompt.class_choice_c4_2)) {
              is_c4_memeber = true;
            }
          }
          $log.log('app_logs : ', app_logs && app_logs.length, taken_cycle_prompt);

          LocaleService.hasTakenStudentCyclePrompt = taken_cycle_prompt;
          LocaleService.is_c4_student = is_c4_memeber;

          if (!taken_cycle_prompt) {
            eventManager.broadcast("navbar:teacher-cycle:prompt");
          }

          //DONT REMOVE THIS - RE ADD WHEN QUESTIONNAIRE IS REENABLED // 2018-11-06: is this still relevant? (CA)

          //else if(is_c4_memeber && (!LocaleService.done_student_post_test || !LocaleService.done_student_offboarding)){

          // var token_saved_url = IAMManager.getSavedUrlParamsForToken();
          // // $log.log("Locale saved baseline/quest: ", LocaleService.hasCompletedStudentBase, LocaleService.hasCompletedStudentQuest)
          // eventManager.broadcast('C4_BASELINE_LOG', {
          //   isTeacher: false,
          //   isApp: window.isWebEmbedConnect || window.location.href.indexOf('web-embed-connect') !== -1 || token_saved_url.indexOf('web-embed-connect') !== -1,
          //   flag_baseline_check: LocaleService.hasCompletedStudentBase,
          //   flag_questionnaire_check:  LocaleService.hasCompletedStudentQuest
          // })

          // api.getUserResourceAppState(user_id,2890).then( (data)=>{
          //   if(!data || data.length === 0){
          //     eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true});
          //   }else{
          //     LocaleService.done_student_post_test = true;
          //     api.getUserResourceAppState(user_id,2893).then( (data)=>{
          //       if(!data || data.length === 0){
          //         eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true, isBaseline: true});
          //       }else{
          //         LocaleService.done_student_offboarding = true;
          //       }
          //     })
          //   }
          // })
          //}
        });
      }
      // else if(LocaleService.is_c4_student && (!LocaleService.done_student_post_test || !LocaleService.done_student_offboarding)){
      //   api.getUserResourceAppState(user_id,2890).then( (data)=>{
      //     if(!data || data.length === 0){
      //       eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true});
      //     }else{
      //       LocaleService.done_student_post_test = true;
      //       api.getUserResourceAppState(user_id,2893).then( (data)=>{
      //         if(!data || data.length === 0){
      //           eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true, isBaseline: true});
      //         }else{
      //           LocaleService.done_student_offboarding = true;
      //         }
      //       })
      //     }
      //   })
      // }
    }

    $scope.getTranslation = function (id) {
      return language.get(id);
    };

    var getClasses = function getClasses() {
      studentClasses.isGettingClasses = true;
      studentClasses.classes_real = [];
      studentClasses.classes_teacherless = [];

      StudentDataService.getClasses().then(function (classes) {
        classes = classes.filter(function (cur_class) {
          return !cur_class.archived;
        });

        var teacherlessResourceMap = {};
        _.each(DEV_VARIABLES.GROUPS.LUXEMBOURG.TEACHERLESS_MODULES, function (resourceDef) {
          teacherlessResourceMap[resourceDef.group_id] = true;
        });
        var resourceTypeCheck = {};
        var classes_real = [];
        var teacherlessResourceStore = {};
        _.each(classes, function (classroom) {
          var isTeacherless = teacherlessResourceMap[classroom.id];
          if (isTeacherless) {
            teacherlessResourceStore[classroom.resource_type] = classroom;
          } else {
            classes_real.push(classroom);
            resourceTypeCheck[classroom.resource_type] = true;
          }
        });
        var classes_teacherless = [];
        _.each(DEV_VARIABLES.GROUPS.LUXEMBOURG.TEACHERLESS_MODULES, function (resourceDef) {
          if (!resourceTypeCheck[resourceDef.resource_type] && teacherlessResourceStore[resourceDef.resource_type]) {
            classes_teacherless.push(teacherlessResourceStore[resourceDef.resource_type]);
          }
        });
        studentClasses.classes_real = classes_real;
        studentClasses.classes_teacherless = classes_teacherless;
        studentClasses.isGettingClasses = false;

        if (window.location.href.indexOf('open_item_link') > -1 && !LocaleService.item_link_opened) {
          var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));
          var found_matching_class = false;
          for (var i = 0; i < studentClasses.classes_real.length; i++) {
            var user_class = studentClasses.classes_real[i];
            if (user_class.module_resource_id + '' === urlParams.get('module_id')) {
              found_matching_class = true;
              studentClasses.selectClassroom(user_class.id);
              break;
            }
          }
          if (!found_matching_class) {
            for (i = 0; i < studentClasses.classes_teacherless.length; i++) {
              var user_classless = studentClasses.classes_teacherless[i];
              if (user_classless.module_resource_id + '' === urlParams.get('module_id')) {
                found_matching_class = true;
                studentClasses.selectClassroom(user_classless.id);
                break;
              }
            }
          }
          if (!found_matching_class) {
            //display error              
            window.alert('No class found with a similar resource to the one you attempting to open');
          }
        }
      });
    };
    studentClasses.selectClassroom = function (class_id) {
      studentClasses.onSelect(class_id);
    };
    studentClasses.getClassTypeCaption = function (moduleResourceType) {
      return language.get(moduleResourceType);
    };
    studentClasses.joinClass = function (classCode) {
      if (!classCode || classCode.length === 0) {
        return;
      }

      studentClasses.isJoiningClass = true;
      var registrationToken = StudentDataService.parseClassCode(classCode);
      StudentDataService.getClassInfo({ class_id: registrationToken.classId }).then(function (classroomTo) {
        var matchedResourceClass = null;
        var matched_module_id = null;
        // check for running class of same type
        _.each(studentClasses.classes_real, function (classroom) {
          if (!matchedResourceClass && classroomTo.resource_type === classroom.resource_type) {
            matched_module_id = classroom.module_id;
            matchedResourceClass = classroom;
          }
        });
        // check for teacherless class of same type
        if (!matchedResourceClass) {
          _.each(studentClasses.classes_teacherless, function (classroom) {
            if (!matchedResourceClass && classroomTo.resource_type === classroom.resource_type) {
              //DO WE WANT TO COPY PROGRESS FROM FAKE CLASSES ?
              matched_module_id = classroom.module_id;
              matchedResourceClass = classroom;
            }
          });
        }

        if (!matchedResourceClass) {
          matchedResourceClass = { id: 0
            //throw new Error('Cannot transfer as no reference class: [SYSTEM: IF NEW CLASS TYPE, PROVIDE ALT REG METHOD]');
          };
        }

        if (parseInt(matchedResourceClass.id) === parseInt(registrationToken.classId)) {
          studentClasses.alreadyInClass = true;
          studentClasses.isJoiningClass = false;
          studentClasses.errorMessage = 28498;
          throw new Error('ROLE_TYPE_ALREADY_EXISTS');
        }

        //        console.log('details :', matchedResourceClass, registrationToken)

        return StudentDataService.transferStudent({
          from_class_id: matchedResourceClass.id,
          teacher_id: registrationToken.teacherId,
          to_class_id: registrationToken.classId
        });
      }).then(function (data) {
        studentClasses.isProblemJoining = false;
        studentClasses.alreadyInClass = false;
        studentClasses.isJoiningClass = false;
        // $log.log('TRANSFER COMPLETE', data)
        init();
      }).catch(function (err) {
        $log.error('TRANSFER FAILED', err);
        if (err.message === 'ROLE_TYPE_ALREADY_EXISTS') {
          studentClasses.alreadyInClass = true;
          studentClasses.errorMessage = 28498;
        } else if (err.message === 'SEARCH_NOT_FOUND') {
          studentClasses.alreadyInClass = true;
          studentClasses.errorMessage = 28499;
        } else if (err.message === 'CLASS_IS_ARCHIVED') {
          studentClasses.alreadyInClass = true;
          studentClasses.errorMessage = 'class_is_archived';
        } else {
          studentClasses.isProblemJoining = true;
          eventManager.broadcast('help:open:forced');
        }
        studentClasses.isJoiningClass = false;
      });
    };

    init();
  }
});
'use strict';

//JUST A NICE FORCE DIRECTED GRAPH
//NO INTERACTION, NO RENDERING

angular.module('mtic.components.modules').service('VerletSystemService', function (PIXI, $log) {

  return function VerletSystem() {

    //Fewer iterations -> looser simulation
    //More iterations -> rigid/snappier simulation (at performance cost)
    var NUM_ITERATIONS = 5;
    var CONSTRAINT_LENGTH = 60;

    var ENABLED = true;

    //a map of VerletBody
    var bodies = {};
    var segments = {
      dash: [],
      solid: []
    };

    this.clear = function () {
      this.deactivateAllBodies();
      bodies = {};
      segments = {
        dash: [],
        solid: []
      };
    };

    var getBody = function getBody(key) {
      return bodies[key];
    };
    //an array of the active verlet bodies
    var active_bodies = [];

    //A body used in verlet simulation
    var VerletBody = function VerletBody(id, sprite, constraints, dash) {
      var thiz = this;
      this.constraints = constraints;
      this.dash = dash;
      thiz.id = id;
      thiz.active = true;
      // this.sprite.alpha = 0;
      this.position = sprite.position;
      this.sprite = sprite;

      this.last_pos = {
        x: this.position.x,
        y: this.position.y
      };
      this.saved_pos = {
        x: this.position.x,
        y: this.position.y
      };
      this.setPosition = function (x, y) {
        thiz.position.x = thiz.last_pos.x = thiz.saved_pos.x = x;
        thiz.position.y = thiz.last_pos.y = thiz.saved_pos.y = y;
      };
    };

    var updateUnlocks = function updateUnlocks(id, constraints) {
      for (var i = 0; i < bodies.length; i++) {
        // if (bodies[id])
      }
    };
    //Every body applies a repel force to every other body
    var addRepelForces = function addRepelForces(strength) {
      if (!ENABLED) {
        return;
      }
      var body;
      for (var i = 0; i < active_bodies.length; i++) {
        body = getBody(active_bodies[i]);
        for (var n = 0; n < active_bodies.length; n++) {
          //Doesn't repel itself
          if (i === n) {
            continue;
          }
          var other = getBody(active_bodies[n]);
          var dir = {
            x: body.position.x - other.position.x,
            y: body.position.y - other.position.y
          };
          //This was supposed to be a simple negative gravity calculation
          //But I messed up and didn't do it right, so it is now some magic math until I get back to it
          //Apply a force between items that are too close together, pushing them apart
          var dist = Math.pow(dir.x, 2) + Math.pow(dir.y, 2);
          if (dist < Math.pow(600, 2)) {
            dist /= strength;
            dir = {
              x: dir.x / dist,
              y: dir.y / dist
            };
            if (isNaN(dir.x) || isNaN(dir.y)) {
              continue;
            }
            body.last_pos.x += dir.x;
            body.last_pos.y += dir.y;
            other.last_pos.x -= dir.x;
            other.last_pos.y -= dir.y;
          }
        }
      }
    };
    //loop over every body, adjusting the positions to try to satisfy every spring constraint created in this.hookUpConstraints()
    //We're already doing the math necessary to draw the lines, so generate that info here if GENERATE_LINES is true
    var simulateConstraints = function simulateConstraints(GENERATE_LINES) {
      var body;
      if (GENERATE_LINES) {
        segments.dash = [];
        segments.solid = [];
      }
      //every body
      for (var i = 0; i < active_bodies.length; i++) {
        body = getBody(active_bodies[i]);
        // $log.log('verlet body : ', body.id, body.constraints)
        var dist = 0;
        //loops over every one of its constraints
        for (var n = 0; n < body.constraints.length; n++) {

          //Ignore deactivated items
          if (active_bodies.indexOf(body.constraints[n]) === -1) {
            continue;
          }
          var other = getBody(body.constraints[n]);
          //Vector between two bodies
          var dir = {
            x: body.position.x - other.position.x,
            y: body.position.y - other.position.y
          };

          //Magnitude of the vector between two bodies
          dist = Math.sqrt(Math.pow(dir.x, 2) + Math.pow(dir.y, 2));

          //Difference between current distance and desired constraint distance
          var diff = CONSTRAINT_LENGTH - dist;

          //If this isn't perfectly satisfying the constraint, add some force
          if (diff !== 0) {
            //normalize direction
            dir = {
              x: dir.x / dist,
              y: dir.y / dist
            };
            if (isNaN(dir.x) || isNaN(dir.y)) {
              continue;
            }

            if (GENERATE_LINES) {

              /* EVERYTHING IS A SOLID LINE FOR NOW
              if (other.dash && body.constraints[n] !== 'mtic_g78_m2_diag' && body.constraints[n] !== 'mtic_g78_m1_diag') {
                var dot_pos = {
                  x : body.position.x + dir.x * -50,
                  y : body.position.y + dir.y * -50
                };
                  for(var j = 0; j < dist - 75; j += 35)
                {
                  segments.dash.push({
                    x : dot_pos.x,
                    y : dot_pos.y
                  });
                  dot_pos.x += dir.x * -35;
                  dot_pos.y += dir.y * -35;
                }
              } else*/
              {
                segments.solid.push({
                  start: {
                    x: body.position.x,
                    y: body.position.y
                  },
                  end: {
                    x: other.position.x,
                    y: other.position.y
                  },
                  id: body.id,
                  constraints: body.constraints
                });
              }
            }

            //We're not actually maintaining a 'velocity' variable
            //Verlet Integration just stores the current position and the last position and derives velocity from (current_pos - last_pos)
            //So to update the 'velocity' we just change what the last position is stored as
            diff /= 2;
            body.last_pos.x += dir.x * diff;
            body.last_pos.y += dir.y * diff;
            other.last_pos.x -= dir.x * diff;
            other.last_pos.y -= dir.y * diff;
          }
        }
      }
    };
    //Actually move the bodies.
    //Verlet Integration does this by finding the inertia (current position minus last position) and adding it to the current position
    var moveBodies = function moveBodies() {
      if (!ENABLED) {
        return;
      }
      var body;
      for (var i = 0; i < active_bodies.length; i++) {
        body = getBody(active_bodies[i]);
        //first store the current position
        body.saved_pos.x = body.position.x;
        body.saved_pos.y = body.position.y;
        //move based on position last frame (inertia)
        var damp = 0.16;
        if (Math.abs(body.position.x - body.last_pos.x) > 5 || Math.abs(body.position.y - body.last_pos.y) > 5) {

          body.position.x -= (body.position.x - body.last_pos.x) * damp;
          body.position.y -= (body.position.y - body.last_pos.y) * damp;
        }
        //store current position for next frame
        body.last_pos.x = body.saved_pos.x;
        body.last_pos.y = body.saved_pos.y;
      }
    };
    this.setConstraintLength = function (val) {
      if (val === undefined) {
        CONSTRAINT_LENGTH = 60;
      } else {
        CONSTRAINT_LENGTH = val;
      }
    };

    this.toggle = function (val) {
      if (val === undefined) {
        ENABLED = !ENABLED;
      } else {
        ENABLED = val;
      }
    };

    this.getCurrentEnabledStatus = function () {
      return ENABLED;
    };

    this.getLineSegments = function () {
      return segments;
    };
    this.getBody = function (id) {
      return bodies[id];
    };

    this.createBody = function (id, sprite, constraints, dash) {
      var body = new VerletBody(id, sprite, constraints, dash);
      bodies[id] = body;
      active_bodies.push(id);
      return body;
    };
    //Loop to update the bodies
    this.update = function () {
      for (var i = 0; i < NUM_ITERATIONS; i++) {
        addRepelForces(800);
        moveBodies();
        simulateConstraints(i === NUM_ITERATIONS - 1);
      }
    };
    //remove a body from the active_bodies list. return true if it exists
    this.deactivateBody = function (id, hide_sprite) {
      var index = active_bodies.indexOf(id);
      if (index > -1) {
        active_bodies.splice(index, 1);
        if (hide_sprite) {
          getBody(id).sprite.visible = false;
        }
        return true;
      }
      return false;
    };
    this.deactivateAllBodies = function (hide_sprites) {
      while (active_bodies.length > 0) {
        this.deactivateBody(active_bodies[0], hide_sprites);
      }
    };

    //add a body to the active_bodies list. return true if it exists
    this.activateBody = function (id, show_sprite) {
      var body = getBody(id);
      if (body !== null && body !== undefined) {
        if (active_bodies.indexOf(id) === -1) {
          active_bodies.push(id);
        }

        //Reset the forces on the sprite
        //  body.setPosition(body.sprite.x, body.sprite.y);

        if (show_sprite) {
          getBody(id).sprite.visible = true;
        }
        return true;
      }
      $log.debug('woah no body: ' + id);
      return false;
    };
    //return an array of PIXI.Sprite
    this.getActiveSprites = function () {
      var sprites = [];
      for (var i = 0; i < active_bodies.length; i++) {
        sprites.push(getBody(active_bodies[i]).sprite);
      }
      return sprites;
    };

    this.getActiveSlugs = function () {
      return active_bodies;
    };
  };
});
'use strict';

angular.module('mtic.components.modules').service('PanelStateService', function () {
  var expanded_resources = {};
  var showAgenda = true;
  var active_agenda;
  return {
    agendaShowing: function agendaShowing() {
      return showAgenda;
    },
    setAgendaShowing: function setAgendaShowing(val) {
      showAgenda = val;
    },
    setActiveAgenda: function setActiveAgenda(val) {
      active_agenda = val;
    },
    getActiveAgenda: function getActiveAgenda() {
      return active_agenda;
    },
    setResourceExpanded: function setResourceExpanded(slug, is_expanded) {
      expanded_resources[slug] = is_expanded;
    },
    getResourceExpanded: function getResourceExpanded(slug) {
      return expanded_resources[slug];
    }
  };
});
'use strict';

angular.module('mtic.components.modules').service('MapStateService', function ($log, EventManager) {
  var active_module = "";
  var active_items = [];
  var states = {};
  var focus_slug = "";
  var map_coords = {
    x: 0,
    y: 0
  };
  var selectedResourcesForAgendaCreation = {};
  var moduleModalsInvertedVisibility = {};
  var active_meta = "";
  var itemOptions;
  var next_item;
  var current_used_lang;
  var eventManager = new EventManager('MapStateService');
  return {
    reset: function reset() {
      active_module = "";
      active_items = [];
      states = {};
      focus_slug = "";
      active_meta = "";
      map_coords = {
        x: 0,
        y: 0
      };
      selectedResourcesForAgendaCreation = {};
      moduleModalsInvertedVisibility = {};
    },
    getMetaStateSlug: function getMetaStateSlug() {
      return active_meta;
    },
    setMetaStateSlug: function setMetaStateSlug(slug) {
      active_meta = slug;
    },
    getActiveModule: function getActiveModule() {
      return active_module;
    },
    setActiveModule: function setActiveModule(slug) {
      active_module = slug;
    },

    setItemState: function setItemState(slug, pos) {
      states[slug] = {
        x: pos.x,
        y: pos.y
      };
    },
    setFocusSlug: function setFocusSlug(slug) {
      focus_slug = slug;
    },
    getFocusSlug: function getFocusSlug() {
      return focus_slug;
    },
    getItemState: function getItemState(slug) {
      return states[slug];
    },
    getActiveItems: function getActiveItems() {
      return active_items;
    },
    setActiveItems: function setActiveItems(items) {
      active_items = items;
    },
    setMapCoords: function setMapCoords(x, y) {
      map_coords.x = x;
      map_coords.y = y;
    },
    getMapCoords: function getMapCoords() {
      return map_coords;
    },
    setModuleModalsInvertedVisibility: function setModuleModalsInvertedVisibility(moduleName, isHidden) {
      moduleModalsInvertedVisibility[moduleName] = isHidden;
    },
    getModuleModalsInvertedVisibility: function getModuleModalsInvertedVisibility(moduleName) {
      return moduleModalsInvertedVisibility[moduleName];
    },
    getSelectedResourcesForAgendaCreation: function getSelectedResourcesForAgendaCreation() {
      return selectedResourcesForAgendaCreation;
    },
    setSelectedResourcesForAgendaCreation: function setSelectedResourcesForAgendaCreation(resources) {
      selectedResourcesForAgendaCreation = resources || {};
    },
    setItemOptions: function setItemOptions(options) {
      $log.log('setItemOptions : ', options);
      itemOptions = options;
      eventManager.broadcast('set:lesson:options', options);
    },
    getItemOptions: function getItemOptions() {
      $log.log('getItemOptions : ', itemOptions);
      return itemOptions;
    },
    setNextAvailableItem: function setNextAvailableItem(item) {
      next_item = item;
    },
    getNextAvailableItem: function getNextAvailableItem() {
      return next_item;
    },
    setCurrentItemLang: function setCurrentItemLang(lang) {
      current_used_lang = lang;
    },
    getCurrentItemLang: function getCurrentItemLang(lang) {
      return current_used_lang;
    }
  };
});
'use strict';

angular.module('mtic.components.modules').service('MapDataMassage', function ($log) {

  var TEMP_UNLOCK_CORE = [
    // 'mtic_g78_m2_equiv_expr',
    // 'mtic_g78_m2_grand_stair_pt1',
    // 'mtic_g78_m2_prog_calc_a',
    // 'mtic_g78_m2_spread_calc_pt1',
    // 'mtic_g78_m2_dist_act',
    // 'mtic_g78_m1_beaker',
    // 'mtic_g78_m1_prop_table_a'
  ];

  return {
    getTempUnlocks: function getTempUnlocks() {
      return TEMP_UNLOCK_CORE;
    },

    massageResourceMapOne: function massageResourceMapOne(resourceMap) {
      var newChildrenList = [];
      var item;

      var disabled_items = [
        //'mtic_g78_m1_candy',
        //'mtic_g78_m1_robot',
        //'mtic_g78_m1_juice',
        //'mtic_g78_m1_crepes',
        //'mtic_g78_m1_meeting',
        //'mtic_g78_m1_path',
        //'mtic_g78_m1_open',
        // 'mtic_g78_m1_summ',
        //'mtic_g78_m1_flooring',
        // 'mtic_g78_m1_diag',
        //'mtic_g78_m1_analyze_coef'
      ];
      var i, n, j;

      for (i = 0; i < resourceMap.length; i++) {
        item = resourceMap[i];
        if (TEMP_UNLOCK_CORE) {
          if (_.indexOf(TEMP_UNLOCK_CORE, item.slug) !== -1) {
            item.locked = false;
          }
        }

        if (item.slug === 'mtic_g78_m1_prop_table_a') {
          item.unlocked_by = ['mtic_g78_m1_diag'];
        }

        if (item.resource_type === 'symlink') {
          item.complete = true;
          for (n = 0; n < item.unlocked_by.length; n++) {
            for (j = 0; j < resourceMap.length; j++) {
              if (item.unlocked_by[n] === resourceMap[j].slug) {
                item.complete = item.complete && resourceMap[j].complete;
              }
            }
          }
        }
        if (disabled_items.indexOf(item.slug) === -1) {
          newChildrenList.push(item);
        }
      }

      //we need to do this check because the db isn't accounting for symlinks yet
      //Standard LOOP over the entire map, checking if any items are locked and if they should be unlocked (all unlocked_by are COMPLETE)
      //repeat the entire loop if any  new items were unlocked in the last loop
      var check_again = true;
      var unlock = true;
      while (check_again) {
        check_again = false;
        for (i = 0; i < newChildrenList.length; i++) {
          item = newChildrenList[i];
          if (item.locked === false) {
            continue;
          }
          unlock = true;
          for (n = 0; n < item.unlocked_by.length; n++) {
            for (j = 0; j < newChildrenList.length; j++) {
              if (item.unlocked_by[n] === newChildrenList[j].slug) {
                unlock = unlock && newChildrenList[j].complete;
              }
            }
          }
          if (unlock && (!item.config || !item.config.assessment_type)) {
            item.locked = false;
            check_again = true;
          }
        }
      }
      return newChildrenList;
    },
    massageResourceMapTwo: function massageResourceMapTwo(resourceMap) {

      var newChildrenList = [];

      //Make our MapItem templates for the groups
      var dist_add_group = {
        children: [],
        id: -1,
        name: "Simple Distributivity (Addition)",
        slug: "mtic_g78_m2_distrib_add_group",
        unlocked_by: [],
        display: {
          position: {},
          color: "blue"
        },
        config: {},
        content: {},
        resource_type: "group"
      };
      var dist_sub_group = {
        children: [],
        id: -1,
        name: "Simple Distributivity (Subtraction)",
        slug: "mtic_g78_m2_distrib_sub_group",
        unlocked_by: ['mtic_g78_m2_distrib_add_group', 'mtic_g78_m2_distrib_add_pt3'],
        display: {
          position: {},
          color: "blue"
        },
        config: {},
        content: {},
        resource_type: "group"
      };

      var spread_calc_group = {
        children: [],
        id: -1,
        name: "Spreadsheet and Calculation Programs",
        slug: "mtic_g78_m2_spread_calc_group",
        unlocked_by: [],
        display: {
          position: {},
          color: "blue"
        },
        config: {},
        content: {},
        resource_type: "group"
      };

      var factoring_group = {
        children: [],
        id: -1,
        name: "Factoring",
        slug: "mtic_g78_m2_factoring_group",
        unlocked_by: ['mtic_g78_m2_distrib_add_group', 'mtic_g78_m2_distrib_add_pt3'],
        display: {
          position: {},
          color: "blue"
        },
        config: {},
        content: {},
        resource_type: "group"
        //   newChildrenList.push(dist_add_group);
        //   newChildrenList.push(dist_sub_group);
        //   newChildrenList.push(spread_calc_group);
        //   newChildrenList.push(factoring_group);

        //Add the map items that should be in the groups to the groups, and put the rest in the root group
      };_.forEach(resourceMap, function (someItem) {

        if (TEMP_UNLOCK_CORE) {
          if (_.indexOf(TEMP_UNLOCK_CORE, someItem.slug) !== -1) {
            someItem.locked = false;
          }
        }

        switch (someItem.slug) {
          //fix up other stuff
          case "mtic_g78_m2_factoring_ex":
            someItem.unlocked_by.push('mtic_g78_m2_factoring_group');
            newChildrenList.push(someItem);
            break;
          case "mtic_g78_m2_fibonacci":
            someItem.unlocked_by.push('mtic_g78_m2_distrib_sub_group');
            newChildrenList.push(someItem);
            break;
          case "mtic_g78_m2_distrib_exer":
            someItem.unlocked_by.push('mtic_g78_m2_distrib_sub_group');
            newChildrenList.push(someItem);
            break;
          case "mtic_g78_m2_sum":
            someItem.unlocked_by = [];
            break;
          default:
            newChildrenList.push(someItem);
            break;
        }
      });

      //Check for group completions
      //Are all of the children of the group finished?
      _.forEach(newChildrenList, function (someItem) {
        if (someItem.children && someItem.children.length > 0) {
          var doComplete = true;
          for (var n = 0; n < someItem.children.length; n++) {
            if (!someItem.children[n].complete) {
              doComplete = false;
            }
          }
          if (doComplete) {
            someItem.studentWork = [];
            someItem.complete = true;
          }
        }
      });

      return newChildrenList;
    }
  };
});
'use strict';

angular.module('mtic.components.modules.moduleIframe', []);
'use strict';

angular.module('mtic.components.modules.moduleIframe').directive('moduleIframe', function ($log, api, $sce, language, EventManager, StudentDataService, apiMethods) {
  return {
    template:'<iframe ng-if="src" scrolling="{{iframeScroll}}" ng-src="{{src}}" id="moduleIframe" style="position:absolute; height: 100%; width: 100%; background: white;"></iframe>',
    restrict: 'E',
    scope: {
      moduleMapData: "=",
      moduleId: "=",
      iframeScroll: '=?'
    },
    link: function link(scope, element, attr) {
      scope.iframeScroll = scope.iframeScroll || 'no';

      var eventManager = new EventManager('moduleIframe', scope);
      scope.language = language;
      var url = scope.moduleMapData.hostUrl;
      if (!url) {
        url = StudentDataService.genUrlfromContent(scope.moduleMapData.slug, scope.moduleMapData.content);
      }

      scope.src = $sce.trustAsResourceUrl(url);
      /**
      * Broadcast to child iframe
      * @param  {String} type
      * @param {Object} payload
      * @return {null}
      */
      var broadcastToIframe = function broadcastToIframe(type, payload) {
        $log.debug('[[broadcastToIframe]]', type, payload);
        document.getElementById('moduleIframe').contentWindow.postMessage(JSON.stringify({
          type: type,
          payload: payload
        }), document.getElementById('moduleIframe').src);
      };

      /**
      * A flag indicating that the postMessageHandler is Sending
      * @type {Boolean}
      */
      var postMessageHandlerLastSentTime = 0;
      var submitting;

      var eventListeners = [{
        eventName: "language:change",
        listener: function listener(e, eventData) {
          broadcastToIframe('LANGUAGE_CHANGE', eventData);
        }
      }, {
        eventName: "moduleIframe:RESOURCE_OPENED",
        listener: function listener(e, eventData) {
          broadcastToIframe('RESOURCE_MODULE_DATA_SENT', {
            slug: scope.moduleMapData.slug,
            id: scope.moduleMapData.id,
            resources: scope.moduleMapData.resources
          });
        }
      }, {
        eventName: "moduleIframe:RESOURCE_LOAD_COMPLETE",
        listener: function listener(e, eventData) {
          broadcastToIframe('LANGUAGE_CHANGE', language.getCurrentSelectedLanguage());
          //run_like_math levels
          if (eventData && eventData.payload && eventData.payload.module_id === 2) {
            eventManager.broadcast('resource:load:complete');
            eventManager.broadcast('mticResource:RESOURCE_LOAD_COMPLETE', eventData.payload);
          }
        }
      },
      /**
      * Modules like c3_m2 (run_like_math) are loaded as a single resource (a module map and collection of lessons).
      * This signal should be invoked when a lesson is opened from that map.
      * Otherwise there is no evidence that lessons are being accessed in the module.
      **/
      {
        eventName: "moduleIframe:OPENING_RESOURCE",
        listener: function listener(e, eventData) {
          eventData.payload.url = true;
          eventManager.broadcast('module:open:resource', eventData.payload);
        }
      }, {
        eventName: "moduleIframe:CLOSING_RESOURCE",
        listener: function listener(e, eventData) {
          eventManager.broadcast('module:close:resource', { isPassive: true });
          $log.log('HERRRRRRRRRREEEEEE');
        }
      }, {
        eventName: "moduleIframe:CHANGE_SUBMODULE",
        listener: function listener(e, eventData) {
          eventManager.broadcast('module:change:submodule', eventData.payload.slug);
        }
      }, {
        eventName: "moduleIframe:REQUEST_REFRESH",
        listener: function listener(e, eventData) {
          var src = scope.src;
          scope.src = null;
          StudentDataService.getModuleData(true).then(function (moduleMapData) {
            scope.src = src;
            eventManager.broadcast('app:module:refresh');
            document.getElementById('moduleIframe').contentWindow.location.reload();
          });
        }
      }, {
        eventName: "moduleIframe:RESOURCE_REFRESH_REQUEST",
        listener: function listener(e, eventData) {
          // $log.log('moduleIframe:RESOURCE_REFRESH_REQUEST', eventData);
          eventManager.broadcast('app:module:refresh'); // TO DO : watch for race condition, this is a fairly loose trigger which is not defending against the user navigating to something else
        }
      }, {
        eventName: "app:module:refresh/ready",
        listener: function listener(e, eventData) {
          // $log.log('app:module:refresh/ready', eventData);
          broadcastToIframe('RESOURCE_REFRESH_READY', {});
        }
      }, {
        eventName: "module:updateAndClose:resource",
        listener: function listener(e, eventData) {
          broadcastToIframe('REQUEST_ITEM_PROGRESS', eventData);
        }
      }, {
        eventName: "moduleIframe:ITEM_PROGRESS",
        listener: function listener(e, payload) {
          if (submitting) {
            return;
          }
          submitting = true;
          if (!payload.payload) {
            var payload_copy = angular.copy(payload);
            payload.payload = payload_copy;
            payload.payload.complete = payload.payload.complete ? payload.payload.complete : payload.completed;
            payload.payload.id = payload.payload.id === undefined ? scope.moduleMapData.id : payload.payload.id;
          }
          // $log.log('from moduleiframe, reporting progress : ', payload)
          var mod_id = scope.moduleId;
          if (payload.slug === 'mtic_student_offboarding' || payload.slug === 'mtic_teacher_offboarding' || payload.slug === 'mtic_post_test') {
            mod_id = 57;
          }
          if (payload.payload.app_state) {
            payload.payload.app_state.assessment_session_hash = eventManager.getResourceSession();
            $log.log('got resource session : ', payload.payload.app_state.assessment_session_hash);
          }
          return api.submitStudentResourceState({
            "slug": payload.payload.slug,
            "score": payload.payload.score, //Math.max(0,Math.min(1,payload.payload.score)),
            "complete": payload.payload.complete,
            "time_spent": payload.payload.time_spent,
            "time_stamp": payload.payload.time_stamp,
            "log_data": payload.payload.log_data || {},
            "app_state": payload.payload.app_state || {},
            "resource_id": payload.payload.id,
            "module_id": mod_id,
            "class_id": scope.moduleMapData.class_id
          }).then(function (response) {
            submitting = false;
            eventManager.broadcast('resource:score:submitted', {
              "attemptNumber": response.attempts,
              "work_batch_id": response.work_batch_id,
              "score": payload.payload.score,
              "complete": payload.payload.complete
            });
          }, function (error) {
            submitting = false;
            $log.error('Failed to update the state', error);
          });
          // }
        }
      }, {
        eventName: "$messageIncoming",
        /**
        * A global listener, that handles events coming from the app
        * @param  {Event} event
        * @param  {Object} itemProgressPayload
        */
        listener: function listener(event, msgPayload) {
          var timeSince = Date.now() - postMessageHandlerLastSentTime;
          $log.debug('$messageIncoming', {
            msgPayload: msgPayload,
            currentResource: scope.currentResource
          });
          if (timeSince < 3 * 1000) {
            $log.warn('postMessageHandlerIsSending is being sent very rapidly! timeSince:', timeSince + 'ms');
          }
          postMessageHandlerLastSentTime = Date.now();
          if (msgPayload.type) {
            eventManager.broadcast('moduleIframe:' + msgPayload.type, msgPayload.payload);
          } else {
            $log.error('No Event Type coming from resource!');
          }
        }
      }];

      var listenerDeregisters = [];
      eventListeners.forEach(function (eventListener) {
        var listener = eventManager.listen(eventListener.eventName, eventListener.listener);
        listenerDeregisters.push(listener);
      });

      scope.$on('$destroy', function () {
        eventManager.broadcast('module:reload:map');
        listenerDeregisters.forEach(function (listenerDeregister) {
          listenerDeregister();
        });
      });
    }
  };
});
'use strict';

angular.module('mtic.components.modules.generalModuleMap').service('itemFactory', function (GR78_ASSET_URL, EventManager, $log, $timeout, TIMING_CONSTANTS, language, DEV_VARIABLES, TeacherDataService, MapStateService, ModuleFilter) {

  var currentActiveItem = null;

  var getIconFilename = function getIconFilename(item_info) {

    //assessments are easy
    if (item_info.resource_type === 'assessment') {
      if (item_info.config.assessment_type && item_info.config.assessment_type === 'formative') {
        if (item_info.complete && item_info.resourceState && item_info.resourceState.score_max >= 0.8) {
          return 'formative_gold.png';
        } else if (item_info.complete) {
          return 'formative_silver.png';
        } else if (!item_info.locked) {
          return 'formative_unlocked.png';
        } else {
          return 'formative_locked.png';
        }
      }
      if (item_info.map_config && item_info.map_config.icon_options && (item_info.map_config.icon_options.summative_locked || item_info.map_config.icon_options.diagnostic_locked)) {
        var status;
        if (item_info.config.assessment_type && item_info.config.assessment_type === 'summative') {
          status = item_info.locked ? item_info.map_config.icon_options.summative_locked : item_info.map_config.icon_options.summative_unlocked;
          status = item_info.complete ? item_info.map_config.icon_options.summative_complete : status;
          return status;
        } else {
          status = item_info.locked ? item_info.map_config.icon_options.diagnostic_locked : item_info.map_config.icon_options.diagnostic_unlocked;
          status = item_info.complete ? item_info.map_config.icon_options.diagnostic_complete : status;
          return status;
        }
      } else {
        if (item_info.complete || item_info.config.assessment_type && item_info.config.assessment_type === 'summative') {
          return 'assessment_complete.png';
        }
        return 'assessment.png';
      }
    }
    if (!item_info.display) {
      item_info.display = {};
    }

    //get the color from item_info.display.color, fall back to "red" if it isn't defined
    var color_string = item_info.display.color !== undefined ? item_info.display.color : 'red';

    var suffix;
    if (item_info.locked) {
      suffix = "_locked";
    } else {
      if (!item_info.resourceState || !item_info.resourceState.complete) {
        suffix = "_0";
      } else {

        var count = 0;

        if (item_info.map_config && item_info.map_config.item_scoring_breakdown) {
          var max_scoring_found = 0;
          for (var scoring in item_info.map_config.item_scoring_breakdown) {
            if (item_info.map_config.item_scoring_breakdown[scoring] && item_info.resourceState.score_max >= Number(scoring) && Number(scoring) > max_scoring_found) {
              count = item_info.map_config.item_scoring_breakdown[scoring];
              max_scoring_found = Number(scoring);
            }
          }
        } else {
          if (item_info.resourceState.score_max >= 1) {
            count = 3;
          } else if (item_info.resourceState.score_max >= 0.8) {
            count = 2;
          } else if (item_info.resourceState.score_max >= 0.5) {
            count = 1;
          }
        }
        if (color_string === 'blue') {
          count = 1; //Math.min(count, 1);
        }
        count = Math.max(0, count);
        suffix = "_" + count;
      }
    }
    var filename = item_info.map_config && item_info.map_config.icon_options && item_info.map_config.icon_options.item_icon_name ? item_info.map_config.icon_options.item_icon_name + suffix + ".png" : "item_" + color_string + suffix + ".png";

    return filename;
  };
  return {
    unlockedByAgenda: false,
    getCurrentActiveItem: function getCurrentActiveItem() {
      return currentActiveItem;
    },
    createMapItem: function MapItem(item_info, eventManager, map_config) {
      item_info.map_config = map_config;
      var scale = item_info.map_config && item_info.map_config.icon_options && item_info.map_config.icon_options.item_icon_scale ? item_info.map_config.icon_options.item_icon_scale : 1.0,
          alwaysHideTooltip = false || item_info.map_config && item_info.map_config.hide_tooltip;
      // Grab Relevant data for item

      this.id = item_info.id;
      this.name = item_info.name;
      this.slug = item_info.slug;
      this.type = item_info.resource_type;
      this.studentWork = item_info.studentWork;
      this.config = item_info.config;

      this.container = {};
      if (item_info.content) {
        this.container = item_info.content.container;
      }
      this.complete = item_info.complete;
      this.locked = item_info.parent_resource_id > 2252 && item_info.parent_resource_id < 2258 ? false : item_info.locked; //item_info.parent_resource_id === 1114 && window.location.href.indexOf('locxalhost') > -1 ? false :item_info.locked;//add this for unlocked m0: item_info.parent_resource_id === 1114 ? false :
      this.unlocked_by = item_info.unlocked_by;
      this.content = item_info.content;
      this.verletBody = null;
      this.parentItem = null;

      var agenda_highlight = null;

      if (DEV_VARIABLES.RESOURCES.MARK_COMPLETE.indexOf(this.slug) > -1) {
        this.complete = true;
      }
      //Handle group stuff!!
      if (item_info.children && item_info.children.length > 0) {
        this.locked = true;
        var i = 0;
        for (i = 0; i < item_info.children.length; i++) {
          this.locked = this.locked && item_info.children[i].locked;
        }
        item_info.locked = this.locked;

        this.complete = true;
        for (i = 0; i < item_info.children.length; i++) {
          this.complete = this.complete && item_info.children[i].complete;
        }
        item_info.complete = this.complete;
        item_info.resourceState = {};
        item_info.resourceState.score_max = this.complete ? 1 : 0;
      }

      if (DEV_VARIABLES.RESOURCES.UNLOCK_THESE.indexOf(this.slug) > -1) {
        this.locked = false;
      }
      if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(this.slug) > -1 || !ModuleFilter.checkAvailable(item_info)) {
        this.locked = true;
      }

      var sprite, icon;
      var startClickPos = {
        x: 0,
        y: 0
      };

      this.setDelegate = function (del) {
        var boundClick = function (e) {
          del(this.slug);
        }.bind(this);
        sprite.on('pointertap', boundClick);
        //sprite.on('click', );
      };

      var getItemDisplayName = function getItemDisplayName() {
        var itemDisplayName;
        if (item_info.display && item_info.display.nameLangId) {
          itemDisplayName = language.get(item_info.display.nameLangId);
        } else {
          // if(item_info.slug.indexOf('gr78_m4') > -1 || item_info.slug.indexOf('g78_m4') > -1){
          //   itemDisplayName = language.get(item_info.slug+'_short', null, true)
          // }else{
          //   itemDisplayName = language.get(item_info.slug, null, true)
          // }
          itemDisplayName = language.get(item_info.slug, null, true);
        }
        if ((!itemDisplayName || itemDisplayName === item_info.slug) && item_info.name) {
          itemDisplayName = item_info.name;
        }
        return itemDisplayName;
      };

      this.updateIcon = function () {
        var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;
        if (this.type === 'symlink') {
          icon.texture = PIXI.loader.resources[ASSET_URL + "symlink.png"].texture;
        } else if (PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)]) {
          icon.texture = PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)].texture;
        } else {
          $log.warn('texture not found for : ', ASSET_URL + getIconFilename(item_info));
        }
        if (this.display_text) {
          this.display_text.visible = !item_info.locked;
        }
      };
      this.buildTooltip = function () {
        if (tooltip !== null && tooltip !== undefined) {
          sprite.removeChild(tooltip);
          tooltip.interactive = false;
        }
        tooltip = new PIXI.Sprite();

        var font_color = item_info.map_config && item_info.map_config.tooltip_options && item_info.map_config.tooltip_options.fontcolor ? item_info.map_config.tooltip_options.fontcolor : 0xFFFFFF;
        var fill_color = item_info.map_config && item_info.map_config.tooltip_options && item_info.map_config.tooltip_options.color ? item_info.map_config.tooltip_options.item_fillcolor || item_info.map_config.tooltip_options.color : 0x3B5763;
        font_color = item_info.display.tooltip_fontcolor || font_color;
        fill_color = item_info.display.tooltip_fillcolor || fill_color;
        // Text Information
        var textInfo = new PIXI.Text(getItemDisplayName(), {
          fontFamily: 'Arial',
          align: 'center',
          fontSize: 24,
          fill: font_color,
          dropShadow: true,
          dropShadowDistance: 1,
          dropShadowBlur: 0,
          wordWrap: true,
          wordWrapWidth: 200
        });

        var tooltip_graphics = new PIXI.Graphics();

        var drawTooltipContainer = function drawTooltipContainer() {
          tooltip_graphics.clear();
          // Draw Text Bubble that wraps around the text
          tooltip_graphics.lineStyle(0);
          tooltip_graphics.beginFill(fill_color);
          tooltip_graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 20, 10);
          tooltip_graphics.endFill();

          // Draw Triangle pointing to planet
          tooltip_graphics.beginFill(fill_color);
          tooltip_graphics.moveTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
          tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2, textInfo.y - 18);
          tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2 + 5, textInfo.y - 10);
          tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
          tooltip_graphics.endFill();

          tooltip_graphics.x = -tooltip_graphics.width / 2 + 20;
          var height_offset = 10;
          if (map_config && map_config.map_style === 'ocmt') {
            height_offset = that.type === 'assessment' ? 85 : 65;
          }
          tooltip_graphics.y = icon.height / 2 + height_offset;
        };

        drawTooltipContainer();

        tooltip.addChild(tooltip_graphics);
        tooltip_graphics.addChild(textInfo);
        sprite.addChild(tooltip);
        tooltip.interactiveChildren = false;
        tooltip.visible = map_config && map_config.tooltip_options && map_config.tooltip_options.always_visible || item_info.config.assessment_type && item_info.config.assessment_type === 'summative' && !item_info.config.show_summative ? true : false;
        var tooltip_scale = map_config && map_config.tooltip_scale ? map_config.tooltip_scale : 1;
        tooltip.scale.set(tooltip_scale, tooltip_scale);

        eventManager.listen('language:change', function () {
          if (textInfo === undefined) {
            return;
          }
          textInfo.setText(getItemDisplayName());
          drawTooltipContainer();
        });

        eventManager.listen('module:change:meta', function () {
          that.hideAgendaHighlight();
        });

        var updateItemInfoComplete = function updateItemInfoComplete(existsItem) {
          var exists_score_max = item_info.resourceState ? item_info.resourceState.score_max : null;
          item_info.complete = existsItem.completed;
          item_info.resourceState = { complete: existsItem.completed };
          item_info.resourceState.score_max = exists_score_max ? Math.max(exists_score_max, existsItem.score) : existsItem.score;
          item_info.score = item_info.resourceState.score_max;
        };

        eventManager.listen("teacherStudentWorkspace:studentFilter:change", function (e, eventData) {
          var filteredList = eventData.list || [];
          var doneItemsList = [];
          if (filteredList && filteredList.length > 0) {
            doneItemsList = _.filter(filteredList, function (item) {
              return item.resource_id === item_info.id;
            });
          }

          if (doneItemsList.length > 0) {
            var exists_info = { score: null, completed: false };
            _.each(doneItemsList, function (existsItem) {
              exists_info.completed = exists_info.completed || existsItem.completed;
              exists_info.score = exists_info.score ? Math.max(exists_info.score, existsItem.score) : existsItem.score;
            });
            updateItemInfoComplete(exists_info);
          } else {
            item_info.complete = false;
            item_info.resourceState = { complete: false, score_max: null };
            item_info.score = null;
          }
          var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;
          if (item_info.resource_type === 'symlink' && PIXI.loader.resources[ASSET_URL + "symlink.png"]) {
            icon.texture = PIXI.loader.resources[ASSET_URL + "symlink.png"].texture;
          } else if (PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)]) {
            icon.texture = PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)].texture;
          }
        });
      };

      eventManager.listen('set:options', function (e, args) {
        item_info.options = args;
      });

      var unclickableTypes = ['symlink'];
      this.onButtonClick = function () {

        if (unclickableTypes.indexOf(this.type) > -1) {
          return;
        }

        //Cancel click events if they dragged more than 100 pixels
        var curPos = sprite.toGlobal(new PIXI.Point(0, 0));
        if (Math.pow(startClickPos.x - curPos.x, 2) + Math.pow(startClickPos.y - curPos.y, 2) > 100 * 100) {
          return;
        }

        $log.debug('[[mapItemFactory]] clicking on', item_info, 'LOCK STATUS:::::::::::::', this.locked);
        if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug) > -1) {
          if (!TeacherDataService.isTeacherModuleView) {
            this.locked = false;
          } else {
            this.locked = true;
          }
        }
        if (!ModuleFilter.checkAvailable(item_info)) {
          this.locked = true;
          item_info.locked = true;
          eventManager.broadcast('display-maintenance-message', item_info.slug);
        }

        $timeout(function () {
          sprite.scale.set(1 * scale, 1 * scale);
          eventManager.broadcast('module:stop:pan');
          eventManager.broadcast('module:select:resource', item_info);
        }, TIMING_CONSTANTS.INSTANT);
      };

      this.unlock = function (force) {
        if (item_info.config.assessment_type && !force || DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug) > -1 || !ModuleFilter.checkAvailable(item_info)) {
          return;
        }
        item_info.locked = false;
        this.locked = false;
        this.updateIcon();
      };

      this.lock = function () {
        if (this.unlockedByAgenda) {
          return;
        }
        item_info.locked = true;
        this.locked = true;
        this.updateIcon();
      };

      this.getItemInfo = function () {
        return item_info;
      };

      this.setItemComplete = function () {
        this.updateIcon();
        if (this.studentWork) {
          this.studentWork.completions++;
        } else {
          this.studentWork = {
            completions: 1
          };
        }
      };

      //For setting up verlet links to items inside a folder
      //items in minimized folders should verlet links to their parent
      this.getLinkedBody = function () {
        if (this.shouldBeOnMap()) {
          return this.verletBody;
        } else {
          return this.parentItem.getLinkedBody();
        }
      };

      //Map items inside mimized folder items get ignored
      this.shouldBeOnMap = function () {
        if (this.parentItem !== null) {
          return this.parentItem.isExpanded;
        } else {
          return this.isExpanded === true ? false : true;
        }
      };

      this.showHighlight = function () {
        if (this.type === 'symlink') {
          return;
        }
        if (tooltip && !alwaysHideTooltip) {
          tooltip.visible = true;
        }
        sprite.scale.set(1.1 * scale, 1.1 * scale);
        if (sprite.parent !== null) {
          sprite.parent.setChildIndex(sprite, sprite.parent.children.length - 1);
        }
      };

      this.undoAgendaHighlight = function () {};

      this.selection_graphic = null;
      this.highlight_graphic = null;
      this.agenda_box_graphic = null;
      this.semi_ring = null;
      this.line_graphic = null;
      var that = this;
      var is_item_selected;
      this.addSemiRing = function () {
        //var scale_size =  this.type === 'assessment' ? 1.25 : 1.025;
        var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;
        var ring_name = 'selection.png';
        if (item_info.map_config && item_info.map_config.map_style === 'ocmt' && item_info.map_config.icon_options && this.type === 'assessment') {
          ring_name = item_info.map_config.icon_options.selection_assessment;
        }
        this.semi_ring = new PIXI.Sprite(PIXI.loader.resources[ASSET_URL + ring_name].texture);
        this.semi_ring.anchor.set(0.5, 0.5);
        this.semi_ring.scale.set(1.025, 1.025);
        this.semi_ring.interactive = false;
        this.semi_ring.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
        icon.addChild(this.semi_ring);
        // this.semi_ring = new PIXI.Graphics();
        // var color = item_info.display.tooltip_fillcolor || map_config.tooltip_options.color;
        // this.semi_ring.lineStyle(3, color, 1)
        // if(this.type === 'assessment'){
        //   x_1 = 0.5; x_2 = -1; x_3 = 45;
        // }
        // this.semi_ring.arc(x_1, x_2, x_3, x_4, x_5)
        // //this.semi_ring.bezierCurveTo(-5-icon.width/2, 5-icon.height/2, 5-icon.width/2, 15-icon.height/2, 5+icon.width/2, 0)
        // this.semi_ring.interactive = false;
        // icon.addChildAt(this.semi_ring, 0);
      };
      this.rotateRing = function () {
        this.semi_ring.rotation = (this.semi_ring.rotation - 0.015) % (Math.PI * 2);
      };
      this.endRotation = function () {
        this.semi_ring.rotation = 0;
      };
      this.addBottomLineGraphics = function () {
        this.line_graphic = new PIXI.Graphics();
        var color = item_info.display.tooltip_fillcolor || map_config.tooltip_options.color;
        this.line_graphic.lineStyle(3, color, 1);
        this.line_graphic.beginFill(color);
        var height = icon.height / 2 + 5;
        var line_height = this.type === 'assessment' ? 50 : 30;
        this.line_graphic.moveTo(0, height);
        this.line_graphic.lineTo(0, height + line_height);
        this.line_graphic.drawCircle(0, height + line_height, 7);
        this.line_graphic.interactive = false;
        icon.addChildAt(this.line_graphic, 0);
      };
      this.showAgendaHighlight = function (force, is_selection) {
        // $log.log('HIGHGLIGHT SELECTION : ' , item_info.display.position)
        if (item_info.map_config && item_info.map_config.selector_options && item_info.map_config.selector_options.disabled) {
          return;
        }
        var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;
        if (this.highlight_graphic === null && is_selection && (!item_info.map_config.selector_options || !item_info.map_config.selector_options.disable_highlight)) {
          // this is used in the agenda editor view
          // $log.log('show agenda highlight', this.slug, is_selection)
          if (item_info.map_config.selector_options && item_info.map_config.selector_options.highlight_icon) {
            icon.texture = PIXI.loader.resources[ASSET_URL + item_info.map_config.selector_options.highlight_icon + '.png'].texture;
            this.showing_highlight = true;
          } else {
            var radius = this.type === 'assessment' && (!item_info.config.assessment_type || item_info.config.assessment_type !== 'formative') ? 85 : 50;
            this.highlight_graphic = new PIXI.Graphics();
            this.highlight_graphic.lineStyle(22, 0x33CCFF, 1);
            this.highlight_graphic.drawCircle(0, 0, radius);
            this.highlight_graphic.interactive = false;
            this.highlight_graphic.scale.set(0.75 * scale, 0.75 * scale);
            this.highlight_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
            icon.addChildAt(this.highlight_graphic, 0);
          }
        } else if (!is_selection && this.selection_graphic === null && force !== false) {
          // this is used in the activity log view
          is_item_selected = is_selection;
          var scale_size = this.type === 'assessment' ? 2.5 : 0.75;
          var selector_scale = item_info.map_config.selector_options && item_info.map_config.selector_options.selector_scale ? item_info.map_config.selector_options.selector_scale : scale_size;
          var selector_icon_name = item_info.map_config.selector_options && item_info.map_config.selector_options.icon_name ? item_info.map_config.selector_options.icon_name : "selection.png";

          if (item_info.map_config && item_info.map_config.selector_options && item_info.map_config.selector_options.drawn_selector) {
            this.selection_graphic = new PIXI.Graphics();
            this.selection_graphic.lineStyle(18, 0xFFCC00, 1);
            this.selection_graphic.drawCircle(0, 0, 48);
          } else {
            this.selection_graphic = new PIXI.Sprite(PIXI.loader.resources[ASSET_URL + selector_icon_name].texture);
            var anchor = item_info.map_config.selector_options && item_info.map_config.selector_options.anchor ? item_info.map_config.selector_options.anchor : { x: 0.5, y: 0.5 };
            this.selection_graphic.anchor.set(anchor.x, anchor.y);
            this.selection_graphic.scale.set(selector_scale * scale, selector_scale * scale);
            this.selection_graphic.interactive = false;
            this.selection_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
          }
          sprite.addChildAt(this.selection_graphic, 0);
        } else if (!force) {
          // $log.log('from toggle agenda selection', this.slug, is_selection)
          that.hideAgendaHighlight();
        }
      };
      this.hideAgendaHighlight = function (from_item_highlight) {
        if (item_info.map_config && item_info.map_config.selector_options && item_info.map_config.selector_options.disabled) {
          return;
        }
        if (from_item_highlight && (this.highlight_graphic !== null || this.showing_highlight)) {
          if (item_info.map_config.selector_options && item_info.map_config.selector_options.highlight_icon) {
            var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;
            icon.texture = PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)].texture;
            this.showing_highlight = false;
          } else {
            icon.removeChild(this.highlight_graphic);
            this.highlight_graphic = null;
          }
        }if (!from_item_highlight && this.selection_graphic !== null) {
          sprite.removeChild(this.selection_graphic);
          this.selection_graphic = null;
        }
      };

      this.hideHighlight = function () {
        if (tooltip && !alwaysHideTooltip) {
          tooltip.visible = map_config && map_config.tooltip_options && map_config.tooltip_options.always_visible || item_info.config.assessment_type && item_info.config.assessment_type === 'summative' && !item_info.config.show_summative ? true : false;
        }
        sprite.scale.set(1 * scale, 1 * scale);
      };

      this.setScale = function (scaleToBeSet) {
        scale = scaleToBeSet;
        sprite.scale.set(scale, scale);
      };

      this.alwaysHideTooltip = function () {
        alwaysHideTooltip = true;
        tooltip.visible = false;
      };

      this.pointerdown = function () {
        sprite.scale.set(0.9 * scale, 0.9 * scale);
        startClickPos = sprite.toGlobal(new PIXI.Point(0, 0));
      };
      /**
       * Tooltip setup
       */
      var tooltip;

      icon = new PIXI.Sprite();
      if (item_info.map_config && item_info.map_config.icon_options && item_info.map_config.icon_options.icon_anchor) {
        icon.anchor.set(item_info.map_config.icon_options.icon_anchor.x, item_info.map_config.icon_options.icon_anchor.y);
      } else {
        icon.anchor.set(0.5, 0.5);
      }
      sprite = new PIXI.Sprite();
      this.sprite = sprite;
      sprite.scale.set(1 * scale, 1 * scale);

      var mouseOver = this.showHighlight.bind(this);
      sprite.on('mouseover', function () {
        mouseOver();
      });

      var mouseOut = this.hideHighlight.bind(this);
      sprite.on('pointerout', function () {
        mouseOut();
      });

      var pointerdown = this.pointerdown.bind(this);
      sprite.on('pointerdown', function () {
        pointerdown();
      });

      if (item_info.resource_type !== "group") {
        var boundClick = this.onButtonClick.bind(this);
        sprite.on('pointertap', boundClick);
      } else if (item_info.resource_type !== 'symlink') {
        this.open = false;
      }

      this.updateIcon();
      if (this.type === "group") {
        var bg = new PIXI.Sprite(icon.texture);
        bg.width += 20;
        bg.height += 20;

        bg.anchor.set(0.5, 0.5);
        sprite.addChild(bg);
      }
      sprite.addChild(icon);

      if (item_info.config.display_text) {
        this.display_text = new PIXI.Text(item_info.config.display_text.text, item_info.config.display_text.options);
        sprite.addChild(this.display_text);
        this.display_text.position = item_info.config.display_text.position || { x: sprite.width / 2 - this.display_text.width / 2, y: sprite.height / 2 - this.display_text.height / 2 };
        this.display_text.visible = !item_info.locked;
      }

      if (item_info.display.position !== undefined) {
        var divideBy = item_info.slug.indexOf("_g78_m0_") > -1 ? 1 : 5;
        var startPosx = item_info.map_config && item_info.map_config.position_x_offset ? item_info.map_config.position_x_offset : item_info.slug.indexOf("_g78_m0_") > -1 ? 1300 : 0;
        var startPosY = item_info.map_config && item_info.map_config.position_y_offset ? item_info.map_config.position_y_offset : item_info.slug.indexOf("_g78_m0_") > -1 ? 300 : 0;
        sprite.position.set(startPosx + item_info.display.position.x / divideBy, startPosY + item_info.display.position.y / divideBy);
      } else {
        sprite.position.set(0, 0);
      }
      sprite.interactive = true; //!item_info.locked;
      sprite.buttonMode = true;
      this.buildTooltip();
      //for testing...
      //this.unlock();
    }
  };
});
'use strict';

angular.module('mtic.components.modules.gr78').service('gr78MapItemFactory', function (GR78_ASSET_URL, EventManager, $log, $timeout, TIMING_CONSTANTS, language, DEV_VARIABLES, TeacherDataService, MapStateService, ModuleFilter) {

  var currentActiveItem = null;

  var getIconFilename = function getIconFilename(item_info) {

    //assessments are easy
    if (item_info.resource_type === 'assessment') {
      if (item_info.config.assessment_type && item_info.config.assessment_type === 'formative') {
        if (item_info.complete && item_info.resourceState && item_info.resourceState.score_max >= 0.8) {
          return 'formative_gold.png';
        } else if (item_info.complete) {
          return 'formative_silver.png';
        } else if (!item_info.locked) {
          return 'formative_unlocked.png';
        } else {
          return 'formative_locked.png';
        }
      }
      if (item_info.complete || item_info.config.assessment_type && item_info.config.assessment_type === 'summative') {
        return 'assessment_complete.png';
      }
      return 'assessment.png';
    }
    if (!item_info.display) {
      item_info.display = {};
    }

    //get the color from item_info.display.color, fall back to "red" if it isn't defined
    var color_string = item_info.display.color !== undefined ? item_info.display.color : 'red';

    var suffix;
    if (item_info.locked) {
      suffix = "_locked";
    } else {
      if (!item_info.resourceState || !item_info.resourceState.complete) {
        suffix = "_0";
      } else {

        var count = 0;

        if (item_info.resourceState.score_max >= 1) {
          count = 3;
        } else if (item_info.resourceState.score_max >= 0.8) {
          count = 2;
        } else if (item_info.resourceState.score_max >= 0.5) {
          count = 1;
        }
        if (color_string === 'blue') {
          count = 1; //Math.min(count, 1);
        }
        count = Math.max(0, count);
        suffix = "_" + count;
      }
    }
    var filename = "item_" + color_string + suffix + ".png";
    return filename;
  };
  return {
    unlockedByAgenda: false,
    getCurrentActiveItem: function getCurrentActiveItem() {
      return currentActiveItem;
    },
    createMapItem: function MapItem(item_info, eventManager) {
      var scale = 1.0,
          alwaysHideTooltip = false;
      // Grab Relevant data for item

      this.id = item_info.id;
      this.name = item_info.name;
      this.slug = item_info.slug;
      this.type = item_info.resource_type;
      this.studentWork = item_info.studentWork;
      this.config = item_info.config;

      this.container = {};
      if (item_info.content) {
        this.container = item_info.content.container;
      }
      this.complete = item_info.complete;
      this.locked = item_info.parent_resource_id > 2252 && item_info.parent_resource_id < 2258 ? false : item_info.locked; //item_info.parent_resource_id === 1114 && window.location.href.indexOf('locxalhost') > -1 ? false :item_info.locked;//add this for unlocked m0: item_info.parent_resource_id === 1114 ? false :
      this.unlocked_by = item_info.unlocked_by;
      this.content = item_info.content;
      this.verletBody = null;
      this.parentItem = null;

      var agenda_highlight = null;

      if (DEV_VARIABLES.RESOURCES.MARK_COMPLETE.indexOf(this.slug) > -1) {
        this.complete = true;
      }
      //Handle group stuff!!
      if (item_info.children && item_info.children.length > 0) {
        this.locked = true;
        var i = 0;
        for (i = 0; i < item_info.children.length; i++) {
          this.locked = this.locked && item_info.children[i].locked;
        }
        item_info.locked = this.locked;

        this.complete = true;
        for (i = 0; i < item_info.children.length; i++) {
          this.complete = this.complete && item_info.children[i].complete;
        }
        item_info.complete = this.complete;
        item_info.resourceState = {};
        item_info.resourceState.score_max = this.complete ? 1 : 0;
      }

      if (DEV_VARIABLES.RESOURCES.UNLOCK_THESE.indexOf(this.slug) > -1) {
        this.locked = false;
      }
      if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(this.slug) > -1 || !ModuleFilter.checkAvailable(item_info)) {
        this.locked = true;
      }

      var sprite, icon;
      var startClickPos = {
        x: 0,
        y: 0
      };

      this.setDelegate = function (del) {
        var boundClick = function (e) {
          del(this.slug);
        }.bind(this);
        sprite.on('pointertap', boundClick);
        //sprite.on('click', );
      };

      var getItemDisplayName = function getItemDisplayName() {
        var itemDisplayName;
        if (item_info.display && item_info.display.nameLangId) {
          itemDisplayName = language.get(item_info.display.nameLangId);
        } else {
          /*
          if(item_info.slug.indexOf('gr78_m4') > -1 || item_info.slug.indexOf('g78_m4') > -1){
            itemDisplayName = language.get(item_info.slug+'_short', null, true)
          }else{
            itemDisplayName = language.get(item_info.slug, null, true)
          }*/
          itemDisplayName = language.get(item_info.slug, null, true);
        }
        if ((!itemDisplayName || itemDisplayName === item_info.slug) && item_info.name) {
          itemDisplayName = item_info.name;
        }
        return itemDisplayName;
      };

      this.updateIcon = function () {
        if (this.type === 'symlink') {
          icon.texture = PIXI.loader.resources[GR78_ASSET_URL + "symlink.png"].texture;
        } else if (PIXI.loader.resources[GR78_ASSET_URL + getIconFilename(item_info)]) {
          icon.texture = PIXI.loader.resources[GR78_ASSET_URL + getIconFilename(item_info)].texture;
        }
      };
      this.buildTooltip = function () {
        if (tooltip !== null && tooltip !== undefined) {
          sprite.removeChild(tooltip);
          tooltip.interactive = false;
        }
        tooltip = new PIXI.Sprite();

        // Text Information
        var textInfo = new PIXI.Text(getItemDisplayName(), {
          fontFamily: 'Arial',
          align: 'center',
          fontSize: 24,
          fill: 0xFFFFFF,
          dropShadow: true,
          dropShadowDistance: 1,
          dropShadowBlur: 0,
          wordWrap: true,
          wordWrapWidth: 200
        });

        var tooltip_graphics = new PIXI.Graphics();

        var drawTooltipContainer = function drawTooltipContainer() {
          tooltip_graphics.clear();
          // Draw Text Bubble that wraps around the text
          tooltip_graphics.lineStyle(0);
          tooltip_graphics.beginFill(0x3B5763);
          tooltip_graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 20, 10);
          tooltip_graphics.endFill();

          // Draw Triangle pointing to planet
          tooltip_graphics.beginFill(0x3B5763);
          tooltip_graphics.moveTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
          tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2, textInfo.y - 18);
          tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2 + 5, textInfo.y - 10);
          tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
          tooltip_graphics.endFill();

          tooltip_graphics.x = -tooltip_graphics.width / 2 + 20;
          tooltip_graphics.y = icon.height / 2 + 10;
        };

        drawTooltipContainer();

        tooltip.addChild(tooltip_graphics);
        tooltip_graphics.addChild(textInfo);
        sprite.addChild(tooltip);
        tooltip.interactiveChildren = false;
        tooltip.visible = item_info.slug.indexOf('ocmt_hse') > -1 || item_info.config.assessment_type && item_info.config.assessment_type === 'summative' && !item_info.config.show_summative ? true : false;

        eventManager.listen('language:change', function () {
          if (textInfo === undefined) {
            return;
          }
          textInfo.setText(getItemDisplayName());
          drawTooltipContainer();
        });

        eventManager.listen('module:change:meta', function () {
          that.hideAgendaHighlight();
        });

        var updateItemInfoComplete = function updateItemInfoComplete(existsItem) {
          var exists_score_max = item_info.resourceState ? item_info.resourceState.score_max : null;
          item_info.complete = existsItem.completed;
          item_info.resourceState = { complete: existsItem.completed };
          item_info.resourceState.score_max = exists_score_max ? Math.max(exists_score_max, existsItem.score) : existsItem.score;
          item_info.score = item_info.resourceState.score_max;
        };

        eventManager.listen("teacherStudentWorkspace:studentFilter:change", function (e, eventData) {
          var filteredList = eventData.list || [];
          var doneItemsList = [];
          if (filteredList && filteredList.length > 0) {
            doneItemsList = _.filter(filteredList, function (item) {
              return item.resource_id === item_info.id;
            });
          }

          if (doneItemsList.length > 0) {
            var exists_info = { score: null, completed: false };
            _.each(doneItemsList, function (existsItem) {
              exists_info.completed = exists_info.completed || existsItem.completed;
              exists_info.score = exists_info.score ? Math.max(exists_info.score, existsItem.score) : existsItem.score;
            });
            updateItemInfoComplete(exists_info);
          } else {
            item_info.complete = false;
            item_info.resourceState = { complete: false, score_max: null };
            item_info.score = null;
          }
          if (item_info.resource_type === 'symlink' && PIXI.loader.resources[GR78_ASSET_URL + "symlink.png"]) {
            icon.texture = PIXI.loader.resources[GR78_ASSET_URL + "symlink.png"].texture;
          } else if (PIXI.loader.resources[GR78_ASSET_URL + getIconFilename(item_info)]) {
            icon.texture = PIXI.loader.resources[GR78_ASSET_URL + getIconFilename(item_info)].texture;
          }
        });
      };

      var unclickableTypes = ['symlink'];
      this.onButtonClick = function () {

        if (unclickableTypes.indexOf(this.type) > -1) {
          return;
        }

        //Cancel click events if they dragged more than 100 pixels
        var curPos = sprite.toGlobal(new PIXI.Point(0, 0));
        if (Math.pow(startClickPos.x - curPos.x, 2) + Math.pow(startClickPos.y - curPos.y, 2) > 100 * 100) {
          return;
        }

        $log.debug('[[mapItemFactory]] clicking on', item_info, 'LOCK STATUS:::::::::::::', this.locked);
        if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug) > -1) {
          if (!TeacherDataService.isTeacherModuleView) {
            this.locked = false;
          } else {
            this.locked = true;
          }
        }
        if (!ModuleFilter.checkAvailable(item_info)) {
          this.locked = true;
          item_info.locked = true;
          eventManager.broadcast('display-maintenance-message', item_info.slug);
        }

        // if (!this.locked) {
        $timeout(function () {
          sprite.scale.set(1 * scale, 1 * scale);
          // var item_evt_info = {
          //   slug : item_info.slug,
          //   id : item_info.id
          // };
          eventManager.broadcast('module:stop:pan');
          eventManager.broadcast('module:select:resource', item_info);
        }, TIMING_CONSTANTS.INSTANT);
        // }
      };

      this.unlock = function (from_agenda) {
        if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug) > -1 || !ModuleFilter.checkAvailable(item_info) || item_info.resource_type === 'assessment' && item_info.resourceState && item_info.resourceState.complete && !from_agenda) {
          return;
        }
        item_info.locked = false;
        this.locked = false;
        this.updateIcon();
      };

      this.lock = function () {
        if (this.unlockedByAgenda) {
          return;
        }
        item_info.locked = true;
        this.locked = true;
        this.updateIcon();
      };

      this.getItemInfo = function () {
        return item_info;
      };

      this.setItemComplete = function () {
        this.updateIcon();
        if (this.studentWork) {
          this.studentWork.completions++;
        } else {
          this.studentWork = {
            completions: 1
          };
        }
      };

      //For setting up verlet links to items inside a folder
      //items in minimized folders should verlet links to their parent
      this.getLinkedBody = function () {
        if (this.shouldBeOnMap()) {
          return this.verletBody;
        } else {
          return this.parentItem.getLinkedBody();
        }
      };

      //Map items inside mimized folder items get ignored
      this.shouldBeOnMap = function () {
        if (this.parentItem !== null) {
          return this.parentItem.isExpanded;
        } else {
          return this.isExpanded === true ? false : true;
        }
      };

      this.showHighlight = function () {
        if (this.type === 'symlink') {
          return;
        }
        if (tooltip && !alwaysHideTooltip) {
          tooltip.visible = true;
        }
        sprite.scale.set(1.1 * scale, 1.1 * scale);
        if (sprite.parent !== null) {
          sprite.parent.setChildIndex(sprite, sprite.parent.children.length - 1);
        }
      };

      this.undoAgendaHighlight = function () {};

      this.selection_graphic = null;
      this.highlight_graphic = null;
      var that = this;
      var is_item_selected;
      this.showAgendaHighlight = function (force, is_selection) {
        // $log.log('HIGHGLIGHT SELECTION : ' , this.type)
        if (this.highlight_graphic === null && is_selection) {
          // $log.log('show agenda highlight', this.slug, is_selection)
          var radius = this.type === 'assessment' ? 90 : 50;
          this.highlight_graphic = new PIXI.Graphics();
          this.highlight_graphic.lineStyle(33, 0x33CCFF, 1);
          this.highlight_graphic.drawCircle(0, 0, radius);
          this.highlight_graphic.interactive = false;
          this.highlight_graphic.scale.set(0.75 * scale, 0.75 * scale);
          this.highlight_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
          icon.addChildAt(this.highlight_graphic, 0);
        } else if (!is_selection && this.selection_graphic === null && force !== false) {
          // $log.log('show agenda selection', this.slug, is_selection)
          is_item_selected = is_selection;
          var scale_size = this.type === 'assessment' ? 2.5 : 0.75;
          this.selection_graphic = new PIXI.Sprite(PIXI.loader.resources[GR78_ASSET_URL + 'selection.png'].texture);
          this.selection_graphic.anchor.set(0.5, 0.5);
          this.selection_graphic.scale.set(scale_size * scale, scale_size * scale);
          this.selection_graphic.interactive = false;
          this.selection_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
          icon.addChild(this.selection_graphic);
        } else if (!force) {
          // $log.log('from toggle agenda selection', this.slug, is_selection)
          that.hideAgendaHighlight();
        }
      };
      this.hideAgendaHighlight = function (from_item_highlight) {
        // $log.log('hide agenda highlight', this.slug, from_item_highlight)
        if (from_item_highlight && this.highlight_graphic !== null) {
          icon.removeChild(this.highlight_graphic);
          this.highlight_graphic = null;
        }if (!from_item_highlight && this.selection_graphic !== null) {
          icon.removeChild(this.selection_graphic);
          this.selection_graphic = null;
        }
      };

      this.hideHighlight = function () {
        if (tooltip && !alwaysHideTooltip) {
          tooltip.visible = item_info.slug.indexOf('ocmt_hse') > -1 || item_info.config.assessment_type && item_info.config.assessment_type === 'summative' && !item_info.config.show_summative ? true : false;
        }
        sprite.scale.set(1 * scale, 1 * scale);
      };

      this.setScale = function (scaleToBeSet) {
        scale = scaleToBeSet;
        sprite.scale.set(scale, scale);
      };

      this.alwaysHideTooltip = function () {
        alwaysHideTooltip = true;
        tooltip.visible = false;
      };

      eventManager.listen('unlock-item', function (e, slug) {
        if (slug === item_info.slug) {
          that.unlock(true);
        }
      });

      this.pointerdown = function () {
        sprite.scale.set(0.9 * scale, 0.9 * scale);
        startClickPos = sprite.toGlobal(new PIXI.Point(0, 0));
      };
      /**
       * Tooltip setup
       */
      var tooltip;

      icon = new PIXI.Sprite();
      icon.anchor.set(0.5, 0.5);
      sprite = new PIXI.Sprite();
      this.sprite = sprite;

      var mouseOver = this.showHighlight.bind(this);
      sprite.on('mouseover', function () {
        mouseOver();
      });

      var mouseOut = this.hideHighlight.bind(this);
      sprite.on('pointerout', function () {
        mouseOut();
      });

      var pointerdown = this.pointerdown.bind(this);
      sprite.on('pointerdown', function () {
        pointerdown();
      });

      if (item_info.resource_type !== "group") {
        var boundClick = this.onButtonClick.bind(this);
        sprite.on('pointertap', boundClick);
      } else if (item_info.resource_type !== 'symlink') {
        this.open = false;
      }

      this.updateIcon();
      if (this.type === "group") {
        var bg = new PIXI.Sprite(icon.texture);
        bg.width += 20;
        bg.height += 20;

        bg.anchor.set(0.5, 0.5);
        sprite.addChild(bg);
      }
      sprite.addChild(icon);

      if (item_info.display.position !== undefined) {
        var divideBy = item_info.slug.indexOf("_g78_m0_") > -1 ? 1 : 5;
        var startPosx = item_info.slug.indexOf("_g78_m0_") > -1 ? 1300 : 0;
        var startPosY = item_info.slug.indexOf("_g78_m0_") > -1 ? 300 : 0;
        sprite.position.set(startPosx + item_info.display.position.x / divideBy, startPosY + item_info.display.position.y / divideBy);
      } else {
        sprite.position.set(0, 0);
      }
      sprite.interactive = true; //!item_info.locked;
      sprite.buttonMode = true;
      this.buildTooltip();
      //for testing...
      //this.unlock();
    }
  };
});
'use strict';

angular.module('mtic.components.modules.c4', []).constant('C4_ASSET_URL', 'assets/images/c4-meta/');
'use strict';

angular.module('mtic.components.modules.c3').service('mapItemFactory', function (C3_ASSET_URL, EventManager, $log, $timeout, TIMING_CONSTANTS, language, TeacherDataService, ModuleFilter) {
  var currentActiveItem = null;
  var getIconFilename = function getIconFilename(item_info) {

    //assessments are easy
    if (item_info.resource_type === 'assessment') {
      if (item_info.complete) {
        return 'assessment_complete.png';
      }
      return 'assessment.png';
    }
    if (!item_info.display) {
      item_info.display = {};
    }

    //get the color from item_info.display.color, fall back to "red" if it isn't defined
    var color_string = item_info.display.color !== undefined ? item_info.display.color : 'blue';

    var suffix;
    if (item_info.locked) {
      suffix = "_locked";
    } else {
      if (!item_info.resourceState || !item_info.resourceState.complete) {
        suffix = "_0";
      } else {

        var count = 0;

        if (item_info.resourceState.score_max >= 1) {
          count = 3;
        } else if (item_info.resourceState.score_max >= 0.8) {
          count = 2;
        } else if (item_info.resourceState.score_max >= 0.5) {
          count = 1;
        }
        if (color_string === 'blue') {
          count = 1; //Math.min(count, 1);
        }
        count = Math.max(0, count);
        suffix = "_" + count;
      }
    }
    var filename = "item_" + color_string + suffix + ".png";
    return filename;
  };
  return {
    getCurrentActiveItem: function getCurrentActiveItem() {
      return currentActiveItem;
    },
    createMapItem: function MapItem(item_info, onItemClick, eventManager) {

      // Grab Relevant data for item
      this.slug = item_info.slug;
      this.id = item_info.id;
      this.type = item_info.resource_type;
      this.studentWork = item_info.studentWork;
      this.container = item_info.content.container;
      this.complete = item_info.complete;
      this.locked = item_info.locked;
      this.unlocked_by = item_info.unlocked_by;
      this.content = item_info.content;
      this.verletBody = null;
      this.parentItem = null;
      var sprite,
          icon,
          agenda_highlight = null;
      var startClickPos = {
        x: 0,
        y: 0
      };

      this.setDelegate = function (del) {
        var boundClick = function (e) {
          del(this.slug);
        }.bind(this);
        sprite.on('pointertap', boundClick);
        //sprite.on('click', );
      };

      this.selection_graphic = null;
      this.highlight_graphic = null;
      var is_item_selected;
      this.showAgendaHighlight = function (force, is_selection) {
        var radius = this.type === 'assessment' ? 70 : 32;
        if (this.highlight_graphic === null && is_selection) {
          // $log.log('show agenda highlight', this.slug, is_selection)
          this.highlight_graphic = new PIXI.Graphics();
          this.highlight_graphic.lineStyle(14, 0x33CCFF, 1);
          this.highlight_graphic.drawCircle(0, 0, radius);
          this.highlight_graphic.interactive = false;
          //this.highlight_graphic.scale.set(0.75*scale,0.75*scale);
          this.highlight_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
          icon.addChildAt(this.highlight_graphic, 0);
        } else if (!is_selection && this.selection_graphic === null && force !== false) {
          // $log.log('show agenda selection', this.slug, is_selection)
          is_item_selected = is_selection;
          this.selection_graphic = new PIXI.Graphics();
          this.selection_graphic.lineStyle(8, 0xFFCC00, 1);
          this.selection_graphic.drawCircle(0, 0, radius);
          this.selection_graphic.interactive = false;
          //this.selection_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);
          icon.addChild(this.selection_graphic);
        } else if (!force) {
          // $log.log('from toggle agenda selection', this.slug, is_selection)
          this.hideAgendaHighlight();
        }

        // if (agenda_highlight === null)
        // {
        //   agenda_highlight = new PIXI.Graphics();
        //   agenda_highlight.lineStyle(12, 0x33CCFF);
        //   agenda_highlight.drawCircle(0,0, 32);
        //   icon.addChild(agenda_highlight);
        // }else if(!force){
        //   this.hideAgendaHighlight();
        // }
      };

      this.hideAgendaHighlight = function (from_item_highlight) {
        // $log.log('hide agenda highlight', this.slug, from_item_highlight)
        if (from_item_highlight && this.highlight_graphic !== null) {
          icon.removeChild(this.highlight_graphic);
          this.highlight_graphic = null;
        }if (!from_item_highlight && this.selection_graphic !== null) {
          icon.removeChild(this.selection_graphic);
          this.selection_graphic = null;
        }
      };

      var getItemDisplayName = function getItemDisplayName() {
        var itemDisplayName;
        if (item_info.display && item_info.display.nameLangId) {
          itemDisplayName = language.get(item_info.display.nameLangId);
        } else {
          itemDisplayName = language.get(item_info.slug, null, true);
        }
        if (!itemDisplayName) {
          itemDisplayName = item_info.name;
        }
        return itemDisplayName;
      };

      this.updateIcon = function () {
        // console.log(C3_ASSET_URL + getIconFilename(item_info));
        icon.texture = PIXI.loader.resources[C3_ASSET_URL + getIconFilename(item_info)].texture;
        if (item_info.resource_type === 'assessment') {
          icon.width = icon.height = 206;
        } else {
          icon.width = icon.height = 104;
        }
      };
      this.buildTooltip = function () {
        if (tooltip !== null && tooltip !== undefined) {
          sprite.removeChild(tooltip);
          tooltip.interactive = false;
        }
        tooltip = new PIXI.Sprite();

        // Text Information
        var textInfo = new PIXI.Text(getItemDisplayName(), {
          fontFamily: 'Arial',
          align: 'center',
          fontSize: 24,
          fill: 0xFFFFFF,
          dropShadow: true,
          dropShadowDistance: 1,
          dropShadowBlur: 0,
          wordWrap: true,
          wordWrapWidth: 200
        });

        var tooltip_graphics = new PIXI.Graphics();

        var drawTooltipContainer = function drawTooltipContainer() {
          tooltip_graphics.clear();
          // Draw Text Bubble that wraps around the text
          tooltip_graphics.lineStyle(0);
          tooltip_graphics.beginFill(0x3B5763);
          tooltip_graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 20, 10);
          tooltip_graphics.endFill();

          // Draw Triangle pointing to planet
          tooltip_graphics.beginFill(0x3B5763);
          tooltip_graphics.moveTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
          tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2, textInfo.y - 18);
          tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2 + 5, textInfo.y - 10);
          tooltip_graphics.lineTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
          tooltip_graphics.endFill();
          tooltip_graphics.x = -tooltip_graphics.width / 2 + 20;
          tooltip_graphics.y = icon.height / 2 + 10;
        };

        drawTooltipContainer();

        tooltip.addChild(tooltip_graphics);
        tooltip_graphics.addChild(textInfo);
        sprite.addChild(tooltip);
        tooltip.interactiveChildren = false;
        tooltip.visible = false;

        eventManager.listen('language:change', function () {
          if (textInfo === undefined) {
            return;
          }
          textInfo.setText(getItemDisplayName());
          drawTooltipContainer();
        });
      };

      var unclickableTypes = ['symlink'];
      this.onButtonClick = function () {
        if (unclickableTypes.indexOf(this.type) > -1) {
          return;
        }

        //Cancel click events if they dragged more than 100 pixels
        var curPos = sprite.toGlobal(new PIXI.Point(0, 0));
        if (Math.pow(startClickPos.x - curPos.x, 2) + Math.pow(startClickPos.y - curPos.y, 2) > 100 * 100) {
          return;
        }

        $log.debug('[[mapItemFactory]] clicking on', item_info, 'LOCK STATUS:::::::::::::', this.locked);
        if (['mtic_g78_m1_diag', 'mtic_g78_m2_diag'].indexOf(item_info.slug) > -1) {
          this.locked = true;
        }
        if (!ModuleFilter.checkAvailable(item_info)) {
          this.locked = true;
          item_info.locked = true;
          eventManager.broadcast('display-maintenance-message', item_info.slug);
          return;
        }
        //console.log('TeacherDataService.isTeacherModuleView', TeacherDataService.isTeacherModuleView);
        if (!this.locked || TeacherDataService.isTeacherModuleView) {
          var currentItem = this;
          $timeout(function () {
            eventManager.broadcast('module:select:resource', item_info);
            if (onItemClick) {
              //onItemClick(item_info,currentItem);
              //console.log(item_info);
            } else {
              sprite.scale.set(1, 1);
              currentActiveItem = this;
              eventManager.broadcast('module:open:resource', item_info);
            }
          }, TIMING_CONSTANTS.INSTANT);
        }
      };

      this.unlock = function () {
        this.locked = false;
        item_info.locked = false;
        this.updateIcon();
      };

      this.getItemInfo = function () {
        return item_info;
      };

      this.setItemComplete = function () {
        if (this.studentWork) {
          this.studentWork.completions++;
        } else {
          this.studentWork = {
            completions: 1
          };
        }
      };

      //For setting up verlet links to items inside a folder
      //items in minimized folders should verlet links to their parent
      this.getLinkedBody = function () {
        if (this.shouldBeOnMap()) {
          return this.verletBody;
        } else {
          return this.parentItem.getLinkedBody();
        }
      };

      //Map items inside mimized folder items get ignored
      this.shouldBeOnMap = function () {
        if (this.parentItem !== null) {
          return this.parentItem.isExpanded;
        } else {
          return this.isExpanded === true ? false : true;
        }
      };

      this.showHighlight = function () {
        if (this.type === 'symlink') {
          return;
        }
        if (tooltip) {
          tooltip.visible = true;
        }
        sprite.scale.set(1.1, 1.1);
        if (sprite.parent !== null) {
          sprite.parent.setChildIndex(sprite, sprite.parent.children.length - 1);
        }
      };

      this.hideHighlight = function () {
        if (tooltip) {
          tooltip.visible = false;
        }
        sprite.scale.set(1, 1);
      };

      this.pointerdown = function () {
        sprite.scale.set(0.9, 0.9);
        startClickPos = sprite.toGlobal(new PIXI.Point(0, 0));
      };
      /**
       * Tooltip setup
       */
      var tooltip;

      icon = new PIXI.Sprite();
      icon.anchor.set(0.5, 0.5);
      sprite = new PIXI.Sprite();
      this.sprite = sprite;

      var mouseOver = this.showHighlight.bind(this);
      sprite.on('mouseover', function () {
        mouseOver();
      });

      var mouseOut = this.hideHighlight.bind(this);
      sprite.on('pointerout', function () {
        mouseOut();
      });

      var pointerdown = this.pointerdown.bind(this);
      sprite.on('pointerdown', function () {
        pointerdown();
      });

      if (item_info.resource_type !== "group") {
        var boundClick = this.onButtonClick.bind(this);
        sprite.on('pointertap', boundClick);
      } else if (item_info.resource_type !== 'symlink') {
        this.open = false;
      }

      this.updateIcon();
      if (this.type === "group") {
        var bg = new PIXI.Sprite(icon.texture);
        bg.width += 20;
        bg.height += 20;

        bg.anchor.set(0.5, 0.5);
        sprite.addChild(bg);
      }
      sprite.addChild(icon);

      if (item_info.display.position !== undefined) {
        sprite.position.set(item_info.display.position.x * 2 + 120 - icon.texture.width * 1.405 / 2, item_info.display.position.y * 2 + 120 - icon.texture.height * 1.405 / 2);
      } else {
        sprite.position.set(0, 0);
      }
      sprite.interactive = true;
      sprite.buttonMode = true;
      this.buildTooltip();

      var updateItemInfoComplete = function updateItemInfoComplete(existsItem) {
        var exists_score_max = item_info.resourceState ? item_info.resourceState.score_max : null;
        item_info.complete = existsItem.completed;
        item_info.resourceState = { complete: existsItem.completed };
        item_info.resourceState.score_max = exists_score_max ? Math.max(exists_score_max, existsItem.score) : existsItem.score;
        item_info.score = item_info.resourceState.score_max;
      };

      eventManager.listen("teacherStudentWorkspace:studentFilter:change", function (e, eventData) {
        var filteredList = eventData.list || [];
        var doneItemsList = [];
        if (filteredList && filteredList.length > 0) {
          doneItemsList = _.filter(filteredList, function (item) {
            return item.resource_id === item_info.id;
          });
        }

        if (doneItemsList.length > 0) {
          var exists_info = { score: null, completed: false };
          _.each(doneItemsList, function (existsItem) {
            exists_info.completed = exists_info.completed || existsItem.completed;
            exists_info.score = exists_info.score ? Math.max(exists_info.score, existsItem.score) : existsItem.score;
          });
          updateItemInfoComplete(exists_info);
        } else {
          item_info.complete = false;
          item_info.resourceState = { complete: false, score_max: null };
          item_info.score = null;
        }
        if (item_info.resource_type === 'symlink') {
          icon.texture = PIXI.loader.resources[C3_ASSET_URL + "symlink.png"].texture;
        } else if (PIXI.loader.resources[C3_ASSET_URL + getIconFilename(item_info)]) {
          icon.texture = PIXI.loader.resources[C3_ASSET_URL + getIconFilename(item_info)].texture;
        }
      });
    }
  };
});
'use strict';

angular.module('mtic.components.modules.c3').directive('c3ModuleSelect', function ($log, $timeout, TIMING_CONSTANTS, EventManager, C3_META_ASSET_URL, PIXI, language, MODULE_AVAILABLE_LANGUAGE, MapStateService, userAccount, preliveCheck, DEV_VARIABLES, TeacherDataService, LocaleService, PanelStateService, PlatformService, ModuleFilter) {

  return {
    template:'<div ng-hide="loading_done" style="position:absolute;top:0px;left:0px;width:100%;height:100%;background-color:#555;z-index:1000"><div class="loader"></div></div><div class="agendaSplitView"><div class="agendaSplitViewSidebar" ng-if="!isTeacherWorkspaceView && !(currentActiveSubModule.slug === \'run_like_math\')"><div class="agendaSplitViewSidebar__scrollableWrap"><nav class="nav is-small" style="margin-bottom: 24px;"><div class="nav-center"><a class="nav-item is-tab studentAgendaPanel__tab" ng-if="!isTeacher" ng-class="{\'is-active studentAgendaPanel__tab--active\':isShowingAgendaPanel()}" ng-click="selectAgendaPanel()" ng-init="selectAgendaPanel()"><span class="icon studentAgendaPanel__navTabIcon"><img src="assets/images/agenda/icon-blue-agenda.png"></span> <span class="studentAgendaPanel__navTabText">Agenda</span></a> <a class="nav-item is-tab studentAgendaPanel__tab" ng-class="{\'is-active studentAgendaPanel__tab--active\':isShowingModulePanel()}" ng-click="selectModulePanel()"><span class="icon studentAgendaPanel__navTabIcon"><img src="assets/images/agenda/icon-module-blue.png"></span> <span class="studentAgendaPanel__navTabText" ng-bind="getTranslation(\'14569\')">Module</span></a></div></nav><div style="padding:12px;"><lmap-sidepanel-agenda ng-show="isShowingAgendaPanel() && !isTeacher" module-map-data="moduleMapData"></lmap-sidepanel-agenda><div ng-show="isShowingModulePanel() || isTeacher"><form autocomplete="off"><input class="agendaSearchField" placeholder="{{getLang(\'22608\')}}" ng-model="itemSearchInput" ng-change="itemSearchChange(itemSearchInput)"></form><teacher-students-agenda-perf-preview module-map="moduleMapData" filtered-view="itemSearchInput" view-controller="view_controller" class-id="currentClassId" unlock-path="new_agenda.unlock_path"></teacher-students-agenda-perf-preview></div></div></div></div><div class="agendaSplitView__main"><div style="display:flex;overflow:hidden"><div ng-hide="currentActiveSubModule !== null || badBrowser" class="inner-viewport" style="overflow:hidden;"><canvas id="c3-map-canvas" width="300" height="300"></canvas></div>{{currentActiveSubModule.slug}}<ng-switch class="inner-viewport" on="currentActiveSubModule.slug" ng-if="!currentResource && currentActiveSubModule!=null && !badBrowser" style="overflow:hidden;"><c3-module-1 ng-switch-when="mtic_c3_m1" module-map-data="currentActiveSubModule" submod-id="\'m1\'" agendas-list="agendas_list"></c3-module-1><c3-module-1 ng-switch-when="mtic_c3_m1v2" module-map-data="currentActiveSubModule" submod-id="\'m1v2\'" agendas-list="agendas_list"></c3-module-1><c3-module-1 ng-switch-when="mtic_c3_m3" module-map-data="currentActiveSubModule" submod-id="\'m34\'" agendas-list="agendas_list"></c3-module-1><c3-module-1 ng-switch-when="mtic_c3_m56" module-map-data="currentActiveSubModule" submod-id="\'m56\'" agendas-list="agendas_list"></c3-module-1><c3-run-like-math-module-select ng-if="isTeacherWorkspaceView" ng-switch-when="run_like_math" module-map-data="currentActiveSubModule"></c3-run-like-math-module-select><module-iframe ng-if="!isTeacherWorkspaceView" ng-switch-when="run_like_math" module-id="moduleMapData.module_id" module-map-data="currentActiveSubModule"></module-iframe></ng-switch><span ng-click="returnToMetaModules()" ng-style="{ top: !isTeacherWorkspaceView ? \'10px\' : \'70px\' }" ng-show="currentActiveSubModule && currentActiveSubModule.slug" style="z-index:1;position:absolute;cursor: pointer; background-color:#FF6666; padding:12px; border-radius: 0px 10px 10px 0px; height:66px; width: 62px; color:#fff; font-size:42px"><i class="fa fa-arrow-left"></i></span><div style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; display: flex; align-items: center; justify-content: center; padding-bottom:180px;background-color: #e9f0f3" ng-show="badBrowser"><div style="width:480px; max-width: 80%; font-size: 20px; text-align:center;"><div style="margin-bottom:18px;"><img src="assets/images/logos/login_mathemaTIC_logo.png"></div><div>This module is not yet available in the <b>MathemaTIC app</b> for Android and iOS.<div style="margin-top:18px; line-height:100%;"><small>Please revisit this module in a the browser or on a desktop.</small></div><button style="margin-top:30px" class="button is-small is-danger" ng-click="goBackToClasses()">My Classes</button></div></div></div></div></div></div><div style="display:flex; position:fixed; right: 8px; top: 45px;" ng-if="!(!currentResource && currentActiveSubModule!=null && !badBrowser)" class="module-zoom-buttons"><button ng-click="zoom_function(1)" class="button" style="margin-right:3px;font-size:24px"><i class="fa fa-search-minus" aria-hidden="true"></i></button> <button ng-click="zoom_function(-1)" class="button" style="font-size:24px"><i class="fa fa-search-plus" aria-hidden="true"></i></button></div><div ng-if="currentActiveSubModule.slug === \'mtic_c3_m1\'" class="fr-only-dialogue" ng-class="{\'fr-only-dialogue--hidden\': modal3Hidden || item_maintenance}" style="z-index: 2;"><div class="fr-only-dialogue__closeButton" ng-click="hideModal(\'c3\')">&#10006;</div><p class="fr-only-dialogue__paragraph" style="display: flex;align-items:center"><img style="width:100px;height:100px;margin-right:20px" src="assets/images/logos/maintenance.png"> <span style="text-align:left" ng-bind="getTranslation(\'c3_maintenance_body\')">For the next few days, please excuse some disabled features and minor display issues. These will be corrected shortly.</span></p></div>', //<canvas id="canvas" width="300" height="300"></canvas>',
    scope: {
      moduleMapData: "=moduleMapData",
      interceptClick: "=?",
      workspaceData: "=?"
    },
    link: function link(scope) {
      scope.badBrowser = false;
      scope.isTeacher = userAccount.getData().role.isTeacher;
      scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
      scope.getTranslation = function (slug) {
        return language.get(slug);
      };
      /*
      if(window.isWebEmbedConnect && !scope.interceptClick && !navigator.userAgent.match(/Android/i)){
        //kickout to browser
        var userData = userAccount.getData();
        var cur_class = userAccount.getData().role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom();
        window.location.href = 'https://mathematic.lu/app2/'+'?web-open-browser&firebase_token='+userData.firebase_token+'&uuid='+userData.uuid+'&session_key='+userData.sessionKey+'&user_id='+userData.user_id+'&class_id='+cur_class;//window.location.href.replace('/?debugBrowsers#/web-embed-connect', '').replace('web-embed-connect', '').replace('web-embed-response', '').replace('&iam-logout', '')
      }
      */
      // else if(window.isWebEmbedConnect && !scope.interceptClick){
      //   scope.badBrowser = true;
      // }
      // $timeout(() => {
      var eventManager = new EventManager('c3ModuleSelect', scope);
      var planetContainer;
      var canvas_el;
      var scale = 1;
      var canvasDimension;var sBackground;var sBlackScreen;var sShip;var sStars;var container;var Planets;var app;scope.currentActiveSubModule = null;
      var androidAdjustmentX = 0;
      var androidAdjustmentY = 0;
      var update_text;var update_direction = 0.002;

      scope.goBackToClasses = function () {
        eventManager.broadcast("navbar:my-classes:click");
        eventManager.broadcast('module:close:resource');
      };
      scope.hasModuleOption = function () {
        return true && scope.currentActiveSubModule && scope.currentActiveSubModule.children;
      };
      var onResize = function onResize(sidepanel_expanded) {
        if (!canvas_el) {
          return;
        }
        var sidepanel_width = TeacherDataService.sidepanelStatus ? 260 : 60;
        var canv_width;
        if (!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView) {
          if (sidepanel_expanded === true || sidepanel_expanded === false) {
            sidepanel_width = sidepanel_expanded ? 140 : -200;
          } else {
            sidepanel_width = 0;
          }
          canv_width = canvas_el.parentElement.offsetWidth - sidepanel_width;
        } else {
          var middleview = document.getElementById('agenda_middleview');
          if (middleview) {
            sidepanel_width += 300;
          }
          if (!TeacherDataService.inTeacherAgendaView) {
            sidepanel_width += -30;
          }
          canv_width = window.innerWidth - 370 - sidepanel_width;
        }
        canvasDimension = {
          width: canv_width,
          height: window.innerHeight - 35
        };

        canvas_el.width = canvasDimension.width;
        canvas_el.height = canvasDimension.height;
        sBackground.width = canvasDimension.width;
        sBackground.height = canvasDimension.height;

        var min_w = 1200;
        var min_h = 600;

        scale = Math.min(canvasDimension.width / min_w, canvasDimension.height / min_h);

        planetContainer.scale.set(Math.min(scale, 1));

        var offset = TeacherDataService.inTeacherAgendaView || TeacherDataService.isTeacherWorkspaceView ? -20 : 50; //scope.isTeacher ? 250 : 75
        planetContainer.x = canvasDimension.width / 2 - planetContainer.width / 2 - offset;

        // if(TeacherDataService.isTeacherWorkspaceView){
        //   if(window.screen.width < 1200){
        //     planetContainer.x += 75;
        //     planetContainer.scale.set(Math.min(0.5, scale, 1))
        //   }else{
        //     planetContainer.scale.set(Math.min(0.8, scale, 1))
        //   }
        // }
        planetContainer.y = canvasDimension.height / 2 - planetContainer.height / 2;

        sShip.y = canvasDimension.height - 150;

        sStars.width = canvasDimension.width;
        sStars.height = canvasDimension.height;
        app.resize(canvasDimension.width, canvasDimension.height);
      };

      // Initialize everything
      //Initialize();

      var isMobile = navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent);
      scope.$watch('moduleMapData', function (moduleMapData) {
        if (!moduleMapData || EXISTS) {
          return;
        }
        $timeout(function () {
          Initialize();
          setSubmodule(MapStateService.getActiveModule());
          //var expanded = TeacherDataService.inTeacherAgendaView || isMobile ? false : null;
          EXISTS = true;
        });
        var timer = isMobile ? 1200 : 500;
        $timeout(function () {
          //var expanded = isMobile && scope.isTeacher ? false : null;
          onResize();
          scope.loading_done = true;
        }, timer);
      });

      eventManager.listen('module:change:submodule', function (e, slug) {
        // $log.log('module:change:submodule : ' , slug)
        if (MODULE_AVAILABLE_LANGUAGE[slug]) {
          language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[slug]);
        }
        var resources = scope.moduleMapData.resources;
        for (var i = 0; i < resources.length; i++) {
          var resource = resources[i];
          if (slug === resource.slug) {
            language.setAvailableOptions(_.get(resource, ['content', 'available_languages', LocaleService.getUrlVersion()]));
            break;
          }
        }
      });
      eventManager.listen('module:change:meta', function (e, slug) {
        language.resetAvilableOptions();
        if (MODULE_AVAILABLE_LANGUAGE[slug]) {
          language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[slug]);
        }
        if (MapStateService.getActiveModule() === 'run_like_math') {
          MapStateService.setActiveModule(scope.moduleMapData.slug);
          eventManager.broadcast('module:close:resource', { isPassive: true });
        }
        //scope.currentActiveSubModule = null;
        $timeout(function () {
          onResize();
        }, 100);
      });

      var assignMatchedSlug = function assignMatchedSlug(matchedSlug, resource) {
        $timeout(function () {
          scope.interceptClick.slug = matchedSlug;
          if (matchedSlug === "run_like_math") {
            eventManager.broadcast("module:change:run_like_math", resource);
          }
        }, 100);
      };

      var lastSlug;
      var setSubmodule = function setSubmodule(slug) {
        if (slug === 'run_like_math' && TeacherDataService.inTeacherAgendaView) {
          return;
        }
        var i;
        if (scope.interceptClick) {
          if (scope.interceptClick.slug !== slug) {
            for (i = 0; i < scope.moduleMapData.resources.length; i++) {
              if (slug === scope.moduleMapData.resources[i].slug) {
                var matchedSlug = scope.moduleMapData.resources[i].slug;
                assignMatchedSlug(matchedSlug, scope.moduleMapData.resources[i]);
                //scope.$apply();
              }
            }
          } else {
            eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
          }

          if (TeacherDataService.inTeacherAgendaView && !scope.interceptClick.slug && slug) {
            $timeout(function () {
              //eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
            }, 200);
          }

          // $log.log('interceptClick : ' , scope.interceptClick.slug, slug)
          return;
        }
        if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(slug) > -1) {
          if (!preliveCheck.isPreliveCheck() && !preliveCheck.isQCCheck()) {
            if (lastSlug !== slug) {
              window.alert(language.get('module_is_locked'));
              return;
            }
          }
        }
        for (i = 0; i < scope.moduleMapData.resources.length; i++) {
          if (slug === scope.moduleMapData.resources[i].slug) {
            scope.currentActiveSubModule = scope.moduleMapData.resources[i];
            scope.currentActiveSubModule.resources = scope.currentActiveSubModule.children;
            eventManager.broadcast('module:change:submodule', scope.currentActiveSubModule.slug);
            eventManager.broadcast('submodule:opened', {
              slug: scope.currentActiveSubModule.slug, //module_container.slug,
              name: scope.currentActiveSubModule.name
            });
            MapStateService.setActiveModule(slug);
            break;
          }
        }
        lastSlug = slug;
      };

      var drag_info = {};
      var _TOUCHED_POINTS = [];
      var Initialize = function Initialize() {
        PIXI.ticker.shared.add(delta_resize);
        // PIXI.ticker.shared.add(update);
        canvas_el = document.getElementById('c3-map-canvas');
        canvasDimension = {
          width: 500,
          height: 500
        };
        $timeout(function () {
          if (canvas_el) {
            canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
            canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else
          }
        }, 1000);

        MapStateService.setMetaStateSlug('mtic_c3_m_meta');
        // Load Assets
        sBackground = new PIXI.Sprite(PIXI.Texture.fromImage(C3_META_ASSET_URL + 'bkg.png'));
        sBlackScreen = new PIXI.Sprite(PIXI.Texture.fromImage(C3_META_ASSET_URL + 'blackscreen.png'));
        sShip = new PIXI.Sprite(PIXI.Texture.fromImage(C3_META_ASSET_URL + 'spaceship.png'));
        sStars = new PIXI.extras.TilingSprite(PIXI.Texture.fromImage(C3_META_ASSET_URL + 'star_pattern.png'));

        container = new PIXI.Container();
        planetContainer = new PIXI.Container();
        Planets = [];

        var PlanetSprites = new Array(new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_spces.png'), new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_measuremtent.png'), new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_numbers.png'), new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_problem.png'), new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_problem.png'), new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_operations.png'));

        // Create the application and container
        var isAndroid = navigator.userAgent.match(/Android/i);
        if (isAndroid) {
          app = new PIXI.CanvasRenderer(1200, 600, {
            autoResize: true,
            backgroundColor: 0x000000,
            view: canvas_el
          });
        } else {
          app = PIXI.autoDetectRenderer(256, 256, {
            autoResize: true,
            backgroundColor: 0x000000,
            view: canvas_el
          });
        }

        // Add background
        container.addChild(sBackground);
        container.addChild(sStars);

        // Add Space Ship
        sShip.x = -50;
        sShip.y = 450;
        container.addChild(sShip);

        // Define the Planet Array

        var startX = 0,
            startY = 0;
        if (TeacherDataService.isTeacherWorkspaceView) {
          startX = -200;
          startY = 5;
        }

        if (isAndroid) {
          androidAdjustmentX = 50;
          androidAdjustmentY = 50;
        }

        Planets = new Array(new Planet(PlanetSprites[0], startX + 220 + androidAdjustmentX, startY + 100 + androidAdjustmentY, -3, 0, "mtic_c3_m56"),
        // new Planet(PlanetSprites[1], 680, 100, 15, -20, 5.0, 10.0, 0xFFCC00,  "Planet\nZone"),
        new Planet(PlanetSprites[2], startX + 450 + androidAdjustmentX, startY + 300 - androidAdjustmentY, 12, 0, "mtic_c3_m3"), new Planet(PlanetSprites[3], startX + 1000, startY + 300 - androidAdjustmentY, 0, 0, "mtic_c3_m1"), new Planet(PlanetSprites[4], startX + 1000, startY + 300 - androidAdjustmentY, 0, 0, "mtic_c3_m1v2"), new Planet(PlanetSprites[5], startX + 720 + androidAdjustmentX / 2, startY + 400 - androidAdjustmentY - androidAdjustmentY, 0, 0, "run_like_math"));

        container.addChild(planetContainer);
        container.on('pointerdown', function (e) {
          var e_o = e.data.originalEvent;
          _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x: e_o.pageX, y: e_o.pageY });
          drag_info.dragging = true;
          //focus_item = null;

          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: planetContainer.x,
            y: planetContainer.y
          };
          // drag_info.start_drag_pos_meta = {
          //   x: meta_container.x,
          //   y: meta_container.y
          // };
          drag_info.start_drag_mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };
        });
        container.on('pointerup', function (e) {
          if (window.DEBUG_TOUCH) {
            $log.log('c3_module pointerup ; ', JSON.stringify(e));
          }
          drag_info.dragging = false;
          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });
        container.on('pointerout', function (e) {
          drag_info.dragging = false;
          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function (point, index) {
            if (point.pointer_id === e.pointerId) {
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });
        container.interactive = true;
        // container.scale.set(0.5,0.5);

        if (window.DEBUG_TOUCH) {
          $log.log('c3_module pointerdown ; ', JSON.stringify(drag_info));
        }
      };

      //onResize();
      // Update Function
      function update() {
        if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
          var mouse_pos = {
            x: app.plugins.interaction.eventData.data.global.x,
            y: app.plugins.interaction.eventData.data.global.y

            // $log.log('DRAGGING :  ', mouse_pos.x, mouse_pos.y)
          };if (isNaN(mouse_pos.x) || isNaN(mouse_pos.y) || isMobile && app.plugins.interaction.eventData.data.identifier === 'MOUSE') {
            mouse_pos.x = drag_info.last_mouse_pos.x;
            mouse_pos.y = drag_info.last_mouse_pos.y;
          }

          // if(!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0){
          //   meta_container.position.x = drag_info.start_drag_pos_meta.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
          //   meta_container.position.y = drag_info.start_drag_pos_meta.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);
          // }else{
          //   //Move the map based on the mouse position
          planetContainer.x = drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
          planetContainer.y = drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);
          // }

          //vector of mouse movement since last update frame
          var delta_pos = {
            x: drag_info.last_mouse_pos.x - mouse_pos.x,
            y: drag_info.last_mouse_pos.y - mouse_pos.y
          };

          //add the mouse movement vector to the map movement velocity (inertia)
          drag_info.velocity = {
            x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
            y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
          };

          //store the current position in the last_mouse_pos to calculate the movement vector next frame
          drag_info.last_mouse_pos = {
            x: mouse_pos.x,
            y: mouse_pos.y
          };

          if (window.DEBUG_TOUCH) {
            $log.log('c3_module update ; ', JSON.stringify(drag_info));
          }
        }
      }

      function delta_resize(delta) {
        // Update things here

        if (canvasDimension.width !== window.innerWidth || canvasDimension.height !== window.innerHeight - 52) {
          //onResize();
        }
        if (update_text) {
          update_direction = update_text.scale.x >= 1.1 || update_text.scale.x < 1 ? update_direction * -1 : update_direction;
          update_text.scale.x += update_direction;
          update_text.scale.y += update_direction;
          update_text.alpha = 1 - 2.5 * (1.1 - update_text.scale.x);

          update_text.x += update_direction * -1;
        }

        app.render(container);
      }

      eventManager.listen('module:change:meta', function (data) {
        scope.currentActiveSubModule = null;
      });

      var computeModuleScoreRecursive = function computeModuleScoreRecursive(resource) {
        var scoreInfo = {
          score: 0,
          scoreMax: 0
        };
        for (var n = 0; n < resource.children.length; n++) {
          var subResource = resource.children[n];
          if (subResource.children && subResource.score === undefined) {
            var subScoreInfo = computeModuleScoreRecursive(subResource);
            // $log.log('[[planet slug]] UPDATE subScoreInfo', subScoreInfo, subResource.score / subResource.scoreMax)
            if (subScoreInfo.scoreMax > 0) {
              scoreInfo.scoreMax++;
              scoreInfo.score += subScoreInfo.score / subScoreInfo.scoreMax;
            }
          } else {
            scoreInfo.scoreMax++;
            if (workspace_data) {
              scoreInfo.score += workspace_list[subResource.id] ? 1 : 0;
            } else {
              scoreInfo.score += subResource.complete ? 1 : 0;
            }
          }
        }
        // $log.log('[[planet slug]] COMPLETE', scoreInfo);
        return scoreInfo;
      };

      // Define Planet Object
      var Planet = function Planet(sprite, xPos, yPos, xTxtOffset, yTxtOffset, slug) {
        var _this = this;

        this.score = 0;
        this.scoreMax = 0;

        // $log.log('[[planet slug]] PRE', slug);
        var module_resource;
        for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
          if (slug === scope.moduleMapData.resources[i].slug) {
            module_resource = scope.moduleMapData.resources[i];
            var scoreInfo = computeModuleScoreRecursive(scope.moduleMapData.resources[i]);
            this.score = scoreInfo.score;
            this.scoreMax = scoreInfo.scoreMax;
          }
        }

        if (!module_resource || module_resource && !ModuleFilter.checkAvailable(module_resource)) {
          return;
        }

        this.scoreCompletion = this.score / this.scoreMax;
        this.xPos = xPos;
        this.yPos = yPos;

        // $log.log('[[planet slug]] POST', slug, this.scoreCompletion);
        var graphics = new PIXI.Graphics();

        // Sprite
        this.sprite = sprite;
        this.sprite.x = this.xPos;
        this.sprite.y = this.yPos;
        this.sprite.interactive = true;
        this.sprite.buttonMode = true;
        sprite.anchor.set(0.5, 1);

        this.sprite.slug = slug;
        this.sprite.on('pointertap', function (e) {
          var cur_slug = e.currentTarget.slug;
          if (e.data.originalEvent.target && e.data.originalEvent.target.id !== 'c3-map-canvas') {
            return;
          }
          if ((cur_slug === 'mtic_c3_m1' || cur_slug === 'mtic_c3_m3') && (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1)) {
            window.alert('Some of the video items are currently not supported on Internet Explorer. Please use a different browser for the best results.');
          }
          if (cur_slug === 'mtic_c3_m56' && isMobile && !window.confirm('This module is not optimized for mobile devices. Please use a different device for the best results.')) {
            return;
          }
          if (cur_slug === 'mtic_c3_m56' && (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1)) {
            window.alert('This module is currently not supported on Internet Explorer. Please use a different browser to access this module.');
            return;
          }
          $timeout(function () {
            if (!zooming) {
              setSubmodule(cur_slug);
            }
          }, 10);
        });

        var setupText = function setupText() {
          // Text Information
          graphics.removeChildren();
          graphics.clear();

          var textInfo = new PIXI.Text(language.get(slug));
          textInfo.style.align = "center";
          textInfo.style.fill = "white";
          textInfo.style.fontFamily = "Helvetica";
          textInfo.style.fontSize = isMobile ? 22 : 15;

          graphics.position.set(xPos - textInfo.width, yPos + 10);

          var new_module = module_resource.slug === 'mtic_c3_m1v2';
          var height_diff = new_module ? 40 : 0;

          textInfo.x = textInfo.width / 2 + xTxtOffset;
          textInfo.y = 20 - textInfo.height / 2 + 10 + yTxtOffset;

          // Draw Text Bubble that wraps around the text
          graphics.lineStyle(0);
          graphics.beginFill(0x3B5763);
          graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 40 + height_diff, 10);
          graphics.endFill();
          if (new_module) {
            graphics.lineStyle(0);
            graphics.beginFill(0x33ccff);
            graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, 40, 10);
            graphics.drawRect(textInfo.x - 20, textInfo.y + 10, textInfo.width + 40, 20);
            graphics.endFill();

            update_text = new PIXI.Text(language.get('updated_slug'));
            update_text.anchor.set(0.5);
            update_text.style.align = "center";
            update_text.style.fill = "white";
            update_text.style.fontFamily = "Helvetica";
            update_text.style.fontSize = 18;
            update_text.x = textInfo.x - 20 + (textInfo.width + 40) / 2;
            update_text.y = 33 + yTxtOffset;
            graphics.addChild(update_text);
          }

          // Draw Triangle pointing to planet
          graphics.beginFill(new_module ? 0x33ccff : 0x3B5763);
          graphics.moveTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
          graphics.lineTo(textInfo.x + textInfo.width / 2, textInfo.y - 18);
          graphics.lineTo(textInfo.x + textInfo.width / 2 + 5, textInfo.y - 10);
          graphics.lineTo(textInfo.x + textInfo.width / 2 - 5, textInfo.y - 10);
          graphics.endFill();

          // Draw the score bar
          graphics.beginFill(0x3CE4B7);
          graphics.drawRect(textInfo.x - 10, textInfo.y + textInfo.height + 10 + height_diff, (textInfo.width + 20) * _this.scoreCompletion, 10);
          graphics.endFill();

          // Draw the score bar background (What isn't completed yet)
          graphics.beginFill(0x4B6875);
          graphics.drawRect(textInfo.x - 10 + (textInfo.width + 20) * _this.scoreCompletion, textInfo.y + textInfo.height + 10 + height_diff, textInfo.width + 20 - (textInfo.width + 20) * _this.scoreCompletion, 10);
          graphics.endFill();
          graphics.addChild(textInfo);

          textInfo.y += height_diff;
        };
        this.setupText = setupText;
        this.setupText();

        eventManager.listen('language:change', function () {
          setupText();
        });
        // Add everything to the stage
        planetContainer.addChild(graphics);
        planetContainer.addChild(this.sprite);
      };

      scope.$on('$destroy', function () {
        destroy_c3();
      });

      scope.returnToMetaModules = function () {
        eventManager.broadcast('module:change:meta', 'mtic_c3_m_meta');
      };

      scope.getLang = language.get;

      var workspace_list = {};
      var users_list = [];
      var workspace_data;
      scope.$watch('[workspaceData.users, workspaceData.modules]', function (val) {
        // $log.log('workspace change ', val)
        $timeout(function () {
          workspace_data = true;
          if (Planets && scope.workspaceData && val && val.length > 0 && scope.workspaceData.modules.length > 0 && (!scope.currentActiveSubModule || !scope.currentActiveSubModule.children)) {
            workspace_list = {};
            users_list = [];
            scope.workspaceData.users.forEach(function (user) {
              users_list.push(user.user_id);
            });

            scope.workspaceData.modules.forEach(function (work) {
              if (users_list.indexOf(work.user_id) > -1) {
                workspace_list[work.resource_id] = scope.workspaceData.users.length === 1 && (work.completed || workspace_list[work.resource_id]) ? true : false;
              }
            });

            Planets.forEach(function (planet) {
              for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
                if (planet.sprite && planet.sprite.slug === scope.moduleMapData.resources[i].slug) {
                  // for(var j = 0; j < scope.moduleMapData.resources[i].children.length ; j++){
                  //   var sub = scope.moduleMapData.resources[i].children[j];
                  //   if(sub.complete && !workspace_list[sub.id]){
                  //     sub.complete = false;
                  //   }
                  // }
                  var scoreInfo = computeModuleScoreRecursive(scope.moduleMapData.resources[i], workspace_list);

                  // $log.log('scoring : ' , scoreInfo, scope.moduleMapData.resources[i])
                  planet.score = scoreInfo.score;
                  planet.scoreMax = scoreInfo.scoreMax;
                }
              }

              planet.scoreCompletion = planet.score / planet.scoreMax;
              if (planet.setupText) {
                planet.setupText();
              }
            });

            workspace_data = false;
          }
        }, 50);
      });

      eventManager.listen('module:select:resource', function (e, data) {
        var scopeResource = getResourceBySlug(data.slug);
        // $log.log('meta got event module:select:resource ', data, scopeResource)
        if (scopeResource === null || data.dontCont) {
          eventManager.broadcast('module:dismiss:focus');
          return;
        }
        //Find the module that contains the selected item and open it
        var found;
        for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
          if (data.slug === 'run_like_math' && scope.moduleMapData.resources[i].slug === data.slug) {
            found = data.slug;
            break;
          }
          if (scope.moduleMapData.resources[i].children.indexOf(scopeResource) > -1) {
            if (MapStateService.getActiveModule() !== scope.moduleMapData.resources[i].slug) {
              found = scope.moduleMapData.resources[i].slug;
              // $timeout(function(){
              //   setSubmodule(scope.moduleMapData.resources[i].slug);
              // }, 1000);
              data.dontCont = true;
              break;
            }
          }
        }
        if (found) {
          scope.currentActiveSubModule = null;
          $timeout(function () {
            setSubmodule(found);
          }, 150);
        }

        // $timeout(()=>{
        //   eventManager.broadcast('module:select:resource', data)
        // }, 500);
      });
      var getResourceBySlug = function getResourceBySlug(slug) {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n++) {
          if (scope.moduleMapData.resources[n].slug === slug) {
            return scope.moduleMapData.resources[n];
          }
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === slug) {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      };
      var prehighlighted_list = [];
      eventManager.listen('highlight:map:items', function (e, list) {
        // $log.log('got prehighlighted list : ', list)
        prehighlighted_list = list;
      });

      eventManager.listen('sidepanel:toggled', function (e, val) {
        if (!PlatformService.isPhonePortrait()) {
          onResize(val);
        }
      });

      scope.view_controller = {
        isStudentView: true,
        isModulePanelView: true,
        openSubMod: function openSubMod(slug) {
          // $log.log('opening sub mod:', slug)
          $timeout(function () {
            eventManager.broadcast('module:change:submodule', slug);
          }, 1000);
        },
        openMainMod: function openMainMod(slug) {
          eventManager.broadcast('module:change:meta', 'mtic_c3_m_meta');
        }
      };

      var zooming = false;
      scope.zoom_function = function (val) {
        handleScroll({ detail: val, preventDefault: function preventDefault() {} });
        zooming = true;
        $timeout(function () {
          zooming = false;
        }, 10);
      };
      var handleScroll = function handleScroll(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = evt.detail < 0 || evt.wheelDelta > 0 ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.0, scale + direction / 15), 0.25);
        var diff = scale - start_scale;

        planetContainer.scale.set(scale, scale);

        evt.preventDefault();
        return false;
      };

      scope.selectAgendaPanel = function () {
        if (!scope.showAgenda) {
          scope.showAgenda = true;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          eventManager.broadcast('moduleview:agenda:request');
        }
      };

      scope.selectModulePanel = function () {
        if (scope.showAgenda) {
          scope.showAgenda = false;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          // for (var i = 0; i < items.length; i++) {
          //   items[i].undoAgendaHighlight();
          // }
        }
      };

      scope.dotifyUnitName = function dotifyUnitName() {
        var overviewDays = document.querySelector(".studentSidebarAgendaUnit__overviewDays");
        var unitNames = document.querySelectorAll(".studentSidebarAgendaUnit__name");

        if (!overviewDays || !unitNames) {
          return;
        }

        var overviewDaysWidth = overviewDays.clientWidth;

        for (var i = 0; i < unitNames.length; i++) {
          if (unitNames[i].clientHeight >= unitNames[i].scrollHeight) {
            unitNames[i].style.overflow = 'hidden';
            unitNames[i].style.textOverflow = 'ellipsis';
            unitNames[i].style.width = unitNames[i].clientWidth - overviewDaysWidth + "px";

            continue;
          }
          var limit = unitNames[i].offsetTop + unitNames[i].offsetHeight;
          var dots = document.createElement('span');
          if (unitNames[i]['data-inner']) {
            unitNames[i].innerHTML = unitNames[i]['data-inner'];
          } else {
            unitNames[i]['data-inner'] = unitNames[i].innerHTML;
          }
          dots.appendChild(document.createTextNode('...'));
          unitNames[i].style.overflow = 'hidden';
          unitNames[i].appendChild(dots);
          while (dots.offsetTop + dots.offsetHeight > limit) {
            dots.previousSibling.data = dots.previousSibling.data.replace(/\W*\w+\W*$/, '');
          }
        }
      };

      scope.agendas_list = [];
      eventManager.listen('moduleview:agenda:loaded', function (e, data) {
        if (data.length > 0) {
          scope.hasAgendas = true;
          scope.agendas_list = data;
          scope.selectAgendaPanel();
          // data.forEach(function(agenda){
          //   if(agenda.force_unlock){
          //     agenda.resources.forEach(function(item){
          //       unlockpath(item);
          //     })
          //   }
          // })

          angular.element(document).ready(function () {
            $timeout(function () {
              scope.dotifyUnitName();
            }, 100);
          });
        } else {
          scope.hasAgendas = false;
          scope.selectModulePanel();
        }
      });

      eventManager.listen('offline-post-call-resolved', function () {
        if (!scope.currentActiveSubModule) {
          destroy_c3(true);
          eventManager.broadcast('refresh:current:tab');
          eventManager.broadcast('student:cycle:open');
        }
      });

      function destroy_c3(clear_cache) {
        EXISTS = false;
        canvas_el = document.getElementById('c3-map-canvas');
        if (canvas_el) {
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll, false);
          canvas_el.removeEventListener('mousewheel', handleScroll, false);
        }
        if (planetContainer) {
          planetContainer.removeChildren();
        }
        if (container) {
          container.removeChildren();
        }
        window.removeEventListener("resize", onResize);
        PIXI.ticker.shared.remove(delta_resize);
        PIXI.ticker.shared.remove(update);
        eventManager.broadcast('destroy-c3-map');
        if (clear_cache) {
          for (var texture in PIXI.TextureCache) {
            var tmp = PIXI.Texture.removeTextureFromCache(texture);
            tmp.destroy(true);
          }
        }
        if (app) {
          app.destroy(true);
        }

        // $log.log('destroy c3!')
      }

      scope.hasAgendaOption = function () {
        return scope.hasAgendas;
      };
      scope.hasModuleOption = function () {
        return true && scope.currentActiveSubModule && scope.currentActiveSubModule.children;
      };
      scope.isShowingAgendaPanel = function () {
        return scope.showAgenda;
      };
      scope.isShowingModulePanel = function () {
        return !scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView;
      };

      scope.hideModal = function (cycle) {
        scope.modal3Hidden = true;
      };

      window.addEventListener("resize", onResize);

      //}, 500)
    }
  };
});

var PIXI_Load_Cache;
var EXISTS;
'use strict';

angular.module('mtic.components.login').directive('signup', function ($log, $q, api, $sce, $timeout, TIMING_CONSTANTS, $location, EventManager, language) {
  return {
    template:'<div class="signup"><alert-popup ng-if="alert.text" text="alert.text" type="{{alert.type}}"></alert-popup><div class="view-container"><div class="login-view"><center><div id="alert" role="alert" style="width: 500px; position: absolute; left: 50%; margin-left: -250px; margin-top: 10px"></div><div class="logo-container"><img class="logo" src="assets/images/logos/login_mathemaTIC_logo.png"></div><div class="ocmt-logo-container"><div class="left-section"><span>OCMT</span></div><div class="right-section"><span>HIGH-SCHOOL</span> <span>EDITION</span></div></div><div class="box ng-cloak" id="login-container" ng-if="!isSigningUp"><div style="padding-bottom: 10px"><div class="button is-medium student" ng-click="setUserType(\'STUDENT\')" ng-class="{\'is-primary\': (currentUserType === \'STUDENT\')}">{{language.get(\'11295\')}}</div><div class="button is-medium teacher" ng-click="setUserType(\'TEACHER\')" ng-class="{\'is-primary\': (currentUserType === \'TEACHER\')}">{{language.get(\'11296\')}}</div></div><form ng-submit="signUpStudent()" ng-if="currentUserType === \'STUDENT\'"><input class="input column" ng-change="splitCode(studentData)" ng-model="studentData.class_code_joined" type="text" placeholder="{{language.get(\'11298\')}}" id="inputid"> <input class="input column" ng-change="splitFullName(studentData)" ng-model="studentData.full_name_joined" type="text" placeholder="Your Name" id="inputid"><br><input class="input" ng-model="studentData.user_name" type="text" placeholder="{{language.get(\'11291\')}}" id="inputid"> <input class="input" ng-model="studentData.password" ng-change="studentData.password_confirm = studentData.password" type="password" placeholder="{{language.get(\'11292\')}}" id="inputpswd"> <button type="button" class="button" id="connectBtn" ng-click="signUpStudent()">{{language.get(\'11294\')}}</button></form><form ng-submit="signUpTeacher()" ng-if="currentUserType === \'TEACHER\'"><input class="input column" ng-model="teacherData.first_name" type="text" placeholder="{{language.get(\'11299\')}}" id="inputid"> <input class="input column" ng-model="teacherData.last_name" type="text" placeholder="{{language.get(\'11300\')}}" id="inputid"> <input class="input" ng-model="teacherData.user_name" type="text" placeholder="{{language.get(\'11291\')}}" id="inputid"> <input class="input" ng-model="teacherData.email" type="text" placeholder="{{language.get(\'11304\')}}" id="inputid"> <input class="input" ng-model="teacherData.password" ng-change="teacherData.password_confirm = teacherData.password" type="password" placeholder="{{language.get(\'11292\')}}" id="inputpswd"><div ng-if="teacherData.allowed_email" select-box options="allowedSchools.list" model="allowedSchools.selected" style="position:relative;" display-function="\'name\'"></div><input class="input" ng-if="!teacherData.allowed_email" ng-model="teacherData.access_code" type="text" placeholder="{{language.get(\'11303\')}}" id="inputid"> <button type="button" class="button" id="connectBtn" ng-click="signUpTeacher()">{{language.get(\'11294\')}}</button></form><div class="go-to-signin" style="margin-top: 15px"><a ng-click="goToSigin()">{{language.get(\'11302\')}}</a></div></div><div class="spinner" ng-if="isSigningUp"></div></center></div></div></div>',
    scope: {
      dueToExpiry: '=dueTo'
    },
    link: function link(scope) {
      /**
      * TEMPORARY
      * SHOULD BE LOADED FROM DB
      */
      scope.allowedSchools = {
        selected: null,
        list: [{ id: 110, name: "Cycle 3 Module 1" }, { id: 178, name: "Cycle 3 Module 2" }, { id: 155, name: "Grade 7&8" }]
      };
      var eventManager = new EventManager('signup', scope);
      var validator = Validator.validator();
      var is = Validator.Assert;
      scope.goToSigin = function () {
        eventManager.broadcast('login:open', 'signin');
      };
      try {
        scope.language = language;
        scope.currentUserType = "STUDENT";
        scope.isSigningUp = false;
        scope.studentData = {
          teacher_id: null, // 235c8456
          class_id: null,
          first_name: null,
          last_name: null,
          user_name: null,
          password: null,
          password_confirm: null,
          user_type: 'person'
        };
        scope.teacherData = {
          access_code: null,
          first_name: null,
          last_name: null,
          user_name: null,
          email: null,
          password: null,
          password_confirm: null,
          selected_school: null,
          allowed_email: false,
          user_type: 'person'
        };
        scope.$watch('teacherData.email', function (value) {
          if (value) {
            if (value.indexOf('@education.lu') > 0) {
              scope.teacherData.allowed_email = true;
            }
          }
        });
        scope.$watch('allowedSchools.selected', function (value) {
          if (value) {
            scope.teacherData.selected_school = String(value.id);
          }
        });
        scope.setUserType = function (type) {
          scope.currentUserType = type;
        };

        scope.signUpStudent = function () {
          scope.isSigningUp = true;
          scope.validateStudentFormData().then(function () {
            return api.signUpStudent(scope.studentData.teacher_id, scope.studentData.class_id, scope.studentData.user_name, scope.studentData.password, scope.studentData.first_name, scope.studentData.last_name, scope.studentData.user_type);
          }).then(function (data) {
            return api.login({
              uuid: scope.studentData.user_name,
              password: scope.studentData.password
            });
          }).then(function (response) {
            $location.url('/home');
          }).catch(function (err) {
            if (err) {
              eventManager.broadcast('signup:fail', err.message);
            }
            scope.isSigningUp = false;
          });
        };

        scope.signUpTeacher = function () {
          scope.isSigningUp = true;
          scope.valudateTeacherFormData().then(function () {
            if (scope.teacherData.allowed_email) {
              return api.signUpTeacherThroughGroup({
                group_id: scope.teacherData.selected_school,
                user_name: scope.teacherData.user_name,
                password: scope.teacherData.password,
                first_name: scope.teacherData.first_name,
                last_name: scope.teacherData.last_name,
                email: scope.teacherData.email,
                user_type: scope.teacherData.user_type
              });
            } else {
              return api.signUpTeacher(scope.teacherData.access_code, scope.teacherData.user_name, scope.teacherData.password, scope.teacherData.first_name, scope.teacherData.last_name, scope.teacherData.email, scope.teacherData.user_type);
            }
          }).then(function (data) {
            return api.login({
              uuid: scope.teacherData.user_name,
              password: scope.teacherData.password
            });
          }).then(function () {
            $location.url('/home');
          }).catch(function (err) {
            if (err) {
              eventManager.broadcast('signup:fail', err.message);
            }
            scope.isSigningUp = false;
          });
        };

        var isNumber = function isNumber(val) {
          return !isNaN(Number(val));
        };
        scope.alert = {
          type: 'danger'
        };
        scope.validateStudentFormData = function () {
          $log.log(scope.studentData.teacher_id);
          return $q(function (resolve, reject) {
            var validationResult = validator.validate(scope.studentData, {
              teacher_id: [is.notBlank(), is.callback(isNumber)],
              class_id: [is.notBlank(), is.callback(isNumber)],
              first_name: [is.notBlank()],
              last_name: [is.notBlank()],
              user_name: [is.notBlank()],
              password: [is.notBlank()],
              password_confirm: [is.equalTo(scope.studentData.password)],
              user_type: [is.notBlank()]
            });
            if (validationResult === true) {
              resolve();
            } else {
              var errorMessages = [];
              if (validationResult.teacher_id) {
                errorMessages.push("- " + language.get('11325'));
              }
              if (validationResult.class_id) {
                errorMessages.push("- " + language.get('11326'));
              }
              if (validationResult.password_confirm) {
                errorMessages.push("- " + language.get('11327'));
              }
              errorMessages.push("- " + language.get('11328'));
              scope.alert.text = null;
              $timeout(function () {
                scope.alert.text = errorMessages[0];
              }, TIMING_CONSTANTS.INSTANT);
              // alertBoxRegistry.get("alert-message").error(errorMessages.join("<br>"));
              scope.isSigningUp = false;
              eventManager.broadcast('signup:validation:fail', {
                validationResult: validationResult,
                errorMessages: errorMessages
              });
              reject();
            }
          });
        };

        var parseDigits = function parseDigits(val) {
          var num = parseInt(val, 10);
          if (isNaN(num) || !num) {
            num = 0;
          }
          return '' + num;
        };

        scope.splitCode = function (studentData) {
          if (studentData && studentData.class_code_joined) {
            var classCodeSplit = studentData.class_code_joined.split('c');
            studentData.teacher_id = parseDigits(classCodeSplit[0]);
            studentData.class_id = parseDigits(classCodeSplit[1]);
          }
        };

        scope.splitFullName = function (studentData) {
          if (studentData && studentData.full_name_joined) {
            var nameSplit = studentData.full_name_joined.split(' ');
            if (nameSplit.length === 1) {
              studentData.first_name = studentData.full_name_joined;
              studentData.last_name = '_';
            } else {
              studentData.last_name = nameSplit.pop();
              studentData.first_name = nameSplit.join(' ');
            }
          }
        };

        scope.valudateTeacherFormData = function () {
          return $q(function (resolve, reject) {
            var validations = {
              first_name: [is.notBlank()],
              last_name: [is.notBlank()],
              user_name: [is.notBlank()],
              email: [is.email(), is.notBlank()],
              password: [is.notBlank()],
              password_confirm: [is.equalTo(scope.teacherData.password)],
              user_type: [is.notBlank()]
            };
            if (!scope.teacherData.allowed_email) {
              validations.access_code = [is.notBlank()];
            } else {
              validations.selected_school = [is.notBlank()];
            }
            var validationResult = validator.validate(scope.teacherData, validations);
            if (validationResult === true) {
              resolve();
            } else {
              var errorMessages = [];
              errorMessages.push("- " + language.get('11328'));
              if (validationResult.password_confirm) {
                errorMessages.push("- " + language.get('11327'));
              }
              if (validationResult.email) {
                errorMessages.push("- " + language.get('11330'));
              }
              if (validationResult.selected_school) {
                errorMessages.push("- " + 'Missing a school selection');
              }

              scope.alert.text = null;
              $timeout(function () {
                scope.alert.text = errorMessages[0];
              }, TIMING_CONSTANTS.INSTANT);

              // alertBoxRegistry.get("alert-message").error(errorMessages.join("<br>"), true);
              reject();
            }
          });
        };
      } catch (err) {
        $log.error(err);
      }
    }
  };
});
'use strict';

angular.module('mtic.components.login').directive('signin', function ($log, $timeout, API_CONFIG, TIMING_CONSTANTS, LocaleService, IAMManager, EventManager, userAccount, api, language, MticAlertModalService, PlatformService, cordovaMessenger) {

  return {

    template:'<div class="signin"><div ng-switch="getCurrentLocale()"><div ng-switch-when="LUXEMBOURG" ng-if="show_login_button"><div ng-if="!loginForm.showDemoLogin" style="overflow:auto; position: absolute;top: 0px;bottom: 0px;left: 0px;right: 0px;"><div ng-if="!finalzeIam.active" class="login-cardless-container"><div class="logo-container"><img src="assets/images/logos/login_mathemaTIC_logo.png"></div><div class="iam-login-contaner"><div class="login-365"><button ng-click="loginThroughMicrosoft();" class="button connectBtn is-remote-login is-office365"><div class="connect-btn-icon-container"><i class="fa fa-windows" aria-hidden="true"></i></div><div class="connect-btn-label"><span ng-bind="language.get(\'8160\')"></span></div></button><div class="login-details" ng-if="isExtendedIamExamples"><div style="background-color:#fff; border-radius:8px; box-shadow: 0px 0px 8px rgba(0,0,0,0.1); font-size: 18px; padding: 16px 42px; text-align: left; width: 370px; height: 295px; margin: auto;display: inline-block;"><div style="border-bottom:1px solid #a9dad1; padding:8px;"><div style="display: flex; flex-direction: row;"><img style="height: 48px; margin-right:10px; vertical-align: left;" src="assets/images/login/iam_student_icon.png"><div><div><span style="font-size: 12px;">iam_student</span><span style="font-size:12px; color:#00be9b">@school.lu</span></div><div><i><span style="font-size: 12px;" ng-bind="language.get(\'26209\')">for example</span><span style="font-size: 12px;">: mulpa007@school.lu</span></i></div></div></div></div><div style="padding:8px;"><div style="display: flex; flex-direction: row;"><img style="height: 48px; margin-right:10px; vertical-align: left;" src="assets/images/login/iam_teacher_icon.png"><div><div><span style="font-size: 12px;">iam_teacher</span><span style="font-size:12px; color:#00be9b">@365.education.lu</span></div><div><i><span style="font-size: 12px;" ng-bind="language.get(\'26209\')">for example</span><span style="font-size: 12px;">: lea12@365.education.lu</span></i></div></div></div></div></div></div></div><div class="login-saml"><button ng-click="loginThroughSaml()" class="button connectBtn is-remote-login is-iam"><div class="connect-btn-icon-container" style="background-color: #EF6A72;"><img src="assets/images/login/IAM_icon.png"></div><div class="connect-btn-label"><span ng-bind="language.get(\'16815\')"></span></div></button><div class="login-details" ng-if="isExtendedIamExamples"><div style="background-color:#fff; border-radius:8px; box-shadow: 0px 0px 8px rgba(0,0,0,0.1); font-size: 18px; padding: 16px 42px; text-align: left; width:370px; height:295px; margin: auto;display: inline-block;"><div style="border-bottom:1px solid #a9dad1; padding:8px;"><div style="display: flex; flex-direction: row;"><img style="height: 48px; margin-right:10px; vertical-align: left;" src="assets/images/login/iam_user_icon.png"><div><div><i style="font-size: 12px;">iam username</i></div><div><i style="font-size: 12px;"><span ng-bind="language.get(\'26209\')">for example</span>: mulpa007</i></div></div></div></div></div></div></div></div><div class="login-details-toggle" ng-click="toggleExtendedIamExamples()"><img src="assets/images/logos/info-icon.png"> <span ng-bind="language.get(\'26208\')">Login Details</span></div><div ng-class="[\'mtic-info\', {expanded: mticInfoExpanded}]"><p ng-bind="language.get(\'26207\')"></p></div><div class="read-more" ng-class="{\'expanded\': mticInfoExpanded}"><span ng-bind="language.get(\'8189\')" ng-click="toggleMTICInfo()"></span></div><div id="ef-instr-video"><button id="iamef-video-toggle" class="button is-small is-info" ng-click="toggleIAMEFVideo()" ng-bind="language.get(\'26210\')">Detailed IAM Instructions for Ecole Fondamentale Teachers</button><div class="iamef-video-toggle-txt"><span ng-click="toggleIAMEFVideo()" ng-bind="language.get(\'26214\')"></span>{{language.get(\'26215\')}}</div><div id="iamef-video-container" ng-if="isIAMEFVideo"><iframe width="560" height="315" src="https://www.youtube.com/embed/E0mlqje-GOA" frameborder="0" allowfullscreen></iframe></div></div><div ng-show="!fromSessionExpiry && !is_ios && !isWebEmbedded && isSystemRequirementOpen" style="margin-top:26px; background-color: #fff;"><div id="min-req-table" style="padding: 16px; text-align: center; font-size:28px; font-weight:600;" ng-bind="language.get(\'14456\')+ \' - \'+getSystemVersion()">Minimum System Requirements</div><table class="table table-system-reqs"><tr><th></th><th colspan="2" class="light-header" ng-bind="language.get(\'14529\')">école fondamentale</th><th class="light-header" ng-bind="language.get(\'14530\')">lycée</th></tr><tr><th></th><th>Cycle 3</th><th>Cycle 4</th><th>Cycle Inférieur</th></tr><tr><th class="system-reqs-left-align"><div><i class="device-icon fa fa-laptop" aria-hidden="true"></i> PC/Mac/Laptop</div><div class="system-reqs-hardware">Intel® Core™ i3 CPU 530<br>2.93GHz <span ng-bind="language.get(\'14503\')">or higher</span><br>4 GB RAM<br>256MB <span ng-bind="language.get(\'14501\')">dedicated video</span></div></th><td class="offset-down"><div>Google Chrome 60</div><div>Internet Explorer 11</div><div>Firefox 57</div></td><td class="offset-down"><div>Google Chrome 60</div><div>Internet Explorer 11</div><div>Firefox 57</div></td><td class="offset-down"><div>Google Chrome 60</div><div>Internet Explorer 11</div><div>Firefox 57</div></td></tr><tr><th class="system-reqs-left-align"><i class="device-icon fa fa-apple" aria-hidden="true"></i> iPad<div class="system-reqs-hardware">iPad Air 2 <span ng-bind="language.get(\'14503\')">or higher</span><br></div></th><td class="offset-down"></td><td><div class="system-reqs-get-app"><a href="https://itunes.apple.com/fr/app/mathematic.lu/id1061078441?mt=8" ng-bind="language.get(\'14461\')">GET THE APP</a></div></td><td class="offset-down"></td></tr></table></div></div><mtic-post-iam-registration ng-if="finalzeIam.active && !finalizeIamDoneInternational" ng-init="finalizeCheck(\'lux\')" role-type="finalzeIam.role_type" profile="finalzeIam.profile"></mtic-post-iam-registration></div><div ng-if="loginForm.showDemoLogin" class="login-view"><center><div class="logo-container"><img src="assets/images/logos/login_mathemaTIC_logo.png"></div><div class="box" id="login-container"><form ng-submit="attemptLogin()"><div class="login-form-input-container"><input class="input login-form-input" ng-if="!pswdSubmitted" ng-change="resetValidation()" ng-model="loginForm.username" type="text" placeholder="{{language.get(\'11291\')}}" ng-focus="focusItem(\'inputid\')" id="inputid" autocomplete="username"> <i class="fa fa-user login-form-input-icon" aria-hidden="true"></i></div><div class="login-form-input-container"><input class="input login-form-input" ng-if="!pswdSubmitted" ng-change="resetValidation()" ng-model="loginForm.password" type="password" placeholder="{{language.get(\'11292\')}}" ng-focus="focusItem(\'inputpswd\')" id="inputpswd" autocomplete="current-password"> <i class="fa fa-key login-form-input-icon" aria-hidden="true"></i></div><input ng-hide="loginForm.isConnecting || loginForm.isFailed" type="submit" class="button connectBtn" value="{{language.get(\'8188\')}}"> <button ng-show="loginForm.isConnecting" class="button connectBtn in-progress">{{language.get(\'11319\')}}</button> <button ng-show="loginForm.isFailed" class="button connectBtn is-danger">{{language.get(\'11320\')}}</button></form></div></center></div><div class="bottom-bar"><div class="system-requirements" ng-hide="finalzeIam.active || fromSessionExpiry || is_ios || isWebEmbedded"><a ng-click="toggleSysReq()"><i class="fa fa-cog" aria-hidden="true"></i> <span ng-bind="language.get(\'14456\')">System Requirement</span></a></div><div class="demo-login" ng-hide="finalzeIam.active"><button ng-click="loginForm.showDemoLogin = !loginForm.showDemoLogin" class="button connectBtn is-demo"><div class="connect-btn-icon-container"><i class="fa fa-user-o" aria-hidden="true"></i></div><div class="connect-btn-label"><span ng-bind="language.get(\'14463\')">Other Login</span> <span ng-show="loginForm.showDemoLogin">(<span ng-bind="language.get(\'27643\')">Logout</span>)</span></div></button></div></div></div><div ng-switch-when="INTERNATIONAL" ng-if="show_login_button"><div class="login-view" ng-if="!isLoggingIn" ng-hide="finalzeIam.active"><center><div class="logo-container"><img src="assets/images/logos/login_mathemaTIC_logo.png"></div><div class="box ng-cloak" id="login-container"><input id="country_filter_input" ng-show="country_box_focus" ng-model="name_object.country_name_filter" ng-change="filter_countries(name_object.country_name_filter)" placeholder="Start typing to change country..." ng-focus="expandCountryBox(true)" ng-blur="expandCountryBox(false, true)"><div class="country_box" ng-show="country_box_focus" id="big_country_box"><div ng-repeat="country in countries_list_filtered" class="box" style="margin-top:10px !important;width:260px;box-shadow:none !important;padding:0px" id="country_id_{{country.code}}"><article class="media" style="margin-bottom:7px"><div ng-click="setCountry(country)" class="media-content" style="cursor:pointer;background-color: #f1f1f1;"><div class="content columns" style="background-color: #f1f1f1" ng-class="{\'country_selected_box\' : selected_country.name === country.name }"><p class="column is-12"><img style="display:inline-block; width:28px;position:relative;top:2px;margin-right:5px" ng-show="selected_country" ng-src="assets/images/flags/{{country.name.toLowerCase().split(\' \').join(\'_\').split(\'\\\'\').join(\'_\')}}.gif"> <strong style="font-size:16px;font-weight:600" ng-bind="country.name" ng-class="{\'country_selected_text\' : selected_country.name === country.name }"></strong></p></div></div></article></div></div><div class="country_box" style="max-height:60px !important;overflow: hidden !important;margin-bottom:0px;cursor: pointer;" ng-show="!country_box_focus" ng-click="expandCountryBox(true)"><p style="text-align:left;margin-left:30px"><img ng-if="!getIpCountryFailed" style="display:inline-block; width:28px;position:relative;top:2px;margin-right:5px" ng-src="assets/images/flags/{{selected_country.name.toLowerCase().split(\' \').join(\'_\').split(\'\\\'\').join(\'_\')}}.gif"> <strong style="font-size:16px;font-weight:600" ng-bind="selected_country.name"></strong> <i class="fa fa-angle-down" aria-hidden="true" style="float:right;font-size: 20px;font-weight: bold;"></i></p></div><br ng-if="$root.branding.code!==\'ocmt\'"><div ng-show="$root.branding.code === \'ocmt\'" class="ocmt-logo-container"><div class="left-section"><span>OCMT</span></div><div class="right-section"><span>HIGH-SCHOOL</span> <span>EDITION</span></div></div><form ng-submit="attemptLogin()"><div class="enter-credentials"><span>{{language.get(\'8192\')}}</span></div><div class="login-form-input-container"><input class="input login-form-input" ng-if="!pswdSubmitted" ng-change="resetValidation()" ng-model="loginForm.username" type="text" placeholder="{{language.get(\'11291\')}}" ng-focus="focusItem(\'inputid\')" id="inputid" autocomplete="username"> <i class="fa fa-user login-form-input-icon" aria-hidden="true"></i></div><div class="login-form-input-container"><input class="input login-form-input" ng-if="!pswdSubmitted" ng-change="resetValidation()" ng-model="loginForm.password" type="password" placeholder="{{language.get(\'11292\')}}" ng-focus="focusItem(\'inputpswd\')" id="inputpswd" autocomplete="current-password"> <i class="fa fa-key login-form-input-icon" aria-hidden="true"></i></div><input ng-hide="loginForm.isConnecting || loginForm.isFailed" type="submit" class="button connectBtn login" value="{{language.get(\'8188\')}}"> <input class="button connectBtn register" value="{{language.get(\'8190\')}}" ng-click="onNoAccount()"><div class="forgot-password"><span ng-click="openForgotPassword()">{{language.get(\'8191\')}}</span></div><button ng-show="loginForm.isConnecting" class="button connectBtn in-progress">{{language.get(\'11319\')}}</button> <button ng-show="loginForm.isFailed" class="button connectBtn is-danger">{{language.get(\'11320\')}}</button></form><div class="or-line-container" ng-hide="isPortugalUser"><div class="or-line"></div><div class="or-line-label" ng-bind="\'or\'"></div><div class="or-line"></div></div><div class="forgotPwdDialog" ng-if="forgotPwd"><div class="dialog"><div class="dheader"><div class="title">{{language.get(\'8193\')}}</div><div class="closeBtn" ng-click="closeForgotPassword()"><i class="fa fa-times-circle" aria-hidden="true"></i></div></div><div class="dbody"><div class="email-form" ng-if="!recoveryEmailSent"><input type="text" class="email-address" placeholder="{{language.get(\'8195\')}}"> <input class="button connectBtn send-link" value="{{language.get(\'8194\')}}" ng-click="sendPasswordRecoveryEmail()"></div><div class="email-confirmation" ng-if="recoveryEmailSent"><div class="confirmation-text">An Email with instructions to reset your password should arrive in a few minutes.</div><input class="button connectBtn ok" value="OK" ng-click="closeForgotPassword()"></div></div></div></div><div class="alternative-logins" ng-hide="isPortugalUser"><button ng-click="onNoAccount();" class="button connectBtn is-remote-login is-facebook"><div class="connect-btn-icon-container"><i class="fa fa-user-plus" aria-hidden="true"></i></div><div class="connect-btn-label"><span ng-bind-disabled="language.get(\'11294\')">New Account</span></div></button></div><div class="alternative-logins" style="margin-top:20px" ng-hide="isPortugalUser"><button ng-click="loginThroughMicrosoft();" class="button connectBtn is-remote-login is-office365"><div class="connect-btn-icon-container"><i class="fa fa-windows" aria-hidden="true"></i></div><div class="connect-btn-label"><span ng-bind="language.get(\'8160\')"></span></div></button></div><div ng-show="messageHandler.display" ng-class="messageHandler.getClass()" role="alert" ng-bind="messageHandler.get()"></div><div ng-if="dueToExpiry">{{language.get(\'11322\')}}<br>{{language.get(\'11323\')}}</div></div><div class="no-account" ng-if="!dueToExpiry"></div></center></div><mtic-post-iam-registration ng-if="finalzeIam.active && !finalizeIamDoneLux" ng-init="finalizeCheck(\'int\')" role-type="finalzeIam.role_type" profile="finalzeIam.profile"></mtic-post-iam-registration></div><div style="position:absolute; top:0px; left:0px; padding:12px;"><div ng-show="loginForm.showDemoLogin" ng-click="onNoAccount()" style="position:relative;background: transparent;width: 50px;height: 50px;cursor:pointer;"></div></div><div ng-if="!show_login_button" id="signin_load_page"><div class="loader"></div></div></div><div ng-if="offline_post_submission" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: fixed;overflow:auto;top:0px;left:0px;z-index:100000000;display:flex;justify-content:center;align-items:center"><div style="background-color:#ffffff;width:400px;height:240px;border-radius: 10px;text-align: center;padding: 30px"><span style="font-size:18px;" ng-bind="language.get(\'15053\')">There appears to be a problem with your Internet connection.</span><br><br><span style="font-size:18px;" ng-bind="language.get(\'15055\')">Check your network connection and try again.</span><br><a class="button is-primary" ng-click="loginThroughMicrosoft()" style="min-width:100px;margin-top:30px;margin-bottom:20px" ng-bind="language.get(\'15054\')">Try Again</a></div></div></div><div ng-if="show_ios_app_login_redirect" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: fixed;overflow:auto;top:0px;left:0px;z-index:100000000;display:flex;justify-content:center;align-items:center"><div style="background-color:#ffffff;width:400px;height:240px;border-radius: 10px;text-align: center;padding: 30px"><span style="font-size:18px;" ng-bind="language.get(\'ios_app_issue\')">We have detected a temporary issue with your Office 365 login, please use your Safari browser to login.</span><br><a class="button is-primary" ng-click="hide_ios_notification()" style="min-width:100px;margin-top:30px;margin-bottom:20px" ng-bind="language.get(\'27896\')">Try Again</a></div></div>',
    scope: {
      keepMoving: '=',
      username: '=?',
      fromSessionExpiry: '=?'
    },
    link: function link(scope) {
      // event manager
      var eventManager = new EventManager('signin', scope);

      scope.is_ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      // $log.log('is iOs: ', scope.is_ios );
      scope.isSystemRequirementOpen = false;

      var WEB_EMBED_URL_SLUG = 'web-embed-connect';

      var token_saved_url = IAMManager.getSavedUrlParamsForToken(); // This because on redirect, url params are erased
      // model

      // IAMManager.shouldPopup = false;
      if (window.location.href.indexOf(WEB_EMBED_URL_SLUG) !== -1 || token_saved_url.indexOf(WEB_EMBED_URL_SLUG) !== -1 || window.isWebEmbedConnect) {
        scope.isWebEmbedded = true;
        IAMManager.shouldPopup = false;
      } else if (scope.is_ios || navigator.userAgent.match(/Android/i)) {
        IAMManager.shouldPopup = false;
      }

      window.isWebEmbedConnect = scope.isWebEmbedded;

      scope.language = language;
      scope.finalzeIam = {
        active: false,
        role_type: null,
        profile: null
      };
      scope.loginForm = {
        username: null,
        password: null,
        isConnecting: false,
        isFailed: false
      };
      if (scope.username) {
        scope.loginForm.username = scope.username;
      }

      scope.getIpCountryFailed = false;

      scope.show_login_button = false;
      var url = window.location.href;
      scope.show_saml = true;
      if (window.location.href.indexOf('force-no-saml') > -1) {
        scope.show_saml = false;
      } else if (url.indexOf('new_saml_user') > -1) {
        var new_user_params = JSON.parse(decodeURIComponent(url.split("new_saml_user=")[1]).replace(/\/"/g, '\\"'));
        new_user_params.oid = Math.random().toString(36).substr(3, 10);
        new_user_params.unique_name = new_user_params.uuid;
        new_user_params.name = new_user_params.full_name;
        $log.log('NEW USER LOGIN ::  ', new_user_params);
        scope.finalzeIam.profile = new_user_params;
        scope.finalzeIam.role_type = new_user_params.account_type.indexOf('STUDENT') > -1 ? 'mtic_student' : 'mtic_teacher';
        scope.finalzeIam.active = true;
        document.location.hash = '';
      }
      if (url.indexOf('id_token=') !== -1) {
        scope.show_login_button = false;
        //console.log('got url params : ', token_saved_url)
        var url_split = url.split('&');
        var id_token = url_split[0].split('id_token=')[1];

        var cached_profile = IAMManager.microsoft.client._extractIdToken(url_split[0].split('=')[1]);

        var saved_url_split = token_saved_url.split('#');
        document.location.hash = saved_url_split.length > 1 ? saved_url_split[1] : '';

        login_with_microsoft_profile(cached_profile);

        //scope.loginThroughMicrosoft()
        //console.log('here: ', IAMManager.microsoft.client.AcquireToken(id_token))
        //console.log('external redirect, id_token : ', url_split[0].split('=')[1])
      } else {
        scope.show_login_button = true;
      }

      eventManager.listen('done-login-attempt', function () {
        scope.show_login_button = true;
      });
      eventManager.listen('start-login-attempt', function () {
        scope.show_login_button = false;
      });
      eventManager.listen('post-iam-finalize', function (data) {
        scope.finalzeIam.profile = data.profile;
        scope.finalzeIam.role_type = data.role_type;
        scope.finalzeIam.active = true;
      });

      scope.toggleExtendedIamExamples = function () {
        scope.isExtendedIamExamples = !scope.isExtendedIamExamples;
      };

      scope.toggleSysReq = function () {
        scope.isSystemRequirementOpen = !scope.isSystemRequirementOpen;
        if (scope.isIAMEFVideo) {
          $timeout(function () {
            document.getElementById('min-req-table').scrollTo(0, document.body.scrollHeight);
          }, 100);
        }
      };

      scope.toggleIAMEFVideo = function () {
        scope.isIAMEFVideo = !scope.isIAMEFVideo;
        if (scope.isIAMEFVideo) {
          $timeout(function () {
            document.getElementById('ef-instr-video').scrollIntoView(false);
          }, 100);
        }
      };

      scope.mticInfoExpanded = false;
      scope.toggleMTICInfo = function () {
        scope.mticInfoExpanded = !scope.mticInfoExpanded;
      };

      scope.getCurrentLocale = function () {
        var curLocale = scope.selected_country && scope.selected_country.code === 'LU' ? 'LUXEMBOURG' : LocaleService.getCurrentLocale();
        scope.isPortugalUser = scope.selected_country && scope.selected_country.code === 'PT';
        return curLocale;
      };

      scope.finalizeCheck = function (val) {
        if (val === 'int') {
          scope.finalizeIamDoneInternational = true;
        } else {
          scope.finalizeIamDoneLux = true;
        }
      };

      var messageHandler = scope.messageHandler = {
        message: null,
        type: 'info',
        display: false,
        timeoutCancel: null,
        ext: '',
        hide: function hide() {
          messageHandler.display = false;
        },
        show: function show() {
          messageHandler.display = true;
        },
        get: function get() {
          return language.get(this.message) + this.ext;
        },
        getClass: function getClass() {
          switch (messageHandler.type) {
            case 'success':
              return { 'notification': true, 'is-success': true };
            case 'error':
              return { 'notification': true, 'is-danger': true };
            default:
              return { 'notification': true };
          }
        },
        set: function set(langId) {
          var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
          var ext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

          messageHandler.type = ['info', 'error', 'success'].indexOf(type) > -1 ? type : 'info';
          messageHandler.message = langId;
          $timeout(function () {
            messageHandler.show();
          }, TIMING_CONSTANTS.SCOPE_REFRESH_DELAY_MS);
          messageHandler.ext = ext ? ext : '';
          if (messageHandler.timeoutCancelToken) {
            $timeout.cancel(messageHandler.timeoutCancelToken);
          }
          messageHandler.timeoutCancelToken = $timeout(messageHandler.hide, TIMING_CONSTANTS.MESSAGE_HIDE_DELAY_MS);
        }
      };

      scope.resetValidation = function () {
        scope.loginForm.isConnecting = false;
        scope.loginForm.isFailed = false;
      };

      scope.openForgotPassword = function () {
        scope.recoveryEmailSent = false;
        scope.forgotPwd = true;
      };
      scope.closeForgotPassword = function () {
        scope.forgotPwd = false;
      };
      scope.sendPasswordRecoveryEmail = function () {
        scope.recoveryEmailSent = true;
      };

      scope.attemptLogin = function () {
        eventManager.broadcast('start-login-attempt');
        scope.loginForm.isFailed = false;
        scope.loginForm.isConnecting = true;
        // console.log(window.location.href, window.location.href.indexOf('web-embed-connect'))
        //if (window.location.href.indexOf(WEB_EMBED_URL_SLUG) !== -1){
        //window.isWebEmbedConnect = scope.isWebEmbedded;
        //}
        // $log.log('[[signin]]', scope.loginForm.username, scope.loginForm.password, !!scope.username, scope.keepMoving)
        api.login({
          uuid: scope.loginForm.username,
          password: scope.loginForm.password,
          dueToExpiry: !!scope.username,
          keepMoving: scope.keepMoving
        }).then(function () {
          eventManager.broadcast('done-login-attempt');
        }).catch(function () {
          eventManager.broadcast('done-login-attempt');
        });
      };
      scope.onNoAccount = function () {
        eventManager.broadcast('login:open', 'signup');
      };
      scope.loginThroughGoogle = function () {
        window.alert('Google login not available at this time.');
      };
      scope.loginThroughFacebook = function () {
        window.alert('Facebook login not available at this time.');
      };
      scope.hide_ios_notification = function () {
        scope.show_ios_app_login_redirect = false;
      };
      scope.loginThroughSaml = function () {
        var _arguments = arguments;

        var hash_params = window.location.href.split('/#');
        var relayState = encodeURIComponent(JSON.stringify({
          redirectTo: window.location.href.replace(/#.*$/, ''),
          urlHash: hash_params.length > 1 ? hash_params[1].replace('/', '') : '',
          forApp: PlatformService.isApp
        }));
        var samlLoginUrl = API_CONFIG.REMOTE_API + '/saml/login' + '?RelayState=' + relayState;
        if (PlatformService.isApp) {
          cordovaMessenger.requestResponse('requestSamlLogin', { samlLoginUrl: samlLoginUrl }).then(function (response) {
            $log.log('loginThroughSaml response', _arguments);
            if (!response) {
              $log.debug('saml login cancelled');
              return;
            }
            response.payload.data.isSamlUser = true;
            document.location.hash = response.payload.messageType + '=' + JSON.stringify(response.payload.data);
            window.location.reload();
          }).catch(function (err) {
            $log.error(err, 'saml login cancelled');
          });
        } else {
          window.location.href = samlLoginUrl;
        }
      };
      scope.loginThroughMicrosoft = function () {
        //IAM LOGIN:
        if (!PlatformService.isApp) {
          scope.offline_post_submission = false;
          if (!navigator.onLine) {
            $timeout(function () {
              scope.offline_post_submission = true;
            }, 200);
            return;
          }
          messageHandler.set(8147, 'info');
          eventManager.broadcast('start-login-attempt');
        }

        IAMManager.login().then(function (data) {
          login_with_microsoft_profile(data.profile);
        }).catch(function (err) {
          $log.debug(err);
          eventManager.broadcast('done-login-attempt');
        });
      };

      function login_with_microsoft_profile(profile) {
        // $log.log('[[signin]] LoggedIn to microsoft!', profile)
        eventManager.broadcast('start-login-attempt');
        scope.finalzeIam.profile = profile;
        api.login({
          uuid: profile.unique_name,
          password: profile.oid,
          dueToExpiry: !!scope.username,
          keepMoving: scope.keepMoving,
          auth_type: 'microsoftStrategy',
          dontCatch: true
        }).then(function (res) {
          // $log.log('[[signin]] Microsoft Login sucessful', res);
          eventManager.broadcast('done-login-attempt');
          LocaleService.setCurrentLocale('LUXEMBOURG');
          LocaleService.setAsIamUser();
        }).catch(function (err) {
          eventManager.broadcast('done-login-attempt');
          //$log.log('[[signin]] Login issue failed', err);
          if (err.message === 'NOT_FOUND__USER_AUTHS') {
            api.validateIAM(profile).then(function (data) {
              // $log.log('api.validateIAM', data);
              scope.finalzeIam.role_type = data.role_type;
              scope.finalzeIam.active = true;
            }).catch(function (err) {
              // $log.log('api.validateIAM FAIL');
              MticAlertModalService.set(err.message, {
                title: 'Microsoft Login',
                callback: function callback() {
                  userAccount.logout();
                }
              });
              $log.debug('[[signin]]', err);
            });
          } else {
            messageHandler.set(8155, 'error');
            // if(err === 'FAILED_TO_CONNECT' || err.message === 'FAILED_TO_CONNECT'){
            //   window.alert('You are not connected to the internet, please try again!')
            // }
            $log.debug('[[signin]]', { err: err });
          }
        });
      }

      if (API_CONFIG.debugLogin) {
        $timeout(function () {
          scope.loginForm.username = API_CONFIG.debugLogin.username;
          scope.loginForm.password = API_CONFIG.debugLogin.password;
          scope.attemptLogin();
        }, TIMING_CONSTANTS.PRE_DEBUG_AUTOACTION_MS);
      }

      //scope.selected_country = {name: 'Select Your Country'};
      scope.country_box_focus = false;
      scope.name_object = {};
      scope.name_object.country_name_filter = '';

      // scope.$watch('selected_country.name', function(val){
      //   console.log('country change : ', val)
      // })
      var cancel_touch = false;
      scope.setCountry = function (country) {
        scope.getIpCountryFailed = false;
        scope.selected_country = country;
        scope.country_box_focus = false;
        scope.name_object.country_name_filter = '';
        scope.filter_countries();
        if (country.code === 'LU') {
          LocaleService.setCurrentLocale('LUXEMBOURG');
        } else {
          var browserLanguage = window.navigator.language;
          if (browserLanguage) {
            var browserLanguageShort = browserLanguage.split('-')[0];
            switch (browserLanguageShort) {
              case 'en':
                // language.set($cookies.get('bar_language') || 'en', true);
                if (!userAccount.isLanguageSetThroughProfile()) {
                  language.set('en', true);
                }
                break;
            }
          }
        }
        // cancel_touch = true;
        // $timeout(function(){
        //   cancel_touch = false;
        // }, 500)
      };

      $timeout(function () {
        location_callback();
      }, 1000);

      var location_callback = function location_callback() {
        var ip_based = LocaleService.getIpBasedCountry();
        if (ip_based) {
          scope.countries_list.forEach(function (country) {
            if (country.code === ip_based && scope.selected_country !== country) {
              scope.setCountry(country);
            }
          });
        } else {
          scope.selected_country = { name: 'Click to select your country...' };
          scope.getIpCountryFailed = true;
        }
      };

      LocaleService.registerObserver(location_callback);

      scope.expandCountryBox = function (bool, clear) {
        $timeout(function () {
          // if(cancel_touch) return;
          scope.country_box_focus = bool;
          if (clear) {
            scope.name_object.country_name_filter = '';
            scope.filter_countries();
          }
          if (bool) {
            $timeout(function () {
              document.getElementById('country_filter_input').focus();
            }, 200);
          }
          // if(bool && scope.selected_country.name){
          // $timeout(function(){
          //   var myElement = document.getElementById('country_id_'+scope.selected_country.code);
          //   if(myElement){
          //     var topPos = myElement.offsetTop;
          //     document.getElementById('big_country_box').scrollTop = topPos - 44;
          //   }
          // }, 200)
          // }
        }, 200);
      };

      scope.filter_countries = function (val) {
        if (!val || val.trim() === '') {
          scope.countries_list_filtered = scope.countries_list;
          //scope.selected_country = {name: 'Select Your Country'};
        } else {
          scope.countries_list_filtered = [];
          scope.countries_list.forEach(function (country) {
            var lc_name = country.name.toLowerCase();
            if (lc_name.match(val.toLowerCase())) {
              scope.countries_list_filtered.push(country);
            }
          });
        }
      };

      scope.focusItem = function (elementId) {
        document.getElementById(elementId).scrollIntoView(true);
      };

      scope.getSystemVersion = function () {
        return 'v7.43.29-rc.110';
      };

      scope.countries_list = [{ "name": "Afghanistan", "code": "AF" }, { "name": "Aland Islands", "code": "AX" }, { "name": "Albania", "code": "AL" }, { "name": "Algeria", "code": "DZ" }, { "name": "American Samoa", "code": "AS" }, { "name": "AndorrA", "code": "AD" }, { "name": "Angola", "code": "AO" }, { "name": "Anguilla", "code": "AI" }, { "name": "Antarctica", "code": "AQ" }, { "name": "Antigua and Barbuda", "code": "AG" }, { "name": "Argentina", "code": "AR" }, { "name": "Armenia", "code": "AM" }, { "name": "Aruba", "code": "AW" }, { "name": "Australia", "code": "AU" }, { "name": "Austria", "code": "AT" }, { "name": "Azerbaijan", "code": "AZ" }, { "name": "Bahamas", "code": "BS" }, { "name": "Bahrain", "code": "BH" }, { "name": "Bangladesh", "code": "BD" }, { "name": "Barbados", "code": "BB" }, { "name": "Belarus", "code": "BY" }, { "name": "Belgium", "code": "BE" }, { "name": "Belize", "code": "BZ" }, { "name": "Benin", "code": "BJ" }, { "name": "Bermuda", "code": "BM" }, { "name": "Bhutan", "code": "BT" }, { "name": "Bolivia", "code": "BO" }, { "name": "Bosnia and Herzegovina", "code": "BA" }, { "name": "Botswana", "code": "BW" }, { "name": "Bouvet Island", "code": "BV" }, { "name": "Brazil", "code": "BR" }, { "name": "British Indian Ocean Territory", "code": "IO" }, { "name": "Brunei Darussalam", "code": "BN" }, { "name": "Bulgaria", "code": "BG" }, { "name": "Burkina Faso", "code": "BF" }, { "name": "Burundi", "code": "BI" }, { "name": "Cambodia", "code": "KH" }, { "name": "Cameroon", "code": "CM" }, { "name": "Canada", "code": "CA" }, { "name": "Cape Verde", "code": "CV" }, { "name": "Cayman Islands", "code": "KY" }, { "name": "Central African Republic", "code": "CF" }, { "name": "Chad", "code": "TD" }, { "name": "Chile", "code": "CL" }, { "name": "China", "code": "CN" }, { "name": "Christmas Island", "code": "CX" }, { "name": "Cocos Islands", "code": "CC" }, { "name": "Colombia", "code": "CO" }, { "name": "Comoros", "code": "KM" }, { "name": "Republic of the Congo", "code": "CG" }, { "name": "Democratic Republic of the Congo", "code": "CD" }, { "name": "Cook Islands", "code": "CK" }, { "name": "Costa Rica", "code": "CR" }, { "name": "Cote D'Ivoire", "code": "CI" }, { "name": "Croatia", "code": "HR" }, { "name": "Cuba", "code": "CU" }, { "name": "Cyprus", "code": "CY" }, { "name": "Czech Republic", "code": "CZ" }, { "name": "Denmark", "code": "DK" }, { "name": "Djibouti", "code": "DJ" }, { "name": "Dominica", "code": "DM" }, { "name": "Dominican Republic", "code": "DO" }, { "name": "Ecuador", "code": "EC" }, { "name": "Egypt", "code": "EG" }, { "name": "El Salvador", "code": "SV" }, { "name": "Equatorial Guinea", "code": "GQ" }, { "name": "Eritrea", "code": "ER" }, { "name": "Estonia", "code": "EE" }, { "name": "Ethiopia", "code": "ET" }, { "name": "Falkland Islands", "code": "FK" }, { "name": "Faroe Islands", "code": "FO" }, { "name": "Fiji", "code": "FJ" }, { "name": "Finland", "code": "FI" }, { "name": "France", "code": "FR" }, { "name": "French Guiana", "code": "GF" }, { "name": "French Polynesia", "code": "PF" }, { "name": "French Southern Territories", "code": "TF" }, { "name": "Gabon", "code": "GA" }, { "name": "Gambia", "code": "GM" }, { "name": "Georgia", "code": "GE" }, { "name": "Germany", "code": "DE" }, { "name": "Ghana", "code": "GH" }, { "name": "Gibraltar", "code": "GI" }, { "name": "Greece", "code": "GR" }, { "name": "Greenland", "code": "GL" }, { "name": "Grenada", "code": "GD" }, { "name": "Guadeloupe", "code": "GP" }, { "name": "Guam", "code": "GU" }, { "name": "Guatemala", "code": "GT" }, { "name": "Guernsey", "code": "GG" }, { "name": "Guinea", "code": "GN" }, { "name": "Guinea Bissau", "code": "GW" }, { "name": "Guyana", "code": "GY" }, { "name": "Haiti", "code": "HT" }, { "name": "Heard Island and Mcdonald Islands", "code": "HM" }, { "name": "Vatican City", "code": "VA" }, { "name": "Honduras", "code": "HN" }, { "name": "Hong Kong", "code": "HK" }, { "name": "Hungary", "code": "HU" }, { "name": "Iceland", "code": "IS" }, { "name": "India", "code": "IN" }, { "name": "Indonesia", "code": "ID" }, { "name": "Iran", "code": "IR" }, { "name": "Iraq", "code": "IQ" }, { "name": "Ireland", "code": "IE" }, { "name": "Isle of Man", "code": "IM" }, { "name": "Israel", "code": "IL" }, { "name": "Italy", "code": "IT" }, { "name": "Jamaica", "code": "JM" }, { "name": "Japan", "code": "JP" }, { "name": "Jersey", "code": "JE" }, { "name": "Jordan", "code": "JO" }, { "name": "Kazakhstan", "code": "KZ" }, { "name": "Kenya", "code": "KE" }, { "name": "Kiribati", "code": "KI" }, { "name": "South Korea", "code": "KP" }, { "name": "North Korea", "code": "KR" }, { "name": "Kuwait", "code": "KW" }, { "name": "Kyrgyzstan", "code": "KG" }, { "name": "Laos", "code": "LA" }, { "name": "Latvia", "code": "LV" }, { "name": "Lebanon", "code": "LB" }, { "name": "Lesotho", "code": "LS" }, { "name": "Liberia", "code": "LR" }, { "name": "Libya", "code": "LY" }, { "name": "Liechtenstein", "code": "LI" }, { "name": "Lithuania", "code": "LT" }, { "name": "Luxembourg", "code": "LU" }, { "name": "Macao", "code": "MO" }, { "name": "Macedonia", "code": "MK" }, { "name": "Madagascar", "code": "MG" }, { "name": "Malawi", "code": "MW" }, { "name": "Malaysia", "code": "MY" }, { "name": "Maldives", "code": "MV" }, { "name": "Mali", "code": "ML" }, { "name": "Malta", "code": "MT" }, { "name": "Marshall Islands", "code": "MH" }, { "name": "Martinique", "code": "MQ" }, { "name": "Mauritania", "code": "MR" }, { "name": "Mauritius", "code": "MU" }, { "name": "Mayotte", "code": "YT" }, { "name": "Mexico", "code": "MX" }, { "name": "Micronesia", "code": "FM" }, { "name": "Moldova", "code": "MD" }, { "name": "Monaco", "code": "MC" }, { "name": "Mongolia", "code": "MN" }, { "name": "Montenegro", "code": "ME" }, { "name": "Montserrat", "code": "MS" }, { "name": "Morocco", "code": "MA" }, { "name": "Mozambique", "code": "MZ" }, { "name": "Myanmar", "code": "MM" }, { "name": "Namibia", "code": "NA" }, { "name": "Nauru", "code": "NR" }, { "name": "Nepal", "code": "NP" }, { "name": "Netherlands", "code": "NL" },
      //{"name": "Netherlands Antilles", "code": "AN"},
      { "name": "New Caledonia", "code": "NC" }, { "name": "New Zealand", "code": "NZ" }, { "name": "Nicaragua", "code": "NI" }, { "name": "Niger", "code": "NE" }, { "name": "Nigeria", "code": "NG" }, { "name": "Niue", "code": "NU" }, { "name": "Norfolk Island", "code": "NF" }, { "name": "Northern Mariana Islands", "code": "MP" }, { "name": "Norway", "code": "NO" }, { "name": "Oman", "code": "OM" }, { "name": "Pakistan", "code": "PK" }, { "name": "Palau", "code": "PW" }, { "name": "Palestinian Territory", "code": "PS" }, { "name": "Panama", "code": "PA" }, { "name": "Papua New Guinea", "code": "PG" }, { "name": "Paraguay", "code": "PY" }, { "name": "Peru", "code": "PE" }, { "name": "Philippines", "code": "PH" }, { "name": "Pitcairn Islands", "code": "PN" }, { "name": "Poland", "code": "PL" }, { "name": "Portugal", "code": "PT" }, { "name": "Puerto Rico", "code": "PR" }, { "name": "Qatar", "code": "QA" }, { "name": "Reunion", "code": "RE" }, { "name": "Romania", "code": "RO" }, { "name": "Russia", "code": "RU" }, { "name": "RWANDA", "code": "RW" }, { "name": "Saint Helena", "code": "SH" }, { "name": "Saint Kitts and Nevis", "code": "KN" }, { "name": "Saint Lucia", "code": "LC" }, { "name": "Saint Pierre and Miquelon", "code": "PM" }, { "name": "Saint Vincent and the Grenadines", "code": "VC" }, { "name": "Samoa", "code": "WS" }, { "name": "San Marino", "code": "SM" }, { "name": "Sao Tome and Principe", "code": "ST" }, { "name": "Saudi Arabia", "code": "SA" }, { "name": "Senegal", "code": "SN" }, { "name": "Serbia", "code": "RS" }, { "name": "Seychelles", "code": "SC" }, { "name": "Sierra Leone", "code": "SL" }, { "name": "Singapore", "code": "SG" }, { "name": "Slovakia", "code": "SK" }, { "name": "Slovenia", "code": "SI" }, { "name": "Solomon Islands", "code": "SB" }, { "name": "Somalia", "code": "SO" }, { "name": "South Africa", "code": "ZA" }, { "name": "South Georgia and the South Sandwich Islands", "code": "GS" }, { "name": "Spain", "code": "ES" }, { "name": "Sri Lanka", "code": "LK" }, { "name": "Sudan", "code": "SD" }, { "name": "Suriname", "code": "SR" }, { "name": "Svalbard and Jan Mayen", "code": "SJ" }, { "name": "Swaziland", "code": "SZ" }, { "name": "Sweden", "code": "SE" }, { "name": "Switzerland", "code": "CH" }, { "name": "Syria", "code": "SY" }, { "name": "Taiwan", "code": "TW" }, { "name": "Tajikistan", "code": "TJ" }, { "name": "Tanzania", "code": "TZ" }, { "name": "Thailand", "code": "TH" }, { "name": "East Timor", "code": "TL" }, { "name": "Togo", "code": "TG" }, { "name": "Tokelau", "code": "TK" }, { "name": "Tonga", "code": "TO" }, { "name": "Trinidad and Tobago", "code": "TT" }, { "name": "Tunisia", "code": "TN" }, { "name": "Turkey", "code": "TR" }, { "name": "Turkmenistan", "code": "TM" }, { "name": "Turks and Caicos Islands", "code": "TC" }, { "name": "Tuvalu", "code": "TV" }, { "name": "Uganda", "code": "UG" }, { "name": "Ukraine", "code": "UA" }, { "name": "United Arab Emirates", "code": "AE" }, { "name": "United Kingdom", "code": "GB" }, { "name": "United States of America", "code": "US" },
      //{"name": "United States Minor Outlying Islands", "code": "UM"},
      { "name": "Uruguay", "code": "UY" }, { "name": "Uzbekistan", "code": "UZ" }, { "name": "Vanuatu", "code": "VU" }, { "name": "Venezuela", "code": "VE" }, { "name": "VietNam", "code": "VN" }, { "name": "Virgin Islands British", "code": "VG" }, { "name": "Virgin Islands US", "code": "VI" }, { "name": "Wallis and Futuna", "code": "WF" }, { "name": "Western Sahara", "code": "EH" }, { "name": "Yemen", "code": "YE" }, { "name": "Zambia", "code": "ZM" }, { "name": "Zimbabwe", "code": "ZW" }];

      scope.countries_list_filtered = scope.countries_list;
    }
  };
});
'use strict';

angular.module('mtic.components.login').directive('sessionExpiryModal', function (EventManager, $location, $log, userAccount, $timeout) {
      return {
            template:'<div ng-if="isOpen" id="expiryModal" class="modal fade" role="dialog" ng-style="{\'display\' : currentDisplay()}" style="z-index:1000;background: rgba(165, 142, 142, 0.75);"><div class="modal-dialog"><div class="modal-content modal-md" style="width:820px !important; height:640px;display:flex;flex-direction:column"><div class="modal-header"><h2>Session Expired</h2></div><div class="modal-body" style="min-height: 300px !important"><signin username="username" keep-moving="doNotStayOnMainPage" from-session-expiry="true"></signin></div><div class="modal-footer" style="text-align: center;position:absolute;bottom:5px;align-self:center"><button type="button" class="button" ng-click="close()">Close</button></div></div></div></div>',
            restrict: 'E',
            scope: {},
            link: function link(scope) {
                  var eventManager = new EventManager('sessionExpiryModal', scope);
                  scope.isOpen = false;
                  window.session_out = function () {
                        scope.isOpen = true;
                        scope.$digest();
                  };
                  eventManager.listen('login:session:expired', function (message) {
                        window.focus();
                        scope.isOpen = true;
                        scope.username = userAccount.getData().uuid;
                        if (message) {
                              scope.doNotStayOnMainPage = true;
                        }
                  });
                  eventManager.listen('session-expiry:close', function () {
                        scope.isOpen = false;
                        scope.doNotStayOnMainPage = false;
                  });
                  eventManager.listen('login:first', function (message) {
                        scope.isOpen = false;
                        scope.doNotStayOnMainPage = false;
                  });

                  scope.close = function () {
                        scope.isOpen = false;
                        eventManager.broadcast('logout');
                  };
                  scope.currentDisplay = function () {
                        return scope.isOpen ? 'flex' : 'none';
                  };
            }
      };
});
'use strict';

angular.module('mtic.components.login').component('mticPostIamRegistration', {

  template:'<div ng-show="!user.isStudent" class="columns container" style="margin-top: 10px;width:100%"><div style="margin:auto;" ng-class="{card : !user.isTeacher}"><header class="card-header"><span class="card-header-title" ng-show="user.isTesting"><b>Vretta</b>:<language-span lang-id="8168"></language-span></span> <span ng-if="!user.isTeacher" class="card-header-title" ng-hide="user.isTesting"><language-span lang-id="8168"></language-span></span></header><div class="card-content" ng-if="!user.flags.loading"><span ng-if="!user.isTeacher" class="tag is-info"><b style="margin-right: 10px;">{{text.IAMEMAIL}}</b> {{user.info.iamUser}}</span><br><span ng-if="!user.isTeacher" style="margin-left: 4px;" ng-bind="user.welcomeText()"></span><br><div class="content" ng-if="!user.flags.error"><mtic-post-iam-registration-school ng-if="user.isTeacher" countries="user.countries" selections="user.selections"></mtic-post-iam-registration-school><div ng-if="user.isStudent"><button class="button" ng-click="user.autoRegisterStudentLuxembourg()">Register Student</button></div></div><div class="content" ng-if="user.flags.error"><language-span lang-id="8152" class="notification is-danger"></language-span></div><button class="button" ng-disabled="!user.groupSelected" ng-click="user.register()" style="cursor:pointer;color:#fff;margin:auto;display: block;border:none;border-radius: 5px" ng-style="{\'background-color\':user.groupSelected?\'#1fca6a\':\'#000\',\'opacity\':user.groupSelected?\'1\':\'0.1\'}">{{text.CONTINUE}}</button></div><footer ng-if="!user.isTeacher" class="card-footer"><a ng-click="logout()"><language-span lang-id="8173"></language-span></a></footer></div></div><div ng-if="user.isTesting" class="notification is-warning" role="alert">You are using a Vretta Testing account!</div>',

  bindings: {
    roleType: '<',
    profile: '<'
  },

  controllerAs: 'user',

  controller: function controller($scope, $log, language, EventManager, userAccount, MticAlertModalService, LOGIN_CONSTANTS, api, LocaleService) {

    // this
    var user = this;

    // event manager
    var eventManager = new EventManager('mticFinalization', $scope);

    // model

    // todo: replace with translation manager
    var text = $scope.text = {
      WELCOME: 'Welcome {{firstName}} {{lastName}}, please proceed to choose your school below.',
      TITLE: 'Microsoft Login',
      INVALIDACCOUNT: 'Invalid Account Type!',
      SCHOOL: 'School',
      COUNTRY: 'Country',
      CONTINUE: 'Continue',
      IAMEMAIL: 'IAM Email'
    };

    var NOSCHOOL_GROUP_ID_LUXEMBOURG = 1916;

    $scope.language = language;
    $scope.logout = userAccount.logout;

    user.flags = {
      loading: true,
      error: null,
      reset: function reset() {
        user.flags.loading = true;
        user.flags.error = null;
      },
      done: function done(error) {
        user.flags.loading = false;
        if (error) {
          user.flags.error = error;
        }

        if (user.isStudent) {
          user.autoRegisterStudentLuxembourg();
        }
      }
    };

    user.selections = {
      selectSchool: function selectSchool(school) {
        user.info.school = school;
        user.groupSelected = true;
      },
      selectModule: function selectModule(classroom) {
        user.info.class = classroom;
        user.groupSelected = true;
      }
    };

    user.welcomeText = function () {
      var msg = text.WELCOME.replace('{{firstName}}', user.info.firstName);
      msg = msg.replace('{{lastName}}', user.info.lastName);
      return msg;
    };

    user.autoRegisterStudentLuxembourg = function () {
      api.getNoSchoolClasses(NOSCHOOL_GROUP_ID_LUXEMBOURG).then(function (classes) {
        var groupIds = _.map(classes, function (t) {
          return t.id;
        });
        return api.signUpStudentThroughNoSchoolAll({
          group_ids: groupIds,
          user_name: user.info.iamUser,
          password: user.info.iam,
          first_name: user.info.firstName,
          last_name: user.info.lastName,
          email: user.info.iamUser,
          auth_type: 'microsoftStrategy',
          class_data: user.info.class_data
        });
      }).then(function () {
        LocaleService.setCurrentLocale('LUXEMBOURG');
        api.login({
          uuid: user.info.iamUser,
          password: user.info.iam,
          auth_type: 'microsoftStrategy'
        });
      });
    };

    user.register = function () {
      if (LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER === user.roleType || LOGIN_CONSTANTS.ACCOUNT_TYPES.VRETTA === user.roleType) {
        return api.signUpTeacherThroughGroup({
          group_id: user.info.school.id,
          user_name: user.info.iamUser,
          password: user.info.iam,
          first_name: user.info.firstName,
          last_name: user.info.lastName,
          email: user.info.iamUser,
          auth_type: 'microsoftStrategy',
          class_data: user.info.class_data
        }).then(function () {
          LocaleService.setCurrentLocale('LUXEMBOURG');
          api.login({
            uuid: user.info.iamUser,
            password: user.info.iam,
            auth_type: 'microsoftStrategy'
          });
        });
      } else if (LOGIN_CONSTANTS.ACCOUNT_TYPES.STUDENT === user.roleType) {
        $log.error('Student path has been divereted from this logic');
      } else {
        MticAlertModalService.set(text.INVALIDACCOUNT, {
          title: text.TITLE,
          callback: function callback() {
            userAccount.logout();
          }
        });
      }
    };

    var setInfo = function setInfo() {

      var msfUser = user.profile;

      user.info = {
        firstName: msfUser.first_name || msfUser.name.split(' ').slice(1).join(' '),
        lastName: msfUser.last_name || msfUser.name.split(' ')[0],
        iam: msfUser.oid,
        iamUser: msfUser.unique_name,
        class_data: msfUser.class_data
      };

      $log.log('msfUser : ', msfUser, user.info);

      user.isTesting = user.roleType === LOGIN_CONSTANTS.ACCOUNT_TYPES.VRETTA;

      user.isStudent = LOGIN_CONSTANTS.ACCOUNT_TYPES.STUDENT === user.roleType;

      user.isTeacher = LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER === user.roleType;
    };

    user.$onInit = function () {

      user.flags.reset();

      setInfo();

      api.getCountries(user.isStudent).then(function (countries) {
        user.countries = countries;
        user.flags.done();
      }).catch(function (err) {
        $log.error(err);
        user.flags.done(err.message);
      });
    };

    this.$onChanges = function () {
      setInfo();
    };
  }
});
'use strict';

angular.module('mtic.components.login').constant('IAM_CODES', {
  LANG: {
    'TEACHER': 8165,
    'STUDENT': 8166,
    'RETURNING': 8171
  }
});
'use strict';

angular.module('mtic.components.login').component('mticFinalization', {

  template:'<div class="columns container" style="margin-top: 10px;"><div class="column is-4 is-offset-4 card"><header class="card-header"><span class="card-header-title" ng-show="user.flow.isTesting"><b>Vretta</b>: {{language.get(\'8168\')}} / {{language.get(user.flow.accountType)}} / <span ng-if="user.flow[\'returningType\']" ng-bind="language.get(user.flow.returningType)"></span></span> <span class="card-header-title" ng-hide="user.flow.isTesting"><language-span lang-id="8168"></language-span>/ {{user.flow.summary}}</span></header><div class="card-content"><div class="content"><mtic-finalization-account-setup ng-if="user.flow.accountSelected" flow="user.flow" profile="user.profile"></mtic-finalization-account-setup><mtic-finalization-account-returning ng-if="user.flow.accountSelected" flow="user.flow"></mtic-finalization-account-returning></div></div><footer class="card-footer"><a ng-click="logout()"><language-span lang-id="8173"></language-span></a></footer></div><mtic-finalization-account-registration class="column is-4" ng-if="user.flow.returningSelected" flow="user.flow" info="user.info" profile="user.profile"></mtic-finalization-account-registration></div><div ng-if="user.flow.isTesting" class="notification is-warning" role="alert">You are using a Vretta Testing account!</div>',

  bindings: {
    roleType: '<',
    profile: '<'
  },

  controllerAs: 'user',

  controller: function controller($scope, $log, language, EventManager, userAccount, IAM_CODES, LOGIN_CONSTANTS) {

    // this
    var user = this;

    // event manager
    var eventManager = new EventManager('mticFinalization', $scope);

    // model
    $scope.language = language;
    $scope.logout = userAccount.logout;

    var setInfo = function setInfo() {
      setFlow();
      var userRoleType = user.roleType;
      var msfUser = user.profile;
      user.info = {
        firstName: msfUser.name.split(' ')[0],
        lastName: msfUser.name.split(' ').slice(1).join(' '),
        username: msfUser.unique_name,
        password: Math.random().toString(36).substr(3, 10),
        iam: msfUser.oid,
        iamUser: msfUser.unique_name
      };
      user.showOptions = true;
      if (userRoleType === LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER) {
        user.flow.setType(IAM_CODES.LANG.TEACHER, 'account');
        user.flow.isTesting = false;
      } else if (userRoleType === LOGIN_CONSTANTS.ACCOUNT_TYPES.STUDENT) {
        user.flow.setType(IAM_CODES.LANG.STUDENT, 'account');
        user.flow.isTesting = false;
      } else {
        user.flow.setType(IAM_CODES.LANG.TEACHER, 'account');
        user.flow.isTesting = true;
      }
      user.flow.setType(IAM_CODES.LANG.RETURNING, 'returning');
    };

    var setFlow = function setFlow() {
      if (!user.flow) {
        user.flow = {
          summary: '',
          accountType: '',
          accountSelected: false,
          returningType: '',
          returningSelected: false,
          isTesting: true,
          setType: function setType(type, which) {
            user.flow[which + 'Type'] = type;
            user.flow[which + 'Selected'] = true;
            user.flow.setSummary();
          },
          setSummary: function setSummary() {
            if (user.flow.accountSelected) {
              user.flow.summary = ' ' + language.get(user.flow.accountType);
            }
            if (user.flow.returningSelected) {
              user.flow.summary += ' / ' + language.get(user.flow.returningType);
            }
          },
          setupBoxClass: function setupBoxClass() {
            if (user.flow.accountSelected && user.flow.returningSelected) {
              return 'col-lg-5 col-md-6 col-sm-6 col-xs-6';
            } else {
              return 'col-md-6 col-md-offset-3';
            }
          }
        };
      }
    };

    user.$onInit = function () {
      setInfo();
    };

    this.$onChanges = function () {
      setInfo();
    };
  }
});
'use strict';

angular.module('mtic.components.login').directive('loginReturnModal', function (EventManager, LoginCookie, api) {
      var eventManager = new EventManager('loginReturnModal');

      eventManager.listen('login:session:restore', function () {
            window.focus();
            var accounts = LoginCookie.getSessionLoginTokens();
            if (accounts.length > 0) {
                  var lastAccount = accounts.pop();
                  if (lastAccount) {
                        logBackIn(lastAccount);
                  }
            }
      });

      var logBackIn = function logBackIn(account) {
            eventManager.broadcast('logging-in');
            LoginCookie.clearSessions();
            api.loginRestore(account.username, account.userid, account.sessionkey, account.firebaseToken).then(function () {
                  eventManager.broadcast('done-login-attempt');
            }).catch(function () {
                  eventManager.broadcast('done-login-attempt');
            });
            if (account.role === 'mtic_student' && account.lastItem && account.lastItem) {
                  eventManager.listen('creating-items-done', function () {
                        eventManager.broadcast('module:select:resource', { slug: account.lastItem, dontSelect: true, centerOnItem: true, highlightItem: true });
                  });
            }
      };

      return {
            template:'<div ng-if="isOpen" id="expiryModal" class="modal fade" role="dialog" ng-style="{\'display\' : currentDisplay()}" style="background: rgba(165, 142, 142, 0.75);"><div class="modal-dialog" style="margin-top: 250px;" ng-click="close()"><div class="modal-content modal-sm"><div class="modal-header"><h2>Login</h2></div><div class="modal-body"><div class="box darken-on-hover" ng-repeat="account in accounts"><article class="media" ng-click="logBackIn(account)"><div class="media-content"><div class="content" style="text-align: center;"><img src="assets/images/logos/avatar_85x85.png" alt="Image"><p><strong ng-bind="account.displayname"></strong> <small ng-bind="account.username"></small></p></div></div></article></div></div></div></div></div>',
            restrict: 'E',
            scope: {},
            link: function link(scope) {
                  scope.isOpen = false;
                  scope.accounts = [];
                  scope.close = function () {
                        scope.isOpen = false;
                  };
                  scope.currentDisplay = function () {
                        return scope.isOpen ? 'block' : 'none';
                  };
            }
      };
});
'use strict';

angular.module('mtic.components.dashboards.badbrowser', []);

angular.module('mtic.components.dashboards.badbrowser').directive('dashboardBadBrowser', function ($timeout) {
  return {
    template:'<div style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; display: flex; align-items: center; justify-content: center; padding-bottom:180px;"><div style="width:480px; max-width: 80%; font-size: 20px; text-align:center;"><div style="margin-bottom:18px;"><img src="assets/images/logos/login_mathemaTIC_logo.png"></div><div ng-show="!compatibleBrowser">This website is optimized for <b>modern browsers</b><br>such as <a href="https://www.google.ca/chrome/browser/desktop" target="_blank">Google Chrome</a>.<div style="margin-top:18px; line-height:100%;"><small>Please click on the links above and follow installation the instructions in order to upgrade to a compatible browser.</small></div></div><div ng-show="compatibleBrowser"><div ng-show="!compatibleDevice">This website is optimized for laptop and desktop computers with a modern web browsers. It has been disabled for mobile phones and most tablets.</div><div ng-show="compatibleDevice">You are using a compatible device and browser and should not be seeing this message. Please <a href="mailto:mathematic@vretta.com">contact support</a>.</div></div></div></div>',
    scope: {},
    link: function link(scope) {

      scope.compatibleBrowser = true;
      scope.compatibleDevice = true;

      if (bowser.name !== 'Chrome') {
        scope.compatibleBrowser = false;
      }
      if (bowser.mobile || bowser.tablet) {
        scope.compatibleDevice = false;
      }

      scope.closeClicked = function () {
        $timeout(function () {
          scope.hideNag = true;
          $timeout(function () {
            scope.hideNag = false;
          }, 120000);
        });
      };
    }
  };
});
'use strict';

angular.module('mtic.components.user_box', []);

angular.module('mtic.components.user_box').component('userBox', {
  template:'<div class="box"><article class="media"><div class="media-left"><figure class="image"><img src="assets/images/navbar/avatar.png" alt="Image"></figure></div><div class="media-content"><div class="content"><p><strong ng-bind="info.user.full_name"></strong> <small ng-bind="info.user.user_name"></small><br></p><p><span>Class:</span> <span ng-bind="info.user.classroom.name"></span> (<span ng-bind="info.user.classroom.id"></span>)<br><span>Module:</span> <span ng-bind="info.user.getModuleName()"></span></p></div></div></article></div>',
  bindings: {
    user: '<'
  },
  controllerAs: 'info',
  controller: function controller() {}
});
'use strict';

angular.module('mtic.components.translation', []);

angular.module('mtic.components.translation').component('languageSpan', {
  template: '<span class="{{$ctrl.class}}" ng-bind="$ctrl.getText()"></span>',
  bindings: {
    class: '@',
    langId: '@'
  },
  controller: function controller(language) {
    this.getText = function () {
      return language.get(isNaN(this.langId) ? this.langId : Number(this.langId));
    };
  }
});
'use strict';

/*global Flatpickr*/
angular.module('mtic.components.timePicker', []).directive('flatTimePicker', function ($log) {
    return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
            options: '='
        },
        link: function link(scope, element, attrs, ngModel) {
            var timePicker;
            var init = function init() {
                var options = _.extend({
                    // mode: 'range',
                    dateFormat: 'Y-m-d',
                    defaultDate:
                    // [
                    // moment().format('YYYY-MM-DD'),
                    moment().add(7, 'days').format('YYYY-MM-DD'),
                    // ],
                    enableTime: false
                }, scope.options || {});
                timePicker = new Flatpickr(element[0], options);
            };
            element.on('$destroy', function () {
                if (timePicker) {
                    timePicker.destroy();
                    timePicker = null;
                }
            });
            init();
            scope.$watch('options', function (val) {
                if (val) {
                    init();
                }
            });
        }
    };
});
'use strict';

angular.module('mtic.components.select_box', []).directive('selectBox', function ($log, EventManager, $timeout, TeacherDataService, PlatformService) {
  return {
    template:'<div class="selectBox__selected" ng-click="ipadToggleCheck()" ng-mousedown="show_options()" ng-touchstart="show_options()"><span ng-bind="fillerText" ng-if="!model" style="color:#999;"></span> <span ng-bind="display(model)" ng-if="model"></span> <i class="fa fa-angle-down selectBox__icon" aria-hidden="true"></i></div><div class="selectBox__options" ng-show="selection_clicked" ng-style="{\'min-width\':!noWidth?\'100%\':\'\'}"><div ng-mouseover="hoverActive=true" ng-mouseleave="hoverActive=false" ng-if="fillerText" ng-click="clear_option()" ng-bind="fillerText" class="selectBox__optionFiller" style="color:#999;padding:0px 5px;" ng-style="{ \'cursor\':clickableFiller?\'pointer\':\'\', \'background-color\':clickableFiller && hoverActive? \'#3398DB\':\'\', \'color\':clickableFiller && hoverActive?\'#fff\':\'#999\' }"></div><div class="selectBox__option" ng-repeat="option in options" ng-bind="display(option)" ng-click="set_option(option)" ng-mouseover="hoverActive=true" ng-mouseleave="hoverActive=false" ng-class="{\'selected\': (model === option)}" ng-style="hoverActive ? {\'background-color\': \'#3398DB\', \'color\':\'#fff\'} : {}"></div></div>',
    scope: {
      options: '=',
      model: '=',
      fillerText: '=?',
      displayFunction: '=?',
      onChange: '=?',
      noWidth: '=?',
      clickableFiller: '=?',
      isViewSwitch: '=?',
      showToggle: '=?'
    },
    link: function link(scope, $el) {
      var eventManager = new EventManager('selectBox');
      scope.selection_clicked = false;
      var clicked = false;

      scope.ipadToggleCheck = function () {
        if (PlatformService.isIos) {
          if (scope.selection_clicked) {
            hide_options();
          } else {
            scope.show_options();
          }
        }
      };

      scope.show_options = function () {
        if (!scope.selection_clicked) {
          clicked = true;
        }
        scope.selection_clicked = true;
        document.addEventListener('pointerdown', hide_options_proxy);
        document.addEventListener("mousedown", hide_options_proxy);
        document.addEventListener('touchstart', hide_options_proxy); // for iOS safari
        $timeout(function () {
          clicked = false;
        }, 50);
      };

      function hide_options() {
        if (clicked) {
          return;
        }
        $timeout(function () {
          scope.selection_clicked = false;
          document.removeEventListener('pointerdown', hide_options_proxy);
          document.removeEventListener("mousedown", hide_options_proxy);
          document.removeEventListener('touchstart', hide_options_proxy); // for iOS safari
        }, 200);
      }

      function hide_options_proxy(e) {
        scope.$apply(function () {
          if (!$el[0].querySelector('.selectBox__options').contains(e.srcElement)) {
            hide_options();
          }
        });
      }

      scope.set_option = function (option, dont_stop) {
        hide_options();
        if (scope.isViewSwitch && TeacherDataService.inTeacherAgendaView && !dont_stop) {
          eventManager.broadcast('request_agenda_change', { class_change: true, class_id: option });
          return;
        }
        scope.model = option;
      };

      eventManager.listen('agenda_class_change_request_granted', function (e, args) {
        scope.set_option(args, true);
      });

      scope.clear_option = function () {
        if (scope.clickableFiller) {
          scope.set_option();
        }
      };

      scope.display = function (option) {
        if (scope.displayFunction && option) {
          if (typeof scope.displayFunction === 'string') {
            return option[scope.displayFunction];
          } else {
            return scope.displayFunction(option);
          }
        } else {
          return option;
        }
      };

      if (scope.onChange) {
        scope.$watch('model', function (val) {
          //$log.log('model', scope.model)
          scope.onChange(val);
        });
      }
    }
  };
});
'use strict';

angular.module('mtic.components.mtic_resource', ['ngAnimate']).directive('mticResource', function ($log, api, $timeout, language, EventManager, ASSET_HOST, LearningEnvironmentService, ComponentIframeCom, MapStateService) {
  return {
    template:'<div class="mtic-resource-loader-container fade" ng-show="notLoaded"><div class="mtic-resource-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div><div ng-show="showUrl" class="mtic-resource-url-bar"><input class="input is-primary" type="text" ng-value="resource.hostUrl" disabled></div><div style="z-index: 0;-moz-user-select: -moz-none; -khtml-user-select: none;-webkit-user-select: none;-ms-user-select: none;user-select: none;"><div ng-if="questionaire.isShown" class="overlay"><div style="text-align: center;"><div class="promptBox2" ng-if="!questionaire.feedbackGiven"><div style="color: #fff; margin-bottom:16px;"><div style="font-size:28px; font-weight:bold;">{{language.get(\'11285\')}}</div><div style="font-size:16px;">{{language.get(\'click_a_face\')}}</div></div><div><div class="character-choice" ng-click="questionaire.getItemFeedback(1)"><img src="https://s3.eu-central-1.amazonaws.com/mtic-items/website/1-vhard.png"></div><div class="character-choice" ng-click="questionaire.getItemFeedback(2)"><img src="https://s3.eu-central-1.amazonaws.com/mtic-items/website/2-hard.png"></div><div class="character-choice" ng-click="questionaire.getItemFeedback(3)"><img src="https://s3.eu-central-1.amazonaws.com/mtic-items/website/4-ok.png"></div><div class="character-choice" ng-click="questionaire.getItemFeedback(4)"><img src="https://s3.eu-central-1.amazonaws.com/mtic-items/website/5-easy.png"></div></div></div><div ng-show="questionaire.feedbackGiven" class="lesson-complete-screen" style="display:flex;flex-direction:column"><div class="summary-container"><div style="position:relative; margin-top:240px;"><div class="ribbon"><div ng-switch="ribbonType"><div ng-switch-when="a"><img ng-src="{{getImageUrlBySlug(\'ribbon-a\')}}"></div><div ng-switch-when="b"><img ng-src="{{getImageUrlBySlug(\'ribbon-b\')}}"></div><div ng-switch-when="c"><img ng-src="{{getImageUrlBySlug(\'ribbon-c\')}}"></div></div><div class="ribbon-label"><div ng-bind="language.get(\'11290\')" style="max-width: 330px; line-height: 100%;"></div></div></div><div class="lesson-title-row" style="display:flex;flex-direction:column;align-items:center"><div class="lesson-title"><span ng-bind="getCurrentResourceName()"></span></div><img ng-show="show_medal" class="star" src="assets/images/c4-meta/medal.png"></div><div style="position:absolute; top:0px; left:50%;"><div ng-switch="starsFormat"><div ng-switch-when="stars-3"><div class="star-container" style="left:-110px; top:-60px; transform:rotate(-21deg);"><img class="star" ng-src="{{getImageUrlBySlug(\'star-empty\')}}"><div ng-show="starsShown >= 1" class="star-anim-container mtic-resource-star-1-of-3"><img class="star" ng-src="{{getImageUrlBySlug(\'star\')}}"></div></div><div class="star-container" style="left:0px; top:-100px; transform:rotate(0deg);"><img class="star" ng-src="{{getImageUrlBySlug(\'star-empty\')}}"><div ng-show="starsShown >= 2" class="star-anim-container mtic-resource-star-2-of-3"><img class="star" ng-src="{{getImageUrlBySlug(\'star\')}}"></div></div><div class="star-container" style="left:110px; top:-60px; transform:rotate(21deg);"><img class="star" ng-src="{{getImageUrlBySlug(\'star-empty\')}}"><div ng-show="starsShown >= 3" class="star-anim-container mtic-resource-star-3-of-3"><img class="star" ng-src="{{getImageUrlBySlug(\'star\')}}"></div></div></div><div ng-switch-when="stars-1"><div class="star-container" style="left:0px; top:-100px; transform:rotate(0deg);"><img class="star" ng-src="{{getImageUrlBySlug(\'star-empty\')}}"><div ng-show="starsShown >= 1" class="star-anim-container mtic-resource-star-single"><img class="star" ng-src="{{getImageUrlBySlug(\'star\')}}"></div></div></div></div></div></div></div><div style="display:flex;justify-content: center;align-items: center;margin-top:80px"><div class="action-btn-container" style="position:relative !important;" ng-hide="resource.resource_type === \'assessment\'"><button class="button action-btn is-replay" ng-click="replayItem()" ng-disabled="resource.notification_slug"><img class="action-btn-icon" ng-src="{{getImageUrlBySlug(\'replay-icon\')}}"> <span class="action-btn-label" ng-bind="language.get(\'11287\')"></span></button></div><div class="action-btn-container" style="position:relative !important;"><button class="button action-btn" ng-class="!resource.notification_slug && (!next_item || (next_item.locked && currentScore === 0)) ? \'is-continue\' : \'is-replay\'" ng-click="unloadItem()" ng-disabled="resource.notification_slug"><img class="action-btn-icon" src="assets/images/navbar/map_icon.png"> <span class="action-btn-label" ng-bind="language.get(\'show_map\')"></span></button></div><div class="action-btn-container" style="position:relative !important;"><button class="button action-btn is-continue" ng-hide="!resource.notification_slug && (!next_item || (next_item.locked && currentScore === 0))" ng-click="loadNextItem()"><img class="action-btn-icon" src="assets/images/c4-meta/continue-icon.png"> <span class="action-btn-label" ng-bind="language.get(\'11288\')"></span></button> <button class="button action-btn is-continue is-replay" ng-show="!resource.notification_slug && (!next_item || (next_item.locked && currentScore === 0))" ng-click="loadNextItem()" ng-disabled="true"><img class="action-btn-icon" src="assets/images/c4-meta/continue-icon-disabled.png"> <span class="action-btn-label" ng-bind="language.get(\'11288\')"></span></button></div></div></div></div></div><div id="lesson-container" ng-style="{\'opacity\': notLoaded ? 0 : 1}"><div ng-if="isCustomResource()" class="placeholder-pane" style="text-align: center;"><span style="font-size: 2em;"><i class="fa fa-external-link" aria-hidden="true"></i><language-span lang-id="link_in_another_window">link_in_another_window</language-span><a ng-click="unloadItem()"><i class="fa fa-window-close" aria-hidden="true"></i></a></span><br><language-span style="font-size: 1em;" lang-id="do_not_see_text">do_not_see_text</language-span></div></div><div ng-if="student_test_complete" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: absolute;overflow:auto"><div class="mticCard" style="width:260px !important; margin-bottom:100px"><div class="mticCard__header"></div><div class="mticCard__body" style="padding : 20px; text-align: center;"><button class="button is-success" ng-click="unload_student_questionaire(true)" ng-bind="language.get(\'11288\')">Continue</button></div></div></div><div ng-if="teacher_test_complete" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: absolute;overflow:auto"><div class="mticCard" style="width:660px !important; margin-bottom:100px"><div class="mticCard__header"><span class="mticCard__headerText"></span> <span class="mticCard__close" ng-click="unload_student_questionaire()">&#10006;</span></div><div class="mticCard__body" style="padding : 20px; text-align: center;"><p class="mticCard__paragraph">Merci de votre participation à ce questionnaire.</p><p class="mticCard__paragraph">Vos réponses sont maintenant enregistrées !</p></div><div class="mticCard__outerLink" ng-click="unload_student_questionaire()" style="position: absolute; top: 100%; width: 100%; transform: translateY(20%); background-color: #3398db; color: #fff; padding: 12px 24px; font-size: 16px; font-weight: 600; cursor: pointer;"><span ng-bind="language.get(\'14783\')">Go back to Mathematic</span> <i class="fa fa-chevron-circle-left" aria-hidden="true" style="float: left; font-size: 24px; font-weight: bold; margin-right: 12px; margin-left: -12px;"></i></div></div></div></div>',
    restrict: 'E',
    scope: {
      resource: '=',
      moduleId: '=?',
      classId: '=?',
      windowId: '@',
      scrollFrame: '@?'
    },
    link: function link(scope, element, attr) {
      // Set Managers
      //console.log('from mtic resource ! ')
      var eventManager = new EventManager('mticResource', scope);
      scope.scrollFrame = scope.scrollFrame || 'no';

      $log.log('MTIC RESOURCE : ', scope.resource);

      eventManager.broadcast('request-next-item', scope.resource.slug);
      $timeout(function () {
        scope.next_item = MapStateService.getNextAvailableItem();
      }, 500);

      var componentIframeCom = new ComponentIframeCom('mticResource', scope, {
        containerId: 'lesson-container',
        windowId: scope.windowId,
        scrolling: scope.scrollFrame
      });

      // Scope Vars
      scope.currentScore = 0;
      scope.showUrl = false;
      scope.language = language;
      scope.notLoaded = true;
      scope.questionaire = {
        isShown: false,
        feedbackGiven: false,
        givingFeedback: false,
        getItemFeedback: function getItemFeedback(feedback) {
          if (this.info && !this.givingFeedback) {
            this.givingFeedback = true;
            api.submitItemEndQuestionaire(scope.resource.id, {
              feedback: feedback,
              miscData: scope.questionaire.info
            }).then(function () {
              eventManager.broadcast('resource:feedback:given');
            }, function () {
              $log.error('Failed to give feedback!');
            });
          } else {
            $log.warn('scope.questionaire.info', scope.questionaire.info);
            throw "Missing questionaire.info to submit feedback!";
          }
        }
      };
      scope.replayItem = function () {
        scope.show_medal = false;
        scope.questionaire.isShown = false;
        eventManager.resetResourceSession();
        componentIframeCom.reloadUrl(scope.resource.slug, scope.resource.hostUrl, scope.resource.content, true);
      };
      scope.unloadItem = function () {
        scope.show_medal = false;
        eventManager.broadcast('module:close:resource');
        language.resetAvilableOptions();
      };
      scope.getImageUrlBySlug = function (slug) {
        return ASSET_HOST.IMAGE[slug];
      };

      var updateStarsDisplayConfig = function updateStarsDisplayConfig() {
        scope.starsFormat = 'stars-3';
        scope.ribbonType = 'b';
        scope.starsShown = 0;
        if (scope.resource && scope.resource.display) {
          var color = scope.resource.display.color;
          if (color === 'blue') {
            scope.ribbonType = 'a';
            scope.starsFormat = 'stars-1';
          }
          if (color === 'red') {
            scope.ribbonType = 'b';
            scope.starsFormat = 'stars-3';
          }
          if (color === 'black') {
            scope.ribbonType = 'c';
            scope.starsFormat = 'stars-3';
          }
          if (scope.resource.resource_type === 'assessment') {
            scope.starsFormat = 'assessment';
            scope.ribbonType = 'c';
          }
          /*
          if (!LearningEnvironmentService.givePostItemQuestionnaire(scope.moduleId) && )
          {
            scope.starsFormat = 'not-c3';
          }
          */
        } else if (scope.resource.resource_type === 'baseline') {
          scope.starsFormat = 'assessment';
          scope.ribbonType = 'c';
        }
        $timeout(animateStars, 20);
      };

      var getElementForStarAnimation = function getElementForStarAnimation(elementId) {
        var el = document.getElementById(elementId);
        el.style.opacity = 0;
        el.style.display = 'block';
        return el;
      };

      var animateStars = function animateStars() {
        // $log.log('animating stars', scope.starsFormat, scope.currentScore);
        var showAdditionalStar = function showAdditionalStar() {
          scope.starsShown++;
        };
        var score = scope.currentScore || 0;
        scope.starsShown = 0;
        if (scope.starsFormat === 'stars-1') {
          // $log.log('animating single star', scope.starsFormat, scope.currentScore);
          $timeout(showAdditionalStar, 500);
          return;
        }
        // $log.log('animating 3 stars', scope.starsFormat, scope.currentScore);
        var scoring_structure = [0.5, 0.8, 1];
        if (scope.resource.slug.indexOf('run_like_math') > -1) {
          scoring_structure = [0.25, 0.5, 0.75];
        }
        if (score >= scoring_structure[0]) {
          $timeout(showAdditionalStar, 500);
        }
        if (score >= scoring_structure[1]) {
          $timeout(showAdditionalStar, 800);
        }
        if (score >= scoring_structure[2]) {
          $timeout(showAdditionalStar, 1000);
        }
        if (scope.resource.slug.indexOf('run_like_math') > -1 && score === 1) {
          $timeout(function () {
            scope.show_medal = true;
          }, 1200);
        }
      };

      scope.getCurrentResourceName = function () {
        var resourceSlug = scope.resource.slug;
        var resourceName;
        if (resourceSlug === 'run_like_math' || resourceSlug.indexOf('run_like_math') === -1 || resourceSlug.indexOf('lv_') === -1) {
          resourceName = language.get(resourceSlug);
        } else {
          var splt = resourceSlug.split('_');
          var level = '';
          if (!isNaN(splt[splt.length - 1])) {
            level = splt[splt.length - 1];
          }
          var trans_slug = resourceSlug.replace('_' + level, '');
          resourceName = language.get(trans_slug) + ' ' + level;
        }

        if (!resourceName) {
          resourceName = resourceSlug;
        }
        return resourceName;
      };

      scope.loadNextItem = function () {
        if (scope.resource.notification_slug) {
          scope.unloadItem();
          return;
        }
        scope.next_item = MapStateService.getNextAvailableItem();
        $log.log('GOT NEXT ITEM : ', scope.next_item);
        if (!scope.next_item || scope.next_item.locked && scope.currentScore === 0) {
          return;
        }
        //eventManager.broadcast('module:close:resource');
        // $timeout(function(){
        //   
        // }, 100);

        scope.show_medal = false;
        eventManager.broadcast('module:open:resource', scope.next_item);
        scope.questionaire.isShown = false;
        eventManager.resetResourceSession();
        componentIframeCom.reloadUrl(scope.next_item.slug, scope.next_item.hostUrl, scope.next_item.content, true);
        scope.resource = scope.next_item;
        eventManager.broadcast('request-next-item', scope.resource.slug);
        $timeout(function () {
          scope.next_item = MapStateService.getNextAvailableItem();
        }, 500);
      };

      // Debug overwrites
      /*
      window.exposeUrl = function(){
        scope.showUrl = !scope.showUrl;
      }
      */

      // Listeners
      eventManager.listen('mticResource:RESOURCE_REFRESH_REQUEST', function () {
        $timeout(function () {
          scope.questionaire.feedbackGiven = true;
          scope.questionaire.info = null;
          scope.questionaire.givingFeedback = false;
          scope.replayItem();
        }, 1000);
      });
      eventManager.listen('mticResource:REQUEST_CLOSE', function () {
        scope.unloadItem();
      });
      eventManager.listen('resource:feedback:given', function () {
        updateStarsDisplayConfig();
        scope.questionaire.feedbackGiven = true;
        scope.questionaire.info = null;
        scope.questionaire.givingFeedback = false;
      });
      eventManager.listen('resource:score:submitted', function (e, eventData) {
        scope.currentScore = eventData.score;
        if (scope.resource.resource_type === 'embedded_notification') {
          return;
        }
        scope.questionaire.isShown = true;
        scope.questionaire.info = eventData;
        scope.questionaire.feedbackGiven = true;
        if (scope.resource.resource_type !== 'assessment' && LearningEnvironmentService.givePostItemQuestionnaire(scope.moduleId, scope.resource.slug)) {
          scope.questionaire.feedbackGiven = false;
        } else if (eventData.slug === 'mtic_teacher_offboarding') {
          scope.questionaire.isShown = false;
          scope.teacher_test_complete = true;
        } else if (eventData.slug === 'mtic_student_offboarding') {
          scope.questionaire.isShown = false;
          scope.student_test_complete = true;
        } else if (eventData.slug === 'mtic_post_test') {
          scope.questionaire.isShown = false;
          scope.student_test_complete = true;
          scope.is_post_test = true;
        } else {
          updateStarsDisplayConfig();
        }
      });
      eventManager.listen('resource:unload:baseline', function () {
        scope.unloadItem();
      });

      scope.unload_student_questionaire = function (show_student_offboarding) {
        $log.log('unload_student_questionaire :  ', show_student_offboarding, scope.is_post_test);
        if (show_student_offboarding && scope.is_post_test) {
          $timeout(function () {
            eventManager.broadcast('navbar:teacher-test:click', { isStudentTest: true, isBaseline: true });
          }, 1000);
        }
        scope.student_test_complete = false;
        scope.teacher_test_complete = false;
        eventManager.broadcast('hide-notification-iframe');
        scope.unloadItem();
      };

      // Init

      componentIframeCom.startLoadingResource(scope.resource.slug, scope.resource.hostUrl, scope.resource.content);
    }
  };
});
'use strict';

angular.module('mtic.components.notifications').service('notificationService', function ($log, api) {
  this.postUserNotification = function (message_type, user_id, from_user_id, log_state) {
    api.postUserNotification(message_type, user_id, from_user_id, log_state).then(function () {
      $log.log('notification created!');
    });
  };
});
'use strict';

/*global window*/
/*global setTimeout*/
angular.module('mtic.components.main', ['mtic.components.navbar', 'mtic.components.login', 'mtic.components.alert_popup', 'mtic.components.timePicker', 'mtic.components.translation', 'mtic.components.mticAlertModal', 'mtic.components.dashboards.student_general', 'mtic.components.dashboards.teacher_general', 'mtic.components.browser_popup', 'mtic.components.dashboards.badbrowser', 'mtic.components.select_box', 'mtic.components.notifications' /*,
                                                                                                                                                                                                                                                                                                                                                                                                                                                             'ngTouch'*/
]).config(function ($sceDelegateProvider) {
  $sceDelegateProvider.resourceUrlWhitelist(['self', 'https://login.microsoftonline.com/**']);
});

angular.module('mtic.components.main').directive('mticApp', function (DEV_VARIABLES, LoginCookie, language, $log, $timeout, TIMING_CONSTANTS, $window, EventManager, userAccount, apiErrorInterpeter, $interval, api, apiMethods, preliveCheck, SessionDataService, MapStateService, $cookies, IAMManager, LocaleService, $q, $http, $sce, $rootScope, BRANDING, PlatformService, cordovaMessenger, URL_VERSIONS, Firebase, MticAlertModalService) {
  return {
    template:'<div ng-class="[\'app-wrapper\', $root.branding.clazz, pageShown+\'-page\', $root.pageView, $root.pageNav, ($root.sidebarExpanded ? \'sidebar-expanded\' : \'\')]"><alert-popup text="alert.text" type="{{alert.type}}"></alert-popup><session-expiry-modal></session-expiry-modal><login-return-modal></login-return-modal><div class="route-view" ng-switch on="pageShown"><login ng-switch-when="login"></login><dashboard-student ng-switch-when="student"></dashboard-student><dashboard-teacher ng-switch-when="teacher"></dashboard-teacher><dashboard-bad-browser ng-switch-when="unsupportedBrowserPage"></dashboard-bad-browser></div><nav-bar user="user" language-service="languageService"></nav-bar><mtic-alert-modal></mtic-alert-modal><browser-popup ng-if="badBrowser && false"></browser-popup><div style="position: absolute;left:-1000px" ng-if="IAMLogoutTrigger"><iframe name="IAMLogoutTriggerIframe" ng-src="{{getWindowLocation()}}"></iframe></div><div ng-if="show_teacher_test" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: absolute;overflow:auto;z-index:1000"><div class="mticCard" style="width:360px !important; margin-bottom:100px"><div class="mticCard__header"><span class="mticCard__headerText"></span></div><div class="mticCard__body content" style="padding : 20px; text-align: center;"><h1 style="margin-top:0px">Questionnaire</h1><div class="button is-success is-medium" style="padding: 10px 60px; text-transform: uppercase" ng-click="take_teacher_test()" ng-bind="languageService.get(\'start_item\')">START</div></div></div></div><div ng-if="show_post_baseline_test_prompt" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: absolute;overflow:auto;z-index:1000"><div class="mticCard" ng-style="{\'width\':is_post_test?\'600px\':\'300px\'}"><div class="mticCard__header"><span class="mticCard__headerText"></span></div><div class="mticCard__body content" style="padding : 20px; text-align: center;"><h1 ng-show="is_post_test" ng-bind="languageService.get(\'mtic_post_test\')" style="margin-top:0px">MathemaTIC Abschlusstest</h1><h1 ng-hide="is_post_test" style="margin-top:0px">Questionnaire</h1><div class="button is-success is-medium" style="padding: 10px 60px; text-transform: uppercase" ng-click="take_teacher_test()" ng-bind="languageService.get(\'start_item\')">START</div></div></div></div><div ng-if="displayPrevLiveTab" class="prevlivetab"><span ng-bind="getCurLink()">On-preview</span></div><div ng-if="admin_view_shown" style="width:100%;height:100%;background-color: rgba(0,0,0,0.4);position: absolute;top:0px;left:0px"><div style="background-color:#ffffff;width:400px;min-height:240px;border-radius: 10px;margin: auto;margin-top:150px;text-align: center;padding: 30px;font-size:16px;text-align: center;">UUID &nbsp;&nbsp;:<input style="margin-right:50px;float:right" ng-model="login_as_uuid"><br>USER ID:<input style="margin-right:50px;float:right" ng-model="login_as_id"><br><a class="button is-primary" ng-click="hideAdminPopup()" style="min-width:100px;margin-top:30px;margin-bottom:20px" ng-bind="getTranslation(\'27447\')">CANCEL</a> <a class="button is-primary" ng-click="loginAs(login_as_id, login_as_uuid)" style="min-width:100px;margin-top:30px;margin-bottom:20px">LOGIN AS</a></div></div></div><div ng-if="androidBlockApplication" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: fixed;overflow:auto;top:0px;left:0px;z-index:100000000;display:flex;justify-content:center;align-items:center"><div style="background-color:#ffffff;width:400px;height:240px;border-radius: 10px;text-align: center;padding: 30px;display:flex;align-items:center"><span style="font-size:22px;" ng-bind="getTranslation(\'android_block\')" ng-hide="general_block">This application is no longer supported on Android devices. Please open the application through your browser.</span></div></div><div ng-if="offline_post_submission" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: fixed;overflow:auto;top:0px;left:0px;z-index:100000000;display:flex;justify-content:center;align-items:center"><div style="background-color:#ffffff;width:400px;height:240px;border-radius: 10px;text-align: center;padding: 30px"><span style="font-size:18px;" ng-bind="languageService.get(\'15053\')">There appears to be a problem with your Internet connection.</span><br><br><span style="font-size:18px;" ng-bind="languageService.get(\'15055\')">Check your network connection and try again.</span><br><a class="button is-primary" ng-click="resubmit_offline_post()" style="min-width:100px;margin-top:30px;margin-bottom:20px" ng-bind="languageService.get(\'15054\')">Try Again</a></div></div><div ng-if="inactivityWarningShown" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: fixed;overflow:auto;top:0px;left:0px;z-index:100000000;display:flex;justify-content:center;align-items:center"><div style="background-color:#ffffff;width:400px;border-radius: 10px;text-align: center;padding: 30px"><span style="font-size:18px;" ng-bind="languageService.get(\'inactivity_1\')">You have been inactive for a while.</span><br><br><span style="font-size:18px;" ng-bind="languageService.get(\'inactivity_2\')">Please interact with the page, otherwise you will be logged out in 1 minute.</span><br></div></div><div ng-if="refreshTokenIsExpired" style="width:100%;height: 100%;background-color: rgba(0,0,0,0.4);position: fixed;overflow:auto;top:0px;left:0px;z-index:100000000;display:flex;justify-content:center;align-items:center"><div style="background-color:#ffffff;width:400px;border-radius: 10px;text-align: center;padding: 30px">Your authentication token has expired, please refresh the page and try again.<br><a class="button is-primary" ng-click="token_expiry_logout()" style="min-width:100px;margin-top:30px;margin-bottom:20px">Got it!</a></div></div><notifications-list></notifications-list><div ng-if="logging_out || logging_in" style="position:fixed;top:0px;left:0px;width:100%;height:100%;background-color:rgba(0,0,0,0.4);display:flex;align-items:center;justify-content:center;z-index:100000000"><div class="loader" style="top:0 !important"></div></div><div class="phone-portrait"></div>',
    restrict: 'E',
    scope: {},
    link: function link(scope) {

      var eventManager = new EventManager('mticApp', scope);
      var showing_student_onboarding = false;
      scope.IAMLogoutTrigger = false;

      scope.getTranslation = function (slug) {
        return language.get(slug);
      };

      function getBranding() {
        // TODO: implement logic for determining application branding
        // ...
        if (PlatformService.getQueryVariable('force-ocmt')) {
          $timeout(function () {
            window.olark('api.box.setLocale', 'en-US');
          }, 2500);
          return BRANDING.OCMT;
        } else {
          $timeout(function () {
            window.olark('api.box.setLocale', 'fr-FR');
          }, 2500);
        }

        return BRANDING.MTIC;
      }
      $rootScope.branding = getBranding();
      $rootScope.isMTIC = $rootScope.branding === BRANDING.MTIC;
      $rootScope.isOCMT = $rootScope.branding === BRANDING.OCMT;

      scope.alert = {};
      // prevent accidental closing
      EventManager.disableBeforeUnloadMsg = false;

      eventManager.listen('logging-in', function () {
        scope.logging_in = true;
      });

      eventManager.listen('done-login-attempt', function () {
        scope.logging_in = false;
      });

      if (LoginCookie.hasSessions()) {
        $timeout(function () {
          eventManager.broadcast('login:session:restore');
        }, TIMING_CONSTANTS.SCOPE_REFRESH_DELAY_MS);
      }

      scope.isPreviewCheck = function () {
        return preliveCheck.isQCCheck();
      };

      if (Array.isArray($cookies.getObject('webembedcookie'))) {
        var webembedCookie = $cookies.getObject('webembedcookie');
        if (webembedCookie[0] === 'true') {
          window.isWebEmbedConnect = true;
        }
      }

      if (Array.isArray($cookies.getObject('updatedVersion'))) {
        var updatedVersionCookie = $cookies.getObject('updatedVersion');
        if (updatedVersionCookie[0] === 'true') {
          window.updatedVersion = true;
        }
      }

      if (Array.isArray($cookies.getObject('latestVersionCheck'))) {
        var latestVersionCheck = $cookies.getObject('latestVersionCheck');
        if (latestVersionCheck[0] === 'true') {
          window.latestVersion = true;
        }
      }

      var token_saved_url = IAMManager.getSavedUrlParamsForToken();

      /**
      * Set user values for navbar
      */
      var setUser = function setUser() {
        scope.user = {
          fullName: userAccount.getData().fullName,
          logout: userAccount.logout
        };
        scope.isTeacher = userAccount.getData().role.isTeacher;

        $window.addEventListener('beforeunload', function (event) {
          if (!PlatformService.supportsBeforeUnloadMsg || EventManager.disableBeforeUnloadMsg) {
            return;
          }
          eventManager.broadcast('browser:tab:beforeunload:shown');
          eventManager.beforeunloadWarning();
          $timeout(function () {
            eventManager.broadcast('browser:tab:beforeunload:cancelled');
          }, TIMING_CONSTANTS.BEFORE_UNLOAD_DELAY_MS);
          event.returnValue = 'Are you sure you want to leave?';
          return event.returnValue;
        });
      };

      /**
      * Make Listeners
      */
      eventManager.listen('app:open', function (e, pageToOpen) {
        if (!DEV_VARIABLES.BROWSER_SUPPORT.IS_SUPPORTED() && !(PlatformService.isAndroid || PlatformService.isIos && !window.MSStream)) {
          scope.badBrowser = true;
        }
        scope.pageShown = null;
        $timeout(function () {
          scope.pageShown = pageToOpen;
        }, 100);
      });
      eventManager.listen('login:first', function () {
        setUser();
        if (userAccount.getData().role.isGeneralAccess) {
          eventManager.broadcast('app:open', 'mtic-finalization');
        } else if (userAccount.getData().role.role_type === 'mtic_student') {
          eventManager.broadcast('app:open', 'student');
        } else {
          eventManager.broadcast('app:open', 'teacher');
        }
        eventManager.broadcast('done-login-attempt');

        if (PlatformService.isApp && PlatformService.isIos) {
          var current_app_version = PlatformService.getQueryVariable('app-version');
          if (current_app_version) {
            var app_version = parseInt(current_app_version.split('.').join(''));
            var latest_version = 609;
            if (app_version < latest_version) {
              $timeout(function () {
                window.confirm('There is a new version available for this app, please visit the Appstore to upgrade.');
              }, 2500);
            }
          }
        }
      });
      eventManager.listen('login:session-refresh', function (keepMoving) {
        setUser();
        eventManager.broadcast('session-expiry:close');
      });
      eventManager.listen('login:cookies', function (e, eventData) {
        eventManager.broadcast('login:first');
      });
      eventManager.listen('logout', function (e, atLeastOneLoggedOut) {
        $timeout(function () {
          scope.IAMLogoutTrigger = true;
          var link = 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + window.location.href;
          if (PlatformService.isMobile && !window.MSStream && LocaleService.getIfIamUser() && !userAccount.isSamlUser()) {
            // TODO why is this logic different from that in the 'app:open' listener, above?
            //scope.custom = 'ANDROID LOGOUT: '+ link;
            window.open(link, '_self');
          } else if (userAccount.isSamlUser && PlatformService.isApp) {
            cordovaMessenger.postToCordova('refreshAppFrame');
            //
          } else if (userAccount.isSamlUser && !PlatformService.isApp) {
            window.location.hash = '';
            window.location.reload();
          } else if (!LocaleService.getIfIamUser()) {
            var url = $window.location.href.split('?')[0];
            var queryFlags = [];
            if ($rootScope.isOCMT) {
              queryFlags.push('force-ocmt');
            }
            if (PlatformService.getQueryVariable('no-watermark')) {
              queryFlags.push('no-watermark');
            }
            if (queryFlags.length) {
              url += '?' + queryFlags[0];
            }
            if (queryFlags.length > 1) {
              for (var i = 1; i < queryFlags.length; i++) {
                url += '&' + queryFlags[i];
              }
            }
            $window.location.href = url.split('/#')[0];
          } else {
            $window.location.href = 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + window.location.href;
          }
        }, 500);

        // if(!atLeastOneLoggedOut) {
        //   $window.location.reload();
        // }
        //$window.location.href = 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=http%3A%2F%2Flocalhost%3A3000%2F';
      });
      eventManager.listen('login:session:clear', function () {
        delete scope.user;
        eventManager.broadcast('app:open', 'login');
      });
      eventManager.listen('login:fail', function (e, message) {
        scope.alert.text = apiErrorInterpeter.get('LOGIN', message);
        scope.alert.type = 'danger';
      });
      eventManager.listen('signup:fail', function (e, message) {
        scope.alert.text = apiErrorInterpeter.get('SIGNUP', message);
        scope.alert.type = 'danger';
      });
      eventManager.listen('module:open:resource', function (e, resource) {
        if (resource.slug) {
          eventManager.setResourceSession(resource.slug, resource.id);
        } else {
          throw "Please put the resource and resource.slug back in the event emission of `module:open:resource`";
        }
      });
      eventManager.listen('set:user:language', function (e, slug) {
        $log.log('language change : ', slug);
        if (userAccount.isLoggedIn()) {
          api.setUserLanguage(slug);
        }
      });
      eventManager.listen('module:close:resource', function (e, args) {
        language.resetAvilableOptions();
        $timeout(function () {
          eventManager.clearResourceSession();
          scope.userTimeout.cancelResourceListeners();
        }, 100);
      });

      eventManager.listen("navbar:my-classes:click", function () {
        MapStateService.setActiveModule("");
      });

      /**
       * Defaults
       */
      scope.pageShown = null;
      scope.badBrowser = false;
      scope.languageService = language;

      eventManager.broadcast('app:open', 'login');
      eventManager.listen('offline-post-call', function () {
        scope.offline_post_submission = true;
        scope.logging_out = false;
      });

      scope.resubmit_offline_post = function () {
        scope.offline_post_submission = false;
        apiMethods.resubmitOfflinePost();
      };

      var logged_out = false;
      eventManager.listen('logging-out', function (e) {
        scope.logging_out = true;
        logged_out = true;
      });

      eventManager.listen('offline-post-call-resolved', function () {
        if (logged_out) {
          location.reload();
        }
      });

      scope.getCurLink = function () {
        return window.location.host;
      };
      scope.isNotLive = function () {
        return LocaleService.getUrlVersion() !== URL_VERSIONS.Live;
      };
      scope.displayPrevLiveTab = scope.isNotLive() && !PlatformService.getQueryVariable('no-watermark');
      scope.custom = '';
      eventManager.listen('change-prelive-message', function (e, args) {
        // scope.preliveMessage = 'change link :  ' + args;
        scope.gotCustom = true;
        scope.custom = args;
      });

      scope.getWindowLocation = function () {
        return 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + window.location.href;
      };

      scope.hide_admin_view = function () {
        scope.admin_view_shown = false;
      };

      eventManager.listen('show_admin_view', function (e) {
        scope.admin_view_shown = true;
      });

      // redirecting to browser view
      var url = window.location.href;

      var auto_login = false;
      function setAutoLoginData(params) {
        var userRole = userAccount.setData(params.info.email, params);
        apiMethods.setGroupId(userRole.group_id);
        Firebase.auth().signInWithCustomToken(params.firebaseToken);
        eventManager.broadcast('login:first');
        LocaleService.setAsIamUser();
        if (document.location.hash.indexOf('open_item_link') > -1) {
          document.location.hash = 'open_item_link' + document.location.hash.split('open_item_link')[1];
        } else {
          document.location.hash = '';
        }
      }

      if (url.indexOf('auto_login') > -1) {
        auto_login = true;
        eventManager.broadcast('logging-in');
        var auto_login_params = JSON.parse(decodeURIComponent(url.split('auto_login=')[1].split('&open_item_link')[0]));
        // $log.log('AUTO LOGIN :  ', _.clone(auto_login_params));
        apiMethods.setHeaders(auto_login_params.session_key, auto_login_params.user_id, auto_login_params.access_token, auto_login_params.refresh_token);
        if (auto_login_params.roles) {
          setAutoLoginData(auto_login_params);
        } else {
          api.getUserGroups().then(function (roles) {
            var lowercase_roles = [];
            _.each(roles, function (role) {
              var lowercase_role = _.transform(role, function (result, val, key) {
                result[key.toLowerCase()] = val;
              });
              lowercase_roles.push(lowercase_role);
            });
            // $log.log('GOT USER ROLES : ' , lowercase_roles);
            auto_login_params.roles = lowercase_roles;
            setAutoLoginData(auto_login_params);
          });
        }
      } else if (url.indexOf('login_error') > -1) {
        $log.log('LOGIN ERROR !');
        var login_errorParams = JSON.parse(decodeURIComponent(url.split('login_error=')[1]));
        if (login_errorParams.isSamlUser) {
          userAccount.setIsSamlUser(true);
        }
        MticAlertModalService.set('USER LOGIN FAILED', {
          title: 'IAM Login',
          callback: function callback() {
            userAccount.logout();
          }
        });
        if (document.location.hash.indexOf('open_item_link') > -1) {
          document.location.hash = 'open_item_link' + document.location.hash.split('open_item_link')[1];
        } else {
          document.location.hash = '';
        }
      }

      if (url.indexOf('web-open-browser&') > -1) {
        window.isWebEmbedConnect = false;
        var url_params = url.split('web-open-browser&')[1];
        var url_parse = url_params.split('&');
        var params = {};
        url_parse.forEach(function (param) {
          var cur = param.split('=');
          params[cur[0]] = cur[1];
        });
        apiMethods.loginRestore(params.uuid, params.user_id, params.session_key, params.firebase_token).then(function () {});
      }

      function autologin() {
        var loginCookies = $cookies.getObject('logincookies');
        if (loginCookies.length > 0) {
          var latest = loginCookies[0];
          $timeout(function () {
            eventManager.broadcast('start-login-attempt');
            if (latest.userid && latest.sessionkey && latest.username && latest.firebaseToken) {
              apiMethods.loginRestore(latest.username, latest.userid, latest.sessionkey, latest.firebaseToken, true).then(function () {
                eventManager.broadcast('done-login-attempt');
              }).catch(function () {
                eventManager.broadcast('done-login-attempt');
              });
            }
          }, 500);
        }
      }
      // (window.isWebEmbedConnect || location.href.indexOf('localhost') > -1 || location.href.indexOf('192') > -1)
      if (location.href.indexOf('open_item_link') > -1 && Array.isArray($cookies.getObject('logincookies')) && !auto_login) {
        autologin();
      }
      eventManager.listen('app:auto:login', autologin);

      scope.loginAs = function (user_id, uuid) {
        apiMethods.loginAs({ user_id: user_id, uuid: uuid }).then(function (res) {
          scope.admin_view_shown = false;
        });
      };

      scope.hideAdminPopup = function () {
        scope.admin_view_shown = false;
      };

      eventManager.listen('refresh-token-expired', function () {
        scope.refreshTokenIsExpired = true;
      });

      scope.token_expiry_logout = function () {
        userAccount.logout();
      };

      eventManager.listen('token-expired-logout', function () {
        userAccount.logout();
      });

      scope.userTimeout = {

        idle_start_60s: false,
        away_start_check: false,
        idle_start_300s: false,
        fifteen_s_ping: null,
        sixty_s_ping: null,
        // iframe_focus_check:null,
        // resource_loader_focus_check: null,

        startTimers: function startTimers() {
          scope.userTimeout.ping = window.setTimeout(scope.userTimeout.goInactive, 60000);
          scope.userTimeout.inactivityWarning = window.setTimeout(scope.userTimeout.showInactivityWarning, 1740000);
          scope.userTimeout.halfHourPing = window.setTimeout(scope.userTimeout.logUserOut, 1800000);
          if (!scope.userTimeout.idle_start_60s) {
            scope.userTimeout.idle_start = window.setTimeout(scope.userTimeout.startIdle, 60000);
          }
          if (!scope.userTimeout.away_start_check) {
            scope.userTimeout.away_start = window.setTimeout(scope.userTimeout.goInactiveAway, 600000);
          }
        },

        startIdle: function startIdle() {
          // eventManager.broadcast('user:idleStart60s')
          scope.userTimeout.idle_start_60s = true;
          eventManager.broadcast('idle:inputs:start');
          LocaleService.idleInput = true;
          window.clearTimeout(scope.userTimeout.idle_start);
          // if (!scope.userTimeout.idle_start_60s) {
          //   scope.userTimeout.idle_start_long = window.setTimeout(scope.userTimeout.startIdle300, 300000);
          //   // $log.log('idle60')
          // }
        },

        startIdle300: function startIdle300() {
          // eventManager.broadcast('user:idleStart300s')
          // $log.log('idle300')
        },

        resetTimers: function resetTimers(e) {
          // $log.log('reseting timer')
          window.clearTimeout(scope.userTimeout.ping);
          window.clearTimeout(scope.userTimeout.inactivityWarning);
          window.clearTimeout(scope.userTimeout.halfHourPing);
          window.clearTimeout(scope.userTimeout.idle_start);
          window.clearTimeout(scope.userTimeout.idle_start_long);
          window.clearTimeout(scope.userTimeout.away_start);
          scope.inactivityWarningShown = false;

          LocaleService.idleInput = false;
          LocaleService.isAway = false;
          if (scope.userTimeout.idle_start_60s) {
            // $log.log('inidle')
            // eventManager.broadcast('user:idle_end')
            eventManager.broadcast('idle:inputs:end');
            eventManager.broadcast('mouse:keyboard:active', { idleInput: LocaleService.idleInput, away: LocaleService.isAway });
          }

          scope.userTimeout.idle_start_60s = false;
          scope.userTimeout.away_start_check = false;
          scope.userTimeout.startTimers();
        },

        goInactive: function goInactive() {
          eventManager.broadcast('user:inactiveForOneMinutePing');
        },
        logUserOut: function logUserOut() {
          if (userAccount.isLoggedIn()) {
            eventManager.broadcast('user:InactiveForThirtyMinutes');
            window.clearTimeout(scope.userTimeout.logUserOut);
            userAccount.logout();
          }
        },
        showInactivityWarning: function showInactivityWarning() {
          if (userAccount.isLoggedIn()) {
            scope.inactivityWarningShown = true;
            window.clearTimeout(scope.userTimeout.inactivityWarning);
          }
        },
        goInactiveAway: function goInactiveAway() {
          scope.userTimeout.away_start_check = true;
          LocaleService.isAway = true;
        },

        cancelResourceListeners: function cancelResourceListeners() {
          $interval.cancel(scope.userTimeout.fifteen_s_ping);
          // $interval.cancel(scope.userTimeout.resource_loader_focus_check)
          scope.userTimeout.fifteen_s_ping = null;
          // scope.userTimeout.resource_loader_focus_check = null;

          // $interval.cancel(scope.userTimeout.iframe_focus_scheck)
          // scope.userTimeout.iframe_focus_check = null;
        },

        setup: function setup() {
          var hidden = "hidden";
          // Standards:
          if (window.isWebEmbedConnect && PlatformService.isIos) {
            document.addEventListener("pagehide", onchange);
            document.addEventListener("pageshow", onchange);
          } else if (hidden in document) {
            document.addEventListener("visibilitychange", onchange);
          } else if ((hidden = "mozHidden") in document) {
            document.addEventListener("mozvisibilitychange", onchange);
          } else if ((hidden = "webkitHidden") in document) {
            document.addEventListener("webkitvisibilitychange", onchange);
          } else if ((hidden = "msHidden") in document) {
            document.addEventListener("msvisibilitychange", onchange);
          } // IE 9 and lower:
          else if ("onfocusin" in document) {
              document.onfocusin = document.onfocusout = onchange;
              // All others:
            } else {
              window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;
            }
          function onchange(evt) {
            if (LocaleService.idleFocus) {
              eventManager.broadcast('focusout:end');
              LocaleService.idleFocus = false;
              eventManager.broadcast('mouse:keyboard:active', { idleInput: LocaleService.idleInput, away: LocaleService.isAway, returned_from_away: true });
            } else {
              eventManager.broadcast('focusout:start');
              LocaleService.idleFocus = true;
            }
          }

          document.addEventListener("mousemove", scope.userTimeout.resetTimers, false);
          document.addEventListener("mousedown", scope.userTimeout.resetTimers, false);
          document.addEventListener("pointerdown", scope.userTimeout.resetTimers, false);
          document.addEventListener("pointermove", scope.userTimeout.resetTimers, false);
          document.addEventListener("pointerup", scope.userTimeout.resetTimers, false);
          document.addEventListener("touchstart", scope.userTimeout.resetTimers, false);
          document.addEventListener("touchend", scope.userTimeout.resetTimers, false);
          document.addEventListener("keypress", scope.userTimeout.resetTimers, false);
          document.addEventListener("DOMMouseScroll", scope.userTimeout.resetTimers, false);
          document.addEventListener("mousewheel", scope.userTimeout.resetTimers, false);
          document.addEventListener("touchmove", scope.userTimeout.resetTimers, false);
          document.addEventListener("MSPointerMove", scope.userTimeout.resetTimers, false);

          eventManager.listen('iframe-idle-reset', function () {
            scope.userTimeout.resetTimers();
          });

          eventManager.listen('resource:load:complete', function () {
            if (!scope.userTimeout.fifteen_s_ping) {
              scope.userTimeout.fifteen_s_ping = $interval(function () {
                eventManager.broadcast('mouse:keyboard:active:first', { idleInput: LocaleService.idleInput });
                $interval.cancel(scope.userTimeout.fifteen_s_ping);
                scope.userTimeout.fifteen_s_ping = null;
              }, 15000);
            }
          });

          eventManager.listen('teacher:change:tab', function () {
            scope.userTimeout.cancelResourceListeners();
          });

          scope.userTimeout.sixty_s_ping = $interval(function () {
            eventManager.broadcast('mouse:keyboard:active', { idleInput: LocaleService.idleInput, away: LocaleService.isAway });
          }, 60000);

          scope.userTimeout.startTimers();
        }

        // listeners for native events moved to the cordovaMessenger service
      };if (PlatformService.isApp) {
        cordovaMessenger.postToCordova('siteIsReady', {});
      }

      scope.userTimeout.setup();

      if (PlatformService.isIos && PlatformService.isApp) {
        document.addEventListener('touchend', function () {
          window.focus();
        });
      }

      window.addEventListener('message', function (event) {
        if (event.data.startsWith && !event.data.startsWith('!')) {
          var eventData = JSON.parse(event.data);
          if ('open_pdf_request' === eventData.type && eventData.payload && eventData.payload.pdf_url) {
            if (PlatformService.isApp) {
              cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: eventData.payload.pdf_url });
            } else {
              window.open(eventData.payload.pdf_url, '_blank');
            }
          }
        }
      }, false);
    }
  };
});
'use strict';

angular.module('mtic.components.mticAlertModal', []).component('mticAlertModal', {
  template:'<div id="mticAlertModal" class="modal columns fade" role="dialog" style="display: none; z-index: 50;"><div class="modal-background"></div><div class="column is-4 is-offset-4 modal-card" style="margin-top: 100px;"><header class="modal-card-head"><p class="modal-card-title" ng-if="alert.options.title" ng-bind-html="alert.options.title"></p><button type="button" class="delete" data-dismiss="modal" ng-click="alert.onExit(false)">&times;</button></header><section class="modal-card-body"><p ng-bind-html="alert.getMessage()"></p></section><footer class="modal-card-foot"><button type="button" ng-click="alert.onExit(false)" class="button" style="margin-right: 0;" data-dismiss="modal">Close</button> <button type="button" ng-click="alert.onExit(true)" ng-if="alert.options.ask" class="button is-success" data-dismiss="modal" ng-bind="getTranslation(\'27663\')">Yes</button></footer></div></div>',
  bindings: {},
  controller: function controller(MticAlertModalService, $scope, language) {
    $scope.alert = MticAlertModalService;
    $scope.getTranslation = function (id) {
      return language.get(id);
    };
  }
});
'use strict';

angular.module('mtic.components.mticAlertModal').service('MticAlertModalService', function ($log, language) {
    var _this = this;

    var message = '';
    var showing = false;
    var defaultOptions = {
        isLang: false,
        callback: null,
        ask: false,
        title: null
    };
    this.options = angular.copy(defaultOptions);

    this.getMessage = function () {
        if (_this.options.isLang) {
            return language.get(message);
        } else {
            return message;
        }
    };
    this.set = function (value, newOptions) {
        _this.options = angular.extend(angular.copy(defaultOptions), newOptions);
        message = value;
        document.getElementById('mticAlertModal').style.display = 'block';
    };

    this.onExit = function (saidYes) {
        if (_this.options.callback) {
            _this.options.callback(saidYes);
        }
        document.getElementById('mticAlertModal').style.display = 'none';
    };
});
'use strict';

angular.module('mtic.components.modules.learningMap', []);

angular.module('mtic.components.modules.learningMap').service('learningMapUtil', function (C3_ASSET_URL, $log, $http, mapItemFactory, PIXI) {

  /**
   * Private vars
   */

  // none


  /**
   * Public Methods
   * @type {Object}
   */
  var learningMapUtil = {

    /**
     * Handles the intro animation/fade in
     * @return {DragInfoSettings}
     */
    createCloudManager: function createCloudManager() {
      var progress = 0;
      var randomMod = Math.random();
      var clouds = [];

      var cloud_graphic = new PIXI.Graphics();

      cloud_graphic.beginFill(0xeef0f1);
      cloud_graphic.drawCircle(100, 100, 100);
      cloud_graphic.endFill();

      var cloud_tex = cloud_graphic.generateCanvasTexture(PIXI.SCALE_MODES.NEAREST);

      var overlay = new PIXI.Graphics();

      overlay.beginFill(0xeef0f1);
      overlay.drawRect(0, 0, 100, 100);
      overlay.endFill();

      var overlay_sprite = new PIXI.Sprite(overlay.generateCanvasTexture(PIXI.SCALE_MODES.NEAREST));

      return {
        overlay_sprite: overlay_sprite,
        update: function update() {
          progress = Math.min(progress + 1, 100);
          overlay_sprite.alpha = (100 - progress) / 100.0;
        },
        onResize: function onResize(width, height) {
          overlay_sprite.width = width;
          overlay_sprite.height = height;
        }
      };
    },

    /**
     * Create Object that tracks intertial click and drag panning around the screen
     * @return {DragInfoSettings}
     */
    getDragInfoSettings: function getDragInfoSettings() {
      return {
        dragging: false,
        velocity: {
          x: 0,
          y: 0
        },
        last_mouse_pos: {
          x: 0,
          y: 0
        },
        start_drag_mouse_pos: {
          x: 0,
          y: 0
        },
        start_drag_pos: {
          x: 0,
          y: 0
        }
      };
    }

  };

  return learningMapUtil;
});
'use strict';

angular.module('mtic.components.custom_calendar', []).directive('customCalendar', function ($interval, $timeout, TIMING_CONSTANTS, $log, EventManager) {
    return {
        template:'<div id="custom-calendar" ng-click="$event.stopPropagation()"><div class="width-910 background-white"><div class="margin-bottom20"><div class="margin-left5"><span class="font-size-35 width-130" ng-bind="calendar.months[calendar.currentMonth]+\', \'+calendar.currentYear"></span></div><div class="margin-left5"><button ng-click="goToPreviousMonth()" class="width-30 height-30"><i class="fa fa-chevron-left padding-top2" aria-hidden="true"></i></button> <button ng-click="goToNextMonth()" class="width-30 height-30"><i class="fa fa-chevron-right padding-top2" aria-hidden="true"></i></button> <button ng-click="selectToday()" class="height-30" ng-bind="\'Today\'"></button></div></div><table id="calendar-table" class="table is-bordered progress-table background-transparent"><tr class="background-transparent"><th class="width-130 height-28 text-left-force border0" ng-bind="\'Mon\'"></th><th class="width-130 height-28 text-left-force border0" ng-bind="\'Tue\'"></th><th class="width-130 height-28 text-left-force border0" ng-bind="\'Wed\'"></th><th class="width-130 height-28 text-left-force border0" ng-bind="\'Thu\'"></th><th class="width-130 height-28 text-left-force border0" ng-bind="\'Fri\'"></th><th class="width-130 height-28 text-left-force border0" ng-bind="\'Sat\'"></th><th class="width-130 height-28 text-left-force border0" ng-bind="\'Sun\'"></th></tr><tr class="background-white"><td class="width-130 height-80 calendar-date" ng-class="{\'background-light-gray\':dateObject.isToday,\'cursor-pointer\':dateObject.month==calendar.currentMonth,\'background-dark-gray\':isSelectedDateMatch(dateObject)}" ng-click="selectDate(dateObject,$event)" ng-repeat="dateObject in calendar.dateObjects | limitTo:7:0"><div><div class="text-left-force" ng-bind="dateObject.day"></div><div ng-if="dateObject.events && dateObject.events.length>0"><p ng-click="dateObject.events[0].onClick(dateObject.events[0].onClickParams)" class="ellipsis background-{{dateObject.events[0].display.color}} border-radius-3 font-size-20 cursor-pointer" ng-bind="dateObject.events[0].description"></p><a class="text-left-force" ng-click="calendar.viewEvents = dateObject.events;$event.stopPropagation()" ng-show="dateObject.events.length>1" ng-bind="\'+\'+(dateObject.events.length-1)+\' more\'"></a></div></div></td></tr><tr class="background-white"><td class="width-130 height-80 calendar-date" ng-repeat="dateObject in calendar.dateObjects | limitTo:7:7" ng-click="selectDate(dateObject,$event)" ng-class="{\'background-light-gray\':dateObject.isToday,\'cursor-pointer\':dateObject.month==calendar.currentMonth,\'background-dark-gray\':isSelectedDateMatch(dateObject)}"><div><div class="text-left-force" ng-bind="dateObject.day"></div><div ng-if="dateObject.events && dateObject.events.length>0"><p ng-click="dateObject.events[0].onClick(dateObject.events[0].onClickParams)" class="ellipsis background-{{dateObject.events[0].display.color}} border-radius-3 font-size-20 cursor-pointer" ng-bind="dateObject.events[0].description"></p><a class="text-left-force" ng-click="calendar.viewEvents = dateObject.events;$event.stopPropagation()" ng-show="dateObject.events.length>1" ng-bind="\'+\'+(dateObject.events.length-1)+\' more\'"></a></div></div></td></tr><tr class="background-white"><td class="width-130 height-80 calendar-date" ng-repeat="dateObject in calendar.dateObjects | limitTo:7:14" ng-click="selectDate(dateObject,$event)" ng-class="{\'background-light-gray\':dateObject.isToday,\'cursor-pointer\':dateObject.month==calendar.currentMonth,\'background-dark-gray\':isSelectedDateMatch(dateObject)}"><div><div class="text-left-force" ng-bind="dateObject.day"></div><div ng-if="dateObject.events && dateObject.events.length>0"><p ng-click="dateObject.events[0].onClick(dateObject.events[0].onClickParams)" class="ellipsis background-{{dateObject.events[0].display.color}} border-radius-3 font-size-20 cursor-pointer" ng-bind="dateObject.events[0].description"></p><a class="text-left-force" ng-click="calendar.viewEvents = dateObject.events;$event.stopPropagation()" ng-show="dateObject.events.length>1" ng-bind="\'+\'+(dateObject.events.length-1)+\' more\'"></a></div></div></td></tr><tr class="background-white"><td class="width-130 height-80 calendar-date" ng-repeat="dateObject in calendar.dateObjects | limitTo:7:21" ng-click="selectDate(dateObject,$event)" ng-class="{\'background-light-gray\':dateObject.isToday,\'cursor-pointer\':dateObject.month==calendar.currentMonth,\'background-dark-gray\':isSelectedDateMatch(dateObject)}"><div><div class="text-left-force" ng-bind="dateObject.day"></div><div ng-if="dateObject.events && dateObject.events.length>0"><p ng-click="dateObject.events[0].onClick(dateObject.events[0].onClickParams)" class="ellipsis background-{{dateObject.events[0].display.color}} border-radius-3 font-size-20 cursor-pointer" ng-bind="dateObject.events[0].description"></p><a class="text-left-force" ng-click="calendar.viewEvents = dateObject.events;$event.stopPropagation()" ng-show="dateObject.events.length>1" ng-bind="\'+\'+(dateObject.events.length-1)+\' more\'"></a></div></div></td></tr><tr class="background-white"><td class="width-130 height-80 calendar-date" ng-repeat="dateObject in calendar.dateObjects | limitTo:7:28" ng-click="selectDate(dateObject,$event)" ng-class="{\'background-light-gray\':dateObject.isToday,\'cursor-pointer\':dateObject.month==calendar.currentMonth,\'background-dark-gray\':isSelectedDateMatch(dateObject)}"><div><div class="text-left-force" ng-bind="dateObject.day"></div><div ng-if="dateObject.events && dateObject.events.length>0"><p ng-click="dateObject.events[0].onClick(dateObject.events[0].onClickParams)" class="ellipsis background-{{dateObject.events[0].display.color}} border-radius-3 font-size-20 cursor-pointer" ng-bind="dateObject.events[0].description"></p><a class="text-left-force" ng-click="calendar.viewEvents = dateObject.events;$event.stopPropagation()" ng-show="dateObject.events.length>1" ng-bind="\'+\'+(dateObject.events.length-1)+\' more\'"></a></div></div></td></tr><tr class="background-white"><td class="width-130 height-80 calendar-date" ng-repeat="dateObject in calendar.dateObjects | limitTo:7:35" ng-click="selectDate(dateObject,$event)" ng-class="{\'background-light-gray\':dateObject.isToday,\'cursor-pointer\':dateObject.month==calendar.currentMonth,\'background-dark-gray\':isSelectedDateMatch(dateObject)}"><div><div class="text-left-force" ng-bind="dateObject.day"></div><div ng-if="dateObject.events && dateObject.events.length>0"><p ng-click="dateObject.events[0].onClick(dateObject.events[0].onClickParams)" class="ellipsis background-{{dateObject.events[0].display.color}} border-radius-3 font-size-20 cursor-pointer" ng-bind="dateObject.events[0].description"></p><a class="text-left-force" ng-click="calendar.viewEvents = dateObject.events;$event.stopPropagation()" ng-show="dateObject.events.length>1" ng-bind="\'+\'+(dateObject.events.length-1)+\' more\'"></a></div></div></td></tr></table></div><div class="modal" ng-class="{\'is-active\':(calendar.viewEvents && calendar.viewEvents.length>1)}"><div class="modal-background"></div><div class="modal-card max-width375"><header class="modal-card-head"><p class="modal-card-title text-center font-bold">Agendas</p></header><section class="modal-card-body max-height-340"><div><div ng-repeat="event in calendar.viewEvents" style="margin-bottom: 8px; border:2px solid #999; border-radius:1em; position:relative; padding-left:90px; overflow:hidden; min-height:140px;"><div style="position:absolute; left:0px; top:0px; bottom:0px; text-align:center; width:90px; line-height:100%; padding: 18px 0px; font-weight: bold;" class="background-{{event.display.color}}"><div style="font-size:19px;" ng-bind="event.eventDate.date()"></div><div style="font-size:14px;margin-top: 10px;" ng-bind="calendar.months[event.eventDate.month()]"></div><div ng-show="event.onClickParams.published" style="width:60px;height:60px;border-radius: 30px;background-color:#000;opacity:0.5;color:#fff;margin-top:10px;margin-left:15px;line-height: 54px"><span style="vertical-align:middle;line-height:10px;display:inline-block;font-size:10px"><i class="fa fa-check display-block-force font-size-20-force" aria-hidden="true"></i>Sent to<br>students<br></span></div></div><div style="padding:12px;"><div style="margin-bottom:8px"><small><strong ng-bind="event.onClickParams.description"></strong></small><br></div><div ng-repeat="resource in event.onClickParams.resourceRefs track by resource.id" style="font-size:0.75em; width:180px;" class="truncate" ng-bind="resource.name">#N/A</div></div></div></div></section><footer class="modal-card-foot"><div class="text-center margin-auto"><button class="button background-color-3398db color-white min-width100" ng-disabled="statusChangeStarted" ng-click="calendar.viewEvents = [];$event.stopPropagation()">Close</button></div></footer></div></div></div>',
        scope: {
            calendarEvents: '=?',
            selectedDate: '=?',
            showSelectedDate: '=?'
        },
        link: function link(scope, element, attrs) {
            scope.calendar = {
                rows: 7,
                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                columns: 6,
                currentMonth: 0,
                dateObjects: [],
                currentYear: 2018
            };

            var eventManager = new EventManager('teacherStudentsAgenda', scope);
            var today = {
                year: 1,
                month: 1,
                day: 1
            };
            scope.goToPreviousMonth = function () {
                scope.calendar.currentMonth -= 1;
                if (scope.calendar.currentMonth < 0) {
                    scope.calendar.currentMonth = 11;
                    scope.calendar.currentYear -= 1;
                }

                updateCalendar(scope.calendar.currentYear, scope.calendar.currentMonth);
            };

            scope.goToNextMonth = function () {
                scope.calendar.currentMonth += 1;
                if (scope.calendar.currentMonth > 11) {
                    scope.calendar.currentMonth = 0;
                    scope.calendar.currentYear += 1;
                }

                updateCalendar(scope.calendar.currentYear, scope.calendar.currentMonth);
            };

            var getEventsForCurrentDay = function getEventsForCurrentDay(year, month, date) {
                var currentEvents = [];
                angular.forEach(scope.calendarEvents, function (event) {
                    if (event.eventDate.date() === date && event.eventDate.month() === month && event.eventDate.year() === year) {
                        currentEvents.push(event);
                    }
                });

                return currentEvents;
            };

            var updateCalendar = function updateCalendar(year, month) {
                var date = moment({ y: year, M: month, d: 1 });
                // date.setDate(1);
                var totalDaysInCurrentMonth = moment({ y: year, M: date.month() }).daysInMonth();
                var firstDayInMonth = date.day();
                //adjustment for monday being the beginning
                if (firstDayInMonth === 0) {
                    firstDayInMonth = 7;
                }
                scope.calendar.dateObjects = [];
                var events;
                for (var i = 1; i <= totalDaysInCurrentMonth; i++) {
                    events = getEventsForCurrentDay(scope.calendar.currentYear, scope.calendar.currentMonth, i);
                    var dateObject = { day: i, events: events, month: scope.calendar.currentMonth, year: scope.calendar.currentYear };
                    dateObject.isToday = today.year === scope.calendar.currentYear && today.month === scope.calendar.currentMonth && today.day === i;
                    scope.calendar.dateObjects.push(dateObject);
                }

                var totalDaysInLastMonth = moment({ y: date.year(), M: date.month() - 1 }).daysInMonth();
                for (i = firstDayInMonth - 1; i > 0; i--) {
                    events = getEventsForCurrentDay(scope.calendar.currentYear, scope.calendar.currentMonth - 1, i);
                    var prevMonthDateObject = { day: totalDaysInLastMonth, events: events, month: scope.calendar.currentMonth - 1 };
                    scope.calendar.dateObjects.unshift(prevMonthDateObject);
                    totalDaysInLastMonth--;
                }

                var emptyDateBoxCount = scope.calendar.rows * scope.calendar.columns - scope.calendar.dateObjects.length;
                for (i = 1; i <= emptyDateBoxCount; i++) {
                    events = getEventsForCurrentDay(scope.calendar.currentYear, scope.calendar.currentMonth + 1, i);
                    var nextMonthDateObject = { day: i, events: events, month: scope.calendar.currentMonth + 1 };
                    scope.calendar.dateObjects.push(nextMonthDateObject);
                }
            };

            scope.selectToday = function () {
                if (!(scope.calendar.currentYear === today.year && scope.calendar.currentMonth === today.month)) {
                    scope.calendar.currentYear = today.year;
                    scope.calendar.currentMonth = today.month;
                    updateCalendar(today.year, today.month);
                }
            };

            scope.selectDate = function (dateObject, $event) {
                $event.stopPropagation();
                if (dateObject && dateObject.month === scope.calendar.currentMonth) {
                    var date = moment().year(dateObject.year).month(dateObject.month).date(dateObject.day);
                    scope.selectedDate = date;
                    eventManager.broadcast("calendar:date:selected", date);
                }
            };

            scope.isSelectedDateMatch = function (dateObject) {
                var matched = false;
                if (scope.selectedDate && scope.showSelectedDate) {
                    var date = moment(scope.selectedDate);
                    if (date.date() === dateObject.day && date.month() === dateObject.month && date.year() === dateObject.year) {
                        matched = true;
                    }
                }

                return matched;
            };

            var initialize = function initialize() {
                // $log.log(scope.calendarEvents);
                var date = moment();
                scope.calendar.currentMonth = date.month();
                scope.calendar.currentYear = date.year();
                today = {
                    year: date.year(),
                    month: date.month(),
                    day: date.date()
                };
                updateCalendar(scope.calendar.currentYear, scope.calendar.currentMonth);
                $timeout(function () {
                    var totalViewableWidth = element.parent()[0].parentElement.clientWidth;
                    var calendarElement = document.getElementById("custom-calendar"); //calendar-table
                    var calendarTable = document.getElementById("calendar-table"); //calendar-table
                    if (totalViewableWidth > calendarTable.clientWidth) {
                        calendarElement.style.marginLeft = (totalViewableWidth - calendarTable.clientWidth) / 2 + "px";
                    }
                }, 100);
            };

            initialize();

            eventManager.listen("calendarEvents:updated", function (e, events) {
                scope.calendarEvents = events;
                updateCalendar(scope.calendar.currentYear, scope.calendar.currentMonth);
            });
        }
    };
});
'use strict';

angular.module('mtic.components.browser_popup', []).directive('browserPopup', function ($interval, $timeout, TIMING_CONSTANTS, EventManager, language) {
  return {
    template:'<div ng-if="!chrome_ios" ng-hide="hideNag"><div class="browser-nag"><div class="browser-nag__back" ng-click="closeClicked()"></div><div class="browser-nag__inner"><div style="position:relative;"><span ng-bind="language.get(\'14524\')"></span> <a href="https://www.google.ca/chrome/browser/desktop" target="_blank">Google Chrome</a> <span ng-bind="language.get(\'14525\')">for desktops/laptops</span>.<div style="margin-top:5px; line-height:100%;"><small ng-bind="language.get(\'14526\')">Please click on the link above and follow the installation instructions to upgrade to a compatible browser.</small></div></div><div ng-if="chrome_ios" style="position:relative;">This website is optimized for <b>desktops</b>.<br><div style="margin-top: 16px; line-height:100%;"><small>Please open this webpage on a desktop device for a better experience.</small></div></div><div ng-click="closeClicked()" class="browser-nag__close">&#10006;</div></div></div></div>',
    scope: {},
    link: function link(scope) {
      $timeout(function () {
        scope.chrome_ios = window.location.href.indexOf('web-embed-connect') !== -1 || window.isWebEmbedConnect;
        //window.navigator.userAgent.match("CriOS");
      }, 1000);
      scope.hideNag = true;

      scope.language = language;

      var eventManager = new EventManager('browserPopup', scope);
      eventManager.listen('login:first', function (message) {
        $timeout(function () {
          scope.hideNag = false;
        }, 1000);
      });
      // $timeout(()=>{
      //   scope.hideNag = false;
      // }, 2500);

      scope.closeClicked = function () {
        scope.hideNag = true;
        // $timeout(()=>{
        //   scope.hideNag = true;
        //   $timeout(()=> {
        //     scope.hideNag = false;
        //   }, 120000);
        // });
      };
    }
  };
});
'use strict';

angular.module('mtic.components.alert_popup', []).directive('alertPopup', function ($interval, $timeout, TIMING_CONSTANTS) {
      return {
            template:'<div ng-if="text" ng-show="show" role="alert" class="notification is-{{type}}" id="alert-message"><span ng-bind="text"></span></div>',
            transclude: false,
            scope: {
                  text: '=',
                  type: '@',
                  timeout: '=?'
            },
            link: function link(scope) {
                  var lastInterval = null;

                  function activateAlert() {
                        if (!scope.text) {
                              scope.show = false;
                              return;
                        }

                        if (lastInterval) {
                              $timeout.cancel(lastInterval);
                        }
                        scope.show = true;
                        lastInterval = $timeout(function () {
                              scope.show = false;
                              scope.text = null;
                        }, scope.timeout || TIMING_CONSTANTS.ALERT_BOX_DEFAULT_DISPLAY_MS);
                  }
                  activateAlert();
                  scope.$watch('text', activateAlert);
            }
      };
});